import "./maplibre-gl-worker.468a5304.js";


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec159"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec159"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jwRWS", function(module, exports) {




/*!
  * Bootstrap base-component.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("kiu4e")), (parcelRequire("eIqqi")), (parcelRequire("9TT4C")), (parcelRequire("djsKl")));
})(module.exports, function(Data, EventHandler, Config, index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = '5.3.8';
    /**
   * Class definition
   */ class BaseComponent extends Config {
        constructor(element, config){
            super();
            element = index_js.getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        // Private
        _queueCallback(callback, element, isAnimated = true) {
            index_js.executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(index_js.getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
    }
    return BaseComponent;
});

});
parcelRegister("kiu4e", function(module, exports) {
/*!
  * Bootstrap data.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    return data;
});

});

parcelRegister("eIqqi", function(module, exports) {

/*!
  * Bootstrap event-handler.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("djsKl")));
})(module.exports, function(index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout'
    };
    const nativeEvents = new Set([
        'click',
        'dblclick',
        'mouseup',
        'mousedown',
        'contextmenu',
        'mousewheel',
        'DOMMouseScroll',
        'mouseover',
        'mouseout',
        'mousemove',
        'selectstart',
        'selectend',
        'keydown',
        'keypress',
        'keyup',
        'orientationchange',
        'touchstart',
        'touchmove',
        'touchend',
        'touchcancel',
        'pointerdown',
        'pointermove',
        'pointerup',
        'pointerleave',
        'pointercancel',
        'gesturestart',
        'gesturechange',
        'gestureend',
        'focus',
        'blur',
        'change',
        'reset',
        'select',
        'submit',
        'focusin',
        'focusout',
        'load',
        'unload',
        'beforeunload',
        'resize',
        'move',
        'DOMContentLoaded',
        'readystatechange',
        'error',
        'abort',
        'scroll'
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === 'string';
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ''));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, '');
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== 'string' || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith('.');
            if (typeof callable !== 'undefined') {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== 'string' || !element) return null;
            const $ = index_js.getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    return EventHandler;
});

});
parcelRegister("djsKl", function(module, exports) {
/*!
  * Bootstrap index.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = 'transitionend';
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(',')[0];
        transitionDelay = transitionDelay.split(',')[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (object)=>{
        if (!object || typeof object !== 'object') return false;
        if (typeof object.jquery !== 'undefined') object = object[0];
        return typeof object.nodeType !== 'undefined';
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === 'string' && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest('details:not([open])');
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest('summary');
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains('disabled')) return true;
        if (typeof element.disabled !== 'undefined') return element.disabled;
        return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === 'function') {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === 'loading') {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === 'rtl';
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    exports1.defineJQueryPlugin = defineJQueryPlugin;
    exports1.execute = execute;
    exports1.executeAfterTransition = executeAfterTransition;
    exports1.findShadowRoot = findShadowRoot;
    exports1.getElement = getElement;
    exports1.getNextActiveElement = getNextActiveElement;
    exports1.getTransitionDurationFromElement = getTransitionDurationFromElement;
    exports1.getUID = getUID;
    exports1.getjQuery = getjQuery;
    exports1.isDisabled = isDisabled;
    exports1.isElement = isElement;
    exports1.isRTL = isRTL;
    exports1.isVisible = isVisible;
    exports1.noop = noop;
    exports1.onDOMContentLoaded = onDOMContentLoaded;
    exports1.parseSelector = parseSelector;
    exports1.reflow = reflow;
    exports1.toType = toType;
    exports1.triggerTransitionEnd = triggerTransitionEnd;
    Object.defineProperty(exports1, Symbol.toStringTag, {
        value: 'Module'
    });
});

});


parcelRegister("9TT4C", function(module, exports) {


/*!
  * Bootstrap config.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("h7W4v")), (parcelRequire("djsKl")));
})(module.exports, function(Manipulator, index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = index_js.isElement(element) ? Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === 'object' ? jsonConfig : {},
                ...index_js.isElement(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === 'object' ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = index_js.isElement(value) ? 'element' : index_js.toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    return Config;
});

});
parcelRegister("h7W4v", function(module, exports) {
/*!
  * Bootstrap manipulator.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === 'true') return true;
        if (value === 'false') return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === '' || value === 'null') return null;
        if (typeof value !== 'string') return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    return Manipulator;
});

});



parcelRegister("f415C", function(module, exports) {

/*!
  * Bootstrap selector-engine.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("djsKl")));
})(module.exports, function(index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute('data-bs-target');
        if (!selector || selector === '#') {
            let hrefAttribute = element.getAttribute('href');
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
            selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(',').map((sel)=>index_js.parseSelector(sel)).join(',') : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                'a',
                'button',
                'input',
                'textarea',
                'select',
                'details',
                '[tabindex]',
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
            return this.find(focusables, element).filter((el)=>!index_js.isDisabled(el) && index_js.isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    return SelectorEngine;
});

});

parcelRegister("1hDBS", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => (parcelRequire("cjXE8")).popperGenerator);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("ywf9A")).default);
$parcel$export(module.exports, "createPopperBase", () => (parcelRequire("cjXE8")).createPopper);
$parcel$export(module.exports, "createPopper", () => (parcelRequire("7QRjP")).createPopper);
$parcel$export(module.exports, "createPopperLite", () => (parcelRequire("5wmH5")).createPopper);

var $7kHwf = parcelRequire("7kHwf");

var $7guwu = parcelRequire("7guwu");

var $cjXE8 = parcelRequire("cjXE8");
var $ywf9A = parcelRequire("ywf9A");

var $7QRjP = parcelRequire("7QRjP");

var $5wmH5 = parcelRequire("5wmH5");
$parcel$exportWildcard(module.exports, $7kHwf);
$parcel$exportWildcard(module.exports, $7guwu);

});
parcelRegister("7kHwf", function(module, exports) {

$parcel$export(module.exports, "top", () => $556c28a550f4fa9a$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $556c28a550f4fa9a$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $556c28a550f4fa9a$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $556c28a550f4fa9a$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $556c28a550f4fa9a$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $556c28a550f4fa9a$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $556c28a550f4fa9a$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $556c28a550f4fa9a$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $556c28a550f4fa9a$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $556c28a550f4fa9a$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $556c28a550f4fa9a$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $556c28a550f4fa9a$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $556c28a550f4fa9a$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $556c28a550f4fa9a$export$803cd8101b6c182b);
$parcel$export(module.exports, "beforeRead", () => $556c28a550f4fa9a$export$421679a7c3d56e);
$parcel$export(module.exports, "read", () => $556c28a550f4fa9a$export$aafa59e2e03f2942);
$parcel$export(module.exports, "afterRead", () => $556c28a550f4fa9a$export$6964f6c886723980);
$parcel$export(module.exports, "beforeMain", () => $556c28a550f4fa9a$export$c65e99957a05207c);
$parcel$export(module.exports, "main", () => $556c28a550f4fa9a$export$f22da7240b7add18);
$parcel$export(module.exports, "afterMain", () => $556c28a550f4fa9a$export$bab79516f2d662fe);
$parcel$export(module.exports, "beforeWrite", () => $556c28a550f4fa9a$export$8d4d2d70e7d46032);
$parcel$export(module.exports, "write", () => $556c28a550f4fa9a$export$68d8715fc104d294);
$parcel$export(module.exports, "afterWrite", () => $556c28a550f4fa9a$export$70a6e5159acce2e6);
$parcel$export(module.exports, "modifierPhases", () => $556c28a550f4fa9a$export$d087d3878fdf71d5);
var $556c28a550f4fa9a$export$1e95b668f3b82d = 'top';
var $556c28a550f4fa9a$export$40e543e69a8b3fbb = 'bottom';
var $556c28a550f4fa9a$export$79ffe56a765070d2 = 'right';
var $556c28a550f4fa9a$export$eabcd2c8791e7bf4 = 'left';
var $556c28a550f4fa9a$export$dfb5619354ba860 = 'auto';
var $556c28a550f4fa9a$export$aec2ce47c367b8c3 = [
    $556c28a550f4fa9a$export$1e95b668f3b82d,
    $556c28a550f4fa9a$export$40e543e69a8b3fbb,
    $556c28a550f4fa9a$export$79ffe56a765070d2,
    $556c28a550f4fa9a$export$eabcd2c8791e7bf4
];
var $556c28a550f4fa9a$export$b3571188c770cc5a = 'start';
var $556c28a550f4fa9a$export$bd5df0f255a350f8 = 'end';
var $556c28a550f4fa9a$export$390fd549c5303b4d = 'clippingParents';
var $556c28a550f4fa9a$export$d7b7311ec04a3e8f = 'viewport';
var $556c28a550f4fa9a$export$ae5ab1c730825774 = 'popper';
var $556c28a550f4fa9a$export$ca50aac9f3ba507f = 'reference';
var $556c28a550f4fa9a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $556c28a550f4fa9a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $556c28a550f4fa9a$export$b3571188c770cc5a,
        placement + "-" + $556c28a550f4fa9a$export$bd5df0f255a350f8
    ]);
}, []);
var $556c28a550f4fa9a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($556c28a550f4fa9a$export$aec2ce47c367b8c3, [
    $556c28a550f4fa9a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $556c28a550f4fa9a$export$b3571188c770cc5a,
        placement + "-" + $556c28a550f4fa9a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $556c28a550f4fa9a$export$421679a7c3d56e = 'beforeRead';
var $556c28a550f4fa9a$export$aafa59e2e03f2942 = 'read';
var $556c28a550f4fa9a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $556c28a550f4fa9a$export$c65e99957a05207c = 'beforeMain';
var $556c28a550f4fa9a$export$f22da7240b7add18 = 'main';
var $556c28a550f4fa9a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $556c28a550f4fa9a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $556c28a550f4fa9a$export$68d8715fc104d294 = 'write';
var $556c28a550f4fa9a$export$70a6e5159acce2e6 = 'afterWrite';
var $556c28a550f4fa9a$export$d087d3878fdf71d5 = [
    $556c28a550f4fa9a$export$421679a7c3d56e,
    $556c28a550f4fa9a$export$aafa59e2e03f2942,
    $556c28a550f4fa9a$export$6964f6c886723980,
    $556c28a550f4fa9a$export$c65e99957a05207c,
    $556c28a550f4fa9a$export$f22da7240b7add18,
    $556c28a550f4fa9a$export$bab79516f2d662fe,
    $556c28a550f4fa9a$export$8d4d2d70e7d46032,
    $556c28a550f4fa9a$export$68d8715fc104d294,
    $556c28a550f4fa9a$export$70a6e5159acce2e6
];

});

parcelRegister("7guwu", function(module, exports) {

$parcel$export(module.exports, "applyStyles", () => (parcelRequire("h1vqt")).default);
$parcel$export(module.exports, "arrow", () => (parcelRequire("8OLgM")).default);
$parcel$export(module.exports, "computeStyles", () => (parcelRequire("lmu7e")).default);
$parcel$export(module.exports, "eventListeners", () => (parcelRequire("28sJo")).default);
$parcel$export(module.exports, "flip", () => (parcelRequire("5QyBE")).default);
$parcel$export(module.exports, "hide", () => (parcelRequire("FLL5r")).default);
$parcel$export(module.exports, "offset", () => (parcelRequire("11ST4")).default);
$parcel$export(module.exports, "popperOffsets", () => (parcelRequire("02qRC")).default);
$parcel$export(module.exports, "preventOverflow", () => (parcelRequire("ia35h")).default);

var $h1vqt = parcelRequire("h1vqt");

var $8OLgM = parcelRequire("8OLgM");

var $lmu7e = parcelRequire("lmu7e");

var $28sJo = parcelRequire("28sJo");

var $5QyBE = parcelRequire("5QyBE");

var $FLL5r = parcelRequire("FLL5r");

var $11ST4 = parcelRequire("11ST4");

var $02qRC = parcelRequire("02qRC");

var $ia35h = parcelRequire("ia35h");

});
parcelRegister("h1vqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64ae8301b3a60ba$export$2e2bcd8739ae039);

var $v8YUd = parcelRequire("v8YUd");

var $knDSd = parcelRequire("knDSd");
// and applies them to the HTMLElements such as popper and arrow
function $c64ae8301b3a60ba$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $knDSd.isHTMLElement)(element) || !(0, $v8YUd.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $c64ae8301b3a60ba$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $knDSd.isHTMLElement)(element) || !(0, $v8YUd.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $c64ae8301b3a60ba$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $c64ae8301b3a60ba$var$applyStyles,
    effect: $c64ae8301b3a60ba$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("v8YUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d9dcdfc971d3db$export$2e2bcd8739ae039);
function $05d9dcdfc971d3db$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("knDSd", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $ed64e2a48077da4a$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $ed64e2a48077da4a$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $ed64e2a48077da4a$export$af51f0f06c0f328a);

var $2UoTv = parcelRequire("2UoTv");
function $ed64e2a48077da4a$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2UoTv.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ed64e2a48077da4a$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2UoTv.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ed64e2a48077da4a$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2UoTv.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("2UoTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e41f3a5b18c385$export$2e2bcd8739ae039);
function $21e41f3a5b18c385$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("8OLgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b7a904f97dbcca$export$2e2bcd8739ae039);

var $ecZzL = parcelRequire("ecZzL");

var $fCcRp = parcelRequire("fCcRp");

var $h1YEC = parcelRequire("h1YEC");

var $5NWNr = parcelRequire("5NWNr");

var $lJzV3 = parcelRequire("lJzV3");

var $aPm35 = parcelRequire("aPm35");

var $2lGiL = parcelRequire("2lGiL");

var $8MYkO = parcelRequire("8MYkO");

var $7kHwf = parcelRequire("7kHwf");
var $66b7a904f97dbcca$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2lGiL.default)(typeof padding !== 'number' ? padding : (0, $8MYkO.default)(padding, (0, $7kHwf.basePlacements)));
};
function $66b7a904f97dbcca$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $ecZzL.default)(state.placement);
    var axis = (0, $lJzV3.default)(basePlacement);
    var isVertical = [
        (0, $7kHwf.left),
        (0, $7kHwf.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $66b7a904f97dbcca$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $fCcRp.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $7kHwf.top) : (0, $7kHwf.left);
    var maxProp = axis === 'y' ? (0, $7kHwf.bottom) : (0, $7kHwf.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5NWNr.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $aPm35.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $66b7a904f97dbcca$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $h1YEC.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $66b7a904f97dbcca$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $66b7a904f97dbcca$var$arrow,
    effect: $66b7a904f97dbcca$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("ecZzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a581f35f79b988c2$export$2e2bcd8739ae039);

function $a581f35f79b988c2$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("fCcRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e4616c482e2763$export$2e2bcd8739ae039);

var $6KZZ2 = parcelRequire("6KZZ2");
function $b5e4616c482e2763$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $6KZZ2.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("6KZZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb71e940f75bb28$export$2e2bcd8739ae039);

var $knDSd = parcelRequire("knDSd");

var $hW0BM = parcelRequire("hW0BM");

var $2UoTv = parcelRequire("2UoTv");

var $bm19G = parcelRequire("bm19G");
function $4eb71e940f75bb28$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $knDSd.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hW0BM.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hW0BM.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $knDSd.isElement)(element) ? (0, $2UoTv.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bm19G.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("hW0BM", function(module, exports) {

$parcel$export(module.exports, "max", () => $d0e8533dd664b9cb$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $d0e8533dd664b9cb$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $d0e8533dd664b9cb$export$2077e0241d6afd3c);
var $d0e8533dd664b9cb$export$8960430cfd85939f = Math.max;
var $d0e8533dd664b9cb$export$96ec731ed4dcb222 = Math.min;
var $d0e8533dd664b9cb$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bm19G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8442a531e630c86c$export$2e2bcd8739ae039);

var $6fVXK = parcelRequire("6fVXK");
function $8442a531e630c86c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6fVXK.default)());
}

});
parcelRegister("6fVXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e11afb3d2bc0f5$export$2e2bcd8739ae039);
function $48e11afb3d2bc0f5$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("h1YEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c661944ae1ded30e$export$2e2bcd8739ae039);

var $knDSd = parcelRequire("knDSd");
function $c661944ae1ded30e$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $knDSd.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5NWNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $439f231a526d5b0e$export$2e2bcd8739ae039);

var $2UoTv = parcelRequire("2UoTv");

var $v8YUd = parcelRequire("v8YUd");

var $567QB = parcelRequire("567QB");

var $knDSd = parcelRequire("knDSd");

var $c3BqJ = parcelRequire("c3BqJ");

var $fgq0w = parcelRequire("fgq0w");

var $6fVXK = parcelRequire("6fVXK");
function $439f231a526d5b0e$var$getTrueOffsetParent(element) {
    if (!(0, $knDSd.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $567QB.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $439f231a526d5b0e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6fVXK.default)());
    var isIE = /Trident/i.test((0, $6fVXK.default)());
    if (isIE && (0, $knDSd.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $567QB.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $fgq0w.default)(element);
    if ((0, $knDSd.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $knDSd.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $v8YUd.default)(currentNode)) < 0){
        var css = (0, $567QB.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $439f231a526d5b0e$export$2e2bcd8739ae039(element) {
    var window = (0, $2UoTv.default)(element);
    var offsetParent = $439f231a526d5b0e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c3BqJ.default)(offsetParent) && (0, $567QB.default)(offsetParent).position === 'static')offsetParent = $439f231a526d5b0e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $v8YUd.default)(offsetParent) === 'html' || (0, $v8YUd.default)(offsetParent) === 'body' && (0, $567QB.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $439f231a526d5b0e$var$getContainingBlock(element) || window;
}

});
parcelRegister("567QB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6399a0a5dbbbd7$export$2e2bcd8739ae039);

var $2UoTv = parcelRequire("2UoTv");
function $3b6399a0a5dbbbd7$export$2e2bcd8739ae039(element) {
    return (0, $2UoTv.default)(element).getComputedStyle(element);
}

});

parcelRegister("c3BqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c72ccb1613ef5da$export$2e2bcd8739ae039);

var $v8YUd = parcelRequire("v8YUd");
function $8c72ccb1613ef5da$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $v8YUd.default)(element)) >= 0;
}

});

parcelRegister("fgq0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1cc8624ff56e7d8$export$2e2bcd8739ae039);

var $v8YUd = parcelRequire("v8YUd");

var $lMBkn = parcelRequire("lMBkn");

var $knDSd = parcelRequire("knDSd");
function $b1cc8624ff56e7d8$export$2e2bcd8739ae039(element) {
    if ((0, $v8YUd.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $knDSd.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $lMBkn.default)(element) // fallback
    );
}

});
parcelRegister("lMBkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdbb092453f21d74$export$2e2bcd8739ae039);

var $knDSd = parcelRequire("knDSd");
function $fdbb092453f21d74$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $knDSd.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("lJzV3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd29a9c25b1c28e0$export$2e2bcd8739ae039);
function $fd29a9c25b1c28e0$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("aPm35", function(module, exports) {

$parcel$export(module.exports, "within", () => $7e1fc53ca80a5149$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $7e1fc53ca80a5149$export$86c8af6d3ef0b4a);

var $hW0BM = parcelRequire("hW0BM");
function $7e1fc53ca80a5149$export$f28d906d67a997f3(min, value, max) {
    return (0, $hW0BM.max)(min, (0, $hW0BM.min)(value, max));
}
function $7e1fc53ca80a5149$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $7e1fc53ca80a5149$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("2lGiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5e5b2564530c1a$export$2e2bcd8739ae039);

var $2KonG = parcelRequire("2KonG");
function $1b5e5b2564530c1a$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2KonG.default)(), paddingObject);
}

});
parcelRegister("2KonG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2002ca2e4a600be3$export$2e2bcd8739ae039);
function $2002ca2e4a600be3$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("8MYkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $66619ba8ff522654$export$2e2bcd8739ae039);
function $66619ba8ff522654$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("lmu7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d30360e9d2e517$export$2e2bcd8739ae039);

var $7kHwf = parcelRequire("7kHwf");

var $5NWNr = parcelRequire("5NWNr");

var $2UoTv = parcelRequire("2UoTv");

var $lMBkn = parcelRequire("lMBkn");

var $567QB = parcelRequire("567QB");

var $ecZzL = parcelRequire("ecZzL");

var $cpmVm = parcelRequire("cpmVm");

var $hW0BM = parcelRequire("hW0BM");
var $f8d30360e9d2e517$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $f8d30360e9d2e517$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hW0BM.round)(x * dpr) / dpr || 0,
        y: (0, $hW0BM.round)(y * dpr) / dpr || 0
    };
}
function $f8d30360e9d2e517$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7kHwf.left);
    var sideY = (0, $7kHwf.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5NWNr.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2UoTv.default)(popper)) {
            offsetParent = (0, $lMBkn.default)(popper);
            if ((0, $567QB.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7kHwf.top) || (placement === (0, $7kHwf.left) || placement === (0, $7kHwf.right)) && variation === (0, $7kHwf.end)) {
            sideY = (0, $7kHwf.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7kHwf.left) || (placement === (0, $7kHwf.top) || placement === (0, $7kHwf.bottom)) && variation === (0, $7kHwf.end)) {
            sideX = (0, $7kHwf.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $f8d30360e9d2e517$var$unsetSides);
    var _ref4 = roundOffsets === true ? $f8d30360e9d2e517$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2UoTv.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $f8d30360e9d2e517$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $ecZzL.default)(state.placement),
        variation: (0, $cpmVm.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $f8d30360e9d2e517$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $f8d30360e9d2e517$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f8d30360e9d2e517$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $f8d30360e9d2e517$var$computeStyles,
    data: {}
};

});
parcelRegister("cpmVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $90899a1bc1e3e8f2$export$2e2bcd8739ae039);
function $90899a1bc1e3e8f2$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("28sJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e29d87bed6925a$export$2e2bcd8739ae039);

var $2UoTv = parcelRequire("2UoTv");
var $18e29d87bed6925a$var$passive = {
    passive: true
};
function $18e29d87bed6925a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2UoTv.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $18e29d87bed6925a$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $18e29d87bed6925a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $18e29d87bed6925a$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $18e29d87bed6925a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $18e29d87bed6925a$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $18e29d87bed6925a$var$effect,
    data: {}
};

});

parcelRegister("5QyBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $441ca7274ebffd48$export$2e2bcd8739ae039);

var $i4eyG = parcelRequire("i4eyG");

var $ecZzL = parcelRequire("ecZzL");

var $74pEl = parcelRequire("74pEl");

var $ywf9A = parcelRequire("ywf9A");

var $b6aHQ = parcelRequire("b6aHQ");

var $7kHwf = parcelRequire("7kHwf");

var $cpmVm = parcelRequire("cpmVm");
function $441ca7274ebffd48$var$getExpandedFallbackPlacements(placement) {
    if ((0, $ecZzL.default)(placement) === (0, $7kHwf.auto)) return [];
    var oppositePlacement = (0, $i4eyG.default)(placement);
    return [
        (0, $74pEl.default)(placement),
        oppositePlacement,
        (0, $74pEl.default)(oppositePlacement)
    ];
}
function $441ca7274ebffd48$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $ecZzL.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $i4eyG.default)(preferredPlacement)
    ] : $441ca7274ebffd48$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $ecZzL.default)(placement) === (0, $7kHwf.auto) ? (0, $b6aHQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $ecZzL.default)(placement);
        var isStartVariation = (0, $cpmVm.default)(placement) === (0, $7kHwf.start);
        var isVertical = [
            (0, $7kHwf.top),
            (0, $7kHwf.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $ywf9A.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7kHwf.right) : (0, $7kHwf.left) : isStartVariation ? (0, $7kHwf.bottom) : (0, $7kHwf.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $i4eyG.default)(mainVariationSide);
        var altVariationSide = (0, $i4eyG.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $441ca7274ebffd48$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $441ca7274ebffd48$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("i4eyG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d273e4b671fff366$export$2e2bcd8739ae039);
var $d273e4b671fff366$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d273e4b671fff366$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d273e4b671fff366$var$hash[matched];
    });
}

});

parcelRegister("74pEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $525ccda323d52362$export$2e2bcd8739ae039);
var $525ccda323d52362$var$hash = {
    start: 'end',
    end: 'start'
};
function $525ccda323d52362$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $525ccda323d52362$var$hash[matched];
    });
}

});

parcelRegister("ywf9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $067c2ff5f92610a3$export$2e2bcd8739ae039);

var $c3JYH = parcelRequire("c3JYH");

var $lMBkn = parcelRequire("lMBkn");

var $6KZZ2 = parcelRequire("6KZZ2");

var $4WNJK = parcelRequire("4WNJK");

var $feQV8 = parcelRequire("feQV8");

var $7kHwf = parcelRequire("7kHwf");

var $knDSd = parcelRequire("knDSd");

var $2lGiL = parcelRequire("2lGiL");

var $8MYkO = parcelRequire("8MYkO");
function $067c2ff5f92610a3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7kHwf.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7kHwf.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7kHwf.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2lGiL.default)(typeof padding !== 'number' ? padding : (0, $8MYkO.default)(padding, (0, $7kHwf.basePlacements)));
    var altContext = elementContext === (0, $7kHwf.popper) ? (0, $7kHwf.reference) : (0, $7kHwf.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c3JYH.default)((0, $knDSd.isElement)(element) ? element : element.contextElement || (0, $lMBkn.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $6KZZ2.default)(state.elements.reference);
    var popperOffsets = (0, $4WNJK.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $feQV8.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7kHwf.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7kHwf.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7kHwf.right),
                (0, $7kHwf.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7kHwf.top),
                (0, $7kHwf.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("c3JYH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c796e2640aa9457$export$2e2bcd8739ae039);

var $7kHwf = parcelRequire("7kHwf");

var $70qUe = parcelRequire("70qUe");

var $fKosH = parcelRequire("fKosH");

var $fGooq = parcelRequire("fGooq");

var $5NWNr = parcelRequire("5NWNr");

var $lMBkn = parcelRequire("lMBkn");

var $567QB = parcelRequire("567QB");

var $knDSd = parcelRequire("knDSd");

var $6KZZ2 = parcelRequire("6KZZ2");

var $fgq0w = parcelRequire("fgq0w");

var $h1YEC = parcelRequire("h1YEC");

var $v8YUd = parcelRequire("v8YUd");

var $feQV8 = parcelRequire("feQV8");

var $hW0BM = parcelRequire("hW0BM");
function $8c796e2640aa9457$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $6KZZ2.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $8c796e2640aa9457$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7kHwf.viewport) ? (0, $feQV8.default)((0, $70qUe.default)(element, strategy)) : (0, $knDSd.isElement)(clippingParent) ? $8c796e2640aa9457$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $feQV8.default)((0, $fKosH.default)((0, $lMBkn.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $8c796e2640aa9457$var$getClippingParents(element) {
    var clippingParents = (0, $fGooq.default)((0, $fgq0w.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $567QB.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $knDSd.isHTMLElement)(element) ? (0, $5NWNr.default)(element) : element;
    if (!(0, $knDSd.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $knDSd.isElement)(clippingParent) && (0, $h1YEC.default)(clippingParent, clipperElement) && (0, $v8YUd.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $8c796e2640aa9457$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $8c796e2640aa9457$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $8c796e2640aa9457$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hW0BM.max)(rect.top, accRect.top);
        accRect.right = (0, $hW0BM.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hW0BM.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hW0BM.max)(rect.left, accRect.left);
        return accRect;
    }, $8c796e2640aa9457$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("70qUe", function(module, exports) {

$parcel$export(module.exports, "default", () => $519d6776de9008a4$export$2e2bcd8739ae039);

var $2UoTv = parcelRequire("2UoTv");

var $lMBkn = parcelRequire("lMBkn");

var $iOmmO = parcelRequire("iOmmO");

var $bm19G = parcelRequire("bm19G");
function $519d6776de9008a4$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2UoTv.default)(element);
    var html = (0, $lMBkn.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bm19G.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $iOmmO.default)(element),
        y: y
    };
}

});
parcelRegister("iOmmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $db1e3f23c2d2c67e$export$2e2bcd8739ae039);

var $6KZZ2 = parcelRequire("6KZZ2");

var $lMBkn = parcelRequire("lMBkn");

var $dIh0y = parcelRequire("dIh0y");
function $db1e3f23c2d2c67e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $6KZZ2.default)((0, $lMBkn.default)(element)).left + (0, $dIh0y.default)(element).scrollLeft;
}

});
parcelRegister("dIh0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fbc93d3686f5982$export$2e2bcd8739ae039);

var $2UoTv = parcelRequire("2UoTv");
function $9fbc93d3686f5982$export$2e2bcd8739ae039(node) {
    var win = (0, $2UoTv.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("fKosH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b76e207e1f480d60$export$2e2bcd8739ae039);

var $lMBkn = parcelRequire("lMBkn");

var $567QB = parcelRequire("567QB");

var $iOmmO = parcelRequire("iOmmO");

var $dIh0y = parcelRequire("dIh0y");

var $hW0BM = parcelRequire("hW0BM");
function $b76e207e1f480d60$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $lMBkn.default)(element);
    var winScroll = (0, $dIh0y.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hW0BM.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hW0BM.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $iOmmO.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $567QB.default)(body || html).direction === 'rtl') x += (0, $hW0BM.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("fGooq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6adb32f76d02d22$export$2e2bcd8739ae039);

var $bvwHn = parcelRequire("bvwHn");

var $fgq0w = parcelRequire("fgq0w");

var $2UoTv = parcelRequire("2UoTv");

var $1YSq6 = parcelRequire("1YSq6");
function $b6adb32f76d02d22$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $bvwHn.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2UoTv.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1YSq6.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($b6adb32f76d02d22$export$2e2bcd8739ae039((0, $fgq0w.default)(target)));
}

});
parcelRegister("bvwHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $860bf437fd508a93$export$2e2bcd8739ae039);

var $fgq0w = parcelRequire("fgq0w");

var $1YSq6 = parcelRequire("1YSq6");

var $v8YUd = parcelRequire("v8YUd");

var $knDSd = parcelRequire("knDSd");
function $860bf437fd508a93$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $v8YUd.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $knDSd.isHTMLElement)(node) && (0, $1YSq6.default)(node)) return node;
    return $860bf437fd508a93$export$2e2bcd8739ae039((0, $fgq0w.default)(node));
}

});
parcelRegister("1YSq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $17159bb96bcd3807$export$2e2bcd8739ae039);

var $567QB = parcelRequire("567QB");
function $17159bb96bcd3807$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $567QB.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("feQV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b18136be2f52ba6b$export$2e2bcd8739ae039);
function $b18136be2f52ba6b$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("4WNJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a328e95b4aef7b$export$2e2bcd8739ae039);

var $ecZzL = parcelRequire("ecZzL");

var $cpmVm = parcelRequire("cpmVm");

var $lJzV3 = parcelRequire("lJzV3");

var $7kHwf = parcelRequire("7kHwf");
function $39a328e95b4aef7b$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $ecZzL.default)(placement) : null;
    var variation = placement ? (0, $cpmVm.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7kHwf.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7kHwf.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7kHwf.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7kHwf.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lJzV3.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7kHwf.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7kHwf.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("b6aHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $81488f49a4fb33a5$export$2e2bcd8739ae039);

var $cpmVm = parcelRequire("cpmVm");

var $7kHwf = parcelRequire("7kHwf");

var $ywf9A = parcelRequire("ywf9A");

var $ecZzL = parcelRequire("ecZzL");
function $81488f49a4fb33a5$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7kHwf.placements) : _options$allowedAutoP;
    var variation = (0, $cpmVm.default)(placement);
    var placements = variation ? flipVariations ? (0, $7kHwf.variationPlacements) : (0, $7kHwf.variationPlacements).filter(function(placement) {
        return (0, $cpmVm.default)(placement) === variation;
    }) : (0, $7kHwf.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ywf9A.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $ecZzL.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("FLL5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $07d8e04946542d67$export$2e2bcd8739ae039);

var $7kHwf = parcelRequire("7kHwf");

var $ywf9A = parcelRequire("ywf9A");
function $07d8e04946542d67$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $07d8e04946542d67$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7kHwf.top),
        (0, $7kHwf.right),
        (0, $7kHwf.bottom),
        (0, $7kHwf.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $07d8e04946542d67$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ywf9A.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $ywf9A.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $07d8e04946542d67$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $07d8e04946542d67$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $07d8e04946542d67$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $07d8e04946542d67$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $07d8e04946542d67$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $07d8e04946542d67$var$hide
};

});

parcelRegister("11ST4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0075e52aa0969e$export$2e2bcd8739ae039);

var $ecZzL = parcelRequire("ecZzL");

var $7kHwf = parcelRequire("7kHwf");
function $0c0075e52aa0969e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $ecZzL.default)(placement);
    var invertDistance = [
        (0, $7kHwf.left),
        (0, $7kHwf.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7kHwf.left),
        (0, $7kHwf.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $0c0075e52aa0969e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7kHwf.placements).reduce(function(acc, placement) {
        acc[placement] = $0c0075e52aa0969e$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0c0075e52aa0969e$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $0c0075e52aa0969e$var$offset
};

});

parcelRegister("02qRC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0075069c6ccaa0e6$export$2e2bcd8739ae039);

var $4WNJK = parcelRequire("4WNJK");
function $0075069c6ccaa0e6$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4WNJK.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0075069c6ccaa0e6$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0075069c6ccaa0e6$var$popperOffsets,
    data: {}
};

});

parcelRegister("ia35h", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38b8d9c7b6e5b35$export$2e2bcd8739ae039);

var $7kHwf = parcelRequire("7kHwf");

var $ecZzL = parcelRequire("ecZzL");

var $lJzV3 = parcelRequire("lJzV3");

var $2e2Z6 = parcelRequire("2e2Z6");

var $aPm35 = parcelRequire("aPm35");

var $fCcRp = parcelRequire("fCcRp");

var $5NWNr = parcelRequire("5NWNr");

var $ywf9A = parcelRequire("ywf9A");

var $cpmVm = parcelRequire("cpmVm");

var $2KonG = parcelRequire("2KonG");

var $hW0BM = parcelRequire("hW0BM");
function $d38b8d9c7b6e5b35$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ywf9A.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $ecZzL.default)(state.placement);
    var variation = (0, $cpmVm.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lJzV3.default)(basePlacement);
    var altAxis = (0, $2e2Z6.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7kHwf.top) : (0, $7kHwf.left);
        var altSide = mainAxis === 'y' ? (0, $7kHwf.bottom) : (0, $7kHwf.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7kHwf.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7kHwf.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $fCcRp.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $2KonG.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $aPm35.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5NWNr.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $aPm35.within)(tether ? (0, $hW0BM.min)(min, tetherMin) : min, offset, tether ? (0, $hW0BM.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7kHwf.top) : (0, $7kHwf.left);
        var _altSide = mainAxis === 'x' ? (0, $7kHwf.bottom) : (0, $7kHwf.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7kHwf.top),
            (0, $7kHwf.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $aPm35.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $aPm35.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d38b8d9c7b6e5b35$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $d38b8d9c7b6e5b35$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("2e2Z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ef3439648e3d00$export$2e2bcd8739ae039);
function $19ef3439648e3d00$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("cjXE8", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $8f8586e34877a92d$export$ed5e13716264f202);
$parcel$export(module.exports, "createPopper", () => $8f8586e34877a92d$export$8f7491d57c8f97a9);

var $aXnFh = parcelRequire("aXnFh");

var $fCcRp = parcelRequire("fCcRp");

var $fGooq = parcelRequire("fGooq");

var $5NWNr = parcelRequire("5NWNr");

var $f3HKp = parcelRequire("f3HKp");

var $37bON = parcelRequire("37bON");

var $bnzPZ = parcelRequire("bnzPZ");

var $ywf9A = parcelRequire("ywf9A");

var $knDSd = parcelRequire("knDSd");
var $8f8586e34877a92d$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $8f8586e34877a92d$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $8f8586e34877a92d$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $8f8586e34877a92d$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $8f8586e34877a92d$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $knDSd.isElement)(reference) ? (0, $fGooq.default)(reference) : reference.contextElement ? (0, $fGooq.default)(reference.contextElement) : [],
                    popper: (0, $fGooq.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f3HKp.default)((0, $bnzPZ.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$8f8586e34877a92d$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $aXnFh.default)(reference, (0, $5NWNr.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $fCcRp.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $37bON.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$8f8586e34877a92d$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $8f8586e34877a92d$export$8f7491d57c8f97a9 = /*#__PURE__*/ $8f8586e34877a92d$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("aXnFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa1c564e3f97080$export$2e2bcd8739ae039);

var $6KZZ2 = parcelRequire("6KZZ2");

var $90TB9 = parcelRequire("90TB9");

var $v8YUd = parcelRequire("v8YUd");

var $knDSd = parcelRequire("knDSd");

var $iOmmO = parcelRequire("iOmmO");

var $lMBkn = parcelRequire("lMBkn");

var $1YSq6 = parcelRequire("1YSq6");

var $hW0BM = parcelRequire("hW0BM");
function $7fa1c564e3f97080$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hW0BM.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hW0BM.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $7fa1c564e3f97080$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $knDSd.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $knDSd.isHTMLElement)(offsetParent) && $7fa1c564e3f97080$var$isElementScaled(offsetParent);
    var documentElement = (0, $lMBkn.default)(offsetParent);
    var rect = (0, $6KZZ2.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $v8YUd.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1YSq6.default)(documentElement)) scroll = (0, $90TB9.default)(offsetParent);
        if ((0, $knDSd.isHTMLElement)(offsetParent)) {
            offsets = (0, $6KZZ2.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $iOmmO.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("90TB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ff3dc6753e66f2$export$2e2bcd8739ae039);

var $dIh0y = parcelRequire("dIh0y");

var $2UoTv = parcelRequire("2UoTv");

var $knDSd = parcelRequire("knDSd");

var $grIL7 = parcelRequire("grIL7");
function $68ff3dc6753e66f2$export$2e2bcd8739ae039(node) {
    if (node === (0, $2UoTv.default)(node) || !(0, $knDSd.isHTMLElement)(node)) return (0, $dIh0y.default)(node);
    else return (0, $grIL7.default)(node);
}

});
parcelRegister("grIL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf91e32767fcda28$export$2e2bcd8739ae039);
function $bf91e32767fcda28$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("f3HKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6912321c8bbeae$export$2e2bcd8739ae039);

var $7kHwf = parcelRequire("7kHwf");
function $af6912321c8bbeae$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $af6912321c8bbeae$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $af6912321c8bbeae$var$order(modifiers); // order based on phase
    return (0, $7kHwf.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("37bON", function(module, exports) {

$parcel$export(module.exports, "default", () => $244b3169a18a2ef0$export$2e2bcd8739ae039);
function $244b3169a18a2ef0$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("bnzPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $848da4495958ed55$export$2e2bcd8739ae039);
function $848da4495958ed55$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("7QRjP", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $5b76bfba18d87fb2$export$8f7491d57c8f97a9);

var $cjXE8 = parcelRequire("cjXE8");

var $28sJo = parcelRequire("28sJo");

var $02qRC = parcelRequire("02qRC");

var $lmu7e = parcelRequire("lmu7e");

var $h1vqt = parcelRequire("h1vqt");

var $11ST4 = parcelRequire("11ST4");

var $5QyBE = parcelRequire("5QyBE");

var $ia35h = parcelRequire("ia35h");

var $8OLgM = parcelRequire("8OLgM");

var $FLL5r = parcelRequire("FLL5r");


var $5b76bfba18d87fb2$export$d34966752335dd47 = [
    (0, $28sJo.default),
    (0, $02qRC.default),
    (0, $lmu7e.default),
    (0, $h1vqt.default),
    (0, $11ST4.default),
    (0, $5QyBE.default),
    (0, $ia35h.default),
    (0, $8OLgM.default),
    (0, $FLL5r.default)
];
var $5b76bfba18d87fb2$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $cjXE8.popperGenerator)({
    defaultModifiers: $5b76bfba18d87fb2$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("5wmH5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $40518b784487aea9$export$8f7491d57c8f97a9);

var $cjXE8 = parcelRequire("cjXE8");

var $28sJo = parcelRequire("28sJo");

var $02qRC = parcelRequire("02qRC");

var $lmu7e = parcelRequire("lmu7e");

var $h1vqt = parcelRequire("h1vqt");
var $40518b784487aea9$export$d34966752335dd47 = [
    (0, $28sJo.default),
    (0, $02qRC.default),
    (0, $lmu7e.default),
    (0, $h1vqt.default)
];
var $40518b784487aea9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $cjXE8.popperGenerator)({
    defaultModifiers: $40518b784487aea9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


parcelRegister("1kpuQ", function(module, exports) {



/*!
  * Bootstrap backdrop.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("eIqqi")), (parcelRequire("9TT4C")), (parcelRequire("djsKl")));
})(module.exports, function(EventHandler, Config, index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'backdrop';
    const CLASS_NAME_FADE = 'fade';
    const CLASS_NAME_SHOW = 'show';
    const EVENT_MOUSEDOWN = `mousedown.bs.${NAME}`;
    const Default = {
        className: 'modal-backdrop',
        clickCallback: null,
        isAnimated: false,
        isVisible: true,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: 'body' // give the choice to place backdrop under different elements
    };
    const DefaultType = {
        className: 'string',
        clickCallback: '(function|null)',
        isAnimated: 'boolean',
        isVisible: 'boolean',
        rootElement: '(element|string)'
    };
    /**
   * Class definition
   */ class Backdrop extends Config {
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isAppended = false;
            this._element = null;
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        show(callback) {
            if (!this._config.isVisible) {
                index_js.execute(callback);
                return;
            }
            this._append();
            const element = this._getElement();
            if (this._config.isAnimated) index_js.reflow(element);
            element.classList.add(CLASS_NAME_SHOW);
            this._emulateAnimation(()=>{
                index_js.execute(callback);
            });
        }
        hide(callback) {
            if (!this._config.isVisible) {
                index_js.execute(callback);
                return;
            }
            this._getElement().classList.remove(CLASS_NAME_SHOW);
            this._emulateAnimation(()=>{
                this.dispose();
                index_js.execute(callback);
            });
        }
        dispose() {
            if (!this._isAppended) return;
            EventHandler.off(this._element, EVENT_MOUSEDOWN);
            this._element.remove();
            this._isAppended = false;
        }
        // Private
        _getElement() {
            if (!this._element) {
                const backdrop = document.createElement('div');
                backdrop.className = this._config.className;
                if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE);
                this._element = backdrop;
            }
            return this._element;
        }
        _configAfterMerge(config) {
            // use getElement() with the default "body" to get a fresh Element on each instantiation
            config.rootElement = index_js.getElement(config.rootElement);
            return config;
        }
        _append() {
            if (this._isAppended) return;
            const element = this._getElement();
            this._config.rootElement.append(element);
            EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
                index_js.execute(this._config.clickCallback);
            });
            this._isAppended = true;
        }
        _emulateAnimation(callback) {
            index_js.executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
        }
    }
    return Backdrop;
});

});

parcelRegister("aiVHJ", function(module, exports) {



/*!
  * Bootstrap component-functions.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory(module.exports, (parcelRequire("eIqqi")), (parcelRequire("f415C")), (parcelRequire("djsKl")));
})(module.exports, function(exports1, EventHandler, SelectorEngine, index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = 'hide')=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                'A',
                'AREA'
            ].includes(this.tagName)) event.preventDefault();
            if (index_js.isDisabled(this)) return;
            const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target);
            // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    exports1.enableDismissTrigger = enableDismissTrigger;
    Object.defineProperty(exports1, Symbol.toStringTag, {
        value: 'Module'
    });
});

});

parcelRegister("69NoN", function(module, exports) {



/*!
  * Bootstrap focustrap.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("eIqqi")), (parcelRequire("f415C")), (parcelRequire("9TT4C")));
})(module.exports, function(EventHandler, SelectorEngine, Config) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'focustrap';
    const DATA_KEY = 'bs.focustrap';
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY}`;
    const TAB_KEY = 'Tab';
    const TAB_NAV_FORWARD = 'forward';
    const TAB_NAV_BACKWARD = 'backward';
    const Default = {
        autofocus: true,
        trapElement: null // The element to trap focus inside of
    };
    const DefaultType = {
        autofocus: 'boolean',
        trapElement: 'element'
    };
    /**
   * Class definition
   */ class FocusTrap extends Config {
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isActive = false;
            this._lastTabNavDirection = null;
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        activate() {
            if (this._isActive) return;
            if (this._config.autofocus) this._config.trapElement.focus();
            EventHandler.off(document, EVENT_KEY); // guard against infinite focus loop
            EventHandler.on(document, EVENT_FOCUSIN, (event)=>this._handleFocusin(event));
            EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
            this._isActive = true;
        }
        deactivate() {
            if (!this._isActive) return;
            this._isActive = false;
            EventHandler.off(document, EVENT_KEY);
        }
        // Private
        _handleFocusin(event) {
            const { trapElement: trapElement } = this._config;
            if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
            const elements = SelectorEngine.focusableChildren(trapElement);
            if (elements.length === 0) trapElement.focus();
            else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
            else elements[0].focus();
        }
        _handleKeydown(event) {
            if (event.key !== TAB_KEY) return;
            this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
        }
    }
    return FocusTrap;
});

});

parcelRegister("6EGSC", function(module, exports) {



/*!
  * Bootstrap scrollbar.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("h7W4v")), (parcelRequire("f415C")), (parcelRequire("djsKl")));
})(module.exports, function(Manipulator, SelectorEngine, index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
    const SELECTOR_STICKY_CONTENT = '.sticky-top';
    const PROPERTY_PADDING = 'padding-right';
    const PROPERTY_MARGIN = 'margin-right';
    /**
   * Class definition
   */ class ScrollBarHelper {
        constructor(){
            this._element = document.body;
        }
        // Public
        getWidth() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
            const documentWidth = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - documentWidth);
        }
        hide() {
            const width = this.getWidth();
            this._disableOverFlow();
            // give padding to element to balance the hidden scrollbar width
            this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
            this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
        }
        reset() {
            this._resetElementAttributes(this._element, 'overflow');
            this._resetElementAttributes(this._element, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        // Private
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, 'overflow');
            this._element.style.overflow = 'hidden';
        }
        _setElementAttributes(selector, styleProperty, callback) {
            const scrollbarWidth = this.getWidth();
            const manipulationCallBack = (element)=>{
                if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                this._saveInitialAttribute(element, styleProperty);
                const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _saveInitialAttribute(element, styleProperty) {
            const actualValue = element.style.getPropertyValue(styleProperty);
            if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
        }
        _resetElementAttributes(selector, styleProperty) {
            const manipulationCallBack = (element)=>{
                const value = Manipulator.getDataAttribute(element, styleProperty);
                // We only want to remove the property if the value is `null`; the value can also be zero
                if (value === null) {
                    element.style.removeProperty(styleProperty);
                    return;
                }
                Manipulator.removeDataAttribute(element, styleProperty);
                element.style.setProperty(styleProperty, value);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _applyManipulationCallback(selector, callBack) {
            if (index_js.isElement(selector)) {
                callBack(selector);
                return;
            }
            for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
        }
    }
    return ScrollBarHelper;
});

});

var $960e2dbf1996ce31$exports = {};




/*!
  * Bootstrap collapse.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $960e2dbf1996ce31$exports = factory((parcelRequire("jwRWS")), (parcelRequire("eIqqi")), (parcelRequire("f415C")), (parcelRequire("djsKl")));
})($960e2dbf1996ce31$exports, function(BaseComponent, EventHandler, SelectorEngine, index_js) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'collapse';
    const DATA_KEY = 'bs.collapse';
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = '.data-api';
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = 'show';
    const CLASS_NAME_COLLAPSE = 'collapse';
    const CLASS_NAME_COLLAPSING = 'collapsing';
    const CLASS_NAME_COLLAPSED = 'collapsed';
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
    const WIDTH = 'width';
    const HEIGHT = 'height';
    const SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
    const Default = {
        parent: null,
        toggle: true
    };
    const DefaultType = {
        parent: '(null|element)',
        toggle: 'boolean'
    };
    /**
   * Class definition
   */ class Collapse extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._isTransitioning = false;
            this._triggerArray = [];
            const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE);
            for (const elem of toggleList){
                const selector = SelectorEngine.getSelectorFromElement(elem);
                const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
                if (selector !== null && filterElement.length) this._triggerArray.push(elem);
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let activeChildren = [];
            // find active children
            if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                    toggle: false
                }));
            if (activeChildren.length && activeChildren[0]._isTransitioning) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_SHOW);
            if (startEvent.defaultPrevented) return;
            for (const activeInstance of activeChildren)activeInstance.hide();
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
                this._element.style[dimension] = '';
                EventHandler.trigger(this._element, EVENT_SHOWN);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            index_js.reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
            for (const trigger of this._triggerArray){
                const element = SelectorEngine.getElementFromSelector(trigger);
                if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.style[dimension] = '';
            this._queueCallback(complete, this._element, true);
        }
        // Private
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW);
        }
        _configAfterMerge(config) {
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = index_js.getElement(config.parent);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE);
            for (const element of children){
                const selected = SelectorEngine.getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            }
        }
        _getFirstLevelChildren(selector) {
            const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            // remove children if greater depth
            return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            for (const element of triggerArray){
                element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                element.setAttribute('aria-expanded', isOpen);
            }
        }
        // Static
        static jQueryInterface(config) {
            const _config = {};
            if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
            return this.each(function() {
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === 'string') {
                    if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
        for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
            toggle: false
        }).toggle();
    });
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Collapse);
    return Collapse;
});


var $68efa47fe8f2c3fc$exports = {};






/*!
  * Bootstrap dropdown.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $68efa47fe8f2c3fc$exports = factory((parcelRequire("1hDBS")), (parcelRequire("jwRWS")), (parcelRequire("eIqqi")), (parcelRequire("h7W4v")), (parcelRequire("f415C")), (parcelRequire("djsKl")));
})($68efa47fe8f2c3fc$exports, function(Popper, BaseComponent, EventHandler, Manipulator, SelectorEngine, index_js) {
    'use strict';
    function _interopNamespaceDefault(e) {
        const n = Object.create(null, {
            [Symbol.toStringTag]: {
                value: 'Module'
            }
        });
        if (e) {
            for(const k in e)if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespaceDefault(Popper);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'dropdown';
    const DATA_KEY = 'bs.dropdown';
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = '.data-api';
    const ESCAPE_KEY = 'Escape';
    const TAB_KEY = 'Tab';
    const ARROW_UP_KEY = 'ArrowUp';
    const ARROW_DOWN_KEY = 'ArrowDown';
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY}${DATA_API_KEY}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = 'show';
    const CLASS_NAME_DROPUP = 'dropup';
    const CLASS_NAME_DROPEND = 'dropend';
    const CLASS_NAME_DROPSTART = 'dropstart';
    const CLASS_NAME_DROPUP_CENTER = 'dropup-center';
    const CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE}.${CLASS_NAME_SHOW}`;
    const SELECTOR_MENU = '.dropdown-menu';
    const SELECTOR_NAVBAR = '.navbar';
    const SELECTOR_NAVBAR_NAV = '.navbar-nav';
    const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
    const PLACEMENT_TOP = index_js.isRTL() ? 'top-end' : 'top-start';
    const PLACEMENT_TOPEND = index_js.isRTL() ? 'top-start' : 'top-end';
    const PLACEMENT_BOTTOM = index_js.isRTL() ? 'bottom-end' : 'bottom-start';
    const PLACEMENT_BOTTOMEND = index_js.isRTL() ? 'bottom-start' : 'bottom-end';
    const PLACEMENT_RIGHT = index_js.isRTL() ? 'left-start' : 'right-start';
    const PLACEMENT_LEFT = index_js.isRTL() ? 'right-start' : 'left-start';
    const PLACEMENT_TOPCENTER = 'top';
    const PLACEMENT_BOTTOMCENTER = 'bottom';
    const Default = {
        autoClose: true,
        boundary: 'clippingParents',
        display: 'dynamic',
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: 'toggle'
    };
    const DefaultType = {
        autoClose: '(boolean|string)',
        boundary: '(string|element)',
        display: 'string',
        offset: '(array|string|function)',
        popperConfig: '(null|object|function)',
        reference: '(string|element|object)'
    };
    /**
   * Class definition
   */ class Dropdown extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._popper = null;
            this._parent = this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
            this._inNavbar = this._detectNavbar();
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (index_js.isDisabled(this._element) || this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW, relatedTarget);
            if (showEvent.defaultPrevented) return;
            this._createPopper();
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ('ontouchstart' in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', index_js.noop);
            this._element.focus();
            this._element.setAttribute('aria-expanded', true);
            this._menu.classList.add(CLASS_NAME_SHOW);
            this._element.classList.add(CLASS_NAME_SHOW);
            EventHandler.trigger(this._element, EVENT_SHOWN, relatedTarget);
        }
        hide() {
            if (index_js.isDisabled(this._element) || !this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        // Private
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE, relatedTarget);
            if (hideEvent.defaultPrevented) return;
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', index_js.noop);
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW);
            this._element.classList.remove(CLASS_NAME_SHOW);
            this._element.setAttribute('aria-expanded', 'false');
            Manipulator.removeDataAttribute(this._menu, 'popper');
            EventHandler.trigger(this._element, EVENT_HIDDEN, relatedTarget);
        }
        _getConfig(config) {
            config = super._getConfig(config);
            if (typeof config.reference === 'object' && !index_js.isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper() {
            if (typeof Popper__namespace === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
            let referenceElement = this._element;
            if (this._config.reference === 'parent') referenceElement = this._parent;
            else if (index_js.isElement(this._config.reference)) referenceElement = index_js.getElement(this._config.reference);
            else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
        }
        _isShown() {
            return this._menu.classList.contains(CLASS_NAME_SHOW);
        }
        _getPlacement() {
            const parentDropdown = this._parent;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
            // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(SELECTOR_NAVBAR) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
            if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            // Disable Popper if we have a static display or Dropdown is in Navbar
            if (this._inNavbar || this._config.display === 'static') {
                Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                defaultBsPopperConfig.modifiers = [
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ];
            }
            return {
                ...defaultBsPopperConfig,
                ...index_js.execute(this._config.popperConfig, [
                    undefined,
                    defaultBsPopperConfig
                ])
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>index_js.isVisible(element));
            if (!items.length) return;
            // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            index_js.getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY) return;
            const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
            for (const toggle of openToggles){
                const context = Dropdown.getInstance(toggle);
                if (!context || context._config.autoClose === false) continue;
                const composedPath = event.composedPath();
                const isMenuTarget = composedPath.includes(context._menu);
                if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event.type === 'click') relatedTarget.clickEvent = event;
                context._completeHide(relatedTarget);
            }
        }
        static dataApiKeydownHandler(event) {
            // If not an UP | DOWN | ESCAPE key => not a dropdown command
            // If input/textarea && if key is other than ESCAPE => not a dropdown command
            const isInput = /input|textarea/i.test(event.target.tagName);
            const isEscapeEvent = event.key === ESCAPE_KEY;
            const isUpOrDownEvent = [
                ARROW_UP_KEY,
                ARROW_DOWN_KEY
            ].includes(event.key);
            if (!isUpOrDownEvent && !isEscapeEvent) return;
            if (isInput && !isEscapeEvent) return;
            event.preventDefault();
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE, event.delegateTarget.parentNode);
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (isUpOrDownEvent) {
                event.stopPropagation();
                instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (instance._isShown()) {
                // else is escape and we check if it is shown
                event.stopPropagation();
                instance.hide();
                getToggleButton.focus();
            }
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Dropdown);
    return Dropdown;
});


var $f79a6de3831f4209$exports = {};








/*!
  * Bootstrap modal.js v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $f79a6de3831f4209$exports = factory((parcelRequire("jwRWS")), (parcelRequire("eIqqi")), (parcelRequire("f415C")), (parcelRequire("1kpuQ")), (parcelRequire("aiVHJ")), (parcelRequire("69NoN")), (parcelRequire("djsKl")), (parcelRequire("6EGSC")));
})($f79a6de3831f4209$exports, function(BaseComponent, EventHandler, SelectorEngine, Backdrop, componentFunctions_js, FocusTrap, index_js, ScrollBarHelper) {
    'use strict';
    /**
   * --------------------------------------------------------------------------
   * Bootstrap modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = 'modal';
    const DATA_KEY = 'bs.modal';
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = '.data-api';
    const ESCAPE_KEY = 'Escape';
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_RESIZE = `resize${EVENT_KEY}`;
    const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY}`;
    const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY}`;
    const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_OPEN = 'modal-open';
    const CLASS_NAME_FADE = 'fade';
    const CLASS_NAME_SHOW = 'show';
    const CLASS_NAME_STATIC = 'modal-static';
    const OPEN_SELECTOR = '.modal.show';
    const SELECTOR_DIALOG = '.modal-dialog';
    const SELECTOR_MODAL_BODY = '.modal-body';
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="modal"]';
    const Default = {
        backdrop: true,
        focus: true,
        keyboard: true
    };
    const DefaultType = {
        backdrop: '(boolean|string)',
        focus: 'boolean',
        keyboard: 'boolean'
    };
    /**
   * Class definition
   */ class Modal extends BaseComponent {
        constructor(element, config){
            super(element, config);
            this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._isShown = false;
            this._isTransitioning = false;
            this._scrollBar = new ScrollBarHelper();
            this._addEventListeners();
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown || this._isTransitioning) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._isTransitioning = true;
            this._scrollBar.hide();
            document.body.classList.add(CLASS_NAME_OPEN);
            this._adjustDialog();
            this._backdrop.show(()=>this._showElement(relatedTarget));
        }
        hide() {
            if (!this._isShown || this._isTransitioning) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            this._isShown = false;
            this._isTransitioning = true;
            this._focustrap.deactivate();
            this._element.classList.remove(CLASS_NAME_SHOW);
            this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
        }
        dispose() {
            EventHandler.off(window, EVENT_KEY);
            EventHandler.off(this._dialog, EVENT_KEY);
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        // Private
        _initializeBackDrop() {
            return new Backdrop({
                isVisible: Boolean(this._config.backdrop),
                // 'static' option will be translated to true, and booleans will keep their value,
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _showElement(relatedTarget) {
            // try to append dynamic modal
            if (!document.body.contains(this._element)) document.body.append(this._element);
            this._element.style.display = 'block';
            this._element.removeAttribute('aria-hidden');
            this._element.setAttribute('aria-modal', true);
            this._element.setAttribute('role', 'dialog');
            this._element.scrollTop = 0;
            const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
            if (modalBody) modalBody.scrollTop = 0;
            index_js.reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW);
            const transitionComplete = ()=>{
                if (this._config.focus) this._focustrap.activate();
                this._isTransitioning = false;
                EventHandler.trigger(this._element, EVENT_SHOWN, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
                if (event.key !== ESCAPE_KEY) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                this._triggerBackdropTransition();
            });
            EventHandler.on(window, EVENT_RESIZE, ()=>{
                if (this._isShown && !this._isTransitioning) this._adjustDialog();
            });
            EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
                // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                    if (this._element !== event.target || this._element !== event2.target) return;
                    if (this._config.backdrop === 'static') {
                        this._triggerBackdropTransition();
                        return;
                    }
                    if (this._config.backdrop) this.hide();
                });
            });
        }
        _hideModal() {
            this._element.style.display = 'none';
            this._element.setAttribute('aria-hidden', true);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            this._isTransitioning = false;
            this._backdrop.hide(()=>{
                document.body.classList.remove(CLASS_NAME_OPEN);
                this._resetAdjustments();
                this._scrollBar.reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            });
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_FADE);
        }
        _triggerBackdropTransition() {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
            if (hideEvent.defaultPrevented) return;
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const initialOverflowY = this._element.style.overflowY;
            // return if the following background transition hasn't yet completed
            if (initialOverflowY === 'hidden' || this._element.classList.contains(CLASS_NAME_STATIC)) return;
            if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
            this._element.classList.add(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.classList.remove(CLASS_NAME_STATIC);
                this._queueCallback(()=>{
                    this._element.style.overflowY = initialOverflowY;
                }, this._dialog);
            }, this._dialog);
            this._element.focus();
        }
        /**
     * The following methods are used to handle overflowing modals
     */ _adjustDialog() {
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const scrollbarWidth = this._scrollBar.getWidth();
            const isBodyOverflowing = scrollbarWidth > 0;
            if (isBodyOverflowing && !isModalOverflowing) {
                const property = index_js.isRTL() ? 'paddingLeft' : 'paddingRight';
                this._element.style[property] = `${scrollbarWidth}px`;
            }
            if (!isBodyOverflowing && isModalOverflowing) {
                const property = index_js.isRTL() ? 'paddingRight' : 'paddingLeft';
                this._element.style[property] = `${scrollbarWidth}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = '';
            this._element.style.paddingRight = '';
        }
        // Static
        static jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                const data = Modal.getOrCreateInstance(this, config);
                if (typeof config !== 'string') return;
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](relatedTarget);
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        EventHandler.one(target, EVENT_SHOW, (showEvent)=>{
            if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
            return;
            EventHandler.one(target, EVENT_HIDDEN, ()=>{
                if (index_js.isVisible(this)) this.focus();
            });
        });
        // avoid conflict when clicking modal toggler while another one is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
        if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
        const data = Modal.getOrCreateInstance(target);
        data.toggle(this);
    });
    componentFunctions_js.enableDismissTrigger(Modal);
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Modal);
    return Modal;
});


/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $01bdee395f33be11$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $01bdee395f33be11$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $01bdee395f33be11$export$bcc6e673dfa14d36(v) {
    return $01bdee395f33be11$export$837ba5c449269406($01bdee395f33be11$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $01bdee395f33be11$export$869b26d4e1bbdb63(v) {
    return $01bdee395f33be11$export$837ba5c449269406($01bdee395f33be11$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $01bdee395f33be11$export$ed9bd8dcaeba14f6(v) {
    return $01bdee395f33be11$export$837ba5c449269406($01bdee395f33be11$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $01bdee395f33be11$export$dbf961a8d278dbef(v) {
    return $01bdee395f33be11$export$837ba5c449269406($01bdee395f33be11$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $01bdee395f33be11$export$aa35ef1f24408ab9(v) {
    return $01bdee395f33be11$export$837ba5c449269406($01bdee395f33be11$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $01bdee395f33be11$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $01bdee395f33be11$var$hex = [
    ...'0123456789ABCDEF'
];
const $01bdee395f33be11$var$h1 = (b)=>$01bdee395f33be11$var$hex[b & 0xF];
const $01bdee395f33be11$var$h2 = (b)=>$01bdee395f33be11$var$hex[(b & 0xF0) >> 4] + $01bdee395f33be11$var$hex[b & 0xF];
const $01bdee395f33be11$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $01bdee395f33be11$var$isShort = (v)=>$01bdee395f33be11$var$eq(v.r) && $01bdee395f33be11$var$eq(v.g) && $01bdee395f33be11$var$eq(v.b) && $01bdee395f33be11$var$eq(v.a);
function $01bdee395f33be11$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $01bdee395f33be11$var$map$1[str[1]] * 17,
            g: 255 & $01bdee395f33be11$var$map$1[str[2]] * 17,
            b: 255 & $01bdee395f33be11$var$map$1[str[3]] * 17,
            a: len === 5 ? $01bdee395f33be11$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $01bdee395f33be11$var$map$1[str[1]] << 4 | $01bdee395f33be11$var$map$1[str[2]],
            g: $01bdee395f33be11$var$map$1[str[3]] << 4 | $01bdee395f33be11$var$map$1[str[4]],
            b: $01bdee395f33be11$var$map$1[str[5]] << 4 | $01bdee395f33be11$var$map$1[str[6]],
            a: len === 9 ? $01bdee395f33be11$var$map$1[str[7]] << 4 | $01bdee395f33be11$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $01bdee395f33be11$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $01bdee395f33be11$export$1b06654353ef9f67(v) {
    var f = $01bdee395f33be11$var$isShort(v) ? $01bdee395f33be11$var$h1 : $01bdee395f33be11$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $01bdee395f33be11$var$alpha(v.a, f) : undefined;
}
const $01bdee395f33be11$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $01bdee395f33be11$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $01bdee395f33be11$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $01bdee395f33be11$var$hwb2rgbn(h, w, b) {
    const rgb = $01bdee395f33be11$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $01bdee395f33be11$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $01bdee395f33be11$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $01bdee395f33be11$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $01bdee395f33be11$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($01bdee395f33be11$export$ed9bd8dcaeba14f6);
}
function $01bdee395f33be11$export$4c15bd42559b811d(h, s, l) {
    return $01bdee395f33be11$var$calln($01bdee395f33be11$var$hsl2rgbn, h, s, l);
}
function $01bdee395f33be11$export$e2710022c70fc9ee(h, w, b) {
    return $01bdee395f33be11$var$calln($01bdee395f33be11$var$hwb2rgbn, h, w, b);
}
function $01bdee395f33be11$export$b785a357c84e4a04(h, s, v) {
    return $01bdee395f33be11$var$calln($01bdee395f33be11$var$hsv2rgbn, h, s, v);
}
function $01bdee395f33be11$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $01bdee395f33be11$export$5e91288c399be4f9(str) {
    const m = $01bdee395f33be11$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $01bdee395f33be11$export$bcc6e673dfa14d36(+m[5]) : $01bdee395f33be11$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $01bdee395f33be11$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $01bdee395f33be11$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $01bdee395f33be11$export$b785a357c84e4a04(h, p1, p2);
    else v = $01bdee395f33be11$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $01bdee395f33be11$export$bb628a54ab399bc9(v, deg) {
    var h = $01bdee395f33be11$export$b5ba70b240f8f7f(v);
    h[0] = $01bdee395f33be11$var$hue(h[0] + deg);
    h = $01bdee395f33be11$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $01bdee395f33be11$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $01bdee395f33be11$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $01bdee395f33be11$export$aa35ef1f24408ab9(a[1]);
    const l = $01bdee395f33be11$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$01bdee395f33be11$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $01bdee395f33be11$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $01bdee395f33be11$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $01bdee395f33be11$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($01bdee395f33be11$var$names$1);
    const tkeys = Object.keys($01bdee395f33be11$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $01bdee395f33be11$var$map[k]);
        }
        k = parseInt($01bdee395f33be11$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $01bdee395f33be11$var$names;
function $01bdee395f33be11$export$b2f06b640faad956(str) {
    if (!$01bdee395f33be11$var$names) {
        $01bdee395f33be11$var$names = $01bdee395f33be11$var$unpack();
        $01bdee395f33be11$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $01bdee395f33be11$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $01bdee395f33be11$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $01bdee395f33be11$export$91aedb20f296e541(str) {
    const m = $01bdee395f33be11$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $01bdee395f33be11$export$bcc6e673dfa14d36(v) : $01bdee395f33be11$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $01bdee395f33be11$export$bcc6e673dfa14d36(r) : $01bdee395f33be11$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $01bdee395f33be11$export$bcc6e673dfa14d36(g) : $01bdee395f33be11$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $01bdee395f33be11$export$bcc6e673dfa14d36(b) : $01bdee395f33be11$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $01bdee395f33be11$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$01bdee395f33be11$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $01bdee395f33be11$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $01bdee395f33be11$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $01bdee395f33be11$var$interpolate(rgb1, rgb2, t) {
    const r = $01bdee395f33be11$var$from($01bdee395f33be11$export$dbf961a8d278dbef(rgb1.r));
    const g = $01bdee395f33be11$var$from($01bdee395f33be11$export$dbf961a8d278dbef(rgb1.g));
    const b = $01bdee395f33be11$var$from($01bdee395f33be11$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $01bdee395f33be11$export$ed9bd8dcaeba14f6($01bdee395f33be11$var$to(r + t * ($01bdee395f33be11$var$from($01bdee395f33be11$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $01bdee395f33be11$export$ed9bd8dcaeba14f6($01bdee395f33be11$var$to(g + t * ($01bdee395f33be11$var$from($01bdee395f33be11$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $01bdee395f33be11$export$ed9bd8dcaeba14f6($01bdee395f33be11$var$to(b + t * ($01bdee395f33be11$var$from($01bdee395f33be11$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $01bdee395f33be11$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $01bdee395f33be11$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $01bdee395f33be11$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $01bdee395f33be11$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $01bdee395f33be11$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $01bdee395f33be11$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $01bdee395f33be11$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $01bdee395f33be11$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $01bdee395f33be11$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $01bdee395f33be11$export$91aedb20f296e541(str);
    return $01bdee395f33be11$export$5e91288c399be4f9(str);
}
class $01bdee395f33be11$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $01bdee395f33be11$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $01bdee395f33be11$var$fromObject(input);
        else if (type === 'string') v = $01bdee395f33be11$export$625a38b961e8b5e9(input) || $01bdee395f33be11$export$b2f06b640faad956(input) || $01bdee395f33be11$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $01bdee395f33be11$var$clone(this._rgb);
        if (v) v.a = $01bdee395f33be11$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $01bdee395f33be11$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $01bdee395f33be11$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $01bdee395f33be11$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $01bdee395f33be11$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $01bdee395f33be11$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $01bdee395f33be11$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $01bdee395f33be11$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $01bdee395f33be11$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $01bdee395f33be11$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $01bdee395f33be11$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $01bdee395f33be11$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $01bdee395f33be11$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $01bdee395f33be11$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $01bdee395f33be11$export$2e2bcd8739ae039(input) {
    return new $01bdee395f33be11$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $2fb01f2a1812f701$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $2fb01f2a1812f701$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $2fb01f2a1812f701$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $2fb01f2a1812f701$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $2fb01f2a1812f701$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $2fb01f2a1812f701$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $2fb01f2a1812f701$export$c4ce752e73470fba(value, defaultValue) {
    return $2fb01f2a1812f701$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $2fb01f2a1812f701$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $2fb01f2a1812f701$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $2fb01f2a1812f701$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $2fb01f2a1812f701$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $2fb01f2a1812f701$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($2fb01f2a1812f701$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($2fb01f2a1812f701$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $2fb01f2a1812f701$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $2fb01f2a1812f701$export$667d3bf0c5f83305(source) {
    if ($2fb01f2a1812f701$export$8b22cf2602fb60ce(source)) return source.map($2fb01f2a1812f701$export$667d3bf0c5f83305);
    if ($2fb01f2a1812f701$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $2fb01f2a1812f701$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $2fb01f2a1812f701$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $2fb01f2a1812f701$export$317a3d46287192d8(key, target, source, options) {
    if (!$2fb01f2a1812f701$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($2fb01f2a1812f701$export$23f2a1d2818174ef(tval) && $2fb01f2a1812f701$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $2fb01f2a1812f701$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $2fb01f2a1812f701$export$667d3bf0c5f83305(sval);
}
function $2fb01f2a1812f701$export$efca4cbe5dd06740(target, source, options) {
    const sources = $2fb01f2a1812f701$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$2fb01f2a1812f701$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $2fb01f2a1812f701$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$2fb01f2a1812f701$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $2fb01f2a1812f701$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $2fb01f2a1812f701$export$efca4cbe5dd06740(target, source, {
        merger: $2fb01f2a1812f701$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $2fb01f2a1812f701$export$1ee57be6f6687d2c(key, target, source) {
    if (!$2fb01f2a1812f701$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($2fb01f2a1812f701$export$23f2a1d2818174ef(tval) && $2fb01f2a1812f701$export$23f2a1d2818174ef(sval)) $2fb01f2a1812f701$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $2fb01f2a1812f701$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $2fb01f2a1812f701$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $2fb01f2a1812f701$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $2fb01f2a1812f701$var$_getKeyResolver(key) {
    const keys = $2fb01f2a1812f701$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $2fb01f2a1812f701$export$2d1720544b23b823(obj, key) {
    const resolver = $2fb01f2a1812f701$var$keyResolvers[key] || ($2fb01f2a1812f701$var$keyResolvers[key] = $2fb01f2a1812f701$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $2fb01f2a1812f701$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $2fb01f2a1812f701$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $2fb01f2a1812f701$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $2fb01f2a1812f701$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $2fb01f2a1812f701$export$56c0d5a1e737357d = Math.PI;
const $2fb01f2a1812f701$export$971d5caa766a69d7 = 2 * $2fb01f2a1812f701$export$56c0d5a1e737357d;
const $2fb01f2a1812f701$export$2ec5befb9e6c97d4 = $2fb01f2a1812f701$export$971d5caa766a69d7 + $2fb01f2a1812f701$export$56c0d5a1e737357d;
const $2fb01f2a1812f701$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $2fb01f2a1812f701$export$39c1cc7c062529d4 = $2fb01f2a1812f701$export$56c0d5a1e737357d / 180;
const $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd = $2fb01f2a1812f701$export$56c0d5a1e737357d / 2;
const $2fb01f2a1812f701$export$7a0bdf7d4a91ea88 = $2fb01f2a1812f701$export$56c0d5a1e737357d / 4;
const $2fb01f2a1812f701$export$c18d01048907ea92 = $2fb01f2a1812f701$export$56c0d5a1e737357d * 2 / 3;
const $2fb01f2a1812f701$export$faec65b429be379 = Math.log10;
const $2fb01f2a1812f701$export$2408f22a0fab9ae5 = Math.sign;
function $2fb01f2a1812f701$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $2fb01f2a1812f701$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $2fb01f2a1812f701$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($2fb01f2a1812f701$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $2fb01f2a1812f701$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $2fb01f2a1812f701$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $2fb01f2a1812f701$export$d141bba7fdc215a3(n) {
    return !$2fb01f2a1812f701$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $2fb01f2a1812f701$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $2fb01f2a1812f701$export$625550452a3fa3ec(degrees) {
    return degrees * ($2fb01f2a1812f701$export$56c0d5a1e737357d / 180);
}
function $2fb01f2a1812f701$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $2fb01f2a1812f701$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $2fb01f2a1812f701$export$91477dc880baac21(x) {
    if (!$2fb01f2a1812f701$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $2fb01f2a1812f701$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $2fb01f2a1812f701$export$56c0d5a1e737357d) angle += $2fb01f2a1812f701$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $2fb01f2a1812f701$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $2fb01f2a1812f701$export$f074adc9fbd50943(a, b) {
    return (a - b + $2fb01f2a1812f701$export$2ec5befb9e6c97d4) % $2fb01f2a1812f701$export$971d5caa766a69d7 - $2fb01f2a1812f701$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $2fb01f2a1812f701$export$ab83b03e4111b1d0(a) {
    return (a % $2fb01f2a1812f701$export$971d5caa766a69d7 + $2fb01f2a1812f701$export$971d5caa766a69d7) % $2fb01f2a1812f701$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $2fb01f2a1812f701$export$ab83b03e4111b1d0(angle);
    const s = $2fb01f2a1812f701$export$ab83b03e4111b1d0(start);
    const e = $2fb01f2a1812f701$export$ab83b03e4111b1d0(end);
    const angleToStart = $2fb01f2a1812f701$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $2fb01f2a1812f701$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $2fb01f2a1812f701$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $2fb01f2a1812f701$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $2fb01f2a1812f701$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $2fb01f2a1812f701$export$71cec2538cb2c617(value) {
    return $2fb01f2a1812f701$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $2fb01f2a1812f701$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $2fb01f2a1812f701$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $2fb01f2a1812f701$export$ef35774e6d314e91 = (table, key, value, last)=>$2fb01f2a1812f701$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $2fb01f2a1812f701$export$ebd11618f299a286 = (table, key, value)=>$2fb01f2a1812f701$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $2fb01f2a1812f701$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $2fb01f2a1812f701$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $2fb01f2a1812f701$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $2fb01f2a1812f701$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $2fb01f2a1812f701$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $2fb01f2a1812f701$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $2fb01f2a1812f701$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $2fb01f2a1812f701$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $2fb01f2a1812f701$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $2fb01f2a1812f701$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $2fb01f2a1812f701$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $2fb01f2a1812f701$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $2fb01f2a1812f701$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $2fb01f2a1812f701$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $2fb01f2a1812f701$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $2fb01f2a1812f701$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $2fb01f2a1812f701$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($2fb01f2a1812f701$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $2fb01f2a1812f701$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$2fb01f2a1812f701$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $2fb01f2a1812f701$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($2fb01f2a1812f701$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $2fb01f2a1812f701$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$2fb01f2a1812f701$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $2fb01f2a1812f701$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $2fb01f2a1812f701$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $2fb01f2a1812f701$var$atEdge = (t)=>t === 0 || t === 1;
const $2fb01f2a1812f701$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $2fb01f2a1812f701$export$971d5caa766a69d7 / p));
const $2fb01f2a1812f701$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $2fb01f2a1812f701$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $2fb01f2a1812f701$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($2fb01f2a1812f701$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$2fb01f2a1812f701$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$2fb01f2a1812f701$var$atEdge(t) ? t : $2fb01f2a1812f701$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$2fb01f2a1812f701$var$atEdge(t) ? t : $2fb01f2a1812f701$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $2fb01f2a1812f701$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $2fb01f2a1812f701$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $2fb01f2a1812f701$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $2fb01f2a1812f701$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $2fb01f2a1812f701$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $2fb01f2a1812f701$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $2fb01f2a1812f701$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $2fb01f2a1812f701$export$db3b6bfb95261072(value) {
    return $2fb01f2a1812f701$export$738ab4df8bf92ae9(value) ? value : new (0, $01bdee395f33be11$export$892596cec99bc70e)(value);
}
function $2fb01f2a1812f701$export$d377dcb2b61d6c4e(value) {
    return $2fb01f2a1812f701$export$738ab4df8bf92ae9(value) ? value : new (0, $01bdee395f33be11$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $2fb01f2a1812f701$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $2fb01f2a1812f701$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $2fb01f2a1812f701$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $2fb01f2a1812f701$var$colors
        },
        numbers: {
            type: 'number',
            properties: $2fb01f2a1812f701$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $2fb01f2a1812f701$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $2fb01f2a1812f701$var$intlCache = new Map();
function $2fb01f2a1812f701$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $2fb01f2a1812f701$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $2fb01f2a1812f701$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $2fb01f2a1812f701$export$ae1af26003f05816(num, locale, options) {
    return $2fb01f2a1812f701$var$getNumberFormat(locale, options).format(num);
}
const $2fb01f2a1812f701$var$formatters = {
    values (value) {
        return $2fb01f2a1812f701$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $2fb01f2a1812f701$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $2fb01f2a1812f701$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $2fb01f2a1812f701$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($2fb01f2a1812f701$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $2fb01f2a1812f701$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $2fb01f2a1812f701$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $2fb01f2a1812f701$export$9f4f30ee63539e24 = {
    formatters: $2fb01f2a1812f701$var$formatters
};
function $2fb01f2a1812f701$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $2fb01f2a1812f701$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $2fb01f2a1812f701$export$6559d589eb85fbb6 = Object.create(null);
const $2fb01f2a1812f701$export$2e2af4578d910ddf = Object.create(null);
function $2fb01f2a1812f701$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $2fb01f2a1812f701$var$set(root, scope, values) {
    if (typeof scope === 'string') return $2fb01f2a1812f701$export$efca4cbe5dd06740($2fb01f2a1812f701$var$getScope$1(root, scope), values);
    return $2fb01f2a1812f701$export$efca4cbe5dd06740($2fb01f2a1812f701$var$getScope$1(root, ''), scope);
}
class $2fb01f2a1812f701$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$2fb01f2a1812f701$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$2fb01f2a1812f701$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$2fb01f2a1812f701$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $2fb01f2a1812f701$var$set(this, scope, values);
    }
    get(scope) {
        return $2fb01f2a1812f701$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $2fb01f2a1812f701$var$set($2fb01f2a1812f701$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $2fb01f2a1812f701$var$set($2fb01f2a1812f701$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $2fb01f2a1812f701$var$getScope$1(this, scope);
        const targetScopeObject = $2fb01f2a1812f701$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($2fb01f2a1812f701$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $2fb01f2a1812f701$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $2fb01f2a1812f701$export$4368d992c4eafac0 = /* #__PURE__ */ new $2fb01f2a1812f701$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $2fb01f2a1812f701$var$applyAnimationsDefaults,
    $2fb01f2a1812f701$var$applyLayoutsDefaults,
    $2fb01f2a1812f701$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $2fb01f2a1812f701$export$e171bab687b50e0(font) {
    if (!font || $2fb01f2a1812f701$export$342063e11d6c3cad(font.size) || $2fb01f2a1812f701$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $2fb01f2a1812f701$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$2fb01f2a1812f701$export$8b22cf2602fb60ce(thing)) longest = $2fb01f2a1812f701$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($2fb01f2a1812f701$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$2fb01f2a1812f701$export$8b22cf2602fb60ce(nestedThing)) longest = $2fb01f2a1812f701$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $2fb01f2a1812f701$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $2fb01f2a1812f701$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $2fb01f2a1812f701$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $2fb01f2a1812f701$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $2fb01f2a1812f701$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $2fb01f2a1812f701$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $2fb01f2a1812f701$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $2fb01f2a1812f701$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $2fb01f2a1812f701$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $2fb01f2a1812f701$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $2fb01f2a1812f701$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $2fb01f2a1812f701$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $2fb01f2a1812f701$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $2fb01f2a1812f701$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $2fb01f2a1812f701$export$56c0d5a1e737357d, rad - $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd, rad + $2fb01f2a1812f701$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $2fb01f2a1812f701$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $2fb01f2a1812f701$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $2fb01f2a1812f701$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $2fb01f2a1812f701$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $2fb01f2a1812f701$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $2fb01f2a1812f701$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $2fb01f2a1812f701$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$2fb01f2a1812f701$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $2fb01f2a1812f701$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $2fb01f2a1812f701$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $2fb01f2a1812f701$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $2fb01f2a1812f701$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $2fb01f2a1812f701$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $2fb01f2a1812f701$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$2fb01f2a1812f701$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $2fb01f2a1812f701$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $2fb01f2a1812f701$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $2fb01f2a1812f701$export$56c0d5a1e737357d, $2fb01f2a1812f701$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $2fb01f2a1812f701$export$56c0d5a1e737357d, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$2fb01f2a1812f701$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $2fb01f2a1812f701$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $2fb01f2a1812f701$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $2fb01f2a1812f701$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($2fb01f2a1812f701$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $2fb01f2a1812f701$var$numberOrZero = (v)=>+v || 0;
function $2fb01f2a1812f701$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $2fb01f2a1812f701$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $2fb01f2a1812f701$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$2fb01f2a1812f701$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $2fb01f2a1812f701$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $2fb01f2a1812f701$export$9fa96a7d116ea3ce(value) {
    return $2fb01f2a1812f701$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $2fb01f2a1812f701$export$28f7fcd39efa255(value) {
    return $2fb01f2a1812f701$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $2fb01f2a1812f701$export$a9c23c6ac3fc3eca(value) {
    const obj = $2fb01f2a1812f701$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $2fb01f2a1812f701$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $2fb01f2a1812f701$export$4368d992c4eafac0.font;
    let size = $2fb01f2a1812f701$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $2fb01f2a1812f701$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($2fb01f2a1812f701$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $2fb01f2a1812f701$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $2fb01f2a1812f701$export$d29e374196577086($2fb01f2a1812f701$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $2fb01f2a1812f701$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $2fb01f2a1812f701$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $2fb01f2a1812f701$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $2fb01f2a1812f701$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $2fb01f2a1812f701$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $2fb01f2a1812f701$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $2fb01f2a1812f701$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $2fb01f2a1812f701$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $2fb01f2a1812f701$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$2fb01f2a1812f701$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $2fb01f2a1812f701$var$_cached(target, prop, ()=>$2fb01f2a1812f701$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $2fb01f2a1812f701$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $2fb01f2a1812f701$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $2fb01f2a1812f701$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $2fb01f2a1812f701$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$2fb01f2a1812f701$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$2fb01f2a1812f701$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $2fb01f2a1812f701$var$_cached(target, prop, ()=>$2fb01f2a1812f701$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $2fb01f2a1812f701$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $2fb01f2a1812f701$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $2fb01f2a1812f701$var$readKey = (prefix, name)=>prefix ? prefix + $2fb01f2a1812f701$export$a8550f7dbe79f93a(name) : name;
const $2fb01f2a1812f701$var$needsSubResolver = (prop, value)=>$2fb01f2a1812f701$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $2fb01f2a1812f701$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $2fb01f2a1812f701$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($2fb01f2a1812f701$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $2fb01f2a1812f701$var$_resolveScriptable(prop, value, target, receiver);
    if ($2fb01f2a1812f701$export$8b22cf2602fb60ce(value) && value.length) value = $2fb01f2a1812f701$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($2fb01f2a1812f701$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $2fb01f2a1812f701$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $2fb01f2a1812f701$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($2fb01f2a1812f701$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $2fb01f2a1812f701$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $2fb01f2a1812f701$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($2fb01f2a1812f701$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $2fb01f2a1812f701$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($2fb01f2a1812f701$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $2fb01f2a1812f701$var$resolveFallback(fallback, prop, value) {
    return $2fb01f2a1812f701$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $2fb01f2a1812f701$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $2fb01f2a1812f701$export$2d1720544b23b823(parent, key) : undefined;
function $2fb01f2a1812f701$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $2fb01f2a1812f701$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $2fb01f2a1812f701$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $2fb01f2a1812f701$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $2fb01f2a1812f701$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $2fb01f2a1812f701$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $2fb01f2a1812f701$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $2fb01f2a1812f701$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$2fb01f2a1812f701$var$subGetTarget(resolver, prop, value));
}
function $2fb01f2a1812f701$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $2fb01f2a1812f701$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $2fb01f2a1812f701$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($2fb01f2a1812f701$export$8b22cf2602fb60ce(target) && $2fb01f2a1812f701$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $2fb01f2a1812f701$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $2fb01f2a1812f701$var$_resolve($2fb01f2a1812f701$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $2fb01f2a1812f701$var$needsSubResolver(prop, value) ? $2fb01f2a1812f701$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $2fb01f2a1812f701$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $2fb01f2a1812f701$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $2fb01f2a1812f701$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $2fb01f2a1812f701$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $2fb01f2a1812f701$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($2fb01f2a1812f701$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $2fb01f2a1812f701$var$EPSILON = Number.EPSILON || 1e-14;
const $2fb01f2a1812f701$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $2fb01f2a1812f701$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $2fb01f2a1812f701$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $2fb01f2a1812f701$export$cf2f7c5792f80b46(current, previous);
    const d12 = $2fb01f2a1812f701$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $2fb01f2a1812f701$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $2fb01f2a1812f701$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $2fb01f2a1812f701$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($2fb01f2a1812f701$export$23ebac1979863676(deltaK[i], 0, $2fb01f2a1812f701$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $2fb01f2a1812f701$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $2fb01f2a1812f701$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $2fb01f2a1812f701$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $2fb01f2a1812f701$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $2fb01f2a1812f701$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $2fb01f2a1812f701$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $2fb01f2a1812f701$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $2fb01f2a1812f701$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $2fb01f2a1812f701$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $2fb01f2a1812f701$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $2fb01f2a1812f701$var$monotoneAdjust(points, deltaK, mK);
    $2fb01f2a1812f701$var$monotoneCompute(points, mK, indexAxis);
}
function $2fb01f2a1812f701$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $2fb01f2a1812f701$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $2fb01f2a1812f701$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $2fb01f2a1812f701$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $2fb01f2a1812f701$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $2fb01f2a1812f701$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $2fb01f2a1812f701$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $2fb01f2a1812f701$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $2fb01f2a1812f701$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $2fb01f2a1812f701$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $2fb01f2a1812f701$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $2fb01f2a1812f701$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $2fb01f2a1812f701$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $2fb01f2a1812f701$export$fef3dfd9bad05307(el, property) {
    return $2fb01f2a1812f701$var$getComputedStyle(el).getPropertyValue(property);
}
const $2fb01f2a1812f701$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $2fb01f2a1812f701$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $2fb01f2a1812f701$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $2fb01f2a1812f701$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $2fb01f2a1812f701$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($2fb01f2a1812f701$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $2fb01f2a1812f701$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $2fb01f2a1812f701$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $2fb01f2a1812f701$var$getPositionedStyle(style, 'padding');
    const borders = $2fb01f2a1812f701$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $2fb01f2a1812f701$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $2fb01f2a1812f701$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $2fb01f2a1812f701$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $2fb01f2a1812f701$var$getComputedStyle(container);
            const containerBorder = $2fb01f2a1812f701$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $2fb01f2a1812f701$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $2fb01f2a1812f701$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $2fb01f2a1812f701$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $2fb01f2a1812f701$export$53c86fa97d611818,
        maxHeight: maxHeight || $2fb01f2a1812f701$export$53c86fa97d611818
    };
}
const $2fb01f2a1812f701$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $2fb01f2a1812f701$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $2fb01f2a1812f701$var$getComputedStyle(canvas);
    const margins = $2fb01f2a1812f701$var$getPositionedStyle(style, 'margin');
    const maxWidth = $2fb01f2a1812f701$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $2fb01f2a1812f701$export$53c86fa97d611818;
    const maxHeight = $2fb01f2a1812f701$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $2fb01f2a1812f701$export$53c86fa97d611818;
    const containerSize = $2fb01f2a1812f701$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $2fb01f2a1812f701$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $2fb01f2a1812f701$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $2fb01f2a1812f701$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $2fb01f2a1812f701$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $2fb01f2a1812f701$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $2fb01f2a1812f701$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $2fb01f2a1812f701$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $2fb01f2a1812f701$var$round1(chart.height * pixelRatio);
    const deviceWidth = $2fb01f2a1812f701$var$round1(chart.width * pixelRatio);
    chart.height = $2fb01f2a1812f701$var$round1(chart.height);
    chart.width = $2fb01f2a1812f701$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $2fb01f2a1812f701$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($2fb01f2a1812f701$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $2fb01f2a1812f701$export$b4171a6734a65d42(element, property) {
    const value = $2fb01f2a1812f701$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $2fb01f2a1812f701$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $2fb01f2a1812f701$export$6554612db691658e(p1, cp1, t);
    const b = $2fb01f2a1812f701$export$6554612db691658e(cp1, cp2, t);
    const c = $2fb01f2a1812f701$export$6554612db691658e(cp2, p2, t);
    const d = $2fb01f2a1812f701$export$6554612db691658e(a, b, t);
    const e = $2fb01f2a1812f701$export$6554612db691658e(b, c, t);
    return $2fb01f2a1812f701$export$6554612db691658e(d, e, t);
}
const $2fb01f2a1812f701$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $2fb01f2a1812f701$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $2fb01f2a1812f701$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $2fb01f2a1812f701$var$getRightToLeftAdapter(rectX, width) : $2fb01f2a1812f701$var$getLeftToRightAdapter();
}
function $2fb01f2a1812f701$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $2fb01f2a1812f701$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $2fb01f2a1812f701$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $2fb01f2a1812f701$export$ffb5f4729a158638,
        compare: $2fb01f2a1812f701$export$f074adc9fbd50943,
        normalize: $2fb01f2a1812f701$export$ab83b03e4111b1d0
    };
    return {
        between: $2fb01f2a1812f701$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $2fb01f2a1812f701$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $2fb01f2a1812f701$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $2fb01f2a1812f701$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $2fb01f2a1812f701$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $2fb01f2a1812f701$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $2fb01f2a1812f701$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($2fb01f2a1812f701$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($2fb01f2a1812f701$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $2fb01f2a1812f701$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $2fb01f2a1812f701$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $2fb01f2a1812f701$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $2fb01f2a1812f701$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $2fb01f2a1812f701$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $2fb01f2a1812f701$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $2fb01f2a1812f701$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $2fb01f2a1812f701$var$splitByStyles(line, $2fb01f2a1812f701$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $2fb01f2a1812f701$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $2fb01f2a1812f701$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $2fb01f2a1812f701$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $2fb01f2a1812f701$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $2fb01f2a1812f701$var$readStyle(segmentOptions.setContext($2fb01f2a1812f701$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($2fb01f2a1812f701$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $2fb01f2a1812f701$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $2fb01f2a1812f701$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$2fb01f2a1812f701$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $2fb01f2a1812f701$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $2fb01f2a1812f701$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $2fb01f2a1812f701$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $2fb01f2a1812f701$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $2fb01f2a1812f701$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $2fb01f2a1812f701$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $2fb01f2a1812f701$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $2fb01f2a1812f701$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $bc0dba28211d8859$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $2fb01f2a1812f701$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $bc0dba28211d8859$export$a424a0aa8f687495 = /* #__PURE__ */ new $bc0dba28211d8859$var$Animator();
const $bc0dba28211d8859$var$transparent = 'transparent';
const $bc0dba28211d8859$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $2fb01f2a1812f701$export$db3b6bfb95261072)(from || $bc0dba28211d8859$var$transparent);
        const c1 = c0.valid && (0, $2fb01f2a1812f701$export$db3b6bfb95261072)(to || $bc0dba28211d8859$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $bc0dba28211d8859$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $2fb01f2a1812f701$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $2fb01f2a1812f701$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $bc0dba28211d8859$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $2fb01f2a1812f701$export$f1e1789686576879)[cfg.easing] || (0, $2fb01f2a1812f701$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $2fb01f2a1812f701$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $2fb01f2a1812f701$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $bc0dba28211d8859$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $2fb01f2a1812f701$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $bc0dba28211d8859$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $bc0dba28211d8859$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $bc0dba28211d8859$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $bc0dba28211d8859$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $bc0dba28211d8859$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $bc0dba28211d8859$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $bc0dba28211d8859$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $bc0dba28211d8859$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $bc0dba28211d8859$var$scaleClip(xScale, allowedOverflow);
    const y = $bc0dba28211d8859$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $bc0dba28211d8859$var$toClip(value) {
    let t, r, b, l;
    if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $bc0dba28211d8859$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $bc0dba28211d8859$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $2fb01f2a1812f701$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(value) === (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $bc0dba28211d8859$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $bc0dba28211d8859$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $bc0dba28211d8859$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $bc0dba28211d8859$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $bc0dba28211d8859$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $bc0dba28211d8859$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $bc0dba28211d8859$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $bc0dba28211d8859$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $bc0dba28211d8859$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $bc0dba28211d8859$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $bc0dba28211d8859$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $bc0dba28211d8859$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $bc0dba28211d8859$var$createDatasetContext(parent, index) {
    return (0, $2fb01f2a1812f701$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $bc0dba28211d8859$var$createDataContext(parent, index, element) {
    return (0, $2fb01f2a1812f701$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $bc0dba28211d8859$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $bc0dba28211d8859$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $bc0dba28211d8859$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $bc0dba28211d8859$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $bc0dba28211d8859$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $bc0dba28211d8859$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $bc0dba28211d8859$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $bc0dba28211d8859$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(dataset.xAxisID, $bc0dba28211d8859$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(dataset.yAxisID, $bc0dba28211d8859$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(dataset.rAxisID, $bc0dba28211d8859$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $2fb01f2a1812f701$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $bc0dba28211d8859$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $bc0dba28211d8859$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $2fb01f2a1812f701$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $bc0dba28211d8859$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $2fb01f2a1812f701$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $bc0dba28211d8859$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $bc0dba28211d8859$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $bc0dba28211d8859$var$updateStacks(this, meta._parsed);
            meta._stacked = $bc0dba28211d8859$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $bc0dba28211d8859$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $2fb01f2a1812f701$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $2fb01f2a1812f701$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $bc0dba28211d8859$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $bc0dba28211d8859$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $bc0dba28211d8859$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $bc0dba28211d8859$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $bc0dba28211d8859$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $2fb01f2a1812f701$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $2fb01f2a1812f701$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $bc0dba28211d8859$var$toClip((0, $2fb01f2a1812f701$export$90a7f3efeed30595)(this.options.clip, $bc0dba28211d8859$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $bc0dba28211d8859$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $bc0dba28211d8859$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $2fb01f2a1812f701$export$dda1d9f60106f0e9)(index);
        if (cached) return $bc0dba28211d8859$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $2fb01f2a1812f701$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($bc0dba28211d8859$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $bc0dba28211d8859$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $bc0dba28211d8859$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($bc0dba28211d8859$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$bc0dba28211d8859$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $bc0dba28211d8859$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $bc0dba28211d8859$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $2fb01f2a1812f701$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $bc0dba28211d8859$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $bc0dba28211d8859$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $2fb01f2a1812f701$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $bc0dba28211d8859$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $bc0dba28211d8859$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $bc0dba28211d8859$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $bc0dba28211d8859$var$parseValue(entry, item, vScale, i) {
    if ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(entry)) $bc0dba28211d8859$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $bc0dba28211d8859$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($bc0dba28211d8859$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $bc0dba28211d8859$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $bc0dba28211d8859$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $bc0dba28211d8859$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $bc0dba28211d8859$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $bc0dba28211d8859$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$bc0dba28211d8859$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$bc0dba28211d8859$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $bc0dba28211d8859$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $bc0dba28211d8859$var$swap(edge, a, b);
        edge = $bc0dba28211d8859$var$startEnd(edge, b, a);
    } else edge = $bc0dba28211d8859$var$startEnd(edge, a, b);
    return edge;
}
function $bc0dba28211d8859$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $bc0dba28211d8859$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $bc0dba28211d8859$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $bc0dba28211d8859$export$e97d5dc64e999004 extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $bc0dba28211d8859$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $bc0dba28211d8859$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $2fb01f2a1812f701$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($bc0dba28211d8859$var$parseValue((0, $2fb01f2a1812f701$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $bc0dba28211d8859$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $2fb01f2a1812f701$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $bc0dba28211d8859$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $bc0dba28211d8859$var$setBorderSkipped(properties, options, stack, index);
            $bc0dba28211d8859$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $2fb01f2a1812f701$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $bc0dba28211d8859$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $bc0dba28211d8859$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(value) !== (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $bc0dba28211d8859$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $bc0dba28211d8859$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $bc0dba28211d8859$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $2fb01f2a1812f701$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $bc0dba28211d8859$export$19b5c4773f17abe extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $bc0dba28211d8859$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $2fb01f2a1812f701$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $2fb01f2a1812f701$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $2fb01f2a1812f701$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $2fb01f2a1812f701$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $2fb01f2a1812f701$export$56c0d5a1e737357d) + (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $bc0dba28211d8859$export$e04603e7d8b77172 extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $2fb01f2a1812f701$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $2fb01f2a1812f701$export$971d5caa766a69d7);
        let max = -(0, $2fb01f2a1812f701$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $2fb01f2a1812f701$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $bc0dba28211d8859$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $2fb01f2a1812f701$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $2fb01f2a1812f701$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $2fb01f2a1812f701$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $2fb01f2a1812f701$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $2fb01f2a1812f701$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $bc0dba28211d8859$export$3c9b5d28c11cbfd0 extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $2fb01f2a1812f701$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $2fb01f2a1812f701$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $2fb01f2a1812f701$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $2fb01f2a1812f701$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $bc0dba28211d8859$export$2a270b3a0d973c85 extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $2fb01f2a1812f701$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $2fb01f2a1812f701$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $2fb01f2a1812f701$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $bc0dba28211d8859$export$b21a3f1286706191 extends $bc0dba28211d8859$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $bc0dba28211d8859$export$48dbc6ac651bf8be extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $2fb01f2a1812f701$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $bc0dba28211d8859$export$b2f2bae6713db87 extends $bc0dba28211d8859$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $2fb01f2a1812f701$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $2fb01f2a1812f701$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $2fb01f2a1812f701$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $2fb01f2a1812f701$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $bc0dba28211d8859$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $bc0dba28211d8859$export$e97d5dc64e999004,
    BubbleController: $bc0dba28211d8859$export$19b5c4773f17abe,
    DoughnutController: $bc0dba28211d8859$export$e04603e7d8b77172,
    LineController: $bc0dba28211d8859$export$3c9b5d28c11cbfd0,
    PieController: $bc0dba28211d8859$export$b21a3f1286706191,
    PolarAreaController: $bc0dba28211d8859$export$2a270b3a0d973c85,
    RadarController: $bc0dba28211d8859$export$48dbc6ac651bf8be,
    ScatterController: $bc0dba28211d8859$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $bc0dba28211d8859$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $bc0dba28211d8859$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($bc0dba28211d8859$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $bc0dba28211d8859$var$abstract();
    }
    parse() {
        return $bc0dba28211d8859$var$abstract();
    }
    format() {
        return $bc0dba28211d8859$var$abstract();
    }
    add() {
        return $bc0dba28211d8859$var$abstract();
    }
    diff() {
        return $bc0dba28211d8859$var$abstract();
    }
    startOf() {
        return $bc0dba28211d8859$var$abstract();
    }
    endOf() {
        return $bc0dba28211d8859$var$abstract();
    }
}
var $bc0dba28211d8859$export$f32766ea09ec8bc4 = {
    _date: $bc0dba28211d8859$var$DateAdapterBase
};
function $bc0dba28211d8859$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $2fb01f2a1812f701$export$ebd11618f299a286) : (0, $2fb01f2a1812f701$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $bc0dba28211d8859$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $bc0dba28211d8859$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $bc0dba28211d8859$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $bc0dba28211d8859$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $2fb01f2a1812f701$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $bc0dba28211d8859$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $bc0dba28211d8859$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $2fb01f2a1812f701$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $2fb01f2a1812f701$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $bc0dba28211d8859$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $bc0dba28211d8859$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $bc0dba28211d8859$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $bc0dba28211d8859$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $bc0dba28211d8859$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $bc0dba28211d8859$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $bc0dba28211d8859$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $bc0dba28211d8859$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $bc0dba28211d8859$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $bc0dba28211d8859$export$a13296960cae0384 = {
    evaluateInteractionItems: $bc0dba28211d8859$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $bc0dba28211d8859$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $bc0dba28211d8859$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $bc0dba28211d8859$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $bc0dba28211d8859$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $bc0dba28211d8859$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $bc0dba28211d8859$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(e, chart);
            return $bc0dba28211d8859$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(e, chart);
            return $bc0dba28211d8859$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $bc0dba28211d8859$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $bc0dba28211d8859$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $bc0dba28211d8859$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$bc0dba28211d8859$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $bc0dba28211d8859$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $bc0dba28211d8859$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $bc0dba28211d8859$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$bc0dba28211d8859$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $bc0dba28211d8859$var$setLayoutDims(layouts, params) {
    const stacks = $bc0dba28211d8859$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $bc0dba28211d8859$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $bc0dba28211d8859$var$wrapBoxes(boxes);
    const fullSize = $bc0dba28211d8859$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $bc0dba28211d8859$var$sortByWeight($bc0dba28211d8859$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $bc0dba28211d8859$var$sortByWeight($bc0dba28211d8859$var$filterByPosition(layoutBoxes, 'right'));
    const top = $bc0dba28211d8859$var$sortByWeight($bc0dba28211d8859$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $bc0dba28211d8859$var$sortByWeight($bc0dba28211d8859$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $bc0dba28211d8859$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $bc0dba28211d8859$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $bc0dba28211d8859$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $bc0dba28211d8859$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $bc0dba28211d8859$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $bc0dba28211d8859$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $bc0dba28211d8859$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $bc0dba28211d8859$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $bc0dba28211d8859$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $bc0dba28211d8859$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $bc0dba28211d8859$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $bc0dba28211d8859$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $bc0dba28211d8859$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $bc0dba28211d8859$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $bc0dba28211d8859$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $bc0dba28211d8859$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $bc0dba28211d8859$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $2fb01f2a1812f701$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $bc0dba28211d8859$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $bc0dba28211d8859$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $2fb01f2a1812f701$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $bc0dba28211d8859$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $bc0dba28211d8859$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $bc0dba28211d8859$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $bc0dba28211d8859$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $2fb01f2a1812f701$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $bc0dba28211d8859$var$updateMaxPadding(maxPadding, (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $bc0dba28211d8859$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $bc0dba28211d8859$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $bc0dba28211d8859$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($bc0dba28211d8859$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $bc0dba28211d8859$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $bc0dba28211d8859$var$handleMaxPadding(chartArea);
        $bc0dba28211d8859$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $bc0dba28211d8859$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $2fb01f2a1812f701$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $bc0dba28211d8859$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $bc0dba28211d8859$export$a40a96b24b46cf35 extends $bc0dba28211d8859$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $bc0dba28211d8859$var$EXPANDO_KEY = '$chartjs';
const $bc0dba28211d8859$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $bc0dba28211d8859$var$isNullOrEmpty = (value)=>value === null || value === '';
function $bc0dba28211d8859$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$bc0dba28211d8859$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($bc0dba28211d8859$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $2fb01f2a1812f701$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($bc0dba28211d8859$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $2fb01f2a1812f701$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $bc0dba28211d8859$var$eventListenerOptions = (0, $2fb01f2a1812f701$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $bc0dba28211d8859$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $bc0dba28211d8859$var$eventListenerOptions);
}
function $bc0dba28211d8859$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $bc0dba28211d8859$var$eventListenerOptions);
}
function $bc0dba28211d8859$var$fromNativeEvent(event, chart) {
    const type = $bc0dba28211d8859$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $2fb01f2a1812f701$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $bc0dba28211d8859$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $bc0dba28211d8859$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $bc0dba28211d8859$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$bc0dba28211d8859$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $bc0dba28211d8859$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $bc0dba28211d8859$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$bc0dba28211d8859$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $bc0dba28211d8859$var$drpListeningCharts = new Map();
let $bc0dba28211d8859$var$oldDevicePixelRatio = 0;
function $bc0dba28211d8859$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $bc0dba28211d8859$var$oldDevicePixelRatio) return;
    $bc0dba28211d8859$var$oldDevicePixelRatio = dpr;
    $bc0dba28211d8859$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $bc0dba28211d8859$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$bc0dba28211d8859$var$drpListeningCharts.size) window.addEventListener('resize', $bc0dba28211d8859$var$onWindowResize);
    $bc0dba28211d8859$var$drpListeningCharts.set(chart, resize);
}
function $bc0dba28211d8859$var$unlistenDevicePixelRatioChanges(chart) {
    $bc0dba28211d8859$var$drpListeningCharts.delete(chart);
    if (!$bc0dba28211d8859$var$drpListeningCharts.size) window.removeEventListener('resize', $bc0dba28211d8859$var$onWindowResize);
}
function $bc0dba28211d8859$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $2fb01f2a1812f701$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $2fb01f2a1812f701$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $bc0dba28211d8859$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $bc0dba28211d8859$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $bc0dba28211d8859$var$unlistenDevicePixelRatioChanges(chart);
}
function $bc0dba28211d8859$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $2fb01f2a1812f701$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($bc0dba28211d8859$var$fromNativeEvent(event, chart));
    }, chart);
    $bc0dba28211d8859$var$addListener(canvas, type, proxy);
    return proxy;
}
class $bc0dba28211d8859$export$f02da7f882cf6b2e extends $bc0dba28211d8859$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $bc0dba28211d8859$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$bc0dba28211d8859$var$EXPANDO_KEY]) return false;
        const initial = canvas[$bc0dba28211d8859$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$bc0dba28211d8859$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $bc0dba28211d8859$var$createAttachObserver,
            detach: $bc0dba28211d8859$var$createDetachObserver,
            resize: $bc0dba28211d8859$var$createResizeObserver
        };
        const handler = handlers[type] || $bc0dba28211d8859$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $bc0dba28211d8859$var$releaseObserver,
            detach: $bc0dba28211d8859$var$releaseObserver,
            resize: $bc0dba28211d8859$var$releaseObserver
        };
        const handler = handlers[type] || $bc0dba28211d8859$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $2fb01f2a1812f701$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $2fb01f2a1812f701$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $bc0dba28211d8859$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $2fb01f2a1812f701$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $bc0dba28211d8859$export$a40a96b24b46cf35;
    return $bc0dba28211d8859$export$f02da7f882cf6b2e;
}
class $bc0dba28211d8859$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $2fb01f2a1812f701$export$d141bba7fdc215a3)(this.x) && (0, $2fb01f2a1812f701$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $bc0dba28211d8859$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $bc0dba28211d8859$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $bc0dba28211d8859$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $bc0dba28211d8859$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $bc0dba28211d8859$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $bc0dba28211d8859$var$skip(ticks, newTicks, spacing, (0, $2fb01f2a1812f701$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$bc0dba28211d8859$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $bc0dba28211d8859$var$skip(ticks, newTicks, spacing, last, (0, $2fb01f2a1812f701$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $bc0dba28211d8859$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $bc0dba28211d8859$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $bc0dba28211d8859$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $bc0dba28211d8859$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $2fb01f2a1812f701$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $bc0dba28211d8859$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $bc0dba28211d8859$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $bc0dba28211d8859$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $2fb01f2a1812f701$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $bc0dba28211d8859$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $bc0dba28211d8859$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $bc0dba28211d8859$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $bc0dba28211d8859$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $bc0dba28211d8859$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $bc0dba28211d8859$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $bc0dba28211d8859$var$garbageCollect(caches, length) {
    (0, $2fb01f2a1812f701$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $bc0dba28211d8859$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $bc0dba28211d8859$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $bc0dba28211d8859$var$createScaleContext(parent, scale) {
    return (0, $2fb01f2a1812f701$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $bc0dba28211d8859$var$createTickContext(parent, index, tick) {
    return (0, $2fb01f2a1812f701$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $bc0dba28211d8859$var$titleAlign(align, position, reverse) {
    let ret = (0, $2fb01f2a1812f701$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $bc0dba28211d8859$var$reverseAlign(ret);
    return ret;
}
function $bc0dba28211d8859$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $bc0dba28211d8859$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $bc0dba28211d8859$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd) : (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $bc0dba28211d8859$export$d60cfc58d3c358b6 extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(min, (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(max, min)),
            max: (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(max, (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $2fb01f2a1812f701$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $bc0dba28211d8859$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $bc0dba28211d8859$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $bc0dba28211d8859$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $bc0dba28211d8859$var$getTickMarkLength(options.grid) - tickOpts.padding - $bc0dba28211d8859$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $2fb01f2a1812f701$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $2fb01f2a1812f701$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $2fb01f2a1812f701$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $2fb01f2a1812f701$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $bc0dba28211d8859$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $bc0dba28211d8859$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $bc0dba28211d8859$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $bc0dba28211d8859$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $bc0dba28211d8859$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(label) && !(0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(label)) {
                width = (0, $2fb01f2a1812f701$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(nestedLabel) && !(0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $2fb01f2a1812f701$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $bc0dba28211d8859$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $2fb01f2a1812f701$export$71cec2538cb2c617)(this._alignToPixels ? (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $bc0dba28211d8859$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $bc0dba28211d8859$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $bc0dba28211d8859$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $bc0dba28211d8859$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $bc0dba28211d8859$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $2fb01f2a1812f701$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $2fb01f2a1812f701$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $2fb01f2a1812f701$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $2fb01f2a1812f701$export$34aec0b863436764)(title.font);
        const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $bc0dba28211d8859$var$titleArgs(this, offset, position, align);
        (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $bc0dba28211d8859$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $bc0dba28211d8859$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $2fb01f2a1812f701$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $bc0dba28211d8859$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($bc0dba28211d8859$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $bc0dba28211d8859$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $2fb01f2a1812f701$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $2fb01f2a1812f701$export$4368d992c4eafac0)[scope]) {
            delete (0, $2fb01f2a1812f701$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $2fb01f2a1812f701$export$6559d589eb85fbb6)[id];
        }
    }
}
function $bc0dba28211d8859$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $2fb01f2a1812f701$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $2fb01f2a1812f701$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $2fb01f2a1812f701$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $2fb01f2a1812f701$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $bc0dba28211d8859$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $2fb01f2a1812f701$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $bc0dba28211d8859$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $2fb01f2a1812f701$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $bc0dba28211d8859$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $bc0dba28211d8859$var$Registry {
    constructor(){
        this.controllers = new $bc0dba28211d8859$var$TypedRegistry($bc0dba28211d8859$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $bc0dba28211d8859$var$TypedRegistry($bc0dba28211d8859$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $bc0dba28211d8859$var$TypedRegistry(Object, 'plugins');
        this.scales = new $bc0dba28211d8859$var$TypedRegistry($bc0dba28211d8859$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $2fb01f2a1812f701$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $2fb01f2a1812f701$export$a8550f7dbe79f93a)(method);
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $bc0dba28211d8859$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $bc0dba28211d8859$var$Registry();
class $bc0dba28211d8859$var$PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $bc0dba28211d8859$var$allPlugins(config);
        return options === false && !all ? [] : $bc0dba28211d8859$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $bc0dba28211d8859$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($bc0dba28211d8859$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($bc0dba28211d8859$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $bc0dba28211d8859$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $bc0dba28211d8859$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $bc0dba28211d8859$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $bc0dba28211d8859$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $bc0dba28211d8859$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $bc0dba28211d8859$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $2fb01f2a1812f701$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $bc0dba28211d8859$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $bc0dba28211d8859$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $bc0dba28211d8859$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $bc0dba28211d8859$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $bc0dba28211d8859$var$determineAxis(id, ...scaleOptions) {
    if ($bc0dba28211d8859$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $bc0dba28211d8859$var$axisFromPosition(opts.position) || id.length > 1 && $bc0dba28211d8859$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $bc0dba28211d8859$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $bc0dba28211d8859$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $bc0dba28211d8859$var$getAxisFromDataset(id, 'x', boundDs[0]) || $bc0dba28211d8859$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $bc0dba28211d8859$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $2fb01f2a1812f701$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $bc0dba28211d8859$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $bc0dba28211d8859$var$determineAxis(id, scaleConf, $bc0dba28211d8859$var$retrieveAxisFromDatasets(id, config), (0, $2fb01f2a1812f701$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $bc0dba28211d8859$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $2fb01f2a1812f701$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $bc0dba28211d8859$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $2fb01f2a1812f701$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $bc0dba28211d8859$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $2fb01f2a1812f701$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $2fb01f2a1812f701$export$555508cbc6add439)(scale, [
            (0, $2fb01f2a1812f701$export$4368d992c4eafac0).scales[scale.type],
            (0, $2fb01f2a1812f701$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $bc0dba28211d8859$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $bc0dba28211d8859$var$mergeScaleConfig(config, options);
}
function $bc0dba28211d8859$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $bc0dba28211d8859$var$initConfig(config) {
    config = config || {};
    config.data = $bc0dba28211d8859$var$initData(config.data);
    $bc0dba28211d8859$var$initOptions(config);
    return config;
}
const $bc0dba28211d8859$var$keyCache = new Map();
const $bc0dba28211d8859$var$keysCached = new Set();
function $bc0dba28211d8859$var$cachedKeys(cacheKey, generate) {
    let keys = $bc0dba28211d8859$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $bc0dba28211d8859$var$keyCache.set(cacheKey, keys);
        $bc0dba28211d8859$var$keysCached.add(keys);
    }
    return keys;
}
const $bc0dba28211d8859$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $2fb01f2a1812f701$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $bc0dba28211d8859$var$Config {
    constructor(config){
        this._config = $bc0dba28211d8859$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $bc0dba28211d8859$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $bc0dba28211d8859$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $bc0dba28211d8859$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $bc0dba28211d8859$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $bc0dba28211d8859$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $bc0dba28211d8859$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$bc0dba28211d8859$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$bc0dba28211d8859$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$bc0dba28211d8859$var$addIfFound(scopes, (0, $2fb01f2a1812f701$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$bc0dba28211d8859$var$addIfFound(scopes, (0, $2fb01f2a1812f701$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$bc0dba28211d8859$var$addIfFound(scopes, (0, $2fb01f2a1812f701$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($bc0dba28211d8859$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $2fb01f2a1812f701$export$6559d589eb85fbb6)[type] || {},
            (0, $2fb01f2a1812f701$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $2fb01f2a1812f701$export$4368d992c4eafac0),
            (0, $2fb01f2a1812f701$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $bc0dba28211d8859$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($bc0dba28211d8859$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $2fb01f2a1812f701$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $2fb01f2a1812f701$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $bc0dba28211d8859$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(context) ? (0, $2fb01f2a1812f701$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $bc0dba28211d8859$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $2fb01f2a1812f701$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $bc0dba28211d8859$var$hasFunction = (value)=>(0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $2fb01f2a1812f701$export$a93c5207d687da10)(value[key]));
function $bc0dba28211d8859$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $2fb01f2a1812f701$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $2fb01f2a1812f701$export$a93c5207d687da10)(value) || $bc0dba28211d8859$var$hasFunction(value)) || indexable && (0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $bc0dba28211d8859$var$version = "4.5.1";
const $bc0dba28211d8859$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $bc0dba28211d8859$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $bc0dba28211d8859$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $bc0dba28211d8859$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $bc0dba28211d8859$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $bc0dba28211d8859$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $bc0dba28211d8859$var$getCanvas(item) {
    if ((0, $2fb01f2a1812f701$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $bc0dba28211d8859$var$instances = {};
const $bc0dba28211d8859$var$getChart = (key)=>{
    const canvas = $bc0dba28211d8859$var$getCanvas(key);
    return Object.values($bc0dba28211d8859$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $bc0dba28211d8859$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $bc0dba28211d8859$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $bc0dba28211d8859$export$acaa6426d77a227e {
    static defaults = (0, $2fb01f2a1812f701$export$4368d992c4eafac0);
    static instances = $bc0dba28211d8859$var$instances;
    static overrides = (0, $2fb01f2a1812f701$export$6559d589eb85fbb6);
    static registry = $bc0dba28211d8859$export$4bb7493d241fd8a5;
    static version = $bc0dba28211d8859$var$version;
    static getChart = $bc0dba28211d8859$var$getChart;
    static register(...items) {
        $bc0dba28211d8859$export$4bb7493d241fd8a5.add(...items);
        $bc0dba28211d8859$var$invalidatePlugins();
    }
    static unregister(...items) {
        $bc0dba28211d8859$export$4bb7493d241fd8a5.remove(...items);
        $bc0dba28211d8859$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $bc0dba28211d8859$var$Config(userConfig);
        const initialCanvas = $bc0dba28211d8859$var$getCanvas(item);
        const existingChart = $bc0dba28211d8859$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $bc0dba28211d8859$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $2fb01f2a1812f701$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $bc0dba28211d8859$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $2fb01f2a1812f701$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $bc0dba28211d8859$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $bc0dba28211d8859$export$a424a0aa8f687495.listen(this, 'complete', $bc0dba28211d8859$var$onAnimationsComplete);
        $bc0dba28211d8859$export$a424a0aa8f687495.listen(this, 'progress', $bc0dba28211d8859$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $bc0dba28211d8859$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $2fb01f2a1812f701$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $2fb01f2a1812f701$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $bc0dba28211d8859$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$bc0dba28211d8859$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $2fb01f2a1812f701$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $2fb01f2a1812f701$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $bc0dba28211d8859$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $2fb01f2a1812f701$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $bc0dba28211d8859$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $bc0dba28211d8859$var$positionIsHorizontal(scaleOptions.position, axis) !== $bc0dba28211d8859$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $bc0dba28211d8859$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $2fb01f2a1812f701$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $2fb01f2a1812f701$export$d66501df72047452)(scales, (scale)=>{
            $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $bc0dba28211d8859$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($bc0dba28211d8859$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $bc0dba28211d8859$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $bc0dba28211d8859$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $2fb01f2a1812f701$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $bc0dba28211d8859$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $bc0dba28211d8859$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $2fb01f2a1812f701$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($bc0dba28211d8859$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this.scales, (scale)=>{
            $bc0dba28211d8859$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $2fb01f2a1812f701$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $bc0dba28211d8859$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $2fb01f2a1812f701$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $bc0dba28211d8859$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $2fb01f2a1812f701$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($bc0dba28211d8859$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$bc0dba28211d8859$export$a424a0aa8f687495.running(this)) $bc0dba28211d8859$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $bc0dba28211d8859$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $2fb01f2a1812f701$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $2fb01f2a1812f701$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $2fb01f2a1812f701$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $2fb01f2a1812f701$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $bc0dba28211d8859$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $2fb01f2a1812f701$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $2fb01f2a1812f701$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $bc0dba28211d8859$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $2fb01f2a1812f701$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $bc0dba28211d8859$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $2fb01f2a1812f701$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $2fb01f2a1812f701$export$3b513254972cfc9c)(e);
        const lastEvent = $bc0dba28211d8859$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $2fb01f2a1812f701$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $bc0dba28211d8859$var$invalidatePlugins() {
    return (0, $2fb01f2a1812f701$export$d66501df72047452)($bc0dba28211d8859$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $bc0dba28211d8859$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / 2, startAngle + (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $bc0dba28211d8859$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd), startAngle - (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $bc0dba28211d8859$var$toRadiusCorners(value) {
    return (0, $2fb01f2a1812f701$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $bc0dba28211d8859$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $bc0dba28211d8859$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $bc0dba28211d8859$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $bc0dba28211d8859$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $2fb01f2a1812f701$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $bc0dba28211d8859$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $bc0dba28211d8859$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $bc0dba28211d8859$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $bc0dba28211d8859$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $bc0dba28211d8859$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $bc0dba28211d8859$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $bc0dba28211d8859$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $bc0dba28211d8859$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $bc0dba28211d8859$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $2fb01f2a1812f701$export$971d5caa766a69d7) || (0, $2fb01f2a1812f701$export$971d5caa766a69d7));
    }
    $bc0dba28211d8859$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $bc0dba28211d8859$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $bc0dba28211d8859$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $2fb01f2a1812f701$export$971d5caa766a69d7) || (0, $2fb01f2a1812f701$export$971d5caa766a69d7));
    }
    if (inner) $bc0dba28211d8859$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $bc0dba28211d8859$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $bc0dba28211d8859$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $bc0dba28211d8859$export$d48203c759d6a1fc extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $2fb01f2a1812f701$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $2fb01f2a1812f701$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $2fb01f2a1812f701$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $2fb01f2a1812f701$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $2fb01f2a1812f701$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $2fb01f2a1812f701$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $2fb01f2a1812f701$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $bc0dba28211d8859$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $bc0dba28211d8859$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $bc0dba28211d8859$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $2fb01f2a1812f701$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $bc0dba28211d8859$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $bc0dba28211d8859$var$getLineMethod(options) {
    if (options.stepped) return 0, $2fb01f2a1812f701$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $2fb01f2a1812f701$export$1fbe638ecf81657e;
    return $bc0dba28211d8859$var$lineTo;
}
function $bc0dba28211d8859$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $bc0dba28211d8859$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $bc0dba28211d8859$var$pathVars(points, segment, params);
    const lineMethod = $bc0dba28211d8859$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $bc0dba28211d8859$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $bc0dba28211d8859$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $bc0dba28211d8859$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $bc0dba28211d8859$var$fastPathSegment : $bc0dba28211d8859$var$pathSegment;
}
function $bc0dba28211d8859$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $2fb01f2a1812f701$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $2fb01f2a1812f701$export$d24c54395ce0c509;
    return 0, $2fb01f2a1812f701$export$6554612db691658e;
}
function $bc0dba28211d8859$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $bc0dba28211d8859$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $bc0dba28211d8859$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $bc0dba28211d8859$var$_getSegmentMethod(line);
    for (const segment of segments){
        $bc0dba28211d8859$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $bc0dba28211d8859$var$usePath2D = typeof Path2D === 'function';
function $bc0dba28211d8859$var$draw(ctx, line, start, count) {
    if ($bc0dba28211d8859$var$usePath2D && !line.options.segment) $bc0dba28211d8859$var$strokePathWithCache(ctx, line, start, count);
    else $bc0dba28211d8859$var$strokePathDirect(ctx, line, start, count);
}
class $bc0dba28211d8859$export$55e463fa7bcd3469 extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $2fb01f2a1812f701$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $2fb01f2a1812f701$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $2fb01f2a1812f701$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $bc0dba28211d8859$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $bc0dba28211d8859$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $bc0dba28211d8859$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $bc0dba28211d8859$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $bc0dba28211d8859$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $bc0dba28211d8859$export$bd159b522b230b7a extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $bc0dba28211d8859$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $bc0dba28211d8859$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $2fb01f2a1812f701$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $2fb01f2a1812f701$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $bc0dba28211d8859$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $bc0dba28211d8859$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(value, min, max);
}
function $bc0dba28211d8859$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $2fb01f2a1812f701$export$9fa96a7d116ea3ce)(value);
    return {
        t: $bc0dba28211d8859$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $bc0dba28211d8859$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $bc0dba28211d8859$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $bc0dba28211d8859$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $bc0dba28211d8859$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $bc0dba28211d8859$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $bc0dba28211d8859$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $bc0dba28211d8859$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $bc0dba28211d8859$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $bc0dba28211d8859$var$boundingRects(bar) {
    const bounds = $bc0dba28211d8859$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $bc0dba28211d8859$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $bc0dba28211d8859$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $bc0dba28211d8859$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $bc0dba28211d8859$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $2fb01f2a1812f701$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $2fb01f2a1812f701$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $bc0dba28211d8859$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $bc0dba28211d8859$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $bc0dba28211d8859$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $bc0dba28211d8859$export$a16ed71bf4b07672 extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $bc0dba28211d8859$var$boundingRects(this);
        const addRectPath = $bc0dba28211d8859$var$hasRadius(outer.radius) ? (0, $2fb01f2a1812f701$export$92108d983e8ee699) : $bc0dba28211d8859$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $bc0dba28211d8859$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $bc0dba28211d8859$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $bc0dba28211d8859$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $bc0dba28211d8859$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $bc0dba28211d8859$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $bc0dba28211d8859$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $bc0dba28211d8859$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $bc0dba28211d8859$export$d48203c759d6a1fc,
    BarElement: $bc0dba28211d8859$export$a16ed71bf4b07672,
    LineElement: $bc0dba28211d8859$export$55e463fa7bcd3469,
    PointElement: $bc0dba28211d8859$export$bd159b522b230b7a
});
const $bc0dba28211d8859$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $bc0dba28211d8859$var$BACKGROUND_COLORS = /* #__PURE__ */ $bc0dba28211d8859$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $bc0dba28211d8859$var$getBorderColor(i) {
    return $bc0dba28211d8859$var$BORDER_COLORS[i % $bc0dba28211d8859$var$BORDER_COLORS.length];
}
function $bc0dba28211d8859$var$getBackgroundColor(i) {
    return $bc0dba28211d8859$var$BACKGROUND_COLORS[i % $bc0dba28211d8859$var$BACKGROUND_COLORS.length];
}
function $bc0dba28211d8859$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $bc0dba28211d8859$var$getBorderColor(i);
    dataset.backgroundColor = $bc0dba28211d8859$var$getBackgroundColor(i);
    return ++i;
}
function $bc0dba28211d8859$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$bc0dba28211d8859$var$getBorderColor(i++));
    return i;
}
function $bc0dba28211d8859$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$bc0dba28211d8859$var$getBackgroundColor(i++));
    return i;
}
function $bc0dba28211d8859$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $bc0dba28211d8859$export$e04603e7d8b77172) i = $bc0dba28211d8859$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $bc0dba28211d8859$export$2a270b3a0d973c85) i = $bc0dba28211d8859$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $bc0dba28211d8859$var$colorizeDefaultDataset(dataset, i);
    };
}
function $bc0dba28211d8859$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $bc0dba28211d8859$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $bc0dba28211d8859$var$containsDefaultColorsDefenitions() {
    return (0, $2fb01f2a1812f701$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $2fb01f2a1812f701$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $bc0dba28211d8859$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $bc0dba28211d8859$var$containsColorsDefinitions(datasets) || $bc0dba28211d8859$var$containsColorsDefinition(chartOptions) || elements && $bc0dba28211d8859$var$containsColorsDefinitions(elements) || $bc0dba28211d8859$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $bc0dba28211d8859$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $bc0dba28211d8859$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $bc0dba28211d8859$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(minIndex) && !(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $bc0dba28211d8859$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $bc0dba28211d8859$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $bc0dba28211d8859$var$cleanDecimatedDataset(dataset);
    });
}
function $bc0dba28211d8859$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $2fb01f2a1812f701$export$25ce5a424b770e84)((0, $2fb01f2a1812f701$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $2fb01f2a1812f701$export$25ce5a424b770e84)((0, $2fb01f2a1812f701$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $bc0dba28211d8859$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $bc0dba28211d8859$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $2fb01f2a1812f701$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $bc0dba28211d8859$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $bc0dba28211d8859$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $bc0dba28211d8859$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $bc0dba28211d8859$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $bc0dba28211d8859$var$cleanDecimatedData(chart);
    }
};
function $bc0dba28211d8859$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $bc0dba28211d8859$var$_findSegmentEnd(start, end, points);
        const bounds = $bc0dba28211d8859$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $2fb01f2a1812f701$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $bc0dba28211d8859$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $2fb01f2a1812f701$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $bc0dba28211d8859$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $bc0dba28211d8859$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $bc0dba28211d8859$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(start);
        end = (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $bc0dba28211d8859$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $bc0dba28211d8859$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $bc0dba28211d8859$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $bc0dba28211d8859$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $bc0dba28211d8859$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $bc0dba28211d8859$var$_pointsFromSegments(boundary, line);
    return points.length ? new $bc0dba28211d8859$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $bc0dba28211d8859$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $bc0dba28211d8859$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $2fb01f2a1812f701$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $bc0dba28211d8859$var$_decodeFill(line, index, count) {
    const fill = $bc0dba28211d8859$var$parseFillOption(line);
    if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $2fb01f2a1812f701$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $bc0dba28211d8859$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $bc0dba28211d8859$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $bc0dba28211d8859$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $bc0dba28211d8859$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $bc0dba28211d8859$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $bc0dba28211d8859$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $bc0dba28211d8859$var$getLinesBelow(scale, index);
    linesBelow.push($bc0dba28211d8859$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$bc0dba28211d8859$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $bc0dba28211d8859$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $bc0dba28211d8859$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $bc0dba28211d8859$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $bc0dba28211d8859$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $bc0dba28211d8859$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $2fb01f2a1812f701$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $bc0dba28211d8859$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $2fb01f2a1812f701$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $bc0dba28211d8859$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $2fb01f2a1812f701$export$39b482c5e57630a8)(fill)) return $bc0dba28211d8859$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $bc0dba28211d8859$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $bc0dba28211d8859$var$computeBoundary(source);
    if (boundary instanceof $bc0dba28211d8859$var$simpleArc) return boundary;
    return $bc0dba28211d8859$var$_createBoundaryLine(boundary, line);
}
function $bc0dba28211d8859$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $bc0dba28211d8859$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $bc0dba28211d8859$var$computeCircularBoundary(source);
    return $bc0dba28211d8859$var$computeLinearBoundary(source);
}
function $bc0dba28211d8859$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $bc0dba28211d8859$var$_getTargetPixel(fill, scale);
    if ((0, $2fb01f2a1812f701$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $bc0dba28211d8859$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $bc0dba28211d8859$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $bc0dba28211d8859$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $bc0dba28211d8859$var$_drawfill(ctx, source, area) {
    const target = $bc0dba28211d8859$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $2fb01f2a1812f701$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $2fb01f2a1812f701$export$8743009a87fcb00f)(ctx, area);
        $bc0dba28211d8859$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $2fb01f2a1812f701$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $bc0dba28211d8859$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $bc0dba28211d8859$var$clipVertical(ctx, target, area.top);
            $bc0dba28211d8859$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $bc0dba28211d8859$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $bc0dba28211d8859$var$clipHorizontal(ctx, target, area.left);
            $bc0dba28211d8859$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $bc0dba28211d8859$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $bc0dba28211d8859$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $bc0dba28211d8859$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$bc0dba28211d8859$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $bc0dba28211d8859$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$bc0dba28211d8859$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $bc0dba28211d8859$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $bc0dba28211d8859$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $bc0dba28211d8859$var$clipBounds(ctx, scale, clip, notShape && $bc0dba28211d8859$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $bc0dba28211d8859$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $bc0dba28211d8859$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $bc0dba28211d8859$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $bc0dba28211d8859$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $bc0dba28211d8859$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $bc0dba28211d8859$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $bc0dba28211d8859$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $bc0dba28211d8859$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $bc0dba28211d8859$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($bc0dba28211d8859$var$_shouldApplyFill(source)) $bc0dba28211d8859$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$bc0dba28211d8859$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $bc0dba28211d8859$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $bc0dba28211d8859$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $bc0dba28211d8859$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $bc0dba28211d8859$var$Legend extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $bc0dba28211d8859$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $bc0dba28211d8859$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $2fb01f2a1812f701$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $2fb01f2a1812f701$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $2fb01f2a1812f701$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $2fb01f2a1812f701$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $2fb01f2a1812f701$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $bc0dba28211d8859$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $2fb01f2a1812f701$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $2fb01f2a1812f701$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $2fb01f2a1812f701$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $2fb01f2a1812f701$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $2fb01f2a1812f701$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $bc0dba28211d8859$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $2fb01f2a1812f701$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $2fb01f2a1812f701$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $2fb01f2a1812f701$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $2fb01f2a1812f701$export$21579262ef46735b)(x, this.left, this.right) && (0, $2fb01f2a1812f701$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $2fb01f2a1812f701$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $2fb01f2a1812f701$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$bc0dba28211d8859$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $bc0dba28211d8859$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $bc0dba28211d8859$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $bc0dba28211d8859$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $bc0dba28211d8859$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $bc0dba28211d8859$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $bc0dba28211d8859$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $bc0dba28211d8859$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $bc0dba28211d8859$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $bc0dba28211d8859$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $bc0dba28211d8859$export$ed247974535929c7 = {
    id: 'legend',
    _element: $bc0dba28211d8859$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $bc0dba28211d8859$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $bc0dba28211d8859$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $bc0dba28211d8859$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $bc0dba28211d8859$var$Title extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $2fb01f2a1812f701$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $2fb01f2a1812f701$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $2fb01f2a1812f701$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $2fb01f2a1812f701$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $bc0dba28211d8859$var$createTitle(chart, titleOpts) {
    const title = new $bc0dba28211d8859$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $bc0dba28211d8859$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $bc0dba28211d8859$export$f99233281efd08a0 = {
    id: 'title',
    _element: $bc0dba28211d8859$var$Title,
    start (chart, _args, options) {
        $bc0dba28211d8859$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $bc0dba28211d8859$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $bc0dba28211d8859$var$map = new WeakMap();
var $bc0dba28211d8859$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $bc0dba28211d8859$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(chart, title, options);
        $bc0dba28211d8859$export$1ecca0613f5e56d2.addBox(chart, title);
        $bc0dba28211d8859$var$map.set(chart, title);
    },
    stop (chart) {
        $bc0dba28211d8859$export$1ecca0613f5e56d2.removeBox(chart, $bc0dba28211d8859$var$map.get(chart));
        $bc0dba28211d8859$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $bc0dba28211d8859$var$map.get(chart);
        $bc0dba28211d8859$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $bc0dba28211d8859$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $2fb01f2a1812f701$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $bc0dba28211d8859$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $bc0dba28211d8859$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $bc0dba28211d8859$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $bc0dba28211d8859$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $2fb01f2a1812f701$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $2fb01f2a1812f701$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $2fb01f2a1812f701$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $2fb01f2a1812f701$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $2fb01f2a1812f701$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $2fb01f2a1812f701$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $2fb01f2a1812f701$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $bc0dba28211d8859$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $bc0dba28211d8859$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $bc0dba28211d8859$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($bc0dba28211d8859$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $bc0dba28211d8859$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $bc0dba28211d8859$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $bc0dba28211d8859$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $bc0dba28211d8859$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $bc0dba28211d8859$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $bc0dba28211d8859$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(cornerRadius);
    let x = $bc0dba28211d8859$var$alignX(size, xAlign);
    const y = $bc0dba28211d8859$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $bc0dba28211d8859$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $bc0dba28211d8859$var$getBeforeAfterBodyLines(callback) {
    return $bc0dba28211d8859$var$pushOrConcat([], $bc0dba28211d8859$var$splitNewlines(callback));
}
function $bc0dba28211d8859$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $2fb01f2a1812f701$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $bc0dba28211d8859$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $bc0dba28211d8859$var$defaultCallbacks = {
    beforeTitle: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    beforeBody: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    beforeLabel: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    afterBody: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    beforeFooter: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    footer: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346),
    afterFooter: (0, $2fb01f2a1812f701$export$53a70dd1ebbae346)
};
function $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $bc0dba28211d8859$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $bc0dba28211d8859$var$Tooltip extends $bc0dba28211d8859$export$db77ccec0bb4ccac {
    static positioners = $bc0dba28211d8859$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $bc0dba28211d8859$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $bc0dba28211d8859$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $bc0dba28211d8859$var$pushOrConcat(lines, $bc0dba28211d8859$var$splitNewlines(beforeTitle));
        lines = $bc0dba28211d8859$var$pushOrConcat(lines, $bc0dba28211d8859$var$splitNewlines(title));
        lines = $bc0dba28211d8859$var$pushOrConcat(lines, $bc0dba28211d8859$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $bc0dba28211d8859$var$getBeforeAfterBodyLines($bc0dba28211d8859$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $2fb01f2a1812f701$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $bc0dba28211d8859$var$overrideCallbacks(callbacks, context);
            $bc0dba28211d8859$var$pushOrConcat(bodyItem.before, $bc0dba28211d8859$var$splitNewlines($bc0dba28211d8859$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $bc0dba28211d8859$var$pushOrConcat(bodyItem.lines, $bc0dba28211d8859$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $bc0dba28211d8859$var$pushOrConcat(bodyItem.after, $bc0dba28211d8859$var$splitNewlines($bc0dba28211d8859$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $bc0dba28211d8859$var$getBeforeAfterBodyLines($bc0dba28211d8859$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $bc0dba28211d8859$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $bc0dba28211d8859$var$pushOrConcat(lines, $bc0dba28211d8859$var$splitNewlines(beforeFooter));
        lines = $bc0dba28211d8859$var$pushOrConcat(lines, $bc0dba28211d8859$var$splitNewlines(footer));
        lines = $bc0dba28211d8859$var$pushOrConcat(lines, $bc0dba28211d8859$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($bc0dba28211d8859$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $2fb01f2a1812f701$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $bc0dba28211d8859$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($bc0dba28211d8859$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($bc0dba28211d8859$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($bc0dba28211d8859$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $bc0dba28211d8859$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $bc0dba28211d8859$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $bc0dba28211d8859$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $bc0dba28211d8859$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $2fb01f2a1812f701$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $bc0dba28211d8859$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.bodyFont);
        const colorX = $bc0dba28211d8859$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $2fb01f2a1812f701$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $2fb01f2a1812f701$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $2fb01f2a1812f701$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $2fb01f2a1812f701$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $2fb01f2a1812f701$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $2fb01f2a1812f701$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $bc0dba28211d8859$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $2fb01f2a1812f701$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $2fb01f2a1812f701$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $2fb01f2a1812f701$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $2fb01f2a1812f701$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $bc0dba28211d8859$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $bc0dba28211d8859$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $bc0dba28211d8859$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $bc0dba28211d8859$var$determineAlignment(chart, options, positionAndSize);
            const point = $bc0dba28211d8859$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $2fb01f2a1812f701$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $2fb01f2a1812f701$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $2fb01f2a1812f701$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $2fb01f2a1812f701$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $bc0dba28211d8859$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $bc0dba28211d8859$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $bc0dba28211d8859$var$Tooltip,
    positioners: $bc0dba28211d8859$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $bc0dba28211d8859$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $bc0dba28211d8859$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $bc0dba28211d8859$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $bc0dba28211d8859$export$c537fa0d021d010b,
    Decimation: $bc0dba28211d8859$export$be17f937e9aa7533,
    Filler: $bc0dba28211d8859$export$d19ba4d812bed757,
    Legend: $bc0dba28211d8859$export$ed247974535929c7,
    SubTitle: $bc0dba28211d8859$export$d5c56664638992a4,
    Title: $bc0dba28211d8859$export$f99233281efd08a0,
    Tooltip: $bc0dba28211d8859$export$28c660c63b792dea
});
const $bc0dba28211d8859$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $bc0dba28211d8859$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $bc0dba28211d8859$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $bc0dba28211d8859$var$validIndex = (index, max)=>index === null ? null : (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $bc0dba28211d8859$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $bc0dba28211d8859$export$29e663ba4d09fe7 extends $bc0dba28211d8859$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $bc0dba28211d8859$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $bc0dba28211d8859$var$findOrAddLabel(labels, raw, (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $bc0dba28211d8859$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $bc0dba28211d8859$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $bc0dba28211d8859$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $2fb01f2a1812f701$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $2fb01f2a1812f701$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $2fb01f2a1812f701$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $2fb01f2a1812f701$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $2fb01f2a1812f701$export$91477dc880baac21)(spacing), (0, $2fb01f2a1812f701$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $2fb01f2a1812f701$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $2fb01f2a1812f701$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $bc0dba28211d8859$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $2fb01f2a1812f701$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $bc0dba28211d8859$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $bc0dba28211d8859$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $bc0dba28211d8859$var$LinearScaleBase extends $bc0dba28211d8859$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $2fb01f2a1812f701$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $bc0dba28211d8859$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $2fb01f2a1812f701$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $2fb01f2a1812f701$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $bc0dba28211d8859$export$e7f4e5e8656f0b93 extends $bc0dba28211d8859$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $2fb01f2a1812f701$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $bc0dba28211d8859$var$log10Floor = (v)=>Math.floor((0, $2fb01f2a1812f701$export$faec65b429be379)(v));
const $bc0dba28211d8859$var$changeExponent = (v, m)=>Math.pow(10, $bc0dba28211d8859$var$log10Floor(v) + m);
function $bc0dba28211d8859$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $bc0dba28211d8859$var$log10Floor(tickVal));
    return remain === 1;
}
function $bc0dba28211d8859$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $bc0dba28211d8859$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $bc0dba28211d8859$var$log10Floor(range);
    while($bc0dba28211d8859$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($bc0dba28211d8859$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $bc0dba28211d8859$var$log10Floor(min));
}
function $bc0dba28211d8859$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $bc0dba28211d8859$var$log10Floor(min);
    let exp = $bc0dba28211d8859$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $bc0dba28211d8859$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $2fb01f2a1812f701$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $bc0dba28211d8859$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $bc0dba28211d8859$export$85295eaf7cb3ac3e extends $bc0dba28211d8859$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $2fb01f2a1812f701$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $bc0dba28211d8859$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $2fb01f2a1812f701$export$39b482c5e57630a8)(this._userMin)) this.min = min === $bc0dba28211d8859$var$changeExponent(this.min, 0) ? $bc0dba28211d8859$var$changeExponent(this.min, -1) : $bc0dba28211d8859$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($bc0dba28211d8859$var$changeExponent(min, -1));
                setMax($bc0dba28211d8859$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($bc0dba28211d8859$var$changeExponent(max, -1));
        if (max <= 0) setMax($bc0dba28211d8859$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $bc0dba28211d8859$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $2fb01f2a1812f701$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $2fb01f2a1812f701$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $2fb01f2a1812f701$export$faec65b429be379)(start);
        this._valueRange = (0, $2fb01f2a1812f701$export$faec65b429be379)(this.max) - (0, $2fb01f2a1812f701$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $2fb01f2a1812f701$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $bc0dba28211d8859$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $2fb01f2a1812f701$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $bc0dba28211d8859$var$measureLabelSize(ctx, font, label) {
    label = (0, $2fb01f2a1812f701$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $2fb01f2a1812f701$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $bc0dba28211d8859$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $bc0dba28211d8859$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(opts.font);
        const textSize = $bc0dba28211d8859$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $2fb01f2a1812f701$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $bc0dba28211d8859$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $bc0dba28211d8859$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $bc0dba28211d8859$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $bc0dba28211d8859$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $bc0dba28211d8859$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $bc0dba28211d8859$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $2fb01f2a1812f701$export$3a6d5c9ae78a2c08)((0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd))));
    const y = $bc0dba28211d8859$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $bc0dba28211d8859$var$getTextAlignForAngle(angle);
    const left = $bc0dba28211d8859$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $bc0dba28211d8859$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $2fb01f2a1812f701$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $2fb01f2a1812f701$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $2fb01f2a1812f701$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $2fb01f2a1812f701$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $bc0dba28211d8859$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $bc0dba28211d8859$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $2fb01f2a1812f701$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $bc0dba28211d8859$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $bc0dba28211d8859$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $bc0dba28211d8859$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $bc0dba28211d8859$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $bc0dba28211d8859$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $bc0dba28211d8859$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $2fb01f2a1812f701$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $2fb01f2a1812f701$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $2fb01f2a1812f701$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $bc0dba28211d8859$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $bc0dba28211d8859$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $bc0dba28211d8859$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $2fb01f2a1812f701$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $bc0dba28211d8859$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $bc0dba28211d8859$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $bc0dba28211d8859$var$createPointLabelContext(parent, index, label) {
    return (0, $2fb01f2a1812f701$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $bc0dba28211d8859$export$cfafc36d95386d38 extends $bc0dba28211d8859$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $2fb01f2a1812f701$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)($bc0dba28211d8859$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $bc0dba28211d8859$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $bc0dba28211d8859$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $bc0dba28211d8859$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $2fb01f2a1812f701$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $2fb01f2a1812f701$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $bc0dba28211d8859$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $2fb01f2a1812f701$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $bc0dba28211d8859$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $bc0dba28211d8859$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $bc0dba28211d8859$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $2fb01f2a1812f701$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $2fb01f2a1812f701$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $2fb01f2a1812f701$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $bc0dba28211d8859$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $bc0dba28211d8859$var$UNITS = /* #__PURE__ */ Object.keys($bc0dba28211d8859$var$INTERVALS);
function $bc0dba28211d8859$var$sorter(a, b) {
    return a - b;
}
function $bc0dba28211d8859$var$parse(scale, input) {
    if ((0, $2fb01f2a1812f701$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $2fb01f2a1812f701$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $2fb01f2a1812f701$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $bc0dba28211d8859$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $bc0dba28211d8859$var$UNITS.length;
    for(let i = $bc0dba28211d8859$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $bc0dba28211d8859$var$INTERVALS[$bc0dba28211d8859$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $bc0dba28211d8859$var$UNITS[i];
    }
    return $bc0dba28211d8859$var$UNITS[ilen - 1];
}
function $bc0dba28211d8859$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $bc0dba28211d8859$var$UNITS.length - 1; i >= $bc0dba28211d8859$var$UNITS.indexOf(minUnit); i--){
        const unit = $bc0dba28211d8859$var$UNITS[i];
        if ($bc0dba28211d8859$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $bc0dba28211d8859$var$UNITS[minUnit ? $bc0dba28211d8859$var$UNITS.indexOf(minUnit) : 0];
}
function $bc0dba28211d8859$var$determineMajorUnit(unit) {
    for(let i = $bc0dba28211d8859$var$UNITS.indexOf(unit) + 1, ilen = $bc0dba28211d8859$var$UNITS.length; i < ilen; ++i){
        if ($bc0dba28211d8859$var$INTERVALS[$bc0dba28211d8859$var$UNITS[i]].common) return $bc0dba28211d8859$var$UNITS[i];
    }
}
function $bc0dba28211d8859$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $2fb01f2a1812f701$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $bc0dba28211d8859$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $bc0dba28211d8859$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $bc0dba28211d8859$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $bc0dba28211d8859$export$a894c72689ff3ec extends $bc0dba28211d8859$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $bc0dba28211d8859$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $2fb01f2a1812f701$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $bc0dba28211d8859$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $2fb01f2a1812f701$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $2fb01f2a1812f701$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $bc0dba28211d8859$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $bc0dba28211d8859$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $bc0dba28211d8859$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $bc0dba28211d8859$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $2fb01f2a1812f701$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $bc0dba28211d8859$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $2fb01f2a1812f701$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $2fb01f2a1812f701$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$bc0dba28211d8859$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $bc0dba28211d8859$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($bc0dba28211d8859$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $2fb01f2a1812f701$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $2fb01f2a1812f701$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $bc0dba28211d8859$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($bc0dba28211d8859$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $2fb01f2a1812f701$export$71511d61b312f219)(values.sort($bc0dba28211d8859$var$sorter));
    }
}
function $bc0dba28211d8859$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $2fb01f2a1812f701$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $2fb01f2a1812f701$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $bc0dba28211d8859$export$85df64a8eb6dc986 extends $bc0dba28211d8859$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $bc0dba28211d8859$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $bc0dba28211d8859$var$interpolate(table, this.min);
        this._tableRange = $bc0dba28211d8859$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($bc0dba28211d8859$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $bc0dba28211d8859$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $bc0dba28211d8859$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $bc0dba28211d8859$export$29e663ba4d09fe7,
    LinearScale: $bc0dba28211d8859$export$e7f4e5e8656f0b93,
    LogarithmicScale: $bc0dba28211d8859$export$85295eaf7cb3ac3e,
    RadialLinearScale: $bc0dba28211d8859$export$cfafc36d95386d38,
    TimeScale: $bc0dba28211d8859$export$a894c72689ff3ec,
    TimeSeriesScale: $bc0dba28211d8859$export$85df64a8eb6dc986
});
const $bc0dba28211d8859$export$e8959e79e3af550f = [
    $bc0dba28211d8859$export$a6506504f799c5d5,
    $bc0dba28211d8859$export$7a5d735b2ab6389d,
    $bc0dba28211d8859$export$8b3ca321c77fdea6,
    $bc0dba28211d8859$export$bcac1c16f1530ec2
];


'use strict';
const $f1e5777e1ac4f58e$export$38d2ecc76f0c2959 = {
    f: '#800080',
    m: '#C8C800',
    fx: '#00a050',
    mx: '#00a050',
    x: '#00a050',
    nb: '#00a050',
    u: '#808080',
    p: '#A46440',
    o: '#AAAAAA' // other (not a person or multiple)
};
const $f1e5777e1ac4f58e$export$eae85ad18a22ab6c = {
    f: '#F46D43',
    m: '#FEE296',
    fx: '#74ADD1',
    mx: '#74ADD1',
    x: '#74ADD1',
    nb: '#74ADD1',
    u: '#808080',
    p: '#8073AC',
    o: '#525252' // other (not a person or multiple)
};




'use strict';
let $8b6c78f0b565e44c$export$8fde8ebd684d5072;
const $8b6c78f0b565e44c$var$elementCanvas = document.querySelector('#gender-chart > canvas');
const $8b6c78f0b565e44c$var$elementDiv = $8b6c78f0b565e44c$var$elementCanvas.parentElement;
(0, $bc0dba28211d8859$export$acaa6426d77a227e).register((0, $bc0dba28211d8859$export$d48203c759d6a1fc), (0, $bc0dba28211d8859$export$e04603e7d8b77172));
function $8b6c78f0b565e44c$var$createChart(data) {
    const context = $8b6c78f0b565e44c$var$elementCanvas.getContext('2d');
    const colors = (0, $c329767ff48960ee$export$bca14c5b3b88a9c9) === 'dark' ? (0, $f1e5777e1ac4f58e$export$eae85ad18a22ab6c) : (0, $f1e5777e1ac4f58e$export$38d2ecc76f0c2959);
    if (context !== null) {
        if (typeof $8b6c78f0b565e44c$export$8fde8ebd684d5072 !== 'undefined') $8b6c78f0b565e44c$export$8fde8ebd684d5072.destroy();
        $8b6c78f0b565e44c$export$8fde8ebd684d5072 = new (0, $bc0dba28211d8859$export$acaa6426d77a227e)(context, {
            type: 'doughnut',
            data: {
                labels: [
                    'Male (cis)',
                    'Female (cis)',
                    'Male (trans)',
                    'Female (trans)',
                    'Intersex',
                    'Non-binary',
                    'Unknown'
                ],
                datasets: [
                    {
                        data: data,
                        backgroundColor: [
                            colors.m,
                            colors.f,
                            colors.mx,
                            colors.fx,
                            colors.x,
                            colors.nb,
                            colors.u
                        ]
                    }
                ]
            },
            options: {
                animation: {
                    animateScale: false,
                    animateRotate: false
                },
                circumference: 180,
                plugins: {
                    legend: {
                        display: false
                    }
                },
                responsive: false,
                rotation: -90
            }
        });
        return $8b6c78f0b565e44c$export$8fde8ebd684d5072;
    }
}
function $8b6c78f0b565e44c$var$updateLabels(count) {
    const colors = (0, $c329767ff48960ee$export$bca14c5b3b88a9c9) === 'dark' ? (0, $f1e5777e1ac4f58e$export$eae85ad18a22ab6c) : (0, $f1e5777e1ac4f58e$export$38d2ecc76f0c2959);
    const totalPerson = count.f + count.m + count.fx + count.mx + count.x + count.nb + count.u + count.p;
    Object.keys(count).forEach((gender)=>{
        const labelElement = $8b6c78f0b565e44c$var$elementDiv.querySelector(`.gender-chart-label[data-gender=${gender}]`);
        if (labelElement !== null) {
            labelElement.style.color = colors[gender];
            const countElement = labelElement.querySelector('.gender-chart-count');
            if (countElement !== null) countElement.innerText = `${count[gender]}`;
            const pctElement = labelElement.querySelector('.gender-chart-pct');
            if (pctElement !== null) {
                const percentage = Math.round(count[gender] / totalPerson * 10000) / 100;
                pctElement.innerText = `${percentage} %`;
            }
        }
    });
}
function $8b6c78f0b565e44c$export$2e2bcd8739ae039() {
    const count = {
        f: (0, $5dd0c5bafbf7a4a5$exports.statistics).F,
        m: (0, $5dd0c5bafbf7a4a5$exports.statistics).M,
        fx: (0, $5dd0c5bafbf7a4a5$exports.statistics).FX,
        mx: (0, $5dd0c5bafbf7a4a5$exports.statistics).MX,
        x: (0, $5dd0c5bafbf7a4a5$exports.statistics).X,
        nb: (0, $5dd0c5bafbf7a4a5$exports.statistics).NB,
        u: (0, $5dd0c5bafbf7a4a5$exports.statistics)['?'],
        p: (0, $5dd0c5bafbf7a4a5$exports.statistics)['+'],
        o: (0, $5dd0c5bafbf7a4a5$exports.statistics)['-'] // not a person
    };
    const totalPerson = count.f + count.m + count.fx + count.mx + count.x + count.nb + count.u + count.p;
    const total = totalPerson + count.o;
    $8b6c78f0b565e44c$var$createChart([
        count.m,
        count.f,
        count.mx,
        count.fx,
        count.x,
        count.nb,
        count.u
    ]);
    $8b6c78f0b565e44c$var$updateLabels(count);
    const spanCount = document.getElementById('count-person');
    const spanTotal = document.getElementById('count-total');
    const percentage = Math.round(totalPerson / total * 10000) / 100;
    spanCount.innerText = `${totalPerson} (${percentage}%)`;
    spanTotal.innerText = total;
    const spanLastUpdate = document.getElementById('last-update');
    if (spanLastUpdate !== null) {
        const date = new Date((0, $5dd0c5bafbf7a4a5$exports.lastUpdate));
        const format = new Intl.DateTimeFormat((0, $358c21e678401062$export$9a771d6906431624), {
            dateStyle: 'medium',
            timeStyle: 'short'
        });
        spanLastUpdate.innerText = format.format(date);
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $4703be9d11e2fafd$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
var $4703be9d11e2fafd$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $4703be9d11e2fafd$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $4703be9d11e2fafd$var$immutable;
var $4703be9d11e2fafd$var$hasRequiredImmutable;
function $4703be9d11e2fafd$var$requireImmutable() {
    if ($4703be9d11e2fafd$var$hasRequiredImmutable) return $4703be9d11e2fafd$var$immutable;
    $4703be9d11e2fafd$var$hasRequiredImmutable = 1;
    $4703be9d11e2fafd$var$immutable = extend;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    function extend() {
        var target = {};
        for(var i = 0; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }
    return $4703be9d11e2fafd$var$immutable;
}
var $4703be9d11e2fafd$var$fuzzy = {
    exports: {}
};
/*
 * Fuzzy
 * https://github.com/myork/fuzzy
 *
 * Copyright (c) 2012 Matt York
 * Licensed under the MIT license.
 */ var $4703be9d11e2fafd$var$hasRequiredFuzzy;
function $4703be9d11e2fafd$var$requireFuzzy() {
    if ($4703be9d11e2fafd$var$hasRequiredFuzzy) return $4703be9d11e2fafd$var$fuzzy.exports;
    $4703be9d11e2fafd$var$hasRequiredFuzzy = 1;
    (function(module, exports$1) {
        (function() {
            var fuzzy = {};
            module.exports = fuzzy;
            // Return all elements of `array` that have a fuzzy
            // match against `pattern`.
            fuzzy.simpleFilter = function(pattern, array) {
                return array.filter(function(str) {
                    return fuzzy.test(pattern, str);
                });
            };
            // Does `pattern` fuzzy match `str`?
            fuzzy.test = function(pattern, str) {
                return fuzzy.match(pattern, str) !== null;
            };
            // If `pattern` matches `str`, wrap each matching character
            // in `opts.pre` and `opts.post`. If no match, return null
            fuzzy.match = function(pattern, str, opts) {
                opts = opts || {};
                var patternIdx = 0, result = [], len = str.length, totalScore = 0, currScore = 0, pre = opts.pre || '', post = opts.post || '', compareString = opts.caseSensitive && str || str.toLowerCase(), ch;
                pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
                // For each character in the string, either add it to the result
                // or wrap in template if it's the next string in the pattern
                for(var idx = 0; idx < len; idx++){
                    ch = str[idx];
                    if (compareString[idx] === pattern[patternIdx]) {
                        ch = pre + ch + post;
                        patternIdx += 1;
                        // consecutive characters should increase the score more than linearly
                        currScore += 1 + currScore;
                    } else currScore = 0;
                    totalScore += currScore;
                    result[result.length] = ch;
                }
                // return rendered string if we have a match for every char
                if (patternIdx === pattern.length) {
                    // if the string is an exact match with pattern, totalScore should be maxed
                    totalScore = compareString === pattern ? Infinity : totalScore;
                    return {
                        rendered: result.join(''),
                        score: totalScore
                    };
                }
                return null;
            };
            // The normal entry point. Filters `arr` for matches against `pattern`.
            // It returns an array with matching values of the type:
            //
            //     [{
            //         string:   '<b>lah' // The rendered string
            //       , index:    2        // The index of the element in `arr`
            //       , original: 'blah'   // The original element in `arr`
            //     }]
            //
            // `opts` is an optional argument bag. Details:
            //
            //    opts = {
            //        // string to put before a matching character
            //        pre:     '<b>'
            //
            //        // string to put after matching character
            //      , post:    '</b>'
            //
            //        // Optional function. Input is an entry in the given arr`,
            //        // output should be the string to test `pattern` against.
            //        // In this example, if `arr = [{crying: 'koala'}]` we would return
            //        // 'koala'.
            //      , extract: function(arg) { return arg.crying; }
            //    }
            fuzzy.filter = function(pattern, arr, opts) {
                if (!arr || arr.length === 0) return [];
                if (typeof pattern !== 'string') return arr;
                opts = opts || {};
                return arr.reduce(function(prev, element, idx, arr) {
                    var str = element;
                    if (opts.extract) str = opts.extract(element);
                    var rendered = fuzzy.match(pattern, str, opts);
                    if (rendered != null) prev[prev.length] = {
                        string: rendered.rendered,
                        score: rendered.score,
                        index: idx,
                        original: element
                    };
                    return prev;
                }, [])// Sort by score. Browsers are inconsistent wrt stable/unstable
                // sorting, so force stable by using the index in the case of tie.
                // See http://ofb.net/~sethml/is-sort-stable.html
                .sort(function(a, b) {
                    var compare = b.score - a.score;
                    if (compare) return compare;
                    return a.index - b.index;
                });
            };
        })();
    })($4703be9d11e2fafd$var$fuzzy);
    return $4703be9d11e2fafd$var$fuzzy.exports;
}
var $4703be9d11e2fafd$var$list;
var $4703be9d11e2fafd$var$hasRequiredList;
function $4703be9d11e2fafd$var$requireList() {
    if ($4703be9d11e2fafd$var$hasRequiredList) return $4703be9d11e2fafd$var$list;
    $4703be9d11e2fafd$var$hasRequiredList = 1;
    var List = function(component) {
        this.component = component;
        this.items = [];
        this.active = component.options.noInitialSelection ? -1 : 0;
        this.wrapper = document.createElement('div');
        this.wrapper.className = 'suggestions-wrapper';
        this.element = document.createElement('ul');
        this.element.className = 'suggestions';
        this.wrapper.appendChild(this.element);
        // selectingListItem is set to true in the time between the mousedown and mouseup when clicking an item in the list
        // mousedown on a list item will cause the input to blur which normally hides the list, so this flag is used to keep
        // the list open until the mouseup
        this.selectingListItem = false;
        component.el.parentNode.insertBefore(this.wrapper, component.el.nextSibling);
        return this;
    };
    List.prototype.show = function() {
        this.element.style.display = 'block';
    };
    List.prototype.hide = function() {
        this.element.style.display = 'none';
    };
    List.prototype.add = function(item) {
        this.items.push(item);
    };
    List.prototype.clear = function() {
        this.items = [];
        this.active = this.component.options.noInitialSelection ? -1 : 0;
    };
    List.prototype.isEmpty = function() {
        return !this.items.length;
    };
    List.prototype.isVisible = function() {
        return this.element.style.display === 'block';
    };
    List.prototype.draw = function() {
        this.element.innerHTML = '';
        if (this.items.length === 0) {
            this.hide();
            return;
        }
        for(var i = 0; i < this.items.length; i++)this.drawItem(this.items[i], this.active === i);
        this.show();
    };
    List.prototype.drawItem = function(item, active) {
        var li = document.createElement('li'), a = document.createElement('a');
        if (active) li.className += ' active';
        a.innerHTML = item.string;
        li.appendChild(a);
        this.element.appendChild(li);
        li.addEventListener('mousedown', (function() {
            this.selectingListItem = true;
        }).bind(this));
        li.addEventListener('mouseup', (function() {
            this.handleMouseUp.call(this, item);
        }).bind(this));
    };
    List.prototype.handleMouseUp = function(item) {
        this.selectingListItem = false;
        this.component.value(item.original);
        this.clear();
        this.draw();
    };
    List.prototype.move = function(index) {
        this.active = index;
        this.draw();
    };
    List.prototype.previous = function() {
        this.move(this.active <= 0 ? this.items.length - 1 : this.active - 1);
    };
    List.prototype.next = function() {
        this.move(this.active >= this.items.length - 1 ? 0 : this.active + 1);
    };
    List.prototype.drawError = function(msg) {
        var li = document.createElement('li');
        li.innerHTML = msg;
        this.element.appendChild(li);
        this.show();
    };
    $4703be9d11e2fafd$var$list = List;
    return $4703be9d11e2fafd$var$list;
}
var $4703be9d11e2fafd$var$suggestions;
var $4703be9d11e2fafd$var$hasRequiredSuggestions;
function $4703be9d11e2fafd$var$requireSuggestions() {
    if ($4703be9d11e2fafd$var$hasRequiredSuggestions) return $4703be9d11e2fafd$var$suggestions;
    $4703be9d11e2fafd$var$hasRequiredSuggestions = 1;
    var extend = $4703be9d11e2fafd$var$requireImmutable();
    var fuzzy = $4703be9d11e2fafd$var$requireFuzzy();
    var List = $4703be9d11e2fafd$var$requireList();
    var Suggestions = function(el, data, options) {
        options = options || {};
        this.options = extend({
            minLength: 2,
            limit: 5,
            filter: true,
            hideOnBlur: true,
            noInitialSelection: true
        }, options);
        this.el = el;
        this.data = data || [];
        this.list = new List(this);
        this.query = '';
        this.selected = null;
        this.list.draw();
        this.el.addEventListener('keyup', (function(e) {
            this.handleKeyUp(e.keyCode, e);
        }).bind(this), false);
        this.el.addEventListener('keydown', (function(e) {
            this.handleKeyDown(e);
        }).bind(this));
        this.el.addEventListener('focus', (function() {
            this.handleFocus();
        }).bind(this));
        this.el.addEventListener('blur', (function() {
            this.handleBlur();
        }).bind(this));
        this.el.addEventListener('paste', (function(e) {
            this.handlePaste(e);
        }).bind(this));
        // use user-provided render function if given, otherwise just use the default
        this.render = this.options.render ? this.options.render.bind(this) : this.render.bind(this);
        this.getItemValue = this.options.getItemValue ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this);
        return this;
    };
    Suggestions.prototype.handleKeyUp = function(keyCode, e) {
        // 40 - DOWN
        // 38 - UP
        // 27 - ESC
        // 13 - ENTER
        // 9 - TAB
        if (keyCode === 40 || keyCode === 38 || keyCode === 27 || keyCode === 9) return;
        if (keyCode === 13) {
            if (this.list.items[this.list.active]) {
                this.list.handleMouseUp(this.list.items[this.list.active]);
                e.stopPropagation();
            }
            return;
        }
        this.handleInputChange(this.el.value);
    };
    Suggestions.prototype.handleKeyDown = function(e) {
        switch(e.keyCode){
            case 13:
                if (this.list.active >= 0) this.list.selectingListItem = true;
                break;
            case 9:
                if (!this.list.isEmpty()) {
                    if (this.list.isVisible()) e.preventDefault();
                    this.value(this.list.active >= 0 ? this.list.items[this.list.active].original : null);
                    this.list.hide();
                }
                break;
            case 27:
                if (!this.list.isEmpty()) this.list.hide();
                break;
            case 38:
                this.list.previous();
                break;
            case 40:
                this.list.next();
                break;
        }
    };
    Suggestions.prototype.handleBlur = function() {
        if (!this.list.selectingListItem && this.options.hideOnBlur) this.list.hide();
    };
    Suggestions.prototype.handlePaste = function(e) {
        if (e.clipboardData) this.handleInputChange(e.clipboardData.getData('Text'));
        else {
            var self1 = this;
            setTimeout(function() {
                self1.handleInputChange(e.target.value);
            }, 100);
        }
    };
    Suggestions.prototype.handleInputChange = function(query) {
        this.query = this.normalize(query);
        this.list.clear();
        if (this.query.length < this.options.minLength) {
            this.list.draw();
            return;
        }
        this.getCandidates((function(data) {
            for(var i = 0; i < data.length; i++){
                this.list.add(data[i]);
                if (i === this.options.limit - 1) break;
            }
            this.list.draw();
        }).bind(this));
    };
    Suggestions.prototype.handleFocus = function() {
        if (!this.list.isEmpty()) this.list.show();
        this.list.selectingListItem = false;
    };
    /**
	 * Update data previously passed
	 *
	 * @param {Array} revisedData
	 */ Suggestions.prototype.update = function(revisedData) {
        this.data = revisedData;
        this.handleKeyUp();
    };
    /**
	 * Clears data
	 */ Suggestions.prototype.clear = function() {
        this.data = [];
        this.list.clear();
    };
    /**
	 * Normalize the results list and input value for matching
	 *
	 * @param {String} value
	 * @return {String}
	 */ Suggestions.prototype.normalize = function(value) {
        value = value.toLowerCase();
        return value;
    };
    /**
	 * Evaluates whether an array item qualifies as a match with the current query
	 *
	 * @param {String} candidate a possible item from the array passed
	 * @param {String} query the current query
	 * @return {Boolean}
	 */ Suggestions.prototype.match = function(candidate, query) {
        return candidate.indexOf(query) > -1;
    };
    Suggestions.prototype.value = function(value) {
        this.selected = value;
        this.el.value = this.getItemValue(value || {
            place_name: this.query
        });
        if (document.createEvent) {
            var e = document.createEvent('HTMLEvents');
            e.initEvent('change', true, false);
            this.el.dispatchEvent(e);
        } else this.el.fireEvent('onchange');
    };
    Suggestions.prototype.getCandidates = function(callback) {
        var options = {
            pre: '<strong>',
            post: '</strong>',
            extract: (function(d) {
                return this.getItemValue(d);
            }).bind(this)
        };
        var results;
        if (this.options.filter) {
            results = fuzzy.filter(this.query, this.data, options);
            results = results.map((function(item) {
                return {
                    original: item.original,
                    string: this.render(item.original, item.string)
                };
            }).bind(this));
        } else results = this.data.map((function(d) {
            var renderedString = this.render(d);
            return {
                original: d,
                string: renderedString
            };
        }).bind(this));
        callback(results);
    };
    /**
	 * For a given item in the data array, return what should be used as the candidate string
	 *
	 * @param {Object|String} item an item from the data array
	 * @return {String} item
	 */ Suggestions.prototype.getItemValue = function(item) {
        return item;
    };
    /**
	 * For a given item in the data array, return a string of html that should be rendered in the dropdown
	 * @param {Object|String} item an item from the data array
	 * @param {String} sourceFormatting a string that has pre-formatted html that should be passed directly through the render function 
	 * @return {String} html
	 */ Suggestions.prototype.render = function(item, sourceFormatting) {
        if (sourceFormatting) // use existing formatting on the source string
        return sourceFormatting;
        var boldString = item.original ? this.getItemValue(item.original) : this.getItemValue(item);
        var indexString = this.normalize(boldString);
        var indexOfQuery = indexString.lastIndexOf(this.query);
        while(indexOfQuery > -1){
            var endIndexOfQuery = indexOfQuery + this.query.length;
            boldString = boldString.slice(0, indexOfQuery) + '<strong>' + boldString.slice(indexOfQuery, endIndexOfQuery) + '</strong>' + boldString.slice(endIndexOfQuery);
            indexOfQuery = indexString.slice(0, indexOfQuery).lastIndexOf(this.query);
        }
        return boldString;
    };
    /**
	 * Render an custom error message in the suggestions list
	 * @param {String} msg An html string to render as an error message
	 */ Suggestions.prototype.renderError = function(msg) {
        this.list.drawError(msg);
    };
    $4703be9d11e2fafd$var$suggestions = Suggestions;
    return $4703be9d11e2fafd$var$suggestions;
}
var $4703be9d11e2fafd$var$suggestionsList;
var $4703be9d11e2fafd$var$hasRequiredSuggestionsList;
function $4703be9d11e2fafd$var$requireSuggestionsList() {
    if ($4703be9d11e2fafd$var$hasRequiredSuggestionsList) return $4703be9d11e2fafd$var$suggestionsList;
    $4703be9d11e2fafd$var$hasRequiredSuggestionsList = 1;
    /**
	 * A typeahead component for inputs
	 * @class Suggestions
	 *
	 * @param {HTMLInputElement} el A valid HTML input element
	 * @param {Array} data An array of data used for results
	 * @param {Object} options
	 * @param {Number} [options.limit=5] Max number of results to display in the auto suggest list.
	 * @param {Number} [options.minLength=2] Number of characters typed into an input to trigger suggestions.
	 * @param {Boolean} [options.hideOnBlur=true] If `true`, hides the suggestions when focus is lost.
	 * @return {Suggestions} `this`
	 * @example
	 * // in the browser
	 * var input = document.querySelector('input');
	 * var data = [
	 *   'Roy Eldridge',
	 *   'Roy Hargrove',
	 *   'Rex Stewart'
	 * ];
	 *
	 * new Suggestions(input, data);
	 *
	 * // with options
	 * var input = document.querySelector('input');
	 * var data = [{
	 *   name: 'Roy Eldridge',
	 *   year: 1911
	 * }, {
	 *   name: 'Roy Hargrove',
	 *   year: 1969
	 * }, {
	 *   name: 'Rex Stewart',
	 *   year: 1907
	 * }];
	 *
	 * var typeahead = new Suggestions(input, data, {
	 *   filter: false, // Disable filtering
	 *   minLength: 3, // Number of characters typed into an input to trigger suggestions.
	 *   limit: 3, //  Max number of results to display.
	 *   hideOnBlur: false // Don't hide results when input loses focus
	 * });
	 *
	 * // As we're passing an object of an arrays as data, override
	 * // `getItemValue` by specifying the specific property to search on.
	 * typeahead.getItemValue = function(item) { return item.name };
	 *
	 * input.addEventListener('change', function() {
	 *   console.log(typeahead.selected); // Current selected item.
	 * });
	 *
	 * // With browserify
	 * var Suggestions = require('suggestions');
	 *
	 * new Suggestions(input, data);
	 */ var Suggestions = $4703be9d11e2fafd$var$requireSuggestions();
    $4703be9d11e2fafd$var$suggestionsList = Suggestions;
    if (typeof window !== 'undefined') window.Suggestions = Suggestions;
    return $4703be9d11e2fafd$var$suggestionsList;
}
var $4703be9d11e2fafd$var$suggestionsListExports = $4703be9d11e2fafd$var$requireSuggestionsList();
var $4703be9d11e2fafd$var$Typeahead = /*@__PURE__*/ $4703be9d11e2fafd$var$getDefaultExportFromCjs($4703be9d11e2fafd$var$suggestionsListExports);
var $4703be9d11e2fafd$var$subtag$2 = {
    exports: {}
};
var $4703be9d11e2fafd$var$subtag$1 = $4703be9d11e2fafd$var$subtag$2.exports;
var $4703be9d11e2fafd$var$hasRequiredSubtag;
function $4703be9d11e2fafd$var$requireSubtag() {
    if ($4703be9d11e2fafd$var$hasRequiredSubtag) return $4703be9d11e2fafd$var$subtag$2.exports;
    $4703be9d11e2fafd$var$hasRequiredSubtag = 1;
    (function(module) {
        !function(root, name, make) {
            if (module.exports) module.exports = make();
            else root[name] = make();
        }($4703be9d11e2fafd$var$subtag$1, 'subtag', function() {
            var empty = '';
            var pattern = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/;
            function match(tag) {
                return tag.match(pattern) || [];
            }
            function split(tag) {
                return match(tag).filter(function(v, i) {
                    return v && i;
                });
            }
            function api(tag) {
                tag = match(tag);
                return {
                    language: tag[1] || empty,
                    extlang: tag[2] || empty,
                    script: tag[3] || empty,
                    region: tag[4] || empty
                };
            }
            function expose(target, key, value) {
                Object.defineProperty(target, key, {
                    value: value,
                    enumerable: true
                });
            }
            function part(position, pattern, type) {
                function method(tag) {
                    return match(tag)[position] || empty;
                }
                expose(method, 'pattern', pattern);
                expose(api, type, method);
            }
            part(1, /^[a-zA-Z]{2,3}$/, 'language');
            part(2, /^[a-zA-Z]{3}$/, 'extlang');
            part(3, /^[a-zA-Z]{4}$/, 'script');
            part(4, /^[a-zA-Z]{2}$|^[0-9]{3}$/, 'region');
            expose(api, 'split', split);
            return api;
        });
    })($4703be9d11e2fafd$var$subtag$2);
    return $4703be9d11e2fafd$var$subtag$2.exports;
}
var $4703be9d11e2fafd$var$subtagExports = $4703be9d11e2fafd$var$requireSubtag();
var $4703be9d11e2fafd$var$subtag = /*@__PURE__*/ $4703be9d11e2fafd$var$getDefaultExportFromCjs($4703be9d11e2fafd$var$subtagExports);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ var $4703be9d11e2fafd$var$lodash_debounce;
var $4703be9d11e2fafd$var$hasRequiredLodash_debounce;
function $4703be9d11e2fafd$var$requireLodash_debounce() {
    if ($4703be9d11e2fafd$var$hasRequiredLodash_debounce) return $4703be9d11e2fafd$var$lodash_debounce;
    $4703be9d11e2fafd$var$hasRequiredLodash_debounce = 1;
    /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as references for various `Number` constants. */ var NAN = 0 / 0;
    /** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
    /** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $4703be9d11e2fafd$var$commonjsGlobal == 'object' && $4703be9d11e2fafd$var$commonjsGlobal && $4703be9d11e2fafd$var$commonjsGlobal.Object === Object && $4703be9d11e2fafd$var$commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var objectToString = objectProto.toString;
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
    /**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */ var now = function() {
        return root.Date.now();
    };
    /**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */ function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
            return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) return trailingEdge(time);
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    /**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */ function isObject(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
    }
    /**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */ function isObjectLike(value) {
        return !!value && typeof value == 'object';
    }
    /**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */ function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */ function toNumber(value) {
        if (typeof value == 'number') return value;
        if (isSymbol(value)) return NAN;
        if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = value.replace(reTrim, '');
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    $4703be9d11e2fafd$var$lodash_debounce = debounce;
    return $4703be9d11e2fafd$var$lodash_debounce;
}
var $4703be9d11e2fafd$var$lodash_debounceExports = $4703be9d11e2fafd$var$requireLodash_debounce();
var $4703be9d11e2fafd$var$debounce = /*@__PURE__*/ $4703be9d11e2fafd$var$getDefaultExportFromCjs($4703be9d11e2fafd$var$lodash_debounceExports);
var $4703be9d11e2fafd$var$immutableExports = $4703be9d11e2fafd$var$requireImmutable();
var $4703be9d11e2fafd$var$extend = /*@__PURE__*/ $4703be9d11e2fafd$var$getDefaultExportFromCjs($4703be9d11e2fafd$var$immutableExports);
var $4703be9d11e2fafd$var$events = {
    exports: {}
};
var $4703be9d11e2fafd$var$hasRequiredEvents;
function $4703be9d11e2fafd$var$requireEvents() {
    if ($4703be9d11e2fafd$var$hasRequiredEvents) return $4703be9d11e2fafd$var$events.exports;
    $4703be9d11e2fafd$var$hasRequiredEvents = 1;
    var R = typeof Reflect === 'object' ? Reflect : null;
    var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
    else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    $4703be9d11e2fafd$var$events.exports = EventEmitter;
    $4703be9d11e2fafd$var$events.exports.once = once;
    // Backwards-compat with node 0.10.x
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = undefined;
    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    var defaultMaxListeners = 10;
    function checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            defaultMaxListeners = arg;
        }
    });
    EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function _getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        // If there is no 'error' event listener then throw.
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
            // At least give some kind of context to the user
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err; // Unhandled 'error' event
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                // No error code for this since it is a Warning
                // eslint-disable-next-line no-restricted-syntax
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                ProcessEmitWarning(w);
            }
        }
        return target;
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function _onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
    // Emits a 'removeListener' event if and only if the listener was removed.
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        // not listening for removeListener, no need to emit
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) // LIFO order
        for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function _listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
        // EventEmitters, we do not listen for `error` events here.
        emitter.addEventListener(name, function wrapListener(arg) {
            // IE does not have builtin `{ once: true }` support so we
            // have to do it manually.
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
    return $4703be9d11e2fafd$var$events.exports;
}
var $4703be9d11e2fafd$var$eventsExports = $4703be9d11e2fafd$var$requireEvents();
const $4703be9d11e2fafd$var$exceptions = {
    'fr': {
        'name': 'France',
        'bbox': [
            [
                -4.59235,
                41.380007
            ],
            [
                9.560016,
                51.148506
            ]
        ]
    },
    'us': {
        'name': 'United States',
        'bbox': [
            [
                -171.791111,
                18.91619
            ],
            [
                -66.96466,
                71.357764
            ]
        ]
    },
    'ru': {
        'name': 'Russia',
        'bbox': [
            [
                19.66064,
                41.151416
            ],
            [
                190.10042,
                81.2504
            ]
        ]
    },
    'ca': {
        'name': 'Canada',
        'bbox': [
            [
                -140.99778,
                41.675105
            ],
            [
                -52.648099,
                83.23324
            ]
        ]
    }
};
/**
 * Localized values for the placeholder string
 *
 * @private
 */ const $4703be9d11e2fafd$var$placeholder = {
    // list drawn from https://docs.mapbox.com/api/search/#language-coverage
    'de': 'Suche',
    'it': 'Ricerca',
    'en': 'Search',
    'nl': 'Zoeken',
    'fr': 'Chercher',
    'ca': 'Cerca',
    'he': "\u05DC\u05D7\u05E4\u05E9",
    'ja': "\u30B5\u30FC\u30C1",
    'lv': "Mekl\u0113t",
    'pt': 'Procurar',
    'sr': "\u041F\u0440\u0435\u0442\u0440\u0430\u0433\u0430",
    'zh': "\u641C\u7D22",
    'cs': "Vyhled\xe1v\xe1n\xed",
    'hu': "Keres\xe9s",
    'ka': "\u10EB\u10D8\u10D4\u10D1\u10D0",
    'nb': "S\xf8ke",
    'sk': "Vyh\u013Ead\xe1vanie",
    'th': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'fi': 'Hae',
    'is': 'Leita',
    'ko': "\uC218\uC0C9",
    'pl': 'Szukaj',
    'sl': 'Iskanje',
    'fa': "\u062C\u0633\u062A\u062C\u0648",
    'ru': "\u041F\u043E\u0438\u0441\u043A",
    'es': 'Buscar' //spanish
};
const $4703be9d11e2fafd$var$errorNoResults = {
    'en': 'No results found',
    'de': 'Keine Ergebnisse gefunden',
    'es': 'No hay resultados',
    'fr': "Aucun r\xe9sultat trouv\xe9"
};
const $4703be9d11e2fafd$var$errorConnectionFailed = {
    'en': 'There was an error reaching the server',
    'de': 'Verbindung fehlgeschlagen',
    'es': 'Error al conectarse al servidor',
    'fr': 'Une erreur est survenue lors de la connexion au serveur'
};
var $4703be9d11e2fafd$var$localization = {
    placeholder: $4703be9d11e2fafd$var$placeholder,
    errorNoResults: $4703be9d11e2fafd$var$errorNoResults,
    errorConnectionFailed: $4703be9d11e2fafd$var$errorConnectionFailed
};
/**
 * A regular expression to match coordinates.
 */ const $4703be9d11e2fafd$var$COORDINATES_REGEXP = /(-?\d+\.?\d*)[, ]+(-?\d+\.?\d*)[ ]*$/;
/**
 * A geocoder component that works with maplibre
 */ class $4703be9d11e2fafd$export$2e2bcd8739ae039 {
    constructor(geocoderApi, options, typeaheadFactory = (input, data, options)=>new $4703be9d11e2fafd$var$Typeahead(input, data, options)){
        // Fill with default values
        this.options = {
            zoom: 16,
            flyTo: true,
            trackProximity: true,
            showResultsWhileTyping: false,
            minLength: 2,
            reverseGeocode: false,
            limit: 5,
            enableEventLogging: true,
            marker: true,
            popup: false,
            maplibregl: undefined,
            collapsed: false,
            clearAndBlurOnEsc: false,
            clearOnBlur: false,
            proximityMinZoom: 9,
            getItemValue: (item)=>{
                return item.text != undefined ? item.text : item.place_name;
            },
            render: (item)=>{
                // Render as a suggestion
                if (!('geometry' in item)) {
                    const suggestionString = item.text;
                    const indexOfMatch = suggestionString.toLowerCase().indexOf(this._typeahead.query.toLowerCase());
                    const lengthOfMatch = this._typeahead.query.length;
                    const beforeMatch = suggestionString.substring(0, indexOfMatch);
                    const match = suggestionString.substring(indexOfMatch, indexOfMatch + lengthOfMatch);
                    const afterMatch = suggestionString.substring(indexOfMatch + lengthOfMatch);
                    return '<div class="maplibregl-ctrl-geocoder--suggestion"><svg class="maplibregl-ctrl-geocoder--suggestion-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22.8702 20.1258H21.4248L20.9125 19.6318C22.7055 17.546 23.785 14.8382 23.785 11.8925C23.785 5.32419 18.4608 0 11.8925 0C5.32419 0 0 5.32419 0 11.8925C0 18.4608 5.32419 23.785 11.8925 23.785C14.8382 23.785 17.546 22.7055 19.6318 20.9125L20.1258 21.4248V22.8702L29.2739 32L32 29.2739L22.8702 20.1258ZM11.8925 20.1258C7.33676 20.1258 3.65923 16.4483 3.65923 11.8925C3.65923 7.33676 7.33676 3.65923 11.8925 3.65923C16.4483 3.65923 20.1258 7.33676 20.1258 11.8925C20.1258 16.4483 16.4483 20.1258 11.8925 20.1258Z" fill="#687078"/></svg><div class="maplibregl-ctrl-geocoder--suggestion-info"><div class="maplibregl-ctrl-geocoder--suggestion-title">' + beforeMatch + '<span class="maplibregl-ctrl-geocoder--suggestion-match">' + match + "</span>" + afterMatch + "</div>" + "</div>" + "</div>";
                }
                // render as a search result
                const placeName = item.place_name.split(",");
                return '<div class="maplibregl-ctrl-geocoder--result"><svg class="maplibregl-ctrl-geocoder--result-icon" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.36571 0 0 5.38676 0 12.0471C0 21.0824 12 32 12 32C12 32 24 21.0824 24 12.0471C24 5.38676 18.6343 0 12 0ZM12 16.3496C9.63428 16.3496 7.71429 14.4221 7.71429 12.0471C7.71429 9.67207 9.63428 7.74454 12 7.74454C14.3657 7.74454 16.2857 9.67207 16.2857 12.0471C16.2857 14.4221 14.3657 16.3496 12 16.3496Z" fill="#687078"/></svg><div><div class="maplibregl-ctrl-geocoder--result-title">' + placeName[0] + "</div>" + '<div class="maplibregl-ctrl-geocoder--result-address">' + placeName.splice(1, placeName.length).join(",") + "</div>" + "</div>" + "</div>";
            },
            popupRender: (item)=>{
                const placeName = item.place_name.split(",");
                return '<div class="maplibregl-ctrl-geocoder--suggestion popup-suggestion"><div class="maplibregl-ctrl-geocoder--suggestion-title popup-suggestion-title">' + placeName[0] + '</div><div class="maplibregl-ctrl-geocoder--suggestion-address popup-suggestion-address">' + placeName.splice(1, placeName.length).join(",") + "</div></div>";
            },
            showResultMarkers: true,
            debounceSearch: 200
        };
        this._eventEmitter = new $4703be9d11e2fafd$var$eventsExports.EventEmitter();
        this.options = $4703be9d11e2fafd$var$extend({}, this.options, options);
        this.fresh = true;
        this.lastSelected = null;
        this.geocoderApi = geocoderApi;
        this.typeaheadFactory = typeaheadFactory;
    }
    /**
     * Add the geocoder to a container. The container can be either a `Map`, an `HTMLElement` or a CSS selector string.
     *
     * If the container is a [`Map`](https://maplibre.org/maplibre-gl-js/docs/API/classes/Map), this function will behave identically to [`Map.addControl(geocoder)`](https://maplibre.org/maplibre-gl-js/docs/API/classes/Map#addcontrol).
     * If the container is an instance of [`HTMLElement`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement), then the geocoder will be appended as a child of that [`HTMLElement`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement).
     * If the container is a [CSS selector string](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors), the geocoder will be appended to the element returned from the query.
     *
     * This function will throw an error if the container is none of the above.
     * It will also throw an error if the referenced HTML element cannot be found in the `document.body`.
     *
     * For example, if the HTML body contains the element `<div id='geocoder-container'></div>`, the following script will append the geocoder to `#geocoder-container`:
     * @example
     * ```js
     * const GeoApi = {
     *   forwardGeocode: (config) => { return { features: [] } },
     *   reverseGeocode: (config) => { return { features: [] } }
     * }
     * const geocoder = new MaplibreGeocoder(GeoAPI, {});
     * geocoder.addTo('#geocoder-container');
     * ```
     * @param container - A reference to the container to which to add the geocoder
     */ addTo(container) {
        function addToExistingContainer(geocoder, container) {
            if (!document.body.contains(container)) throw new Error("Element provided to #addTo() exists, but is not in the DOM");
            const el = geocoder.onAdd(); //returns the input elements, which are then added to the requested html container
            container.appendChild(el);
        }
        // if the container is an HTMLElement, then set the parent to be that element
        if (container instanceof HTMLElement) addToExistingContainer(this, container);
        else if (typeof container == "string") {
            const parent = document.querySelectorAll(container);
            if (parent.length === 0) throw new Error("Element " + container + "not found.");
            if (parent.length > 1) throw new Error("Geocoder can only be added to a single html element");
            addToExistingContainer(this, parent[0]);
        } else if ('addControl' in container) //  it's a maplibre-gl map, add like normal
        container.addControl(this);
        else throw new Error("Error: addTo must be a maplibre-gl-js map, an html element, or a CSS selector query for a single html element");
    }
    onAdd(map) {
        if (map && typeof map != "string") this._map = map;
        this.setLanguage();
        if (this.options.localGeocoderOnly && !this.options.localGeocoder) throw new Error("A localGeocoder function must be specified to use localGeocoderOnly mode");
        this._onChange = this._onChange.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onPaste = this._onPaste.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._showButton = this._showButton.bind(this);
        this._hideButton = this._hideButton.bind(this);
        this._onQueryResult = this._onQueryResult.bind(this);
        this.clear = this.clear.bind(this);
        this._updateProximity = this._updateProximity.bind(this);
        this._collapse = this._collapse.bind(this);
        this._unCollapse = this._unCollapse.bind(this);
        this._clear = this._clear.bind(this);
        this._clearOnBlur = this._clearOnBlur.bind(this);
        const el = this.container = document.createElement("div");
        el.className = "maplibregl-ctrl-geocoder maplibregl-ctrl maplibregl-ctrl-geocoder maplibregl-ctrl";
        const searchIcon = this.createIcon("search", '<path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"/>');
        this._inputEl = document.createElement("input");
        this._inputEl.type = "search";
        this._inputEl.className = "maplibregl-ctrl-geocoder--input";
        this.setPlaceholder();
        if (this.options.collapsed) {
            this._collapse();
            this.container.addEventListener("mouseenter", this._unCollapse);
            this.container.addEventListener("mouseleave", this._collapse);
            this._inputEl.addEventListener("focus", this._unCollapse);
        }
        if (this.options.collapsed || this.options.clearOnBlur) this._inputEl.addEventListener("blur", this._onBlur);
        this._inputEl.addEventListener("keydown", $4703be9d11e2fafd$var$debounce(this._onKeyDown, this.options.debounceSearch));
        this._inputEl.addEventListener("paste", this._onPaste);
        this._inputEl.addEventListener("change", this._onChange);
        this.container.addEventListener("mouseenter", this._showButton);
        this.container.addEventListener("mouseleave", this._hideButton);
        const actions = document.createElement("div");
        actions.classList.add("maplibregl-ctrl-geocoder--pin-right");
        this._clearEl = document.createElement("button");
        this._clearEl.setAttribute("type", "button");
        this._clearEl.setAttribute("aria-label", "Clear");
        this._clearEl.addEventListener("click", this.clear);
        this._clearEl.className = "maplibregl-ctrl-geocoder--button";
        const buttonIcon = this.createIcon("close", '<path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"/>');
        this._clearEl.appendChild(buttonIcon);
        this._loadingEl = this.createIcon("loading", '<path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"/><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"/>');
        actions.appendChild(this._clearEl);
        actions.appendChild(this._loadingEl);
        el.appendChild(searchIcon);
        el.appendChild(this._inputEl);
        el.appendChild(actions);
        this._typeahead = this.typeaheadFactory(this._inputEl, [], {
            filter: false,
            minLength: this.options.minLength,
            limit: this.options.limit,
            noInitialSelection: true
        });
        this.container.addEventListener("click", ()=>{
            this._typeahead.update(this._typeahead.data);
        });
        this.setRenderFunction(this.options.render);
        this._typeahead.getItemValue = this.options.getItemValue;
        this.mapMarker = null;
        this.resultMarkers = [];
        this._handleMarker = this._handleMarker.bind(this);
        this._handleResultMarkers = this._handleResultMarkers.bind(this);
        if (this._map) {
            if (this.options.trackProximity) {
                this._updateProximity();
                this._map.on("moveend", this._updateProximity);
            }
            this._maplibregl = this.options.maplibregl;
            if (!this._maplibregl && this.options.marker) {
                console.error("No maplibregl detected in options. Map markers are disabled. Please set options.maplibregl.");
                this.options.marker = false;
            }
        }
        return el;
    }
    createIcon(name, path) {
        const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        icon.setAttribute("class", "maplibregl-ctrl-geocoder--icon maplibregl-ctrl-geocoder--icon-" + name);
        icon.setAttribute("viewBox", "0 0 18 18");
        icon.setAttribute("xml:space", "preserve");
        icon.setAttribute("width", "18");
        icon.setAttribute("height", "18");
        // IE does not have innerHTML for SVG nodes
        if (!("innerHTML" in icon)) {
            const SVGNodeContainer = document.createElement("div");
            SVGNodeContainer.innerHTML = "<svg>" + path.valueOf().toString() + "</svg>";
            const SVGNode = SVGNodeContainer.firstChild, SVGPath = SVGNode.firstChild;
            icon.appendChild(SVGPath);
        } else icon.innerHTML = path;
        return icon;
    }
    onRemove() {
        this.container.remove();
        if (this.options.trackProximity && this._map) this._map.off("moveend", this._updateProximity);
        this._removeMarker();
        this._map = null;
        return this;
    }
    _onPaste(e) {
        const value = (e.clipboardData || window.clipboardData).getData("text");
        if (value.length >= this.options.minLength && this.options.showResultsWhileTyping) this._geocode(value);
    }
    _onKeyDown(e) {
        if (e.key === 'Escape' && this.options.clearAndBlurOnEsc) {
            this._clear(e);
            this._inputEl.blur();
            return;
        }
        const value = this._inputEl.value;
        if (!value) {
            this.fresh = true;
            // the user has removed all the text
            if (e.key !== 'Tab') this.clear(e);
            this._clearEl.style.display = "none";
            return;
        }
        if (e.metaKey || e.key === 'Tab' || e.key === 'Escape' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown') return;
        if (e.key === 'Enter') {
            if (!this.options.showResultsWhileTyping) {
                if (!this._typeahead.selected) this._geocode(value);
            } else {
                // Pressing enter on the search box will do a search for the currently string input
                if (this._typeahead.selected == null && this.geocoderApi.getSuggestions) this._geocode(value, true);
                else if (this._typeahead.selected == null) {
                    if (this.options.showResultMarkers) this._fitBoundsForMarkers();
                }
                return;
            }
        }
        // Show results while typing and greater than min length
        if (value.length >= this.options.minLength && this.options.showResultsWhileTyping) this._geocode(value);
    }
    _showButton() {
        if (this._inputEl.value.length > 0) this._clearEl.style.display = "block";
    }
    _hideButton() {
        if (this._typeahead.selected) this._clearEl.style.display = "none";
    }
    _onBlur(e) {
        if (this.options.clearOnBlur) this._clearOnBlur(e);
        if (this.options.collapsed) this._collapse();
    }
    // Change events are fire by suggestions library whenever the enter key is pressed or input is blurred
    // This can sometimes cause strange behavior as this function is called before our own onKeyDown handler and thus
    //  we cannot depend on some internal values of the suggestion state like `selected` as those will change or before
    //  our onKeyDown handler.
    _onChange() {
        var _a;
        const selected = this._typeahead.selected;
        // If a suggestion was selected
        if (!selected) return;
        if (!('geometry' in selected)) {
            if (selected.placeId) this._geocode(selected.placeId, true, true);
            else this._geocode(selected.text, true);
            return;
        }
        if (JSON.stringify(selected) === this.lastSelected) return;
        this._clearEl.style.display = "none";
        if (this.options.flyTo) {
            let flyOptions;
            this._removeResultMarkers();
            if (selected.properties && $4703be9d11e2fafd$var$exceptions[selected.properties.short_code]) {
                // Certain geocoder search results return (and therefore zoom to fit)
                // an unexpectedly large bounding box: for example, both Russia and the
                // USA span both sides of -180/180, or France includes the island of
                // Reunion in the Indian Ocean. An incomplete list of these exceptions
                // at ./exceptions.json provides "reasonable" bounding boxes as a
                // short-term solution; this may be amended as necessary.
                flyOptions = $4703be9d11e2fafd$var$extend({}, this.options.flyTo);
                if (this._map) this._map.fitBounds($4703be9d11e2fafd$var$exceptions[selected.properties.short_code].bbox, flyOptions);
            } else if (selected.bbox) {
                const bbox = selected.bbox;
                flyOptions = $4703be9d11e2fafd$var$extend({}, this.options.flyTo);
                if (this._map) this._map.fitBounds([
                    [
                        bbox[0],
                        bbox[1]
                    ],
                    [
                        bbox[2],
                        bbox[3]
                    ]
                ], flyOptions);
            } else {
                const defaultFlyOptions = {
                    zoom: this.options.zoom
                };
                flyOptions = $4703be9d11e2fafd$var$extend({}, defaultFlyOptions, this.options.flyTo);
                //  ensure that center is not overriden by custom options
                if (selected.center) flyOptions.center = selected.center;
                else if (((_a = selected.geometry) === null || _a === void 0 ? void 0 : _a.type) === "Point" && selected.geometry.coordinates) flyOptions.center = selected.geometry.coordinates;
                if (this._map) this._map.flyTo(flyOptions);
            }
        }
        if (this.options.marker && this._maplibregl) this._handleMarker(selected);
        // After selecting a feature, re-focus the textarea and set
        // cursor at start, and reset the selected feature.
        this._inputEl.focus();
        this._inputEl.scrollLeft = 0;
        this._inputEl.setSelectionRange(0, 0);
        this.lastSelected = JSON.stringify(selected);
        this._typeahead.selected = null; // reset selection current selection value and set it to last selected
        this._eventEmitter.emit("result", {
            result: selected
        });
    }
    _getConfigForRequest() {
        // Possible config proprerties to pass to client
        const keys = [
            "bbox",
            "limit",
            "proximity",
            "countries",
            "types",
            "language",
            "reverseMode"
        ];
        // Create config object
        const config = keys.reduce((config, key)=>{
            if (this.options[key]) {
                if ([
                    "countries",
                    "types",
                    "language"
                ].indexOf(key) > -1) config[key] = this.options[key].split(/[\s,]+/);
                else config[key] = this.options[key];
                if (key === "proximity" && this.options[key] && typeof this.options[key].longitude === "number" && typeof this.options[key].latitude === "number") config[key] = [
                    this.options[key].longitude,
                    this.options[key].latitude
                ];
            }
            return config;
        }, {});
        return config;
    }
    _geocode(searchInput_1) {
        return $4703be9d11e2fafd$var$__awaiter(this, arguments, void 0, function*(searchInput, isSuggestion = false, isPlaceId = false) {
            this._loadingEl.style.display = "block";
            this._eventEmitter.emit("loading", {
                query: searchInput
            });
            const config = this._getConfigForRequest();
            const request = this._createGeocodeRequest(config, searchInput, isSuggestion, isPlaceId);
            const localGeocoderResults = this.options.localGeocoder ? this.options.localGeocoder(searchInput) || [] : [];
            try {
                const response = yield request;
                yield this._handleGeocodeResponse(response, config, searchInput, isSuggestion, localGeocoderResults);
            } catch (err) {
                this._handleGeocodeErrorResponse(err, localGeocoderResults);
            }
            return request;
        });
    }
    _createGeocodeRequest(config, searchInput, isSuggestion, isPlaceId) {
        if (this.options.localGeocoderOnly) return Promise.resolve({});
        if (this.options.reverseGeocode && $4703be9d11e2fafd$var$COORDINATES_REGEXP.test(searchInput)) // searchInput resembles coordinates, make the request a reverseGeocode
        return this._createReverseGeocodeRequest(searchInput, config);
        config.query = searchInput;
        if (!this.geocoderApi.getSuggestions) return this.geocoderApi.forwardGeocode(config);
        if (!isSuggestion) // user typed in text and should receive suggestions
        return this.geocoderApi.getSuggestions(config);
        // user clicked on a suggestion
        if (this.geocoderApi.searchByPlaceId && isPlaceId) // suggestion has place Id
        return this.geocoderApi.searchByPlaceId(config);
        return this.geocoderApi.forwardGeocode(config);
    }
    _createReverseGeocodeRequest(searchInput, config) {
        // parse coordinates
        const coords = searchInput.split(/[\s(,)?]+/).map((c)=>parseFloat(c)).reverse();
        // client only accepts one type for reverseGeocode, so
        // use first config type if one, if not default to poi
        config.query = coords;
        config.limit = 1;
        // drop proximity which may have been set by trackProximity since it's not supported by the reverseGeocoder
        if ("proximity" in config) delete config.proximity;
        return this.geocoderApi.reverseGeocode(config);
    }
    _handleGeocodeResponse(response, config, searchInput, isSuggestion, localGeocoderResults) {
        return $4703be9d11e2fafd$var$__awaiter(this, void 0, void 0, function*() {
            this._loadingEl.style.display = "none";
            let res = {};
            if (!response) res = {
                type: "FeatureCollection",
                features: []
            };
            else res = response;
            res.config = config;
            if (this.fresh) this.fresh = false;
            // supplement Maplibre Geocoding API results with locally populated results
            res.features = res.features ? localGeocoderResults.concat(res.features) : localGeocoderResults;
            const externalGeocoderResultsPromise = this.options.externalGeocoder ? this.options.externalGeocoder(searchInput, res.features, config) || Promise.resolve([]) : Promise.resolve([]);
            // supplement Geocoding API results with features returned by a promise
            try {
                const features = yield externalGeocoderResultsPromise;
                res.features = res.features ? features.concat(res.features) : features;
            } catch (_a) {
            // on error, display the original result
            }
            // apply results filter if provided
            if (this.options.filter && res.features.length) res.features = res.features.filter(this.options.filter);
            let typeaheadData = [];
            if ('suggestions' in res) typeaheadData = res.suggestions;
            else if ('place' in res) typeaheadData = Array.isArray(res.place) ? res.place : [
                res.place
            ];
            else typeaheadData = res.features;
            if (typeaheadData.length) {
                this._clearEl.style.display = "block";
                this._typeahead.update(typeaheadData);
                if ((!this.options.showResultsWhileTyping || isSuggestion) && this.options.showResultMarkers && (res.features.length > 0 || 'place' in res)) this._fitBoundsForMarkers();
                this._eventEmitter.emit("results", res);
            } else {
                this._clearEl.style.display = "none";
                this._typeahead.selected = null;
                this._renderNoResults();
                this._eventEmitter.emit("results", res);
            }
        });
    }
    _handleGeocodeErrorResponse(error, localGeocoderResults) {
        this._loadingEl.style.display = "none";
        // in the event of an error in the Geocoding API still display results from the localGeocoder
        if (localGeocoderResults.length && this.options.localGeocoder) {
            this._clearEl.style.display = "block";
            this._typeahead.update(localGeocoderResults);
        } else {
            this._clearEl.style.display = "none";
            this._typeahead.selected = null;
            this._renderError();
        }
        this._eventEmitter.emit("results", {
            features: localGeocoderResults
        });
        this._eventEmitter.emit("error", {
            error: error
        });
    }
    /**
     * Shared logic for clearing input
     * @param ev - the event that triggered the clear, if available
     */ _clear(ev) {
        if (ev) ev.preventDefault();
        this._inputEl.value = "";
        this._typeahead.selected = null;
        this._typeahead.clear();
        this._onChange();
        this._clearEl.style.display = "none";
        this._removeMarker();
        this._removeResultMarkers();
        this.lastSelected = null;
        this._eventEmitter.emit("clear");
        this.fresh = true;
    }
    /**
     * Clear and then focus the input.
     * @param ev - the event that triggered the clear, if available
     *
     */ clear(ev) {
        this._clear(ev);
        this._inputEl.focus();
    }
    /**
     * Clear the input, without refocusing it. Used to implement clearOnBlur
     * constructor option.
     * @param ev - the blur event
     */ _clearOnBlur(ev) {
        /*
         * If relatedTarget is not found, assume user targeted the suggestions list.
         * In that case, do not clear on blur. There are other edge cases where
         * ev.relatedTarget could be null. Clicking on list always results in null
         * relatedtarget because of upstream behavior in `suggestions`.
         *
         * The ideal solution would be to check if ev.relatedTarget is a child of
         * the list. See issue #258 for details on why we can't do that yet.
         */ if (ev.relatedTarget) this._clear(ev);
    }
    _onQueryResult(results) {
        if (!('features' in results)) return;
        if (!results.features.length) return;
        const result = results.features[0];
        this._typeahead.selected = result;
        this._inputEl.value = result.place_name;
        this._onChange();
    }
    _updateProximity() {
        // proximity is designed for local scale, if the user is looking at the whole world,
        // it doesn't make sense to factor in the arbitrary centre of the map
        if (!this._map) return;
        if (this._map.getZoom() > this.options.proximityMinZoom) {
            const center = this._map.getCenter().wrap();
            this.setProximity({
                longitude: center.lng,
                latitude: center.lat
            });
        } else this.setProximity(null);
    }
    _collapse() {
        // do not collapse if input is in focus
        if (!this._inputEl.value && this._inputEl !== document.activeElement) this.container.classList.add("maplibregl-ctrl-geocoder--collapsed");
    }
    _unCollapse() {
        this.container.classList.remove("maplibregl-ctrl-geocoder--collapsed");
    }
    /**
     * Set & query the input
     * @param searchInput - location name or other search input
     */ query(searchInput) {
        return $4703be9d11e2fafd$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield this._geocode(searchInput);
            this._onQueryResult(results);
        });
    }
    _renderError() {
        const errorMessage = `<div class='maplibre-gl-geocoder--error'>${this._localize("errorConnectionFailed")}</div>`;
        this._renderMessage(errorMessage);
    }
    _renderNoResults() {
        const errorMessage = `<div class='maplibre-gl-geocoder--error maplibre-gl-geocoder--no-results'>
        ${this._localize("errorNoResults")}</div>`;
        this._renderMessage(errorMessage);
    }
    _renderMessage(msg) {
        this._typeahead.update([]);
        this._typeahead.selected = null;
        this._typeahead.clear();
        this._typeahead.renderError(msg);
    }
    /**
     * Get a localised string for a given key
     *
     * If language is provided in options, attempt to return localized string (defaults to English)
     * @param key - key in the localization object
     * @returns localized string
     */ _localize(key) {
        const language = $4703be9d11e2fafd$var$subtag.language(this.options.language.split(',')[0]);
        return this.options.language && ($4703be9d11e2fafd$var$localization === null || $4703be9d11e2fafd$var$localization === void 0 ? void 0 : $4703be9d11e2fafd$var$localization[key][language]) ? $4703be9d11e2fafd$var$localization[key][language] : $4703be9d11e2fafd$var$localization[key]['en'];
    }
    /**
     * Fits the map to the current bounds for the searched results
     */ _fitBoundsForMarkers() {
        var _a;
        if (this._typeahead.data.length < 1) return;
        // Filter out suggestions and restrict to limit
        const results = this._typeahead.data.filter((result)=>{
            return typeof result === "string" ? false : true;
        }).slice(0, this.options.limit);
        this._clearEl.style.display = "none";
        if (this.options.flyTo && this._maplibregl) {
            if (this._map) {
                const defaultFlyOptions = {
                    padding: 100
                };
                const flyOptions = $4703be9d11e2fafd$var$extend({}, defaultFlyOptions, this.options.flyTo);
                const bounds = new this._maplibregl.LngLatBounds();
                for (const feature of results)if ('geometry' in feature && ((_a = feature.geometry) === null || _a === void 0 ? void 0 : _a.type) === "Point") bounds.extend(feature.geometry.coordinates);
                this._map.fitBounds(bounds, flyOptions);
            }
        }
        if (results.length > 0 && this._maplibregl) this._handleResultMarkers(results);
        return this;
    }
    /**
     * Set input
     * @param searchInput - location name or other search input
     */ setInput(searchInput) {
        // Set input value to passed value and clear everything else.
        this._inputEl.value = searchInput;
        this._typeahead.selected = null;
        this._typeahead.clear();
        if (searchInput.length >= this.options.minLength && this.options.showResultsWhileTyping) this._geocode(searchInput);
        return this;
    }
    /**
     * Set proximity
     * @param proximity - The new `options.proximity` value. This is a geographical point given as an object with `latitude` and `longitude` properties.
     */ setProximity(proximity) {
        this.options.proximity = proximity;
        return this;
    }
    /**
     * Get proximity
     * @returns The geocoder proximity
     */ getProximity() {
        return this.options.proximity;
    }
    /**
     * Set the render function used in the results dropdown
     * @param fn - The function to use as a render function. This function accepts a single {@link CarmenGeojsonFeature} object as input and returns a string.
     */ setRenderFunction(fn) {
        if (fn && typeof fn == "function") this._typeahead.render = fn;
        return this;
    }
    /**
     * Get the function used to render the results dropdown
     *
     * @returns the render function
     */ getRenderFunction() {
        return this._typeahead.render;
    }
    /**
     * Get the language to use in UI elements and when making search requests
     *
     * Look first at the explicitly set options otherwise use the browser's language settings
     * @param language - Specify the language to use for response text and query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas.
     */ setLanguage(language) {
        this.options.language = language || this.options.language || navigator.language;
        return this;
    }
    /**
     * Get the language to use in UI elements and when making search requests
     * @returns The language(s) used by the plugin, if any
     */ getLanguage() {
        return this.options.language;
    }
    /**
     * Get the zoom level the map will move to when there is no bounding box on the selected result
     * @returns the map zoom
     */ getZoom() {
        return this.options.zoom;
    }
    /**
     * Set the zoom level
     * @param zoom - The zoom level that the map should animate to when a `bbox` isn't found in the response. If a `bbox` is found the map will fit to the `bbox`.
     * @returns this
     */ setZoom(zoom) {
        this.options.zoom = zoom;
        return this;
    }
    /**
     * Get the parameters used to fly to the selected response, if any
     * @returns The `flyTo` option
     */ getFlyTo() {
        return this.options.flyTo;
    }
    /**
     * Set the flyTo options
     * @param flyTo - If false, animating the map to a selected result is disabled. If true, animating the map will use the default animation parameters. If an object, it will be passed as `options` to the map [`flyTo`](https://maplibre.org/maplibre-gl-js/docs/API/classes/Map#flyto) or [`fitBounds`](https://maplibre.org/maplibre-gl-js/docs/API/classes/Map#fitbounds) method providing control over the animation of the transition.
     */ setFlyTo(flyTo) {
        this.options.flyTo = flyTo;
        return this;
    }
    /**
     * Get the value of the placeholder string
     * @returns The input element's placeholder value
     */ getPlaceholder() {
        return this.options.placeholder;
    }
    /**
     * Set the value of the input element's placeholder
     * @param placeholder - the text to use as the input element's placeholder
     */ setPlaceholder(placeholder) {
        this.options.placeholder = placeholder ? placeholder : this.options.placeholder || this._localize("placeholder");
        this._inputEl.placeholder = this.options.placeholder;
        this._inputEl.setAttribute("aria-label", this.options.placeholder);
        return this;
    }
    /**
     * Get the bounding box used by the plugin
     * @returns the bounding box, if any
     */ getBbox() {
        return this.options.bbox;
    }
    /**
     * Set the bounding box to limit search results to
     * @param bbox - a bounding box given as an array in the format [minX, minY, maxX, maxY].
     */ setBbox(bbox) {
        this.options.bbox = bbox;
        return this;
    }
    /**
     * Get a list of the countries to limit search results to
     * @returns a comma separated list of countries to limit to, if any
     */ getCountries() {
        return this.options.countries;
    }
    /**
     * Set the countries to limit search results to
     * @param countries - a comma separated list of countries to limit to
     */ setCountries(countries) {
        this.options.countries = countries;
        return this;
    }
    /**
     * Get a list of the types to limit search results to
     * @returns a comma separated list of types to limit to
     */ getTypes() {
        return this.options.types;
    }
    /**
     * Set the types to limit search results to
     * @param types - a comma separated list of types to limit to
     */ setTypes(types) {
        this.options.types = types;
        return this;
    }
    /**
     * Get the minimum number of characters typed to trigger results used in the plugin
     * @returns The minimum length in characters before a search is triggered
     */ getMinLength() {
        return this.options.minLength;
    }
    /**
     * Set the minimum number of characters typed to trigger results used by the plugin
     * @param minLength - the minimum length in characters
     */ setMinLength(minLength) {
        this.options.minLength = minLength;
        if (this._typeahead) this._typeahead.options.minLength = minLength;
        return this;
    }
    /**
     * Get the limit value for the number of results to display used by the plugin
     * @returns The limit value for the number of results to display used by the plugin
     */ getLimit() {
        return this.options.limit;
    }
    /**
     * Set the limit value for the number of results to display used by the plugin
     * @param limit - the number of search results to return
     */ setLimit(limit) {
        this.options.limit = limit;
        if (this._typeahead) this._typeahead.options.limit = limit;
        return this;
    }
    /**
     * Get the filter function used by the plugin
     * @returns the filter function
     */ getFilter() {
        return this.options.filter;
    }
    /**
     * Set the filter function used by the plugin.
     * @param filter - A function which accepts a {@link CarmenGeojsonFeature} to filter out results from the Geocoding API response before they are included in the suggestions list. Return `true` to keep the item, `false` otherwise.
     */ setFilter(filter) {
        this.options.filter = filter;
        return this;
    }
    /**
     * Set the geocoding api used by the plugin.
     */ setGeocoderApi(geocoderApi) {
        this.geocoderApi = geocoderApi;
        return this;
    }
    /**
     * Get the geocoding endpoint the plugin is currently set to
     * @returns the geocoding API
     */ getGeocoderApi() {
        return this.geocoderApi;
    }
    /**
     * Handle the placement of a result marking the selected result
     * @param selected - the selected geojson feature
     */ _handleMarker(selected) {
        var _a;
        // clean up any old marker that might be present
        if (!this._map) return;
        this._removeMarker();
        const defaultMarkerOptions = {
            color: "#4668F2"
        };
        const markerOptions = $4703be9d11e2fafd$var$extend({}, defaultMarkerOptions, this.options.marker);
        this.mapMarker = new this._maplibregl.Marker(markerOptions);
        let popup = null;
        if (this.options.popup) {
            const defaultPopupOptions = {};
            const popupOptions = $4703be9d11e2fafd$var$extend({}, defaultPopupOptions, this.options.popup);
            popup = new this._maplibregl.Popup(popupOptions).setHTML(this.options.popupRender(selected));
        }
        if (selected.center) {
            this.mapMarker.setLngLat(selected.center).addTo(this._map);
            if (this.options.popup) this.mapMarker.setPopup(popup);
        } else if (((_a = selected.geometry) === null || _a === void 0 ? void 0 : _a.type) === "Point" && selected.geometry.coordinates) {
            this.mapMarker.setLngLat(selected.geometry.coordinates).addTo(this._map);
            if (this.options.popup) this.mapMarker.setPopup(popup);
        }
        return this;
    }
    /**
     * Handle the removal of a result marker
     */ _removeMarker() {
        if (this.mapMarker) {
            this.mapMarker.remove();
            this.mapMarker = null;
        }
    }
    /**
     * Handle the placement of a result marking the selected result
     * @param results - the top results to display on the map
     */ _handleResultMarkers(results) {
        // clean up any old marker that might be present
        if (!this._map) return;
        this._removeResultMarkers();
        const defaultMarkerOptions = {
            color: "#4668F2"
        };
        let markerOptions = $4703be9d11e2fafd$var$extend({}, defaultMarkerOptions, this.options.showResultMarkers);
        for (const result of results){
            let el;
            if (this.options.showResultMarkers) {
                if (this.options.showResultMarkers && this.options.showResultMarkers.element) {
                    el = this.options.showResultMarkers.element.cloneNode(true);
                    markerOptions = $4703be9d11e2fafd$var$extend(markerOptions, {
                        element: el
                    });
                }
                const marker = new this._maplibregl.Marker($4703be9d11e2fafd$var$extend({}, markerOptions, {
                    element: el
                }));
                let popup;
                if (this.options.popup) {
                    const defaultPopupOptions = {};
                    const popupOptions = $4703be9d11e2fafd$var$extend({}, defaultPopupOptions, this.options.popup);
                    popup = new this._maplibregl.Popup(popupOptions).setHTML(this.options.popupRender(result));
                }
                if (result.center) {
                    marker.setLngLat(result.center).addTo(this._map);
                    if (this.options.popup) marker.setPopup(popup);
                } else if (result.geometry && result.geometry.type && result.geometry.type === "Point" && result.geometry.coordinates) {
                    marker.setLngLat(result.geometry.coordinates).addTo(this._map);
                    if (this.options.popup) marker.setPopup(popup);
                }
                this.resultMarkers.push(marker);
            }
        }
        return this;
    }
    /**
     * Handle the removal of a result marker
     */ _removeResultMarkers() {
        if (this.resultMarkers && this.resultMarkers.length > 0) {
            this.resultMarkers.forEach(function(marker) {
                marker.remove();
            });
            this.resultMarkers = [];
        }
    }
    /**
     * Subscribe to events that happen within the plugin.
     * @param type - name of event. Check out the {@link MaplibreGeocoderEventTypeMap} for a list of available events.
     * @param fn - function that's called when the event is emitted.
     */ on(type, fn) {
        this._eventEmitter.on(type, fn);
        return this;
    }
    /**
     * Subscribe to events that happen within the plugin only once.
     * @param type - Event name. Check out the {@link MaplibreGeocoderEventTypeMap} for a list of available events.
     * @returns a Promise that resolves when the event is emitted.
     */ once(type) {
        return new Promise((resolve)=>{
            this._eventEmitter.once(type, resolve);
        });
    }
    /**
     * Remove an event
     * @param type - Event name.
     * @param fn - Function that should unsubscribe to the event emitted.
     */ off(type, fn) {
        this._eventEmitter.removeListener(type, fn);
        return this;
    }
}


var $834619e78bbf578c$exports = {};

$parcel$export($834619e78bbf578c$exports, "now", () => $834619e78bbf578c$export$461939dd4422153);
$parcel$export($834619e78bbf578c$exports, "setNow", () => $834619e78bbf578c$export$6b09b4ca4892be7e);
$parcel$export($834619e78bbf578c$exports, "restoreNow", () => $834619e78bbf578c$export$c893a3a0ea8f2422);
$parcel$export($834619e78bbf578c$exports, "isTimeFrozen", () => $834619e78bbf578c$export$b034adc12b1cc7ef);
$parcel$export($834619e78bbf578c$exports, "MapLibreEvent", () => $834619e78bbf578c$export$fc21b96c04d10d16);
$parcel$export($834619e78bbf578c$exports, "MapMovementEvent", () => $834619e78bbf578c$export$534b7a2acb0e16da);
$parcel$export($834619e78bbf578c$exports, "MapStyleLoadEvent", () => $834619e78bbf578c$export$444e55cd0e2f4f3a);
$parcel$export($834619e78bbf578c$exports, "MapStyleDataEvent", () => $834619e78bbf578c$export$49025a11e3fe5bd0);
$parcel$export($834619e78bbf578c$exports, "MapSourceDataEvent", () => $834619e78bbf578c$export$ae09c661b7a299b2);
$parcel$export($834619e78bbf578c$exports, "MapMouseEvent", () => $834619e78bbf578c$export$83f023c8e5acf676);
$parcel$export($834619e78bbf578c$exports, "MapTouchEvent", () => $834619e78bbf578c$export$706699378fec3ddd);
$parcel$export($834619e78bbf578c$exports, "MapWheelEvent", () => $834619e78bbf578c$export$10870e40d23509f);
$parcel$export($834619e78bbf578c$exports, "MapBoxZoomEvent", () => $834619e78bbf578c$export$702e4d7a848278fa);
$parcel$export($834619e78bbf578c$exports, "MapTerrainEvent", () => $834619e78bbf578c$export$da1f2ab236a92d66);
$parcel$export($834619e78bbf578c$exports, "MapProjectionEvent", () => $834619e78bbf578c$export$f966cee55553279);
$parcel$export($834619e78bbf578c$exports, "MapContextEvent", () => $834619e78bbf578c$export$3238995171e25bd5);
$parcel$export($834619e78bbf578c$exports, "MapStyleImageMissingEvent", () => $834619e78bbf578c$export$14816c15d485a7b9);
$parcel$export($834619e78bbf578c$exports, "prewarm", () => $834619e78bbf578c$export$ea453d9c8cc3d5d2);
$parcel$export($834619e78bbf578c$exports, "clearPrewarmedResources", () => $834619e78bbf578c$export$3b8bb46c10ecf86e);
$parcel$export($834619e78bbf578c$exports, "getGlobalDispatcher", () => $834619e78bbf578c$export$6f0c702cbe7d6ed8);
$parcel$export($834619e78bbf578c$exports, "LngLatBounds", () => $834619e78bbf578c$export$266d2884f61535d3);
$parcel$export($834619e78bbf578c$exports, "VectorTileSource", () => $834619e78bbf578c$export$5feeb63c172810c5);
$parcel$export($834619e78bbf578c$exports, "RasterTileSource", () => $834619e78bbf578c$export$908e4015b805db3c);
$parcel$export($834619e78bbf578c$exports, "RasterDEMTileSource", () => $834619e78bbf578c$export$12673e0db63b98e3);
$parcel$export($834619e78bbf578c$exports, "GeoJSONSource", () => $834619e78bbf578c$export$8a9e6af3bfd58eb9);
$parcel$export($834619e78bbf578c$exports, "createTileMesh", () => $834619e78bbf578c$export$54e626fcf5dbddb3);
$parcel$export($834619e78bbf578c$exports, "ImageSource", () => $834619e78bbf578c$export$280e9a68c3ffd919);
$parcel$export($834619e78bbf578c$exports, "VideoSource", () => $834619e78bbf578c$export$f3a17123d80000c5);
$parcel$export($834619e78bbf578c$exports, "CanvasSource", () => $834619e78bbf578c$export$ca65ccf5708c6a0c);
$parcel$export($834619e78bbf578c$exports, "addSourceType", () => $834619e78bbf578c$export$10a8414b48d62ec3);
$parcel$export($834619e78bbf578c$exports, "EdgeInsets", () => $834619e78bbf578c$export$45cce0bd6c1f342a);
$parcel$export($834619e78bbf578c$exports, "Style", () => $834619e78bbf578c$export$d9e45bc13d335801);
$parcel$export($834619e78bbf578c$exports, "GPUInitializationError", () => $834619e78bbf578c$export$68b5dc085315a832);
$parcel$export($834619e78bbf578c$exports, "Hash", () => $834619e78bbf578c$export$ab85ecd77ce6a5cd);
$parcel$export($834619e78bbf578c$exports, "BoxZoomHandler", () => $834619e78bbf578c$export$bd01c6f06175f3af);
$parcel$export($834619e78bbf578c$exports, "TwoFingersTouchZoomHandler", () => $834619e78bbf578c$export$db37e9f00445aa54);
$parcel$export($834619e78bbf578c$exports, "TwoFingersTouchRotateHandler", () => $834619e78bbf578c$export$6966aa20d1b4577f);
$parcel$export($834619e78bbf578c$exports, "TwoFingersTouchPitchHandler", () => $834619e78bbf578c$export$7ea266bd3010ae2a);
$parcel$export($834619e78bbf578c$exports, "KeyboardHandler", () => $834619e78bbf578c$export$474b8119f9aaf6a9);
$parcel$export($834619e78bbf578c$exports, "ScrollZoomHandler", () => $834619e78bbf578c$export$fd7a47efd2367414);
$parcel$export($834619e78bbf578c$exports, "DoubleClickZoomHandler", () => $834619e78bbf578c$export$939799190379133f);
$parcel$export($834619e78bbf578c$exports, "DragPanHandler", () => $834619e78bbf578c$export$69c4612f5624c3f0);
$parcel$export($834619e78bbf578c$exports, "DragRotateHandler", () => $834619e78bbf578c$export$fc9ed7efe29ccb64);
$parcel$export($834619e78bbf578c$exports, "TwoFingersTouchZoomRotateHandler", () => $834619e78bbf578c$export$69d5f25840cce15f);
$parcel$export($834619e78bbf578c$exports, "CooperativeGesturesHandler", () => $834619e78bbf578c$export$eba3588e2069a729);
$parcel$export($834619e78bbf578c$exports, "AttributionControl", () => $834619e78bbf578c$export$5af5c3cc9905683);
$parcel$export($834619e78bbf578c$exports, "LogoControl", () => $834619e78bbf578c$export$6941d1bdee1234d4);
$parcel$export($834619e78bbf578c$exports, "Map", () => $834619e78bbf578c$export$a5c7b93649eaf8f8);
$parcel$export($834619e78bbf578c$exports, "NavigationControl", () => $834619e78bbf578c$export$49a437922edc1bd9);
$parcel$export($834619e78bbf578c$exports, "MarkerDragEvent", () => $834619e78bbf578c$export$4da46cf7208441a7);
$parcel$export($834619e78bbf578c$exports, "MarkerClickEvent", () => $834619e78bbf578c$export$20d8ab55cf6e381);
$parcel$export($834619e78bbf578c$exports, "Marker", () => $834619e78bbf578c$export$e98856a975cab58e);
$parcel$export($834619e78bbf578c$exports, "GeolocateEvent", () => $834619e78bbf578c$export$caf365a3870a7616);
$parcel$export($834619e78bbf578c$exports, "GeolocatePositionEvent", () => $834619e78bbf578c$export$d3cbd8e3df821073);
$parcel$export($834619e78bbf578c$exports, "GeolocateErrorEvent", () => $834619e78bbf578c$export$319ba8bf7a75a42a);
$parcel$export($834619e78bbf578c$exports, "GeolocateControl", () => $834619e78bbf578c$export$15e4ff48f7e9d8e0);
$parcel$export($834619e78bbf578c$exports, "ScaleControl", () => $834619e78bbf578c$export$1fb16e435eedcce9);
$parcel$export($834619e78bbf578c$exports, "FullscreenEvent", () => $834619e78bbf578c$export$a2126d0731cda86b);
$parcel$export($834619e78bbf578c$exports, "FullscreenControl", () => $834619e78bbf578c$export$91e8ffb52c2b32c5);
$parcel$export($834619e78bbf578c$exports, "TerrainControl", () => $834619e78bbf578c$export$cc733900d53f94f9);
$parcel$export($834619e78bbf578c$exports, "GlobeControl", () => $834619e78bbf578c$export$9618410ded3c9550);
$parcel$export($834619e78bbf578c$exports, "PopupEvent", () => $834619e78bbf578c$export$c09aca14b6b2f8f0);
$parcel$export($834619e78bbf578c$exports, "Popup", () => $834619e78bbf578c$export$129a32eedafa97c5);
$parcel$export($834619e78bbf578c$exports, "setRTLTextPlugin", () => $834619e78bbf578c$export$80220802faa18fec);
$parcel$export($834619e78bbf578c$exports, "getRTLTextPluginStatus", () => $834619e78bbf578c$export$c8f205afdabdaef4);
$parcel$export($834619e78bbf578c$exports, "getVersion", () => $834619e78bbf578c$export$c506eb22e615ba4a);
$parcel$export($834619e78bbf578c$exports, "getWorkerCount", () => $834619e78bbf578c$export$33e4148f0a10446f);
$parcel$export($834619e78bbf578c$exports, "setWorkerCount", () => $834619e78bbf578c$export$ec8b1053ddd7f5bc);
$parcel$export($834619e78bbf578c$exports, "getMaxParallelImageRequests", () => $834619e78bbf578c$export$8ac2684f98a393b0);
$parcel$export($834619e78bbf578c$exports, "setMaxParallelImageRequests", () => $834619e78bbf578c$export$9569597edc1f5cf3);
$parcel$export($834619e78bbf578c$exports, "getWorkerUrl", () => $834619e78bbf578c$export$b01b5f33620cab52);
$parcel$export($834619e78bbf578c$exports, "setWorkerUrl", () => $834619e78bbf578c$export$f7f2857281fba5f0);
$parcel$export($834619e78bbf578c$exports, "importScriptInWorkers", () => $834619e78bbf578c$export$9cdc513767f0ece9);
$parcel$export($834619e78bbf578c$exports, "MapLibreMap", () => $834619e78bbf578c$export$a5c7b93649eaf8f8);
$parcel$export($834619e78bbf578c$exports, "AJAXError", () => (parcelRequire("1rqx5")).yn);
$parcel$export($834619e78bbf578c$exports, "EXTENT", () => (parcelRequire("1rqx5")).Lr);
$parcel$export($834619e78bbf578c$exports, "ErrorEvent", () => (parcelRequire("1rqx5")).gn);
$parcel$export($834619e78bbf578c$exports, "Event", () => (parcelRequire("1rqx5"))._n);
$parcel$export($834619e78bbf578c$exports, "Evented", () => (parcelRequire("1rqx5")).vn);
$parcel$export($834619e78bbf578c$exports, "LngLat", () => (parcelRequire("1rqx5")).lt);
$parcel$export($834619e78bbf578c$exports, "MercatorCoordinate", () => (parcelRequire("1rqx5")).nt);
$parcel$export($834619e78bbf578c$exports, "Point", () => (parcelRequire("1rqx5")).Li);
$parcel$export($834619e78bbf578c$exports, "addProtocol", () => (parcelRequire("1rqx5")).Dn);
$parcel$export($834619e78bbf578c$exports, "config", () => (parcelRequire("1rqx5")).An);
$parcel$export($834619e78bbf578c$exports, "removeProtocol", () => (parcelRequire("1rqx5")).kn);
/**
* MapLibre GL JS
* @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v6.11.2/LICENSE.txt
*/ 
var $1rqx5 = parcelRequire("1rqx5");
var $834619e78bbf578c$var$Ar = `6.11.2`;
function $834619e78bbf578c$var$jr() {
    var e1 = new (0, $1rqx5.Pi)(4);
    return (0, $1rqx5.Pi) != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
}
function $834619e78bbf578c$var$Mr(e1, t) {
    var n = t[0], r = t[1], i = t[2], a = t[3], o = n * a - i * r;
    return o ? (o = 1 / o, e1[0] = a * o, e1[1] = -r * o, e1[2] = -i * o, e1[3] = n * o, e1) : null;
}
function $834619e78bbf578c$var$Nr(e1) {
    return e1[0] * e1[3] - e1[2] * e1[1];
}
function $834619e78bbf578c$var$Pr(e1, t, n) {
    var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
    return e1[0] = r * c + a * s, e1[1] = i * c + o * s, e1[2] = r * -s + a * c, e1[3] = i * -s + o * c, e1;
}
let $834619e78bbf578c$var$Fr, $834619e78bbf578c$var$Ir, $834619e78bbf578c$var$Lr;
const $834619e78bbf578c$var$Rr = {
    frame (e1, t, n, r) {
        let i = r || window, a = i.requestAnimationFrame((e1)=>{
            o(), t(e1);
        }), { unsubscribe: o } = (0, $1rqx5.kr)(e1.signal, `abort`, ()=>{
            o(), i.cancelAnimationFrame(a), n(new (0, $1rqx5.jn)(e1.signal.reason));
        }, !1);
    },
    frameAsync (e1, t) {
        return new Promise((n, r)=>{
            this.frame(e1, n, r, t);
        });
    },
    getImageData (e1, t = 0) {
        return this.getImageCanvasContext(e1).getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
    },
    getImageCanvasContext (e1) {
        let t;
        if ((0, $1rqx5.Ii)() && !(0, $1rqx5.Fi)()) t = new OffscreenCanvas(e1.width, e1.height).getContext(`2d`, {
            willReadFrequently: !0
        });
        else {
            let n = window.document.createElement(`canvas`);
            n.width = e1.width, n.height = e1.height, t = n.getContext(`2d`, {
                willReadFrequently: !0
            });
        }
        if (!t) throw Error(`failed to create canvas 2d context`);
        return t.drawImage(e1, 0, 0, e1.width, e1.height), t;
    },
    resolveURL (e1) {
        return $834619e78bbf578c$var$Fr ||= document.createElement(`a`), $834619e78bbf578c$var$Fr.href = e1, $834619e78bbf578c$var$Fr.href;
    },
    get hardwareConcurrency () {
        return typeof navigator < `u` && navigator.hardwareConcurrency || 4;
    },
    get prefersReducedMotion () {
        return $834619e78bbf578c$var$Lr === void 0 ? matchMedia ? ($834619e78bbf578c$var$Ir ??= matchMedia(`(prefers-reduced-motion: reduce)`), $834619e78bbf578c$var$Ir.matches) : !1 : $834619e78bbf578c$var$Lr;
    },
    set prefersReducedMotion (e){
        $834619e78bbf578c$var$Lr = e;
    }
}, $834619e78bbf578c$var$zr = new class {
    constructor(){
        this._frozenAt = null;
    }
    getCurrentTime() {
        return this._frozenAt === null ? performance.now() : this._frozenAt;
    }
    setNow(e1) {
        this._frozenAt = e1;
    }
    restoreNow() {
        this._frozenAt = null;
    }
    isFrozen() {
        return this._frozenAt !== null;
    }
};
function $834619e78bbf578c$export$461939dd4422153() {
    return $834619e78bbf578c$var$zr.getCurrentTime();
}
function $834619e78bbf578c$export$6b09b4ca4892be7e(e1) {
    $834619e78bbf578c$var$zr.setNow(e1);
}
function $834619e78bbf578c$export$c893a3a0ea8f2422() {
    $834619e78bbf578c$var$zr.restoreNow();
}
function $834619e78bbf578c$export$b034adc12b1cc7ef() {
    return $834619e78bbf578c$var$zr.isFrozen();
}
const $834619e78bbf578c$var$Ur = /* @__PURE__ */ new Set(/* @__PURE__ */ `a.abbr.b.bdi.bdo.br.cite.code.del.div.em.i.img.ins.kbd.li.mark.ol.p.q.s.samp.small.span.strong.sub.sup.time.u.ul.var.wbr`.split(`.`)), $834619e78bbf578c$var$Wr = /* @__PURE__ */ new Set([
    `alt`,
    `class`,
    `datetime`,
    `dir`,
    `height`,
    `href`,
    `hreflang`,
    `lang`,
    `referrerpolicy`,
    `rel`,
    `role`,
    `src`,
    `target`,
    `title`,
    `translate`,
    `type`,
    `width`
]), $834619e78bbf578c$var$Gr = /* @__PURE__ */ new Set([
    `href`,
    `src`
]), $834619e78bbf578c$var$Kr = /* @__PURE__ */ new Set([
    `http:`,
    `https:`,
    `mailto:`
]);
let $834619e78bbf578c$var$qr;
function $834619e78bbf578c$var$Jr() {
    return $834619e78bbf578c$var$qr ??= {
        getAttribute: Element.prototype.getAttribute,
        getAttributeNames: Element.prototype.getAttributeNames,
        querySelectorAll: Element.prototype.querySelectorAll,
        remove: Element.prototype.remove,
        removeAttribute: Element.prototype.removeAttribute,
        localName: Object.getOwnPropertyDescriptor(Element.prototype, `localName`).get,
        namespaceURI: Object.getOwnPropertyDescriptor(Element.prototype, `namespaceURI`).get
    }, $834619e78bbf578c$var$qr;
}
var $834619e78bbf578c$var$G = class e1 {
    static{
        this.docStyle = typeof window < `u` && window.document?.documentElement.style;
    }
    static{
        this.selectProp = !e1.docStyle || `userSelect` in e1.docStyle ? `userSelect` : `webkitUserSelect`;
    }
    static create(e1, t, n) {
        let r = window.document.createElement(e1);
        return t !== void 0 && (r.className = t), n && n.appendChild(r), r;
    }
    static createNS(e1, t) {
        return window.document.createElementNS(e1, t);
    }
    static disableDrag() {
        e1.docStyle && e1.selectProp && (e1.userSelect = e1.docStyle[e1.selectProp], e1.docStyle[e1.selectProp] = `none`);
    }
    static enableDrag() {
        e1.docStyle && e1.selectProp && (e1.docStyle[e1.selectProp] = e1.userSelect);
    }
    static suppressClickInternal(t) {
        t.preventDefault(), t.stopPropagation(), window.removeEventListener(`click`, e1.suppressClickInternal, !0);
    }
    static suppressClick() {
        window.addEventListener(`click`, e1.suppressClickInternal, !0), window.setTimeout(()=>{
            window.removeEventListener(`click`, e1.suppressClickInternal, !0);
        }, 0);
    }
    static getScale(e1) {
        let t = e1.getBoundingClientRect();
        return {
            x: t.width / e1.offsetWidth || 1,
            y: t.height / e1.offsetHeight || 1,
            boundingClientRect: t
        };
    }
    static getPoint(e1, t, n) {
        let r = t.boundingClientRect;
        return new (0, $1rqx5.Li)((n.clientX - r.left) / t.x - e1.clientLeft, (n.clientY - r.top) / t.y - e1.clientTop);
    }
    static mousePos(t, n) {
        let r = e1.getScale(t);
        return e1.getPoint(t, r, n);
    }
    static touchPos(t, n) {
        let r = [], i = e1.getScale(t);
        for (let a of n)r.push(e1.getPoint(t, i, a));
        return r;
    }
    static sanitize(t) {
        let n = new DOMParser().parseFromString(t, `text/html`).body, { querySelectorAll: r, remove: i } = $834619e78bbf578c$var$Jr();
        for (let t of Array.from(r.call(n, `*`)))e1.isAllowedElement(t) ? e1.removeDisallowedAttributes(t) : i.call(t);
        let a = document.createDocumentFragment();
        return a.append(...n.childNodes), a;
    }
    static isAllowedElement(e1) {
        let { namespaceURI: t, localName: n } = $834619e78bbf578c$var$Jr();
        return t.call(e1) === `http://www.w3.org/1999/xhtml` && $834619e78bbf578c$var$Ur.has(n.call(e1));
    }
    static removeDisallowedAttributes(t) {
        let { getAttributeNames: n, getAttribute: r, removeAttribute: i } = $834619e78bbf578c$var$Jr();
        for (let a of n.call(t))e1.isAllowedAttribute(a, r.call(t, a)) || i.call(t, a);
    }
    static isAllowedAttribute(e1, t) {
        if (!$834619e78bbf578c$var$Wr.has(e1) && !e1.startsWith(`aria-`)) return !1;
        if (!$834619e78bbf578c$var$Gr.has(e1)) return !0;
        try {
            return $834619e78bbf578c$var$Kr.has(new URL(t, `https://maplibre.invalid/`).protocol);
        } catch  {
            return !1;
        }
    }
};
let $834619e78bbf578c$var$Yr;
(function(e1) {
    let t, n, r, i;
    e1.resetRequestQueue = ()=>{
        t = [], n = 0, r = 0, i = {};
    }, e1.addThrottleControl = (e1)=>{
        let t = r++;
        return i[t] = e1, t;
    }, e1.removeThrottleControl = (e1)=>{
        delete i[e1], u();
    };
    let a = ()=>{
        for (let e1 of Object.keys(i))if (i[e1]()) return !0;
        return !1;
    };
    async function s(e1, t, n, r, i = !0, a) {
        let o = await e1.transformRequest(t, n);
        return (0, $1rqx5.Nn)(r.signal), $834619e78bbf578c$var$Yr.getImage(o, r, i, a);
    }
    e1.transformAndGetImage = s, e1.getImage = (e1, n, r = !0, i)=>new Promise((a, o)=>{
            e1.headers ||= {}, e1.headers.accept = `image/webp,*/*`, (0, $1rqx5.er)(e1, {
                type: `image`
            });
            let s = {
                abortController: n,
                requestParameters: e1,
                supportImageRefresh: r,
                imageBitmapOptions: i,
                state: `queued`,
                onError: (e1)=>{
                    o(e1);
                },
                onSuccess: (e1)=>{
                    a(e1);
                }
            };
            t.push(s), u();
        });
    let c = (e1, t)=>typeof createImageBitmap == `function` ? (0, $1rqx5.Rn)(e1, t) : (0, $1rqx5.Ln)(e1), l = async (e1)=>{
        e1.state = `running`;
        let { requestParameters: t, supportImageRefresh: r, imageBitmapOptions: i, onError: a, onSuccess: o, abortController: s } = e1, l = r === !1 && !i && !(0, $1rqx5.pr)(self) && !(0, $1rqx5.On)(t.url) && (!t.headers || Object.keys(t.headers).reduce((e1, t)=>e1 && t === `accept`, !0));
        n++;
        let f = l ? d(t, s) : (0, $1rqx5.Tn)(t, s);
        try {
            let t = await f;
            delete e1.abortController, e1.state = `completed`, t.data instanceof HTMLImageElement || (0, $1rqx5.cr)(t.data) ? o(t) : !t.data || t.data.byteLength === 0 ? o({
                data: null,
                cacheControl: t.cacheControl,
                expires: t.expires
            }) : o({
                data: await c(t.data, i),
                cacheControl: t.cacheControl,
                expires: t.expires
            });
        } catch (t) {
            delete e1.abortController, a((0, $1rqx5.Qn)(t));
        } finally{
            n--, u();
        }
    }, u = ()=>{
        let e1 = a() ? (0, $1rqx5.An).MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : (0, $1rqx5.An).MAX_PARALLEL_IMAGE_REQUESTS;
        for(let r = n; r < e1 && t.length > 0; r++){
            let e1 = t.shift();
            if (e1.abortController.signal.aborted) {
                r--;
                continue;
            }
            l(e1);
        }
    }, d = (e1, t)=>new Promise((n, r)=>{
            let i = new Image, a = e1.url, o = e1.credentials;
            o && o === `include` ? i.crossOrigin = `use-credentials` : (o && o === `same-origin` || !(0, $1rqx5.En)(a)) && (i.crossOrigin = `anonymous`), t.signal.addEventListener(`abort`, ()=>{
                i.src = ``, r(new (0, $1rqx5.jn)(t.signal.reason));
            }), i.fetchPriority = `high`, i.onload = ()=>{
                i.onerror = i.onload = null, n({
                    data: i
                });
            }, i.onerror = ()=>{
                i.onerror = i.onload = null, !t.signal.aborted && r(/* @__PURE__ */ Error(`Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            }, i.src = a;
        });
})($834619e78bbf578c$var$Yr ||= {}), $834619e78bbf578c$var$Yr.resetRequestQueue();
var $834619e78bbf578c$var$Xr = class {
    constructor(e1){
        this._transformRequestFn = e1 ?? null;
    }
    transformRequest(e1, t) {
        return this._transformRequestFn && this._transformRequestFn(e1, t) || {
            url: e1
        };
    }
    setTransformRequest(e1) {
        this._transformRequestFn = e1;
    }
}, $834619e78bbf578c$export$fc21b96c04d10d16 = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$534b7a2acb0e16da = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
}, $834619e78bbf578c$export$444e55cd0e2f4f3a = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`style.load`, e1);
    }
}, $834619e78bbf578c$export$49025a11e3fe5bd0 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = `style`;
    }
}, $834619e78bbf578c$export$ae09c661b7a299b2 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = `source`;
    }
}, $834619e78bbf578c$export$83f023c8e5acf676 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, n, r = {}){
        n = n instanceof MouseEvent ? n : new MouseEvent(e1, n);
        let i = $834619e78bbf578c$var$G.mousePos(t.getCanvas(), n), a = t.unproject(i);
        super(e1, (0, $1rqx5.er)({
            point: i,
            lngLat: a,
            originalEvent: n
        }, r)), this._defaultPrevented = !1, this.target = t;
    }
}, $834619e78bbf578c$export$706699378fec3ddd = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, n){
        let r = e1 === `touchend` ? n.changedTouches : n.touches, i = $834619e78bbf578c$var$G.touchPos(t.getCanvasContainer(), r), a = i.map((e1)=>t.unproject(e1)), o = i.reduce((e1, t, n, r)=>e1.add(t.div(r.length)), new (0, $1rqx5.Li)(0, 0)), s = t.unproject(o);
        super(e1, {
            points: i,
            point: o,
            lngLats: a,
            lngLat: s,
            originalEvent: n
        }), this._defaultPrevented = !1;
    }
}, $834619e78bbf578c$export$10870e40d23509f = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t){
        super(`wheel`, {
            originalEvent: t
        }), this._defaultPrevented = !1;
    }
}, $834619e78bbf578c$export$702e4d7a848278fa = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
}, $834619e78bbf578c$export$da1f2ab236a92d66 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`terrain`, e1);
    }
}, $834619e78bbf578c$export$f966cee55553279 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`projectiontransition`, e1);
    }
}, $834619e78bbf578c$export$3238995171e25bd5 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
}, $834619e78bbf578c$export$14816c15d485a7b9 = class extends $834619e78bbf578c$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`styleimagemissing`, e1);
    }
};
function $834619e78bbf578c$var$ci(e1, t) {
    let n = {};
    for(let t in e1)t !== `ref` && (n[t] = e1[t]);
    return (0, $1rqx5.mn).forEach((e1)=>{
        e1 in t && (n[e1] = t[e1]);
    }), n;
}
function $834619e78bbf578c$var$li(e1) {
    e1 = e1.slice();
    let t = Object.create(null);
    for(let n = 0; n < e1.length; n++)t[e1[n].id] = e1[n];
    for(let n = 0; n < e1.length; n++)`ref` in e1[n] && (e1[n] = $834619e78bbf578c$var$ci(e1[n], t[e1[n].ref]));
    return e1;
}
function $834619e78bbf578c$var$J(e1, t) {
    if (Array.isArray(e1)) {
        if (!Array.isArray(t) || e1.length !== t.length) return !1;
        for(let n = 0; n < e1.length; n++)if (!$834619e78bbf578c$var$J(e1[n], t[n])) return !1;
        return !0;
    }
    if (typeof e1 == `object` && e1 && t !== null) {
        if (typeof t != `object` || Object.keys(e1).length !== Object.keys(t).length) return !1;
        for(let n in e1)if (!$834619e78bbf578c$var$J(e1[n], t[n])) return !1;
        return !0;
    }
    return e1 === t;
}
function $834619e78bbf578c$var$ui(e1, t) {
    e1.push(t);
}
function $834619e78bbf578c$var$di(e1, t, n) {
    $834619e78bbf578c$var$ui(n, {
        command: `addSource`,
        args: [
            e1,
            t[e1]
        ]
    });
}
function $834619e78bbf578c$var$fi(e1, t, n) {
    $834619e78bbf578c$var$ui(t, {
        command: `removeSource`,
        args: [
            e1
        ]
    }), n[e1] = !0;
}
function $834619e78bbf578c$var$pi(e1, t, n, r) {
    $834619e78bbf578c$var$fi(e1, n, r), $834619e78bbf578c$var$di(e1, t, n);
}
function $834619e78bbf578c$var$mi(e1, t, n) {
    let r;
    for(r in e1[n])if (Object.prototype.hasOwnProperty.call(e1[n], r) && r !== `data` && !$834619e78bbf578c$var$J(e1[n][r], t[n][r])) return !1;
    for(r in t[n])if (Object.prototype.hasOwnProperty.call(t[n], r) && r !== `data` && !$834619e78bbf578c$var$J(e1[n][r], t[n][r])) return !1;
    return !0;
}
function $834619e78bbf578c$var$hi(e1, t, n, r) {
    e1 ||= {}, t ||= {};
    let i;
    for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t, i) || $834619e78bbf578c$var$fi(i, n, r));
    for(i in t)Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e1, i) ? $834619e78bbf578c$var$J(e1[i], t[i]) || (e1[i].type === `geojson` && t[i].type === `geojson` && $834619e78bbf578c$var$mi(e1, t, i) ? $834619e78bbf578c$var$ui(n, {
        command: `setGeoJSONSourceData`,
        args: [
            i,
            t[i].data
        ]
    }) : $834619e78bbf578c$var$pi(i, t, n, r)) : $834619e78bbf578c$var$di(i, t, n));
}
function $834619e78bbf578c$var$gi(e1, t, n, r, i) {
    $834619e78bbf578c$var$ui(t, {
        command: i,
        args: [
            n,
            r,
            e1[r]
        ]
    });
}
function $834619e78bbf578c$var$_i(e1, t, n, r, i) {
    e1 ||= {}, t ||= {};
    for(let a in e1)Object.prototype.hasOwnProperty.call(e1, a) && ($834619e78bbf578c$var$J(e1[a], t[a]) || $834619e78bbf578c$var$gi(t, n, r, a, i));
    for(let a in t)Object.prototype.hasOwnProperty.call(t, a) && !Object.prototype.hasOwnProperty.call(e1, a) && ($834619e78bbf578c$var$J(e1[a], t[a]) || $834619e78bbf578c$var$gi(t, n, r, a, i));
}
function $834619e78bbf578c$var$vi(e1) {
    return e1.id;
}
function $834619e78bbf578c$var$yi(e1, t) {
    return e1[t.id] = t, e1;
}
function $834619e78bbf578c$var$bi(e1, t, n) {
    e1 ||= [], t ||= [];
    let r = e1.map($834619e78bbf578c$var$vi), i = t.map($834619e78bbf578c$var$vi), a = e1.reduce($834619e78bbf578c$var$yi, {}), o = t.reduce($834619e78bbf578c$var$yi, {}), s = r.slice(), c = Object.create(null), l, u, d, f, p;
    for(let e1 = 0, t = 0; e1 < r.length; e1++)l = r[e1], Object.prototype.hasOwnProperty.call(o, l) ? t++ : ($834619e78bbf578c$var$ui(n, {
        command: `removeLayer`,
        args: [
            l
        ]
    }), s.splice(s.indexOf(l, t), 1));
    for(let e1 = 0, t = 0; e1 < i.length; e1++)l = i[i.length - 1 - e1], s[s.length - 1 - e1] !== l && (Object.prototype.hasOwnProperty.call(a, l) ? ($834619e78bbf578c$var$ui(n, {
        command: `removeLayer`,
        args: [
            l
        ]
    }), s.splice(s.lastIndexOf(l, s.length - t), 1)) : t++, f = s[s.length - e1], $834619e78bbf578c$var$ui(n, {
        command: `addLayer`,
        args: [
            o[l],
            f
        ]
    }), s.splice(s.length - e1, 0, l), c[l] = !0);
    for(let e1 = 0; e1 < i.length; e1++)if (l = i[e1], u = a[l], d = o[l], !(c[l] || $834619e78bbf578c$var$J(u, d))) {
        if (!$834619e78bbf578c$var$J(u.source, d.source) || !$834619e78bbf578c$var$J(u[`source-layer`], d[`source-layer`]) || !$834619e78bbf578c$var$J(u.type, d.type)) {
            $834619e78bbf578c$var$ui(n, {
                command: `removeLayer`,
                args: [
                    l
                ]
            }), f = s[s.lastIndexOf(l) + 1], $834619e78bbf578c$var$ui(n, {
                command: `addLayer`,
                args: [
                    d,
                    f
                ]
            });
            continue;
        }
        for(p in $834619e78bbf578c$var$_i(u.layout, d.layout, n, l, `setLayoutProperty`), $834619e78bbf578c$var$_i(u.paint, d.paint, n, l, `setPaintProperty`), $834619e78bbf578c$var$J(u.filter, d.filter) || $834619e78bbf578c$var$ui(n, {
            command: `setFilter`,
            args: [
                l,
                d.filter
            ]
        }), (!$834619e78bbf578c$var$J(u.minzoom, d.minzoom) || !$834619e78bbf578c$var$J(u.maxzoom, d.maxzoom)) && $834619e78bbf578c$var$ui(n, {
            command: `setLayerZoomRange`,
            args: [
                l,
                d.minzoom,
                d.maxzoom
            ]
        }), u)Object.prototype.hasOwnProperty.call(u, p) && p !== `layout` && p !== `paint` && p !== `filter` && p !== `metadata` && p !== `minzoom` && p !== `maxzoom` && (p.indexOf(`paint.`) === 0 ? $834619e78bbf578c$var$_i(u[p], d[p], n, l, `setPaintProperty`) : $834619e78bbf578c$var$J(u[p], d[p]) || $834619e78bbf578c$var$ui(n, {
            command: `setLayerProperty`,
            args: [
                l,
                p,
                d[p]
            ]
        }));
        for(p in d)Object.prototype.hasOwnProperty.call(d, p) && !Object.prototype.hasOwnProperty.call(u, p) && p !== `layout` && p !== `paint` && p !== `filter` && p !== `metadata` && p !== `minzoom` && p !== `maxzoom` && (p.indexOf(`paint.`) === 0 ? $834619e78bbf578c$var$_i(u[p], d[p], n, l, `setPaintProperty`) : $834619e78bbf578c$var$J(u[p], d[p]) || $834619e78bbf578c$var$ui(n, {
            command: `setLayerProperty`,
            args: [
                l,
                p,
                d[p]
            ]
        }));
    }
}
function $834619e78bbf578c$var$xi(e1, t) {
    if (!e1) return [
        {
            command: `setStyle`,
            args: [
                t
            ]
        }
    ];
    let n = [];
    try {
        if (!$834619e78bbf578c$var$J(e1.version, t.version)) return [
            {
                command: `setStyle`,
                args: [
                    t
                ]
            }
        ];
        $834619e78bbf578c$var$J(e1.center, t.center) || n.push({
            command: `setCenter`,
            args: [
                t.center
            ]
        }), $834619e78bbf578c$var$J(e1.state, t.state) || n.push({
            command: `setGlobalState`,
            args: [
                t.state
            ]
        }), $834619e78bbf578c$var$J(e1.centerAltitude, t.centerAltitude) || n.push({
            command: `setCenterAltitude`,
            args: [
                t.centerAltitude
            ]
        }), $834619e78bbf578c$var$J(e1.zoom, t.zoom) || n.push({
            command: `setZoom`,
            args: [
                t.zoom
            ]
        }), $834619e78bbf578c$var$J(e1.bearing, t.bearing) || n.push({
            command: `setBearing`,
            args: [
                t.bearing
            ]
        }), $834619e78bbf578c$var$J(e1.pitch, t.pitch) || n.push({
            command: `setPitch`,
            args: [
                t.pitch
            ]
        }), $834619e78bbf578c$var$J(e1.roll, t.roll) || n.push({
            command: `setRoll`,
            args: [
                t.roll
            ]
        }), $834619e78bbf578c$var$J(e1.sprite, t.sprite) || n.push({
            command: `setSprite`,
            args: [
                t.sprite
            ]
        }), $834619e78bbf578c$var$J(e1.glyphs, t.glyphs) || n.push({
            command: `setGlyphs`,
            args: [
                t.glyphs
            ]
        }), $834619e78bbf578c$var$J(e1[`font-faces`], t[`font-faces`]) || n.push({
            command: `setFontFaces`,
            args: [
                t[`font-faces`]
            ]
        }), $834619e78bbf578c$var$J(e1.transition, t.transition) || n.push({
            command: `setTransition`,
            args: [
                t.transition
            ]
        }), $834619e78bbf578c$var$J(e1.light, t.light) || n.push({
            command: `setLight`,
            args: [
                t.light
            ]
        });
        let r = !$834619e78bbf578c$var$J(e1.terrain, t.terrain);
        r && !t.terrain && n.push({
            command: `setTerrain`,
            args: [
                void 0
            ]
        }), $834619e78bbf578c$var$J(e1.sky, t.sky) || n.push({
            command: `setSky`,
            args: [
                t.sky
            ]
        }), $834619e78bbf578c$var$J(e1.projection, t.projection) || n.push({
            command: `setProjection`,
            args: [
                t.projection
            ]
        });
        let i = {}, a = [];
        $834619e78bbf578c$var$hi(e1.sources, t.sources, a, i);
        let o = [];
        e1.layers && e1.layers.forEach((e1)=>{
            `source` in e1 && i[e1.source] ? n.push({
                command: `removeLayer`,
                args: [
                    e1.id
                ]
            }) : o.push(e1);
        }), n = n.concat(a), $834619e78bbf578c$var$bi(o, t.layers, n), r && t.terrain && n.push({
            command: `setTerrain`,
            args: [
                t.terrain
            ]
        });
    } catch (e1) {
        console.warn(`Unable to compute style diff:`, e1), n = [
            {
                command: `setStyle`,
                args: [
                    t
                ]
            }
        ];
    }
    return n;
}
function $834619e78bbf578c$var$Si() {
    let e1 = {}, t = (0, $1rqx5.hn).$version;
    for(let n in (0, $1rqx5.hn).$root){
        let r = (0, $1rqx5.hn).$root[n];
        if (r.required) {
            let i = null;
            i = n === `version` ? t : r.type === `array` ? [] : {}, i != null && (e1[n] = i);
        }
    }
    return e1;
}
function $834619e78bbf578c$var$Ci(e1) {
    let t = [];
    if (typeof e1 == `string`) t.push({
        id: `default`,
        url: e1
    });
    else if (e1 && e1.length > 0) {
        let n = [];
        for (let { id: r, url: i } of e1){
            let e1 = `${r}${i}`;
            n.includes(e1) || (n.push(e1), t.push({
                id: r,
                url: i
            }));
        }
    }
    return t;
}
function $834619e78bbf578c$var$wi(e1, t, n) {
    try {
        let r = new URL(e1);
        return r.pathname += `${t}${n}`, r.toString();
    } catch  {
        throw Error(`Invalid sprite URL "${e1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
    }
}
async function $834619e78bbf578c$var$Ti(e1, t, n, r) {
    let i = $834619e78bbf578c$var$Ci(e1), a = n > 1 ? `@2x` : ``, o = {}, s = {};
    for (let { id: e1, url: n } of i){
        let i = await t.transformRequest($834619e78bbf578c$var$wi(n, a, `.json`), `SpriteJSON`);
        o[e1] = (0, $1rqx5.Sn)(i, r);
        let c = await t.transformRequest($834619e78bbf578c$var$wi(n, a, `.png`), `SpriteImage`);
        s[e1] = $834619e78bbf578c$var$Yr.getImage(c, r);
    }
    return await Promise.all([
        ...Object.values(o),
        ...Object.values(s)
    ]), $834619e78bbf578c$var$Ei(o, s);
}
async function $834619e78bbf578c$var$Ei(e1, t) {
    let n = {};
    for(let r in e1){
        n[r] = {};
        let i = (await t[r]).data;
        if (!i) throw Error(`Could not load sprite image for ${r}: the response is empty`);
        let a = $834619e78bbf578c$var$Rr.getImageCanvasContext(i), o = (await e1[r]).data;
        for(let e1 in o){
            let { width: t, height: i, x: s, y: c, sdf: l, pixelRatio: u, stretchX: d, stretchY: f, content: p, textFitWidth: m, textFitHeight: h } = o[e1], g = {
                width: t,
                height: i,
                x: s,
                y: c,
                context: a
            };
            n[r][e1] = {
                data: null,
                pixelRatio: u,
                sdf: l,
                stretchX: d,
                stretchY: f,
                content: p,
                textFitWidth: m,
                textFitHeight: h,
                spriteData: g
            };
        }
    }
    return n;
}
var $834619e78bbf578c$var$Di = class extends (0, $1rqx5.vn) {
    constructor(){
        super(), this.images = {}, this.updateVersion = 0, this.loaded = !1, this.requestors = [], this.missingImageResolver = null, this._spriteImagesIds = {}, this._imagesIds = null, this._renderCallbacksDispatchedThisFrame = {};
    }
    destroy() {
        for (let e1 of Object.keys(this.images))this.removeImage(e1);
        this._spriteImagesIds = {};
    }
    isLoaded() {
        return this.loaded;
    }
    setLoaded(e1) {
        if (this.loaded !== e1 && (this.loaded = e1, e1)) {
            for (let { ids: e1, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e1));
            this.requestors = [];
        }
    }
    getImage(e1) {
        let t = this.images[e1];
        if (t && !t.data && t.spriteData) {
            let e1 = t.spriteData;
            t.data = new (0, $1rqx5.Dt)({
                width: e1.width,
                height: e1.height
            }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), t.spriteData = null;
        }
        return t;
    }
    addImage(e1, t) {
        if (this.images[e1]) throw Error(`Image id ${e1} already exist, use updateImage instead`);
        this._validate(e1, t) && (this.images[e1] = t, this._imagesIds = null, t.isWebGLImage && this.updateImage(e1, t, !1));
    }
    _validate(e1, t) {
        let n = !0, r = t.data || t.spriteData;
        return this._validateStretch(t.stretchX, r?.width) || (this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Image "${e1}" has invalid "stretchX" value`))), n = !1), this._validateStretch(t.stretchY, r?.height) || (this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Image "${e1}" has invalid "stretchY" value`))), n = !1), this._validateContent(t.content, t) || (this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Image "${e1}" has invalid "content" value`))), n = !1), n;
    }
    _validateStretch(e1, t) {
        if (!e1) return !0;
        let n = 0;
        for (let r of e1){
            if (r[0] < n || r[1] < r[0] || t < r[1]) return !1;
            n = r[1];
        }
        return !0;
    }
    _validateContent(e1, t) {
        if (!e1) return !0;
        if (e1.length !== 4) return !1;
        let n = t.spriteData, r = n?.width || t.data.width, i = n?.height || t.data.height;
        return e1[0] < 0 || r < e1[0] || e1[1] < 0 || i < e1[1] || e1[2] < 0 || r < e1[2] || e1[3] < 0 || i < e1[3] || e1[2] < e1[0] ? !1 : e1[3] >= e1[1];
    }
    updateImage(e1, t, n = !0) {
        let r = this.images[e1];
        if (n) {
            let e1 = r.data || r.spriteData;
            if (e1.width !== t.data.width || e1.height !== t.data.height) throw Error(`size mismatch between old image (${e1.width}x${e1.height}) and new image (${t.data.width}x${t.data.height}).`);
        }
        t.version = (r.version ?? 0) + 1, this.images[e1] = t, this.updateVersion++;
    }
    removeImage(e1) {
        let t = this.images[e1];
        t && (delete this.images[e1], this._imagesIds = null, t.userImage?.onRemove && t.userImage.onRemove());
    }
    listImages() {
        return this._imagesIds ??= Object.keys(this.images), this._imagesIds;
    }
    _getSpriteImageId(e1, t) {
        return e1 === "default" ? t : `${e1}:${t}`;
    }
    setSpriteImages(e1, t) {
        let n = this._spriteImagesIds[e1] ?? [], r = [];
        for(let n in t){
            let i = this._getSpriteImageId(e1, n);
            r.push(i), i in this.images ? this.updateImage(i, t[n], !1) : this.addImage(i, t[n]);
        }
        let i = new Set(r), a = n.filter((e1)=>!i.has(e1));
        for (let e1 of a)this.removeImage(e1);
        return this._spriteImagesIds[e1] = r, {
            loaded: r,
            removed: a
        };
    }
    removeSpriteImages(e1) {
        let t = this._spriteImagesIds[e1] ?? [];
        for (let e1 of t)this.removeImage(e1);
        return delete this._spriteImagesIds[e1], t;
    }
    removeAllSpriteImages() {
        let e1 = Object.values(this._spriteImagesIds).flat();
        for (let t of e1)this.removeImage(t);
        return this._spriteImagesIds = {}, e1;
    }
    setMissingImageResolver(e1) {
        this.missingImageResolver = e1;
    }
    getImages(e1) {
        return new Promise((t, n)=>{
            let r = !0;
            if (!this.isLoaded()) for (let t of e1)this.images[t] || (r = !1);
            this.isLoaded() || r ? t(this._getImagesForIds(e1)) : this.requestors.push({
                ids: e1,
                promiseResolve: t
            });
        });
    }
    async _getImagesForIds(e1) {
        let t = new Set(e1.filter((e1)=>!this.getImage(e1))), n = this.missingImageResolver;
        n && await Promise.allSettled(Array.from(t, (e1)=>n(e1)));
        let r = {};
        for (let n of e1){
            let e1 = this.getImage(n);
            e1 && (t.delete(n), r[n] = {
                data: e1.data.clone(),
                pixelRatio: e1.pixelRatio,
                sdf: e1.sdf,
                version: e1.version,
                stretchX: e1.stretchX,
                stretchY: e1.stretchY,
                content: e1.content,
                textFitWidth: e1.textFitWidth,
                textFitHeight: e1.textFitHeight,
                hasRenderCallback: !!e1.userImage?.render,
                isWebGLImage: e1.isWebGLImage
            });
        }
        for (let e1 of t)this.fire(new $834619e78bbf578c$export$14816c15d485a7b9({
            id: e1
        })), (0, $1rqx5.Nr)(`Image "${e1}" could not be loaded. Please make sure you have added the image before it is needed with map.addImage(), resolved it with map.setMissingStyleImageResolver(), or included it in a "sprite" property in your style.`);
        return r;
    }
    beginFrame() {
        this._renderCallbacksDispatchedThisFrame = {};
    }
    dispatchRenderCallbacks(e1) {
        for (let t of e1){
            if (this._renderCallbacksDispatchedThisFrame[t]) continue;
            this._renderCallbacksDispatchedThisFrame[t] = !0;
            let e1 = this.getImage(t);
            e1 || (0, $1rqx5.Nr)(`Image with ID: "${t}" was not found`), (0, $1rqx5.L)(e1) && this.updateImage(t, e1);
        }
    }
    cloneImages() {
        let e1 = {};
        for(let t in this.images){
            let n = this.images[t];
            e1[t] = {
                ...n,
                data: n.data ? n.data.clone() : null
            };
        }
        return e1;
    }
}, $834619e78bbf578c$var$Oi = class {
    constructor(e1){
        this._imageManager = e1, this._entries = {}, this._image = new (0, $1rqx5.Dt)({
            width: 1,
            height: 1
        }), this._dirty = !0;
    }
    destroy() {
        this._texture &&= (this._texture.destroy(), null), this._entries = {}, this._image = new (0, $1rqx5.Dt)({
            width: 1,
            height: 1
        }), this._dirty = !0;
    }
    getPixelSize() {
        let { width: e1, height: t } = this._image;
        return {
            width: e1,
            height: t
        };
    }
    getPattern(e1) {
        let t = this._imageManager.getImage(e1);
        if (!t) return null;
        let n = this._entries[e1];
        if (n?.image !== t) {
            let n = {
                w: t.data.width + 2,
                h: t.data.height + 2,
                x: 0,
                y: 0
            };
            this._entries[e1] = {
                bin: n,
                position: new (0, $1rqx5.P)(n, t),
                image: t
            };
        } else if (n.position.version !== t.version) n.position.version = t.version;
        else return n.position;
        return this._update(), this._entries[e1].position;
    }
    bind(e1) {
        let t = e1.gl;
        this._texture ? this._dirty &&= (this._texture.update(this._image), !1) : (this._texture = new (0, $1rqx5.xt)(e1, this._image, t.RGBA), this._dirty = !1), this._texture.bind(t.LINEAR, t.CLAMP_TO_EDGE);
    }
    _update() {
        for(let e1 in this._entries)this._imageManager.getImage(e1) || delete this._entries[e1];
        let e1 = [];
        for(let t in this._entries)e1.push(this._entries[t].bin);
        let { w: t, h: n } = (0, $1rqx5.F)(e1), r = this._image;
        r.resize({
            width: t || 1,
            height: n || 1
        });
        for(let e1 in this._entries){
            let { bin: t } = this._entries[e1], n = t.x + 1, i = t.y + 1, a = this._entries[e1].image.data, o = a.width, s = a.height;
            (0, $1rqx5.Dt).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n,
                y: i
            }, {
                width: o,
                height: s
            }), (0, $1rqx5.Dt).copy(a, r, {
                x: 0,
                y: s - 1
            }, {
                x: n,
                y: i - 1
            }, {
                width: o,
                height: 1
            }), (0, $1rqx5.Dt).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n,
                y: i + s
            }, {
                width: o,
                height: 1
            }), (0, $1rqx5.Dt).copy(a, r, {
                x: o - 1,
                y: 0
            }, {
                x: n - 1,
                y: i
            }, {
                width: 1,
                height: s
            }), (0, $1rqx5.Dt).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n + o,
                y: i
            }, {
                width: 1,
                height: s
            });
        }
        this._dirty = !0;
    }
};
const $834619e78bbf578c$var$ki = 1114111, $834619e78bbf578c$var$Ai = {
    start: 0,
    end: $834619e78bbf578c$var$ki
};
let $834619e78bbf578c$var$ji = 0;
function $834619e78bbf578c$var$Mi(e1) {
    let t = /^u\+([0-9a-f]*)(\?+)$/i.exec(e1);
    if (t) {
        let [, e1, n] = t;
        return e1.length + n.length > 6 ? null : $834619e78bbf578c$var$Ni(parseInt(`${e1}${`0`.repeat(n.length)}`, 16), parseInt(`${e1}${`f`.repeat(n.length)}`, 16));
    }
    let n = /^u\+([0-9a-f]{1,6})(?:-([0-9a-f]{1,6}))?$/i.exec(e1);
    if (!n) return null;
    let r = parseInt(n[1], 16);
    return $834619e78bbf578c$var$Ni(r, n[2] === void 0 ? r : parseInt(n[2], 16));
}
function $834619e78bbf578c$var$Ni(e1, t) {
    return e1 > t || e1 > $834619e78bbf578c$var$ki ? null : {
        start: e1,
        end: Math.min(t, $834619e78bbf578c$var$ki)
    };
}
function $834619e78bbf578c$var$Pi(e1, t) {
    return e1.ranges.some(({ start: e1, end: n })=>t >= e1 && t <= n);
}
var $834619e78bbf578c$var$Fi = class {
    constructor(e1){
        this.requestManager = e1, this._faces = {}, this._registered = /* @__PURE__ */ new Set;
    }
    setFontFaces(e1) {
        this._unregisterAll(), this._faces = {};
        for (let [t, n] of Object.entries(e1 ?? {})){
            let e1 = Array.isArray(n) ? n : [
                n
            ];
            this._faces[t] = e1.map((e1)=>this._declareFontFace(t, e1)).filter((e1)=>e1 !== null);
        }
    }
    hasFontFaces() {
        return Object.keys(this._faces).length > 0;
    }
    async getFontFamily(e1, t) {
        for (let n of e1.split(`,`))for (let e1 of this._faces[n.trim()] ?? [])if ($834619e78bbf578c$var$Pi(e1, t) && (e1.loaded ??= this._loadFontFace(e1), await e1.loaded)) return e1.family;
        return null;
    }
    _declareFontFace(e1, t) {
        let n = typeof t == `string` ? {
            url: t
        } : t;
        if (typeof n?.url != `string`) return (0, $1rqx5.Nr)(`Ignoring the font face declared for "${e1}": it has no URL.`), null;
        let r = `maplibre-gl-font-face-${$834619e78bbf578c$var$ji++}`, i = n[`unicode-range`];
        if (!i?.length) return {
            url: n.url,
            ranges: [
                $834619e78bbf578c$var$Ai
            ],
            family: r
        };
        let a = [];
        for (let e1 of i){
            let t = $834619e78bbf578c$var$Mi(e1);
            if (!t) {
                (0, $1rqx5.Nr)(`Ignoring the unicode range "${e1}" of the font face at ${n.url}: it is not a valid range.`);
                continue;
            }
            a.push(t);
        }
        return a.length ? {
            url: n.url,
            ranges: a,
            family: r
        } : null;
    }
    async _loadFontFace(e1) {
        if (typeof FontFace > `u` || typeof document > `u` || !document.fonts) return (0, $1rqx5.Nr)(`Ignoring the font face at ${e1.url}: this environment has no CSS Font Loading API.`), !1;
        let t;
        try {
            return t = new FontFace(e1.family, await this._downloadFontFile(e1.url)), Object.values(this._faces).some((t)=>t.includes(e1)) ? (document.fonts.add(t), this._registered.add(t), await t.load(), !0) : !1;
        } catch (n) {
            return t && this._unregister(t), (0, $1rqx5.Nr)(`Ignoring the font face at ${e1.url}: ${(0, $1rqx5.Qn)(n).message}`), !1;
        }
    }
    async _downloadFontFile(e1) {
        let t = await this.requestManager.transformRequest(e1, `Glyphs`), n = await (0, $1rqx5.xn)(t, new AbortController);
        if (!n?.data) throw Error(`the response was empty for the font file at ${e1}`);
        return n.data;
    }
    _unregister(e1) {
        document.fonts?.delete(e1), this._registered.delete(e1);
    }
    _unregisterAll() {
        for (let e1 of this._registered)document.fonts?.delete(e1);
        this._registered.clear();
    }
    destroy() {
        this._unregisterAll(), this._faces = {};
    }
};
const $834619e78bbf578c$var$Ii = 0x56bc75e2d63100000, $834619e78bbf578c$var$Li = /* @__PURE__ */ new Float64Array(256);
for(let e1 = 0; e1 < 256; e1++){
    let t = .5 - (e1 / 255) ** (1 / 2.2);
    $834619e78bbf578c$var$Li[e1] = t * Math.abs(t);
}
$834619e78bbf578c$var$Li[255] = -100000000000000000000;
var $834619e78bbf578c$var$Ri = class {
    constructor({ fontSize: e1 = 24, buffer: t = 3, radius: n = 8, cutoff: r = .25, fontFamily: i = `sans-serif`, fontWeight: a = `normal`, fontStyle: o = `normal`, lang: s = null } = {}){
        this.buffer = t, this.radius = n, this.cutoff = r, this.lang = s;
        let c = this.size = e1 + t * 4, l = this._createCanvas(c), u = this.ctx = l.getContext(`2d`, {
            willReadFrequently: !0
        });
        u.font = `${o} ${a} ${e1}px ${i}`, u.textBaseline = `alphabetic`, u.textAlign = `left`, u.fillStyle = `black`, this.gridOuter = new Float64Array(c * c), this.gridInner = new Float64Array(c * c), this.f = new Float64Array(c), this.z = new Float64Array(c + 1), this.v = new Uint16Array(c);
    }
    _createCanvas(e1) {
        if (typeof OffscreenCanvas < `u`) return new OffscreenCanvas(e1, e1);
        let t = document.createElement(`canvas`);
        return t.width = t.height = e1, t;
    }
    draw(e1) {
        let { width: t, actualBoundingBoxAscent: n, actualBoundingBoxDescent: r, actualBoundingBoxLeft: i, actualBoundingBoxRight: a } = this.ctx.measureText(e1), o = Math.ceil(n), s = Math.floor(-i), c = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a) - s)), l = Math.max(0, Math.min(this.size - this.buffer, o + Math.ceil(r))), u = c + 2 * this.buffer, d = l + 2 * this.buffer, f = Math.max(u * d, 0), p = new Uint8ClampedArray(f), m = {
            data: p,
            width: u,
            height: d,
            glyphWidth: c,
            glyphHeight: l,
            glyphTop: o,
            glyphLeft: s,
            glyphAdvance: t
        };
        if (c === 0 || l === 0) return m;
        let { ctx: h, buffer: g, gridInner: _, gridOuter: v } = this;
        this.lang && (h.lang = this.lang), h.clearRect(g, g, c, l), h.fillText(e1, g - s, g + o);
        let y = h.getImageData(g, g, c, l);
        v.fill($834619e78bbf578c$var$Ii, 0, f), _.fill(0, 0, f);
        let b = 3;
        for(let e1 = 0; e1 < l; e1++){
            let t = (e1 + g) * u + g;
            for(let e1 = 0; e1 < c; e1++, b += 4, t++){
                let e1 = y.data[b];
                if (e1 === 0) continue;
                let n = $834619e78bbf578c$var$Li[e1];
                v[t] = Math.max(0, n), _[t] = Math.max(0, -n);
            }
        }
        $834619e78bbf578c$var$zi(v, 0, 0, u, d, u, this.f, this.v, this.z);
        let x = Math.min(g, 1);
        $834619e78bbf578c$var$zi(_, g - x, g - x, c + 2 * x, l + 2 * x, u, this.f, this.v, this.z);
        let S = 255 / this.radius, C = 255 * (1 - this.cutoff);
        for(let e1 = 0; e1 < f; e1++){
            let t = Math.sqrt(v[e1]) - Math.sqrt(_[e1]);
            p[e1] = Math.round(C - S * t);
        }
        return m;
    }
};
function $834619e78bbf578c$var$zi(e1, t, n, r, i, a, o, s, c) {
    for(let l = t; l < t + r; l++)$834619e78bbf578c$var$Bi(e1, n * a + l, a, i, o, s, c);
    for(let l = n; l < n + i; l++)$834619e78bbf578c$var$Bi(e1, l * a + t, 1, r, o, s, c);
}
function $834619e78bbf578c$var$Bi(e1, t, n, r, i, a, o) {
    a[0] = 0, o[0] = -100000000000000000000, o[1] = $834619e78bbf578c$var$Ii, i[0] = e1[t];
    for(let s = 1, c = 0, l = 0; s < r; s++){
        i[s] = e1[t + s * n];
        let r = s * s;
        do {
            let e1 = a[c];
            l = (i[s] - i[e1] + r - e1 * e1) / (s - e1) / 2;
        }while (l <= o[c] && --c > -1);
        c++, a[c] = s, o[c] = l, o[c + 1] = $834619e78bbf578c$var$Ii;
    }
    for(let s = 0, c = 0; s < r; s++){
        for(; o[c + 1] < s;)c++;
        let r = a[c], l = s - r;
        e1[t + s * n] = i[r] + l * l;
    }
}
const $834619e78bbf578c$var$Vi = (0, $1rqx5.hn).layout_symbol[`text-font`].default.join(`,`), $834619e78bbf578c$var$Hi = (e1, t)=>{
    let n = new $834619e78bbf578c$var$Ri(e1);
    return n.buffer = t, n;
};
var $834619e78bbf578c$var$Ui = class {
    constructor(e1, t, n, r = $834619e78bbf578c$var$Hi){
        this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = n, this.fontFaceManager = new $834619e78bbf578c$var$Fi(e1), this.createRasterizer = r;
    }
    setURL(e1) {
        this.url = e1;
    }
    setFontFaces(e1) {
        this.fontFaceManager.setFontFaces(e1), this.entries = {};
    }
    async getGlyphs(e1) {
        let t = [];
        for(let n in e1)for(let r in e1[n])for (let i of e1[n][r])t.push(this._getAndCacheGlyphsPromise(n, i, r));
        let n = await Promise.all(t), r = {};
        for (let { stack: e1, id: t, variant: i, glyph: a } of n)r[e1] ||= {}, r[e1][i] ||= {}, r[e1][i][t] = a && {
            id: a.id,
            bitmap: a.bitmap.clone(),
            metrics: a.metrics
        };
        return r;
    }
    async _getAndCacheGlyphsPromise(e1, t, n) {
        this.entries[e1] ??= {
            glyphs: {
                default: {}
            },
            requests: {},
            ranges: {}
        };
        let r = this.entries[e1], i = r.glyphs[n] ||= {}, a = i[t];
        if (a !== void 0) return {
            stack: e1,
            id: t,
            variant: n,
            glyph: a
        };
        if (n !== "default") return i[t] = null, {
            stack: e1,
            id: t,
            variant: n,
            glyph: null
        };
        let o = t.codePointAt(0), s = this.fontFaceManager.hasFontFaces() ? await this.fontFaceManager.getFontFamily(e1, o) : null;
        return s ? (a = i[t] = await this._drawGlyph(r, e1, t, s), {
            stack: e1,
            id: t,
            variant: n,
            glyph: a
        }) : !this.url || (0, $1rqx5.B)(t) || this._charUsesLocalIdeographFontFamily(o) ? (a = i[t] = await this._drawGlyph(r, e1, t), {
            stack: e1,
            id: t,
            variant: n,
            glyph: a
        }) : {
            ...await this._downloadAndCacheRangePromise(e1, t),
            variant: n
        };
    }
    async _downloadAndCacheRangePromise(e1, t) {
        let n = t.codePointAt(0), r = this.entries[e1], i = Math.floor(n / 256);
        if (r.ranges[i]) return {
            stack: e1,
            id: t,
            glyph: null
        };
        r.requests[i] ||= this._loadGlyphRange(e1, i);
        try {
            let a = await r.requests[i];
            for(let e1 in a)r.glyphs.default[String.fromCodePoint(+e1)] = a[+e1];
            return r.ranges[i] = !0, {
                stack: e1,
                id: t,
                glyph: a[n] || null
            };
        } catch (a) {
            let o = r.glyphs.default[t] = await this._drawGlyph(r, e1, t);
            return this._warnOnMissingGlyphRange(o, i, n, (0, $1rqx5.Qn)(a)), {
                stack: e1,
                id: t,
                glyph: o
            };
        }
    }
    async _loadGlyphRange(e1, t) {
        let n = t * 256, r = n + 255, i = await this.requestManager.transformRequest(this.url.replace(`{fontstack}`, e1).replace(`{range}`, `${n}-${r}`), `Glyphs`), a = await (0, $1rqx5.xn)(i, new AbortController);
        if (!a?.data) throw Error(`Could not load glyph range. range: ${t}, ${n}-${r}`);
        let o = {};
        for (let e1 of (0, $1rqx5.R)(a.data))o[e1.id] = e1;
        return o;
    }
    _warnOnMissingGlyphRange(e1, t, n, r) {
        let i = t * 256, a = i + 255, o = n.toString(16).padStart(4, `0`).toUpperCase();
        (0, $1rqx5.Nr)(`Unable to load glyph range ${t}, ${i}-${a}. Rendering codepoint U+${o} locally instead. ${r}`);
    }
    _charUsesLocalIdeographFontFamily(e1) {
        return !!this.localIdeographFontFamily && (0, $1rqx5.V)(e1);
    }
    async _drawGlyph(e1, t, n, r) {
        let i = (await this._getTinySDF(e1, t, n, r)).draw(n), a = /^\p{gc=Cf}+$/u.test(n);
        return {
            id: n.codePointAt(0),
            bitmap: new (0, $1rqx5.Et)({
                width: i.width || 60,
                height: i.height || 60
            }, i.data),
            metrics: {
                width: a ? 0 : i.glyphWidth / 2 || 24,
                height: i.glyphHeight / 2 || 24,
                left: i.glyphLeft / 2 + .5 || 0,
                top: i.glyphTop / 2 - 27.5 || -8,
                advance: a ? 0 : i.glyphAdvance / 2 || 24,
                isDoubleResolution: !0
            }
        };
    }
    _getTinySDF(e1, t, n, r) {
        let i = (0, $1rqx5.B)(n);
        if (r) {
            let t = i ? `clusterTinySDFs` : `fontFaceTinySDFs`;
            return e1[t] ??= {}, e1[t][r] ||= this._createTinySDF(r, !1, i ? 3 : 1), e1[t][r];
        }
        let a = t === $834619e78bbf578c$var$Vi && this.localIdeographFontFamily !== `` && this._charUsesLocalIdeographFontFamily(n.codePointAt(0)), o = a ? this.localIdeographFontFamily : t;
        if (i) return e1.clusterTinySDFs ??= {}, e1.clusterTinySDFs[o] ||= this._createTinySDF(o, !0, 3), e1.clusterTinySDFs[o];
        let s = a ? `ideographTinySDF` : `tinySDF`;
        return e1[s] ||= this._createTinySDF(o), e1[s];
    }
    async _createTinySDF(e1, t = !0, n = 1) {
        let r = e1 ? e1.split(`,`) : [];
        r.push(`sans-serif`);
        let i = r.map((e1)=>/[-\w]+/.test(e1) ? e1 : `'${CSS.escape(e1)}'`).join(`,`), a = t ? this._fontWeight(r[0]) : void 0, o = t ? this._fontStyle(r[0]) : `normal`;
        if (typeof document < `u` && document.fonts?.load) try {
            await document.fonts.load(`${o} ${a || `normal`} 48px ${i}`);
        } catch (e1) {
            (0, $1rqx5.Nr)(`Failed to load font "${i}": ${(0, $1rqx5.Qn)(e1).message}`);
        }
        return this.createRasterizer({
            fontSize: 48,
            buffer: Math.max(6, Math.ceil(48 * (n - 1) / 4)),
            radius: 16,
            cutoff: .25,
            fontFamily: i,
            fontWeight: a,
            fontStyle: o,
            lang: this.lang
        }, 6);
    }
    _fontStyle(e1) {
        return /italic/i.test(e1) ? `italic` : /oblique/i.test(e1) ? `oblique` : `normal`;
    }
    _fontWeight(e1) {
        let t = {
            thin: 100,
            hairline: 100,
            "extra light": 200,
            "ultra light": 200,
            light: 300,
            normal: 400,
            regular: 400,
            medium: 500,
            semibold: 600,
            demibold: 600,
            bold: 700,
            "extra bold": 800,
            "ultra bold": 800,
            black: 900,
            heavy: 900,
            "extra black": 950,
            "ultra black": 950
        }, n;
        for (let [r, i] of Object.entries(t))RegExp(`\\b${r}\\b`, `i`).test(e1) && (n = `${i}`);
        return n;
    }
    destroy() {
        for(let e1 in this.entries){
            let t = this.entries[e1];
            t.tinySDF = null, t.ideographTinySDF = null, t.fontFaceTinySDFs = {}, t.glyphs = {
                default: {}
            }, t.requests = {}, t.ranges = {};
        }
        this.entries = {}, this.fontFaceManager.destroy();
    }
};
let $834619e78bbf578c$var$Wi;
const $834619e78bbf578c$var$Gi = ()=>$834619e78bbf578c$var$Wi ||= new (0, $1rqx5.Qt)({
        anchor: new (0, $1rqx5.Zt)((0, $1rqx5.hn).light.anchor, `anchor`),
        position: new (0, $1rqx5.Zt)((0, $1rqx5.hn).light.position, `position`),
        color: new (0, $1rqx5.Zt)((0, $1rqx5.hn).light.color, `color`),
        intensity: new (0, $1rqx5.Zt)((0, $1rqx5.hn).light.intensity, `intensity`)
    });
var $834619e78bbf578c$var$Ki = class extends (0, $1rqx5.vn) {
    constructor(e1, t){
        super(), this._transitionable = new (0, $1rqx5.$t)($834619e78bbf578c$var$Gi(), `light`, t), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
    }
    getLight() {
        return this._transitionable.serialize();
    }
    getCartesianPosition() {
        return (0, $1rqx5.Or)(this.properties.get(`position`));
    }
    setLight(e1, t = {}) {
        this._validate((0, $1rqx5.on).light, e1, t) || this._transitionable.setValues(e1);
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    applyGlobalStateChange(e1, t, n) {
        this._transitioning = this._transitionable.applyGlobalStateChange(e1, t, this._transitioning, n);
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, n) {
        return (0, $1rqx5.an)(this, e1, {
            value: t
        }, n);
    }
};
let $834619e78bbf578c$var$qi;
const $834619e78bbf578c$var$Ji = ()=>$834619e78bbf578c$var$qi ||= new (0, $1rqx5.Qt)({
        "sky-color": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`sky-color`], `sky-color`),
        "horizon-color": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`horizon-color`], `horizon-color`),
        "fog-color": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`fog-color`], `fog-color`),
        "fog-ground-blend": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`fog-ground-blend`], `fog-ground-blend`),
        "horizon-fog-blend": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`horizon-fog-blend`], `horizon-fog-blend`),
        "sky-horizon-blend": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`sky-horizon-blend`], `sky-horizon-blend`),
        "atmosphere-blend": new (0, $1rqx5.Zt)((0, $1rqx5.hn).sky[`atmosphere-blend`], `atmosphere-blend`)
    });
var $834619e78bbf578c$var$Yi = class extends (0, $1rqx5.vn) {
    constructor(e1, t){
        super(), this._transitionable = new (0, $1rqx5.$t)($834619e78bbf578c$var$Ji(), `sky`, t), this.setSky(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new (0, $1rqx5.en)(0));
    }
    setSky(e1, t = {}) {
        return !this._validate((0, $1rqx5.on).sky, e1, t) && (e1 ||= {
            "sky-color": `transparent`,
            "horizon-color": `transparent`,
            "fog-color": `transparent`,
            "fog-ground-blend": 1,
            "atmosphere-blend": 0
        }, this._transitionable.setValues(e1), !0);
    }
    getSky() {
        return this._transitionable.serialize();
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    applyGlobalStateChange(e1, t, n) {
        this._transitioning = this._transitionable.applyGlobalStateChange(e1, t, this._transitioning, n);
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, n = {}) {
        return (0, $1rqx5.an)(this, e1, {
            value: t
        }, n);
    }
    calculateFogBlendOpacity(e1) {
        return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
    }
}, $834619e78bbf578c$var$Xi = class {
    constructor(e1, t){
        this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
    }
    getDash(e1, t) {
        let n = e1.join(`,`) + String(t);
        return this.dashEntry[n] ||= this.addDash(e1, t), this.dashEntry[n];
    }
    getDashRanges(e1, t, n) {
        let r = e1.length % 2 == 1, i = [], a = r ? -e1[e1.length - 1] * n : 0, o = e1[0] * n, s = !0;
        i.push({
            left: a,
            right: o,
            isDash: s,
            zeroLength: e1[0] === 0
        });
        let c = e1[0];
        for(let t = 1; t < e1.length; t++){
            s = !s;
            let r = e1[t];
            a = c * n, c += r, o = c * n, i.push({
                left: a,
                right: o,
                isDash: s,
                zeroLength: r === 0
            });
        }
        return i;
    }
    addRoundDash(e1, t, n) {
        let r = t / 2;
        for(let t = -n; t <= n; t++){
            let i = this.nextRow + n + t, a = this.width * i, o = 0, s = e1[o];
            for(let i = 0; i < this.width; i++){
                i / s.right > 1 && (s = e1[++o]);
                let c = Math.abs(i - s.left), l = Math.abs(i - s.right), u = Math.min(c, l), d, f = t / n * (r + 1);
                if (s.isDash) {
                    let e1 = r - Math.abs(f);
                    d = Math.sqrt(u * u + e1 * e1);
                } else d = r - Math.sqrt(u * u + f * f);
                this.data[a + i] = Math.max(0, Math.min(255, d + 128));
            }
        }
    }
    addRegularDash(e1) {
        for(let t = e1.length - 1; t >= 0; --t){
            let n = e1[t], r = e1[t + 1];
            n.zeroLength ? e1.splice(t, 1) : r?.isDash === n.isDash && (r.left = n.left, e1.splice(t, 1));
        }
        let t = e1[0], n = e1[e1.length - 1];
        t.isDash === n.isDash && (t.left = n.left - this.width, n.right = t.right + this.width);
        let r = this.width * this.nextRow, i = 0, a = e1[i];
        for(let t = 0; t < this.width; t++){
            t / a.right > 1 && (a = e1[++i]);
            let n = Math.abs(t - a.left), o = Math.abs(t - a.right), s = Math.min(n, o), c = a.isDash ? s : -s;
            this.data[r + t] = Math.max(0, Math.min(255, c + 128));
        }
    }
    addDash(e1, t) {
        let n = t ? 7 : 0, r = 2 * n + 1;
        if (this.nextRow + r > this.height) return (0, $1rqx5.Nr)(`LineAtlas out of space`), null;
        let i = 0;
        for (let t of e1)i += t;
        if (i !== 0) {
            let r = this.width / i, a = this.getDashRanges(e1, this.width, r);
            t ? this.addRoundDash(a, r, n) : this.addRegularDash(a);
        }
        let a = {
            y: this.nextRow + n,
            height: 2 * n,
            width: i
        };
        return this.nextRow += r, this.dirty = !0, a;
    }
    bind(e1) {
        let t = e1.gl;
        this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
    }
};
function $834619e78bbf578c$var$Zi(e1) {
    if (!e1) return !1;
    let t = globalThis.location;
    if (!t) return !1;
    try {
        return new URL(e1, t.href).origin !== t.origin;
    } catch  {
        return !1;
    }
}
function $834619e78bbf578c$var$Qi() {
    let e1 = "file:///node_modules/maplibre-gl/dist/maplibre-gl.mjs";
    if (!/^https?:/.test(e1)) return ``;
    let t = e1.endsWith(`-dev.mjs`) ? `maplibre-gl-worker-dev.mjs` : `maplibre-gl-worker.mjs`;
    return new URL(`./${t}`, e1).href;
}
function $834619e78bbf578c$var$$i(e1, t) {
    if (t) try {
        return new Worker(e1, {
            type: `module`
        });
    } catch (e1) {
        console.warn(`Module worker not supported, falling back to classic worker`, e1);
    }
    return new Worker(e1);
}
async function $834619e78bbf578c$var$ea(e1) {
    let t = await fetch(e1);
    if (!t.ok) throw Error(`Failed to fetch worker script (${t.status}): ${e1}`);
    let n = await t.text(), r = new Blob([
        n
    ], {
        type: `text/javascript`
    });
    return URL.createObjectURL(r);
}
function $834619e78bbf578c$var$ta(e1) {
    let t = new Blob([
        `import ${JSON.stringify(new URL(e1, "file:///node_modules/maplibre-gl/dist/maplibre-gl.mjs").href)}`
    ], {
        type: `text/javascript`
    });
    return URL.createObjectURL(t);
}
async function $834619e78bbf578c$var$na() {
    let e1 = (0, $1rqx5.An).WORKER_URL || $834619e78bbf578c$var$Qi(), t = !e1?.endsWith(`.cjs`);
    if (!$834619e78bbf578c$var$Zi(e1)) return $834619e78bbf578c$var$$i(e1, t);
    if (t) {
        let n = $834619e78bbf578c$var$ta(e1);
        try {
            return $834619e78bbf578c$var$$i(n, t);
        } finally{
            URL.revokeObjectURL(n);
        }
    }
    let n = await $834619e78bbf578c$var$ea(e1);
    try {
        return $834619e78bbf578c$var$$i(n, t);
    } finally{
        URL.revokeObjectURL(n);
    }
}
const $834619e78bbf578c$var$ra = `maplibre_preloaded_worker_pool`;
var $834619e78bbf578c$var$ia = class e1 {
    constructor(){
        this.active = {}, this.workersPromise = null;
    }
    async acquire(t) {
        if (this.active[t] = !0, !this.workersPromise) {
            let t = [];
            for(; t.length < e1.workerCount;)t.push($834619e78bbf578c$var$na());
            this.workersPromise = Promise.all(t);
        }
        return (await this.workersPromise).slice();
    }
    release(e1) {
        if (delete this.active[e1], this.numActive() === 0 && this.workersPromise) {
            let e1 = this.workersPromise;
            this.workersPromise = null, e1.then((e1)=>{
                for (let t of e1)t.terminate();
            });
        }
    }
    isPreloaded() {
        return !!this.active[$834619e78bbf578c$var$ra];
    }
    numActive() {
        return Object.keys(this.active).length;
    }
};
const $834619e78bbf578c$var$aa = Math.floor($834619e78bbf578c$var$Rr.hardwareConcurrency / 2);
$834619e78bbf578c$var$ia.workerCount = (0, $1rqx5.ur)(globalThis) ? Math.max(Math.min($834619e78bbf578c$var$aa, 3), 1) : 1;
let $834619e78bbf578c$var$oa;
function $834619e78bbf578c$var$sa() {
    return $834619e78bbf578c$var$oa ||= new $834619e78bbf578c$var$ia, $834619e78bbf578c$var$oa;
}
function $834619e78bbf578c$export$ea453d9c8cc3d5d2() {
    $834619e78bbf578c$var$sa().acquire($834619e78bbf578c$var$ra);
}
function $834619e78bbf578c$export$3b8bb46c10ecf86e() {
    let e1 = $834619e78bbf578c$var$oa;
    e1 && (e1.isPreloaded() && e1.numActive() === 1 ? (e1.release($834619e78bbf578c$var$ra), $834619e78bbf578c$var$oa = null) : console.warn(`Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()`));
}
var $834619e78bbf578c$var$ua = class extends (0, $1rqx5.vn) {
    constructor(e1, t){
        super(), this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = t, this.removed = !1, this.workerErrorSubscriptions = [], this.actorsPromise = this.initActors(t);
    }
    async initActors(e1) {
        let t = await this.workerPool.acquire(e1);
        if (this.removed) return [];
        if (this.actors = t.map((t, n)=>{
            this.workerErrorSubscriptions.push((0, $1rqx5.kr)(t, `error`, ()=>{
                this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Worker failed to load. Check that the worker URL is correct.`)));
            }, !1));
            let r = new (0, $1rqx5.g)(t, e1);
            return r.name = `Worker ${n}`, r;
        }), !this.actors.length) throw Error(`No actors found`);
        return this.actors;
    }
    async broadcast(e1, t) {
        let n = await this.actorsPromise;
        return Promise.all(n.map((n)=>n.sendAsync({
                type: e1,
                data: t
            })));
    }
    async getActor() {
        let e1 = await this.actorsPromise;
        return this.currentActor = (this.currentActor + 1) % e1.length, e1[this.currentActor];
    }
    async waitForInitComplete() {
        this.actors.length === 0 && await this.actorsPromise;
    }
    getReadyActor() {
        return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
    }
    remove(e1 = !0) {
        this.removed = !0;
        for (let e1 of this.actors)e1.remove();
        for (let e1 of this.workerErrorSubscriptions)e1.unsubscribe();
        this.actors = [], this.workerErrorSubscriptions = [], this.setEventedParent(null), e1 && this.workerPool.release(this.id);
    }
    async registerMessageHandler(e1, t) {
        let n = await this.actorsPromise;
        for (let r of n)r.registerMessageHandler(e1, t);
    }
    async unregisterMessageHandler(e1) {
        let t = await this.actorsPromise;
        for (let n of t)n.unregisterMessageHandler(e1);
    }
};
let $834619e78bbf578c$var$da;
function $834619e78bbf578c$export$6f0c702cbe7d6ed8() {
    return $834619e78bbf578c$var$da || ($834619e78bbf578c$var$da = new $834619e78bbf578c$var$ua($834619e78bbf578c$var$sa(), (0, $1rqx5.bn)), $834619e78bbf578c$var$da.registerMessageHandler(`GR`, (e1, t, n)=>(0, $1rqx5.Tn)(t, n))), $834619e78bbf578c$var$da;
}
function $834619e78bbf578c$var$pa(e1, t) {
    let n = (0, $1rqx5.vi)();
    return (0, $1rqx5.ji)(n, n, [
        1,
        1,
        0
    ]), (0, $1rqx5.Ai)(n, n, [
        e1.width * .5,
        e1.height * .5,
        1
    ]), e1.calculatePosMatrix ? (0, $1rqx5.wi)(n, n, e1.calculatePosMatrix(t.toUnwrapped())) : n;
}
function $834619e78bbf578c$var$ma(e1, t, n) {
    if (e1) for (let r of e1){
        let e1 = t[r];
        if (e1?.source === n && e1.type === `fill-extrusion`) return !0;
    }
    else for(let e1 in t){
        let r = t[e1];
        if (r.source === n && r.type === `fill-extrusion`) return !0;
    }
    return !1;
}
function $834619e78bbf578c$var$ha(e1, t, n, r, i, a, o) {
    let s = $834619e78bbf578c$var$ma(i?.layers ?? null, t, e1.id), c = a.maxPitchScaleFactor(), l = e1.tilesIn(r, c, s);
    l.sort($834619e78bbf578c$var$va);
    let u = [];
    for (let r of l)u.push({
        wrappedTileID: r.tileID.wrapped().key,
        queryResults: r.tile.queryRenderedFeatures(t, n, e1.getState(), r.queryGeometry, r.cameraQueryGeometry, r.scale, i, a, c, $834619e78bbf578c$var$pa(a, r.tileID), o ? (e1, t)=>o(r.tileID, e1, t) : void 0)
    });
    return $834619e78bbf578c$var$ba($834619e78bbf578c$var$ya(u), e1);
}
function $834619e78bbf578c$var$ga(e1, t, n, r, i, a, o) {
    let s = {}, c = a.queryRenderedSymbols(r), l = [];
    for (let e1 of Object.keys(c).map(Number))l.push(o[e1]);
    l.sort($834619e78bbf578c$var$va);
    for (let n of l){
        let r = n.featureIndex.lookupSymbolFeatures(c[n.bucketInstanceId], t, n.bucketIndex, n.sourceLayerIndex, {
            filterSpec: i.filter,
            globalState: i.globalState
        }, i.layers, i.availableImages, e1);
        for(let e1 in r){
            s[e1] ||= [];
            let t = r[e1];
            t.sort((e1, t)=>{
                let r = n.featureSortOrder;
                if (r) {
                    let n = r.indexOf(e1.featureIndex);
                    return r.indexOf(t.featureIndex) - n;
                }
                return t.featureIndex - e1.featureIndex;
            });
            for (let n of t)s[e1].push(n);
        }
    }
    return $834619e78bbf578c$var$xa(s, e1, n);
}
function $834619e78bbf578c$var$_a(e1, t) {
    let n = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), r = [], i = {};
    for (let e1 of n){
        let n = e1.tileID.canonical.key;
        i[n] || (i[n] = !0, e1.querySourceFeatures(r, t));
    }
    return r;
}
function $834619e78bbf578c$var$va(e1, t) {
    let n = e1.tileID, r = t.tileID;
    return n.overscaledZ - r.overscaledZ || n.canonical.y - r.canonical.y || n.wrap - r.wrap || n.canonical.x - r.canonical.x;
}
function $834619e78bbf578c$var$ya(e1) {
    let t = {}, n = {};
    for (let { queryResults: r, wrappedTileID: i } of e1){
        n[i] ||= {};
        let e1 = n[i];
        for(let n in r){
            let i = r[n];
            e1[n] ||= {};
            let a = e1[n];
            t[n] ||= [];
            for (let e1 of i)a[e1.featureIndex] || (a[e1.featureIndex] = !0, t[n].push(e1));
        }
    }
    return t;
}
function $834619e78bbf578c$var$ba(e1, t) {
    for(let n in e1)for (let r of e1[n])$834619e78bbf578c$var$Sa(r, t);
    return e1;
}
function $834619e78bbf578c$var$xa(e1, t, n) {
    for(let r in e1)for (let i of e1[r]){
        let e1 = n[t[r].source];
        $834619e78bbf578c$var$Sa(i, e1);
    }
    return e1;
}
function $834619e78bbf578c$var$Sa(e1, t) {
    let n = e1.feature, r = t.getFeatureState(n.layer[`source-layer`], n.id);
    n.source = n.layer.source, n.layer[`source-layer`] && (n.sourceLayer = n.layer[`source-layer`]), n.state = r;
}
async function $834619e78bbf578c$var$Ca(e1, t, n, r) {
    let i = e1;
    if (e1.url ? i = (await (0, $1rqx5.Sn)(await t.transformRequest(e1.url, `Source`), n)).data : await $834619e78bbf578c$var$Rr.frameAsync(n, r), !i) return null;
    let a = (0, $1rqx5.yr)((0, $1rqx5.er)(i, e1), [
        `tiles`,
        `minzoom`,
        `maxzoom`,
        `attribution`,
        `bounds`,
        `scheme`,
        `tileSize`,
        `encoding`
    ]);
    return `vector_layers` in i && i.vector_layers && (a.vectorLayerIds = i.vector_layers.map((e1)=>e1.id)), a;
}
var $834619e78bbf578c$export$266d2884f61535d3 = class e1 {
    constructor(e1, t){
        e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (e1.length === 4 ? this.setSouthWest([
            e1[0],
            e1[1]
        ]).setNorthEast([
            e1[2],
            e1[3]
        ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
    }
    setNorthEast(e1) {
        return this._ne = e1 instanceof (0, $1rqx5.lt) ? new (0, $1rqx5.lt)(e1.lng, e1.lat) : (0, $1rqx5.lt).convert(e1), this;
    }
    setSouthWest(e1) {
        return this._sw = e1 instanceof (0, $1rqx5.lt) ? new (0, $1rqx5.lt)(e1.lng, e1.lat) : (0, $1rqx5.lt).convert(e1), this;
    }
    extend(t) {
        let n = this._sw, r = this._ne, i, a;
        if (t instanceof (0, $1rqx5.lt)) i = t, a = t;
        else if (t instanceof e1) {
            if (i = t._sw, a = t._ne, !i || !a) return this;
        } else {
            if (Array.isArray(t)) {
                if (t.length === 4 || t.every(Array.isArray)) {
                    let n = t;
                    return this.extend(e1.convert(n));
                }
                {
                    let e1 = t;
                    return this.extend((0, $1rqx5.lt).convert(e1));
                }
            }
            return t && (`lng` in t || `lon` in t) && `lat` in t ? this.extend((0, $1rqx5.lt).convert(t)) : this;
        }
        return !n && !r ? (this._sw = new (0, $1rqx5.lt)(i.lng, i.lat), this._ne = new (0, $1rqx5.lt)(a.lng, a.lat)) : (n.lng = Math.min(i.lng, n.lng), n.lat = Math.min(i.lat, n.lat), r.lng = Math.max(a.lng, r.lng), r.lat = Math.max(a.lat, r.lat)), this;
    }
    getCenter() {
        return new (0, $1rqx5.lt)((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
    }
    getSouthWest() {
        return this._sw;
    }
    getNorthEast() {
        return this._ne;
    }
    getNorthWest() {
        return new (0, $1rqx5.lt)(this.getWest(), this.getNorth());
    }
    getSouthEast() {
        return new (0, $1rqx5.lt)(this.getEast(), this.getSouth());
    }
    getWest() {
        return this._sw.lng;
    }
    getSouth() {
        return this._sw.lat;
    }
    getEast() {
        return this._ne.lng;
    }
    getNorth() {
        return this._ne.lat;
    }
    toArray() {
        return [
            this._sw.toArray(),
            this._ne.toArray()
        ];
    }
    toString() {
        return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
    }
    isEmpty() {
        return !(this._sw && this._ne);
    }
    contains(e1) {
        let { lng: t, lat: n } = (0, $1rqx5.lt).convert(e1), r = this._sw.lat <= n && n <= this._ne.lat, i = this._sw.lng <= t && t <= this._ne.lng;
        return this._sw.lng > this._ne.lng && (i = this._sw.lng >= t && t >= this._ne.lng), r && i;
    }
    intersects(t) {
        if (t = e1.convert(t), !(t.getNorth() >= this.getSouth() && t.getSouth() <= this.getNorth())) return !1;
        let n = Math.abs(this.getEast() - this.getWest()), r = Math.abs(t.getEast() - t.getWest());
        if (n >= 360 || r >= 360) return !0;
        let i = (0, $1rqx5.Pr)(this.getWest(), -180, 180), a = (0, $1rqx5.Pr)(this.getEast(), -180, 180), o = (0, $1rqx5.Pr)(t.getWest(), -180, 180), s = (0, $1rqx5.Pr)(t.getEast(), -180, 180), c = i > a, l = o > s;
        return c && l ? !0 : c ? s >= i || o <= a : l ? a >= o || i <= s : o <= a && s >= i;
    }
    static convert(t) {
        return t instanceof e1 || !t ? t : new e1(t);
    }
    static fromLngLat(t, n = 0) {
        let r = 360 * n / 40075017, i = r / Math.cos(Math.PI / 180 * t.lat);
        return new e1(new (0, $1rqx5.lt)(t.lng - i, t.lat - r), new (0, $1rqx5.lt)(t.lng + i, t.lat + r));
    }
    adjustAntiMeridian() {
        let t = new (0, $1rqx5.lt)(this._sw.lng, this._sw.lat), n = new (0, $1rqx5.lt)(this._ne.lng, this._ne.lat);
        return t.lng > n.lng ? new e1(t, new (0, $1rqx5.lt)(n.lng + 360, n.lat)) : new e1(t, n);
    }
}, $834619e78bbf578c$var$Ta = class {
    constructor(e1, t, n){
        this.bounds = $834619e78bbf578c$export$266d2884f61535d3.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = n || 24;
    }
    validateBounds(e1) {
        return !Array.isArray(e1) || e1.length !== 4 ? [
            -180,
            -90,
            180,
            90
        ] : [
            Math.max(-180, e1[0]),
            Math.max(-90, e1[1]),
            Math.min(180, e1[2]),
            Math.min(90, e1[3])
        ];
    }
    contains(e1) {
        let t = 2 ** e1.z, n = {
            minX: Math.floor((0, $1rqx5.ot)(this.bounds.getWest()) * t),
            minY: Math.floor((0, $1rqx5.st)(this.bounds.getNorth()) * t),
            maxX: Math.ceil((0, $1rqx5.ot)(this.bounds.getEast()) * t),
            maxY: Math.ceil((0, $1rqx5.st)(this.bounds.getSouth()) * t)
        };
        return e1.x >= n.minX && e1.x < n.maxX && e1.y >= n.minY && e1.y < n.maxY;
    }
}, $834619e78bbf578c$export$5feeb63c172810c5 = class extends (0, $1rqx5.vn) {
    constructor(e1, t, n, r){
        if (super(), this.id = e1, this.dispatcher = n, this.type = `vector`, this.minzoom = 0, this.maxzoom = 22, this.scheme = `xyz`, this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, (0, $1rqx5.er)(this, (0, $1rqx5.yr)(t, [
            `url`,
            `scheme`,
            `tileSize`,
            `promoteId`,
            `encoding`
        ])), this._options = (0, $1rqx5.er)({
            type: `vector`
        }, t), this._collectResourceTiming = t.collectResourceTiming, this.tileSize !== 512) throw Error(`vector tile sources must have a tileSize of 512`);
        this.setEventedParent(r);
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataloading`)), this._tileJSONRequest = new AbortController;
        try {
            let t = await $834619e78bbf578c$var$Ca(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ((0, $1rqx5.er)(this, t), t.bounds && (this.tileBounds = new $834619e78bbf578c$var$Ta(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `metadata`
            })), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `content`,
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, (0, $1rqx5.Mn)(e1) || this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setSourceProperty(e1) {
        this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this.tiles = e1, this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    serialize() {
        return (0, $1rqx5.er)({}, this._options);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = {
            request: await this.map._requestManager.transformRequest(t, `Tile`),
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
            type: this.type,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
            encoding: this.encoding,
            overzoomParameters: await this._getOverzoomParameters(e1),
            etag: e1.etag
        };
        if (n.request.collectResourceTiming = this._collectResourceTiming, await this.dispatcher.waitForInitComplete(), e1.aborted) return;
        let r = `RT`;
        if (!e1.actor || e1.state === `expired`) e1.actor = this.dispatcher.getReadyActor(), r = `LT`;
        else if (e1.state === `loading`) return new Promise((t, n)=>{
            e1.reloadPromise = {
                resolve: t,
                reject: n
            };
        });
        e1.abortController = new AbortController;
        try {
            let t = await e1.actor.sendAsync({
                type: r,
                data: n
            }, e1.abortController);
            if (delete e1.abortController, e1.aborted) return;
            this._afterTileLoadWorkerResponse(e1, t);
            let i = {};
            return t?.etagUnmodified && (i.unmodified = !0), i;
        } catch (t) {
            if (delete e1.abortController, e1.aborted || (0, $1rqx5.Mn)(t)) return;
            if (t && t.status !== 404) throw t;
            this._afterTileLoadWorkerResponse(e1, null);
        }
    }
    async _getOverzoomParameters(e1) {
        if (e1.tileID.canonical.z <= this.maxzoom || this.map._zoomLevelsToOverscale === void 0) return;
        let t = e1.tileID.scaledTo(this.maxzoom).canonical, n = t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        return {
            maxZoomTileID: t,
            overzoomRequest: await this.map._requestManager.transformRequest(n, `Tile`)
        };
    }
    _afterTileLoadWorkerResponse(e1, t) {
        if (t?.resourceTiming && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.etag = t?.etag, e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
            let t = e1.reloadPromise;
            e1.reloadPromise = null, this.loadTile(e1).then(t.resolve).catch(t.reject);
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.actor && await e1.actor.sendAsync({
            type: `AT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), e1.actor && await e1.actor.sendAsync({
            type: `RMT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    hasTransition() {
        return !1;
    }
}, $834619e78bbf578c$export$908e4015b805db3c = class extends (0, $1rqx5.vn) {
    constructor(e1, t, n, r){
        super(), this.id = e1, this.dispatcher = n, this.setEventedParent(r), this.type = `raster`, this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = `xyz`, this.tileSize = 512, this._loaded = !1, this._premultiplyAlpha = !0, this._options = (0, $1rqx5.er)({
            type: `raster`
        }, t), (0, $1rqx5.er)(this, (0, $1rqx5.yr)(t, [
            `url`,
            `scheme`,
            `tileSize`
        ]));
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataloading`)), this._tileJSONRequest = new AbortController;
        try {
            let t = await $834619e78bbf578c$var$Ca(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ((0, $1rqx5.er)(this, t), t.bounds && (this.tileBounds = new $834619e78bbf578c$var$Ta(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `metadata`
            })), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `content`,
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, (0, $1rqx5.Mn)(e1) || this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    setSourceProperty(e1) {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this.tiles = e1, this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    serialize() {
        return (0, $1rqx5.er)({}, this._options);
    }
    setPremultiplyAlpha(e1) {
        return this._premultiplyAlpha === e1 || this.setSourceProperty(()=>{
            this._premultiplyAlpha = e1;
        }), this;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = this._premultiplyAlpha, r = n ? void 0 : {
            premultiplyAlpha: `none`
        };
        e1.abortController = new AbortController;
        try {
            let i = await $834619e78bbf578c$var$Yr.transformAndGetImage(this.map._requestManager, t, `Tile`, e1.abortController, this.map._refreshExpiredTiles, r);
            if (delete e1.abortController, e1.aborted) {
                e1.state = `unloaded`;
                return;
            }
            if (i) {
                this.map._refreshExpiredTiles && (i.cacheControl || i.expires) && e1.setExpiryData({
                    cacheControl: i.cacheControl,
                    expires: i.expires
                });
                let t = this.map.painter.context, r = t.gl, a = i.data ?? new (0, $1rqx5.Dt)({
                    width: 1,
                    height: 1
                }, /* @__PURE__ */ new Uint8Array(4));
                e1.texture = this.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                    useMipmap: !0,
                    premultiply: n
                }) : (e1.texture = new (0, $1rqx5.xt)(t, a, r.RGBA, {
                    useMipmap: !0,
                    premultiply: n
                }), e1.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST)), e1.state = `loaded`;
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = `unloaded`;
            else if (t) throw e1.state = `errored`, t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController);
    }
    async unloadTile(e1) {
        e1.texture && this.map.painter.saveTileTexture(e1.texture);
    }
    hasTransition() {
        return !1;
    }
}, $834619e78bbf578c$export$12673e0db63b98e3 = class extends $834619e78bbf578c$export$908e4015b805db3c {
    constructor(e1, t, n, r){
        super(e1, t, n, r), this.type = `raster-dem`, this.maxzoom = 22, this._options = (0, $1rqx5.er)({
            type: `raster-dem`
        }, t), this.encoding = t.encoding || `mapbox`, this.redFactor = t.redFactor, this.greenFactor = t.greenFactor, this.blueFactor = t.blueFactor, this.baseShift = t.baseShift;
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
        try {
            let n = await $834619e78bbf578c$var$Yr.transformAndGetImage(this.map._requestManager, t, `Tile`, e1.abortController, this.map._refreshExpiredTiles, {
                colorSpaceConversion: `none`
            });
            if (delete e1.abortController, e1.aborted) {
                e1.state = `unloaded`;
                return;
            }
            if (n) {
                if (this.map._refreshExpiredTiles && (n.cacheControl || n.expires) && e1.setExpiryData({
                    cacheControl: n.cacheControl,
                    expires: n.expires
                }), !n.data) {
                    e1.state = `loaded`;
                    return;
                }
                let t = n.data, r = (0, $1rqx5.cr)(t) && (0, $1rqx5.Ii)() ? t : await this.readImageNow(t), i = {
                    type: this.type,
                    uid: e1.uid,
                    source: this.id,
                    rawImageData: r,
                    encoding: this.encoding,
                    redFactor: this.redFactor,
                    greenFactor: this.greenFactor,
                    blueFactor: this.blueFactor,
                    baseShift: this.baseShift
                };
                if (e1.actor && e1.state !== `expired` && e1.state !== `reloading`) return;
                await this.dispatcher.waitForInitComplete(), (!e1.actor || e1.state === `expired`) && (e1.actor = this.dispatcher.getReadyActor()), e1.dem = await e1.actor.sendAsync({
                    type: `LDT`,
                    data: i
                }), e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.needsColorReliefPrepare = !0, e1.state = `loaded`;
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = `unloaded`;
            else if (t) throw e1.state = `errored`, t;
        }
    }
    async readImageNow(e1) {
        if (typeof VideoFrame < `u` && (0, $1rqx5.Fi)()) {
            let t = e1.width + 4, n = e1.height + 4;
            try {
                return new (0, $1rqx5.Dt)({
                    width: t,
                    height: n
                }, await (0, $1rqx5.Cr)(e1, -2, -2, t, n));
            } catch  {}
        }
        return $834619e78bbf578c$var$Rr.getImageData(e1, 2);
    }
    _getNeighboringTiles(e1) {
        let t = e1.canonical, n = 2 ** t.z, r = (t.x - 1 + n) % n, i = t.x === 0 ? e1.wrap - 1 : e1.wrap, a = (t.x + 1 + n) % n, o = t.x + 1 === n ? e1.wrap + 1 : e1.wrap, s = {};
        return s[new (0, $1rqx5.d)(e1.overscaledZ, i, t.z, r, t.y).key] = {
            backfilled: !1
        }, s[new (0, $1rqx5.d)(e1.overscaledZ, o, t.z, a, t.y).key] = {
            backfilled: !1
        }, t.y > 0 && (s[new (0, $1rqx5.d)(e1.overscaledZ, i, t.z, r, t.y - 1).key] = {
            backfilled: !1
        }, s[new (0, $1rqx5.d)(e1.overscaledZ, e1.wrap, t.z, t.x, t.y - 1).key] = {
            backfilled: !1
        }, s[new (0, $1rqx5.d)(e1.overscaledZ, o, t.z, a, t.y - 1).key] = {
            backfilled: !1
        }), t.y + 1 < n && (s[new (0, $1rqx5.d)(e1.overscaledZ, i, t.z, r, t.y + 1).key] = {
            backfilled: !1
        }, s[new (0, $1rqx5.d)(e1.overscaledZ, e1.wrap, t.z, t.x, t.y + 1).key] = {
            backfilled: !1
        }, s[new (0, $1rqx5.d)(e1.overscaledZ, o, t.z, a, t.y + 1).key] = {
            backfilled: !1
        }), s;
    }
    async unloadTile(e1) {
        e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = `unloaded`, e1.actor && await e1.actor.sendAsync({
            type: `RDT`,
            data: {
                type: this.type,
                uid: e1.uid,
                source: this.id
            }
        });
    }
};
function $834619e78bbf578c$var$ka(e1, t) {
    return t ? e1.properties[t] : e1.id;
}
function $834619e78bbf578c$var$Aa(e1, t) {
    let n = /* @__PURE__ */ new Map;
    if (e1 == null || e1.type == null) return n;
    if (e1.type === `Feature`) {
        let r = $834619e78bbf578c$var$ka(e1, t);
        return r == null ? void 0 : (n.set(r, e1), n);
    }
    if (e1.type === `FeatureCollection`) {
        let r = /* @__PURE__ */ new Set;
        for (let i of e1.features){
            let e1 = $834619e78bbf578c$var$ka(i, t);
            if (e1 == null || r.has(e1)) return;
            r.add(e1), n.set(e1, i);
        }
        return n;
    }
}
function $834619e78bbf578c$var$ja(e1, t, n) {
    let r = [];
    if (t.removeAll) e1.clear();
    else if (t.remove) for (let n of t.remove){
        let t = e1.get(n);
        t && (r.push(t.geometry), e1.delete(n));
    }
    if (t.add) for (let i of t.add){
        let t = $834619e78bbf578c$var$ka(i, n);
        if (t == null) continue;
        let a = e1.get(t);
        a && r.push(a.geometry), r.push(i.geometry), e1.set(t, i);
    }
    if (t.update) for (let n of t.update){
        let t = e1.get(n.id);
        if (!t) continue;
        let i = !!n.newGeometry, a = n.removeAllProperties || n.removeProperties?.length > 0 || n.addOrUpdateProperties?.length > 0;
        if (!i && !a) continue;
        r.push(t.geometry);
        let o = {
            ...t
        };
        if (e1.set(n.id, o), i && (r.push(n.newGeometry), o.geometry = n.newGeometry), a) {
            if (o.properties = n.removeAllProperties ? {} : {
                ...o.properties || {}
            }, n.removeProperties) for (let e1 of n.removeProperties)delete o.properties[e1];
            if (n.addOrUpdateProperties) for (let { key: e1, value: t } of n.addOrUpdateProperties)o.properties[e1] = t;
        }
    }
    return r;
}
function $834619e78bbf578c$var$Ma(e1, t, n) {
    if (!e1) return t || {};
    if (!t) return e1 || {};
    let r = $834619e78bbf578c$var$Fa(e1, n), i = $834619e78bbf578c$var$Fa(t, n);
    $834619e78bbf578c$var$Na(r, i);
    let a = {};
    if ((r.removeAll || i.removeAll) && (a.removeAll = !0), a.remove = /* @__PURE__ */ new Set([
        ...r.remove,
        ...i.remove
    ]), a.add = new Map([
        ...r.add,
        ...i.add
    ]), a.update = new Map([
        ...r.update,
        ...i.update
    ]), a.remove.size && a.add.size) for (let e1 of a.add.keys())a.remove.delete(e1);
    return $834619e78bbf578c$var$Ia(a);
}
function $834619e78bbf578c$var$Na(e1, t) {
    t.removeAll && (e1.add.clear(), e1.update.clear(), e1.remove.clear(), t.remove.clear());
    for (let n of t.remove)e1.add.delete(n), e1.update.delete(n);
    for (let [n, r] of t.update){
        let i = e1.update.get(n);
        i && (t.update.set(n, $834619e78bbf578c$var$Pa(i, r)), e1.update.delete(n));
    }
}
function $834619e78bbf578c$var$Pa(e1, t) {
    let n = {
        id: e1.id
    };
    if (t.removeAllProperties && (delete e1.removeProperties, delete e1.addOrUpdateProperties, delete t.removeProperties), t.removeProperties && e1.addOrUpdateProperties) {
        let n = new Set(t.removeProperties);
        e1.addOrUpdateProperties = e1.addOrUpdateProperties.filter((e1)=>!n.has(e1.key));
    }
    return (e1.removeAllProperties || t.removeAllProperties) && (n.removeAllProperties = !0), (e1.removeProperties || t.removeProperties) && (n.removeProperties = [
        ...e1.removeProperties || [],
        ...t.removeProperties || []
    ]), (e1.addOrUpdateProperties || t.addOrUpdateProperties) && (n.addOrUpdateProperties = [
        ...e1.addOrUpdateProperties || [],
        ...t.addOrUpdateProperties || []
    ]), (e1.newGeometry || t.newGeometry) && (n.newGeometry = t.newGeometry || e1.newGeometry), n;
}
function $834619e78bbf578c$var$Fa(e1, t) {
    if (!e1) return {};
    let n = {};
    return n.removeAll = e1.removeAll, n.remove = new Set(e1.remove || []), n.add = new Map(e1.add?.map((e1)=>[
            $834619e78bbf578c$var$ka(e1, t),
            e1
        ])), n.update = new Map(e1.update?.map((e1)=>[
            e1.id,
            e1
        ])), n;
}
function $834619e78bbf578c$var$Ia(e1) {
    let t = {};
    return e1.removeAll && (t.removeAll = e1.removeAll), e1.remove && (t.remove = Array.from(e1.remove)), e1.add && (t.add = Array.from(e1.add.values())), e1.update && (t.update = Array.from(e1.update.values())), t;
}
function $834619e78bbf578c$var$La(e1) {
    return !e1 || e1.length === 0 ? [] : typeof e1[0] == `number` ? [
        e1
    ] : e1.flatMap((e1)=>$834619e78bbf578c$var$La(e1));
}
function $834619e78bbf578c$var$Ra(e1) {
    return e1.type === `GeometryCollection` ? e1.geometries.flatMap((e1)=>$834619e78bbf578c$var$Ra(e1)) : $834619e78bbf578c$var$La(e1.coordinates);
}
function $834619e78bbf578c$var$za(e1) {
    let t = new $834619e78bbf578c$export$266d2884f61535d3, n;
    switch(e1.type){
        case `FeatureCollection`:
            n = e1.features.flatMap((e1)=>$834619e78bbf578c$var$Ra(e1.geometry));
            break;
        case `Feature`:
            n = $834619e78bbf578c$var$Ra(e1.geometry);
            break;
        default:
            n = $834619e78bbf578c$var$Ra(e1);
    }
    if (n.length === 0) return t;
    for (let e1 of n){
        let [n, r] = e1;
        t.extend([
            n,
            r
        ]);
    }
    return t;
}
function $834619e78bbf578c$var$Ba({ x: e1, y: t, z: n }, r = 0) {
    let i = (0, $1rqx5.at)((e1 - r) / 2 ** n), a = (0, $1rqx5.it)((t + 1 + r) / 2 ** n), o = (0, $1rqx5.at)((e1 + 1 + r) / 2 ** n), s = (0, $1rqx5.it)((t - r) / 2 ** n);
    return new $834619e78bbf578c$export$266d2884f61535d3([
        i,
        a
    ], [
        o,
        s
    ]);
}
var $834619e78bbf578c$export$8a9e6af3bfd58eb9 = class extends (0, $1rqx5.vn) {
    constructor(e1, t, n, r){
        super(), this.id = e1, this.type = `geojson`, this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
            data: t.data
        }, this.actorPromise = n.getActor(), this.setEventedParent(r), this._data = typeof t.data == `string` ? {
            url: t.data
        } : {
            geojson: t.data
        }, this._options = (0, $1rqx5.er)({}, t), this._collectResourceTiming = t.collectResourceTiming, t.maxzoom !== void 0 && (this.maxzoom = t.maxzoom), t.type && (this.type = t.type), t.attribution && (this.attribution = t.attribution), this.promoteId = t.promoteId, t.clusterMaxZoom !== void 0 && this.maxzoom <= t.clusterMaxZoom && (0, $1rqx5.Nr)(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${t.clusterMaxZoom}".`), this.workerOptions = (0, $1rqx5.er)({
            source: this.id,
            geojsonVtOptions: {
                buffer: this._pixelsToTileUnits(t.buffer === void 0 ? 128 : t.buffer),
                tolerance: this._pixelsToTileUnits(t.tolerance === void 0 ? .375 : t.tolerance),
                extent: (0, $1rqx5.Lr),
                maxZoom: this.maxzoom,
                lineMetrics: t.lineMetrics || !1,
                generateId: t.generateId || !1,
                promoteId: this._promoteIdKey,
                cluster: t.cluster || !1,
                clusterOptions: {
                    maxZoom: this._getClusterMaxZoom(t.clusterMaxZoom),
                    minPoints: Math.max(2, t.clusterMinPoints || 2),
                    extent: (0, $1rqx5.Lr),
                    radius: this._pixelsToTileUnits(t.clusterRadius || 50),
                    log: !1,
                    generateId: t.generateId || !1
                }
            },
            clusterProperties: t.clusterProperties,
            filter: t.filter
        }, t.workerOptions);
    }
    get _promoteIdKey() {
        return typeof this.promoteId == `string` ? this.promoteId : void 0;
    }
    _hasPendingWorkerUpdate() {
        return this._pendingWorkerUpdate.data !== void 0 || this._pendingWorkerUpdate.diff !== void 0 || this._pendingWorkerUpdate.updateCluster;
    }
    _pixelsToTileUnits(e1) {
        return e1 * ((0, $1rqx5.Lr) / this.tileSize);
    }
    _tileUnitsToPixels(e1) {
        return e1 / ((0, $1rqx5.Lr) / this.tileSize);
    }
    _getClusterMaxZoom(e1) {
        let t = e1 ? Math.round(e1) : this.maxzoom - 1;
        return Number.isInteger(e1) || e1 === void 0 || (0, $1rqx5.Nr)(`Integer expected for option 'clusterMaxZoom': provided value "${e1}" rounded to "${t}"`), t;
    }
    async load() {
        await this._updateWorkerData();
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setData(e1) {
        return this._data = typeof e1 == `string` ? {
            url: e1
        } : {
            geojson: e1
        }, this._pendingWorkerUpdate = {
            data: e1
        }, this._updateWorkerData();
    }
    updateData(e1) {
        return this._pendingWorkerUpdate.diff = $834619e78bbf578c$var$Ma(this._pendingWorkerUpdate.diff, e1, this._promoteIdKey), this._updateWorkerData();
    }
    async getData() {
        return this._data.url && await this.once(`data`), this._data.geojson ? this._data.geojson : {
            type: `FeatureCollection`,
            features: Array.from(this._data.updateable.values())
        };
    }
    async getBounds() {
        return $834619e78bbf578c$var$za(await this.getData());
    }
    setClusterOptions(e1) {
        return this.workerOptions.geojsonVtOptions.cluster = e1.cluster, e1.clusterRadius !== void 0 && (this.workerOptions.geojsonVtOptions.clusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), e1.clusterMaxZoom !== void 0 && (this.workerOptions.geojsonVtOptions.clusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.updateCluster = !0, this._updateWorkerData();
    }
    getClusterOptions() {
        let { cluster: e1, clusterOptions: t } = this.workerOptions.geojsonVtOptions;
        return {
            cluster: e1,
            clusterMaxZoom: t.maxZoom,
            clusterRadius: this._tileUnitsToPixels(t.radius)
        };
    }
    async getClusterExpansionZoom(e1) {
        return (await this.actorPromise).sendAsync({
            type: `GCEZ`,
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterChildren(e1) {
        return (await this.actorPromise).sendAsync({
            type: `GCC`,
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterLeaves(e1, t, n) {
        return (await this.actorPromise).sendAsync({
            type: `GCL`,
            data: {
                type: this.type,
                source: this.id,
                clusterId: e1,
                limit: t,
                offset: n
            }
        });
    }
    async _updateWorkerData() {
        if (this._isUpdatingWorker) return this._updatePromise;
        if (!this._hasPendingWorkerUpdate()) {
            (0, $1rqx5.Nr)(`No pending worker updates for GeoJSONSource ${this.id}.`);
            return;
        }
        let { data: e1, diff: t, updateCluster: n } = this._pendingWorkerUpdate, r = this._getLoadGeoJSONParameters(e1, t, n);
        e1 === void 0 ? t ? this._pendingWorkerUpdate.diff = void 0 : n && (this._pendingWorkerUpdate.updateCluster = void 0) : this._pendingWorkerUpdate.data = void 0, this._updatePromise = this._dispatchWorkerUpdate(r), await this._updatePromise;
    }
    async _getLoadGeoJSONParameters(e1, t, n) {
        let r = (0, $1rqx5.er)({
            type: this.type,
            source: this.id
        }, this.workerOptions);
        if (typeof e1 == `string`) return r.request = await this.map._requestManager.transformRequest($834619e78bbf578c$var$Rr.resolveURL(e1), `Source`), r.request.collectResourceTiming = this._collectResourceTiming, r;
        if (e1 !== void 0) return r.data = e1, r;
        if (t) return r.dataDiff = t, r;
        if (n) return r.updateCluster = !0, r;
    }
    async _dispatchWorkerUpdate(e1) {
        this._isUpdatingWorker = !0, this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataloading`));
        try {
            let t = await e1, n = await (await this.actorPromise).sendAsync({
                type: `LD`,
                data: t
            });
            if (this._isUpdatingWorker = !1, this._removed || n.abandoned) {
                this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataabort`));
                return;
            }
            n.data && (this._data = {
                geojson: n.data
            });
            let r = this._applyDiffToSource(t.dataDiff), i = this._getShouldReloadTileOptions(r), a = {};
            this._applyResourceTiming(a, n), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                ...a,
                sourceDataType: `metadata`
            })), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                ...a,
                sourceDataType: `content`,
                shouldReloadTileOptions: i
            }));
        } catch (e1) {
            if (this._isUpdatingWorker = !1, this._removed) {
                this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataabort`));
                return;
            }
            this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
        } finally{
            this._hasPendingWorkerUpdate() && await this._updateWorkerData();
        }
    }
    _applyResourceTiming(e1, t) {
        if (!this._collectResourceTiming) return;
        let n = t.resourceTiming?.[this.id];
        if (!n) return;
        let r = n.slice(0);
        r?.length && (0, $1rqx5.er)(e1, {
            resourceTiming: r
        });
    }
    _applyDiffToSource(e1) {
        if (!e1) return;
        let t = this._promoteIdKey;
        if (!this._data.url && !this._data.updateable) {
            let e1 = $834619e78bbf578c$var$Aa(this._data.geojson, t);
            if (!e1) throw Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
            this._data = {
                updateable: e1
            };
        }
        if (!this._data.updateable) return;
        let n = $834619e78bbf578c$var$ja(this._data.updateable, e1, t);
        if (!(e1.removeAll || this._options.cluster)) return n;
    }
    _getShouldReloadTileOptions(e1) {
        if (e1) return {
            affectedBounds: e1.filter(Boolean).map((e1)=>$834619e78bbf578c$var$za(e1))
        };
    }
    shouldReloadTile(e1, { affectedBounds: t }) {
        if (e1.state === `loading`) return !0;
        if (e1.state === `unloaded`) return !1;
        let { buffer: n, extent: r } = this.workerOptions.geojsonVtOptions, i = $834619e78bbf578c$var$Ba(e1.tileID.canonical, n / r);
        for (let e1 of t)if (i.intersects(e1)) return !0;
        return !1;
    }
    loaded() {
        return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
    }
    async loadTile(e1) {
        let t = e1.actor ? `RT` : `LT`;
        e1.actor = await this.actorPromise;
        let n = {
            type: this.type,
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            maxZoom: this.maxzoom,
            tileSize: this.tileSize,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity
        };
        e1.abortController = new AbortController;
        try {
            let r = await (await this.actorPromise).sendAsync({
                type: t,
                data: n
            }, e1.abortController);
            delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(r, this.map.painter, t === `RT`);
        } catch (t) {
            if (delete e1.abortController, e1.aborted || (0, $1rqx5.Mn)(t)) return;
            throw t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), await (await this.actorPromise).sendAsync({
            type: `RMT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    onRemove() {
        this._removed = !0, this.actorPromise.then((e1)=>e1.sendAsync({
                type: `RS`,
                data: {
                    type: this.type,
                    source: this.id
                }
            }));
    }
    serialize() {
        return (0, $1rqx5.er)({}, this._options, {
            type: this.type,
            data: this._data.updateable ? {
                type: `FeatureCollection`,
                features: Array.from(this._data.updateable.values())
            } : this._data.url || this._data.geojson
        });
    }
    hasTransition() {
        return !1;
    }
};
const $834619e78bbf578c$var$Ha = [
    0,
    0,
    1
], $834619e78bbf578c$var$Ua = (e1, t)=>({
        u_tl_parent: new (0, $1rqx5.Nt)(e1, t.u_tl_parent),
        u_scale_parent: new (0, $1rqx5.jt)(e1, t.u_scale_parent),
        u_buffer_scale: new (0, $1rqx5.jt)(e1, t.u_buffer_scale),
        u_image_warp: new (0, $1rqx5.Pt)(e1, t.u_image_warp),
        u_fade_t: new (0, $1rqx5.jt)(e1, t.u_fade_t),
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity),
        u_image0: new (0, $1rqx5.Mt)(e1, t.u_image0),
        u_image1: new (0, $1rqx5.Mt)(e1, t.u_image1),
        u_brightness_low: new (0, $1rqx5.jt)(e1, t.u_brightness_low),
        u_brightness_high: new (0, $1rqx5.jt)(e1, t.u_brightness_high),
        u_saturation_factor: new (0, $1rqx5.jt)(e1, t.u_saturation_factor),
        u_contrast_factor: new (0, $1rqx5.jt)(e1, t.u_contrast_factor),
        u_spin_weights: new (0, $1rqx5.Pt)(e1, t.u_spin_weights),
        u_coords_top: new (0, $1rqx5.Ft)(e1, t.u_coords_top),
        u_coords_bottom: new (0, $1rqx5.Ft)(e1, t.u_coords_bottom)
    }), $834619e78bbf578c$var$Wa = (e1, t, n, r, i, a)=>({
        u_tl_parent: e1,
        u_scale_parent: t,
        u_buffer_scale: 1,
        u_image_warp: a,
        u_fade_t: n.mix,
        u_opacity: n.opacity * r.paint.get(`raster-opacity`),
        u_image0: 0,
        u_image1: 1,
        u_brightness_low: r.paint.get(`raster-brightness-min`),
        u_brightness_high: r.paint.get(`raster-brightness-max`),
        u_saturation_factor: $834619e78bbf578c$var$qa(r.paint.get(`raster-saturation`)),
        u_contrast_factor: $834619e78bbf578c$var$Ka(r.paint.get(`raster-contrast`)),
        u_spin_weights: $834619e78bbf578c$var$Ga(r.paint.get(`raster-hue-rotate`)),
        u_coords_top: [
            i[0].x,
            i[0].y,
            i[1].x,
            i[1].y
        ],
        u_coords_bottom: [
            i[3].x,
            i[3].y,
            i[2].x,
            i[2].y
        ]
    });
function $834619e78bbf578c$var$Ga(e1) {
    e1 *= Math.PI / 180;
    let t = Math.sin(e1), n = Math.cos(e1);
    return [
        (2 * n + 1) / 3,
        (-Math.sqrt(3) * t - n + 1) / 3,
        (Math.sqrt(3) * t - n + 1) / 3
    ];
}
function $834619e78bbf578c$var$Ka(e1) {
    return e1 > 0 ? 1 / (1 - e1) : 1 + e1;
}
function $834619e78bbf578c$var$qa(e1) {
    return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
}
var $834619e78bbf578c$var$Ja = class {
    constructor(e1, t, n){
        this.vertexBuffer = e1, this.indexBuffer = t, this.segments = n;
    }
    destroy() {
        this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
    }
};
const $834619e78bbf578c$var$Ya = (0, $1rqx5.Yt)([
    {
        name: `a_pos`,
        type: `Int16`,
        components: 2
    }
]), $834619e78bbf578c$var$Xa = (0, $1rqx5.Lr) / 128;
function $834619e78bbf578c$var$Za(e1, t) {
    let n = $834619e78bbf578c$export$54e626fcf5dbddb3(t, `16bit`), r = (0, $1rqx5.Gt).deserialize({
        arrayBuffer: n.vertices,
        length: n.vertices.byteLength / 2 / 2
    }), i = (0, $1rqx5.Jt).deserialize({
        arrayBuffer: n.indices,
        length: n.indices.byteLength / 2 / 3
    });
    return new $834619e78bbf578c$var$Ja(e1.createVertexBuffer(r, $834619e78bbf578c$var$Ya.members), e1.createIndexBuffer(i), (0, $1rqx5.Bt).simpleSegment(0, 0, r.length, i.length));
}
function $834619e78bbf578c$export$54e626fcf5dbddb3(e1, t) {
    let n = e1.granularity === void 0 ? 1 : Math.max(e1.granularity, 1), r = n + (e1.generateBorders ? 2 : 0), i = n + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), a = r + 1, o = i + 1, s = e1.generateBorders ? -1 : 0, c = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, l = n + +!!e1.generateBorders, u = n + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), d = a * o, f = r * i * 6, p = a * o > 65536;
    if (p && t === `16bit`) throw Error(`Granularity is too large and meshes would not fit inside 16 bit vertex indices.`);
    let m = p || t === `32bit`, h = new Int16Array(d * 2), g = 0;
    for(let t = c; t <= u; t++)for(let r = s; r <= l; r++){
        let i = r / n * (0, $1rqx5.Lr);
        r === -1 && (i = -$834619e78bbf578c$var$Xa), r === n + 1 && (i = (0, $1rqx5.Lr) + $834619e78bbf578c$var$Xa);
        let a = t / n * (0, $1rqx5.Lr);
        t === -1 && (a = e1.extendToNorthPole ? (0, $1rqx5.ht) : -$834619e78bbf578c$var$Xa), t === n + 1 && (a = e1.extendToSouthPole ? (0, $1rqx5.gt) : (0, $1rqx5.Lr) + $834619e78bbf578c$var$Xa), h[g++] = i, h[g++] = a;
    }
    let _ = m ? new Uint32Array(f) : new Uint16Array(f), v = 0;
    for(let e1 = 0; e1 < i; e1++)for(let t = 0; t < r; t++){
        let n = t + e1 * a, r = t + 1 + e1 * a, i = t + (e1 + 1) * a, o = t + 1 + (e1 + 1) * a;
        _[v++] = n, _[v++] = i, _[v++] = r, _[v++] = r, _[v++] = i, _[v++] = o;
    }
    return {
        vertices: h.buffer.slice(0),
        indices: _.buffer.slice(0),
        uses32bitIndices: m
    };
}
var $834619e78bbf578c$export$280e9a68c3ffd919 = class extends (0, $1rqx5.vn) {
    constructor(e1, t, n, r){
        super(), this.imageWarp = $834619e78bbf578c$var$Ha, this.flippedWindingOrder = !1, this._warp = `auto`, this._imageDirty = !1, this._subdividedQuad = !1, this._subdividedMesh = null, this.id = e1, this.dispatcher = n, this.coordinates = t.coordinates, this.type = `image`, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(r), this.options = t;
    }
    async load(e1) {
        if (this.options.url === void 0) {
            this._loaded = !0, this._finishLoading();
            return;
        }
        this._loaded = !1, this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataloading`)), this.url = this.options.url, this._abortController = new AbortController;
        try {
            let t = await $834619e78bbf578c$var$Yr.transformAndGetImage(this.map._requestManager, this.url, `Image`, this._abortController);
            this._abortController = null, this._loaded = !0, t?.data ? (this._setImage(t.data), e1 && (this.coordinates = e1), this._finishLoading()) : this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Could not load image ${this.url}: the response is empty`)));
        } catch (e1) {
            if ((0, $1rqx5.Mn)(e1)) return;
            this._abortController = null, this._loaded = !0, this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    updateImage(e1) {
        return this._abortController &&= (this._abortController.abort(), null), `image` in e1 ? (this._loaded = !0, this._setImage(e1.image), e1.coordinates && (this.coordinates = e1.coordinates), this._finishLoading(), this) : e1.url ? (this.options.url = e1.url, this.load(e1.coordinates), this) : this;
    }
    _setImage(e1) {
        this.image = e1, this._imageDirty = !0;
    }
    getMesh(e1, t) {
        return !this._subdividedQuad || t ? null : (this._subdividedMesh ??= $834619e78bbf578c$var$Za(e1, {
            granularity: 16
        }), this._subdividedMesh);
    }
    _disposeTexture() {
        this.texture?.destroy(), this.texture = null;
    }
    _finishLoading() {
        this.map && (this.setCoordinates(this.coordinates), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `metadata`
        })));
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._abortController &&= (this._abortController.abort(), null), this._disposeTexture(), this._subdividedMesh?.destroy(), this._subdividedMesh = null, this.image = null, this.tiles = {};
    }
    setWarp(e1) {
        return this._warp === e1 ? this : (this._warp = e1, this.tileCoords && this.setCoordinates(this.coordinates), this);
    }
    getWarp() {
        return this._warp;
    }
    setCoordinates(e1) {
        this.coordinates = e1;
        let t = e1.map((0, $1rqx5.nt).fromLngLat);
        return this.tileID = $834619e78bbf578c$var$eo(t), this.terrainTileRanges = this._getOverlappingTileRanges(t), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = t.map((e1)=>this.tileID.getTilePoint(e1)._round()), this.imageWarp = $834619e78bbf578c$var$no(this.tileCoords, this._warp), this._subdividedQuad = this.imageWarp[2] > 0 && !$834619e78bbf578c$var$io(this.tileCoords), this.flippedWindingOrder = $834619e78bbf578c$var$to(this.tileCoords), this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `content`
        })), this;
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || !this.image) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this._imageDirty && (this.texture.update(this.image), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE)) : (this.texture = new (0, $1rqx5.xt)(e1, this.image, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE)), this._imageDirty = !1;
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, n = !0);
        }
        n && this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    async loadTile(e1) {
        this.tileID?.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = `errored`;
    }
    serialize() {
        let e1 = {
            type: `image`,
            coordinates: this.coordinates
        };
        return this.options.url !== void 0 && (e1.url = this.options.url), e1;
    }
    hasTransition() {
        return !1;
    }
    _getOverlappingTileRanges(e1) {
        let { minX: t, minY: n, maxX: r, maxY: i } = (0, $1rqx5.pt).fromPoints(e1), a = {};
        for(let e1 = 0; e1 <= 25; e1++){
            let o = 2 ** e1, s = Math.floor(t * o), c = Math.floor(n * o), l = Math.floor(r * o), u = Math.floor(i * o), d = (s % o + o) % o, f = l % o, p = Math.floor(s / o), m = Math.floor(l / o);
            a[e1] = {
                minWrap: p,
                maxWrap: m,
                minTileXWrapped: d,
                maxTileXWrapped: f,
                minTileY: c,
                maxTileY: u
            };
        }
        return a;
    }
};
function $834619e78bbf578c$var$eo(e1) {
    let t = (0, $1rqx5.pt).fromPoints(e1), n = t.width(), r = t.height(), i = Math.max(0, Math.floor(-Math.log(Math.max(n, r)) / Math.LN2)), a = 2 ** i;
    return new (0, $1rqx5.u)(i, Math.floor((t.minX + t.maxX) / 2 * a), Math.floor((t.minY + t.maxY) / 2 * a));
}
function $834619e78bbf578c$var$to(e1) {
    let t = e1[1].x - e1[0].x, n = e1[1].y - e1[0].y, r = e1[2].x - e1[0].x;
    return t * (e1[2].y - e1[0].y) - n * r < 0;
}
function $834619e78bbf578c$var$no(e1, t) {
    if (t === `flat` || $834619e78bbf578c$var$io(e1)) return $834619e78bbf578c$var$Ha;
    let [n, r, i, a] = e1, o = n.x - r.x + i.x - a.x, s = n.y - r.y + i.y - a.y, c = [
        r.x - i.x,
        r.y - i.y,
        a.x - i.x,
        a.y - i.y
    ], [l, u, d, f] = c, p = $834619e78bbf578c$var$Nr(c), m = (o * f - d * s) / p, h = (l * s - o * u) / p, g = [
        1,
        1 + m,
        1 + m + h,
        1 + h
    ], _ = Math.max(...g) / Math.min(...g), v = t === `perspective` ? 0 : $834619e78bbf578c$var$ro(_);
    return !(_ >= 1 && _ <= 512) || v >= 1 ? $834619e78bbf578c$var$Ha : [
        m,
        h,
        v
    ];
}
function $834619e78bbf578c$var$ro(e1) {
    let t = (1 - 4 / e1) / (1 - 4 / 512);
    return Math.max(0, t);
}
function $834619e78bbf578c$var$io(e1) {
    let [t, n, r, i] = e1;
    return t.x + r.x === n.x + i.x && t.y + r.y === n.y + i.y;
}
var $834619e78bbf578c$export$f3a17123d80000c5 = class extends $834619e78bbf578c$export$280e9a68c3ffd919 {
    constructor(e1, t, n, r){
        super(e1, t, n, r), this._onPlayingHandler = ()=>{
            this.map?.triggerRepaint();
        }, this.roundZoom = !0, this.type = `video`, this.options = t;
    }
    async load() {
        this._loaded = !1;
        let e1 = this.options;
        this.urls = [];
        for (let t of e1.urls)this.urls.push((await this.map._requestManager.transformRequest(t, `Source`)).url);
        try {
            let e1 = await (0, $1rqx5.wn)(this.urls);
            if (this._loaded = !0, !e1) return;
            this.video = e1, this.video.loop = !0, this.video.addEventListener(`playing`, this._onPlayingHandler), this.map && this.video.play(), this._finishLoading();
        } catch (e1) {
            this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
        }
    }
    pause() {
        this.video && this.video.pause();
    }
    play() {
        this.video && this.video.play();
    }
    seek(e1) {
        if (this.video) {
            let t = this.video.seekable;
            e1 < t.start(0) || e1 > t.end(0) ? this.fire(new (0, $1rqx5.gn)(new (0, $1rqx5.pn)(`sources.${this.id}`, null, `Playback for this video can be set only between the ${t.start(0)} and ${t.end(0)}-second mark.`))) : this.video.currentTime = e1;
        }
    }
    getVideo() {
        return this.video;
    }
    onAdd(e1) {
        this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
    }
    onRemove() {
        super.onRemove(), this.video && (this.video.removeEventListener(`playing`, this._onPlayingHandler), this.video.pause());
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this.video.paused || (this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, t.RGBA, t.UNSIGNED_BYTE, this.video)) : (this.texture = new (0, $1rqx5.xt)(e1, this.video, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE));
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, n = !0);
        }
        n && this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: `video`,
            urls: this.urls,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this.video && !this.video.paused;
    }
}, $834619e78bbf578c$export$ca65ccf5708c6a0c = class extends $834619e78bbf578c$export$280e9a68c3ffd919 {
    constructor(e1, t, n, r){
        super(e1, t, n, r), t.coordinates ? (!Array.isArray(t.coordinates) || t.coordinates.length !== 4 || t.coordinates.some((e1)=>!Array.isArray(e1) || e1.length !== 2 || e1.some((e1)=>typeof e1 != `number`))) && this.fire(new (0, $1rqx5.gn)(new (0, $1rqx5.pn)(`sources.${e1}`, null, `"coordinates" property must be an array of 4 longitude/latitude array pairs`))) : this.fire(new (0, $1rqx5.gn)(new (0, $1rqx5.pn)(`sources.${e1}`, null, `missing required property "coordinates"`))), t.animate && typeof t.animate != `boolean` && this.fire(new (0, $1rqx5.gn)(new (0, $1rqx5.pn)(`sources.${e1}`, null, `optional "animate" property must be a boolean value`))), t.canvas ? typeof t.canvas != `string` && !(t.canvas instanceof HTMLCanvasElement) && this.fire(new (0, $1rqx5.gn)(new (0, $1rqx5.pn)(`sources.${e1}`, null, `"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance`))) : this.fire(new (0, $1rqx5.gn)(new (0, $1rqx5.pn)(`sources.${e1}`, null, `missing required property "canvas"`))), this.options = t, this.animate = t.animate === void 0 || t.animate;
    }
    async load() {
        if (this._loaded = !0, this.canvas ||= this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions()) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Canvas dimensions cannot be less than or equal to zero.`)));
            return;
        }
        this.play = function() {
            this._playing = !0, this.map.triggerRepaint();
        }, this.pause = function() {
            this._playing &&= (this.prepare(), !1);
        }, this._finishLoading();
    }
    getCanvas() {
        return this.canvas;
    }
    onAdd(e1) {
        this.map = e1, this.load(), this.canvas && this.animate && this.play();
    }
    onRemove() {
        this._playing = !1, super.onRemove();
    }
    prepare() {
        let e1 = !1;
        if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions() || Object.keys(this.tiles).length === 0) return;
        let t = this.map.painter.context, n = t.gl;
        this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
            premultiply: !0
        }) : (this.texture = new (0, $1rqx5.xt)(t, this.canvas, n.RGBA, {
            premultiply: !0
        }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE));
        let r = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, r = !0);
        }
        r && this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: `canvas`,
            animate: this.animate,
            canvas: this.options.canvas,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this._playing;
    }
    _hasInvalidDimensions() {
        for (let e1 of [
            this.canvas.width,
            this.canvas.height
        ])if (isNaN(e1) || e1 <= 0) return !0;
        return !1;
    }
};
const $834619e78bbf578c$var$so = {}, $834619e78bbf578c$var$co = (e1, t, n, r)=>{
    let i = new ($834619e78bbf578c$var$lo(t.type))(e1, t, n, r);
    if (i.id !== e1) throw Error(`Expected Source id to be ${e1} instead of ${i.id}`);
    return i;
}, $834619e78bbf578c$var$lo = (e1)=>{
    switch(e1){
        case `geojson`:
            return $834619e78bbf578c$export$8a9e6af3bfd58eb9;
        case `image`:
            return $834619e78bbf578c$export$280e9a68c3ffd919;
        case `raster`:
            return $834619e78bbf578c$export$908e4015b805db3c;
        case `raster-dem`:
            return $834619e78bbf578c$export$12673e0db63b98e3;
        case `vector`:
            return $834619e78bbf578c$export$5feeb63c172810c5;
        case `video`:
            return $834619e78bbf578c$export$f3a17123d80000c5;
        case `canvas`:
            return $834619e78bbf578c$export$ca65ccf5708c6a0c;
    }
    return $834619e78bbf578c$var$so[e1];
}, $834619e78bbf578c$var$uo = (e1, t)=>{
    $834619e78bbf578c$var$so[e1] = t;
}, $834619e78bbf578c$export$10a8414b48d62ec3 = async (e1, t)=>{
    if ($834619e78bbf578c$var$lo(e1)) throw Error(`A source type called "${e1}" already exists.`);
    $834619e78bbf578c$var$uo(e1, t);
};
function $834619e78bbf578c$var$po(e1, t) {
    let n = {};
    if (!t) return n;
    for (let r of e1){
        let e1 = r.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
        if (e1.length !== 0) {
            r.layers = e1, r.stateDependentLayerIds && (r.stateDependentLayers = r.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
            for (let t of e1)n[t.id] = r;
        }
    }
    return n;
}
const $834619e78bbf578c$var$mo = `RTLPluginLoaded`;
var $834619e78bbf578c$var$ho = class extends (0, $1rqx5.vn) {
    constructor(...e1){
        super(...e1), this.status = `unavailable`, this.url = null, this.dispatcher = $834619e78bbf578c$export$6f0c702cbe7d6ed8();
    }
    _syncState(e1) {
        return this.status = e1, this.dispatcher.broadcast(`SRPS`, {
            pluginStatus: e1,
            pluginURL: this.url
        }).catch((e1)=>{
            throw this.status = `error`, e1;
        });
    }
    getRTLTextPluginStatus() {
        return this.status;
    }
    clearRTLTextPlugin() {
        this.status = `unavailable`, this.url = null;
    }
    async setRTLTextPlugin(e1, t = !1) {
        if (this.url) throw Error(`setRTLTextPlugin cannot be called multiple times.`);
        if (this.url = $834619e78bbf578c$var$Rr.resolveURL(e1), !this.url) throw Error(`requested url ${e1} is invalid`);
        if (this.status === `unavailable`) {
            if (t) this.status = `deferred`, this._syncState(this.status);
            else return this._requestImport();
        } else if (this.status === `requested`) return this._requestImport();
    }
    async _requestImport() {
        await this._syncState(`loading`), this.status = `loaded`, this.fire(new (0, $1rqx5._n)($834619e78bbf578c$var$mo));
    }
    lazyLoad() {
        this.status === `unavailable` ? this.status = `requested` : this.status === `deferred` && this._requestImport();
    }
};
let $834619e78bbf578c$var$go = null;
function $834619e78bbf578c$var$_o() {
    return $834619e78bbf578c$var$go ||= new $834619e78bbf578c$var$ho, $834619e78bbf578c$var$go;
}
var $834619e78bbf578c$var$vo = class {
    constructor(e1, t){
        this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = (0, $1rqx5.Mr)(), this.uses = 0, this.tileSize = t, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rttObjects = [], this.rttFingerprint = {}, this.expiredRequestCount = 0, this.state = `loading`, this.featureStateRevision = -1;
    }
    isRenderable(e1) {
        return this.hasData() && (!this.fadeEndTime || this.fadingDirection !== 0 || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
    }
    setCrossFadeLogic({ fadingRole: e1, fadingDirection: t, fadingParentID: n, fadeEndTime: r }) {
        this.resetFadeLogic(), this.fadingRole = e1, this.fadingDirection = t, this.fadingParentID = n, this.fadeEndTime = r;
    }
    setSelfFadeLogic(e1) {
        this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
    }
    resetFadeLogic() {
        this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = $834619e78bbf578c$export$461939dd4422153(), this.fadeEndTime = 0, this.fadeOpacity = 1;
    }
    wasRequested() {
        return this.state === `errored` || this.state === `loaded` || this.state === `reloading`;
    }
    clearTextures(e1) {
        this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
    }
    getRTT(e1) {
        return this.rttObjects[e1];
    }
    acquireRTT(e1, t, n) {
        return this.rttObjects[t] = e1.acquireRTT(n);
    }
    releaseRTT(e1) {
        if (this.rttObjects.length !== 0) {
            for (let t of this.rttObjects)t && e1.releaseRTT(t);
            this.rttObjects.length = 0;
        }
    }
    loadVectorData(e1, t, n) {
        if (e1?.etagUnmodified === !0) {
            this.state = `loaded`;
            return;
        }
        if (this.hasData() && this.unloadVectorData(), this.state = `loaded`, !e1) {
            this.collisionBoxArray = new (0, $1rqx5.Vt);
            return;
        }
        e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestEncoding = e1.encoding, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = $834619e78bbf578c$var$po(e1.buckets, t?.style), this.hasSymbolBuckets = !1;
        for(let e1 in this.buckets){
            let t = this.buckets[e1];
            if (t instanceof (0, $1rqx5.S)) {
                if (this.hasSymbolBuckets = !0, n) t.justReloaded = !0;
                else break;
            }
        }
        if (this.hasRTLText = !1, this.hasSymbolBuckets) for(let e1 in this.buckets){
            let t = this.buckets[e1];
            if (t instanceof (0, $1rqx5.S) && t.hasRTLText) {
                this.hasRTLText = !0, $834619e78bbf578c$var$_o().lazyLoad();
                break;
            }
        }
        this.queryPadding = 0;
        for(let e1 in this.buckets){
            let n = this.buckets[e1];
            this.queryPadding = Math.max(this.queryPadding, t.style.getLayer(e1).queryRadius(n));
        }
        e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
    }
    unloadVectorData() {
        for(let e1 in this.buckets)this.buckets[e1].destroy();
        this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.imageAtlas = null, this.dashPositions = null, this.latestFeatureIndex = null, this.state = `unloaded`;
    }
    getBucket(e1) {
        return this.buckets[e1.id];
    }
    upload(e1) {
        for(let t in this.buckets){
            let n = this.buckets[t];
            n.uploadPending() && n.upload(e1);
        }
        let t = e1.gl;
        this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new (0, $1rqx5.xt)(e1, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage &&= (this.glyphAtlasTexture = new (0, $1rqx5.xt)(e1, this.glyphAtlasImage, t.ALPHA), null);
    }
    prepare(e1) {
        this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
    }
    queryRenderedFeatures(e1, t, n, r, i, a, o, s, c, l, u) {
        return this.latestFeatureIndex?.rawTileData ? this.latestFeatureIndex.query({
            queryGeometry: r,
            cameraQueryGeometry: i,
            scale: a,
            tileSize: this.tileSize,
            pixelPosMatrix: l,
            transform: s,
            params: o,
            queryPadding: this.queryPadding * c,
            getElevation: u
        }, e1, t, n) : {};
    }
    querySourceFeatures(e1, t) {
        let n = this.latestFeatureIndex;
        if (!n?.rawTileData) return;
        let r = n.loadVTLayers(), i = t?.sourceLayer ? t.sourceLayer : ``, a = r._geojsonTileLayer || r[i];
        if (!a) return;
        let o = (0, $1rqx5.cn)(t?.filter, `querySourceFeatures[${i}].filter`, t?.globalState), { z: s, x: l, y: u } = this.tileID.canonical, d = {
            z: s,
            x: l,
            y: u
        };
        for(let t = 0; t < a.length; t++){
            let r = a.feature(t);
            if (o.needGeometry) {
                let e1 = (0, $1rqx5.At)(r, !0);
                if (!o.filter(new (0, $1rqx5.en)(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
            } else if (!o.filter(new (0, $1rqx5.en)(this.tileID.overscaledZ), r)) continue;
            let f = n.getId(r, i), p = new (0, $1rqx5.a)(r, s, l, u, f);
            p.tile = d, e1.push(p);
        }
    }
    hasData() {
        return this.state === `loaded` || this.state === `reloading` || this.state === `expired`;
    }
    patternsLoaded() {
        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
    }
    setExpiryData(e1) {
        let t = this.expirationTime;
        if (e1.cacheControl) {
            let t = (0, $1rqx5.vr)(e1.cacheControl);
            t[`max-age`] && (this.expirationTime = Date.now() + t[`max-age`] * 1e3);
        } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
        if (this.expirationTime) {
            let e1 = Date.now(), n = !1;
            if (this.expirationTime > e1) n = !1;
            else if (!t) n = !0;
            else if (this.expirationTime < t) n = !0;
            else {
                let r = this.expirationTime - t;
                r ? this.expirationTime = e1 + Math.max(r, 3e4) : n = !0;
            }
            n ? (this.expiredRequestCount++, this.state = `expired`) : this.expiredRequestCount = 0;
        }
    }
    getExpiryTimeout() {
        if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - /* @__PURE__ */ new Date().getTime(), 2 ** 31 - 1);
    }
    setFeatureState(e1, t, n) {
        if (!this.latestFeatureIndex?.rawTileData || Object.keys(e1).length === 0 || this.featureStateRevision === n) return;
        this.featureStateRevision = n;
        let r = this.latestFeatureIndex.loadVTLayers();
        for(let n in this.buckets){
            if (!t.style.hasLayer(n)) continue;
            let i = this.buckets[n], a = i.layers[0].sourceLayer || `_geojsonTileLayer`, o = r[a], s = e1[a];
            if (!o || !s || s.length === 0) continue;
            i.update(s, o, this.imageAtlas?.patternPositions || {}, this.dashPositions || {});
            let c = t?.style?.getLayer(n);
            c && (this.queryPadding = Math.max(this.queryPadding, c.queryRadius(i)));
        }
    }
    holdingForSymbolFade() {
        return this.symbolFadeHoldUntil !== void 0;
    }
    symbolFadeFinished() {
        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < $834619e78bbf578c$export$461939dd4422153();
    }
    clearSymbolFadeHold() {
        this.symbolFadeHoldUntil = void 0;
    }
    setSymbolHoldDuration(e1) {
        this.symbolFadeHoldUntil = $834619e78bbf578c$export$461939dd4422153() + e1;
    }
    setDependencies(e1, t) {
        let n = {};
        for (let e1 of t)n[e1] = !0;
        this.dependencies[e1] = n;
    }
    hasDependency(e1, t) {
        for (let n of e1){
            let e1 = this.dependencies[n];
            if (e1) {
                for (let n of t)if (e1[n]) return !0;
            }
        }
        return !1;
    }
};
function $834619e78bbf578c$var$yo(e1) {
    let t = [];
    for(let n in e1)t.push({
        id: n,
        state: e1[n]
    });
    return t;
}
var $834619e78bbf578c$var$bo = class {
    constructor(){
        this.state = {}, this.stateChanges = {}, this.deletedStates = {}, this.revision = 0;
    }
    updateState(e1, t, n) {
        let r = String(t);
        if (this.stateChanges[e1] ||= {}, this.stateChanges[e1][r] ||= {}, (0, $1rqx5.er)(this.stateChanges[e1][r], n), this.deletedStates[e1] === null) {
            this.deletedStates[e1] = {};
            for(let t in this.state[e1])if (t === r) {
                this.deletedStates[e1][r] = {};
                for(let i in this.state[e1][t])n[i] === void 0 && (this.deletedStates[e1][r][i] = null);
            } else this.deletedStates[e1][t] = null;
        } else if (this.deletedStates[e1]?.[r] === null) {
            this.deletedStates[e1][r] = {};
            for(let t in this.state[e1][r])n[t] === void 0 && (this.deletedStates[e1][r][t] = null);
        } else for(let t in n)this.deletedStates[e1]?.[r]?.[t] === null && delete this.deletedStates[e1][r][t];
    }
    removeFeatureState(e1, t, n) {
        if (this.deletedStates[e1] === null) return;
        let r = String(t);
        if (this.deletedStates[e1] ||= {}, n && t !== void 0) this.deletedStates[e1][r] !== null && (this.deletedStates[e1][r] ||= {}, this.deletedStates[e1][r][n] = null);
        else if (t !== void 0) {
            if (this.stateChanges[e1]?.[r]) for(n in this.deletedStates[e1][r] = {}, this.stateChanges[e1][r])this.deletedStates[e1][r][n] = null;
            else this.deletedStates[e1][r] = null;
        } else this.deletedStates[e1] = null;
    }
    getState(e1, t) {
        let n = String(t), r = this.state[e1] || {}, i = this.stateChanges[e1] || {}, a = (0, $1rqx5.er)({}, r[n], i[n]);
        if (this.deletedStates[e1] === null) return {};
        if (this.deletedStates[e1]) {
            let n = this.deletedStates[e1][t];
            if (n === null) return {};
            for(let e1 in n)delete a[e1];
        }
        return a;
    }
    initializeTileState(e1, t) {
        let n = {};
        for(let e1 in this.state)n[e1] = $834619e78bbf578c$var$yo(this.state[e1]);
        e1.setFeatureState(n, t, this.revision);
    }
    coalesceChanges(e1, t) {
        let n = {};
        for(let e1 in this.stateChanges){
            this.state[e1] ||= {}, n[e1] ||= {};
            for(let t in this.stateChanges[e1])this.state[e1][t] ||= {}, (0, $1rqx5.er)(this.state[e1][t], this.stateChanges[e1][t]), n[e1][t] = this.state[e1][t];
        }
        for(let e1 in this.deletedStates)if (this.state[e1] ||= {}, n[e1] ||= {}, this.deletedStates[e1] === null) for(let t in this.state[e1])this.state[e1][t] = {}, n[e1][t] = {};
        else for(let t in this.deletedStates[e1]){
            if (this.deletedStates[e1][t] === null) this.state[e1][t] = {};
            else for (let n of Object.keys(this.deletedStates[e1][t]))delete this.state[e1][t][n];
            n[e1][t] = this.state[e1][t];
        }
        if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(n).length === 0) return;
        this.revision++;
        let r = {};
        for(let e1 in n)r[e1] = $834619e78bbf578c$var$yo(n[e1]);
        e1.setFeatureState(r, t, this.revision);
    }
}, $834619e78bbf578c$var$xo = class e1 {
    constructor(e1, t){
        this.min = e1, this.max = t, this.center = (0, $1rqx5.ci)([], (0, $1rqx5.Xr)([], this.min, this.max), .5);
    }
    quadrant(t) {
        let n = [
            t % 2 == 0,
            t < 2
        ], r = (0, $1rqx5.Zr)(this.min), i = (0, $1rqx5.Zr)(this.max);
        for(let e1 = 0; e1 < n.length; e1++)r[e1] = n[e1] ? this.min[e1] : this.center[e1], i[e1] = n[e1] ? this.center[e1] : this.max[e1];
        return i[2] = this.max[2], new e1(r, i);
    }
    distanceX(e1) {
        return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
    }
    distanceY(e1) {
        return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
    }
    intersectsFrustum(e1) {
        let t = !0;
        for (let n of e1.planes){
            let e1 = this.intersectsPlane(n);
            if (e1 === 0) return 0;
            e1 === 1 && (t = !1);
        }
        return t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
    }
    intersectsPlane(e1) {
        let t = e1[3], n = e1[3];
        for(let r = 0; r < 3; r++)e1[r] > 0 ? (t += e1[r] * this.min[r], n += e1[r] * this.max[r]) : (n += e1[r] * this.min[r], t += e1[r] * this.max[r]);
        return t >= 0 ? 2 : n < 0 ? 0 : 1;
    }
}, $834619e78bbf578c$var$So = class e1 {
    constructor(e1, t, n){
        this.points = e1, this.planes = t, this.aabb = n;
    }
    static fromInvProjectionMatrix(t, n = 1, r = 0, i, a) {
        let o = [
            [
                -1,
                1,
                -1,
                1
            ],
            [
                1,
                1,
                -1,
                1
            ],
            [
                1,
                -1,
                -1,
                1
            ],
            [
                -1,
                -1,
                -1,
                1
            ],
            [
                -1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1
            ],
            [
                1,
                -1,
                1,
                1
            ],
            [
                -1,
                -1,
                1,
                1
            ]
        ], s = a ? [
            [
                6,
                5,
                4
            ],
            [
                0,
                1,
                2
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ] : [
            [
                0,
                1,
                2
            ],
            [
                6,
                5,
                4
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ], c = 2 ** r, l = o.map((e1)=>$834619e78bbf578c$var$Co(e1, t, n, c));
        i && $834619e78bbf578c$var$wo(l, s[0], i, a);
        let u = s.map((e1)=>{
            let t = (0, $1rqx5.ui)([], l[e1[0]], l[e1[1]]), n = (0, $1rqx5.ui)([], l[e1[2]], l[e1[1]]), r = (0, $1rqx5.ii)([], (0, $1rqx5.Qr)([], t, n)), i = -(0, $1rqx5.ei)(r, l[e1[1]]);
            return r.concat(i);
        }), d = [
            1 / 0,
            1 / 0,
            1 / 0
        ], f = [
            -1 / 0,
            -1 / 0,
            -1 / 0
        ];
        for (let e1 of l)for(let t = 0; t < 3; t++)d[t] = Math.min(d[t], e1[t]), f[t] = Math.max(f[t], e1[t]);
        return new e1(l, u, new $834619e78bbf578c$var$xo(d, f));
    }
};
function $834619e78bbf578c$var$Co(e1, t, n, r) {
    let i = (0, $1rqx5.Yr)([], e1, t), a = 1 / i[3] / n * r;
    return (0, $1rqx5.qr)(i, i, [
        a,
        a,
        1 / i[3],
        a
    ]);
}
function $834619e78bbf578c$var$wo(e1, t, n, r) {
    let i = r ? 4 : 0, a = r ? 0 : 4, o = 0, s = [], c = [];
    for(let t = 0; t < 4; t++){
        let n = (0, $1rqx5.ui)([], e1[t + a], e1[t + i]), r = (0, $1rqx5.ni)(n);
        (0, $1rqx5.ci)(n, n, 1 / r), s.push(r), c.push(n);
    }
    for(let t = 0; t < 4; t++){
        let r = (0, $1rqx5.Sr)(e1[t + i], c[t], n);
        o = r !== null && r >= 0 ? Math.max(o, r) : Math.max(o, s[t]);
    }
    let l = $834619e78bbf578c$var$To(e1, t), u = $834619e78bbf578c$var$Eo(n, l);
    if (u !== null) {
        let e1 = u / (0, $1rqx5.ei)(c[0], l);
        o = Math.min(o, e1);
    }
    for(let t = 0; t < 4; t++){
        let n = Math.min(o, s[t]);
        e1[t + a] = [
            e1[t + i][0] + c[t][0] * n,
            e1[t + i][1] + c[t][1] * n,
            e1[t + i][2] + c[t][2] * n,
            1
        ];
    }
}
function $834619e78bbf578c$var$To(e1, t) {
    let n = (0, $1rqx5.ui)([], e1[t[0]], e1[t[1]]), r = (0, $1rqx5.ui)([], e1[t[2]], e1[t[1]]), i = [
        0,
        0,
        0,
        0
    ];
    return (0, $1rqx5.ii)(i, (0, $1rqx5.Qr)([], n, r)), i[3] = -(0, $1rqx5.ei)(i, e1[t[0]]), i;
}
function $834619e78bbf578c$var$Eo(e1, t) {
    let n = (0, $1rqx5.ti)(e1), r = (0, $1rqx5.Jr)([], e1, 1 / n), i = (0, $1rqx5.ui)([], t, (0, $1rqx5.ci)([], r, (0, $1rqx5.ei)(t, r))), a = (0, $1rqx5.ti)(i);
    if (a > 0) {
        let e1 = Math.sqrt(1 - r[3] * r[3]), n = (0, $1rqx5.ci)([], r, -r[3]), o = (0, $1rqx5.Xr)([], n, (0, $1rqx5.ci)([], i, e1 / a));
        return (0, $1rqx5.br)(t, o);
    }
    return null;
}
function $834619e78bbf578c$var$Do(e1, t, n) {
    let r = t.intersectsFrustum(e1);
    if (!n || r === 0) return r;
    let i = t.intersectsPlane(n);
    return i === 0 ? 0 : r === 2 && i === 2 ? 2 : 1;
}
function $834619e78bbf578c$var$Oo(e1, t, n) {
    let r = 0, i = (n - t) / 10;
    for(let a = 0; a < 10; a++){
        let o = t + (a + .5) / 10 * (n - t);
        r += i * Math.cos(o) ** +e1;
    }
    return r;
}
function $834619e78bbf578c$var$ko(e1, t) {
    return function(n, r, i, a, o) {
        let s = 2 * ((e1 - 1) / (0, $1rqx5.Dr)(Math.cos((0, $1rqx5.Yn)((0, $1rqx5.Q) - o)) / Math.cos((0, $1rqx5.Yn)((0, $1rqx5.Q)))) - 1), c = Math.acos(i / a), l = 2 * $834619e78bbf578c$var$Oo(s - 1, 0, (0, $1rqx5.Yn)(o / 2)), u = Math.min((0, $1rqx5.Yn)((0, $1rqx5.Q)), c + (0, $1rqx5.Yn)(o / 2)), d = Math.min(u, c - (0, $1rqx5.Yn)(o / 2)), f = $834619e78bbf578c$var$Oo(s - 1, d, u), p = Math.atan(r / i), m = Math.hypot(r, i), h = n;
        return h += (0, $1rqx5.Dr)(a / m / Math.max(.5, Math.cos((0, $1rqx5.Yn)(o / 2)))), h += s * (0, $1rqx5.Dr)(Math.cos(p)) / 2, h -= (0, $1rqx5.Dr)(Math.max(1, f / l / t)) / 2, h;
    };
}
const $834619e78bbf578c$var$Ao = $834619e78bbf578c$var$ko(9.314, 3);
function $834619e78bbf578c$var$jo(e1, t) {
    let n = (t.roundZoom ? Math.round : Math.floor)(e1.zoom + (0, $1rqx5.Dr)(e1.tileSize / t.tileSize));
    return Math.max(0, n);
}
function $834619e78bbf578c$var$Mo(e1, t) {
    let n = (0, $1rqx5.Q) - e1.pitch - e1.fov / 2, r = (0, $1rqx5.Bn)((15 - n) / 15, 0, 1), i = Math.max(500, t ?? 0);
    return e1.elevation + r * i;
}
function $834619e78bbf578c$var$No(e1, t, n) {
    let r = e1.planes[1], i = e1.points.map((e1)=>{
        let i = r[0] * e1[0] + r[1] * e1[1] + r[2] * e1[2] + r[3];
        if (Math.abs(i) > 1e-6) return e1;
        let a = [
            e1[0] - n[0],
            e1[1] - n[1],
            e1[2] - n[2]
        ], o = r[0] * a[0] + r[1] * a[1] + r[2] * a[2];
        if (o >= -0.000000001) return e1;
        let s = t / -o;
        return [
            e1[0] + a[0] * s,
            e1[1] + a[1] * s,
            e1[2] + a[2] * s,
            e1[3]
        ];
    }), a = e1.planes.map((e1, n)=>n === 1 ? [
            e1[0],
            e1[1],
            e1[2],
            e1[3] + t
        ] : e1), o = [
        1 / 0,
        1 / 0,
        1 / 0
    ], s = [
        -1 / 0,
        -1 / 0,
        -1 / 0
    ];
    for (let e1 of i)for(let t = 0; t < 3; t++)o[t] = Math.min(o[t], e1[t]), s[t] = Math.max(s[t], e1[t]);
    return new $834619e78bbf578c$var$So(i, a, new $834619e78bbf578c$var$xo(o, s));
}
function $834619e78bbf578c$var$Po(e1, t, n, r) {
    let i = Math.hypot(t[0], t[1], t[2]);
    if (i === 0) return {
        frustum: e1,
        plane: t
    };
    let a = 1 + r / (0, $1rqx5.ut), o = (0, $1rqx5.Bn)(-t[3] / i, -1, 1), s = Math.cos(Math.acos(o) + Math.acos(1 / a));
    return {
        frustum: $834619e78bbf578c$var$No(e1, Math.sqrt(a * a - 1), n),
        plane: [
            t[0],
            t[1],
            t[2],
            -s * i
        ]
    };
}
function $834619e78bbf578c$var$Fo(e1, t) {
    let n = e1.getCameraFrustum(), r = e1.getClippingPlane();
    r && t.maxContentElevation > 0 && ({ frustum: n, plane: r } = $834619e78bbf578c$var$Po(n, r, e1.cameraPosition, t.maxContentElevation));
    let i = (0, $1rqx5.Y)(e1), a = (0, $1rqx5.nt).fromLngLat(e1.center, e1.elevation), o = $834619e78bbf578c$var$Mo(e1, t.maxContentElevation), s = e1.getCoveringTilesDetailsProvider(), c = s.allowVariableZoom(e1, t), l = $834619e78bbf578c$var$jo(e1, t), u = t.minzoom || 0, d = t.maxzoom === void 0 ? e1.maxZoom : t.maxzoom, f = Math.min(Math.max(0, l), d), p = 2 ** f, m = [
        p * i.x,
        p * i.y,
        0
    ], h = [
        p * a.x,
        p * a.y,
        0
    ], g = Math.hypot(a.x - i.x, a.y - i.y), _ = Math.abs(a.z - i.z), v = Math.hypot(g, _), y = (e1)=>({
            zoom: 0,
            x: 0,
            y: 0,
            wrap: e1,
            fullyVisible: !1
        }), x = [], S = [];
    if (e1.renderWorldCopies && s.allowWorldCopies()) for(let e1 = 1; e1 <= 3; e1++)x.push(y(-e1)), x.push(y(e1));
    for(x.push(y(0)); x.length > 0;){
        let p = x.pop(), g = p.x, y = p.y, C = p.fullyVisible, w = {
            x: g,
            y: y,
            z: p.zoom
        }, T = s.getTileBoundingVolume(w, p.wrap, o, t);
        if (!C) {
            let e1 = $834619e78bbf578c$var$Do(n, T, r);
            if (e1 === 0) continue;
            C = e1 === 2;
        }
        let E = s.distanceToTile2d(i.x, i.y, w, T), D = l;
        c && (D = (t.calculateTileZoom || $834619e78bbf578c$var$Ao)(e1.zoom + (0, $1rqx5.Dr)(e1.tileSize / t.tileSize), E, _, v, e1.fov)), D = (t.roundZoom ? Math.round : Math.floor)(D), D = Math.max(0, D);
        let O = Math.min(D, d);
        if (p.wrap = s.getWrap(a, w, p.wrap), p.zoom >= O) {
            if (p.zoom < u) continue;
            let e1 = f - p.zoom, n = m[0] - .5 - (g << e1), r = m[1] - .5 - (y << e1), i = t.reparseOverscaled ? Math.max(p.zoom, D) : p.zoom;
            S.push({
                tileID: new (0, $1rqx5.d)(p.zoom === d ? i : p.zoom, p.wrap, p.zoom, g, y),
                distanceSq: (0, $1rqx5.Vr)([
                    h[0] - .5 - g,
                    h[1] - .5 - y
                ]),
                tileDistanceToCamera: Math.sqrt(n * n + r * r)
            });
            continue;
        }
        for(let e1 = 0; e1 < 4; e1++){
            let t = (g << 1) + e1 % 2, n = (y << 1) + (e1 >> 1), r = p.zoom + 1;
            x.push({
                zoom: r,
                x: t,
                y: n,
                wrap: p.wrap,
                fullyVisible: C
            });
        }
    }
    return S.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
}
function $834619e78bbf578c$var$Io(e1) {
    return e1 === `raster` || e1 === `image` || e1 === `video`;
}
function $834619e78bbf578c$var$Lo(e1, t, n, r, i, a, o) {
    let s = $834619e78bbf578c$export$461939dd4422153(), c = (0, $1rqx5.ar)(t);
    for (let l of t){
        let t = e1.getTileById(l.key);
        (t.fadingDirection === 0 || t.fadeOpacity === 0) && t.resetFadeLogic(), !$834619e78bbf578c$var$Ro(e1, t, n, s, r, i, o) && ($834619e78bbf578c$var$zo(e1, t, n, s, a, o) || $834619e78bbf578c$var$Vo(t, c, s, o) || t.resetFadeLogic());
    }
}
function $834619e78bbf578c$var$Ro(e1, t, n, r, i, a, o) {
    if (!t.hasData()) return !1;
    let { tileID: s, fadingRole: c, fadingDirection: l, fadingParentID: u } = t;
    if (c === 0 && l === 1 && u) return n[u.key] = u, !0;
    let d = Math.max(s.overscaledZ - i, a);
    for(let i = s.overscaledZ - 1; i >= d; i--){
        let a = s.scaledTo(i), c = e1.getLoadedTile(a);
        if (c) return t.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 1,
            fadingParentID: c.tileID,
            fadeEndTime: r + o
        }), c.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 0,
            fadeEndTime: r + o
        }), n[a.key] = a, !0;
    }
    return !1;
}
function $834619e78bbf578c$var$zo(e1, t, n, r, i, a) {
    if (!t.hasData()) return !1;
    let o = t.tileID.children(i), s = $834619e78bbf578c$var$Bo(e1, t, o, n, r, i, a);
    if (s) return !0;
    for (let c of o)$834619e78bbf578c$var$Bo(e1, t, c.children(i), n, r, i, a) && (s = !0);
    return s;
}
function $834619e78bbf578c$var$Bo(e1, t, n, r, i, a, o) {
    if (n[0].overscaledZ >= a) return !1;
    let s = !1;
    for (let a of n){
        let n = e1.getLoadedTile(a);
        if (!n) continue;
        let { fadingRole: c, fadingDirection: l, fadingParentID: u } = n;
        (c !== 0 || l !== 0 || !u) && (n.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 0,
            fadingParentID: t.tileID,
            fadeEndTime: i + o
        }), t.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 1,
            fadeEndTime: i + o
        })), r[a.key] = a, s = !0;
    }
    return s;
}
function $834619e78bbf578c$var$Vo(e1, t, n, r) {
    let i = e1.tileID;
    if (e1.selfFading) return !0;
    if (e1.hasData()) return !1;
    if (t.has(i)) {
        let t = n + r;
        return e1.setSelfFadeLogic(t), !0;
    }
    return !1;
}
function $834619e78bbf578c$var$Ho(e1, t) {
    if (t <= 0) return !1;
    let n = $834619e78bbf578c$export$461939dd4422153();
    for (let t of e1.getAllTiles())if (t.fadeEndTime >= n) return !0;
    return !1;
}
function $834619e78bbf578c$var$Uo(e1, t) {
    let n = t.getRenderableIds();
    for (let r of n){
        if (!e1.neighboringTiles?.[r]) continue;
        let n = t.getTileById(r);
        e1.neighboringTiles[r].backfilled || $834619e78bbf578c$var$Wo(e1, n), !n.neighboringTiles?.[e1.tileID.key]?.backfilled && $834619e78bbf578c$var$Wo(n, e1);
    }
}
function $834619e78bbf578c$var$Wo(e1, t) {
    e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.needsColorReliefPrepare = !0;
    let n = t.tileID.canonical.x - e1.tileID.canonical.x, r = t.tileID.canonical.y - e1.tileID.canonical.y, i = 2 ** e1.tileID.canonical.z, a = t.tileID.key;
    (n !== 0 || r !== 0) && (Math.abs(r) > 1 || (Math.abs(n) > 1 && (Math.abs(n + i) === 1 ? n += i : Math.abs(n - i) === 1 && (n -= i)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, n, r), e1.neighboringTiles?.[a] && (e1.neighboringTiles[a].backfilled = !0))));
}
var $834619e78bbf578c$var$Go = class {
    constructor(){
        this._tiles = {};
    }
    handleWrapJump(e1) {
        let t = {};
        for(let n in this._tiles){
            let r = this._tiles[n];
            r.tileID = r.tileID.unwrapTo(r.tileID.wrap + e1), t[r.tileID.key] = r;
        }
        this._tiles = t;
    }
    setFeatureState(e1, t, n) {
        for(let r in this._tiles)this._tiles[r].setFeatureState(e1, t, n);
    }
    getAllTiles() {
        return Object.values(this._tiles);
    }
    getAllIds(e1 = !1) {
        return e1 ? Object.values(this._tiles).map((e1)=>e1.tileID).sort((0, $1rqx5.m)).map((e1)=>e1.key) : Object.keys(this._tiles);
    }
    getTileById(e1) {
        return this._tiles[e1];
    }
    setTile(e1, t) {
        this._tiles[e1] = t;
    }
    deleteTileById(e1) {
        delete this._tiles[e1];
    }
    getLoadedTile(e1) {
        let t = this.getTileById(e1.key);
        return t?.hasData() ? t : null;
    }
    isIdRenderable(e1, t = !1) {
        return this.getTileById(e1)?.isRenderable(t);
    }
    getRenderableIds(e1 = 0, t) {
        let n = [];
        for (let e1 of this.getAllIds())this.isIdRenderable(e1, t) && n.push(this.getTileById(e1));
        return t ? n.sort((t, n)=>{
            let r = t.tileID, i = n.tileID, a = new (0, $1rqx5.Li)(r.canonical.x, r.canonical.y)._rotate(-e1), o = new (0, $1rqx5.Li)(i.canonical.x, i.canonical.y)._rotate(-e1);
            return r.overscaledZ - i.overscaledZ || o.y - a.y || o.x - a.x;
        }).map((e1)=>e1.tileID.key) : n.map((e1)=>e1.tileID).sort((0, $1rqx5.m)).map((e1)=>e1.key);
    }
}, $834619e78bbf578c$var$Ko = class e1 extends (0, $1rqx5.vn) {
    static{
        this.maxUnderzooming = 10;
    }
    static{
        this.maxOverzooming = 3;
    }
    constructor(e1, t, n){
        super(), this._maxContentElevationSeen = 0, this.id = e1, this.dispatcher = n, this.on(`data`, (e1)=>{
            this._dataHandler(e1);
        }), this.on(`dataloading`, ()=>{
            this._sourceErrored = !1;
        }), this.on(`error`, ()=>{
            this._sourceErrored = this._source.loaded();
        }), this._source = $834619e78bbf578c$var$co(e1, t, n, this), this._inViewTiles = new $834619e78bbf578c$var$Go, this._outOfViewCache = new (0, $1rqx5.n)(0, (e1)=>this._unloadTile(e1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new $834619e78bbf578c$var$bo, this._didEmitContent = !1, this._updated = !1;
    }
    onAdd(e1) {
        this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, this._source?.onAdd && this._source.onAdd(e1);
    }
    onRemove(e1) {
        for (let e1 of this._inViewTiles.getAllTiles())e1.unloadVectorData();
        this.clearTiles(), this._source?.onRemove && this._source.onRemove(e1), this._inViewTiles = new $834619e78bbf578c$var$Go;
    }
    loaded() {
        if (this._sourceErrored) return !0;
        if (!this._sourceLoaded || !this._source.loaded()) return !1;
        if ((this.used !== void 0 || this.usedForTerrain !== void 0) && !this.used && !this.usedForTerrain) return !0;
        if (!this._updated) return !1;
        for (let e1 of this._inViewTiles.getAllTiles())if (e1.state !== `loaded` && e1.state !== `errored`) return !1;
        return !0;
    }
    getSource() {
        return this._source;
    }
    getState() {
        return this._state;
    }
    pause() {
        this._paused = !0;
    }
    resume() {
        if (!this._paused) return;
        let e1 = this._shouldReloadOnResume;
        this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
    }
    async _loadTile(e1, t, n, r) {
        try {
            let i = await this._source.loadTile(e1);
            this._tileLoaded(e1, t, n, r, i);
        } catch (t) {
            e1.state = `errored`, t.status === 404 ? this.update(this.transform, this.terrain) : this._source.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(t), {
                tile: e1
            }));
        }
    }
    _unloadTile(e1) {
        this._source.unloadTile && this._source.unloadTile(e1);
    }
    _abortTile(e1) {
        this._source.abortTile && this._source.abortTile(e1), this._source.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataabort`, {
            tile: e1,
            coord: e1.tileID
        }));
    }
    serialize() {
        return this._source.serialize();
    }
    prepare(e1) {
        this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
        for (let t of this._inViewTiles.getAllTiles())t.upload(e1), t.prepare(this.map.style.imageManager);
    }
    getIds() {
        return this._inViewTiles.getAllIds(!0);
    }
    getRenderableIds(e1) {
        return this._inViewTiles.getRenderableIds(this.transform?.bearingInRadians, e1);
    }
    hasRenderableParent(e1) {
        let t = e1.overscaledZ - 1;
        if (t >= this._source.minzoom) {
            let n = this.getLoadedTile(e1.scaledTo(t));
            if (n) return this._inViewTiles.isIdRenderable(n.tileID.key);
        }
        return !1;
    }
    reload(e1, t) {
        if (this._paused) {
            this._shouldReloadOnResume = !0;
            return;
        }
        this._outOfViewCache.reset();
        for (let n of this._inViewTiles.getAllIds()){
            let r = this._inViewTiles.getTileById(n);
            (!t || this._source.shouldReloadTile(r, t)) && (e1 ? this._reloadTile(n, r.state === `errored` ? `loading` : `expired`) : r.state !== `errored` && this._reloadTile(n, `reloading`));
        }
    }
    async _reloadTile(e1, t) {
        let n = this._inViewTiles.getTileById(e1);
        if (!n) return;
        let r = n.hasData();
        n.state !== `loading` && (n.state = t), await this._loadTile(n, e1, t, r);
    }
    _tileLoaded(e1, t, n, r, i) {
        r || (e1.timeAdded = $834619e78bbf578c$export$461939dd4422153(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration)), n === `expired` && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(t, e1), !i?.unmodified && (this.getSource().type === `raster-dem` && e1.dem && $834619e78bbf578c$var$Uo(e1, this._inViewTiles), e1.featureStateRevision = -1, this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            tile: e1,
            coord: e1.tileID
        })));
    }
    getTile(e1) {
        return this.getTileByID(e1.key);
    }
    getTileByID(e1) {
        return this._inViewTiles.getTileById(e1);
    }
    _retainLoadedChildren(t, n) {
        let r = this._getLoadedDescendents(n), i = /* @__PURE__ */ new Set;
        for (let a of n){
            let n = r[a.key];
            if (!n?.length) {
                i.add(a);
                continue;
            }
            let o = a.overscaledZ + e1.maxOverzooming, s = n.filter((e1)=>e1.tileID.overscaledZ <= o);
            if (!s.length) {
                i.add(a);
                continue;
            }
            let c = Math.min(...s.map((e1)=>e1.tileID.overscaledZ)), l = s.filter((e1)=>e1.tileID.overscaledZ === c).map((e1)=>e1.tileID);
            for (let e1 of l)t[e1.key] = e1;
            this._areDescendentsComplete(l, c, a.overscaledZ) || i.add(a);
        }
        return i;
    }
    _getLoadedDescendents(e1) {
        let t = {};
        for (let n of this._inViewTiles.getAllTiles().filter((e1)=>e1.hasData()))for (let r of e1)n.tileID.isChildOf(r) && (t[r.key] ||= [], t[r.key].push(n));
        return t;
    }
    _areDescendentsComplete(e1, t, n) {
        return e1.length === 1 && e1[0].isOverscaled() ? e1[0].overscaledZ === t : 4 ** (t - n) === e1.length;
    }
    getLoadedTile(e1) {
        return this._inViewTiles.getLoadedTile(e1);
    }
    updateCacheSize(e1) {
        let t = (Math.ceil(e1.width / this._source.tileSize) + 1) * (Math.ceil(e1.height / this._source.tileSize) + 1), n = this._maxTileCacheZoomLevels === null ? (0, $1rqx5.An).MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels, r = Math.floor(t * n), i = typeof this._maxTileCacheSize == `number` ? Math.min(this._maxTileCacheSize, r) : r;
        this._outOfViewCache.setMaxSize(i);
    }
    handleWrapJump(e1) {
        let t = (e1 - (this._prevLng === void 0 ? e1 : this._prevLng)) / 360, n = Math.round(t);
        this._prevLng = e1, n && (this._inViewTiles.handleWrapJump(n), this._resetTileReloadTimers());
    }
    _updateMaxContentElevation() {
        let e1 = this._maxContentElevationSeen, t = this.map?.style?._layers;
        if (!t) return e1;
        let n = this._inViewTiles.getAllTiles();
        for(let r in t){
            let i = t[r];
            if (i.type !== `symbol` || i.source !== this.id || i.isHidden(this.transform.zoom)) continue;
            let a = i;
            if (!a.layout) continue;
            let o = a.layout.get(`symbol-height-offset`);
            if (e1 = Math.max(e1, o.constantOr(0)), !o.isConstant()) for (let t of n){
                let n = t.getBucket(i);
                n && n.maxHeightOffset > e1 && (e1 = n.maxHeightOffset);
            }
        }
        return this._maxContentElevationSeen = e1, e1;
    }
    update(e1, t) {
        if (!this._sourceLoaded || this._paused) return;
        this.transform = e1, this.terrain = t, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng);
        let n;
        !this.used && !this.usedForTerrain ? n = [] : this._source.tileID ? n = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new (0, $1rqx5.d)(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (n = $834619e78bbf578c$var$Fo(e1, {
            tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
            minzoom: this._source.minzoom,
            maxzoom: this._source.type === `vector` && this.map._zoomLevelsToOverscale !== void 0 ? Math.max(this._source.maxzoom, e1.maxZoom - this.map._zoomLevelsToOverscale) : this._source.maxzoom,
            roundZoom: !this.usedForTerrain && this._source.roundZoom,
            reparseOverscaled: this._source.reparseOverscaled,
            terrain: t,
            calculateTileZoom: this._source.calculateTileZoom,
            maxContentElevation: this._updateMaxContentElevation()
        }), this._source.hasTile && (n = n.filter((e1)=>this._source.hasTile(e1)))), this.usedForTerrain && (n = this._addTerrainIdealTiles(n));
        let r = n.length === 0 && !this._updated && this._didEmitContent;
        this._updated = !0, r && this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
        let i = $834619e78bbf578c$var$jo(e1, this._source), a = this._updateRetainedTiles(n, i), o = $834619e78bbf578c$var$Io(this._source.type);
        o && this._rasterFadeDuration > 0 && !t && $834619e78bbf578c$var$Lo(this._inViewTiles, n, a, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), o ? this._cleanUpRasterTiles(a) : this._cleanUpVectorTiles(a);
    }
    _cleanUpRasterTiles(e1) {
        for (let t of this._inViewTiles.getAllIds())e1[t] || this._removeTile(t);
    }
    _cleanUpVectorTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let n = this._inViewTiles.getTileById(t);
            if (e1[t]) {
                n.clearSymbolFadeHold();
                continue;
            }
            if (!n.hasSymbolBuckets) {
                this._removeTile(t);
                continue;
            }
            n.holdingForSymbolFade() ? n.symbolFadeFinished() && this._removeTile(t) : n.setSymbolHoldDuration(this.map._fadeDuration);
        }
    }
    _addTerrainIdealTiles(e1) {
        let t = [];
        for (let n of e1)if (n.canonical.z > this._source.minzoom) {
            let e1 = n.scaledTo(n.canonical.z - 1);
            t.push(e1);
            let r = n.scaledTo(Math.max(this._source.minzoom, Math.min(n.canonical.z, 5)));
            t.push(r);
        }
        return e1.concat(t);
    }
    releaseSymbolFadeTiles() {
        for (let e1 of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(e1).holdingForSymbolFade() && this._removeTile(e1);
    }
    _updateRetainedTiles(t, n) {
        let r = /* @__PURE__ */ new Set;
        for (let e1 of t)this._addTile(e1).hasData() || r.add(e1);
        let i = t.reduce((e1, t)=>(e1[t.key] = t, e1), {}), a = this._retainLoadedChildren(i, r), o = {}, s = Math.max(n - e1.maxUnderzooming, this._source.minzoom);
        for (let e1 of a){
            let t = this._inViewTiles.getTileById(e1.key), n = t?.wasRequested();
            for(let r = e1.overscaledZ - 1; r >= s; --r){
                let a = e1.scaledTo(r);
                if (o[a.key]) break;
                if (o[a.key] = !0, t = this.getTile(a), !t && n && (t = this._addTile(a)), t) {
                    let e1 = t.hasData();
                    if ((e1 || !this.map?.cancelPendingTileRequestsWhileZooming || n) && (i[a.key] = a), n = t.wasRequested(), e1) break;
                }
            }
        }
        return i;
    }
    _addTile(e1) {
        let t = this._inViewTiles.getTileById(e1.key);
        if (t) return t;
        t = this._outOfViewCache.getAndRemove(e1), t && (t.resetFadeLogic(), this._setTileReloadTimer(e1.key, t), t.tileID = e1, this._state.initializeTileState(t, this.map ? this.map.painter : null));
        let n = t;
        return t || (t = new $834619e78bbf578c$var$vo(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(t, e1.key, t.state, !1)), t.uses++, this._inViewTiles.setTile(e1.key, t), n || this._source.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`dataloading`, {
            tile: t,
            coord: t.tileID
        })), t;
    }
    _setTileReloadTimer(e1, t) {
        this._clearTileReloadTimer(e1);
        let n = t.getExpiryTimeout();
        if (n) {
            let t = ()=>{
                this._reloadTile(e1, `expired`), delete this._timers[e1];
            };
            this._timers[e1] = setTimeout(t, n);
        }
    }
    _clearTileReloadTimer(e1) {
        let t = this._timers[e1];
        t && (clearTimeout(t), delete this._timers[e1]);
    }
    _resetTileReloadTimers() {
        for(let e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
        for (let e1 of this._inViewTiles.getAllIds()){
            let t = this._inViewTiles.getTileById(e1);
            this._setTileReloadTimer(e1, t);
        }
    }
    refreshTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let n = this._inViewTiles.getTileById(t);
            (this._inViewTiles.isIdRenderable(t) || n.state == `errored`) && e1.some((e1)=>e1.equals(n.tileID.canonical)) && this._reloadTile(t, `expired`);
        }
    }
    _removeTile(e1) {
        let t = this._inViewTiles.getTileById(e1);
        t && (t.uses--, this._inViewTiles.deleteTileById(e1), this._clearTileReloadTimer(e1), !(t.uses > 0) && (t.hasData() && t.state !== `reloading` ? this._outOfViewCache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
    }
    _dataHandler(e1) {
        if (e1.dataType === `source`) {
            if (e1.sourceDataType === `metadata`) {
                this._sourceLoaded = !0;
                return;
            }
            e1.sourceDataType === `content` && this._sourceLoaded && !this._paused && (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
        }
    }
    resetMaxContentElevation() {
        this._maxContentElevationSeen = 0;
    }
    clearTiles() {
        this._shouldReloadOnResume = !1, this._paused = !1, this.resetMaxContentElevation();
        for (let e1 of this._inViewTiles.getAllIds())this._removeTile(e1);
        this._outOfViewCache.reset();
    }
    tilesIn(e1, t, n) {
        let r = [], i = this.transform;
        if (!i) return r;
        let a = i.getCoveringTilesDetailsProvider().allowWorldCopies(), o = n ? i.getCameraQueryGeometry(e1) : e1, s = (e1)=>i.screenPointToMercatorCoordinate(e1, this.terrain), c = this.transformBbox(e1, s, !a), l = this.transformBbox(o, s, !a), u = this.getIds(), d = (0, $1rqx5.pt).fromPoints(l);
        for (let e1 of u){
            let n = this._inViewTiles.getTileById(e1);
            if (n.holdingForSymbolFade()) continue;
            let o = a ? [
                n.tileID
            ] : [
                n.tileID.unwrapTo(-1),
                n.tileID.unwrapTo(0)
            ], s = 2 ** (i.zoom - n.tileID.overscaledZ), u = t * n.queryPadding * (0, $1rqx5.Lr) / n.tileSize / s;
            for (let e1 of o){
                let t = d.map((t)=>e1.getTilePoint(new (0, $1rqx5.nt)(t.x, t.y)));
                if (t.expandBy(u), t.intersects((0, $1rqx5.ft))) {
                    let t = c.map((t)=>e1.getTilePoint(t)), i = l.map((t)=>e1.getTilePoint(t));
                    r.push({
                        tile: n,
                        tileID: a ? e1 : e1.unwrapTo(0),
                        queryGeometry: t,
                        cameraQueryGeometry: i,
                        scale: s
                    });
                }
            }
        }
        return r;
    }
    transformBbox(e1, t, n) {
        let r = e1.map(t);
        if (n) {
            let n = (0, $1rqx5.pt).fromPoints(e1);
            n.shrinkBy(Math.min(n.width(), n.height()) * .001);
            let i = n.map(t);
            (0, $1rqx5.pt).fromPoints(r).covers(i) || (r = r.map((e1)=>e1.x > .5 ? new (0, $1rqx5.nt)(e1.x - 1, e1.y, e1.z) : e1));
        }
        return r;
    }
    getVisibleCoordinates(e1) {
        let t = this.getRenderableIds(e1).map((e1)=>this._inViewTiles.getTileById(e1).tileID);
        return this.transform && this.transform.populateCache(t), t;
    }
    hasTransition() {
        return this._source.hasTransition() ? !0 : $834619e78bbf578c$var$Io(this._source.type) && $834619e78bbf578c$var$Ho(this._inViewTiles, this._rasterFadeDuration);
    }
    setRasterFadeDuration(e1) {
        this._rasterFadeDuration = e1;
    }
    setFeatureState(e1, t, n) {
        e1 ||= (0, $1rqx5.s), this._state.updateState(e1, t, n);
    }
    removeFeatureState(e1, t, n) {
        e1 ||= (0, $1rqx5.s), this._state.removeFeatureState(e1, t, n);
    }
    getFeatureState(e1, t) {
        return e1 ||= (0, $1rqx5.s), this._state.getState(e1, t);
    }
    setDependencies(e1, t, n) {
        let r = this._inViewTiles.getTileById(e1);
        r && r.setDependencies(t, n);
    }
    reloadTilesForDependencies(e1, t) {
        for (let n of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(n).hasDependency(e1, t) && this._reloadTile(n, `reloading`);
        this._outOfViewCache.filter((n)=>!n.hasDependency(e1, t));
    }
    areTilesLoaded() {
        for (let e1 of this._inViewTiles.getAllTiles())if (e1.state !== `loaded` && e1.state !== `errored`) return !1;
        return !0;
    }
}, $834619e78bbf578c$var$qo = class {
    constructor(e1, t){
        this.reset(e1, t);
    }
    reset(e1, t) {
        this.points = e1 || [], this._distances = [
            0
        ];
        for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
        this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, this.length * .5), this.paddedLength = this.length - this.padding * 2;
    }
    lerp(e1) {
        if (this.points.length === 1) return this.points[0];
        e1 = (0, $1rqx5.Bn)(e1, 0, 1);
        let t = 1, n = this._distances[t], r = e1 * this.paddedLength + this.padding;
        for(; n < r && t < this._distances.length;)n = this._distances[++t];
        let i = t - 1, a = this._distances[i], o = n - a, s = o > 0 ? (r - a) / o : 0;
        return this.points[i].mult(1 - s).add(this.points[t].mult(s));
    }
};
function $834619e78bbf578c$var$Jo(e1, t, n, r, i) {
    return i ? e1 ? e1(t, n) + r : r === 0 ? void 0 : r : r;
}
function $834619e78bbf578c$var$Yo(e1, t) {
    let n = !0;
    return e1 === `always` || (e1 === `never` || t === `never`) && (n = !1), n;
}
var $834619e78bbf578c$var$Xo = class {
    constructor(e1, t, n){
        let r = this.boxCells = [], i = this.circleCells = [];
        this.xCellCount = Math.ceil(e1 / n), this.yCellCount = Math.ceil(t / n);
        for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)r.push([]), i.push([]);
        this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
    }
    keysLength() {
        return this.boxKeys.length + this.circleKeys.length;
    }
    insert(e1, t, n, r, i) {
        this._forEachCell(t, n, r, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(n), this.bboxes.push(r), this.bboxes.push(i);
    }
    insertCircle(e1, t, n, r) {
        this._forEachCell(t - r, n - r, t + r, n + r, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(n), this.circles.push(r);
    }
    _insertBoxCell(e1, t, n, r, i, a) {
        this.boxCells[i].push(a);
    }
    _insertCircleCell(e1, t, n, r, i, a) {
        this.circleCells[i].push(a);
    }
    _query(e1, t, n, r, i, a, o) {
        if (n < 0 || e1 > this.width || r < 0 || t > this.height) return [];
        let s = [];
        if (e1 <= 0 && t <= 0 && this.width <= n && this.height <= r) {
            if (i) return [
                {
                    key: null,
                    x1: e1,
                    y1: t,
                    x2: n,
                    y2: r
                }
            ];
            for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                key: this.boxKeys[e1],
                x1: this.bboxes[e1 * 4],
                y1: this.bboxes[e1 * 4 + 1],
                x2: this.bboxes[e1 * 4 + 2],
                y2: this.bboxes[e1 * 4 + 3]
            });
            for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                let t = this.circles[e1 * 3], n = this.circles[e1 * 3 + 1], r = this.circles[e1 * 3 + 2];
                s.push({
                    key: this.circleKeys[e1],
                    x1: t - r,
                    y1: n - r,
                    x2: t + r,
                    y2: n + r
                });
            }
        } else {
            let c = {
                hitTest: i,
                overlapMode: a,
                seenUids: {
                    box: {},
                    circle: {}
                }
            };
            this._forEachCell(e1, t, n, r, this._queryCell, s, c, o);
        }
        return s;
    }
    query(e1, t, n, r) {
        return this._query(e1, t, n, r, !1, null);
    }
    hitTest(e1, t, n, r, i, a) {
        return this._query(e1, t, n, r, !0, i, a).length > 0;
    }
    hitTestCircle(e1, t, n, r, i) {
        let a = e1 - n, o = e1 + n, s = t - n, c = t + n;
        if (o < 0 || a > this.width || c < 0 || s > this.height) return !1;
        let l = [], u = {
            hitTest: !0,
            overlapMode: r,
            circle: {
                x: e1,
                y: t,
                radius: n
            },
            seenUids: {
                box: {},
                circle: {}
            }
        };
        return this._forEachCell(a, s, o, c, this._queryCellCircle, l, u, i), l.length > 0;
    }
    _queryCell(e1, t, n, r, i, a, o, s) {
        let { seenUids: c, hitTest: l, overlapMode: u } = o, d = this.boxCells[i], f = 1e-6;
        if (d !== null) {
            let i = this.bboxes;
            for (let o of d)if (!c.box[o]) {
                c.box[o] = !0;
                let d = o * 4, p = this.boxKeys[o];
                if (e1 <= i[d + 2] + f && t <= i[d + 3] + f && n >= i[d + 0] - f && r >= i[d + 1] - f && (!s || s(p)) && (!l || !$834619e78bbf578c$var$Yo(u, p.overlapMode)) && (a.push({
                    key: p,
                    x1: i[d],
                    y1: i[d + 1],
                    x2: i[d + 2],
                    y2: i[d + 3]
                }), l)) return !0;
            }
        }
        let p = this.circleCells[i];
        if (p !== null) {
            let i = this.circles;
            for (let o of p)if (!c.circle[o]) {
                c.circle[o] = !0;
                let d = o * 3, f = this.circleKeys[o];
                if (this._circleAndRectCollide(i[d], i[d + 1], i[d + 2], e1, t, n, r) && (!s || s(f)) && (!l || !$834619e78bbf578c$var$Yo(u, f.overlapMode))) {
                    let e1 = i[d], t = i[d + 1], n = i[d + 2];
                    if (a.push({
                        key: f,
                        x1: e1 - n,
                        y1: t - n,
                        x2: e1 + n,
                        y2: t + n
                    }), l) return !0;
                }
            }
        }
        return !1;
    }
    _queryCellCircle(e1, t, n, r, i, a, o, s) {
        let { circle: c, seenUids: l, overlapMode: u } = o, d = this.boxCells[i];
        if (d !== null) {
            let e1 = this.bboxes;
            for (let t of d)if (!l.box[t]) {
                l.box[t] = !0;
                let n = t * 4, r = this.boxKeys[t];
                if (this._circleAndRectCollide(c.x, c.y, c.radius, e1[n + 0], e1[n + 1], e1[n + 2], e1[n + 3]) && (!s || s(r)) && !$834619e78bbf578c$var$Yo(u, r.overlapMode)) return a.push(!0), !0;
            }
        }
        let f = this.circleCells[i];
        if (f !== null) {
            let e1 = this.circles;
            for (let t of f)if (!l.circle[t]) {
                l.circle[t] = !0;
                let n = t * 3, r = this.circleKeys[t];
                if (this._circlesCollide(e1[n], e1[n + 1], e1[n + 2], c.x, c.y, c.radius) && (!s || s(r)) && !$834619e78bbf578c$var$Yo(u, r.overlapMode)) return a.push(!0), !0;
            }
        }
    }
    _forEachCell(e1, t, n, r, i, a, o, s) {
        let c = this._convertToXCellCoord(e1), l = this._convertToYCellCoord(t), u = this._convertToXCellCoord(n), d = this._convertToYCellCoord(r);
        for(let f = c; f <= u; f++)for(let c = l; c <= d; c++){
            let l = this.xCellCount * c + f;
            if (i.call(this, e1, t, n, r, l, a, o, s)) return;
        }
    }
    _convertToXCellCoord(e1) {
        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
    }
    _convertToYCellCoord(e1) {
        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
    }
    _circlesCollide(e1, t, n, r, i, a) {
        let o = r - e1, s = i - t, c = n + a;
        return c * c > o * o + s * s;
    }
    _circleAndRectCollide(e1, t, n, r, i, a, o) {
        let s = (a - r) / 2, c = Math.abs(e1 - (r + s));
        if (c > s + n) return !1;
        let l = (o - i) / 2, u = Math.abs(t - (i + l));
        if (u > l + n) return !1;
        if (c <= s || u <= l) return !0;
        let d = c - s, f = u - l;
        return d * d + f * f <= n * n;
    }
};
function $834619e78bbf578c$var$Zo(e1, t) {
    let n = 1 / (t[0] * t[0] + t[1] * t[1] + t[2] * t[2]), r = 1 / (t[8] * t[8] + t[9] * t[9] + t[10] * t[10]), i = t[0] * n, a = t[4] * n, o = t[8] * r, s = t[1] * n, c = t[5] * n, l = t[9] * r, u = t[2] * n, d = t[6] * n, f = t[10] * r;
    e1[0] = i, e1[1] = a, e1[2] = o, e1[4] = s, e1[5] = c, e1[6] = l, e1[8] = u, e1[9] = d, e1[10] = f;
    let p = t[12], m = t[13], h = t[14];
    return e1[12] = -i * p - s * m - u * h, e1[13] = -a * p - c * m - d * h, e1[14] = -o * p - l * m - f * h, e1[3] = 0, e1[7] = 0, e1[11] = 0, e1[15] = 1, e1;
}
function $834619e78bbf578c$var$Qo(e1, t) {
    return e1[0] = 1 / t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1 / t[5], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 0, e1[11] = 1 / t[14], e1[12] = 0, e1[13] = 0, e1[14] = -1, e1[15] = t[10] / t[14], e1;
}
function $834619e78bbf578c$var$$o(e1, t) {
    let n = 1 / (t[0] * t[5] - t[1] * t[4]);
    return e1[0] = t[5] * n, e1[1] = -t[1] * n, e1[2] = 0, e1[3] = 0, e1[4] = -t[4] * n, e1[5] = t[0] * n, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1 / t[10], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1 / t[15], e1;
}
const $834619e78bbf578c$var$es = (0, $1rqx5.vi)();
function $834619e78bbf578c$var$ts(e1, t, n) {
    let r = (0, $1rqx5.vi)();
    if (!e1) {
        let { vecSouth: e1, vecEast: n } = $834619e78bbf578c$var$rs(t), i = $834619e78bbf578c$var$jr();
        i[0] = n[0], i[1] = n[1], i[2] = e1[0], i[3] = e1[1], $834619e78bbf578c$var$Mr(i, i), r[0] = i[0], r[1] = i[1], r[4] = i[2], r[5] = i[3];
    }
    return (0, $1rqx5.Ai)(r, r, [
        1 / n,
        1 / n,
        1
    ]), r;
}
function $834619e78bbf578c$var$ns(e1, t, n, r) {
    if (e1) {
        let e1 = (0, $1rqx5.vi)();
        if (!t) {
            let { vecSouth: t, vecEast: r } = $834619e78bbf578c$var$rs(n);
            e1[0] = r[0], e1[1] = r[1], e1[4] = t[0], e1[5] = t[1];
        }
        return (0, $1rqx5.Ai)(e1, e1, [
            r,
            r,
            1
        ]), e1;
    }
    return n.pixelsToClipSpaceMatrix;
}
function $834619e78bbf578c$var$rs(e1) {
    let t = Math.cos(e1.rollInRadians), n = Math.sin(e1.rollInRadians), r = Math.cos(e1.pitchInRadians), i = Math.cos(e1.bearingInRadians), a = Math.sin(e1.bearingInRadians), o = (0, $1rqx5.Rr)();
    o[0] = -i * r * n - a * t, o[1] = -a * r * n + i * t;
    let s = (0, $1rqx5.zr)(o);
    s < 1e-9 ? (0, $1rqx5.Hr)(o) : (0, $1rqx5.Br)(o, o, 1 / s);
    let c = (0, $1rqx5.Rr)();
    c[0] = i * r * t - a * n, c[1] = a * r * t + i * n;
    let l = (0, $1rqx5.zr)(c);
    return l < 1e-9 ? (0, $1rqx5.Hr)(c) : (0, $1rqx5.Br)(c, c, 1 / l), {
        vecEast: c,
        vecSouth: o
    };
}
function $834619e78bbf578c$var$is(e1, t, n) {
    return $834619e78bbf578c$var$Jo(e1.getElevation, t, n, e1.heightOffset ?? 0, e1.heightAnchorGround ?? !0);
}
function $834619e78bbf578c$var$as(e1, t, n, r) {
    let i;
    r == null ? (i = [
        e1,
        t,
        0,
        1
    ], $834619e78bbf578c$var$Ss(i, i, n)) : (i = [
        e1,
        t,
        r,
        1
    ], (0, $1rqx5.Yr)(i, i, n));
    let a = i[3];
    return {
        point: new (0, $1rqx5.Li)(i[0] / a, i[1] / a),
        signedDistanceFromCamera: a,
        isOccluded: !1
    };
}
function $834619e78bbf578c$var$os(e1, t) {
    return .5 + e1 / t * .5;
}
function $834619e78bbf578c$var$ss(e1, t) {
    return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
}
function $834619e78bbf578c$var$cs(e1, t, n, r, a, o, s, c, l, u, d, f, p) {
    let m = n ? e1.textSizeData : e1.iconSizeData, h = (0, $1rqx5.A)(m, t.transform.zoom), g = [
        256 / t.width * 2 + 1,
        256 / t.height * 2 + 1
    ], _ = n ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
    _.clear();
    let v = e1.lineVertexArray, y = n ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = t.transform.width / t.transform.height, x = !1;
    for(let n = 0; n < y.length; n++){
        let i = y.get(n);
        if (i.hidden || i.writingMode === 2 && !x) {
            $834619e78bbf578c$var$xs(i.numGlyphs, _);
            continue;
        }
        x = !1;
        let S = new (0, $1rqx5.Li)(i.anchorX, i.anchorY), C = {
            getElevation: p,
            pitchedLabelPlaneMatrix: r,
            lineVertexArray: v,
            pitchWithMap: o,
            projectionCache: {
                projections: {},
                offsets: {},
                cachedAnchorPoint: void 0,
                anyProjectionOccluded: !1
            },
            transform: t.transform,
            tileAnchorPoint: S,
            unwrappedTileID: l,
            width: u,
            height: d,
            translation: f
        }, w = $834619e78bbf578c$var$gs(i.anchorX, i.anchorY, C);
        if (!$834619e78bbf578c$var$ss(w.point, g)) {
            $834619e78bbf578c$var$xs(i.numGlyphs, _);
            continue;
        }
        let T = w.signedDistanceFromCamera, E = $834619e78bbf578c$var$os(t.transform.cameraToCenterDistance, T), D = (0, $1rqx5.k)(m, h, i), O = o ? D * t.transform.getPitchedTextCorrection(i.anchorX, i.anchorY, l) / E : D * E, k = $834619e78bbf578c$var$ds({
            projectionContext: C,
            pitchedLabelPlaneMatrixInverse: a,
            symbol: i,
            fontSize: O,
            flip: !1,
            keepUpright: s,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: _,
            aspectRatio: b,
            rotateToLine: c
        });
        x = k.useVertical, (k.notEnoughRoom || x || k.needsFlipping && $834619e78bbf578c$var$ds({
            projectionContext: C,
            pitchedLabelPlaneMatrixInverse: a,
            symbol: i,
            fontSize: O,
            flip: !0,
            keepUpright: s,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: _,
            aspectRatio: b,
            rotateToLine: c
        }).notEnoughRoom) && $834619e78bbf578c$var$xs(i.numGlyphs, _);
    }
    n ? e1.text.dynamicLayoutVertexBuffer.updateData(_) : e1.icon.dynamicLayoutVertexBuffer.updateData(_);
}
function $834619e78bbf578c$var$ls(e1, t, n, r, i, a, o, s) {
    let c = a.glyphStartIndex + a.numGlyphs, l = a.lineStartIndex, u = a.lineStartIndex + a.lineLength, d = t.getoffsetX(a.glyphStartIndex), f = t.getoffsetX(c - 1), p = $834619e78bbf578c$var$ys(e1 * d, n, r, i, a.segment, l, u, s, o);
    if (!p) return null;
    let m = $834619e78bbf578c$var$ys(e1 * f, n, r, i, a.segment, l, u, s, o);
    return !m || s.projectionCache.anyProjectionOccluded ? null : {
        first: p,
        last: m
    };
}
function $834619e78bbf578c$var$us(e1, t, n, r) {
    return e1 === 1 && Math.abs(n.y - t.y) > Math.abs(n.x - t.x) * r ? {
        useVertical: !0
    } : (e1 === 2 ? t.y < n.y : t.x > n.x) ? {
        needsFlipping: !0
    } : null;
}
function $834619e78bbf578c$var$ds(e1) {
    let { projectionContext: t, pitchedLabelPlaneMatrixInverse: n, symbol: r, fontSize: i, flip: a, keepUpright: o, glyphOffsetArray: s, dynamicLayoutVertexArray: c, aspectRatio: l, rotateToLine: u } = e1, d = i / 24, f = r.lineOffsetX * d, m = r.lineOffsetY * d, h;
    if (r.numGlyphs > 1) {
        let e1 = r.glyphStartIndex + r.numGlyphs, i = r.lineStartIndex, c = r.lineStartIndex + r.lineLength, p = $834619e78bbf578c$var$ls(d, s, f, m, a, r, u, t);
        if (!p) return {
            notEnoughRoom: !0
        };
        let g = $834619e78bbf578c$var$hs(p.first.point.x, p.first.point.y, t, n), _ = $834619e78bbf578c$var$hs(p.last.point.x, p.last.point.y, t, n);
        if (o && !a) {
            let e1 = $834619e78bbf578c$var$us(r.writingMode, g, _, l);
            if (e1) return e1;
        }
        h = [
            p.first
        ];
        for(let n = r.glyphStartIndex + 1; n < e1 - 1; n++){
            let e1 = $834619e78bbf578c$var$ys(d * s.getoffsetX(n), f, m, a, r.segment, i, c, t, u);
            if (!e1) return {
                notEnoughRoom: !0
            };
            h.push(e1);
        }
        h.push(p.last);
    } else {
        if (o && !a) {
            let e1 = $834619e78bbf578c$var$ms(t.tileAnchorPoint.x, t.tileAnchorPoint.y, t).point, i = r.lineStartIndex + r.segment + 1, a = new (0, $1rqx5.Li)(t.lineVertexArray.getx(i), t.lineVertexArray.gety(i)), o = $834619e78bbf578c$var$ms(a.x, a.y, t), s = o.signedDistanceFromCamera > 0 ? o.point : $834619e78bbf578c$var$fs(t.tileAnchorPoint, a, e1, 1, t), c = $834619e78bbf578c$var$hs(e1.x, e1.y, t, n), u = $834619e78bbf578c$var$hs(s.x, s.y, t, n), d = $834619e78bbf578c$var$us(r.writingMode, c, u, l);
            if (d) return d;
        }
        let e1 = $834619e78bbf578c$var$ys(d * s.getoffsetX(r.glyphStartIndex), f, m, a, r.segment, r.lineStartIndex, r.lineStartIndex + r.lineLength, t, u);
        if (!e1 || t.projectionCache.anyProjectionOccluded) return {
            notEnoughRoom: !0
        };
        h = [
            e1
        ];
    }
    for (let e1 of h)(0, $1rqx5.C)(c, e1.point, e1.angle);
    return {};
}
function $834619e78bbf578c$var$fs(e1, t, n, r, i) {
    let a = e1.add(e1.sub(t)._unit()), o = $834619e78bbf578c$var$ms(a.x, a.y, i).point, s = n.sub(o);
    return n.add(s._mult(r / s.mag()));
}
function $834619e78bbf578c$var$ps(e1, t, n) {
    let r = t.projectionCache;
    if (r.projections[e1]) return r.projections[e1];
    let i = new (0, $1rqx5.Li)(t.lineVertexArray.getx(e1), t.lineVertexArray.gety(e1)), a = $834619e78bbf578c$var$ms(i.x, i.y, t);
    if (a.signedDistanceFromCamera > 0) return r.projections[e1] = a.point, r.anyProjectionOccluded ||= a.isOccluded, a.point;
    let o = e1 - n.direction, s = n.distanceFromAnchor === 0 ? t.tileAnchorPoint : new (0, $1rqx5.Li)(t.lineVertexArray.getx(o), t.lineVertexArray.gety(o)), c = n.absOffsetX - n.distanceFromAnchor + 1;
    return $834619e78bbf578c$var$fs(s, i, n.previousVertex, c, t);
}
function $834619e78bbf578c$var$ms(e1, t, n) {
    let r = e1 + n.translation[0], i = t + n.translation[1], a;
    return n.pitchWithMap ? (a = $834619e78bbf578c$var$as(r, i, n.pitchedLabelPlaneMatrix, $834619e78bbf578c$var$is(n, r, i)), a.isOccluded = !1) : (a = n.transform.projectTileCoordinates(r, i, n.unwrappedTileID, $834619e78bbf578c$var$is(n, r, i)), a.point.x = (a.point.x * .5 + .5) * n.width, a.point.y = (-a.point.y * .5 + .5) * n.height), a;
}
function $834619e78bbf578c$var$hs(e1, t, n, r) {
    if (n.pitchWithMap) {
        let i = [
            e1,
            t,
            0,
            1
        ];
        (0, $1rqx5.Yr)(i, i, r);
        let a = i[0] / i[3], o = i[1] / i[3];
        return n.transform.projectTileCoordinates(a, o, n.unwrappedTileID, $834619e78bbf578c$var$is(n, a, o)).point;
    }
    return {
        x: e1 / n.width * 2 - 1,
        y: 1 - t / n.height * 2
    };
}
function $834619e78bbf578c$var$gs(e1, t, n) {
    return n.transform.projectTileCoordinates(e1, t, n.unwrappedTileID, $834619e78bbf578c$var$is(n, e1, t));
}
function $834619e78bbf578c$var$_s(e1, t, n) {
    return e1._unit()._perp()._mult(t * n);
}
function $834619e78bbf578c$var$vs(e1, t, n, r, i, a, o, s, c) {
    if (s.projectionCache.offsets[e1]) return s.projectionCache.offsets[e1];
    let l = n.add(t);
    if (e1 + c.direction < r || e1 + c.direction >= i) return s.projectionCache.offsets[e1] = l, l;
    let u = $834619e78bbf578c$var$ps(e1 + c.direction, s, c), d = $834619e78bbf578c$var$_s(u.sub(n), o, c.direction), f = n.add(d), p = u.add(d);
    return s.projectionCache.offsets[e1] = (0, $1rqx5.nr)(a, l, f, p) || l, s.projectionCache.offsets[e1];
}
function $834619e78bbf578c$var$ys(e1, t, n, r, i, a, o, s, c) {
    let l = r ? e1 - t : e1 + t, u = l > 0 ? 1 : -1, d = 0;
    r && (u *= -1, d = Math.PI), u < 0 && (d += Math.PI);
    let f = u > 0 ? a + i : a + i + 1, p;
    s.projectionCache.cachedAnchorPoint ? p = s.projectionCache.cachedAnchorPoint : (p = $834619e78bbf578c$var$ms(s.tileAnchorPoint.x, s.tileAnchorPoint.y, s).point, s.projectionCache.cachedAnchorPoint = p);
    let m = p, h = p, g, _, v = 0, y = 0, b = Math.abs(l), x = [], S;
    for(; v + y <= b;){
        if (f += u, f < a || f >= o) return null;
        v += y, h = m, _ = g;
        let e1 = {
            absOffsetX: b,
            direction: u,
            distanceFromAnchor: v,
            previousVertex: h
        };
        if (m = $834619e78bbf578c$var$ps(f, s, e1), n === 0) x.push(h), S = m.sub(h);
        else {
            let t, r = m.sub(h);
            t = r.mag() === 0 ? $834619e78bbf578c$var$_s($834619e78bbf578c$var$ps(f + u, s, e1).sub(m), n, u) : $834619e78bbf578c$var$_s(r, n, u), _ ||= h.add(t), g = $834619e78bbf578c$var$vs(f, t, m, a, o, _, n, s, e1), x.push(_), S = g.sub(_);
        }
        y = S.mag();
    }
    let C = (b - v) / y, w = S._mult(C)._add(_ || h), T = d + Math.atan2(m.y - h.y, m.x - h.x);
    return x.push(w), {
        point: w,
        angle: c ? T : 0,
        path: x
    };
}
const $834619e78bbf578c$var$bs = new Float32Array([
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0
]);
function $834619e78bbf578c$var$xs(e1, t) {
    for(let n = 0; n < e1; n++){
        let e1 = t.length;
        t.resize(e1 + 4), t.float32.set($834619e78bbf578c$var$bs, e1 * 3);
    }
}
function $834619e78bbf578c$var$Ss(e1, t, n) {
    let r = t[0], i = t[1];
    return e1[0] = n[0] * r + n[4] * i + n[12], e1[1] = n[1] * r + n[5] * i + n[13], e1[3] = n[3] * r + n[7] * i + n[15], e1;
}
function $834619e78bbf578c$var$Cs(e1, t) {
    let n = $834619e78bbf578c$var$es;
    return $834619e78bbf578c$var$$o(n, t.pitchedLabelPlaneMatrix), e1.map((e1)=>{
        let r = $834619e78bbf578c$var$as(e1.x, e1.y, n, $834619e78bbf578c$var$is(t, e1.x, e1.y)), i = t.transform.projectTileCoordinates(r.point.x, r.point.y, t.unwrappedTileID, $834619e78bbf578c$var$is(t, r.point.x, r.point.y));
        return i.point.x = (i.point.x * .5 + .5) * t.width, i.point.y = (-i.point.y * .5 + .5) * t.height, i;
    });
}
function $834619e78bbf578c$var$ws(e1) {
    let t = 0, n = 0, r = 0, i = 0;
    for(let a = 0; a < e1.length; a++)e1[a].isOccluded ? (r = a + 1, i = 0) : (i++, i > n && (n = i, t = r));
    return e1.slice(t, t + n);
}
var $834619e78bbf578c$var$Ts = class {
    constructor(e1, t = new $834619e78bbf578c$var$Xo(e1.width + 200, e1.height + 200, 25), n = new $834619e78bbf578c$var$Xo(e1.width + 200, e1.height + 200, 25)){
        this.transform = e1, this.grid = t, this.ignoredGrid = n, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + 100, this.screenBottomBoundary = e1.height + 100, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
    }
    placeCollisionBox(e1, t, n, r, i, a, o, s, c, l, u, d, f = 0, p = !0) {
        let m = e1.anchorPointX + s[0], h = e1.anchorPointY + s[1], g = this.projectAndGetPerspectiveRatio(m, h, i, $834619e78bbf578c$var$Jo(l, m, h, f, p), d), _ = n * g.perspectiveRatio, v;
        if (!a && !o) {
            let t = g.x + (u ? u.x * _ : 0), n = g.y + (u ? u.y * _ : 0);
            v = {
                allPointsOccluded: !1,
                box: [
                    t + e1.x1 * _,
                    n + e1.y1 * _,
                    t + e1.x2 * _,
                    n + e1.y2 * _
                ]
            };
        } else v = this._projectCollisionBox(e1, _, r, i, a, o, s, g, l, u, d, f, p);
        let [y, b, x, S] = v.box, C = a ? v.allPointsOccluded : g.isOccluded, w = C;
        return w ||= g.perspectiveRatio < this.perspectiveRatioCutoff, w ||= !this.isInsideGrid(y, b, x, S), w || t !== `always` && this.grid.hitTest(y, b, x, S, t, c) ? {
            box: [
                y,
                b,
                x,
                S
            ],
            placeable: !1,
            offscreen: !1,
            occluded: C
        } : {
            box: [
                y,
                b,
                x,
                S
            ],
            placeable: !0,
            offscreen: this.isOffscreen(y, b, x, S),
            occluded: C
        };
    }
    placeCollisionCircles(e1, t, n, r, i, a, o, s, c, l, u, d, f, p) {
        let m = [], h = new (0, $1rqx5.Li)(t.anchorX, t.anchorY), g = this.getPerspectiveRatio(h.x, h.y, a, p?.(h.x, h.y)), _ = (c ? i * this.transform.getPitchedTextCorrection(t.anchorX, t.anchorY, a) / g : i * g) / 24, v = {
            projections: {},
            offsets: {},
            cachedAnchorPoint: void 0,
            anyProjectionOccluded: !1
        }, y = t.lineOffsetX * _, b = t.lineOffsetY * _, x = {
            getElevation: p,
            pitchedLabelPlaneMatrix: o,
            lineVertexArray: n,
            pitchWithMap: c,
            projectionCache: v,
            transform: this.transform,
            tileAnchorPoint: h,
            unwrappedTileID: a,
            width: this.transform.width,
            height: this.transform.height,
            translation: f
        }, S = $834619e78bbf578c$var$ls(_, r, y, b, !1, t, !1, x), C = !1, w = !1, T = !0;
        if (S) {
            let t = u * .5 * g + d, n = new (0, $1rqx5.Li)(-100, -100), r = new (0, $1rqx5.Li)(this.screenRightBoundary, this.screenBottomBoundary), i = new $834619e78bbf578c$var$qo, a = S.first, o = S.last, f = [];
            for(let e1 = a.path.length - 1; e1 >= 1; e1--)f.push(a.path[e1]);
            for(let e1 = 1; e1 < o.path.length; e1++)f.push(o.path[e1]);
            let p = t * 2.5;
            if (c) {
                let e1 = this.projectPathToScreenSpace(f, x);
                f = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
            }
            let h = [];
            if (f.length > 0) {
                let e1 = f[0].clone(), t = f[0].clone();
                for(let n = 1; n < f.length; n++)e1.x = Math.min(e1.x, f[n].x), e1.y = Math.min(e1.y, f[n].y), t.x = Math.max(t.x, f[n].x), t.y = Math.max(t.y, f[n].y);
                h = e1.x >= n.x && t.x <= r.x && e1.y >= n.y && t.y <= r.y ? [
                    f
                ] : t.x < n.x || e1.x > r.x || t.y < n.y || e1.y > r.y ? [] : (0, $1rqx5.O)([
                    f
                ], n.x, n.y, r.x, r.y);
            }
            for (let n of h){
                i.reset(n, t * .25);
                let r = 0;
                r = i.length <= .5 * t ? 1 : Math.ceil(i.paddedLength / p) + 1;
                for(let n = 0; n < r; n++){
                    let a = n / Math.max(r - 1, 1), o = i.lerp(a), c = o.x + 100, u = o.y + 100;
                    m.push(c, u, t, 0);
                    let d = c - t, f = u - t, p = c + t, h = u + t;
                    if (T &&= this.isOffscreen(d, f, p, h), w ||= this.isInsideGrid(d, f, p, h), e1 !== `always` && this.grid.hitTestCircle(c, u, t, e1, l) && (C = !0, !s)) return {
                        circles: [],
                        offscreen: !1,
                        collisionDetected: C
                    };
                }
            }
        }
        return {
            circles: !s && C || !w || g < this.perspectiveRatioCutoff ? [] : m,
            offscreen: T,
            collisionDetected: C
        };
    }
    projectPathToScreenSpace(e1, t) {
        return $834619e78bbf578c$var$ws($834619e78bbf578c$var$Cs(e1, t));
    }
    queryRenderedSymbols(e1) {
        if (e1.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) return {};
        let t = [], n = new (0, $1rqx5.pt);
        for (let r of e1){
            let e1 = new (0, $1rqx5.Li)(r.x + 100, r.y + 100);
            n.extend(e1), t.push(e1);
        }
        let { minX: r, minY: i, maxX: a, maxY: o } = n, s = this.grid.query(r, i, a, o).concat(this.ignoredGrid.query(r, i, a, o)), c = {}, l = {};
        for (let e1 of s){
            let n = e1.key;
            if (c[n.bucketInstanceId] === void 0 && (c[n.bucketInstanceId] = {}), c[n.bucketInstanceId][n.featureIndex]) continue;
            let r = [
                new (0, $1rqx5.Li)(e1.x1, e1.y1),
                new (0, $1rqx5.Li)(e1.x2, e1.y1),
                new (0, $1rqx5.Li)(e1.x2, e1.y2),
                new (0, $1rqx5.Li)(e1.x1, e1.y2)
            ];
            (0, $1rqx5.kt)(t, r) && (c[n.bucketInstanceId][n.featureIndex] = !0, l[n.bucketInstanceId] === void 0 && (l[n.bucketInstanceId] = []), l[n.bucketInstanceId].push(n.featureIndex));
        }
        return l;
    }
    insertCollisionBox(e1, t, n, r, i, a) {
        let o = n ? this.ignoredGrid : this.grid, s = {
            bucketInstanceId: r,
            featureIndex: i,
            collisionGroupID: a,
            overlapMode: t
        };
        o.insert(s, e1[0], e1[1], e1[2], e1[3]);
    }
    insertCollisionCircles(e1, t, n, r, i, a) {
        let o = n ? this.ignoredGrid : this.grid, s = {
            bucketInstanceId: r,
            featureIndex: i,
            collisionGroupID: a,
            overlapMode: t
        };
        for(let t = 0; t < e1.length; t += 4)o.insertCircle(s, e1[t], e1[t + 1], e1[t + 2]);
    }
    projectAndGetPerspectiveRatio(e1, t, n, r, i) {
        if (i) {
            let n;
            r == null ? (n = [
                e1,
                t,
                0,
                1
            ], $834619e78bbf578c$var$Ss(n, n, i)) : (n = [
                e1,
                t,
                r,
                1
            ], (0, $1rqx5.Yr)(n, n, i));
            let a = n[3];
            return {
                x: (n[0] / a + 1) / 2 * this.transform.width + 100,
                y: (-n[1] / a + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / a),
                isOccluded: !1,
                signedDistanceFromCamera: a
            };
        }
        {
            let i = this.transform.projectTileCoordinates(e1, t, n, r);
            return {
                x: (i.point.x + 1) / 2 * this.transform.width + 100,
                y: (-i.point.y + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / i.signedDistanceFromCamera),
                isOccluded: i.isOccluded,
                signedDistanceFromCamera: i.signedDistanceFromCamera
            };
        }
    }
    getPerspectiveRatio(e1, t, n, r) {
        let i = this.transform.projectTileCoordinates(e1, t, n, r);
        return .5 + .5 * (this.transform.cameraToCenterDistance / i.signedDistanceFromCamera);
    }
    isOffscreen(e1, t, n, r) {
        return n < 100 || e1 >= this.screenRightBoundary || r < 100 || t > this.screenBottomBoundary;
    }
    isInsideGrid(e1, t, n, r) {
        return n >= 0 && e1 < this.gridRightBoundary && r >= 0 && t < this.gridBottomBoundary;
    }
    getViewportMatrix() {
        let e1 = (0, $1rqx5.Si)([]);
        return (0, $1rqx5.ji)(e1, e1, [
            -100,
            -100,
            0
        ]), e1;
    }
    _projectCollisionBox(e1, t, n, r, i, a, o, s, c, l, d, f = 0, p = !0) {
        let m = 1, h = 0, g = 0, _ = 1, v = e1.anchorPointX + o[0], y = e1.anchorPointY + o[1];
        if (a && !i) {
            let e1 = this.projectAndGetPerspectiveRatio(v + 1, y, r, $834619e78bbf578c$var$Jo(c, v + 1, y, f, p), d), t = e1.x - s.x, n = e1.y - s.y, i = Math.atan(n / t) + (t < 0 ? Math.PI : 0), a = Math.sin(i), o = Math.cos(i);
            m = o, h = a, g = -a, _ = o;
        } else if (!a && i) {
            let e1 = $834619e78bbf578c$var$rs(this.transform);
            m = e1.vecEast[0], h = e1.vecEast[1], g = e1.vecSouth[0], _ = e1.vecSouth[1];
        }
        let b = s.x, x = s.y, S = t;
        if (i && (b = v, x = y, S = 2 ** -(this.transform.zoom - n.overscaledZ), S *= this.transform.getPitchedTextCorrection(v, y, r), !l)) {
            let e1 = s.signedDistanceFromCamera / this.transform.cameraToCenterDistance, t = (0, $1rqx5.Bn)(.5 + .5 * e1, 0, 4);
            S *= t;
        }
        l && (b += m * l.x * S + g * l.y * S, x += h * l.x * S + _ * l.y * S);
        let C = e1.x1 * S, w = e1.x2 * S, T = (C + w) / 2, E = e1.y1 * S, D = e1.y2 * S, O = (E + D) / 2, k = [
            {
                offsetX: C,
                offsetY: E
            },
            {
                offsetX: T,
                offsetY: E
            },
            {
                offsetX: w,
                offsetY: E
            },
            {
                offsetX: w,
                offsetY: O
            },
            {
                offsetX: w,
                offsetY: D
            },
            {
                offsetX: T,
                offsetY: D
            },
            {
                offsetX: C,
                offsetY: D
            },
            {
                offsetX: C,
                offsetY: O
            }
        ], A = [];
        for (let { offsetX: e1, offsetY: t } of k)A.push(new (0, $1rqx5.Li)(b + m * e1 + g * t, x + h * e1 + _ * t));
        let j = !1;
        if (i) {
            let e1 = A.map((e1)=>this.projectAndGetPerspectiveRatio(e1.x, e1.y, r, $834619e78bbf578c$var$Jo(c, e1.x, e1.y, f, p), d));
            j = e1.some((e1)=>!e1.isOccluded), A = e1.map((e1)=>new (0, $1rqx5.Li)(e1.x, e1.y));
        } else j = !0;
        return {
            box: (0, $1rqx5.rr)(A),
            allPointsOccluded: !j
        };
    }
}, $834619e78bbf578c$var$Es = class {
    constructor(e1, t, n, r){
        this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : r && n ? 1 : 0, this.placed = n;
    }
    isHidden() {
        return this.opacity === 0 && !this.placed;
    }
}, $834619e78bbf578c$var$Ds = class {
    constructor(e1, t, n, r, i){
        this.text = new $834619e78bbf578c$var$Es(e1 ? e1.text : null, t, n, i), this.icon = new $834619e78bbf578c$var$Es(e1 ? e1.icon : null, t, r, i);
    }
    isHidden() {
        return this.text.isHidden() && this.icon.isHidden();
    }
}, $834619e78bbf578c$var$Os = class {
    constructor(e1, t, n){
        this.text = e1, this.icon = t, this.skipFade = n;
    }
}, $834619e78bbf578c$var$ks = class {
    constructor(e1, t, n, r, i){
        this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = n, this.bucketIndex = r, this.tileID = i;
    }
}, $834619e78bbf578c$var$As = class {
    constructor(e1){
        this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
    }
    get(e1) {
        if (this.crossSourceCollisions) return {
            ID: 0,
            predicate: null
        };
        if (!this.collisionGroups[e1]) {
            let t = ++this.maxGroupID;
            this.collisionGroups[e1] = {
                ID: t,
                predicate: (e1)=>e1.collisionGroupID === t
            };
        }
        return this.collisionGroups[e1];
    }
};
function $834619e78bbf578c$var$js(e1, t, n, r, i) {
    let { horizontalAlign: a, verticalAlign: o } = (0, $1rqx5.M)(e1), s = -(a - .5) * t, c = -(o - .5) * n;
    return new (0, $1rqx5.Li)(s + r[0] * i, c + r[1] * i);
}
var $834619e78bbf578c$var$Ms = class {
    constructor(e1, t, n, r, i){
        this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new $834619e78bbf578c$var$Ts(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = n, this.retainedQueryData = {}, this.collisionGroups = new $834619e78bbf578c$var$As(r), this.collisionCircleArrays = {}, this.collisionBoxArrays = /* @__PURE__ */ new Map, this.prevPlacement = i, i && (i.prevPlacement = void 0), this.placedOrientations = {};
    }
    _getTerrainElevationFunc(e1) {
        let t = this.terrain;
        if (t) return (n, r)=>t.getElevation(e1, n, r);
    }
    getBucketParts(e1, t, n, r) {
        let a = n.getBucket(t), o = n.latestFeatureIndex;
        if (!a || !o || t.id !== a.layerIds[0]) return;
        let s = n.collisionBoxArray, c = a.layers[0].layout, l = a.layers[0].paint, u = 2 ** (this.transform.zoom - n.tileID.overscaledZ), d = n.tileSize / (0, $1rqx5.Lr), f = n.tileID.toUnwrapped(), p = c.get(`text-rotation-alignment`) === `map`, m = (0, $1rqx5.Ir)(n, 1, this.transform.zoom), h = (0, $1rqx5.jr)(this.collisionIndex.transform, n, l.get(`text-translate`), l.get(`text-translate-anchor`)), g = (0, $1rqx5.jr)(this.collisionIndex.transform, n, l.get(`icon-translate`), l.get(`icon-translate-anchor`)), _ = $834619e78bbf578c$var$ts(p, this.transform, m);
        this.retainedQueryData[a.bucketInstanceId] = new $834619e78bbf578c$var$ks(a.bucketInstanceId, o, a.sourceLayerIndex, a.index, n.tileID);
        let v = {
            bucket: a,
            layout: c,
            translationText: h,
            translationIcon: g,
            unwrappedTileID: f,
            pitchedLabelPlaneMatrix: _,
            scale: u,
            textPixelRatio: d,
            holdingForFade: n.holdingForSymbolFade(),
            collisionBoxArray: s,
            partiallyEvaluatedTextSize: (0, $1rqx5.A)(a.textSizeData, this.transform.zoom),
            collisionGroup: this.collisionGroups.get(a.sourceID)
        };
        if (r) for (let t of a.sortKeyRanges){
            let { sortKey: n, symbolInstanceStart: r, symbolInstanceEnd: i } = t;
            e1.push({
                sortKey: n,
                symbolInstanceStart: r,
                symbolInstanceEnd: i,
                parameters: v
            });
        }
        else e1.push({
            symbolInstanceStart: 0,
            symbolInstanceEnd: a.symbolInstances.length,
            parameters: v
        });
    }
    attemptAnchorPlacement(e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x) {
        let C = (0, $1rqx5.E)[e1.textAnchor], w = [
            e1.textOffset0,
            e1.textOffset1
        ], T = $834619e78bbf578c$var$js(C, n, r, w, i), E = this.collisionIndex.placeCollisionBox(t, d, s, c, l, o, a, h, u.predicate, v, T, y, b, x);
        if ((!_ || this.collisionIndex.placeCollisionBox(_, d, s, c, l, o, a, g, u.predicate, v, T, y, b, x).placeable) && E.placeable) {
            let e1;
            if (this.prevPlacement?.variableOffsets[f.crossTileID] && this.prevPlacement?.placements[f.crossTileID]?.text && (e1 = this.prevPlacement.variableOffsets[f.crossTileID].anchor), f.crossTileID === 0) throw Error(`symbolInstance.crossTileID can't be 0`);
            return this.variableOffsets[f.crossTileID] = {
                textOffset: w,
                width: n,
                height: r,
                anchor: C,
                textBoxScale: i,
                prevAnchor: e1
            }, this.markUsedJustification(p, C, f, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, f), this.placedOrientations[f.crossTileID] = m), {
                shift: T,
                placedGlyphBoxes: E
            };
        }
    }
    placeLayerBucketPart(e1, t, n) {
        let { bucket: r, layout: i, translationText: a, translationIcon: o, unwrappedTileID: s, pitchedLabelPlaneMatrix: c, textPixelRatio: l, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: f, collisionGroup: p } = e1.parameters, m = i.get(`text-optional`), h = i.get(`icon-optional`), g = (0, $1rqx5.w)(i, `text-overlap`, `text-allow-overlap`), _ = g === `always`, v = (0, $1rqx5.w)(i, `icon-overlap`, `icon-allow-overlap`), y = v === `always`, b = i.get(`text-rotation-alignment`) === `map`, x = i.get(`text-pitch-alignment`) === `map`, C = i.get(`icon-text-fit`) !== `none`, w = i.get(`symbol-z-order`) === `viewport-y`, T = i.get(`symbol-height-anchor`) === `ground`, E = _ && (y || !r.hasIconData() || h), D = y && (_ || !r.hasTextData() || m);
        !r.collisionArrays && d && r.deserializeCollisionBoxes(d);
        let O = this.retainedQueryData[r.bucketInstanceId].tileID, k = this._getTerrainElevationFunc(O), A = this.transform.getFastPathSimpleProjectionMatrix(O), j = (e1, d, y)=>{
            if (t[e1.crossTileID]) return;
            if (u) {
                this.placements[e1.crossTileID] = new $834619e78bbf578c$var$Os(!1, !1, !1);
                return;
            }
            let w = e1.heightOffset, j = !1, M = !1, ee = !0, te = null, ne = {
                box: null,
                placeable: !1,
                offscreen: null,
                occluded: !1
            }, re = {
                box: null,
                placeable: !1,
                offscreen: null
            }, ie = null, ae = null, oe = null, se = 0, ce = 0, le = 0;
            d.textFeatureIndex ? se = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (se = e1.featureIndex), d.verticalTextFeatureIndex && (ce = d.verticalTextFeatureIndex);
            let ue = d.textBox;
            if (ue) {
                let t = (t)=>{
                    let n = 1;
                    if (r.allowVerticalPlacement && !t && this.prevPlacement) {
                        let t = this.prevPlacement.placedOrientations[e1.crossTileID];
                        t && (this.placedOrientations[e1.crossTileID] = t, n = t, this.markUsedOrientation(r, n, e1));
                    }
                    return n;
                }, i = (t, n)=>{
                    if (r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                        for (let e1 of r.writingModes)if (e1 === 2 ? (ne = n(), re = ne) : ne = t(), ne?.placeable) break;
                    } else ne = t();
                }, c = e1.textAnchorOffsetStartIndex, u = e1.textAnchorOffsetEndIndex;
                if (u === c) {
                    let n = (t, n)=>{
                        let i = this.collisionIndex.placeCollisionBox(t, g, l, O, s, x, b, a, p.predicate, k, void 0, A, w, T);
                        return i?.placeable && (this.markUsedOrientation(r, n, e1), this.placedOrientations[e1.crossTileID] = n), i;
                    };
                    i(()=>n(ue, 1), ()=>{
                        let t = d.verticalTextBox;
                        return r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && t ? n(t, 2) : {
                            box: null,
                            offscreen: null
                        };
                    }), t(ne?.placeable);
                } else {
                    let f = (0, $1rqx5.E)[this.prevPlacement?.variableOffsets[e1.crossTileID]?.anchor], m = (t, i, d)=>{
                        let m = t.x2 - t.x1, h = t.y2 - t.y1, _ = e1.textBoxScale, y = C && v === `never` ? i : null, S = null, E = g === `never` ? 1 : 2, D = `never`;
                        f && E++;
                        for(let n = 0; n < E; n++){
                            for(let n = c; n < u; n++){
                                let i = r.textAnchorOffsets.get(n);
                                if (f && i.textAnchor !== f) continue;
                                let c = this.attemptAnchorPlacement(i, t, m, h, _, b, x, l, O, s, p, D, e1, r, d, a, o, y, k, A, w, T);
                                if (c && (S = c.placedGlyphBoxes, S?.placeable)) return j = !0, te = c.shift, S;
                            }
                            f ? f = null : D = g;
                        }
                        return n && !S && (S = {
                            box: this.collisionIndex.placeCollisionBox(ue, `always`, l, O, s, x, b, a, p.predicate, k, void 0, A, w, T).box,
                            offscreen: !1,
                            placeable: !1,
                            occluded: !1
                        }), S;
                    };
                    i(()=>m(ue, d.iconBox, 1), ()=>{
                        let t = d.verticalTextBox, n = ne?.placeable;
                        return r.allowVerticalPlacement && !n && e1.numVerticalGlyphVertices > 0 && t ? m(t, d.verticalIconBox, 2) : {
                            box: null,
                            occluded: !0,
                            offscreen: null
                        };
                    }), ne && (j = ne.placeable, ee = ne.offscreen);
                    let h = t(ne?.placeable);
                    if (!j && this.prevPlacement) {
                        let t = this.prevPlacement.variableOffsets[e1.crossTileID];
                        t && (this.variableOffsets[e1.crossTileID] = t, this.markUsedJustification(r, t.anchor, e1, h));
                    }
                }
            }
            if (ie = ne, j = ie?.placeable, ee = ie?.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                let t = r.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), o = (0, $1rqx5.k)(r.textSizeData, f, t), l = i.get(`text-padding`), u = e1.collisionCircleDiameter;
                ae = this.collisionIndex.placeCollisionCircles(g, t, r.lineVertexArray, r.glyphOffsetArray, o, s, c, n, x, p.predicate, u, l, a, k), ae.circles.length && ae.collisionDetected && !n && (0, $1rqx5.Nr)(`Collisions detected, but collision boxes are not shown`), j = _ || ae.circles.length > 0 && !ae.collisionDetected, ee &&= ae.offscreen;
            }
            if (d.iconFeatureIndex && (le = d.iconFeatureIndex), d.iconBox) {
                let e1 = (e1)=>this.collisionIndex.placeCollisionBox(e1, v, l, O, s, x, b, o, p.predicate, k, C && te ? te : void 0, A, w, T);
                re && re.placeable && d.verticalIconBox ? (oe = e1(d.verticalIconBox), M = oe.placeable) : (oe = e1(d.iconBox), M = oe.placeable), ee &&= oe.offscreen;
            }
            let de = m || e1.numHorizontalGlyphVertices === 0 && e1.numVerticalGlyphVertices === 0, fe = h || e1.numIconVertices === 0;
            !de && !fe ? M = j = M && j : fe ? de || (M &&= j) : j = M && j;
            let pe = j && ie.placeable, me = M && oe.placeable;
            if (pe && (re && re.placeable && ce ? this.collisionIndex.insertCollisionBox(ie.box, g, i.get(`text-ignore-placement`), r.bucketInstanceId, ce, p.ID) : this.collisionIndex.insertCollisionBox(ie.box, g, i.get(`text-ignore-placement`), r.bucketInstanceId, se, p.ID)), me && this.collisionIndex.insertCollisionBox(oe.box, v, i.get(`icon-ignore-placement`), r.bucketInstanceId, le, p.ID), ae && j && this.collisionIndex.insertCollisionCircles(ae.circles, g, i.get(`text-ignore-placement`), r.bucketInstanceId, se, p.ID), n && this.storeCollisionData(r.bucketInstanceId, y, d, ie, oe, ae), e1.crossTileID === 0) throw Error(`symbolInstance.crossTileID can't be 0`);
            if (r.bucketInstanceId === 0) throw Error(`bucket.bucketInstanceId can't be 0`);
            let he = (j || E) && !ie?.occluded, ge = (M || D) && !oe?.occluded;
            this.placements[e1.crossTileID] = new $834619e78bbf578c$var$Os(he, ge, ee || r.justReloaded), t[e1.crossTileID] = !0;
        };
        if (w) {
            if (e1.symbolInstanceStart !== 0) throw Error(`bucket.bucketInstanceId should be 0`);
            let t = r.getSortedSymbolIndexes(-this.transform.bearingInRadians);
            for(let e1 = t.length - 1; e1 >= 0; --e1){
                let n = t[e1];
                j(r.symbolInstances.get(n), r.collisionArrays[n], n);
            }
        } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)j(r.symbolInstances.get(t), r.collisionArrays[t], t);
        r.justReloaded = !1;
    }
    storeCollisionData(e1, t, n, r, i, a) {
        if (n.textBox || n.iconBox) {
            let a;
            this.collisionBoxArrays.has(e1) ? a = this.collisionBoxArrays.get(e1) : (a = /* @__PURE__ */ new Map, this.collisionBoxArrays.set(e1, a));
            let o;
            a.has(t) ? o = a.get(t) : (o = {
                text: null,
                icon: null
            }, a.set(t, o)), n.textBox && (o.text = r.box), n.iconBox && (o.icon = i.box);
        }
        if (a) {
            let t = this.collisionCircleArrays[e1];
            t === void 0 && (t = this.collisionCircleArrays[e1] = []);
            for(let e1 = 0; e1 < a.circles.length; e1 += 4)t.push(a.circles[e1 + 0] - 100), t.push(a.circles[e1 + 1] - 100), t.push(a.circles[e1 + 2]), t.push(+!!a.collisionDetected);
        }
    }
    markUsedJustification(e1, t, n, r) {
        let i = {
            left: n.leftJustifiedTextSymbolIndex,
            center: n.centerJustifiedTextSymbolIndex,
            right: n.rightJustifiedTextSymbolIndex
        }, a;
        a = r === 2 ? n.verticalPlacedTextSymbolIndex : i[(0, $1rqx5.T)(t)];
        let o = [
            n.leftJustifiedTextSymbolIndex,
            n.centerJustifiedTextSymbolIndex,
            n.rightJustifiedTextSymbolIndex,
            n.verticalPlacedTextSymbolIndex
        ];
        for (let t of o)t >= 0 && (a >= 0 && t !== a ? e1.text.placedSymbolArray.get(t).crossTileID = 0 : e1.text.placedSymbolArray.get(t).crossTileID = n.crossTileID);
    }
    markUsedOrientation(e1, t, n) {
        let r = t === 1 || t === 3 ? t : 0, i = t === 2 ? t : 0, a = [
            n.leftJustifiedTextSymbolIndex,
            n.centerJustifiedTextSymbolIndex,
            n.rightJustifiedTextSymbolIndex
        ];
        for (let t of a)e1.text.placedSymbolArray.get(t).placedOrientation = r;
        n.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = i);
    }
    commit(e1) {
        this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
        let t = this.prevPlacement, n = !1;
        this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
        let r = t ? t.symbolFadeChange(e1) : 1, i = t ? t.opacities : {}, a = t ? t.variableOffsets : {}, o = t ? t.placedOrientations : {};
        for(let e1 in this.placements){
            let t = this.placements[e1], a = i[e1];
            a ? (this.opacities[e1] = new $834619e78bbf578c$var$Ds(a, r, t.text, t.icon), n ||= t.text !== a.text.placed, n ||= t.icon !== a.icon.placed) : (this.opacities[e1] = new $834619e78bbf578c$var$Ds(null, r, t.text, t.icon, t.skipFade), n ||= t.text || t.icon);
        }
        for(let e1 in i){
            let t = i[e1];
            if (!this.opacities[e1]) {
                let i = new $834619e78bbf578c$var$Ds(t, r, !1, !1);
                i.isHidden() || (this.opacities[e1] = i, n ||= t.text.placed, n ||= t.icon.placed);
            }
        }
        for(let e1 in a)!this.variableOffsets[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.variableOffsets[e1] = a[e1]);
        for(let e1 in o)!this.placedOrientations[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.placedOrientations[e1] = o[e1]);
        if (t && t.lastPlacementChangeTime === void 0) throw Error(`Last placement time for previous placement is not defined`);
        n ? this.lastPlacementChangeTime = e1 : typeof this.lastPlacementChangeTime != `number` && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
    }
    updateLayerOpacities(e1, t) {
        let n = {};
        for (let r of t){
            let t = r.getBucket(e1);
            t && r.latestFeatureIndex && e1.id === t.layerIds[0] && this.updateBucketOpacities(t, r.tileID, n, r.collisionBoxArray);
        }
    }
    updateBucketOpacities(e1, t, n, r) {
        e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
        let i = e1.layers[0], a = i.layout, o = new $834619e78bbf578c$var$Ds(null, 0, !1, !1, !0), s = a.get(`text-allow-overlap`), c = a.get(`icon-allow-overlap`), l = i._unevaluatedLayout.hasValue(`text-variable-anchor`) || i._unevaluatedLayout.hasValue(`text-variable-anchor-offset`), u = a.get(`text-rotation-alignment`) === `map`, d = a.get(`text-pitch-alignment`) === `map`, f = a.get(`icon-text-fit`) !== `none`, p = new $834619e78bbf578c$var$Ds(null, 0, s && (c || !e1.hasIconData() || a.get(`icon-optional`)), c && (s || !e1.hasTextData() || a.get(`text-optional`)), !0);
        !e1.collisionArrays && r && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(r);
        let m = (e1, t, n)=>{
            for(let r = 0; r < t / 4; r++)e1.opacityVertexArray.emplaceBack(n);
            e1.hasVisibleVertices ||= n !== $834619e78bbf578c$var$zs;
        }, h = this.collisionBoxArrays.get(e1.bucketInstanceId);
        for(let t = 0; t < e1.symbolInstances.length; t++){
            let r = e1.symbolInstances.get(t), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: a, crossTileID: s } = r, c = n[s], g = this.opacities[s];
            c ? g = o : g || (g = p, this.opacities[s] = g), n[s] = !0;
            let _ = i > 0 || a > 0, v = r.numIconVertices > 0, y = this.placedOrientations[r.crossTileID], b = y === 2, x = y === 1 || y === 3;
            if (_) {
                let t = $834619e78bbf578c$var$Rs(g.text), n = b ? $834619e78bbf578c$var$zs : t;
                m(e1.text, i, n);
                let o = x ? $834619e78bbf578c$var$zs : t;
                m(e1.text, a, o);
                let s = g.text.isHidden(), c = [
                    r.rightJustifiedTextSymbolIndex,
                    r.centerJustifiedTextSymbolIndex,
                    r.leftJustifiedTextSymbolIndex
                ];
                for (let t of c)t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = s || b ? 1 : 0);
                r.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).hidden = s || x ? 1 : 0);
                let l = this.variableOffsets[r.crossTileID];
                l && this.markUsedJustification(e1, l.anchor, r, y);
                let u = this.placedOrientations[r.crossTileID];
                u && (this.markUsedJustification(e1, `left`, r, u), this.markUsedOrientation(e1, u, r));
            }
            if (v) {
                let t = $834619e78bbf578c$var$Rs(g.icon), n = !(f && r.verticalPlacedIconSymbolIndex && b);
                if (r.placedIconSymbolIndex >= 0) {
                    let i = n ? t : $834619e78bbf578c$var$zs;
                    m(e1.icon, r.numIconVertices, i), e1.icon.placedSymbolArray.get(r.placedIconSymbolIndex).hidden = g.icon.isHidden();
                }
                if (r.verticalPlacedIconSymbolIndex >= 0) {
                    let i = n ? $834619e78bbf578c$var$zs : t;
                    m(e1.icon, r.numVerticalIconVertices, i), e1.icon.placedSymbolArray.get(r.verticalPlacedIconSymbolIndex).hidden = g.icon.isHidden();
                }
            }
            let S = h?.has(t) ? h.get(t) : {
                text: null,
                icon: null
            };
            if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                let n = e1.collisionArrays[t];
                if (n) {
                    let t = new (0, $1rqx5.Li)(0, 0);
                    if (n.textBox || n.verticalTextBox) {
                        let r = !0;
                        if (l) {
                            let e1 = this.variableOffsets[s];
                            e1 ? (t = $834619e78bbf578c$var$js(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), u && t._rotate(d ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : r = !1;
                        }
                        if (n.textBox || n.verticalTextBox) {
                            let i;
                            n.textBox && (i = b), n.verticalTextBox && (i = x), $834619e78bbf578c$var$Ns(e1.textCollisionBox.collisionVertexArray, g.text.placed, !r || i, S.text, t.x, t.y);
                        }
                    }
                    if (n.iconBox || n.verticalIconBox) {
                        let r = !(x || !n.verticalIconBox), i;
                        n.iconBox && (i = r), n.verticalIconBox && (i = !r), $834619e78bbf578c$var$Ns(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, i, S.icon, f ? t.x : 0, f ? t.y : 0);
                    }
                }
            }
        }
        if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
        if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
        e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
    }
    symbolFadeChange(e1) {
        return this.fadeDuration === 0 ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
    }
    zoomAdjustment(e1) {
        return Math.max(0, (this.transform.zoom - e1) / 1.5);
    }
    hasTransitions(e1) {
        return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
    }
    stillRecent(e1, t) {
        let n = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
        return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * n > e1;
    }
    setStale() {
        this.stale = !0;
    }
};
function $834619e78bbf578c$var$Ns(e1, t, n, r, i, a) {
    (!r || r.length === 0) && (r = [
        0,
        0,
        0,
        0
    ]);
    let o = r[0] - 100, s = r[1] - 100, c = r[2] - 100, l = r[3] - 100;
    e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, o, s), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, c, s), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, c, l), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, o, l);
}
const $834619e78bbf578c$var$Ps = 2 ** 25, $834619e78bbf578c$var$Fs = 2 ** 24, $834619e78bbf578c$var$Is = 2 ** 17, $834619e78bbf578c$var$Ls = 2 ** 16;
function $834619e78bbf578c$var$Rs(e1) {
    if (e1.opacity === 0 && !e1.placed) return 0;
    if (e1.opacity === 1 && e1.placed) return 4294967295;
    let t = +!!e1.placed, n = Math.floor(e1.opacity * 127);
    return n * $834619e78bbf578c$var$Ps + t * $834619e78bbf578c$var$Fs + n * $834619e78bbf578c$var$Is + t * $834619e78bbf578c$var$Ls + n * 512 + t * 256 + n * 2 + t;
}
const $834619e78bbf578c$var$zs = 0;
var $834619e78bbf578c$var$Bs = class {
    constructor(e1){
        this._sortAcrossTiles = e1.layout.get(`symbol-z-order`) !== `viewport-y` && !e1.layout.get(`symbol-sort-key`).isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
    }
    continuePlacement(e1, t, n, r, i) {
        let a = this._bucketParts;
        for(; this._currentTileIndex < e1.length;){
            let n = e1[this._currentTileIndex];
            if (t.getBucketParts(a, r, n, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
        }
        for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < a.length;){
            let e1 = a[this._currentPartIndex];
            if (t.placeLayerBucketPart(e1, this._seenCrossTileIDs, n), this._currentPartIndex++, i()) return !0;
        }
        return !1;
    }
}, $834619e78bbf578c$var$Vs = class {
    constructor(e1, t, n, r, i, a, o, s){
        this.placement = new $834619e78bbf578c$var$Ms(e1, t, a, o, s), this._currentPlacementIndex = n.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = i, this._done = !1;
    }
    isDone() {
        return this._done;
    }
    continuePlacement(e1, t, n) {
        let r = $834619e78bbf578c$export$461939dd4422153(), i = ()=>!this._forceFullPlacement && $834619e78bbf578c$export$461939dd4422153() - r > 2;
        for(; this._currentPlacementIndex >= 0;){
            let r = t[e1[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
            if ((0, $1rqx5.x)(r) && r.layout && (!r.minzoom || r.minzoom <= a) && (!r.maxzoom || r.maxzoom > a)) {
                if (this._inProgressLayer ||= new $834619e78bbf578c$var$Bs(r), this._inProgressLayer.continuePlacement(n[r.source], this.placement, this._showCollisionBoxes, r, i)) return;
                delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
        }
        this._done = !0;
    }
    commit(e1) {
        return this.placement.commit(e1), this.placement;
    }
};
const $834619e78bbf578c$var$Hs = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
], $834619e78bbf578c$var$Us = /* @__PURE__ */ new Uint32Array(96);
var $834619e78bbf578c$var$Ws = class e1 {
    static from(t) {
        if (!t || t.byteLength === void 0 || t.buffer) throw Error(`Data must be an instance of ArrayBuffer or SharedArrayBuffer.`);
        let [n, r] = new Uint8Array(t, 0, 2);
        if (n !== 219) throw Error(`Data does not appear to be in a KDBush format.`);
        let i = r >> 4;
        if (i !== 1) throw Error(`Got v${i} data when expected v1.`);
        let a = $834619e78bbf578c$var$Hs[r & 15];
        if (!a) throw Error(`Unrecognized array type.`);
        let [o] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
        return new e1(s, o, a, void 0, t);
    }
    constructor(e1, t = 64, n = Float64Array, r = ArrayBuffer, i){
        if (isNaN(e1) || e1 < 0) throw Error(`Unexpected numItems value: ${e1}.`);
        this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = n, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
        let a = $834619e78bbf578c$var$Hs.indexOf(this.ArrayType), o = e1 * 2 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, c = (8 - s % 8) % 8;
        if (a < 0) throw Error(`Unexpected typed array class: ${n}.`);
        if (i) this.data = i, this.ids = new this.IndexArrayType(i, 8, e1), this.coords = new n(i, 8 + s + c, e1 * 2), this._pos = e1 * 2, this._finished = !0;
        else {
            let i = this.data = new r(8 + o + s + c);
            this.ids = new this.IndexArrayType(i, 8, e1), this.coords = new n(i, 8 + s + c, e1 * 2), this._pos = 0, this._finished = !1, new Uint8Array(i, 0, 2).set([
                219,
                16 + a
            ]), new Uint16Array(i, 2, 1)[0] = t, new Uint32Array(i, 4, 1)[0] = e1;
        }
    }
    add(e1, t) {
        let n = this._pos >> 1;
        return this.ids[n] = n, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, n;
    }
    finish() {
        let e1 = this._pos >> 1;
        if (e1 !== this.numItems) throw Error(`Added ${e1} items when expected ${this.numItems}.`);
        return $834619e78bbf578c$var$Gs(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
    }
    range(e1, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        $834619e78bbf578c$var$Us[0] = 0, $834619e78bbf578c$var$Us[1] = i.length - 1, $834619e78bbf578c$var$Us[2] = 0;
        let s = 3, c = [];
        for(; s > 0;){
            let l = $834619e78bbf578c$var$Us[--s], u = $834619e78bbf578c$var$Us[--s], d = $834619e78bbf578c$var$Us[--s];
            if (u - d <= o) {
                for(let o = d; o <= u; o++){
                    let s = a[2 * o], l = a[2 * o + 1];
                    s >= e1 && s <= n && l >= t && l <= r && c.push(i[o]);
                }
                continue;
            }
            let f = d + u >> 1, p = a[2 * f], m = a[2 * f + 1];
            p >= e1 && p <= n && m >= t && m <= r && c.push(i[f]), (l === 0 ? e1 <= p : t <= m) && ($834619e78bbf578c$var$Us[s++] = d, $834619e78bbf578c$var$Us[s++] = f - 1, $834619e78bbf578c$var$Us[s++] = 1 - l), (l === 0 ? n >= p : r >= m) && ($834619e78bbf578c$var$Us[s++] = f + 1, $834619e78bbf578c$var$Us[s++] = u, $834619e78bbf578c$var$Us[s++] = 1 - l);
        }
        return c;
    }
    within(e1, t, n) {
        let r = [];
        return this.withinInto(e1, t, n, r), r;
    }
    withinInto(e1, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        $834619e78bbf578c$var$Us[0] = 0, $834619e78bbf578c$var$Us[1] = i.length - 1, $834619e78bbf578c$var$Us[2] = 0;
        let s = 3, c = 0, l = n * n;
        for(; s > 0;){
            let u = $834619e78bbf578c$var$Us[--s], d = $834619e78bbf578c$var$Us[--s], f = $834619e78bbf578c$var$Us[--s];
            if (d - f <= o) {
                for(let n = f; n <= d; n++)$834619e78bbf578c$var$Ys(a[2 * n], a[2 * n + 1], e1, t) <= l && (r[c++] = i[n]);
                continue;
            }
            let p = f + d >> 1, m = a[2 * p], h = a[2 * p + 1];
            $834619e78bbf578c$var$Ys(m, h, e1, t) <= l && (r[c++] = i[p]), (u === 0 ? e1 - n <= m : t - n <= h) && ($834619e78bbf578c$var$Us[s++] = f, $834619e78bbf578c$var$Us[s++] = p - 1, $834619e78bbf578c$var$Us[s++] = 1 - u), (u === 0 ? e1 + n >= m : t + n >= h) && ($834619e78bbf578c$var$Us[s++] = p + 1, $834619e78bbf578c$var$Us[s++] = d, $834619e78bbf578c$var$Us[s++] = 1 - u);
        }
        return c;
    }
};
function $834619e78bbf578c$var$Gs(e1, t, n, r, i, a) {
    if (i - r <= n) return;
    let o = r + i >> 1;
    $834619e78bbf578c$var$Ks(e1, t, o, r, i, a), $834619e78bbf578c$var$Gs(e1, t, n, r, o - 1, 1 - a), $834619e78bbf578c$var$Gs(e1, t, n, o + 1, i, 1 - a);
}
function $834619e78bbf578c$var$Ks(e1, t, n, r, i, a) {
    for(; i > r;){
        if (i - r > 600) {
            let o = i - r + 1, s = n - r + 1, c = Math.log(o), l = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
            $834619e78bbf578c$var$Ks(e1, t, n, Math.max(r, Math.floor(n - s * l / o + u)), Math.min(i, Math.floor(n + (o - s) * l / o + u)), a);
        }
        let o = t[2 * n + a], s = r, c = i;
        for($834619e78bbf578c$var$qs(e1, t, r, n), t[2 * i + a] > o && $834619e78bbf578c$var$qs(e1, t, r, i); s < c;){
            for($834619e78bbf578c$var$qs(e1, t, s, c), s++, c--; t[2 * s + a] < o;)s++;
            for(; t[2 * c + a] > o;)c--;
        }
        t[2 * r + a] === o ? $834619e78bbf578c$var$qs(e1, t, r, c) : (c++, $834619e78bbf578c$var$qs(e1, t, c, i)), c <= n && (r = c + 1), n <= c && (i = c - 1);
    }
}
function $834619e78bbf578c$var$qs(e1, t, n, r) {
    $834619e78bbf578c$var$Js(e1, n, r), $834619e78bbf578c$var$Js(t, 2 * n, 2 * r), $834619e78bbf578c$var$Js(t, 2 * n + 1, 2 * r + 1);
}
function $834619e78bbf578c$var$Js(e1, t, n) {
    let r = e1[t];
    e1[t] = e1[n], e1[n] = r;
}
function $834619e78bbf578c$var$Ys(e1, t, n, r) {
    let i = e1 - n, a = t - r;
    return i * i + a * a;
}
const $834619e78bbf578c$var$Xs = 512 / (0, $1rqx5.Lr) / 2;
var $834619e78bbf578c$var$Zs = class {
    constructor(e1, t, n){
        this.tileID = e1, this.bucketInstanceId = n, this._symbolsByKey = {};
        let r = /* @__PURE__ */ new Map;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t.get(e1), i = n.key, a = r.get(i);
            a ? a.push(n) : r.set(i, [
                n
            ]);
        }
        for (let [e1, t] of r){
            let n = {
                positions: t.map((e1)=>({
                        x: Math.floor(e1.anchorX * $834619e78bbf578c$var$Xs),
                        y: Math.floor(e1.anchorY * $834619e78bbf578c$var$Xs)
                    })),
                crossTileIDs: t.map((e1)=>e1.crossTileID)
            };
            if (n.positions.length > 128) {
                let e1 = new $834619e78bbf578c$var$Ws(n.positions.length, 16, Uint16Array);
                for (let { x: t, y: r } of n.positions)e1.add(t, r);
                e1.finish(), delete n.positions, n.index = e1;
            }
            this._symbolsByKey[e1] = n;
        }
    }
    getScaledCoordinates(e1, t) {
        let { x: n, y: r, z: i } = this.tileID.canonical, { x: a, y: o, z: s } = t.canonical, c = s - i, l = $834619e78bbf578c$var$Xs / 2 ** c, u = (a * (0, $1rqx5.Lr) + e1.anchorX) * l, d = (o * (0, $1rqx5.Lr) + e1.anchorY) * l, f = n * (0, $1rqx5.Lr) * $834619e78bbf578c$var$Xs, p = r * (0, $1rqx5.Lr) * $834619e78bbf578c$var$Xs;
        return {
            x: Math.floor(u - f),
            y: Math.floor(d - p)
        };
    }
    findMatches(e1, t, n) {
        let r = this.tileID.canonical.z < t.canonical.z ? 1 : 2 ** (this.tileID.canonical.z - t.canonical.z);
        for(let i = 0; i < e1.length; i++){
            let a = e1.get(i);
            if (a.crossTileID) continue;
            let o = this._symbolsByKey[a.key];
            if (!o) continue;
            let s = this.getScaledCoordinates(a, t);
            o.index ? this.findMatchesForIndexedEntry(o, a, s, r, n) : o.positions && this.findMatchesForNonIndexedEntry(o, a, s, r, n);
        }
    }
    findMatchesForIndexedEntry(e1, t, n, r, i) {
        let a = e1.index.range(n.x - r, n.y - r, n.x + r, n.y + r), o = 1 / 0;
        for (let t of a)t < o && !i[e1.crossTileIDs[t]] && (o = t);
        if (o !== 1 / 0) {
            let n = e1.crossTileIDs[o];
            i[n] = !0, t.crossTileID = n;
        }
    }
    findMatchesForNonIndexedEntry(e1, t, n, r, i) {
        for(let a = 0; a < e1.positions.length; a++){
            let o = e1.positions[a], s = e1.crossTileIDs[a];
            if (Math.abs(o.x - n.x) <= r && Math.abs(o.y - n.y) <= r && !i[s]) {
                i[s] = !0, t.crossTileID = s;
                break;
            }
        }
    }
    getCrossTileIDsLists() {
        return Object.values(this._symbolsByKey).map(({ crossTileIDs: e1 })=>e1);
    }
}, $834619e78bbf578c$var$Qs = class {
    constructor(){
        this.maxCrossTileID = 0;
    }
    generate() {
        return ++this.maxCrossTileID;
    }
}, $834619e78bbf578c$var$$s = class {
    constructor(){
        this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
    }
    handleWrapJump(e1) {
        let t = Math.round((e1 - this.lng) / 360);
        if (t !== 0) for(let e1 in this.indexes){
            let n = this.indexes[e1], r = {};
            for(let e1 in n){
                let i = n[e1];
                i.tileID = i.tileID.unwrapTo(i.tileID.wrap + t), r[i.tileID.key] = i;
            }
            this.indexes[e1] = r;
        }
        this.lng = e1;
    }
    addBucket(e1, t, n) {
        if (this.indexes[e1.overscaledZ]?.[e1.key]) {
            if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
            this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let n = t.symbolInstances.get(e1);
            n.crossTileID = 0;
        }
        this.usedCrossTileIDs[e1.overscaledZ] ||= {};
        let r = this.usedCrossTileIDs[e1.overscaledZ];
        for(let n in this.indexes){
            let i = this.indexes[n];
            if (Number(n) > e1.overscaledZ) for(let n in i){
                let a = i[n];
                a.tileID.isChildOf(e1) && a.findMatches(t.symbolInstances, e1, r);
            }
            else {
                let a = i[e1.scaledTo(Number(n)).key];
                a && a.findMatches(t.symbolInstances, e1, r);
            }
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let i = t.symbolInstances.get(e1);
            i.crossTileID || (i.crossTileID = n.generate(), r[i.crossTileID] = !0);
        }
        return this.indexes[e1.overscaledZ] === void 0 && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new $834619e78bbf578c$var$Zs(e1, t.symbolInstances, t.bucketInstanceId), !0;
    }
    removeBucketCrossTileIDs(e1, t) {
        for (let n of t.getCrossTileIDsLists())for (let t of n)delete this.usedCrossTileIDs[e1][t];
    }
    removeStaleBuckets(e1) {
        let t = !1;
        for(let n in this.indexes){
            let r = this.indexes[n];
            for(let i in r)e1[r[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(n, r[i]), delete r[i], t = !0);
        }
        return t;
    }
}, $834619e78bbf578c$var$ec = class {
    constructor(){
        this.layerIndexes = {}, this.crossTileIDs = new $834619e78bbf578c$var$Qs, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
    }
    addLayer(e1, t, n) {
        let r = this.layerIndexes[e1.id];
        r === void 0 && (r = this.layerIndexes[e1.id] = new $834619e78bbf578c$var$$s);
        let i = !1, a = {};
        r.handleWrapJump(n);
        for (let n of t){
            let t = n.getBucket(e1);
            e1.id === t?.layerIds[0] && (t.bucketInstanceId ||= (this.maxBucketInstanceId += 1, this.maxBucketInstanceId), r.addBucket(n.tileID, t, this.crossTileIDs) && (i = !0), a[t.bucketInstanceId] = !0);
        }
        return r.removeStaleBuckets(a) && (i = !0), i;
    }
    pruneUnusedLayers(e1) {
        let t = {};
        for (let n of e1)t[n] = !0;
        for(let e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
    }
}, $834619e78bbf578c$var$tc = `#ifdef GL_ES
precision mediump float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
out highp vec4 fragColor;layout(std140) uniform ProjectionUBO {highp mat4 u_projection_matrix;highp mat4 u_projection_fallback_matrix;highp vec4 u_projection_tile_mercator_coords;highp vec4 u_projection_clipping_plane;highp float u_projection_transition;highp int u_projection_clip_antimeridian;};layout(std140) uniform FrameUBO {highp vec2 u_units_to_pixels;highp vec2 u_world_size;highp float u_camera_to_center_distance;highp float u_symbol_fade_change;highp float u_aspect_ratio;highp float u_device_pixel_ratio;highp vec2 u_viewport_size;highp vec2 u_pixel_extrude_scale;highp float u_pitch;};`, $834619e78bbf578c$var$nc = `#ifdef GL_ES
precision highp float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const uint packedOpacity) {return vec2(float(packedOpacity >> 1u)/127.0,float(packedOpacity & 1u));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c
);}
#ifdef TERRAIN3D
uniform sampler2D u_terrain;uniform highp sampler2D u_depth;layout(std140) uniform TerrainUBO {highp mat4 u_terrain_matrix;highp vec4 u_terrain_unpack;highp float u_terrain_dim;highp float u_terrain_exaggeration;};
#endif
const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {
#ifdef TERRAIN3D
highp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));
#else
return 1.0;
#endif
}float calculate_visibility(vec4 pos) {
#ifdef TERRAIN3D
vec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;
#else
return 1.0;
#endif
}float ele(ivec2 pos) {
#ifdef TERRAIN3D
vec4 rgb=(texelFetch(u_terrain,pos,0)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;
#else
return 0.0;
#endif
}float get_elevation(vec2 pos) {
#ifdef TERRAIN3D
#ifdef GLOBE
if ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}
#endif
vec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.5;vec2 f=fract(coord);ivec2 c=ivec2(floor(coord));ivec2 hi=textureSize(u_terrain,0)-1;float tl=ele(clamp(c,ivec2(0),hi));float tr=ele(clamp(c+ivec2(1,0),ivec2(0),hi));float bl=ele(clamp(c+ivec2(0,1),ivec2(0),hi));float br=ele(clamp(c+ivec2(1,1),ivec2(0),hi));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;
#else
return 0.0;
#endif
}const float PI=3.141592653589793;
#define PROJECTION_UBO
layout(std140) uniform ProjectionUBO {highp mat4 u_projection_matrix;highp mat4 u_projection_fallback_matrix;highp vec4 u_projection_tile_mercator_coords;highp vec4 u_projection_clipping_plane;highp float u_projection_transition;highp int u_projection_clip_antimeridian;};layout(std140) uniform FrameUBO {highp vec2 u_units_to_pixels;highp vec2 u_world_size;highp float u_camera_to_center_distance;highp float u_symbol_fade_change;highp float u_aspect_ratio;highp float u_device_pixel_ratio;highp vec2 u_viewport_size;highp vec2 u_pixel_extrude_scale;highp float u_pitch;};`, $834619e78bbf578c$var$rc = `uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $834619e78bbf578c$var$ic = `layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}`, $834619e78bbf578c$var$ac = `uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $834619e78bbf578c$var$oc = `uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}`, $834619e78bbf578c$var$sc = `in vec3 v_data;flat in float v_visibility;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define mediump float radius
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 stroke_color
#pragma maplibre: define mediump float stroke_width
#pragma maplibre: define lowp float stroke_opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump float radius
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 stroke_color
#pragma maplibre: initialize mediump float stroke_width
#pragma maplibre: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $834619e78bbf578c$var$cc = `uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform vec2 u_translate;layout(location=0) in ivec2 a_pos;out vec3 v_data;flat out float v_visibility;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define mediump float radius
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 stroke_color
#pragma maplibre: define mediump float stroke_width
#pragma maplibre: define lowp float stroke_opacity
void main(void) {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump float radius
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 stroke_color
#pragma maplibre: initialize mediump float stroke_width
#pragma maplibre: initialize lowp float stroke_opacity
ivec2 pos_raw=a_pos+32768;vec2 extrude=vec2(pos_raw & 7)/7.0*2.0-1.0;vec2 circle_center=vec2(pos_raw >> 3)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {
#ifdef GLOBE
vec3 center_vector=projectToSphere(circle_center);
#endif
float angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {
#ifdef GLOBE
vec4 projected_center=interpolateProjection(circle_center,center_vector,ele);
#else
vec4 projected_center=projectTileWithElevation(circle_center,ele);
#endif
corner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}
#ifdef GLOBE
vec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);
#else
gl_Position=projectTileWithElevation(corner_position,ele);
#endif
} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}`, $834619e78bbf578c$var$lc = `void main() {fragColor=vec4(1.0);}`;
const $834619e78bbf578c$var$uc = {
    prelude: $834619e78bbf578c$var$Y($834619e78bbf578c$var$tc, $834619e78bbf578c$var$nc),
    projectionMercator: $834619e78bbf578c$var$Y(`
void clipAntimeridian() {}`, `float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}`),
    projectionGlobe: $834619e78bbf578c$var$Y(`in highp float v_projection_tile_x;void clipAntimeridian() {if (u_projection_clip_antimeridian !=0 && (v_projection_tile_x < 0.0 || v_projection_tile_x >=8192.0)) {discard;}}`, `#define GLOBE_RADIUS 6371008.8
#ifndef PROJECTION_UBO
uniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;
#endif
out highp float v_projection_tile_x;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos
);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float t=exp(PI-(mercator_pos_y*PI*2.0));return (2.0*t)/(t*t+1.0);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY);if (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;float spherical_x=mercator_pos.x*PI*2.0+PI;float t=exp(PI-(mercator_pos.y*PI*2.0));float t2=t*t;float denom=t2+1.0;float sin_sy=(t2-1.0)/denom;float cos_sy=(2.0*t)/denom;vec3 pos=vec3(sin(spherical_x)*cos_sy,sin_sy,cos(spherical_x)*cos_sy
);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {v_projection_tile_x=posInTile.x;vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {v_projection_tile_x=posInTile.x;vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}`),
    background: $834619e78bbf578c$var$Y($834619e78bbf578c$var$rc, $834619e78bbf578c$var$ic),
    backgroundPattern: $834619e78bbf578c$var$Y($834619e78bbf578c$var$ac, $834619e78bbf578c$var$oc),
    circle: $834619e78bbf578c$var$Y($834619e78bbf578c$var$sc, $834619e78bbf578c$var$cc),
    clippingMask: $834619e78bbf578c$var$Y($834619e78bbf578c$var$lc, `layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}`),
    heatmap: $834619e78bbf578c$var$Y(`uniform highp float u_intensity;in vec2 v_extrude;
#pragma maplibre: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma maplibre: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;layout(location=0) in ivec2 a_pos;out vec2 v_extrude;
#pragma maplibre: define highp float weight
#pragma maplibre: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma maplibre: initialize highp float weight
#pragma maplibre: initialize mediump float radius
ivec2 pos_raw=a_pos+32768;vec2 unscaled_extrude=vec2(pos_raw & 7)/7.0*2.0-1.0;float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=vec2(pos_raw >> 3);
#ifdef GLOBE
vec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);
#else
gl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));
#endif
}`),
    heatmapTexture: $834619e78bbf578c$var$Y(`uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(0.0);
#endif
}`, `uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world_size,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}`),
    collisionBox: $834619e78bbf578c$var$Y(`flat in float v_placed;flat in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}`, `layout(location=0) in vec2 a_anchor_pos;layout(location=1) in vec2 a_placed;layout(location=2) in vec2 a_box_real;flat out float v_placed;flat out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}`),
    collisionCircle: $834619e78bbf578c$var$Y(`flat in float v_radius;in vec2 v_extrude;flat in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}`, `layout(location=0) in vec2 a_pos;layout(location=1) in float a_radius;layout(location=2) in vec2 a_flags;flat out float v_radius;out vec2 v_extrude;flat out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}`),
    colorRelief: $834619e78bbf578c$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {vec4 data=texelFetch(u_elevation_stops,ivec2(stop,0),0)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else
{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=2.0/u_dimension;float scale=(u_dimension.x-4.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}`),
    debug: $834619e78bbf578c$var$Y(`uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}`, `layout(location=0) in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}`),
    depth: $834619e78bbf578c$var$Y($834619e78bbf578c$var$lc, `layout(location=0) in vec2 a_pos;void main() {
#ifdef GLOBE
gl_Position=projectTileFor3D(a_pos,0.0);
#else
gl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);
#endif
}`),
    fill: $834619e78bbf578c$var$Y(`#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float opacity
fragColor=color*opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float opacity
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);}`),
    fillOutline: $834619e78bbf578c$var$Y(`in vec2 v_pos;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 outline_color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 outline_color
#pragma maplibre: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 outline_color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 outline_color
#pragma maplibre: initialize lowp float opacity
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world_size;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
}`),
    fillOutlinePattern: $834619e78bbf578c$var$Y(`uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;uniform bool u_sdf_pattern;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);if (u_sdf_pattern) {highp float sdf_edge=(256.0-64.0)/256.0;highp float sdf_gamma_a=max(fwidth(color1.a)*0.5,1.0/255.0/16.0);highp float sdf_gamma_b=max(fwidth(color2.a)*0.5,1.0/255.0/16.0);float sdf_alpha_a=smoothstep(sdf_edge-sdf_gamma_a,sdf_edge+sdf_gamma_a,color1.a);float sdf_alpha_b=smoothstep(sdf_edge-sdf_gamma_b,sdf_edge+sdf_gamma_b,color2.a);fragColor=mix(color*sdf_alpha_a,color*sdf_alpha_b,u_fade)*alpha*opacity;} else {fragColor=mix(color1,color2,u_fade)*alpha*opacity;}
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world_size;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
}`),
    fillPattern: $834619e78bbf578c$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform bool u_sdf_pattern;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);if (u_sdf_pattern) {highp float sdf_edge=(256.0-64.0)/256.0;highp float sdf_gamma_a=max(fwidth(color1.a)*0.5,1.0/255.0/16.0);highp float sdf_gamma_b=max(fwidth(color2.a)*0.5,1.0/255.0/16.0);float sdf_alpha_a=smoothstep(sdf_edge-sdf_gamma_a,sdf_edge+sdf_gamma_a,color1.a);float sdf_alpha_b=smoothstep(sdf_edge-sdf_gamma_b,sdf_edge+sdf_gamma_b,color2.a);fragColor=mix(color*sdf_alpha_a,color*sdf_alpha_b,u_fade)*opacity;} else {fragColor=mix(color1,color2,u_fade)*opacity;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}`),
    fillExtrusion: $834619e78bbf578c$var$Y(`in vec4 v_color;void main() {fragColor=v_color;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;layout(location=1) in ivec4 a_normal_ed;
#ifdef TERRAIN3D
layout(location=2) in vec2 a_centroid;
#endif
out vec4 v_color;
#pragma maplibre: define highp float base
#pragma maplibre: define highp float height
#pragma maplibre: define highp vec4 color
void main() {
#pragma maplibre: initialize highp float base
#pragma maplibre: initialize highp float height
#pragma maplibre: initialize highp vec4 color
vec3 normal=vec3(a_normal_ed.xyz);float gradient_base=max(0.0,base);float gradient_height=max(0.0,height);
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=float(a_normal_ed.x & 1);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;
#ifdef GLOBE
vec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);
#else
gl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);
#endif
float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);
#ifdef GLOBE
mat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);
#endif
directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+gradient_base)*pow(gradient_height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}`),
    fillExtrusionPattern: $834619e78bbf578c$var$Y(`uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;
#pragma maplibre: define lowp float base
#pragma maplibre: define lowp float height
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float base
#pragma maplibre: initialize lowp float height
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;layout(location=0) in vec2 a_pos;layout(location=1) in ivec4 a_normal_ed;
#ifdef TERRAIN3D
layout(location=2) in vec2 a_centroid;
#endif
#ifdef GLOBE
out vec3 v_sphere_pos;
#endif
out vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;
#pragma maplibre: define lowp float base
#pragma maplibre: define lowp float height
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float base
#pragma maplibre: initialize lowp float height
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=vec3(a_normal_ed.xyz);float edgedistance=float(a_normal_ed.w);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;float gradient_base=max(0.0,base);float gradient_height=max(0.0,height);
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=float(a_normal_ed.x & 1);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;
#ifdef GLOBE
vec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);
#else
gl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);
#endif
vec2 pos=a_normal_ed.x==1 && a_normal_ed.y==0 && a_normal_ed.z==16384
? a_pos
: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+gradient_base)*pow(gradient_height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}`),
    hillshadePrepare: $834619e78bbf578c$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(ivec2 texel) {vec4 data=texelFetch(u_image,texel,0)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {ivec2 pos=ivec2(gl_FragCoord.xy)+ivec2(1);float tileSize=u_dimension.x-4.0;float a=getElevation(pos+ivec2(-1,-1));float b=getElevation(pos+ivec2(0,-1));float c=getElevation(pos+ivec2(1,-1));float d=getElevation(pos+ivec2(-1,0));float e=getElevation(pos);float f=getElevation(pos+ivec2(1,0));float g=getElevation(pos+ivec2(-1,1));float h=getElevation(pos+ivec2(0,1));float i=getElevation(pos+ivec2(1,1));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+128.0/255.0,deriv.y/8.0+128.0/255.0,1.0,1.0),0.0,1.0);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;layout(location=1) in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}`),
    hillshade: $834619e78bbf578c$var$Y(`uniform sampler2D u_image;in highp vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];
#define PI 3.141592653589793
#define STANDARD 0
#define COMBINED 1
#define IGOR 2
#define MULTIDIRECTIONAL 3
#define BASIC 4
float get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else
{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else
{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {highp vec2 size=vec2(textureSize(u_image,0));highp vec2 texturePos=(v_pos*(size-2.0)+1.0)/size;vec4 pixel=texture(u_image,texturePos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=(pixel.rg-128.0/255.0)*8.0/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}`),
    line: $834619e78bbf578c$var$Y(`flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);v_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*2.0;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
    lineGradient: $834619e78bbf578c$var$Y(`uniform sampler2D u_image;flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_image_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
    linePattern: $834619e78bbf578c$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;flat in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;flat in float v_width;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
clipAntimeridian();vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;flat out float v_width;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}`),
    lineSDF: $834619e78bbf578c$var$Y(`uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
float u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}`),
    lineGradientSDF: $834619e78bbf578c$var$Y(`uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
float u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}`),
    layerOpacity: $834619e78bbf578c$var$Y(`uniform sampler2D u_image;uniform float u_opacity;in vec2 v_pos;void main() {fragColor=texture(u_image,v_pos)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(0.0);
#endif
}`, `layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos.x*2.0-1.0,1.0-a_pos.y*2.0,0.0,1.0);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}`),
    raster: $834619e78bbf578c$var$Y(`uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec3 v_pos0;in vec3 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0.xy/v_pos0.z);vec4 color1=texture(u_image1,v_pos1.xy/v_pos1.z);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec3 u_image_warp;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;layout(location=0) in vec2 a_pos;out vec3 v_pos0;out vec3 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 topLeft=u_coords_top.xy;vec2 topRight=u_coords_top.zw;vec2 bottomLeft=u_coords_bottom.xy;vec2 bottomRight=u_coords_bottom.zw;vec2 bilinearPos=mix(mix(topLeft,topRight,fractionalPos.x),mix(bottomLeft,bottomRight,fractionalPos.x),fractionalPos.y);float denominator=dot(u_image_warp.xy,fractionalPos)+1.0;vec2 acrossTop=topRight-topLeft+u_image_warp.x*topRight;vec2 downLeft=bottomLeft-topLeft+u_image_warp.y*bottomLeft;vec2 projectivePos=(acrossTop*fractionalPos.x+downLeft*fractionalPos.y+topLeft)/denominator;vec2 position=mix(projectivePos,bilinearPos,u_image_warp.z);gl_Position=projectTile(position,position);vec2 texturePos=((fractionalPos-0.5)/u_buffer_scale)+0.5;
#ifdef GLOBE
if (a_pos.y <-32767.5) {texturePos.y=0.0;}if (a_pos.y > 32766.5) {texturePos.y=1.0;}
#endif
float perspectiveRatio=mix(1.0/denominator,1.0,u_image_warp.z);v_pos0=vec3(texturePos*perspectiveRatio,perspectiveRatio);vec2 parentPos=(texturePos*u_scale_parent)+u_tl_parent;v_pos1=vec3(parentPos*perspectiveRatio,perspectiveRatio);}`),
    symbolIcon: $834619e78bbf578c$var$Y(`uniform sampler2D u_texture;in vec2 v_tex;flat in float v_total_opacity;void main() {fragColor=texture(u_texture,v_tex)*v_total_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in uint a_fade_opacity;layout(location=5) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform bool u_rotate_symbol;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec2 v_tex;flat out float v_total_opacity;
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize lowp float opacity
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float visibility=calculate_visibility(projectedPoint);v_total_opacity=opacity*max(0.0,min(visibility,fade_opacity[0]+fade_change));if (v_total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;}`),
    symbolSDF: $834619e78bbf578c$var$Y(`#define SDF_PX 8.0
uniform bool u_is_halo;uniform bool u_is_plain;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
float EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float total_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out_text,color_alpha_out_halo;if (u_is_plain){highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);color_alpha_out_text=total_opacity*alpha*fill_color;}if (u_is_halo) {float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);float inner_edge_halo=inner_edge+gamma_halo*gamma_scale;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(inner_edge_halo-gamma_scaled_halo,inner_edge_halo+gamma_scaled_halo,dist);highp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha_halo= min(smoothstep(halo_edge-gamma_scaled_halo,halo_edge+gamma_scaled_halo,dist),1.0-alpha_halo);color_alpha_out_halo=total_opacity*alpha_halo*halo_color;}if (u_is_plain && u_is_halo) {fragColor=color_alpha_out_text+(1.-color_alpha_out_text.a)*color_alpha_out_halo;} else if (u_is_halo){fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out_text;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in uint a_fade_opacity;layout(location=5) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform bool u_rotate_symbol;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec2 v_data0;out vec3 v_data1;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);vec2 a_pxoffset=a_pixeloffset.xy/16.0;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,total_opacity);}`),
    symbolTextAndIcon: $834619e78bbf578c$var$Y(`#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform bool u_is_halo;uniform bool u_is_text;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;in vec4 v_data0;in vec3 v_data1;flat in float v_is_sdf;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
float total_opacity=v_data1[2];if (v_is_sdf==ICON) {vec2 tex_icon=v_data0.zw;fragColor=texture(u_texture_icon,tex_icon)*total_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
return;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out,color_alpha_out_halo;if (u_is_text) {highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);color_alpha_out=fill_color*(alpha*total_opacity);}if (u_is_halo) {highp float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);lowp float buff_halo=(6.0-halo_width/fontScale)/SDF_PX;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(buff_halo-gamma_scaled_halo,buff_halo+gamma_scaled_halo,dist);color_alpha_out_halo=halo_color*(alpha_halo*total_opacity);}if (u_is_text && u_is_halo) {fragColor=color_alpha_out+(1.-color_alpha_out.a)*color_alpha_out_halo;} else if (u_is_halo) {fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec3 a_projected_pos;layout(location=3) in uint a_fade_opacity;layout(location=4) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec4 v_data0;out vec3 v_data1;flat out float v_is_sdf;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);float is_sdf=float(a_data.z & 1u);float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec3(gamma_scale,size,total_opacity);v_is_sdf=is_sdf;}`),
    terrain: $834619e78bbf578c$var$Y(`uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && u_fog_ground_blend_opacity > 0.0 && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}`, `layout(location=0) in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}`),
    terrainDepth: $834619e78bbf578c$var$Y(`in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}`, `layout(location=0) in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}`),
    atmosphere: $834619e78bbf578c$var$Y(`#ifdef GL_ES
precision highp float;
#endif
in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758
);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}`, `layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}`),
    sky: $834619e78bbf578c$var$Y(`uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;in vec3 v_view_direction;const float ATMOSPHERE_HEIGHT_TO_GLOBE_RADIUS=100000.0/6371000.0;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;float opacity=1.0;if (u_sky_blend > 0.0) {vec3 ray=normalize(v_view_direction);float globe_distance=length(u_globe_position);float angle_to_globe_center=acos(clamp(dot(ray,u_globe_position)/globe_distance,-1.0,1.0));float horizon_angle=asin(min(u_globe_radius/globe_distance,1.0));blend=mix(blend,((angle_to_globe_center-horizon_angle)*u_camera_to_center_distance+1.0)*u_device_pixel_ratio,u_sky_blend);float closest_approach=max(dot(ray,u_globe_position),0.0);float lowest_altitude=sqrt(max(globe_distance*globe_distance-closest_approach*closest_approach,0.0))-u_globe_radius;float atmosphere_height=u_globe_radius*ATMOSPHERE_HEIGHT_TO_GLOBE_RADIUS;float inside_atmosphere=1.0-smoothstep(atmosphere_height,10.0*atmosphere_height,globe_distance-u_globe_radius);float through_atmosphere=1.0-smoothstep(0.0,atmosphere_height,lowest_altitude);opacity=inside_atmosphere*through_atmosphere*(1.0-u_atmosphere_blend);}if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor*=mix(1.0,opacity,u_sky_blend);}`, `layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 v_view_direction;void main() {v_view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,1.0,1.0);}`)
};
function $834619e78bbf578c$var$Y(e1, t) {
    let n = /#pragma maplibre: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, r = t.match(/in ([\w]+) ([\w]+)/g), i = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = a ? a.concat(i) : i, s = r ? r.length : 0, c = {};
    return e1 = e1.replace(n, (e1, t, n, r, i)=>(c[i] = !0, t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
in ${n} ${r} ${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : `
#ifdef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = u_${i};
#endif
`)), t = t.replace(n, (e1, t, n, r, i)=>{
        let a = r === `float` ? `vec2` : `vec4`, o = i.match(/color/) ? `color` : a;
        return c[i] ? t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
uniform lowp float u_${i}_t;
layout(location = ${s++}) in ${n} ${a} a_${i};
out ${n} ${r} ${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : o === `vec4` ? `
#ifndef HAS_UNIFORM_u_${i}
    ${i} = a_${i};
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : `
#ifndef HAS_UNIFORM_u_${i}
    ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
uniform lowp float u_${i}_t;
layout(location = ${s++}) in ${n} ${a} a_${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : o === `vec4` ? `
#ifndef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = a_${i};
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : `
#ifndef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);
#else
    ${n} ${r} ${i} = u_${i};
#endif
`;
    }), {
        fragmentSource: e1,
        vertexSource: t,
        staticAttributes: r,
        staticUniforms: o
    };
}
const $834619e78bbf578c$var$dc = `#define PROJECTION_MERCATOR`, $834619e78bbf578c$var$fc = `mercator`;
var $834619e78bbf578c$var$pc = class {
    constructor(){
        this._cachedMesh = null;
    }
    get name() {
        return `mercator`;
    }
    get useSubdivision() {
        return !1;
    }
    get shaderVariantName() {
        return $834619e78bbf578c$var$fc;
    }
    get shaderDefine() {
        return $834619e78bbf578c$var$dc;
    }
    get shaderPreludeCode() {
        return $834619e78bbf578c$var$uc.projectionMercator;
    }
    get vertexShaderPreludeCode() {
        return $834619e78bbf578c$var$uc.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return (0, $1rqx5.vt).noSubdivision;
    }
    get useGlobeControls() {
        return !1;
    }
    get transitionState() {
        return 0;
    }
    destroy() {}
    getMeshFromTileID(e1, t, n, r, i) {
        if (this._cachedMesh) return this._cachedMesh;
        let a = new (0, $1rqx5.Gt);
        a.emplaceBack(0, 0), a.emplaceBack((0, $1rqx5.Lr), 0), a.emplaceBack(0, (0, $1rqx5.Lr)), a.emplaceBack((0, $1rqx5.Lr), (0, $1rqx5.Lr));
        let o = e1.createVertexBuffer(a, $834619e78bbf578c$var$Ya.members), s = (0, $1rqx5.Bt).simpleSegment(0, 0, 4, 2), c = new (0, $1rqx5.Jt);
        c.emplaceBack(1, 0, 2), c.emplaceBack(1, 2, 3);
        let l = e1.createIndexBuffer(c);
        return this._cachedMesh = new $834619e78bbf578c$var$Ja(o, l, s), this._cachedMesh;
    }
    recalculate() {}
    hasTransition() {
        return !1;
    }
}, $834619e78bbf578c$export$45cce0bd6c1f342a = class e1 {
    constructor(e1 = 0, t = 0, n = 0, r = 0){
        if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(n) || n < 0 || isNaN(r) || r < 0) throw Error(`Invalid value for edge-insets, top, bottom, left and right must all be numbers`);
        this.top = e1, this.bottom = t, this.left = n, this.right = r;
    }
    interpolate(e1, t, n) {
        return t.top != null && e1.top != null && (this.top = (0, $1rqx5.un).number(e1.top, t.top, n)), t.bottom != null && e1.bottom != null && (this.bottom = (0, $1rqx5.un).number(e1.bottom, t.bottom, n)), t.left != null && e1.left != null && (this.left = (0, $1rqx5.un).number(e1.left, t.left, n)), t.right != null && e1.right != null && (this.right = (0, $1rqx5.un).number(e1.right, t.right, n)), this;
    }
    getCenter(e1, t) {
        let n = (0, $1rqx5.Bn)((this.left + e1 - this.right) / 2, 0, e1), r = (0, $1rqx5.Bn)((this.top + t - this.bottom) / 2, 0, t);
        return new (0, $1rqx5.Li)(n, r);
    }
    equals(e1) {
        return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
    }
    clone() {
        return new e1(this.top, this.bottom, this.left, this.right);
    }
    toJSON() {
        return {
            top: this.top,
            bottom: this.bottom,
            left: this.left,
            right: this.right
        };
    }
};
function $834619e78bbf578c$var$hc(e1, t) {
    if (!e1.renderWorldCopies || e1.lngRange) return;
    let n = t.lng - e1.center.lng;
    t.lng += n > 180 ? -360 : n < -180 ? 360 : 0;
}
function $834619e78bbf578c$var$gc(e1) {
    return Math.max(0, Math.floor(e1));
}
var $834619e78bbf578c$var$_c = class {
    constructor(e1, t){
        this.applyConstrain = (e1, t)=>this._constrainOverride === null ? this._callbacks.defaultConstrain(e1, t) : this._constrainOverride(e1, t), this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = t?.renderWorldCopies === void 0 || !!t?.renderWorldCopies, this._minZoom = t?.minZoom || 0, this._maxZoom = t?.maxZoom || 22, this._minPitch = t?.minPitch === void 0 || t?.minPitch === null ? 0 : t?.minPitch, this._maxPitch = t?.maxPitch === void 0 || t?.maxPitch === null ? 60 : t?.maxPitch, this._constrainOverride = t?.constrainOverride ?? null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new (0, $1rqx5.lt)(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = $834619e78bbf578c$var$gc(this._zoom), this._scale = (0, $1rqx5.Fr)(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new $834619e78bbf578c$export$45cce0bd6c1f342a, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
    }
    apply(e1, t) {
        this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = $834619e78bbf578c$var$gc(this._zoom), this._scale = (0, $1rqx5.Fr)(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new $834619e78bbf578c$export$45cce0bd6c1f342a(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = e1.autoCalculateNearFarZ, t && this.constrainInternal(), this._calcMatrices();
    }
    get pixelsToClipSpaceMatrix() {
        return this._pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._clipSpaceToPixelsMatrix;
    }
    get minElevationForCurrentTile() {
        return this._minElevationForCurrentTile;
    }
    setMinElevationForCurrentTile(e1) {
        this._minElevationForCurrentTile = e1;
    }
    get tileSize() {
        return this._tileSize;
    }
    get tileZoom() {
        return this._tileZoom;
    }
    get scale() {
        return this._scale;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get bearingInRadians() {
        return this._bearingInRadians;
    }
    get lngRange() {
        return this._lngRange;
    }
    get latRange() {
        return this._latRange;
    }
    get pixelsToGLUnits() {
        return this._pixelsToGLUnits;
    }
    get minZoom() {
        return this._minZoom;
    }
    setMinZoom(e1) {
        if (this._minZoom === e1) return;
        this._minZoom = e1;
        let t = this._unmodified;
        this.setZoom(this.applyConstrain(this._center, this.zoom).zoom), this._unmodified = t;
    }
    get maxZoom() {
        return this._maxZoom;
    }
    setMaxZoom(e1) {
        if (this._maxZoom === e1) return;
        this._maxZoom = e1;
        let t = this._unmodified;
        this.setZoom(this.applyConstrain(this._center, this.zoom).zoom), this._unmodified = t;
    }
    get minPitch() {
        return this._minPitch;
    }
    setMinPitch(e1) {
        if (this._minPitch === e1) return;
        this._minPitch = e1;
        let t = this._unmodified;
        this.setPitch(Math.max(this.pitch, e1)), this._unmodified = t;
    }
    get maxPitch() {
        return this._maxPitch;
    }
    setMaxPitch(e1) {
        if (this._maxPitch === e1) return;
        this._maxPitch = e1;
        let t = this._unmodified;
        this.setPitch(Math.min(this.pitch, e1)), this._unmodified = t;
    }
    get renderWorldCopies() {
        return this._renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        e1 === void 0 ? e1 = !0 : e1 === null && (e1 = !1), this._renderWorldCopies = e1;
    }
    get constrainOverride() {
        return this._constrainOverride;
    }
    setConstrainOverride(e1) {
        e1 === void 0 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
    }
    get worldSize() {
        return this._tileSize * this._scale;
    }
    get centerOffset() {
        return this.centerPoint._sub(this.size._div(2));
    }
    get size() {
        return new (0, $1rqx5.Li)(this._width, this._height);
    }
    get bearing() {
        return this._bearingInRadians / Math.PI * 180;
    }
    setBearing(e1) {
        let t = (0, $1rqx5.Pr)(e1, -180, 180) * Math.PI / 180;
        this._bearingInRadians !== t && (this._unmodified = !1, this._bearingInRadians = t, this._calcMatrices(), this._rotationMatrix = $834619e78bbf578c$var$jr(), $834619e78bbf578c$var$Pr(this._rotationMatrix, this._rotationMatrix, -this._bearingInRadians));
    }
    get rotationMatrix() {
        return this._rotationMatrix;
    }
    get pitchInRadians() {
        return this._pitchInRadians;
    }
    get pitch() {
        return this._pitchInRadians / Math.PI * 180;
    }
    setPitch(e1) {
        let t = (0, $1rqx5.Bn)(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
        this._pitchInRadians !== t && (this._unmodified = !1, this._pitchInRadians = t, this._calcMatrices());
    }
    get rollInRadians() {
        return this._rollInRadians;
    }
    get roll() {
        return this._rollInRadians / Math.PI * 180;
    }
    setRoll(e1) {
        let t = e1 / 180 * Math.PI;
        this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
    }
    get fovInRadians() {
        return this._fovInRadians;
    }
    get fov() {
        return (0, $1rqx5.xr)(this._fovInRadians);
    }
    setFov(e1) {
        e1 = (0, $1rqx5.Bn)(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = (0, $1rqx5.Yn)(e1), this._calcMatrices());
    }
    get zoom() {
        return this._zoom;
    }
    setZoom(e1) {
        let t = this.applyConstrain(this._center, e1).zoom;
        this._zoom !== t && (this._unmodified = !1, this._zoom = t, this._tileZoom = Math.max(0, Math.floor(t)), this._scale = (0, $1rqx5.Fr)(t), this.constrainInternal(), this._calcMatrices());
    }
    get center() {
        return this._center;
    }
    setCenter(e1) {
        (e1.lat !== this._center.lat || e1.lng !== this._center.lng) && (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
    }
    get elevation() {
        return this._elevation;
    }
    setElevation(e1) {
        e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
    }
    get padding() {
        return this._edgeInsets.toJSON();
    }
    setPadding(e1) {
        this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
    }
    get centerPoint() {
        return this._edgeInsets.getCenter(this._width, this._height);
    }
    get pixelsPerMeter() {
        return this._pixelPerMeter;
    }
    get unmodified() {
        return this._unmodified;
    }
    get cameraToCenterDistance() {
        return this._cameraToCenterDistance;
    }
    get nearZ() {
        return this._nearZ;
    }
    get farZ() {
        return this._farZ;
    }
    get autoCalculateNearFarZ() {
        return this._autoCalculateNearFarZ;
    }
    overrideNearFarZ(e1, t) {
        this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
    }
    clearNearFarZOverride() {
        this._autoCalculateNearFarZ = !0, this._calcMatrices();
    }
    isPaddingEqual(e1) {
        return this._edgeInsets.equals(e1);
    }
    interpolatePadding(e1, t, n) {
        this._unmodified = !1, this._edgeInsets.interpolate(e1, t, n), this.constrainInternal(), this._calcMatrices();
    }
    resize(e1, t, n = !0) {
        this._width = e1, this._height = t, n && this.constrainInternal(), this._calcMatrices();
    }
    getMaxBounds() {
        return this._latRange?.length !== 2 || this._lngRange?.length !== 2 ? null : new $834619e78bbf578c$export$266d2884f61535d3([
            this._lngRange[0],
            this._latRange[0]
        ], [
            this._lngRange[1],
            this._latRange[1]
        ]);
    }
    setMaxBounds(e1) {
        e1 ? (this._lngRange = [
            e1.getWest(),
            e1.getEast()
        ], this._latRange = [
            e1.getSouth(),
            e1.getNorth()
        ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
            -(0, $1rqx5.Fn),
            (0, $1rqx5.Fn)
        ]);
    }
    getCameraQueryGeometry(e1, t) {
        if (t.length === 1) return [
            t[0],
            e1
        ];
        {
            let { minX: n, minY: r, maxX: i, maxY: a } = (0, $1rqx5.pt).fromPoints(t).extend(e1);
            return [
                new (0, $1rqx5.Li)(n, r),
                new (0, $1rqx5.Li)(i, r),
                new (0, $1rqx5.Li)(i, a),
                new (0, $1rqx5.Li)(n, a),
                new (0, $1rqx5.Li)(n, r)
            ];
        }
    }
    constrainInternal() {
        if (!this.center || !this._width || !this._height || this._constraining) return;
        this._constraining = !0;
        let e1 = this._unmodified, { center: t, zoom: n } = this.applyConstrain(this.center, this.zoom);
        this.setCenter(t), this.setZoom(n), this._unmodified = e1, this._constraining = !1;
    }
    _calcMatrices() {
        if (this._pixelPerMeter = (0, $1rqx5.ct)(1, this.center.lat) * this.worldSize, !this._width || !this._height) return;
        this._pixelsToGLUnits = [
            2 / this._width,
            -2 / this._height
        ];
        let e1 = (0, $1rqx5.Si)(/* @__PURE__ */ new Float64Array(16));
        (0, $1rqx5.Ai)(e1, e1, [
            this._width / 2,
            -this._height / 2,
            1
        ]), (0, $1rqx5.ji)(e1, e1, [
            1,
            -1,
            0
        ]), this._clipSpaceToPixelsMatrix = e1, e1 = (0, $1rqx5.Si)(/* @__PURE__ */ new Float64Array(16)), (0, $1rqx5.Ai)(e1, e1, [
            1,
            -1,
            1
        ]), (0, $1rqx5.ji)(e1, e1, [
            -1,
            -1,
            0
        ]), (0, $1rqx5.Ai)(e1, e1, [
            2 / this._width,
            2 / this._height,
            1
        ]), this._pixelsToClipSpaceMatrix = e1;
        let t = this.fovInRadians / 2;
        this._cameraToCenterDistance = .5 / Math.tan(t) * this._height, this._callbacks.calcMatrices();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        let i = n === void 0 ? this.bearing : n, a = r = r === void 0 ? this.pitch : r, { distanceToCenter: o, clampedElevation: s } = this._distanceToCenterFromAltElevationPitch(t, this.elevation, a), { x: c, y: l } = (0, $1rqx5.J)(a, i), u = (0, $1rqx5.nt).fromLngLat(e1, t), d = (0, $1rqx5.rt)(1, u.y), f, p, m = 0;
        do {
            if (m += 1, m > 10) break;
            p = o / d;
            let e1 = c * p, t = l * p;
            f = new (0, $1rqx5.nt)(u.x + e1, u.y + t), d = 1 / f.meterInMercatorCoordinateUnits();
        }while (Math.abs(o - p * d) > 1e-12);
        return {
            center: f.toLngLat(),
            elevation: s,
            zoom: (0, $1rqx5.Dr)(this.height / 2 / Math.tan(this.fovInRadians / 2) / p / this.tileSize)
        };
    }
    recalculateZoomAndCenter(e1) {
        if (this.elevation - e1 === 0) return;
        let t = 1 / this.worldSize, n = (0, $1rqx5.ct)(1, this.center.lat) * this.worldSize, r = (0, $1rqx5.nt).fromLngLat(this.center, this.elevation), i = r.x / t, a = r.y / t, o = r.z / t, s = this.pitch, c = this.bearing, { x: l, y: u, z: d } = (0, $1rqx5.J)(s, c), f = this.cameraToCenterDistance, p = i + f * -l, m = a + f * -u, h = o + f * d, { distanceToCenter: g, clampedElevation: _ } = this._distanceToCenterFromAltElevationPitch(h / n, e1, s), v = g * n, y = p + l * v, x = m + u * v, S = new (0, $1rqx5.nt)(y * t, x * t, 0).toLngLat(), C = (0, $1rqx5.ct)(1, S.lat), w = (0, $1rqx5.Dr)(this.height / 2 / Math.tan(this.fovInRadians / 2) / g / C / this.tileSize);
        this._elevation = _, this._center = S, this.setZoom(w);
    }
    _distanceToCenterFromAltElevationPitch(e1, t, n) {
        let r = -Math.cos((0, $1rqx5.Yn)(n)), i = e1 - t, a, o = t;
        return r * i >= 0 || Math.abs(r) < Math.cos((0, $1rqx5.Yn)(89.25)) ? (a = 1e4, o = e1 + a * r) : a = -i / r, {
            distanceToCenter: a,
            clampedElevation: o
        };
    }
    getCameraPoint() {
        let e1 = this.pitchInRadians, t = Math.tan(e1) * (this.cameraToCenterDistance || 1);
        return this.centerPoint.add(new (0, $1rqx5.Li)(t * Math.sin(this.rollInRadians), t * Math.cos(this.rollInRadians)));
    }
    getMercatorTileCoordinates(e1) {
        if (!e1) return [
            0,
            0,
            1,
            1
        ];
        let t = e1.canonical.z >= 0 ? 1 << e1.canonical.z : 2 ** e1.canonical.z;
        return [
            e1.canonical.x / t,
            e1.canonical.y / t,
            1 / t / (0, $1rqx5.Lr),
            1 / t / (0, $1rqx5.Lr)
        ];
    }
}, $834619e78bbf578c$var$vc = class {
    distanceToTile2d(e1, t, n, r) {
        let i = r, a = i.distanceX([
            e1,
            t
        ]), o = i.distanceY([
            e1,
            t
        ]);
        return Math.hypot(a, o);
    }
    getWrap(e1, t, n) {
        return n;
    }
    getTileBoundingVolume(e1, t, n, r) {
        let i = Math.min(0, n), a = Math.max(0, n);
        if (r?.terrain) {
            let n = new (0, $1rqx5.d)(e1.z, t, e1.z, e1.x, e1.y), o = r.terrain.getMinMaxElevation(n);
            i = o.minElevation ?? i, a = o.maxElevation ?? a;
        }
        let o = 1 << e1.z;
        return new $834619e78bbf578c$var$xo([
            t + e1.x / o,
            e1.y / o,
            i
        ], [
            t + (e1.x + 1) / o,
            (e1.y + 1) / o,
            a
        ]);
    }
    allowVariableZoom(e1, t) {
        let n = e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height, r = (0, $1rqx5.Bn)(78.5 - n / 2, 0, 60);
        return !!t.terrain || e1.pitch > r;
    }
    allowWorldCopies() {
        return !0;
    }
    prepareNextFrame() {}
};
const $834619e78bbf578c$var$yc = (0, $1rqx5.Yt)([
    {
        name: `a_pos3d`,
        type: `Int16`,
        components: 3
    }
]);
var $834619e78bbf578c$var$bc = class extends (0, $1rqx5.vn) {
    constructor(e1){
        super(), this._lastTilesetChange = $834619e78bbf578c$export$461939dd4422153(), this.tileManager = e1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e1._source.tileSize * 2 ** this.deltaZoom, e1.usedForTerrain = !0, e1.tileSize = this.tileSize;
    }
    destruct() {
        this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null, this.releaseAllRTT();
    }
    getSource() {
        return this.tileManager._source;
    }
    update(e1, t) {
        this.tileManager.update(e1, t), this._renderableTilesKeys = [];
        let n = {}, r = !1;
        for (let i of $834619e78bbf578c$var$Fo(e1, {
            tileSize: this.tileSize,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            reparseOverscaled: !1,
            terrain: t
        }))n[i.key] = !0, this._renderableTilesKeys.push(i.key), this._tiles[i.key] || (i.terrainRttPosMatrix32f = /* @__PURE__ */ new Float32Array(16), (0, $1rqx5.Ti)(i.terrainRttPosMatrix32f, 0, (0, $1rqx5.Lr), (0, $1rqx5.Lr), 0, 0, 1), this._tiles[i.key] = new $834619e78bbf578c$var$vo(i, this.tileSize), this._lastTilesetChange = $834619e78bbf578c$export$461939dd4422153(), r = !0);
        for(let e1 in this._tiles)n[e1] || (this._tiles[e1].releaseRTT(this.tileManager.map.painter), delete this._tiles[e1], r = !0);
        return r;
    }
    releaseRTT(e1) {
        for(let t in this._tiles){
            let n = this._tiles[t];
            (n.tileID.equals(e1) || n.tileID.isChildOf(e1) || e1.isChildOf(n.tileID)) && n.releaseRTT(this.tileManager.map.painter);
        }
    }
    releaseAllRTT() {
        for(let e1 in this._tiles)this._tiles[e1].releaseRTT(this.tileManager.map.painter);
    }
    getRenderableTiles() {
        return this._renderableTilesKeys.map((e1)=>this.getTileByID(e1));
    }
    getTileByID(e1) {
        return this._tiles[e1];
    }
    getTerrainCoords(e1, t) {
        return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
    }
    _getTerrainCoordsForRegularTile(e1) {
        let t = {};
        for (let n of this._renderableTilesKeys){
            let r = this._tiles[n].tileID, i = e1.clone(), o = (0, $1rqx5.Wn)();
            if (r.canonical.equals(e1.canonical)) (0, $1rqx5.Ti)(o, 0, (0, $1rqx5.Lr), (0, $1rqx5.Lr), 0, 0, 1);
            else if (r.canonical.isChildOf(e1.canonical)) {
                let t = r.canonical.z - e1.canonical.z, n = r.canonical.x - (r.canonical.x >> t << t), i = r.canonical.y - (r.canonical.y >> t << t), a = (0, $1rqx5.Lr) >> t;
                (0, $1rqx5.Ti)(o, 0, a, a, 0, 0, 1), (0, $1rqx5.ji)(o, o, [
                    -n * a,
                    -i * a,
                    0
                ]);
            } else if (e1.canonical.isChildOf(r.canonical)) {
                let t = e1.canonical.z - r.canonical.z, n = e1.canonical.x - (e1.canonical.x >> t << t), i = e1.canonical.y - (e1.canonical.y >> t << t), s = (0, $1rqx5.Lr) >> t;
                (0, $1rqx5.Ti)(o, 0, (0, $1rqx5.Lr), (0, $1rqx5.Lr), 0, 0, 1), (0, $1rqx5.ji)(o, o, [
                    n * s,
                    i * s,
                    0
                ]), (0, $1rqx5.Ai)(o, o, [
                    1 / 2 ** t,
                    1 / 2 ** t,
                    0
                ]);
            } else continue;
            i.terrainRttPosMatrix32f = new Float32Array(o), t[n] = i;
        }
        return t;
    }
    _getTerrainCoordsForTileRanges(e1, t) {
        let n = {};
        for (let r of this._renderableTilesKeys){
            let i = this._tiles[r].tileID;
            if (!this._isWithinTileRanges(i, t)) continue;
            let a = e1.clone(), o = (0, $1rqx5.Wn)();
            if (i.canonical.z === e1.canonical.z) {
                let t = e1.canonical.x - i.canonical.x + e1.wrap * (1 << e1.canonical.z), n = e1.canonical.y - i.canonical.y;
                (0, $1rqx5.Ti)(o, 0, (0, $1rqx5.Lr), (0, $1rqx5.Lr), 0, 0, 1), (0, $1rqx5.ji)(o, o, [
                    t * (0, $1rqx5.Lr),
                    n * (0, $1rqx5.Lr),
                    0
                ]);
            } else if (i.canonical.z > e1.canonical.z) {
                let t = i.canonical.z - e1.canonical.z, n = i.canonical.x - (i.canonical.x >> t << t) + e1.wrap * (1 << i.canonical.z), r = i.canonical.y - (i.canonical.y >> t << t), a = e1.canonical.x - (i.canonical.x >> t), s = e1.canonical.y - (i.canonical.y >> t), c = (0, $1rqx5.Lr) >> t;
                (0, $1rqx5.Ti)(o, 0, c, c, 0, 0, 1), (0, $1rqx5.ji)(o, o, [
                    -n * c + a * (0, $1rqx5.Lr),
                    -r * c + s * (0, $1rqx5.Lr),
                    0
                ]);
            } else {
                let t = e1.canonical.z - i.canonical.z, n = e1.canonical.x - (e1.canonical.x >> t << t) + e1.wrap * (1 << e1.canonical.z), r = e1.canonical.y - (e1.canonical.y >> t << t), a = (e1.canonical.x >> t) - i.canonical.x, s = (e1.canonical.y >> t) - i.canonical.y, c = (0, $1rqx5.Lr) << t;
                (0, $1rqx5.Ti)(o, 0, c, c, 0, 0, 1), (0, $1rqx5.ji)(o, o, [
                    n * (0, $1rqx5.Lr) + a * c,
                    r * (0, $1rqx5.Lr) + s * c,
                    0
                ]);
            }
            a.terrainRttPosMatrix32f = new Float32Array(o), n[r] = a;
        }
        return n;
    }
    getSourceTile(e1, t) {
        let n = this.tileManager._source, r = e1.overscaledZ - this.deltaZoom;
        if (r > n.maxzoom && (r = n.maxzoom), r < n.minzoom) return;
        this._sourceTileCache[e1.key] ||= e1.scaledTo(r).key;
        let i = this.findTileInCaches(this._sourceTileCache[e1.key]);
        if (!i?.dem && t) for(; r >= n.minzoom && !i?.dem;)i = this.findTileInCaches(e1.scaledTo(r--).key);
        return i;
    }
    findTileInCaches(e1) {
        let t = this.tileManager.getTileByID(e1);
        return t || (t = this.tileManager._outOfViewCache.getByKey(e1), t);
    }
    anyTilesAfterTime(e1 = $834619e78bbf578c$export$461939dd4422153()) {
        return this._lastTilesetChange >= e1;
    }
    _isWithinTileRanges(e1, t) {
        let n = t[e1.canonical.z];
        return !!n && (e1.wrap > n.minWrap || e1.wrap < n.maxWrap || e1.canonical.x >= n.minTileXWrapped && e1.canonical.x <= n.maxTileXWrapped && e1.canonical.y >= n.minTileY && e1.canonical.y <= n.maxTileY);
    }
};
const $834619e78bbf578c$var$xc = (0, $1rqx5.Lr) * (1 - 1e-12), $834619e78bbf578c$var$Sc = -0.5;
var $834619e78bbf578c$var$Cc = class {
    constructor(e1, t, n, r = `auto`){
        this._meshCache = {}, this.painter = e1, this.tileManager = new $834619e78bbf578c$var$bc(t), this.options = n, this.exaggeration = typeof n.exaggeration == `number` ? n.exaggeration : 1, this._terrainSkirtLength = r, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = /* @__PURE__ */ new Map, this._elevationSamplerCache = /* @__PURE__ */ new Map;
    }
    destroy() {
        this._fbo &&= (this._fbo.destroy(), null), this._fboDepthTexture &&= (this._fboDepthTexture.destroy(), null), this._emptyDemTexture &&= (this._emptyDemTexture.destroy(), null), this._emptyDepthTexture &&= (this._emptyDepthTexture.destroy(), null);
        for(let e1 in this._meshCache)this._meshCache[e1].destroy();
        this._meshCache = {}, this.tileManager.destruct();
    }
    getDEMElevation(e1, t, n, r = (0, $1rqx5.Lr)) {
        let i = e1.normalizeCoordinates(t, n, r);
        if (!i) return 0;
        let a = this.getElevationSampler(i.tileID);
        return a ? a(i.x, i.y, r) : 0;
    }
    getElevationForLngLatZoom(e1, t) {
        if (!(0, $1rqx5.h)(t, e1.wrap())) return 0;
        let { tileID: n, mercatorX: r, mercatorY: i } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getElevation(n, r % (0, $1rqx5.Lr), i % (0, $1rqx5.Lr), (0, $1rqx5.Lr));
    }
    getElevationForLngLat(e1, t) {
        let n = this.getCoverageIndex();
        if (n) {
            let t = (0, $1rqx5.nt).fromLngLat(e1), r = $834619e78bbf578c$var$Tc(n, this.exaggeration, t.x, t.y);
            if (r.demLoaded) return r.elevation;
        }
        let r = $834619e78bbf578c$var$Fo(t, {
            maxzoom: this.tileManager.maxzoom,
            minzoom: this.tileManager.minzoom,
            tileSize: 512,
            terrain: this
        }), i = 0;
        for (let e1 of r)e1.canonical.z > i && (i = Math.min(e1.canonical.z, this.tileManager.maxzoom));
        return this.getElevationForLngLatZoom(e1, i);
    }
    getElevation(e1, t, n, r = (0, $1rqx5.Lr)) {
        return this.getDEMElevation(e1, t, n, r) * this.exaggeration;
    }
    resetElevationCache() {
        this._elevationSamplerCache.clear(), this._coverageIndex = void 0;
    }
    getCoverageIndex() {
        return this._coverageIndex === void 0 && (this._coverageIndex = this._buildCoverageIndex()), this._coverageIndex;
    }
    _buildCoverageIndex() {
        let e1 = [], t = /* @__PURE__ */ new Map, n = 0, r = 0;
        for (let i of this.tileManager.getRenderableTiles()){
            if (!i) continue;
            let { canonical: a, wrap: o } = i.tileID;
            e1.includes(a.z) || e1.push(a.z);
            let s = this.getElevationSampler(i.tileID);
            t.set(`${o}/${a.z}/${a.x}/${a.y}`, s);
            let { minElevation: c, maxElevation: l } = this.getMinMaxElevation(i.tileID);
            n = Math.min(n, c ?? 0), r = Math.max(r, l ?? 0);
        }
        return t.size === 0 ? null : (e1.sort((e1, t)=>t - e1), {
            zooms: e1,
            samplerPerTile: t,
            minElevation: n - 10,
            maxElevation: r + 10
        });
    }
    getElevationSampler(e1) {
        let t = e1.key, n = this._elevationSamplerCache.get(t);
        if (n) return n;
        let r = this.tileManager.getSourceTile(e1, !0), i = r?.dem;
        if (!r || !i) return null;
        let a = this._getDEMTileMatrix(e1, r), o = a[0] * i.dim, s = a[5] * i.dim, c = a[12] * i.dim + $834619e78bbf578c$var$Sc, l = a[13] * i.dim + $834619e78bbf578c$var$Sc, u = (e1, t, n)=>{
            let r = n === 8192 ? 1 : (0, $1rqx5.Lr) / n;
            return i.sampleBilinear(e1 * r * o + c, t * r * s + l);
        };
        return this._elevationSamplerCache.set(t, u), u;
    }
    _getDEMTileMatrix(e1, t) {
        let n = `${t.tileID.key}/${e1.key}`, r = this._demMatrixCache.get(n);
        if (r) return r;
        let i = e1.canonical.z - t.tileID.canonical.z, a = e1.canonical.x - (e1.canonical.x >> i << i), o = e1.canonical.y - (e1.canonical.y >> i << i), s = (0, $1rqx5.xi)(/* @__PURE__ */ new Float64Array(16), [
            1 / ((0, $1rqx5.Lr) << i),
            1 / ((0, $1rqx5.Lr) << i),
            0
        ]);
        return (0, $1rqx5.ji)(s, s, [
            a * (0, $1rqx5.Lr),
            o * (0, $1rqx5.Lr),
            0
        ]), this._demMatrixCache.set(n, s), s;
    }
    getTerrainData(e1) {
        if (!this._emptyDemTexture) {
            let e1 = this.painter.context, t = new (0, $1rqx5.Dt)({
                width: 1,
                height: 1
            }, /* @__PURE__ */ new Uint8Array(4));
            this._emptyDepthTexture = new (0, $1rqx5.xt)(e1, t, e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemUnpack = [
                0,
                0,
                0,
                0
            ], this._emptyDemTexture = new (0, $1rqx5.xt)(e1, new (0, $1rqx5.Dt)({
                width: 1,
                height: 1
            }), e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = (0, $1rqx5.Si)([]);
        }
        let t = this.tileManager.getSourceTile(e1, !0);
        if (t?.dem && (!t.demTexture || t.needsTerrainPrepare)) {
            let e1 = this.painter.context;
            t.demTexture ||= this.painter.getTileTexture(t.dem.stride), t.demTexture ? t.demTexture.update(t.dem.getPixels(), {
                premultiply: !1
            }) : t.demTexture = new (0, $1rqx5.xt)(e1, t.dem.getPixels(), e1.gl.RGBA, {
                premultiply: !1
            }), t.demTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), t.needsTerrainPrepare = !1;
        }
        let n = t ? this._getDEMTileMatrix(e1, t) : this._emptyDemMatrix;
        return {
            u_depth: 2,
            u_terrain: 3,
            u_terrain_dim: t?.dem?.dim || 1,
            u_terrain_matrix: n,
            u_terrain_unpack: t?.dem?.getUnpackVector() || this._emptyDemUnpack,
            u_terrain_exaggeration: this.exaggeration,
            texture: (t?.demTexture || this._emptyDemTexture).texture,
            depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
            tile: t
        };
    }
    getFramebuffer() {
        let e1 = this.painter, t = e1.width / devicePixelRatio, n = e1.height / devicePixelRatio;
        return this._fbo && (this._fbo.width !== t || this._fbo.height !== n) && (this._fbo.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture), this._fboDepthTexture || (this._fboDepthTexture = new (0, $1rqx5.xt)(e1.context, {
            width: t,
            height: n,
            data: null
        }, e1.context.gl.RGBA, {
            premultiply: !1
        }), this._fboDepthTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e1.context.createFramebuffer(t, n, !0, !1), this._fbo.depthAttachment.set(e1.context.createRenderbuffer(e1.context.gl.DEPTH_COMPONENT16, t, n))), this._fbo.colorAttachment.set(this._fboDepthTexture.texture), this._fbo;
    }
    getTerrainMesh(e1) {
        let t = this.painter.style.projection?.transitionState > 0, n = t && e1.canonical.y === 0, r = t && e1.canonical.y === (1 << e1.canonical.z) - 1, i = `m_${n ? `n` : ``}_${r ? `s` : ``}`;
        if (this._meshCache[i]) return this._meshCache[i];
        let a = this.painter.context, o = new (0, $1rqx5.Wt), s = new (0, $1rqx5.Jt), c = this.meshSize, l = (0, $1rqx5.Lr) / c, u = c * c;
        for(let e1 = 0; e1 <= c; e1++)for(let t = 0; t <= c; t++)o.emplaceBack(t * l, e1 * l, 0);
        for(let e1 = 0; e1 < u; e1 += c + 1)for(let t = 0; t < c; t++)s.emplaceBack(t + e1, c + t + e1 + 1, c + t + e1 + 2), s.emplaceBack(t + e1, c + t + e1 + 2, t + e1 + 1);
        this._terrainSkirtLength !== `none` && this._buildSkirts(o, s, c, l, n, r);
        let d = new $834619e78bbf578c$var$Ja(a.createVertexBuffer(o, $834619e78bbf578c$var$yc.members), a.createIndexBuffer(s), (0, $1rqx5.Bt).simpleSegment(0, 0, o.length, s.length));
        return this._meshCache[i] = d, d;
    }
    getSkirtLength(e1) {
        return 2 * Math.PI * (0, $1rqx5.ut) / 2 ** Math.max(e1, 0) / 5;
    }
    getMinTileElevationForLngLatZoom(e1, t) {
        if (!(0, $1rqx5.h)(t, e1.wrap())) return 0;
        let { tileID: n } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getMinMaxElevation(n).minElevation ?? 0;
    }
    getMinMaxElevation(e1) {
        let t = this.tileManager.getSourceTile(e1, !0), n = {
            minElevation: null,
            maxElevation: null
        };
        return t?.dem && (n.minElevation = t.dem.min * this.exaggeration, n.maxElevation = t.dem.max * this.exaggeration), n;
    }
    _getOverscaledTileIDFromLngLatZoom(e1, t) {
        let n = (0, $1rqx5.nt).fromLngLat(e1.wrap()), r = (1 << t) * (0, $1rqx5.Lr), i = n.x * r, a = n.y * r, o = Math.floor(i / (0, $1rqx5.Lr)), s = Math.floor(a / (0, $1rqx5.Lr));
        return {
            tileID: new (0, $1rqx5.d)(t, 0, t, o, s),
            mercatorX: i,
            mercatorY: a
        };
    }
    _buildSkirts(e1, t, n, r, i, a) {
        let o = e1.length, s = o + (n + 1), c = (n + 1) * n, l = i ? (0, $1rqx5.ht) : 0, u = +!i, d = a ? (0, $1rqx5.gt) : (0, $1rqx5.Lr), f = +!a;
        for(let t = 0; t <= n; t++)e1.emplaceBack(t * r, l, u);
        for(let t = 0; t <= n; t++)e1.emplaceBack(t * r, d, f);
        for(let e1 = 0; e1 < n; e1++)t.emplaceBack(c + e1, s + e1, s + e1 + 1), t.emplaceBack(c + e1, s + e1 + 1, c + e1 + 1), t.emplaceBack(0 + e1, o + e1 + 1, o + e1), t.emplaceBack(0 + e1, 0 + e1 + 1, o + e1 + 1);
        let p = e1.length, m = p + (n + 1) * 2;
        for (let t of [
            0,
            1
        ])for(let i = 0; i <= n; i++)for (let n of [
            0,
            1
        ])e1.emplaceBack(t * (0, $1rqx5.Lr), i * r, n);
        for(let e1 = 0; e1 < n * 2; e1 += 2)t.emplaceBack(p + e1, p + e1 + 1, p + e1 + 3), t.emplaceBack(p + e1, p + e1 + 3, p + e1 + 2), t.emplaceBack(m + e1, m + e1 + 3, m + e1 + 1), t.emplaceBack(m + e1, m + e1 + 2, m + e1 + 3);
    }
};
const $834619e78bbf578c$var$wc = {
    covered: !1,
    demLoaded: !1,
    elevation: 0
};
function $834619e78bbf578c$var$Tc(e1, t, n, r) {
    if (r < 0 || r >= 1) return $834619e78bbf578c$var$wc;
    let i = Math.floor(n), a = n - i;
    for (let n of e1.zooms){
        let o = 1 << n, s = a * o, c = r * o, l = Math.floor(s), u = Math.floor(c), d = `${i}/${n}/${l}/${u}`;
        if (!e1.samplerPerTile.has(d)) continue;
        let f = e1.samplerPerTile.get(d);
        return f ? {
            covered: !0,
            demLoaded: !0,
            elevation: f(Math.min((s - l) * (0, $1rqx5.Lr), $834619e78bbf578c$var$xc), Math.min((c - u) * (0, $1rqx5.Lr), $834619e78bbf578c$var$xc), (0, $1rqx5.Lr)) * t
        } : {
            covered: !0,
            demLoaded: !1,
            elevation: 0
        };
    }
    return $834619e78bbf578c$var$wc;
}
function $834619e78bbf578c$var$Ec(e1, t) {
    return e1.covered && t <= e1.elevation + 1e-6;
}
function $834619e78bbf578c$var$Dc(e1, t, n, r, i) {
    for(let a = 0; a < 40 && r - n > i; a++){
        let i = (n + r) / 2;
        t(e1, i) ? r = i : n = i;
    }
    return {
        lo: n,
        hi: r
    };
}
var $834619e78bbf578c$var$Oc = class t {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, n = !0) {
        this._helper.resize(e1, t, n);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(t, n){
        this._posMatrixCache = /* @__PURE__ */ new Map, this._alignedPosMatrixCache = /* @__PURE__ */ new Map, this._fogMatrixCacheF32 = /* @__PURE__ */ new Map, this.defaultConstrain = (t, n)=>{
            n = (0, $1rqx5.Bn)(+n, this.minZoom, this.maxZoom);
            let r = {
                center: new (0, $1rqx5.lt)(t.lng, t.lat),
                zoom: n
            }, i = this._helper._lngRange;
            !this._helper._renderWorldCopies && i === null && (i = [
                -179.9999999999,
                180 - 1e-10
            ]);
            let a = this.tileSize * (0, $1rqx5.Fr)(r.zoom), o = 0, s = a, c = 0, l = a, d = 0, f = 0, { x: p, y: m } = this.size;
            if (this._helper._latRange) {
                let e1 = this._helper._latRange;
                o = (0, $1rqx5.st)(e1[1]) * a, s = (0, $1rqx5.st)(e1[0]) * a, s - o < m && (d = m / (s - o));
            }
            i && (c = (0, $1rqx5.Pr)((0, $1rqx5.ot)(i[0]) * a, 0, a), l = (0, $1rqx5.Pr)((0, $1rqx5.ot)(i[1]) * a, 0, a), l < c && (l += a), l - c < p && (f = p / (l - c)));
            let { x: h, y: g } = (0, $1rqx5.$)(a, t), _, v, y = Math.max(f || 0, d || 0);
            if (y) {
                let e1 = new (0, $1rqx5.Li)(f ? (l + c) / 2 : h, d ? (s + o) / 2 : g);
                return r.center = (0, $1rqx5.tt)(a, e1).wrap(), r.zoom += (0, $1rqx5.Dr)(y), r;
            }
            if (this._helper._latRange) {
                let e1 = m / 2;
                g - e1 < o && (v = o + e1), g + e1 > s && (v = s - e1);
            }
            if (i) {
                let e1 = (c + l) / 2, t = h;
                this._helper._renderWorldCopies && (t = (0, $1rqx5.Pr)(h, e1 - a / 2, e1 + a / 2));
                let n = p / 2;
                t - n < c && (_ = c + n), t + n > l && (_ = l - n);
            }
            if (_ !== void 0 || v !== void 0) {
                let e1 = new (0, $1rqx5.Li)(_ ?? h, v ?? g);
                r.center = (0, $1rqx5.tt)(a, e1).wrap();
            }
            return r;
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = n ?? new $834619e78bbf578c$var$_c({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, t), this._coveringTilesDetailsProvider = new $834619e78bbf578c$var$vc;
    }
    clone() {
        let e1 = new t;
        return e1.apply(this, !1), e1;
    }
    apply(e1, t) {
        this._helper.apply(e1, t);
    }
    get cameraPosition() {
        return this._cameraPosition;
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._viewProjMatrix;
    }
    get inverseProjectionMatrix() {
        return this._invProjMatrix;
    }
    get mercatorMatrix() {
        return this._mercatorMatrix;
    }
    getVisibleUnwrappedCoordinates(e1) {
        let t = [
            new (0, $1rqx5.f)(0, e1)
        ];
        if (this._helper._renderWorldCopies) {
            let n = this.screenPointToMercatorCoordinate(new (0, $1rqx5.Li)(0, 0)), r = this.screenPointToMercatorCoordinate(new (0, $1rqx5.Li)(this._helper._width, 0)), i = this.screenPointToMercatorCoordinate(new (0, $1rqx5.Li)(this._helper._width, this._helper._height)), a = this.screenPointToMercatorCoordinate(new (0, $1rqx5.Li)(0, this._helper._height)), o = Math.floor(Math.min(n.x, r.x, i.x, a.x)), s = Math.floor(Math.max(n.x, r.x, i.x, a.x));
            for(let n = o - 1; n <= s + 1; n++)n !== 0 && t.push(new (0, $1rqx5.f)(n, e1));
        }
        return t;
    }
    getCameraFrustum() {
        return $834619e78bbf578c$var$So.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
    }
    getClippingPlane() {
        return null;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        let t = this.screenPointToLocation(this.centerPoint, e1), n = e1 ? e1.getElevationForLngLat(t, this) : 0;
        this._helper.recalculateZoomAndCenter(n);
    }
    setLocationAtPoint(e1, t, n = this.elevation) {
        let r = n - this.elevation, i = this.screenPointToMercatorCoordinateAtZ(t, r), a = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, 0), o = (0, $1rqx5.nt).fromLngLat(e1), s = new (0, $1rqx5.nt)(o.x - (i.x - a.x), o.y - (i.y - a.y));
        this.setCenter(s?.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
    }
    locationToScreenPoint(e1, t) {
        return t ? this.coordinatePoint((0, $1rqx5.nt).fromLngLat(e1), t.getElevationForLngLat(e1, this), this._pixelMatrix3D) : this.coordinatePoint((0, $1rqx5.nt).fromLngLat(e1));
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.screenPointToMercatorCoordinateAtZ(e1, t - this.elevation)?.toLngLat();
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let n = this.screenTerrainPointToMercatorCoordinate(e1, t);
            if (n != null) return n;
        }
        return this.screenPointToMercatorCoordinateAtZ(e1);
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        let n = t.getCoverageIndex();
        if (!n) return null;
        let { near: r, far: i } = this.getRaySegmentFromPixel(e1), a = this.worldSize, o = i[0] - r[0], s = i[1] - r[1], c = i[2] - r[2], l = {
            index: n,
            exaggeration: t.exaggeration,
            near: r,
            dx: o,
            dy: s,
            dz: c,
            worldSize: a
        }, d = 0, f = 1;
        if (c === 0) {
            if (r[2] > n.maxElevation || r[2] < n.minElevation) return null;
        } else {
            let e1 = (n.maxElevation - r[2]) / c, t = (n.minElevation - r[2]) / c;
            if (d = Math.max(d, Math.min(e1, t)), f = Math.min(f, Math.max(e1, t)), d > f) return null;
        }
        let p = Math.hypot(o, s), m = (0, $1rqx5.Bn)(Math.ceil(p * (f - d) / 4), 1, 512), h = 0, g = !$834619e78bbf578c$var$Ac(l, 0);
        for(let e1 = 0; e1 <= m; e1++){
            let t = d + (f - d) * e1 / m;
            if (!g) g = !$834619e78bbf578c$var$Ac(l, t);
            else if ($834619e78bbf578c$var$Ac(l, t)) {
                let { lo: e1, hi: n } = $834619e78bbf578c$var$Dc(l, $834619e78bbf578c$var$Ac, h, t, .001 / p), i = $834619e78bbf578c$var$kc(l, e1), d = $834619e78bbf578c$var$kc(l, n), f = r[2] + e1 * c - i.elevation, m = r[2] + n * c - d.elevation, g = i.covered && f > m ? (0, $1rqx5.Bn)(e1 + f * (n - e1) / (f - m), e1, n) : n;
                return new (0, $1rqx5.nt)((r[0] + g * o) / a, (r[1] + g * s) / a, $834619e78bbf578c$var$kc(l, g).elevation);
            }
            h = t;
        }
        return null;
    }
    getRaySegmentFromPixel(e1) {
        let t = [
            e1.x,
            e1.y,
            0,
            1
        ], n = [
            e1.x,
            e1.y,
            1,
            1
        ];
        (0, $1rqx5.Yr)(t, t, this._pixelMatrixInverse), (0, $1rqx5.Yr)(n, n, this._pixelMatrixInverse);
        let r = t[3], i = n[3], a = this.elevation;
        return {
            near: [
                t[0] / r,
                t[1] / r,
                t[2] / r + a
            ],
            far: [
                n[0] / i,
                n[1] / i,
                n[2] / i + a
            ]
        };
    }
    screenPointToMercatorCoordinateAtZ(e1, t) {
        let n = t || 0, { near: r, far: i } = this.getRaySegmentFromPixel(e1), a = r[2] === i[2] ? 0 : (n + this.elevation - r[2]) / (i[2] - r[2]);
        return new (0, $1rqx5.nt)((0, $1rqx5.un).number(r[0], i[0], a) / this.worldSize, (0, $1rqx5.un).number(r[1], i[1], a) / this.worldSize, n);
    }
    coordinatePoint(e1, t = 0, n = this._pixelMatrix) {
        let r = this._coordinateClipPoint(e1, t, n), i = r[3];
        return i > 0 ? new (0, $1rqx5.Li)(r[0] / i, r[1] / i) : this._offScreenPointBehindCamera(r[0], r[1], i);
    }
    _coordinateClipPoint(e1, t, n) {
        let r = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            t,
            1
        ];
        return (0, $1rqx5.Yr)(r, r, n);
    }
    _offScreenPointBehindCamera(e1, t, n) {
        let r = this.width / 2, i = this.height / 2, a = e1 - r * n, o = t - i * n;
        a === 0 && o === 0 && (o = 1);
        let s = r + this.width, c = i + this.height, l = Math.min(a === 0 ? 1 / 0 : s / Math.abs(a), o === 0 ? 1 / 0 : c / Math.abs(o));
        return new (0, $1rqx5.Li)(r + a * l, i + o * l);
    }
    getBounds() {
        let e1 = Math.max(0, this._helper._height / 2 - (0, $1rqx5.Z)(this));
        return new $834619e78bbf578c$export$266d2884f61535d3().extend(this.screenPointToLocation(new (0, $1rqx5.Li)(0, e1))).extend(this.screenPointToLocation(new (0, $1rqx5.Li)(this._helper._width, e1))).extend(this.screenPointToLocation(new (0, $1rqx5.Li)(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new (0, $1rqx5.Li)(0, this._helper._height)));
    }
    isPointOnMapSurface(e1, t) {
        return t ? this.screenTerrainPointToMercatorCoordinate(e1, t) != null : e1.y > this.centerPoint.y - (0, $1rqx5.Z)(this);
    }
    calculatePosMatrix(e1, t = !1, n = !1) {
        let r = e1.key ?? (0, $1rqx5.p)(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), i = t ? this._alignedPosMatrixCache : this._posMatrixCache;
        if (i.has(r)) {
            let e1 = i.get(r);
            return n ? e1.f32 : e1.f64;
        }
        let a = (0, $1rqx5.q)(e1, this.worldSize);
        (0, $1rqx5.wi)(a, t ? this._alignedProjMatrix : this._viewProjMatrix, a);
        let o = {
            f64: a,
            f32: new Float32Array(a)
        };
        return i.set(r, o), n ? o.f32 : o.f64;
    }
    calculateFogMatrix(e1) {
        let t = e1.key, n = this._fogMatrixCacheF32;
        if (n.has(t)) return n.get(t);
        let r = (0, $1rqx5.q)(e1, this.worldSize);
        return (0, $1rqx5.wi)(r, this._fogMatrix, r), n.set(t, new Float32Array(r)), n.get(t);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        let i = (0, $1rqx5.nt).fromLngLat(e1, t), a = (0, $1rqx5.nt).fromLngLat(n, r), o = a.x - i.x, s = a.y - i.y, c = a.z - i.z, l = Math.hypot(o, s, c);
        if (l === 0) throw Error(`Can't calculate camera options with same From and To`);
        let u = Math.hypot(o, s), d = (0, $1rqx5.Dr)(this.cameraToCenterDistance / l / this.tileSize), f = (0, $1rqx5.xr)(Math.atan2(o, -s)), p = (0, $1rqx5.xr)(Math.acos(u / l));
        return p = c < 0 ? 90 - p : 90 + p, {
            center: a.toLngLat(),
            elevation: r,
            zoom: d,
            pitch: p,
            bearing: f
        };
    }
    _calculateNearFarZ(e1, t, n) {
        let r = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), i = e1 - r * this._helper._pixelPerMeter / Math.cos(t), a = r < 0 ? i : e1, o = Math.PI / 2 + this.pitchInRadians, s = (0, $1rqx5.Yn)(this.fov) * (Math.abs(Math.cos((0, $1rqx5.Yn)(this.roll))) * this.height + Math.abs(Math.sin((0, $1rqx5.Yn)(this.roll))) * this.width) / this.height * (.5 + n.y / this.height), c = Math.sin(s) * a / Math.sin((0, $1rqx5.Bn)(Math.PI - o - s, .01, Math.PI - .01)), l = (0, $1rqx5.Z)(this), d = Math.atan(l / this._helper.cameraToCenterDistance), f = (0, $1rqx5.Yn)(90 - (0, $1rqx5.Q)), p = d > f ? 2 * d * (.5 + n.y / (l * 2)) : f, m = Math.sin(p) * a / Math.sin((0, $1rqx5.Bn)(Math.PI - o - p, .01, Math.PI - .01)), h = Math.min(c, m);
        this._helper._farZ = (Math.cos(Math.PI / 2 - t) * h + a) * 1.01, this._helper._nearZ = this._helper._height / 50;
    }
    _calcMatrices(t = this._helper.autoCalculateNearFarZ) {
        let n = this.centerOffset, r = (0, $1rqx5.$)(this.worldSize, this.center), i = r.x, o = r.y, s = (0, $1rqx5.Yn)(Math.min(this.pitch, (0, $1rqx5.Q))), c = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(s));
        t && this._calculateNearFarZ(c, s, n);
        let l;
        l = /* @__PURE__ */ new Float64Array(16), (0, $1rqx5.Ei)(l, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = /* @__PURE__ */ new Float64Array(16), $834619e78bbf578c$var$Qo(this._invProjMatrix, l), l[8] = -n.x * 2 / this._helper._width, l[9] = n.y * 2 / this._helper._height, this._projectionMatrix = (0, $1rqx5.gi)(l), (0, $1rqx5.Ai)(l, l, [
            1,
            -1,
            1
        ]), (0, $1rqx5.ji)(l, l, [
            0,
            0,
            -this._helper.cameraToCenterDistance
        ]), (0, $1rqx5.ki)(l, l, -this.rollInRadians), (0, $1rqx5.Di)(l, l, this.pitchInRadians), (0, $1rqx5.ki)(l, l, -this.bearingInRadians), (0, $1rqx5.ji)(l, l, [
            -i,
            -o,
            0
        ]), this._mercatorMatrix = (0, $1rqx5.Ai)([], l, [
            this.worldSize,
            this.worldSize,
            this.worldSize
        ]), (0, $1rqx5.Ai)(l, l, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), this._pixelMatrix = (0, $1rqx5.wi)(/* @__PURE__ */ new Float64Array(16), this.clipSpaceToPixelsMatrix, l), (0, $1rqx5.ji)(l, l, [
            0,
            0,
            -this.elevation
        ]), this._viewProjMatrix = l, this._invViewProjMatrix = (0, $1rqx5.Ci)([], l);
        let u = [
            0,
            0,
            -1,
            1
        ];
        (0, $1rqx5.Yr)(u, u, this._invViewProjMatrix), this._cameraPosition = [
            u[0] / u[3],
            u[1] / u[3],
            u[2] / u[3]
        ], this._fogMatrix = /* @__PURE__ */ new Float64Array(16), (0, $1rqx5.Ei)(this._fogMatrix, this.fovInRadians, this.width / this.height, c, this._helper._farZ), this._fogMatrix[8] = -n.x * 2 / this.width, this._fogMatrix[9] = n.y * 2 / this.height, (0, $1rqx5.Ai)(this._fogMatrix, this._fogMatrix, [
            1,
            -1,
            1
        ]), (0, $1rqx5.ji)(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), (0, $1rqx5.ki)(this._fogMatrix, this._fogMatrix, -this.rollInRadians), (0, $1rqx5.Di)(this._fogMatrix, this._fogMatrix, this.pitchInRadians), (0, $1rqx5.ki)(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), (0, $1rqx5.ji)(this._fogMatrix, this._fogMatrix, [
            -i,
            -o,
            0
        ]), (0, $1rqx5.Ai)(this._fogMatrix, this._fogMatrix, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), (0, $1rqx5.ji)(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.elevation
        ]), this._pixelMatrix3D = (0, $1rqx5.wi)(/* @__PURE__ */ new Float64Array(16), this.clipSpaceToPixelsMatrix, l);
        let d = this._helper._width % 2 / 2, f = this._helper._height % 2 / 2, p = Math.cos(this.bearingInRadians), h = Math.sin(-this.bearingInRadians), g = i - Math.round(i) + p * d + h * f, _ = o - Math.round(o) + p * f + h * d, y = new Float64Array(l);
        if ((0, $1rqx5.ji)(y, y, [
            g > .5 ? g - 1 : g,
            _ > .5 ? _ - 1 : _,
            0
        ]), this._alignedProjMatrix = y, l = (0, $1rqx5.Ci)(/* @__PURE__ */ new Float64Array(16), this._pixelMatrix), !l) throw Error(`failed to invert matrix`);
        this._pixelMatrixInverse = l, this._clearMatrixCaches();
    }
    _clearMatrixCaches() {
        this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
    }
    maxPitchScaleFactor() {
        if (!this._pixelMatrixInverse) return 1;
        let e1 = this.screenPointToMercatorCoordinate(new (0, $1rqx5.Li)(0, 0)), t = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            0,
            1
        ];
        return (0, $1rqx5.Yr)(t, t, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return Math.cos(this.pitchInRadians) * this.cameraToCenterDistance / this.pixelsPerMeter + this.elevation;
    }
    getCameraLngLat() {
        let e1 = (0, $1rqx5.ct)(1, this.center.lat) * this.worldSize, t = this._helper.cameraToCenterDistance / e1;
        return (0, $1rqx5.X)(this.center, this.elevation, this.pitch, this.bearing, t).toLngLat();
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, aligned: n, applyTerrainMatrix: r } = e1, i = this._helper.getMercatorTileCoordinates(t), a = t ? this.calculatePosMatrix(t, n, !0) : null, o;
        return o = t?.terrainRttPosMatrix32f && r ? t.terrainRttPosMatrix32f : a || (0, $1rqx5.Hn)(), {
            mainMatrix: o,
            tileMercatorCoords: i,
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: o,
            clipAntimeridian: !1
        };
    }
    isLocationOccluded(e1, t, n) {
        if (!t?.getCoverageIndex()) return !1;
        let r = (0, $1rqx5.nt).fromLngLat(e1);
        n ??= t.getElevationForLngLat(e1, this);
        let i = this._coordinateClipPoint(r, n, this._pixelMatrix3D), a = i[3];
        if (a <= 0 || i[2] > a) return !0;
        let o = new (0, $1rqx5.Li)(i[0] / a, i[1] / a), s = this.screenTerrainPointToMercatorCoordinate(o, t);
        if (s == null) return !1;
        let c = this.getRaySegmentFromPixel(o), l = $834619e78bbf578c$var$jc(c, r.x * this.worldSize, r.y * this.worldSize, n);
        return $834619e78bbf578c$var$jc(c, s.x * this.worldSize, s.y * this.worldSize, s.z) < l * .99;
    }
    getPixelScale() {
        return 1;
    }
    getCircleRadiusCorrection() {
        return 1;
    }
    getPitchedTextCorrection(e1, t, n) {
        return 1;
    }
    transformLightDirection(e1) {
        return (0, $1rqx5.Zr)(e1);
    }
    getRayDirectionFromPixel(e1) {
        throw Error(`Not implemented.`);
    }
    projectTileCoordinates(e1, t, n, r) {
        let i = this.calculatePosMatrix(n), a;
        r == null ? (a = [
            e1,
            t,
            0,
            1
        ], $834619e78bbf578c$var$Ss(a, a, i)) : (a = [
            e1,
            t,
            r,
            1
        ], (0, $1rqx5.Yr)(a, a, i));
        let o = a[3];
        return {
            point: new (0, $1rqx5.Li)(a[0] / o, a[1] / o),
            signedDistanceFromCamera: o,
            isOccluded: !1
        };
    }
    populateCache(e1) {
        for (let t of e1)this.calculatePosMatrix(t);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = new (0, $1rqx5.d)(0, 0, 0, 0, 0), n = this.getProjectionData({
            overscaledTileID: t,
            applyGlobeMatrix: e1
        }), r = (0, $1rqx5.q)(t, this.worldSize);
        (0, $1rqx5.wi)(r, this._viewProjMatrix, r);
        let i = [
            (0, $1rqx5.Lr),
            (0, $1rqx5.Lr),
            this.worldSize / this._helper.pixelsPerMeter
        ], o = (0, $1rqx5.Wn)();
        return (0, $1rqx5.Ai)(o, r, i), {
            ...n,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            fallbackMatrix: o,
            mainMatrix: o
        };
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.calculatePosMatrix(e1);
    }
};
function $834619e78bbf578c$var$kc(e1, t) {
    return $834619e78bbf578c$var$Tc(e1.index, e1.exaggeration, (e1.near[0] + t * e1.dx) / e1.worldSize, (e1.near[1] + t * e1.dy) / e1.worldSize);
}
function $834619e78bbf578c$var$Ac(e1, t) {
    return $834619e78bbf578c$var$Ec($834619e78bbf578c$var$kc(e1, t), e1.near[2] + t * e1.dz);
}
function $834619e78bbf578c$var$jc({ near: e1, far: t }, n, r, i) {
    let a = t[0] - e1[0], o = t[1] - e1[1], s = t[2] - e1[2];
    return ((n - e1[0]) * a + (r - e1[1]) * o + (i - e1[2]) * s) / (a * a + o * o + s * s);
}
function $834619e78bbf578c$var$Mc() {
    (0, $1rqx5.Nr)(`Map cannot fit within canvas with the given bounds, padding, and/or offset.`);
}
function $834619e78bbf578c$var$Nc(e1) {
    if (e1.useSlerp) {
        if (e1.k < 1) {
            let t = (0, $1rqx5.Er)(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), n = (0, $1rqx5.Er)(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), r = /* @__PURE__ */ new Float64Array(4);
            (0, $1rqx5.Kr)(r, t, n, e1.k);
            let i = (0, $1rqx5.sr)(r);
            e1.tr.setRoll(i.roll), e1.tr.setPitch(i.pitch), e1.tr.setBearing(i.bearing);
        } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
    } else e1.tr.setRoll((0, $1rqx5.un).number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch((0, $1rqx5.un).number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing((0, $1rqx5.un).number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
}
function $834619e78bbf578c$var$Pc(t, n, r, i, a) {
    let o = a.padding, s = (0, $1rqx5.$)(a.worldSize, r.getNorthWest()), c = (0, $1rqx5.$)(a.worldSize, r.getNorthEast()), l = (0, $1rqx5.$)(a.worldSize, r.getSouthEast()), u = (0, $1rqx5.$)(a.worldSize, r.getSouthWest()), d = (0, $1rqx5.Yn)(-i), f = s.rotate(d), p = c.rotate(d), m = l.rotate(d), h = u.rotate(d), g = new (0, $1rqx5.Li)(Math.max(f.x, p.x, h.x, m.x), Math.max(f.y, p.y, h.y, m.y)), _ = new (0, $1rqx5.Li)(Math.min(f.x, p.x, h.x, m.x), Math.min(f.y, p.y, h.y, m.y)), v = g.sub(_), y = a.width - (o.left + o.right + n.left + n.right), x = a.height - (o.top + o.bottom + n.top + n.bottom), S = y / v.x, C = x / v.y;
    if (C < 0 || S < 0) {
        $834619e78bbf578c$var$Mc();
        return;
    }
    let w = Math.min((0, $1rqx5.Dr)(a.scale * Math.min(S, C)), t.maxZoom), T = (0, $1rqx5.Li).convert(t.offset), E = (n.left - n.right) / 2, D = (n.top - n.bottom) / 2, O = new (0, $1rqx5.Li)(E, D).rotate((0, $1rqx5.Yn)(i)), k = T.add(O).mult(a.scale / (0, $1rqx5.Fr)(w));
    return {
        center: (0, $1rqx5.tt)(a.worldSize, s.add(l).div(2).sub(k)),
        zoom: w,
        bearing: i
    };
}
var $834619e78bbf578c$var$Fc = class {
    get useGlobeControls() {
        return !1;
    }
    handlePanInertia(e1, t) {
        let n = e1.mag(), r = Math.abs((0, $1rqx5.Z)(t));
        return {
            easingOffset: e1.mult(Math.min(r * .75 / n, 1)),
            easingCenter: t.center
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
    }
    handleMapControlsPan(e1, t, n) {
        e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(n, e1.around, e1.aroundElevation);
    }
    cameraForBoxAndBearing(e1, t, n, r, i) {
        return $834619e78bbf578c$var$Pc(e1, t, n, r, i);
    }
    handleJumpToCenterZoom(e1, t) {
        let n = t.zoom === void 0 ? e1.zoom : +t.zoom;
        e1.zoom !== n && e1.setZoom(+t.zoom), t.center !== void 0 && e1.setCenter((0, $1rqx5.lt).convert(t.center));
    }
    handleEaseTo(t, n) {
        let r = t.zoom, i = t.padding, a = {
            roll: t.roll,
            pitch: t.pitch,
            bearing: t.bearing
        }, o = {
            roll: n.roll === void 0 ? t.roll : n.roll,
            pitch: n.pitch === void 0 ? t.pitch : n.pitch,
            bearing: n.bearing === void 0 ? t.bearing : n.bearing
        }, s = n.zoom !== void 0, c = !t.isPaddingEqual(n.padding), l = !1, u = s ? +n.zoom : t.zoom, d = t.centerPoint.add(n.offsetAsPoint), f = t.screenPointToLocation(d), { center: p, zoom: m } = t.applyConstrain((0, $1rqx5.lt).convert(n.center || f), u ?? r);
        $834619e78bbf578c$var$hc(t, p);
        let h = (0, $1rqx5.$)(t.worldSize, f), g = (0, $1rqx5.$)(t.worldSize, p).sub(h), _ = (0, $1rqx5.Fr)(m - r);
        l = m !== r;
        let v = (e1)=>{
            if (l && t.setZoom((0, $1rqx5.un).number(r, m, e1)), (0, $1rqx5.Tr)(a, o) || $834619e78bbf578c$var$Nc({
                startEulerAngles: a,
                endEulerAngles: o,
                tr: t,
                k: e1,
                useSlerp: a.roll != o.roll
            }), c && (t.interpolatePadding(i, n.padding, e1), d = t.centerPoint.add(n.offsetAsPoint)), n.around) t.setLocationAtPoint(n.around, n.aroundPoint);
            else {
                let n = (0, $1rqx5.Fr)(t.zoom - r), i = (m > r ? Math.min(2, _) : Math.max(.5, _)) ** (1 - e1), a = (0, $1rqx5.tt)(t.worldSize, h.add(g.mult(e1 * i)).mult(n));
                t.setLocationAtPoint(t.renderWorldCopies ? a.wrap() : a, d);
            }
        }, y = this._transformAtAnimationEnd(t, m, o, n.padding);
        return n.around ? y.setLocationAtPoint(n.around, n.aroundPoint) : y.setLocationAtPoint(p, y.centerPoint.add(n.offsetAsPoint)), {
            easeFunc: v,
            isZooming: l,
            elevationCenter: y.center
        };
    }
    handleFlyTo(t, n) {
        let r = n.zoom !== void 0, i = t.zoom, a = t.applyConstrain((0, $1rqx5.lt).convert(n.center || n.locationAtOffset), r ? +n.zoom : i), o = a.center, s = a.zoom;
        $834619e78bbf578c$var$hc(t, o);
        let c = t.worldSize, l = (0, $1rqx5.$)(c, n.locationAtOffset), u = (0, $1rqx5.$)(c, o).sub(l), d = u.mag(), f = (0, $1rqx5.Fr)(s - i), p = n.minZoom === void 0 ? t.minZoom : +n.minZoom, m = Math.max(p, t.minZoom), h = Math.min(m, i, s), g = t.applyConstrain(o, h).zoom, _ = (0, $1rqx5.Fr)(g - i), v = (e1, n, r, a)=>{
            t.setZoom(e1 === 1 ? s : i + (0, $1rqx5.Dr)(n));
            let d = e1 === 1 ? o : (0, $1rqx5.tt)(c, l.add(u.mult(r)));
            t.setLocationAtPoint(t.renderWorldCopies ? d.wrap() : d, a);
        }, y = this._transformAtAnimationEnd(t, s, {
            roll: n.roll,
            pitch: n.pitch,
            bearing: n.bearing
        }, n.padding);
        return y.setLocationAtPoint(o, y.centerPoint.add(n.offsetAsPoint)), {
            easeFunc: v,
            scaleOfZoom: f,
            targetCenter: y.center,
            scaleOfMinZoom: _,
            pixelPathLength: d
        };
    }
    _transformAtAnimationEnd(e1, t, n, r) {
        let i = e1.clone();
        return i.setZoom(t), i.setRoll(n.roll), i.setPitch(n.pitch), i.setBearing(n.bearing), i.setPadding(r), i;
    }
};
let $834619e78bbf578c$var$Ic;
const $834619e78bbf578c$var$Lc = ()=>$834619e78bbf578c$var$Ic ||= new (0, $1rqx5.Qt)({
        type: new (0, $1rqx5.Zt)((0, $1rqx5.hn).projection.type, `type`)
    }), $834619e78bbf578c$var$Rc = new (0, $1rqx5.vt)({
    fill: new (0, $1rqx5._t)(128, 2),
    line: new (0, $1rqx5._t)(512, 0),
    tile: new (0, $1rqx5._t)(128, 32),
    stencil: new (0, $1rqx5._t)(128, 1),
    circle: 3
});
var $834619e78bbf578c$var$zc = class {
    constructor(){
        this._tileMeshCache = {};
    }
    get name() {
        return `vertical-perspective`;
    }
    get transitionState() {
        return 1;
    }
    get useSubdivision() {
        return !0;
    }
    get shaderVariantName() {
        return `globe`;
    }
    get shaderDefine() {
        return `#define GLOBE`;
    }
    get shaderPreludeCode() {
        return $834619e78bbf578c$var$uc.projectionGlobe;
    }
    get vertexShaderPreludeCode() {
        return $834619e78bbf578c$var$uc.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return $834619e78bbf578c$var$Rc;
    }
    get useGlobeControls() {
        return !0;
    }
    destroy() {}
    _getMeshKey(e1) {
        return `${e1.granularity.toString(36)}_${e1.generateBorders ? `b` : ``}${e1.extendToNorthPole ? `n` : ``}${e1.extendToSouthPole ? `s` : ``}`;
    }
    getMeshFromTileID(e1, t, n, r, i) {
        let a = (i === `stencil` ? $834619e78bbf578c$var$Rc.stencil : $834619e78bbf578c$var$Rc.tile).getGranularityForZoomLevel(t.z), o = t.y === 0 && r, s = t.y === (1 << t.z) - 1 && r;
        return this._getMesh(e1, {
            granularity: a,
            generateBorders: n,
            extendToNorthPole: o,
            extendToSouthPole: s
        });
    }
    _getMesh(e1, t) {
        let n = this._getMeshKey(t);
        if (n in this._tileMeshCache) return this._tileMeshCache[n];
        let r = $834619e78bbf578c$var$Za(e1, t);
        return this._tileMeshCache[n] = r, r;
    }
    recalculate(e1) {}
    hasTransition() {
        return !1;
    }
}, $834619e78bbf578c$var$Bc = class extends (0, $1rqx5.vn) {
    constructor(e1, t){
        super(), this._transitionable = new (0, $1rqx5.$t)($834619e78bbf578c$var$Lc(), `projection`, t), this.setProjection(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new (0, $1rqx5.en)(0)), this._mercatorProjection = new $834619e78bbf578c$var$pc, this._verticalPerspectiveProjection = new $834619e78bbf578c$var$zc;
    }
    get transitionState() {
        let e1 = this.properties.get(`type`);
        if (typeof e1 == `string` && e1 === `mercator`) return 0;
        if (typeof e1 == `string` && e1 === `vertical-perspective`) return 1;
        if (e1 instanceof (0, $1rqx5.dn)) {
            if (e1.from === e1.to) return e1.from === `mercator` ? 0 : 1;
            if (e1.from === `vertical-perspective` && e1.to === `mercator`) return 1 - e1.transition;
            if (e1.from === `mercator` && e1.to === `vertical-perspective`) return e1.transition;
        }
        return 1;
    }
    get useGlobeRendering() {
        return this.transitionState > 0;
    }
    get currentProjection() {
        return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
    }
    get name() {
        return `globe`;
    }
    get useSubdivision() {
        return this.currentProjection.useSubdivision;
    }
    get shaderVariantName() {
        return this.currentProjection.shaderVariantName;
    }
    get shaderDefine() {
        return this.currentProjection.shaderDefine;
    }
    get shaderPreludeCode() {
        return this.currentProjection.shaderPreludeCode;
    }
    get vertexShaderPreludeCode() {
        return this.currentProjection.vertexShaderPreludeCode;
    }
    get subdivisionGranularity() {
        return this.currentProjection.subdivisionGranularity;
    }
    get useGlobeControls() {
        return this.transitionState > 0;
    }
    destroy() {
        this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
    }
    getMeshFromTileID(e1, t, n, r, i) {
        return this.currentProjection.getMeshFromTileID(e1, t, n, r, i);
    }
    setProjection(e1) {
        this._transitionable.setValue(`type`, e1?.type || `mercator`);
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
};
function $834619e78bbf578c$var$Vc(e1) {
    let t = $834619e78bbf578c$var$qc(e1.worldSize, e1.center.lat);
    return 2 * Math.PI * t;
}
function $834619e78bbf578c$var$Hc(e1, t, n) {
    let r = $834619e78bbf578c$var$Kc(t), i = $834619e78bbf578c$var$Kc(n), a = (0, $1rqx5.ei)(r, i), o = Math.acos(a), s = $834619e78bbf578c$var$Vc(e1);
    return o / (2 * Math.PI) * s;
}
function $834619e78bbf578c$var$Uc(e1, t) {
    return [
        (0, $1rqx5.gr)(e1 * Math.PI * 2 + Math.PI, Math.PI * 2),
        2 * Math.atan(Math.exp(Math.PI - t * Math.PI * 2)) - Math.PI * .5
    ];
}
function $834619e78bbf578c$var$Wc(e1, t) {
    let n = Math.cos(t), r = /* @__PURE__ */ new Float64Array(3);
    return r[0] = Math.sin(e1) * n, r[1] = Math.sin(t), r[2] = Math.cos(e1) * n, r;
}
function $834619e78bbf578c$var$Gc(e1, t, n, r, i) {
    let a = 1 / (1 << i), o = e1 / (0, $1rqx5.Lr) * a + n * a, s = t / (0, $1rqx5.Lr) * a + r * a, c = (0, $1rqx5.gr)(o * Math.PI * 2 + Math.PI, Math.PI * 2), l = 2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - Math.PI * .5, u = Math.cos(l), d = /* @__PURE__ */ new Float64Array(3);
    return d[0] = Math.sin(c) * u, d[1] = Math.sin(l), d[2] = Math.cos(c) * u, d;
}
function $834619e78bbf578c$var$Kc(e1) {
    return $834619e78bbf578c$var$Wc(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
}
function $834619e78bbf578c$var$qc(e1, t) {
    return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
}
function $834619e78bbf578c$var$Jc(e1) {
    let t = (0, $1rqx5.Yr)((0, $1rqx5.Kn)(), [
        0,
        0,
        0,
        1
    ], e1.modelViewProjectionMatrix);
    return (0, $1rqx5.Yr)(t, t, e1.inverseProjectionMatrix), [
        t[0] / t[3],
        t[1] / t[3],
        t[2] / t[3]
    ];
}
function $834619e78bbf578c$var$Yc(e1) {
    let t = Math.asin(e1[1]) / Math.PI * 180, n = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
    if (n > 1e-6) {
        let r = e1[0] / n, i = e1[2] / n, a = Math.acos(i), o = (r > 0 ? a : -a) / Math.PI * 180;
        return new (0, $1rqx5.lt)((0, $1rqx5.Pr)(o, -180, 180), t);
    }
    return new (0, $1rqx5.lt)(0, t);
}
function $834619e78bbf578c$var$Xc(e1, t) {
    return (0, $1rqx5.Ur)((0, $1rqx5.Kn)(), -e1.lng, -e1.lat, t);
}
function $834619e78bbf578c$var$Zc(e1) {
    let t = e1[0], n = e1[1], r = e1[2], i = e1[3];
    return {
        lng: -Math.atan2(2 * (i * t + n * r), 1 - 2 * (t * t + n * n)) * 180 / Math.PI,
        lat: -Math.asin((0, $1rqx5.Bn)(2 * (i * n - r * t), -1, 1)) * 180 / Math.PI,
        bearing: Math.atan2(2 * (i * r + t * n), 1 - 2 * (n * n + r * r)) * 180 / Math.PI
    };
}
const $834619e78bbf578c$var$Qc = Math.PI * .98;
function $834619e78bbf578c$var$$c(e1, t) {
    let n = e1.cameraPosition, r = (0, $1rqx5.ni)(n);
    if (r <= 1) return e1.screenPointToLocation(t);
    let i = (0, $1rqx5.Gn)();
    (0, $1rqx5.ii)(i, n);
    let a = e1.getRayDirectionFromPixel(t), o = -(0, $1rqx5.ei)(a, i), s = (0, $1rqx5.Gn)();
    (0, $1rqx5.li)(s, a, i, o);
    let c = (0, $1rqx5.ni)(s);
    if (c < 1e-9) return e1.screenPointToLocation(t);
    let l = Math.atan2(c, o), d = Math.asin(1 / r) * .9;
    if (l < d) return e1.screenPointToLocation(t);
    let f = r * Math.sin(d), p = Math.asin((0, $1rqx5.Bn)(f, -1, 1)) - d, m = r * Math.cos(d) / Math.sqrt(Math.max(1 - f * f, 1e-12)) - 1, h = $834619e78bbf578c$var$Qc - p, g = l - d, _ = p + m * g * h / (h + m * g), v = (0, $1rqx5.Gn)();
    (0, $1rqx5.ci)(v, s, 1 / c);
    let y = (0, $1rqx5.Gn)();
    return (0, $1rqx5.ci)(y, i, Math.cos((0, $1rqx5.Bn)(_, 0, $834619e78bbf578c$var$Qc))), (0, $1rqx5.li)(y, y, v, Math.sin((0, $1rqx5.Bn)(_, 0, $834619e78bbf578c$var$Qc))), (0, $1rqx5.ii)(y, y), $834619e78bbf578c$var$Yc(y);
}
function $834619e78bbf578c$var$el(e1, t, n, r, i = !0) {
    let a = $834619e78bbf578c$var$$c(e1, n), o = t;
    if (r) o = $834619e78bbf578c$var$$c(e1, n.sub(r));
    else if (!e1.isPointOnMapSurface(n)) return;
    let s = $834619e78bbf578c$var$Kc(a), c = $834619e78bbf578c$var$Kc(o), l = $834619e78bbf578c$var$Xc(e1.center, e1.bearing), d = (0, $1rqx5.Qr)((0, $1rqx5.Gn)(), c, s), f = Math.sqrt((0, $1rqx5.ei)(d, d)), p = Math.acos((0, $1rqx5.Bn)((0, $1rqx5.ei)(c, s), -1, 1)) / 2, m = Math.sin(p), h = f ? (0, $1rqx5.Wr)(d[1] / f * m, -d[0] / f * m, d[2] / f * m, Math.cos(p)) : (0, $1rqx5.Wr)(0, 0, 0, 1), { lng: g, lat: _, bearing: v } = $834619e78bbf578c$var$Zc((0, $1rqx5.Gr)((0, $1rqx5.Kn)(), l, h)), y = e1.center.lat, b = e1.zoom, x = (0, $1rqx5.Bn)(_, -90, 90), S = i ? $834619e78bbf578c$var$tl(e1, n, r, g) : g;
    e1.setCenter(new (0, $1rqx5.lt)((0, $1rqx5.Pr)(S, -180, 180), x)), i || e1.setBearing(v), e1.setZoom(b + $834619e78bbf578c$var$al(y, e1.center.lat));
}
function $834619e78bbf578c$var$tl(e1, t, n, r) {
    let i = e1.center.lng, a = e1.center.lat, o = a >= 0 ? 90 : -90, s = e1.locationToScreenPoint(new (0, $1rqx5.lt)(0, o)), c = t.x - s.x, l = t.y - s.y, d = c * c + l * l, f = (0, $1rqx5.Bn)(1 - ((0, $1rqx5.Fn) - Math.abs(a)) / 12, 0, 1), p = f * f * (3 - 2 * f), m = (0, $1rqx5.gr)(r - i + 180, 360) - 180, h = 0;
    if (p > 0 && n) {
        let e1 = (c * n.y - l * n.x) / Math.max(d, 400);
        h = (o > 0 ? 1 : -1) * e1 * 180 / Math.PI;
    }
    return i + (1 - p) * m + p * h;
}
function $834619e78bbf578c$var$nl(e1) {
    let t = (0, $1rqx5.Gn)();
    return t[0] = e1[0] * -e1[3], t[1] = e1[1] * -e1[3], t[2] = e1[2] * -e1[3], {
        center: t,
        radius: Math.sqrt(1 - e1[3] * e1[3])
    };
}
function $834619e78bbf578c$var$rl(e1, t, n) {
    let r = (0, $1rqx5.Gn)();
    (0, $1rqx5.ui)(r, n, e1);
    let i = (0, $1rqx5.Gn)();
    return (0, $1rqx5.li)(i, e1, r, t / (0, $1rqx5.ti)(r)), i;
}
function $834619e78bbf578c$var$il(e1) {
    return Math.cos(e1 * Math.PI / 180);
}
function $834619e78bbf578c$var$al(e1, t) {
    let n = $834619e78bbf578c$var$il(e1), r = $834619e78bbf578c$var$il(t);
    return (0, $1rqx5.Dr)(r / n);
}
function $834619e78bbf578c$var$ol(e1, t) {
    return 360 / $834619e78bbf578c$var$Vc({
        worldSize: e1,
        center: {
            lat: t
        }
    });
}
function $834619e78bbf578c$var$sl(e1, t) {
    let n = e1.rotate(t.bearingInRadians), r = t.zoom + $834619e78bbf578c$var$al(t.center.lat, 0), i = (0, $1rqx5.mr)(1 / $834619e78bbf578c$var$il(t.center.lat), 1 / $834619e78bbf578c$var$il(Math.min(Math.abs(t.center.lat), 60)), (0, $1rqx5.wr)(r, 7, 3, 0, 1)), a = $834619e78bbf578c$var$ol(t.worldSize, t.center.lat);
    return new (0, $1rqx5.lt)(t.center.lng - n.x * a * i, (0, $1rqx5.Bn)(t.center.lat + n.y * a, -(0, $1rqx5.Fn), (0, $1rqx5.Fn)));
}
function $834619e78bbf578c$var$cl(e1) {
    let t = .5 * e1, n = Math.sin(t), r = Math.cos(t);
    return Math.log(n + r) - Math.log(r - n);
}
function $834619e78bbf578c$var$ll(e1, t, n, r) {
    let i = e1.lat + n * r;
    if (Math.abs(n) > 1) {
        let a = e1.lat + n, o = (Math.sign(a) === Math.sign(e1.lat) ? Math.abs(e1.lat) : -Math.abs(e1.lat)) * Math.PI / 180, s = Math.abs(e1.lat + n) * Math.PI / 180, c = $834619e78bbf578c$var$cl(o + r * (s - o)), l = $834619e78bbf578c$var$cl(o), u = $834619e78bbf578c$var$cl(s), d = (c - l) / (u - l), f = e1.lng + t * d;
        return new (0, $1rqx5.lt)(f, i);
    }
    {
        let n = e1.lng + t * r;
        return new (0, $1rqx5.lt)(n, i);
    }
}
function $834619e78bbf578c$var$ul(e1, t, n = 1) {
    let r = (0, $1rqx5.ei)(e1, t), i = n * n, a = (0, $1rqx5.Gn)(), o = (0, $1rqx5.Gn)();
    (0, $1rqx5.ci)(o, t, r), (0, $1rqx5.ui)(a, e1, o);
    let s = i - (0, $1rqx5.ei)(a, a);
    if (s < 0) return null;
    let c = (0, $1rqx5.ei)(e1, e1) - i, l = -r + (r < 0 ? 1 : -1) * Math.sqrt(s), u = c / l, d = l, f = Math.max(u, d);
    return f < 0 ? null : {
        tMin: Math.min(u, d),
        tMax: f
    };
}
function $834619e78bbf578c$var$dl(e1, t) {
    let n = t * .01569612305760477, r = (0, $1rqx5.Bn)((e1 - n) / (9 * n), 0, 1);
    return r * r * (3 - 2 * r);
}
var $834619e78bbf578c$var$fl = class {
    constructor(e1){
        this._cachePrevious = /* @__PURE__ */ new Map, this._cache = /* @__PURE__ */ new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
    }
    swapBuffers() {
        if (!this._hadAnyChanges) return;
        let e1 = this._cachePrevious;
        this._cachePrevious = this._cache, this._cache = e1, this._cache.clear(), this._hadAnyChanges = !1;
    }
    getTileBoundingVolume(e1, t, n, r) {
        let i = `${e1.z}_${e1.x}_${e1.y}_${r?.terrain ? `t` : ``}_${Math.round(n)}`, a = this._cache.get(i);
        if (a) return a;
        let o = this._cachePrevious.get(i);
        if (o) return this._cache.set(i, o), o;
        let s = this._boundingVolumeFactory(e1, t, n, r);
        return this._cache.set(i, s), this._hadAnyChanges = !0, s;
    }
}, $834619e78bbf578c$var$pl = class e1 {
    constructor(e1, t, n, r){
        this.min = n, this.max = r, this.points = e1, this.planes = t;
    }
    static fromAabb(t, n) {
        let r = [];
        for(let e1 = 0; e1 < 8; e1++)r.push([
            (e1 >> 0 & 1) == 1 ? n[0] : t[0],
            (e1 >> 1 & 1) == 1 ? n[1] : t[1],
            (e1 >> 2 & 1) == 1 ? n[2] : t[2]
        ]);
        return new e1(r, [
            [
                -1,
                0,
                0,
                n[0]
            ],
            [
                1,
                0,
                0,
                -t[0]
            ],
            [
                0,
                -1,
                0,
                n[1]
            ],
            [
                0,
                1,
                0,
                -t[1]
            ],
            [
                0,
                0,
                -1,
                n[2]
            ],
            [
                0,
                0,
                1,
                -t[2]
            ]
        ], t, n);
    }
    static fromCenterSizeAngles(t, n, r) {
        let i = (0, $1rqx5.Ur)([], r[0], r[1], r[2]), a = (0, $1rqx5.mi)([], [
            n[0],
            0,
            0
        ], i), o = (0, $1rqx5.mi)([], [
            0,
            n[1],
            0
        ], i), s = (0, $1rqx5.mi)([], [
            0,
            0,
            n[2]
        ], i), c = [
            ...t
        ], l = [
            ...t
        ];
        for(let e1 = 0; e1 < 8; e1++)for(let n = 0; n < 3; n++){
            let r = t[n] + a[n] * ((e1 >> 0 & 1) == 1 ? 1 : -1) + o[n] * ((e1 >> 1 & 1) == 1 ? 1 : -1) + s[n] * ((e1 >> 2 & 1) == 1 ? 1 : -1);
            c[n] = Math.min(c[n], r), l[n] = Math.max(l[n], r);
        }
        let u = [];
        for(let e1 = 0; e1 < 8; e1++){
            let n = [
                ...t
            ];
            (0, $1rqx5.Xr)(n, n, (0, $1rqx5.ci)([], a, (e1 >> 0 & 1) == 1 ? 1 : -1)), (0, $1rqx5.Xr)(n, n, (0, $1rqx5.ci)([], o, (e1 >> 1 & 1) == 1 ? 1 : -1)), (0, $1rqx5.Xr)(n, n, (0, $1rqx5.ci)([], s, (e1 >> 2 & 1) == 1 ? 1 : -1)), u.push(n);
        }
        return new e1(u, [
            [
                ...a,
                -(0, $1rqx5.ei)(a, u[0])
            ],
            [
                ...o,
                -(0, $1rqx5.ei)(o, u[0])
            ],
            [
                ...s,
                -(0, $1rqx5.ei)(s, u[0])
            ],
            [
                -a[0],
                -a[1],
                -a[2],
                -(0, $1rqx5.ei)(a, u[7])
            ],
            [
                -o[0],
                -o[1],
                -o[2],
                -(0, $1rqx5.ei)(o, u[7])
            ],
            [
                -s[0],
                -s[1],
                -s[2],
                -(0, $1rqx5.ei)(s, u[7])
            ]
        ], c, l);
    }
    intersectsFrustum(e1) {
        let t = !0, n = this.points.length, r = this.planes.length, i = e1.planes.length, a = e1.points.length;
        for(let r = 0; r < i; r++){
            let i = e1.planes[r], a = 0;
            for(let e1 = 0; e1 < n; e1++){
                let t = this.points[e1];
                i[0] * t[0] + i[1] * t[1] + i[2] * t[2] + i[3] >= 0 && a++;
            }
            if (a === 0) return 0;
            a < n && (t = !1);
        }
        if (t) return 2;
        for(let t = 0; t < r; t++){
            let n = this.planes[t], r = 0;
            for(let t = 0; t < a; t++){
                let i = e1.points[t];
                n[0] * i[0] + n[1] * i[1] + n[2] * i[2] + n[3] >= 0 && r++;
            }
            if (r === 0) return 0;
        }
        return 1;
    }
    intersectsPlane(e1) {
        let t = this.points.length, n = 0;
        for(let r = 0; r < t; r++){
            let t = this.points[r];
            e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] >= 0 && n++;
        }
        return n === t ? 2 : n === 0 ? 0 : 1;
    }
};
function $834619e78bbf578c$var$ml(e1, t, n) {
    let r = e1 - t;
    return r < 0 ? -r : Math.max(0, r - n);
}
function $834619e78bbf578c$var$hl(e1, t, n, r, i) {
    let a = e1 - n, o;
    return o = a < 0 ? Math.min(-a, 1 + a - i) : a > i ? Math.min(Math.max(a - i, 0), 1 - a) : 0, Math.max(o, $834619e78bbf578c$var$ml(t, r, i));
}
var $834619e78bbf578c$var$gl = class {
    constructor(){
        this._boundingVolumeCache = new $834619e78bbf578c$var$fl(this._computeTileBoundingVolume);
    }
    prepareNextFrame() {
        this._boundingVolumeCache.swapBuffers();
    }
    distanceToTile2d(e1, t, n, r) {
        let i = 1 << n.z, a = 1 / i, o = n.x / i, s = n.y / i, c = .5, l = 2;
        return l = Math.min(l, $834619e78bbf578c$var$hl(e1, t, o, s, a)), l = Math.min(l, $834619e78bbf578c$var$hl(e1, t, o + c, -s - a, a)), l = Math.min(l, $834619e78bbf578c$var$hl(e1, t, o + c, 2 - s - a, a)), l;
    }
    getWrap(e1, t, n) {
        let r = 1 << t.z, i = 1 / r, a = t.x / r, o = $834619e78bbf578c$var$ml(e1.x, a, i), s = $834619e78bbf578c$var$ml(e1.x, a - 1, i), c = $834619e78bbf578c$var$ml(e1.x, a + 1, i), l = Math.min(o, s, c);
        return l === c ? 1 : l === s ? -1 : 0;
    }
    allowVariableZoom(e1, t) {
        return $834619e78bbf578c$var$jo(e1, t) > 4;
    }
    allowWorldCopies() {
        return !1;
    }
    getTileBoundingVolume(e1, t, n, r) {
        return this._boundingVolumeCache.getTileBoundingVolume(e1, t, n, r);
    }
    _computeTileBoundingVolume(e1, t, n, r) {
        let i = Math.min(0, n), a = Math.max(0, n);
        if (r?.terrain) {
            let n = new (0, $1rqx5.d)(e1.z, t, e1.z, e1.x, e1.y), o = r.terrain.getMinMaxElevation(n);
            i = o.minElevation ?? i, a = Math.max(o.maxElevation ?? a, a);
        }
        if (i /= (0, $1rqx5.ut), a /= (0, $1rqx5.ut), i += 1, a += 1, e1.z <= 0) return $834619e78bbf578c$var$pl.fromAabb([
            -a,
            -a,
            -a
        ], [
            a,
            a,
            a
        ]);
        if (e1.z === 1) return $834619e78bbf578c$var$pl.fromAabb([
            e1.x === 0 ? -a : 0,
            e1.y === 0 ? 0 : -a,
            -a
        ], [
            e1.x === 0 ? 0 : a,
            e1.y === 0 ? a : 0,
            a
        ]);
        {
            let t = [
                $834619e78bbf578c$var$Gc(0, 0, e1.x, e1.y, e1.z),
                $834619e78bbf578c$var$Gc((0, $1rqx5.Lr), 0, e1.x, e1.y, e1.z),
                $834619e78bbf578c$var$Gc((0, $1rqx5.Lr), (0, $1rqx5.Lr), e1.x, e1.y, e1.z),
                $834619e78bbf578c$var$Gc(0, (0, $1rqx5.Lr), e1.x, e1.y, e1.z)
            ], n = [];
            for (let e1 of t)n.push((0, $1rqx5.ci)([], e1, a));
            if (a !== i) for (let e1 of t)n.push((0, $1rqx5.ci)([], e1, i));
            e1.y === 0 && n.push([
                0,
                1,
                0
            ]), e1.y === (1 << e1.z) - 1 && n.push([
                0,
                -1,
                0
            ]);
            let r = [
                1,
                1,
                1
            ], o = [
                -1,
                -1,
                -1
            ];
            for (let e1 of n)for(let t = 0; t < 3; t++)r[t] = Math.min(r[t], e1[t]), o[t] = Math.max(o[t], e1[t]);
            let c = $834619e78bbf578c$var$Gc((0, $1rqx5.Lr) / 2, (0, $1rqx5.Lr) / 2, e1.x, e1.y, e1.z), l = (0, $1rqx5.Qr)([], [
                0,
                1,
                0
            ], c);
            (0, $1rqx5.ii)(l, l);
            let u = (0, $1rqx5.Qr)([], c, l);
            (0, $1rqx5.ii)(u, u);
            let d = (0, $1rqx5.Qr)([], t[2], t[1]);
            (0, $1rqx5.ii)(d, d);
            let f = (0, $1rqx5.Qr)([], t[0], t[3]);
            (0, $1rqx5.ii)(f, f), n.push((0, $1rqx5.ci)([], c, a)), e1.y >= (1 << e1.z) / 2 && n.push((0, $1rqx5.ci)([], $834619e78bbf578c$var$Gc((0, $1rqx5.Lr) / 2, 0, e1.x, e1.y, e1.z), a)), e1.y < (1 << e1.z) / 2 && n.push((0, $1rqx5.ci)([], $834619e78bbf578c$var$Gc((0, $1rqx5.Lr) / 2, (0, $1rqx5.Lr), e1.x, e1.y, e1.z), a));
            let p = $834619e78bbf578c$var$_l(c, n), m = $834619e78bbf578c$var$_l(u, n), h = [
                -c[0],
                -c[1],
                -c[2],
                p.max
            ], g = [
                c[0],
                c[1],
                c[2],
                -p.min
            ], _ = [
                -u[0],
                -u[1],
                -u[2],
                m.max
            ], v = [
                u[0],
                u[1],
                u[2],
                -m.min
            ], y = [
                ...d,
                0
            ], b = [
                ...f,
                0
            ], x = [];
            return e1.y === 0 ? x.push((0, $1rqx5.Ar)(b, y, h), (0, $1rqx5.Ar)(b, y, g)) : x.push((0, $1rqx5.Ar)(_, y, h), (0, $1rqx5.Ar)(_, y, g), (0, $1rqx5.Ar)(_, b, h), (0, $1rqx5.Ar)(_, b, g)), e1.y === (1 << e1.z) - 1 ? x.push((0, $1rqx5.Ar)(b, y, h), (0, $1rqx5.Ar)(b, y, g)) : x.push((0, $1rqx5.Ar)(v, y, h), (0, $1rqx5.Ar)(v, y, g), (0, $1rqx5.Ar)(v, b, h), (0, $1rqx5.Ar)(v, b, g)), new $834619e78bbf578c$var$pl(x, [
                h,
                g,
                _,
                v,
                y,
                b
            ], r, o);
        }
    }
};
function $834619e78bbf578c$var$_l(e1, t) {
    let n = 1 / 0, r = -1 / 0;
    for (let i of t){
        let t = (0, $1rqx5.ei)(e1, i);
        n = Math.min(n, t), r = Math.max(r, t);
    }
    return {
        min: n,
        max: r
    };
}
const $834619e78bbf578c$var$vl = 1e-12;
var $834619e78bbf578c$var$yl = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t) {
        this._helper.resize(e1, t);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(e1, t){
        this._cachedClippingPlane = (0, $1rqx5.Kn)(), this._projectionMatrix = (0, $1rqx5.Un)(), this._globeViewProjMatrix32f = (0, $1rqx5.Hn)(), this._globeViewProjMatrixF64 = (0, $1rqx5.Un)(), this._globeViewProjMatrixF64Inverted = (0, $1rqx5.Un)(), this._globeProjMatrixInverted = (0, $1rqx5.Un)(), this._cameraPosition = (0, $1rqx5.Gn)(), this.defaultConstrain = (e1, t)=>{
            let n = (0, $1rqx5.Bn)(e1.lat, -(0, $1rqx5.Fn), (0, $1rqx5.Fn)), r = (0, $1rqx5.Bn)(+t, this.minZoom + $834619e78bbf578c$var$al(0, n), this.maxZoom);
            return {
                center: new (0, $1rqx5.lt)(e1.lng, n),
                zoom: r
            };
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = t ?? new $834619e78bbf578c$var$_c({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._coveringTilesDetailsProvider = new $834619e78bbf578c$var$gl;
    }
    clone() {
        let t = new e1;
        return t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t);
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._globeViewProjMatrixF64;
    }
    get inverseProjectionMatrix() {
        return this._globeProjMatrixInverted;
    }
    get cameraPosition() {
        let e1 = (0, $1rqx5.Gn)();
        return e1[0] = this._cameraPosition[0], e1[1] = this._cameraPosition[1], e1[2] = this._cameraPosition[2], e1;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, applyGlobeMatrix: n } = e1, r = this._helper.getMercatorTileCoordinates(t);
        return {
            mainMatrix: this._globeViewProjMatrix32f,
            tileMercatorCoords: r,
            clippingPlane: this._cachedClippingPlane,
            projectionTransition: +!!n,
            fallbackMatrix: this._globeViewProjMatrix32f,
            clipAntimeridian: t?.canonical.z === 0
        };
    }
    _computeClippingPlane(e1) {
        let t = this.pitchInRadians, n = this.cameraToCenterDistance / e1, r = Math.sin(t) * n, i = Math.cos(t) * n + 1, a = 1 / Math.sqrt(r * r + i * i) * 1, o = -r, s = i, c = Math.sqrt(o * o + s * s);
        o /= c, s /= c;
        let l = [
            0,
            o,
            s
        ];
        (0, $1rqx5.si)(l, l, [
            0,
            0,
            0
        ], -this.bearingInRadians), (0, $1rqx5.ai)(l, l, [
            0,
            0,
            0
        ], -1 * this.center.lat * Math.PI / 180), (0, $1rqx5.oi)(l, l, [
            0,
            0,
            0
        ], this.center.lng * Math.PI / 180);
        let u = 1 / (0, $1rqx5.ni)(l);
        return (0, $1rqx5.ci)(l, l, u), [
            ...l,
            -a * u
        ];
    }
    isLocationOccluded(e1, t, n) {
        let r = t?.getCoverageIndex();
        n ??= r ? t.getElevationForLngLat(e1, this) : 0;
        let i = $834619e78bbf578c$var$Sl(e1, n);
        if (!this.isSurfacePointVisible(i)) return !0;
        if (!r) return !1;
        let a = this._projectSurfacePointToScreen(i), o = this.cameraPosition, s = this.getRayDirectionFromPixel(a), c = $834619e78bbf578c$var$Cl(o, s, i);
        if (c <= 0) return !0;
        let l = this.screenTerrainPointToMercatorCoordinate(a, t);
        return l != null && $834619e78bbf578c$var$Cl(o, s, $834619e78bbf578c$var$Sl(l.toLngLat(), l.z)) < c * .99;
    }
    transformLightDirection(e1) {
        let t = this._helper._center.lng * Math.PI / 180, n = this._helper._center.lat * Math.PI / 180, r = Math.cos(n), i = [
            Math.sin(t) * r,
            Math.sin(n),
            Math.cos(t) * r
        ], a = [
            i[2],
            0,
            -i[0]
        ], o = [
            0,
            0,
            0
        ];
        (0, $1rqx5.Qr)(o, a, i), (0, $1rqx5.ii)(a, a), (0, $1rqx5.ii)(o, o);
        let s = [
            a[0] * e1[0] + o[0] * e1[1] + i[0] * e1[2],
            a[1] * e1[0] + o[1] * e1[1] + i[1] * e1[2],
            a[2] * e1[0] + o[2] * e1[1] + i[2] * e1[2]
        ], c = [
            0,
            0,
            0
        ];
        return (0, $1rqx5.ii)(c, s), c;
    }
    getPixelScale() {
        return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getCircleRadiusCorrection() {
        return Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getPitchedTextCorrection(e1, t, n) {
        let r = (0, $1rqx5.et)(e1, t, n.canonical), i = $834619e78bbf578c$var$Uc(r.x, r.y);
        return this.getCircleRadiusCorrection() / Math.cos(i[1]);
    }
    projectTileCoordinates(e1, t, n, r) {
        let i = n.canonical, a = $834619e78bbf578c$var$Gc(e1, t, i.x, i.y, i.z), o = 1 + (r ?? 0) / (0, $1rqx5.ut), s = a[0] * o, c = a[1] * o, l = a[2] * o, u = [
            s,
            c,
            l,
            1
        ];
        (0, $1rqx5.Yr)(u, u, this._globeViewProjMatrixF64);
        let d;
        if (o <= 1) {
            let e1 = this._cachedClippingPlane;
            d = e1[0] * a[0] + e1[1] * a[1] + e1[2] * a[2] + e1[3] < 0;
        } else d = this._isLineOfSightBlocked(s, c, l);
        return {
            point: new (0, $1rqx5.Li)(u[0] / u[3], u[1] / u[3]),
            signedDistanceFromCamera: u[3],
            isOccluded: d
        };
    }
    _isLineOfSightBlocked(e1, t, n) {
        let r = this._cameraPosition, i = e1 - r[0], a = t - r[1], o = n - r[2], s = i * i + a * a + o * o;
        if (s === 0) return !1;
        let c = (0, $1rqx5.Bn)(-(r[0] * i + r[1] * a + r[2] * o) / s, 0, 1), l = r[0] + c * i, d = r[1] + c * a, f = r[2] + c * o;
        return l * l + d * d + f * f < 1;
    }
    _calcMatrices(e1 = this._helper.autoCalculateNearFarZ) {
        let t = $834619e78bbf578c$var$qc(this.worldSize, this.center.lat), n = (0, $1rqx5.Wn)();
        e1 && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + t * 2), (0, $1rqx5.Ei)(n, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
        let r = this.centerOffset;
        n[8] = -r.x * 2 / this._helper._width, n[9] = r.y * 2 / this._helper._height, this._projectionMatrix = (0, $1rqx5.gi)(n), this._globeProjMatrixInverted = (0, $1rqx5.Wn)(), (0, $1rqx5.Ci)(this._globeProjMatrixInverted, n), (0, $1rqx5.ji)(n, n, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), (0, $1rqx5.ki)(n, n, this.rollInRadians), (0, $1rqx5.Di)(n, n, -this.pitchInRadians), (0, $1rqx5.ki)(n, n, this.bearingInRadians), (0, $1rqx5.ji)(n, n, [
            0,
            0,
            -t
        ]);
        let i = (0, $1rqx5.Gn)();
        i[0] = t, i[1] = t, i[2] = t, (0, $1rqx5.Di)(n, n, this.center.lat * Math.PI / 180), (0, $1rqx5.Oi)(n, n, -this.center.lng * Math.PI / 180), (0, $1rqx5.Ai)(n, n, i), this._globeViewProjMatrixF64 = n, this._globeViewProjMatrix32f = new Float32Array(n), this._globeViewProjMatrixF64Inverted = (0, $1rqx5.Wn)(), (0, $1rqx5.Ci)(this._globeViewProjMatrixF64Inverted, n);
        let o = (0, $1rqx5.Gn)();
        this._cameraPosition = (0, $1rqx5.Gn)(), this._cameraPosition[2] = this.cameraToCenterDistance / t, (0, $1rqx5.si)(this._cameraPosition, this._cameraPosition, o, -this.rollInRadians), (0, $1rqx5.ai)(this._cameraPosition, this._cameraPosition, o, this.pitchInRadians), (0, $1rqx5.si)(this._cameraPosition, this._cameraPosition, o, -this.bearingInRadians), (0, $1rqx5.Xr)(this._cameraPosition, this._cameraPosition, [
            0,
            0,
            1
        ]), (0, $1rqx5.ai)(this._cameraPosition, this._cameraPosition, o, -this.center.lat * Math.PI / 180), (0, $1rqx5.oi)(this._cameraPosition, this._cameraPosition, o, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(t);
        let s = (0, $1rqx5.gi)(this._globeViewProjMatrixF64Inverted);
        (0, $1rqx5.Ai)(s, s, [
            1,
            1,
            -1
        ]), this._cachedFrustum = $834619e78bbf578c$var$So.fromInvProjectionMatrix(s, 1, 0, this._cachedClippingPlane, !0);
    }
    calculateFogMatrix(e1) {
        (0, $1rqx5.Nr)(`calculateFogMatrix is not supported on globe projection.`);
        let t = (0, $1rqx5.Wn)();
        return (0, $1rqx5.Si)(t), t;
    }
    getVisibleUnwrappedCoordinates(e1) {
        return [
            new (0, $1rqx5.f)(0, e1)
        ];
    }
    getCameraFrustum() {
        return this._cachedFrustum;
    }
    getClippingPlane() {
        return this._cachedClippingPlane;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        if (e1) {
            (0, $1rqx5.Nr)(`terrain is not fully supported on vertical perspective projection.`);
            return;
        }
        this._helper.recalculateZoomAndCenter(0);
    }
    maxPitchScaleFactor() {
        return 1;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return ((0, $1rqx5.ni)(this._cameraPosition) - 1) * (0, $1rqx5.ut);
    }
    getCameraLngLat() {
        let e1 = (0, $1rqx5.Gn)();
        return (0, $1rqx5.ii)(e1, this._cameraPosition), $834619e78bbf578c$var$Yc(e1);
    }
    populateCache(e1) {}
    getBounds() {
        let e1 = this.width * .5, t = this.height * .5, n = [
            new (0, $1rqx5.Li)(0, 0),
            new (0, $1rqx5.Li)(e1, 0),
            new (0, $1rqx5.Li)(this.width, 0),
            new (0, $1rqx5.Li)(this.width, t),
            new (0, $1rqx5.Li)(this.width, this.height),
            new (0, $1rqx5.Li)(e1, this.height),
            new (0, $1rqx5.Li)(0, this.height),
            new (0, $1rqx5.Li)(0, t)
        ], r = [];
        for (let e1 of n)r.push(this.unprojectScreenPoint(e1));
        let i = 0, a = 0, o = 0, s = 0, c = this.center;
        for (let e1 of r){
            let t = (0, $1rqx5.Xn)(c.lng, e1.lng), n = (0, $1rqx5.Xn)(c.lat, e1.lat);
            t < a && (a = t), t > i && (i = t), n < s && (s = n), n > o && (o = n);
        }
        let l = [
            c.lng + a,
            c.lat + s,
            c.lng + i,
            c.lat + o
        ];
        return this.isSurfacePointOnScreen([
            0,
            1,
            0
        ]) && (l[3] = 90, l[0] = -180, l[2] = 180), this.isSurfacePointOnScreen([
            0,
            -1,
            0
        ]) && (l[1] = -90, l[0] = -180, l[2] = 180), new $834619e78bbf578c$export$266d2884f61535d3(l);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    calculateCameraOptionsFromTo(e1, t, r, i) {
        let a = (0, $1rqx5.lt).convert(r), o = $834619e78bbf578c$var$Kc((0, $1rqx5.lt).convert(e1));
        (0, $1rqx5.ci)(o, o, 1 + t / (0, $1rqx5.ut));
        let s = $834619e78bbf578c$var$Kc(a), c = (0, $1rqx5.ci)((0, $1rqx5.Gn)(), s, 1 + i / (0, $1rqx5.ut)), l = (0, $1rqx5.di)((0, $1rqx5.Gn)(), o, s), d = (0, $1rqx5.ni)(l);
        if (d < $834619e78bbf578c$var$vl || (0, $1rqx5.$r)(o, c) < $834619e78bbf578c$var$vl) throw Error(`Can't calculate camera options with same From and To`);
        let f = (0, $1rqx5.Gn)();
        (0, $1rqx5.oi)(l, l, f, -(0, $1rqx5.Yn)(a.lng)), (0, $1rqx5.ai)(l, l, f, (0, $1rqx5.Yn)(a.lat));
        let p = (0, $1rqx5.xr)(Math.acos((0, $1rqx5.Bn)(l[2] / d, -1, 1))), m = Math.hypot(l[0], l[1]) < d * 1e-9 ? this.bearing : (0, $1rqx5.xr)(Math.atan2(-l[0], -l[1]));
        return {
            center: a,
            elevation: i,
            zoom: (0, $1rqx5.Dr)(this.cameraToCenterDistance / d / $834619e78bbf578c$var$qc(this.tileSize, a.lat)),
            pitch: p,
            bearing: m
        };
    }
    setLocationAtPoint(e1, t, n) {
        let r = $834619e78bbf578c$var$Kc(this.unprojectScreenPoint(t)), i = $834619e78bbf578c$var$Kc(e1), a = (0, $1rqx5.Gn)();
        (0, $1rqx5.hi)(a);
        let o = (0, $1rqx5.Gn)();
        (0, $1rqx5.oi)(o, r, a, -this.center.lng * Math.PI / 180), (0, $1rqx5.ai)(o, o, a, this.center.lat * Math.PI / 180);
        let s = i[0] * i[0] + i[2] * i[2], c = o[0] * o[0];
        if (s < c) return;
        let l = Math.sqrt(s - c), d = -l, f = (0, $1rqx5.In)(i[0], i[2], o[0], l), p = (0, $1rqx5.In)(i[0], i[2], o[0], d), m = (0, $1rqx5.Gn)();
        (0, $1rqx5.oi)(m, i, a, -f);
        let h = (0, $1rqx5.In)(m[1], m[2], o[1], o[2]), g = (0, $1rqx5.Gn)();
        (0, $1rqx5.oi)(g, i, a, -p);
        let _ = (0, $1rqx5.In)(g[1], g[2], o[1], o[2]), v = Math.PI * .5, y = h >= -v && h <= v, b = _ >= -v && _ <= v, x, S;
        if (y && b) {
            let e1 = this.center.lng * Math.PI / 180, t = this.center.lat * Math.PI / 180, n = (0, $1rqx5.Zn)(f, e1), r = (0, $1rqx5.Zn)(h, t), i = (0, $1rqx5.Zn)(p, e1), a = (0, $1rqx5.Zn)(_, t);
            n + r < i + a ? (x = f, S = h) : (x = p, S = _);
        } else if (y) x = f, S = h;
        else if (b) x = p, S = _;
        else return;
        let C = x / Math.PI * 180, w = S / Math.PI * 180, T = this.center.lat;
        this.setCenter(new (0, $1rqx5.lt)(C, (0, $1rqx5.Bn)(w, -90, 90))), this.setZoom(this.zoom + $834619e78bbf578c$var$al(T, this.center.lat));
    }
    locationToScreenPoint(e1, t) {
        let n = $834619e78bbf578c$var$Kc(e1);
        if (t) {
            let r = t.getElevationForLngLatZoom(e1, this._helper._tileZoom);
            (0, $1rqx5.ci)(n, n, 1 + r / (0, $1rqx5.ut));
        }
        return this._projectSurfacePointToScreen(n);
    }
    _projectSurfacePointToScreen(e1) {
        let t = (0, $1rqx5.Kn)();
        return (0, $1rqx5.Yr)(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixF64), t[0] /= t[3], t[1] /= t[3], new (0, $1rqx5.Li)((t[0] * .5 + .5) * this.width, (-t[1] * .5 + .5) * this.height);
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let n = this.screenTerrainPointToMercatorCoordinate(e1, t);
            if (n) return n;
        }
        return (0, $1rqx5.nt).fromLngLat(this.unprojectScreenPoint(e1));
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        let n = t.getCoverageIndex();
        if (!n) return null;
        let r = this.cameraPosition, i = this.getRayDirectionFromPixel(e1), a = $834619e78bbf578c$var$ul(r, i, 1 + n.maxElevation / (0, $1rqx5.ut));
        if (!a) return null;
        let o = $834619e78bbf578c$var$ul(r, i, 1 + n.minElevation / (0, $1rqx5.ut)), s = Math.max(a.tMin, 0), c = o ? o.tMin : a.tMax;
        if (c <= s) return null;
        let l = {
            index: n,
            exaggeration: t.exaggeration,
            origin: r,
            direction: i
        }, u = 0;
        for(let e1 = 0; e1 <= 256; e1++){
            let t = s + (c - s) * e1 / 256;
            if ($834619e78bbf578c$var$xl(l, t)) {
                let { hi: e1 } = $834619e78bbf578c$var$Dc(l, $834619e78bbf578c$var$xl, u, t, 1e-12), { sample: n, mercator: r } = $834619e78bbf578c$var$bl(l, e1);
                return new (0, $1rqx5.nt)(r.x, r.y, n.elevation);
            }
            u = t;
        }
        return null;
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.screenPointToLocation(e1);
    }
    isPointOnMapSurface(e1, t) {
        let n = this._cameraPosition;
        return !!$834619e78bbf578c$var$ul(n, this.getRayDirectionFromPixel(e1));
    }
    getRayDirectionFromPixel(e1) {
        let t = (0, $1rqx5.Kn)();
        t[0] = e1.x / this.width * 2 - 1, t[1] = (e1.y / this.height * 2 - 1) * -1, t[2] = 1, t[3] = 1, (0, $1rqx5.Yr)(t, t, this._globeViewProjMatrixF64Inverted), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3];
        let n = (0, $1rqx5.Gn)();
        n[0] = t[0] - this._cameraPosition[0], n[1] = t[1] - this._cameraPosition[1], n[2] = t[2] - this._cameraPosition[2];
        let r = (0, $1rqx5.Gn)();
        return (0, $1rqx5.ii)(r, n), r;
    }
    isSurfacePointVisible(e1) {
        let t = this._cachedClippingPlane;
        return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3] >= 0;
    }
    isSurfacePointOnScreen(e1) {
        if (!this.isSurfacePointVisible(e1)) return !1;
        let t = (0, $1rqx5.Kn)();
        return (0, $1rqx5.Yr)(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixF64), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], t[0] > -1 && t[0] < 1 && t[1] > -1 && t[1] < 1 && t[2] > -1 && t[2] < 1;
    }
    unprojectScreenPoint(e1) {
        let t = this._cameraPosition, n = this.getRayDirectionFromPixel(e1), r = $834619e78bbf578c$var$ul(t, n);
        if (r) {
            let e1 = (0, $1rqx5.Gn)();
            (0, $1rqx5.Xr)(e1, t, [
                n[0] * r.tMin,
                n[1] * r.tMin,
                n[2] * r.tMin
            ]);
            let i = (0, $1rqx5.Gn)();
            return (0, $1rqx5.ii)(i, e1), $834619e78bbf578c$var$Yc(i);
        }
        let i = this._cachedClippingPlane, a = i[0] * n[0] + i[1] * n[1] + i[2] * n[2], o = -(0, $1rqx5.br)(i, t) / a, s = (0, $1rqx5.Gn)();
        if (o > 0) (0, $1rqx5.Xr)(s, t, [
            n[0] * o,
            n[1] * o,
            n[2] * o
        ]);
        else {
            let e1 = (0, $1rqx5.Gn)();
            (0, $1rqx5.Xr)(e1, t, [
                n[0] * 2,
                n[1] * 2,
                n[2] * 2
            ]);
            let r = (0, $1rqx5.br)(this._cachedClippingPlane, e1);
            (0, $1rqx5.ui)(s, e1, [
                this._cachedClippingPlane[0] * r,
                this._cachedClippingPlane[1] * r,
                this._cachedClippingPlane[2] * r
            ]);
        }
        let c = $834619e78bbf578c$var$nl(i);
        return $834619e78bbf578c$var$Yc($834619e78bbf578c$var$rl(c.center, c.radius, s));
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this.getProjectionData({
            overscaledTileID: new (0, $1rqx5.d)(0, 0, 0, 0, 0),
            applyGlobeMatrix: e1
        });
        return t.tileMercatorCoords = [
            0,
            0,
            1,
            1
        ], t;
    }
    getFastPathSimpleProjectionMatrix(e1) {}
};
function $834619e78bbf578c$var$bl(e1, t) {
    let n = (0, $1rqx5.Gn)();
    (0, $1rqx5.li)(n, e1.origin, e1.direction, t);
    let r = (0, $1rqx5.ni)(n), i = (0, $1rqx5.Gn)();
    (0, $1rqx5.ci)(i, n, 1 / r);
    let a = $834619e78bbf578c$var$Yc(i), o = (0, $1rqx5.nt).fromLngLat(a), s = new (0, $1rqx5.nt)(o.x, (0, $1rqx5.Bn)(o.y, 0, .999999999)), c = $834619e78bbf578c$var$Tc(e1.index, e1.exaggeration, s.x, s.y), l = Math.abs(a.lat) > 85.051129 ? 0 : c.elevation;
    return {
        sample: {
            ...c,
            elevation: l
        },
        radius: r,
        mercator: s
    };
}
function $834619e78bbf578c$var$xl(e1, t) {
    let { sample: n, radius: r } = $834619e78bbf578c$var$bl(e1, t);
    return $834619e78bbf578c$var$Ec(n, (r - 1) * (0, $1rqx5.ut));
}
function $834619e78bbf578c$var$Sl(e1, t) {
    let n = $834619e78bbf578c$var$Kc(e1);
    return (0, $1rqx5.ci)(n, n, 1 + t / (0, $1rqx5.ut));
}
function $834619e78bbf578c$var$Cl(e1, t, n) {
    let r = (0, $1rqx5.di)((0, $1rqx5.Gn)(), n, e1);
    return (0, $1rqx5.ei)(r, t);
}
var $834619e78bbf578c$var$wl = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, n = !0) {
        this._helper.resize(e1, t, n);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    get isGlobeRendering() {
        return this._globeness > 0;
    }
    setTransitionState(e1) {
        this._globeness = e1, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
    }
    get currentTransform() {
        return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
    }
    constructor(e1){
        this._globeness = 1, this.defaultConstrain = (e1, t)=>this.currentTransform.defaultConstrain(e1, t), this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $834619e78bbf578c$var$_c({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._globeness = 1, this._mercatorTransform = new $834619e78bbf578c$var$Oc(void 0, this._helper), this._verticalPerspectiveTransform = new $834619e78bbf578c$var$yl(void 0, this._helper);
    }
    clone() {
        let t = new e1;
        return t._globeness = this._globeness, t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t);
    }
    get projectionMatrix() {
        return this.currentTransform.projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this.currentTransform.modelViewProjectionMatrix;
    }
    get inverseProjectionMatrix() {
        return this.currentTransform.inverseProjectionMatrix;
    }
    get cameraPosition() {
        return this.currentTransform.cameraPosition;
    }
    getProjectionData(e1) {
        let t = this._mercatorTransform.getProjectionData(e1), n = this._verticalPerspectiveTransform.getProjectionData(e1);
        return {
            mainMatrix: this.isGlobeRendering ? n.mainMatrix : t.mainMatrix,
            clippingPlane: n.clippingPlane,
            tileMercatorCoords: n.tileMercatorCoords,
            projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
            fallbackMatrix: t.fallbackMatrix,
            clipAntimeridian: n.clipAntimeridian
        };
    }
    isLocationOccluded(e1, t, n) {
        return this.currentTransform.isLocationOccluded(e1, t, n);
    }
    transformLightDirection(e1) {
        return this.currentTransform.transformLightDirection(e1);
    }
    getPixelScale() {
        return (0, $1rqx5.mr)(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
    }
    getCircleRadiusCorrection() {
        return (0, $1rqx5.mr)(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
    }
    getPitchedTextCorrection(e1, t, n) {
        let r = this._mercatorTransform.getPitchedTextCorrection(e1, t, n), i = this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, t, n);
        return (0, $1rqx5.mr)(r, i, this._globeness);
    }
    projectTileCoordinates(e1, t, n, r) {
        return this.currentTransform.projectTileCoordinates(e1, t, n, r);
    }
    _calcMatrices() {
        this._helper._width && this._helper._height && (this._verticalPerspectiveTransform._calcMatrices(), this._mercatorTransform._calcMatrices(this.autoCalculateNearFarZ && !this.isGlobeRendering));
    }
    calculateFogMatrix(e1) {
        return this.currentTransform.calculateFogMatrix(e1);
    }
    getVisibleUnwrappedCoordinates(e1) {
        return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
    }
    getCameraFrustum() {
        return this.currentTransform.getCameraFrustum();
    }
    getClippingPlane() {
        return this.currentTransform.getClippingPlane();
    }
    getCoveringTilesDetailsProvider() {
        return this.currentTransform.getCoveringTilesDetailsProvider();
    }
    recalculateZoomAndCenter(e1) {
        this.currentTransform.recalculateZoomAndCenter(e1);
    }
    maxPitchScaleFactor() {
        return this._mercatorTransform.maxPitchScaleFactor();
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return this.currentTransform.getCameraAltitude();
    }
    getCameraLngLat() {
        return this.currentTransform.getCameraLngLat();
    }
    populateCache(e1) {
        this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
    }
    getBounds() {
        return this.currentTransform.getBounds();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        return this.currentTransform.calculateCameraOptionsFromTo(e1, t, n, r);
    }
    setLocationAtPoint(e1, t, n) {
        this.currentTransform.setLocationAtPoint(e1, t, n);
    }
    locationToScreenPoint(e1, t) {
        return this.currentTransform.locationToScreenPoint(e1, t);
    }
    screenPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenTerrainPointToMercatorCoordinate(e1, t);
    }
    screenPointToLocation(e1, t) {
        return this.currentTransform.screenPointToLocation(e1, t);
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.currentTransform.screenPointToLocationAtElevation(e1, t);
    }
    isPointOnMapSurface(e1, t) {
        return this.currentTransform.isPointOnMapSurface(e1, t);
    }
    getRayDirectionFromPixel(e1) {
        return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this._mercatorTransform.getProjectionDataForCustomLayer(e1);
        if (!this.isGlobeRendering) return t;
        let n = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e1);
        return n.fallbackMatrix = t.mainMatrix, n.projectionTransition = this._globeness, n;
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
    }
}, $834619e78bbf578c$var$Tl = class e1 {
    get useGlobeControls() {
        return !0;
    }
    handlePanInertia(e1, t) {
        let n = $834619e78bbf578c$var$sl(e1, t);
        return Math.abs(n.lng - t.center.lng) > 180 && (n.lng = t.center.lng + 179.5 * Math.sign(n.lng - t.center.lng)), {
            easingCenter: n,
            easingOffset: new (0, $1rqx5.Li)(0, 0)
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        let n = e1.around, r = t.screenPointToLocation(n);
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta);
        let i = t.zoom;
        e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
        let a = t.zoom - i;
        if (a === 0) return;
        let o = (0, $1rqx5.Xn)(t.center.lng, r.lng), s = o / (Math.abs(o / 180) + 1), c = (0, $1rqx5.Xn)(t.center.lat, r.lat), l = t.getRayDirectionFromPixel(n), d = t.cameraPosition, f = (0, $1rqx5.ei)(d, l) * -1, p = (0, $1rqx5.Gn)();
        (0, $1rqx5.Xr)(p, d, [
            l[0] * f,
            l[1] * f,
            l[2] * f
        ]);
        let m = (0, $1rqx5.ni)(p), h = m - 1, g = Math.exp(-Math.max(h - .3, 0) * .5), _ = (0, $1rqx5.wr)(m, .95, .999, 0, 1), v = $834619e78bbf578c$var$qc(t.worldSize, t.center.lat) / Math.min(t.width, t.height), y = (0, $1rqx5.wr)(v, .9, .5, 1, .25), b = Math.min(g, (0, $1rqx5.mr)(1, y, _)), x = (1 - (0, $1rqx5.Fr)(-a)) * b, S = t.center.lat, C = t.zoom, w = new (0, $1rqx5.lt)(t.center.lng + s * x, (0, $1rqx5.Bn)(t.center.lat + c * x, -(0, $1rqx5.Fn), (0, $1rqx5.Fn)));
        t.setLocationAtPoint(r, n);
        let T = t.center, E = (0, $1rqx5.wr)(Math.abs(o), 45, 85, 0, 1), D = Math.max(E, _) ** .25, O = (0, $1rqx5.Xn)(T.lng, w.lng), j = (0, $1rqx5.Xn)(T.lat, w.lat);
        t.setCenter(new (0, $1rqx5.lt)(T.lng + O * D, T.lat + j * D).wrap()), t.setZoom(C + $834619e78bbf578c$var$al(S, t.center.lat));
    }
    handleMapControlsPan(e1, t, n) {
        e1.panDelta && $834619e78bbf578c$var$el(t, n, t.isPointOnMapSurface(e1.around) ? e1.around : t.centerPoint, e1.panDelta);
    }
    cameraForBoxAndBearing(t, n, r, i, a) {
        let o = $834619e78bbf578c$var$Pc(t, n, r, i, a);
        if (!o) return;
        let s = n.left / a.width * 2 - 1, c = (a.width - n.right) / a.width * 2 - 1, l = n.top / a.height * -2 + 1, u = (a.height - n.bottom) / a.height * -2 + 1, d = (0, $1rqx5.Xn)(r.getWest(), r.getEast()) < 0, f = d ? r.getEast() : r.getWest(), p = d ? r.getWest() : r.getEast(), m = Math.max(r.getNorth(), r.getSouth()), h = Math.min(r.getNorth(), r.getSouth()), g = f + (0, $1rqx5.Xn)(f, p) * .5, _ = m + (0, $1rqx5.Xn)(m, h) * .5, v = a.clone();
        v.setCenter(o.center), v.setBearing(o.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(o.zoom);
        let y = v.modelViewProjectionMatrix, x = [
            $834619e78bbf578c$var$Kc(r.getNorthWest()),
            $834619e78bbf578c$var$Kc(r.getNorthEast()),
            $834619e78bbf578c$var$Kc(r.getSouthWest()),
            $834619e78bbf578c$var$Kc(r.getSouthEast()),
            $834619e78bbf578c$var$Kc(new (0, $1rqx5.lt)(p, _)),
            $834619e78bbf578c$var$Kc(new (0, $1rqx5.lt)(f, _)),
            $834619e78bbf578c$var$Kc(new (0, $1rqx5.lt)(g, m)),
            $834619e78bbf578c$var$Kc(new (0, $1rqx5.lt)(g, h))
        ], S = $834619e78bbf578c$var$Kc(o.center), C = 1 / 0;
        for (let t of x)s < 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `x`, s))), c > 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `x`, c))), l > 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `y`, l))), u < 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `y`, u)));
        if (!Number.isFinite(C) || C === 0) {
            $834619e78bbf578c$var$Mc();
            return;
        }
        return o.zoom = Math.min(v.zoom + (0, $1rqx5.Dr)(C), t.maxZoom), o;
    }
    handleJumpToCenterZoom(e1, t) {
        let n = e1.center.lat, r = e1.applyConstrain(t.center ? (0, $1rqx5.lt).convert(t.center) : e1.center, e1.zoom).center;
        e1.setCenter(r.wrap());
        let i = t.zoom === void 0 ? e1.zoom + $834619e78bbf578c$var$al(n, r.lat) : +t.zoom;
        e1.zoom !== i && e1.setZoom(i);
    }
    handleEaseTo(e1, t) {
        let n = e1.zoom, r = e1.center, i = e1.padding, a = {
            roll: e1.roll,
            pitch: e1.pitch,
            bearing: e1.bearing
        }, o = {
            roll: t.roll === void 0 ? e1.roll : t.roll,
            pitch: t.pitch === void 0 ? e1.pitch : t.pitch,
            bearing: t.bearing === void 0 ? e1.bearing : t.bearing
        }, s = t.zoom !== void 0, c = !e1.isPaddingEqual(t.padding), l = !1, d = t.center ? (0, $1rqx5.lt).convert(t.center) : r, f = e1.applyConstrain(d, n).center;
        $834619e78bbf578c$var$hc(e1, f);
        let p = e1.clone();
        p.setCenter(f), p.setZoom(s ? +t.zoom : n + $834619e78bbf578c$var$al(r.lat, d.lat)), p.setBearing(t.bearing);
        let m = new (0, $1rqx5.Li)((0, $1rqx5.Bn)(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), (0, $1rqx5.Bn)(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        p.setLocationAtPoint(f, m);
        let h = (t.offset && t.offsetAsPoint.mag()) > 0 ? p.center : f, g = s ? +t.zoom : n + $834619e78bbf578c$var$al(r.lat, h.lat), _ = n + $834619e78bbf578c$var$al(r.lat, 0), v = g + $834619e78bbf578c$var$al(h.lat, 0), y = (0, $1rqx5.Xn)(r.lng, h.lng), b = (0, $1rqx5.Xn)(r.lat, h.lat), x = (0, $1rqx5.Fr)(v - _);
        return l = g !== n, {
            easeFunc: (n)=>{
                if ((0, $1rqx5.Tr)(a, o) || $834619e78bbf578c$var$Nc({
                    startEulerAngles: a,
                    endEulerAngles: o,
                    tr: e1,
                    k: n,
                    useSlerp: a.roll != o.roll
                }), c && e1.interpolatePadding(i, t.padding, n), t.around) (0, $1rqx5.Nr)(`Easing around a point is not supported under globe projection.`), e1.setLocationAtPoint(t.around, t.aroundPoint);
                else {
                    let t = n * (v > _ ? Math.min(2, x) : Math.max(.5, x)) ** (1 - n), i = $834619e78bbf578c$var$ll(r, y, b, t);
                    e1.setCenter(i.wrap());
                }
                if (l) {
                    let t = (0, $1rqx5.un).number(_, v, n) + $834619e78bbf578c$var$al(0, e1.center.lat);
                    e1.setZoom(t);
                }
            },
            isZooming: l,
            elevationCenter: h
        };
    }
    handleFlyTo(e1, t) {
        let n = t.zoom !== void 0, r = e1.center, i = e1.zoom, a = e1.padding, o = !e1.isPaddingEqual(t.padding), s = e1.applyConstrain((0, $1rqx5.lt).convert(t.center || t.locationAtOffset), i).center, c = n ? +t.zoom : e1.zoom + $834619e78bbf578c$var$al(e1.center.lat, s.lat), l = e1.clone();
        l.setCenter(s), l.setZoom(c), l.setBearing(t.bearing);
        let d = new (0, $1rqx5.Li)((0, $1rqx5.Bn)(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), (0, $1rqx5.Bn)(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        l.setLocationAtPoint(s, d);
        let f = l.center;
        $834619e78bbf578c$var$hc(e1, f);
        let p = $834619e78bbf578c$var$Hc(e1, r, f), m = i + $834619e78bbf578c$var$al(r.lat, 0), h = c + $834619e78bbf578c$var$al(f.lat, 0), g = (0, $1rqx5.Fr)(h - m), _ = typeof t.minZoom == `number` ? +t.minZoom : e1.minZoom, v = Math.max(_, e1.minZoom) + $834619e78bbf578c$var$al(f.lat, 0), y = Math.min(v, m, h) + $834619e78bbf578c$var$al(0, f.lat), x = e1.applyConstrain(f, y).zoom + $834619e78bbf578c$var$al(f.lat, 0), S = (0, $1rqx5.Fr)(x - m), C = (0, $1rqx5.Xn)(r.lng, f.lng), w = (0, $1rqx5.Xn)(r.lat, f.lat);
        return {
            easeFunc: (n, i, s, l)=>{
                let u = $834619e78bbf578c$var$ll(r, C, w, s);
                o && e1.interpolatePadding(a, t.padding, n);
                let d = n === 1 ? f : u;
                e1.setCenter(d.wrap());
                let p = m + (0, $1rqx5.Dr)(i);
                e1.setZoom(n === 1 ? c : p + $834619e78bbf578c$var$al(0, d.lat));
            },
            scaleOfZoom: g,
            targetCenter: f,
            scaleOfMinZoom: S,
            pixelPathLength: p
        };
    }
    static solveVectorScale(e1, t, n, r, i) {
        let a = i, o = r === `x` ? [
            n[0],
            n[4],
            n[8],
            n[12]
        ] : [
            n[1],
            n[5],
            n[9],
            n[13]
        ], s = [
            n[3],
            n[7],
            n[11],
            n[15]
        ], c = e1[0] * o[0] + e1[1] * o[1] + e1[2] * o[2], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], u = t[0] * o[0] + t[1] * o[1] + t[2] * o[2], d = t[0] * s[0] + t[1] * s[1] + t[2] * s[2], f = (u + o[3] - a * d - a * s[3]) / (u - c - a * d + a * l);
        return u + a * l === c + a * d || s[3] * (c - u) + o[3] * (d - l) + c * d === u * l ? null : f;
    }
    static getLesserNonNegativeNonNull(e1, t) {
        return t !== null && t >= 0 && t < e1 ? t : e1;
    }
}, $834619e78bbf578c$var$El = class {
    constructor(e1){
        this._globe = e1, this._mercatorCameraHelper = new $834619e78bbf578c$var$Fc, this._verticalPerspectiveCameraHelper = new $834619e78bbf578c$var$Tl;
    }
    get useGlobeControls() {
        return this._globe.useGlobeRendering;
    }
    get currentHelper() {
        return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
    }
    handlePanInertia(e1, t) {
        return this.currentHelper.handlePanInertia(e1, t);
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
    }
    handleMapControlsPan(e1, t, n) {
        this.currentHelper.handleMapControlsPan(e1, t, n);
    }
    cameraForBoxAndBearing(e1, t, n, r, i) {
        return this.currentHelper.cameraForBoxAndBearing(e1, t, n, r, i);
    }
    handleJumpToCenterZoom(e1, t) {
        this.currentHelper.handleJumpToCenterZoom(e1, t);
    }
    handleEaseTo(e1, t) {
        return this.currentHelper.handleEaseTo(e1, t);
    }
    handleFlyTo(e1, t) {
        return this.currentHelper.handleFlyTo(e1, t);
    }
};
function $834619e78bbf578c$var$Dl(e1, t, n) {
    let r = {
        constrainOverride: t
    };
    if (Array.isArray(e1)) {
        let t = new $834619e78bbf578c$var$Bc({
            type: e1
        }, n);
        return {
            projection: t,
            transform: new $834619e78bbf578c$var$wl(r),
            cameraHelper: new $834619e78bbf578c$var$El(t)
        };
    }
    switch(e1){
        case `mercator`:
            return {
                projection: new $834619e78bbf578c$var$pc,
                transform: new $834619e78bbf578c$var$Oc(r),
                cameraHelper: new $834619e78bbf578c$var$Fc
            };
        case `globe`:
            {
                let e1 = new $834619e78bbf578c$var$Bc({
                    type: [
                        `interpolate`,
                        [
                            `linear`
                        ],
                        [
                            `zoom`
                        ],
                        11,
                        `vertical-perspective`,
                        12,
                        `mercator`
                    ]
                }, {});
                return {
                    projection: e1,
                    transform: new $834619e78bbf578c$var$wl(r),
                    cameraHelper: new $834619e78bbf578c$var$El(e1)
                };
            }
        case `vertical-perspective`:
            return {
                projection: new $834619e78bbf578c$var$zc,
                transform: new $834619e78bbf578c$var$yl(r),
                cameraHelper: new $834619e78bbf578c$var$Tl
            };
        default:
            return (0, $1rqx5.Nr)(`Unknown projection name: ${e1}. Falling back to mercator projection.`), {
                projection: new $834619e78bbf578c$var$pc,
                transform: new $834619e78bbf578c$var$Oc(r),
                cameraHelper: new $834619e78bbf578c$var$Fc
            };
    }
}
const $834619e78bbf578c$var$Ol = $834619e78bbf578c$var$Si();
var $834619e78bbf578c$export$d9e45bc13d335801 = class extends (0, $1rqx5.vn) {
    constructor(e1, t = {}){
        super(), this._rtlPluginLoaded = ()=>{
            for(let e1 in this.tileManagers){
                let t = this.tileManagers[e1].getSource().type;
                (t === `vector` || t === `geojson`) && this.tileManagers[e1].reload();
            }
        }, this.map = e1, this.dispatcher = new $834619e78bbf578c$var$ua($834619e78bbf578c$var$sa(), e1._getMapId()).setEventedParent(this), this.dispatcher.registerMessageHandler(`GG`, (e1, t)=>this.getGlyphs(e1, t)), this.dispatcher.registerMessageHandler(`GI`, (e1, t)=>this.getImages(e1, t)), this.dispatcher.registerMessageHandler(`GDA`, (e1, t)=>this.getDashes(e1, t)), this.imageManager = new $834619e78bbf578c$var$Di, this.imageManager.setEventedParent(this), this.imageManager.setMissingImageResolver(e1._missingStyleImageResolver), this.patternAtlas = new $834619e78bbf578c$var$Oi(this.imageManager);
        let n = e1._container?.lang || typeof document < `u` && document.documentElement?.lang || void 0;
        this.glyphManager = new $834619e78bbf578c$var$Ui(e1._requestManager, t.localIdeographFontFamily, n), this.lineAtlas = new $834619e78bbf578c$var$Xi(256, 512), this.crossTileSymbolIndex = new $834619e78bbf578c$var$ec, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast(`SR`, (0, $1rqx5.Cn)()), $834619e78bbf578c$var$_o().on($834619e78bbf578c$var$mo, this._rtlPluginLoaded), this.on(`data`, (e1)=>{
            if (e1.dataType !== `source` || e1.sourceDataType !== `metadata`) return;
            let t = this.tileManagers[e1.sourceId];
            if (!t) return;
            let n = t.getSource();
            if (n?.vectorLayerIds) for(let e1 in this._layers){
                let t = this._layers[e1];
                t.source === n.id && this._validateLayer(t);
            }
        });
    }
    _setInitialValues() {
        this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new (0, $1rqx5.tn), this._imagesListDirty = !1, this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this._symbolPlacementTriggered = !1, this._placedProjectionTransition = void 0, this.crossTileSymbolIndex = new (this.crossTileSymbolIndex?.constructor || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
    }
    setGlobalStateProperty(e1, t) {
        this._checkLoaded();
        let n = t === null ? this.stylesheet.state?.[e1]?.default ?? null : t;
        return this._setGlobalStateValues({
            [e1]: n
        }), this;
    }
    getGlobalState() {
        return this._globalState;
    }
    setGlobalState(e1) {
        this._checkLoaded();
        let t = {};
        for(let n in e1)t[n] = e1[n].default;
        this._setGlobalStateValues(t);
    }
    _setGlobalStateValues(e1) {
        let t = [];
        for(let n in e1)(0, $1rqx5.qn)(e1[n], this._globalState[n]) || t.push(n);
        if (t.length === 0) return;
        let n = {
            ...this._globalState
        };
        for (let n of t)this._globalState[n] = e1[n];
        this._applyGlobalStateChanges(t, n);
    }
    _applyGlobalStateChanges(e1, t) {
        let n = /* @__PURE__ */ new Set, r = {};
        for (let t of e1)r[t] = this._globalState[t];
        for(let r in this._layers){
            let i = this._layers[r];
            i.retainPriorGlobalState(e1, t);
            let a = i.getLayoutAffectingGlobalStateRefs(), o = i.getPaintAffectingGlobalStateRefs(), s = i.getVisibilityAffectingGlobalStateRefs();
            for (let t of e1){
                if (a.has(t) && n.add(i.source), o.has(t)) for (let { name: e1, value: n } of o.get(t))this._updatePaintProperty(i, e1, n, {
                    validate: !1
                });
                s?.has(t) && (i.recalculateVisibility(), this._updateLayer(i));
            }
        }
        let i = {
            now: $834619e78bbf578c$export$461939dd4422153(),
            transition: this.getTransition()
        };
        this.light?.applyGlobalStateChange(e1, t, i), this.sky?.applyGlobalStateChange(e1, t, i), this.dispatcher.broadcast(`UGS`, r);
        for(let e1 in this.tileManagers)n.has(e1) && (this._reloadSource(e1), this._changed = !0);
    }
    async loadURL(e1, t = {}, n) {
        this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`dataloading`)), t.validate = typeof t.validate != `boolean` || t.validate, this._loadStyleRequest = new AbortController;
        let r = this._loadStyleRequest;
        try {
            let i = await this.map._requestManager.transformRequest(e1, `Style`);
            (0, $1rqx5.Nn)(r.signal);
            let a = await (0, $1rqx5.Sn)(i, r);
            this._loadStyleRequest === r && (this._loadStyleRequest = null), this._load(a.data, t, n);
        } catch (e1) {
            this._loadStyleRequest === r && (this._loadStyleRequest = null), e1 && !r.signal.aborted && this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
        }
    }
    loadJSON(e1, t = {}, n) {
        this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`dataloading`)), this._frameRequest = new AbortController, $834619e78bbf578c$var$Rr.frameAsync(this._frameRequest, this.map._ownerWindow).then(()=>{
            this._frameRequest = null, t.validate = t.validate !== !1, this._load(e1, t, n);
        }).catch(()=>{});
    }
    loadEmpty() {
        this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`dataloading`)), this._load($834619e78bbf578c$var$Ol, {
            validate: !1
        });
    }
    _load(e1, t, n) {
        let r = t.transformStyle ? t.transformStyle(n, e1) : e1;
        if (!(t.validate && (0, $1rqx5.sn)(this, r))) {
            r = {
                ...r
            }, this._loaded = !0, this.stylesheet = r;
            for(let e1 in r.sources)this.addSource(e1, r.sources[e1], {
                validate: !1
            });
            r.sprite ? this._loadSprite(r.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(r.glyphs), this.glyphManager.setFontFaces(r[`font-faces`]), this._createLayers(), this.light = new $834619e78bbf578c$var$Ki(this.stylesheet.light ?? {}, this._globalState), this._setProjectionInternal(this.stylesheet.projection?.type || `mercator`), this.sky = new $834619e78bbf578c$var$Yi(this.stylesheet.sky, this._globalState), this.sky.setEventedParent(this), this.map.setTerrain(this.stylesheet.terrain ?? null, {
                validate: !1
            }), this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`data`)), this.fire(new $834619e78bbf578c$export$444e55cd0e2f4f3a);
        }
    }
    _createLayers() {
        let e1 = $834619e78bbf578c$var$li(this.stylesheet.layers);
        this.setGlobalState(this.stylesheet.state ?? null), this.dispatcher.broadcast(`SL`, e1), this._order = e1.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = null;
        for (let t of e1){
            let e1 = (0, $1rqx5._)(t, this._globalState);
            if (e1.setEventedParent(this, {
                layer: {
                    id: t.id
                }
            }), this._layers[t.id] = e1, (0, $1rqx5.Xt)(e1) && this.tileManagers[e1.source]) {
                let n = t.paint?.[`raster-fade-duration`] ?? e1.paint.get(`raster-fade-duration`);
                this.tileManagers[e1.source].setRasterFadeDuration(n);
            }
        }
    }
    async _loadSprite(e1, t = !1, n) {
        this.imageManager.setLoaded(!1);
        let r = new AbortController;
        this._spriteRequest = r;
        let i;
        try {
            let n = await $834619e78bbf578c$var$Ti(e1, this.map._requestManager, this.map.getPixelRatio(), r);
            if (!n) return;
            for(let e1 in n){
                let { loaded: r, removed: i } = this.imageManager.setSpriteImages(e1, n[e1]);
                this._markImagesChanged(i), t && this._markImagesChanged(r);
            }
        } catch (e1) {
            i = e1, r.signal.aborted || this.fire(new (0, $1rqx5.gn)(i));
        } finally{
            this._spriteRequest = null, this.imageManager.setLoaded(!0), t && (this._changed = !0), this.dispatcher.broadcast(`SI`, this.imageManager.listImages()), this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`data`)), n?.(i);
        }
    }
    _unloadSprite() {
        this._markImagesChanged(this.imageManager.removeAllSpriteImages()), this._imagesListDirty = !0, this._changed = !0, this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`data`));
    }
    _validateLayer(e1) {
        let t = this.tileManagers[e1.source];
        if (!t) return;
        let n = e1.sourceLayer;
        if (!n) return;
        let r = t.getSource();
        (r.type === `geojson` || r.vectorLayerIds && !r.vectorLayerIds.includes(n)) && this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Source layer "${n}" does not exist on source "${r.id}" as specified by style layer "${e1.id}".`)));
    }
    loaded() {
        if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
        for(let e1 in this.tileManagers)if (!this.tileManagers[e1].loaded()) return !1;
        return this.imageManager.isLoaded();
    }
    _serializeByIds(e1, t = !1) {
        let n = this._serializedAllLayers();
        if (!e1 || e1.length === 0) return Object.values(t ? (0, $1rqx5.Vn)(n) : n);
        let r = [];
        for (let i of e1)if (n[i]) {
            let e1 = t ? (0, $1rqx5.Vn)(n[i]) : n[i];
            r.push(e1);
        }
        return r;
    }
    _serializedAllLayers() {
        let e1 = this._serializedLayers;
        if (e1) return e1;
        e1 = this._serializedLayers = {};
        let t = Object.keys(this._layers);
        for (let n of t){
            let t = this._layers[n];
            t.type !== `custom` && (e1[n] = t.serialize());
        }
        return e1;
    }
    hasTransitions() {
        if (this.light?.hasTransition() || this.sky?.hasTransition() || this.projection?.hasTransition()) return !0;
        for(let e1 in this.tileManagers)if (this.tileManagers[e1].hasTransition()) return !0;
        for(let e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
        return !1;
    }
    _checkLoaded() {
        if (!this._loaded) throw Error(`Style is not done loading.`);
    }
    update(e1) {
        if (!this._loaded) return;
        let t = this._changed;
        if (t) {
            this._imagesListDirty &&= (this.dispatcher.broadcast(`SI`, this.imageManager.listImages()), !1);
            let t = Object.keys(this._updatedLayers), n = Object.keys(this._removedLayers);
            (t.length || n.length) && this._updateWorkerLayers(t, n);
            for(let e1 in this._updatedSources){
                let t = this._updatedSources[e1];
                if (t === `reload`) this._reloadSource(e1);
                else if (t === `clear`) this._clearSource(e1);
                else throw Error(`Invalid action ${t}`);
            }
            this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
            for(let t in this._updatedPaintProps)this._layers[t].updateTransitions(e1);
            this._resetUpdates();
        }
        let n = {};
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            n[e1] = t.used, t.used = !1;
        }
        let r = this.imageManager.listImages();
        for (let t of this._order){
            let n = this._layers[t];
            n.recalculate(e1, r), !n.isHidden(e1.zoom) && n.source && (this.tileManagers[n.source].used = !0);
        }
        for(let e1 in n){
            let t = this.tileManagers[e1];
            !!n[e1] != !!t.used && t.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `visibility`,
                sourceId: e1
            }));
        }
        this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, t && this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`data`));
    }
    _updateTilesForChangedImages() {
        let e1 = Object.keys(this._changedImages);
        if (e1.length) {
            for(let t in this.tileManagers)this.tileManagers[t].reloadTilesForDependencies([
                `icons`,
                `patterns`
            ], e1);
            this._changedImages = {};
        }
    }
    _updateTilesForChangedGlyphs() {
        if (this._glyphsDidChange) {
            for(let e1 in this.tileManagers)this.tileManagers[e1].reloadTilesForDependencies([
                `glyphs`
            ], [
                ``
            ]);
            this._glyphsDidChange = !1;
        }
    }
    _updateWorkerLayers(e1, t) {
        this.dispatcher.broadcast(`UL`, {
            layers: this._serializeByIds(e1, !1),
            removedIds: t
        });
    }
    _resetUpdates() {
        this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
    }
    setState(e1, t = {}) {
        this._checkLoaded();
        let n = this.serialize();
        if (e1 = t.transformStyle ? t.transformStyle(n, e1) : e1, (t.validate ?? !0) && (0, $1rqx5.sn)(this, e1)) return !1;
        e1 = (0, $1rqx5.Vn)(e1), e1.layers = $834619e78bbf578c$var$li(e1.layers);
        let r = $834619e78bbf578c$var$xi(n, e1), i = this._getOperationsToPerform(r);
        if (i.unimplemented.length > 0) throw Error(`Unimplemented: ${i.unimplemented.join(`, `)}.`);
        if (i.operations.length === 0) return !1;
        for (let e1 of i.operations)e1();
        return this.stylesheet = e1, this._serializedLayers = null, this.fire(new $834619e78bbf578c$export$444e55cd0e2f4f3a({
            style: this
        })), !0;
    }
    _getOperationsToPerform(e1) {
        let t = [], n = [];
        for (let r of e1)switch(r.command){
            case `setCenter`:
            case `setZoom`:
            case `setBearing`:
            case `setPitch`:
            case `setRoll`:
                continue;
            case `addLayer`:
                {
                    let [e1, n] = r.args;
                    t.push(()=>this.addLayer(e1, n));
                    break;
                }
            case `removeLayer`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.removeLayer(e1));
                    break;
                }
            case `setPaintProperty`:
                {
                    let [e1, n, i] = r.args;
                    t.push(()=>this.setPaintProperty(e1, n, i));
                    break;
                }
            case `setLayoutProperty`:
                {
                    let [e1, n, i] = r.args;
                    t.push(()=>this.setLayoutProperty(e1, n, i));
                    break;
                }
            case `setFilter`:
                {
                    let [e1, n] = r.args;
                    t.push(()=>this.setFilter(e1, n));
                    break;
                }
            case `addSource`:
                {
                    let [e1, n] = r.args;
                    t.push(()=>this.addSource(e1, n));
                    break;
                }
            case `removeSource`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.removeSource(e1));
                    break;
                }
            case `setLayerZoomRange`:
                {
                    let [e1, n, i] = r.args;
                    t.push(()=>this.setLayerZoomRange(e1, n, i));
                    break;
                }
            case `setLight`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setLight(e1));
                    break;
                }
            case `setGeoJSONSourceData`:
                {
                    let [e1, n] = r.args;
                    t.push(()=>this.setGeoJSONSourceData(e1, n));
                    break;
                }
            case `setGlyphs`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setGlyphs(e1));
                    break;
                }
            case `setFontFaces`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setFontFaces(e1));
                    break;
                }
            case `setSprite`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setSprite(e1));
                    break;
                }
            case `setTerrain`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.map.setTerrain(e1));
                    break;
                }
            case `setSky`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setSky(e1));
                    break;
                }
            case `setProjection`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setProjection(e1));
                    break;
                }
            case `setGlobalState`:
                {
                    let [e1] = r.args;
                    t.push(()=>this.setGlobalState(e1));
                    break;
                }
            case `setTransition`:
                t.push(()=>{});
                break;
            default:
                n.push(r.command);
        }
        return {
            operations: t,
            unimplemented: n
        };
    }
    addImage(e1, t) {
        if (this.getImage(e1)) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`An image named "${e1}" already exists.`)));
            return;
        }
        this.imageManager.addImage(e1, t), this._afterImageUpdated(e1);
    }
    updateImage(e1, t) {
        this.imageManager.updateImage(e1, t);
    }
    getImage(e1) {
        return this.imageManager.getImage(e1);
    }
    setMissingImageResolver(e1) {
        this.imageManager.setMissingImageResolver(e1);
    }
    removeImage(e1) {
        if (!this.getImage(e1)) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`An image named "${e1}" does not exist.`)));
            return;
        }
        this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
    }
    _markImagesChanged(e1) {
        for (let t of e1)this._changedImages[t] = !0;
    }
    _afterImageUpdated(e1) {
        this._changedImages[e1] = !0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`data`));
    }
    listImages() {
        return this._checkLoaded(), this.imageManager.listImages();
    }
    addSource(e1, t, n = {}) {
        if (this._checkLoaded(), this.tileManagers[e1] !== void 0) throw Error(`Source "${e1}" already exists.`);
        if (!t.type) throw Error(`The type property must be defined, but only the following properties were given: ${Object.keys(t).join(`, `)}.`);
        if ((0, $1rqx5.rn).has(t.type) && this._validate((0, $1rqx5.on).source, `sources.${e1}`, t, null, n)) return;
        this.map?._collectResourceTiming && (t.collectResourceTiming = !0);
        let r = this.tileManagers[e1] = new $834619e78bbf578c$var$Ko(e1, t, this.dispatcher);
        r.style = this, r.setEventedParent(this, ()=>({
                isSourceLoaded: r.loaded(),
                source: r.serialize(),
                sourceId: e1
            })), r.onAdd(this.map), this._changed = !0;
    }
    removeSource(e1) {
        if (this._checkLoaded(), this.tileManagers[e1] === void 0) throw Error(`There is no source with this ID=${e1}`);
        for(let t in this._layers)if (this._layers[t].source === e1) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Source "${e1}" cannot be removed while layer "${t}" is using it.`)));
        let t = this.tileManagers[e1];
        delete this.tileManagers[e1], delete this._updatedSources[e1], t.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `metadata`,
            sourceId: e1
        })), t.setEventedParent(null), t.onRemove(this.map), this._changed = !0;
    }
    setGeoJSONSourceData(e1, t) {
        if (this._checkLoaded(), this.tileManagers[e1] === void 0) throw Error(`There is no source with this ID=${e1}`);
        let n = this.tileManagers[e1].getSource();
        if (n.type !== `geojson`) throw Error(`geojsonSource.type is ${n.type}, which is !== 'geojson`);
        n.setData(t), this._changed = !0;
    }
    getSource(e1) {
        return this.tileManagers[e1]?.getSource();
    }
    addLayer(e1, t, n = {}) {
        this._checkLoaded();
        let r = e1.id;
        if (this.getLayer(r)) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Layer "${r}" already exists on this map.`)));
            return;
        }
        let i;
        if (e1.type === `custom`) {
            if ((0, $1rqx5.in)(this, (0, $1rqx5.y)(e1))) return;
            i = (0, $1rqx5._)(e1, this._globalState);
        } else {
            if (`source` in e1 && typeof e1.source == `object` && (this.addSource(r, e1.source), e1 = (0, $1rqx5.Vn)(e1), e1 = (0, $1rqx5.er)(e1, {
                source: r
            })), this._validate((0, $1rqx5.on).layer, `layers.${r}`, e1, {
                arrayIndex: -1
            }, n)) return;
            i = (0, $1rqx5._)(e1, this._globalState), this._validateLayer(i), i.setEventedParent(this, {
                layer: {
                    id: r
                }
            });
        }
        let a = t ? this._order.indexOf(t) : this._order.length;
        if (t && a === -1) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot add layer "${r}" before non-existing layer "${t}".`)));
            return;
        }
        if (this._order.splice(a, 0, r), this._layerOrderChanged = !0, this._layers[r] = i, this._removedLayers[r] && i.source && i.type !== `custom`) {
            let e1 = this._removedLayers[r];
            delete this._removedLayers[r], e1.type === i.type ? (this._updatedSources[i.source] = `reload`, this.tileManagers[i.source].pause()) : this._updatedSources[i.source] = `clear`;
        }
        this._updateLayer(i), i.onAdd && i.onAdd(this.map);
    }
    moveLayer(e1, t) {
        if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
            return;
        }
        if (e1 === t) return;
        if (t && !this._order.includes(t)) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot move layer "${e1}" before non-existing layer "${t}".`)));
            return;
        }
        let n = this._order.indexOf(e1);
        this._order.splice(n, 1);
        let r = t ? this._order.indexOf(t) : this._order.length;
        this._order.splice(r, 0, e1), this._layerOrderChanged = !0;
    }
    removeLayer(e1) {
        this._checkLoaded();
        let t = this._layers[e1];
        if (!t) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot remove non-existing layer "${e1}".`)));
            return;
        }
        t.setEventedParent(null);
        let n = this._order.indexOf(e1);
        this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = t, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], t.type === `symbol` && t.source && this.tileManagers[t.source]?.resetMaxContentElevation(), t.onRemove && t.onRemove(this.map);
    }
    getLayer(e1) {
        return this._layers[e1];
    }
    getLayersOrder() {
        return [
            ...this._order
        ];
    }
    hasLayer(e1) {
        return e1 in this._layers;
    }
    setLayerZoomRange(e1, t, n) {
        this._checkLoaded();
        let r = this.getLayer(e1);
        if (!r) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            return;
        }
        (r.minzoom !== t || r.maxzoom !== n) && (t != null && (r.minzoom = t), n != null && (r.maxzoom = n), this._updateLayer(r));
    }
    setFilter(e1, t, n = {}) {
        this._checkLoaded();
        let r = this.getLayer(e1);
        if (!r) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot filter non-existing layer "${e1}".`)));
            return;
        }
        if (!(0, $1rqx5.qn)(r.filter, t)) {
            if (t == null) {
                r.setFilter(void 0), this._updateLayer(r);
                return;
            }
            this._validate((0, $1rqx5.on).filter, `layers.${r.id}.filter`, t, null, n) || (r.setFilter((0, $1rqx5.Vn)(t)), this._updateLayer(r));
        }
    }
    getFilter(e1) {
        return (0, $1rqx5.Vn)(this.getLayer(e1).filter);
    }
    setLayoutProperty(e1, t, n, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot style non-existing layer "${e1}".`)));
            return;
        }
        (0, $1rqx5.qn)(i.getLayoutProperty(t), n) || (i.setLayoutProperty(t, n, r), this._updateLayer(i));
    }
    getLayoutProperty(e1, t) {
        let n = this.getLayer(e1);
        if (!n) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot get style of non-existing layer "${e1}".`)));
            return;
        }
        return n.getLayoutProperty(t);
    }
    setPaintProperty(e1, t, n, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Cannot style non-existing layer "${e1}".`)));
            return;
        }
        (0, $1rqx5.qn)(i.getPaintProperty(t), n) || this._updatePaintProperty(i, t, n, r);
    }
    _updatePaintProperty(e1, t, n, r = {}) {
        e1.setPaintProperty(t, n, r) && this._updateLayer(e1), (0, $1rqx5.Xt)(e1) && t === `raster-fade-duration` && this.tileManagers[e1.source].setRasterFadeDuration(n), this._changed = !0, this._updatedPaintProps[e1.id] = !0, e1.type === `symbol` && this.triggerSymbolPlacement(), this._serializedLayers = null;
    }
    getPaintProperty(e1, t) {
        return this.getLayer(e1).getPaintProperty(t);
    }
    setFeatureState(e1, t) {
        this._checkLoaded();
        let n = e1.source, r = e1.sourceLayer, i = this.tileManagers[n];
        if (i === void 0) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The source '${n}' does not exist in the map's style.`)));
            return;
        }
        let a = i.getSource().type;
        if (a === `geojson` && r) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`GeoJSON sources cannot have a sourceLayer parameter.`)));
            return;
        }
        if (a === `vector` && !r) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        if (e1.id === void 0) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The feature id parameter must be provided.`)));
            return;
        }
        let o = [
            `__proto__`,
            `constructor`,
            `prototype`
        ];
        if (t && Object.keys(t).some((e1)=>o.includes(e1))) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The feature state should not include one of the following keys: ${o}`)));
            return;
        }
        i.setFeatureState(r, e1.id, t);
    }
    removeFeatureState(e1, t) {
        this._checkLoaded();
        let n = e1.source, r = this.tileManagers[n];
        if (r === void 0) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The source '${n}' does not exist in the map's style.`)));
            return;
        }
        let i = r.getSource().type, a = i === `vector` ? e1.sourceLayer : void 0;
        if (i === `vector` && !a) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        if (t && typeof e1.id != `string` && typeof e1.id != `number`) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`A feature id is required to remove its specific state property.`)));
            return;
        }
        r.removeFeatureState(a, e1.id, t);
    }
    getFeatureState(e1) {
        this._checkLoaded();
        let t = e1.source, n = e1.sourceLayer, r = this.tileManagers[t];
        if (r === void 0) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The source '${t}' does not exist in the map's style.`)));
            return;
        }
        if (r.getSource().type === `vector` && !n) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        return e1.id === void 0 && this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The feature id parameter must be provided.`))), r.getFeatureState(n, e1.id);
    }
    getTransition() {
        return (0, $1rqx5.er)({
            duration: 300,
            delay: 0
        }, this.stylesheet?.transition);
    }
    serialize() {
        if (!this._loaded) return;
        let e1 = (0, $1rqx5.hr)(this.tileManagers, (e1)=>e1.serialize()), t = this._serializeByIds(this._order, !0), n = this.map.getTerrain() || void 0, r = this.stylesheet;
        return (0, $1rqx5.tr)({
            version: r.version,
            name: r.name,
            metadata: r.metadata,
            light: r.light,
            sky: r.sky,
            center: r.center,
            zoom: r.zoom,
            bearing: r.bearing,
            pitch: r.pitch,
            sprite: r.sprite,
            glyphs: r.glyphs,
            "font-faces": r[`font-faces`],
            transition: r.transition,
            projection: r.projection,
            state: r.state,
            sources: e1,
            layers: t,
            terrain: n
        }, (e1)=>e1 !== void 0);
    }
    _updateLayer(e1) {
        this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && this.tileManagers[e1.source].getSource().type !== `raster` && (this._updatedSources[e1.source] = `reload`, this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
    }
    _flattenAndSortRenderedFeatures(e1) {
        let t = (e1)=>this._layers[e1].type === `fill-extrusion`, n = {}, r = [];
        for(let i = this._order.length - 1; i >= 0; i--){
            let a = this._order[i];
            if (t(a)) {
                n[a] = i;
                for (let t of e1){
                    let e1 = t[a];
                    if (e1) for (let t of e1)r.push(t);
                }
            }
        }
        r.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
        let i = [];
        for(let a = this._order.length - 1; a >= 0; a--){
            let o = this._order[a];
            if (t(o)) for(let e1 = r.length - 1; e1 >= 0; e1--){
                let t = r[e1].feature;
                if (n[t.layer.id] < a) break;
                i.push(t), r.pop();
            }
            else for (let t of e1){
                let e1 = t[o];
                if (e1) for (let t of e1)i.push(t.feature);
            }
        }
        return i;
    }
    queryRenderedFeatures(e1, t, n) {
        t?.filter && this._validate((0, $1rqx5.on).filter, `queryRenderedFeatures.filter`, t.filter, null, t);
        let r = {};
        if (t?.layers) {
            if (!(Array.isArray(t.layers) || t.layers instanceof Set)) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`parameters.layers must be an Array or a Set of strings`))), [];
            for (let e1 of t.layers){
                let t = this._layers[e1];
                if (!t) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                r[t.source] = !0;
            }
        }
        let i = [];
        t.availableImages = this.imageManager.listImages();
        let a = this._serializedAllLayers(), o = t.layers instanceof Set ? t.layers : Array.isArray(t.layers) ? new Set(t.layers) : null, s = {
            ...t,
            layers: o,
            globalState: this._globalState
        };
        for(let o in this.tileManagers)(!t.layers || r[o]) && i.push($834619e78bbf578c$var$ha(this.tileManagers[o], this._layers, a, e1, s, n, this.map.terrain ? (e1, t, n)=>this.map.terrain.getElevation(e1, t, n) : void 0));
        return this.placement && i.push($834619e78bbf578c$var$ga(this._layers, a, this.tileManagers, e1, s, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(i);
    }
    querySourceFeatures(e1, t) {
        t?.filter && this._validate((0, $1rqx5.on).filter, `querySourceFeatures.filter`, t.filter, null, t);
        let n = this.tileManagers[e1];
        return n ? $834619e78bbf578c$var$_a(n, t ? {
            ...t,
            globalState: this._globalState
        } : {
            globalState: this._globalState
        }) : [];
    }
    getLight() {
        return this.light.getLight();
    }
    setLight(e1, t = {}) {
        this._checkLoaded();
        let n = this.light.getLight(), r = !1;
        for(let t in e1)if (!(0, $1rqx5.qn)(e1[t], n[t])) {
            r = !0;
            break;
        }
        if (!r) return;
        let i = {
            now: $834619e78bbf578c$export$461939dd4422153(),
            transition: (0, $1rqx5.er)({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.light.setLight(e1, t), this.light.updateTransitions(i);
    }
    getProjection() {
        return this.stylesheet?.projection;
    }
    setProjection(e1) {
        this._checkLoaded();
        let t = e1 ?? {
            type: `mercator`
        };
        if (this.stylesheet.projection = e1, this.projection) {
            if (this.projection.name === t.type) return;
            this.projection.destroy(), delete this.projection;
        }
        this._setProjectionInternal(t.type);
    }
    getSky() {
        return this.stylesheet?.sky;
    }
    setSky(e1, t = {}) {
        this._checkLoaded();
        let n = this.getSky(), r = !1;
        if (!e1 && !n) return;
        if (e1 && !n) r = !0;
        else if (!e1 && n) r = !0;
        else for(let t in e1)if (!(0, $1rqx5.qn)(e1[t], n[t])) {
            r = !0;
            break;
        }
        if (!r) return;
        let i = {
            now: $834619e78bbf578c$export$461939dd4422153(),
            transition: (0, $1rqx5.er)({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.sky.setSky(e1, t) && (this.stylesheet.sky = e1, this.sky.updateTransitions(i));
    }
    _setProjectionInternal(e1) {
        let t = $834619e78bbf578c$var$Dl(e1, this.map._camera?.transform.constrainOverride, this._globalState);
        this.projection = t.projection, this.map.migrateProjection(t.transform, t.cameraHelper);
        for(let e1 in this.tileManagers)this.tileManagers[e1].reload();
    }
    _validate(e1, t, n, r, i = {}) {
        return i.validate !== !1 && (0, $1rqx5.an)(this, e1, {
            key: t,
            style: this.serialize(),
            value: n,
            ...r
        }, i);
    }
    _remove(e1 = !0) {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null), $834619e78bbf578c$var$_o().off($834619e78bbf578c$var$mo, this._rtlPluginLoaded);
        for(let e1 in this._layers)this._layers[e1].setEventedParent(null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.imageManager.setEventedParent(null), this.setEventedParent(null), e1 && this.dispatcher.broadcast(`RM`, void 0), this.dispatcher.remove(e1);
    }
    _clearSource(e1) {
        this.tileManagers[e1].clearTiles();
    }
    _reloadSource(e1) {
        this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
    }
    _updateSources(e1) {
        for(let t in this.tileManagers)this.tileManagers[t].update(e1, this.map.terrain);
    }
    _generateCollisionBoxes() {
        for(let e1 in this.tileManagers)this._reloadSource(e1);
    }
    triggerSymbolPlacement() {
        this._symbolPlacementTriggered = !0;
    }
    _placementInputsChanged(e1, t, n) {
        let r = this.pauseablePlacement;
        return !r || this._symbolPlacementTriggered || this._placedProjectionTransition !== this.projection?.transitionState || r._showCollisionBoxes !== t || r.placement.collisionGroups.crossSourceCollisions !== n || r.placement.transform.renderWorldCopies !== e1.renderWorldCopies || !(0, $1rqx5.bi)(r.placement.transform.modelViewProjectionMatrix, e1.modelViewProjectionMatrix);
    }
    _updatePlacement(e1, t, n, r, i = !1) {
        let a = !1, o = !1, s = {};
        for (let t of this._order){
            let n = this._layers[t];
            if (n.type !== `symbol`) continue;
            if (!s[n.source]) {
                let e1 = this.tileManagers[n.source];
                s[n.source] = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t)).sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
            }
            let r = this.crossTileSymbolIndex.addLayer(n, s[n.source], e1.center.lng);
            a ||= r;
        }
        this.crossTileSymbolIndex.pruneUnusedLayers(this._order), i ||= this._layerOrderChanged || n === 0;
        let c = a || this._placementInputsChanged(e1, t, r), l = this.pauseablePlacement?.isDone() && !this.placement.stillRecent($834619e78bbf578c$export$461939dd4422153(), e1.zoom);
        if ((i || !this.pauseablePlacement || l && (c || this.placement.stale)) && (this._symbolPlacementTriggered = !1, this._placedProjectionTransition = this.projection?.transitionState, this.pauseablePlacement = new $834619e78bbf578c$var$Vs(e1, this.map.terrain, this._order, i, t, n, r, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? c && this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, s), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit($834619e78bbf578c$export$461939dd4422153()), o = !0), a && this.pauseablePlacement.placement.setStale()), o || a) for (let e1 of this._order){
            let t = this._layers[e1];
            t.type === `symbol` && this.placement.updateLayerOpacities(t, s[t.source]);
        }
        return !this.pauseablePlacement.isDone() || this.placement.hasTransitions($834619e78bbf578c$export$461939dd4422153());
    }
    _releaseSymbolFadeTiles() {
        for(let e1 in this.tileManagers)this.tileManagers[e1].releaseSymbolFadeTiles();
    }
    async getImages(e1, t) {
        let n = await this.imageManager.getImages(t.icons);
        this._updateTilesForChangedImages();
        let r = this.tileManagers[t.source];
        return r && r.setDependencies(t.tileID.key, t.type, t.icons), n;
    }
    async getGlyphs(e1, t) {
        let n = await this.glyphManager.getGlyphs(t.stacks), r = this.tileManagers[t.source];
        return r && r.setDependencies(t.tileID.key, t.type, [
            ``
        ]), n;
    }
    getGlyphsUrl() {
        return this.stylesheet.glyphs || null;
    }
    setGlyphs(e1, t = {}) {
        this._checkLoaded(), !(e1 && this._validate((0, $1rqx5.on).glyphs, `glyphs`, e1, null, t)) && (this._changed = !0, this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
    }
    getFontFaces() {
        return this.stylesheet[`font-faces`] || null;
    }
    setFontFaces(e1) {
        this._checkLoaded(), this._changed = !0, this._glyphsDidChange = !0, this.stylesheet[`font-faces`] = e1, this.glyphManager.setFontFaces(e1);
    }
    async getDashes(e1, t) {
        let n = {};
        for (let [e1, r] of Object.entries(t.dashes))n[e1] = this.lineAtlas.getDash(r.dasharray, r.round);
        return n;
    }
    addSprite(e1, t, n = {}, r) {
        this._checkLoaded();
        let i = [
            {
                id: e1,
                url: t
            }
        ], a = [
            ...$834619e78bbf578c$var$Ci(this.stylesheet.sprite),
            ...i
        ];
        this._validate((0, $1rqx5.on).sprite, `sprite`, a, null, n) || (this.stylesheet.sprite = a, this._loadSprite(i, !0, r));
    }
    removeSprite(e1) {
        this._checkLoaded();
        let t = $834619e78bbf578c$var$Ci(this.stylesheet.sprite);
        if (!t.find((t)=>t.id === e1)) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Sprite "${e1}" doesn't exists on this map.`)));
            return;
        }
        let n = this.imageManager.removeSpriteImages(e1);
        this._markImagesChanged(n), t.splice(t.findIndex((t)=>t.id === e1), 1), this.stylesheet.sprite = t.length > 0 ? t : void 0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $834619e78bbf578c$export$49025a11e3fe5bd0(`data`));
    }
    getSprite() {
        return $834619e78bbf578c$var$Ci(this.stylesheet.sprite);
    }
    setSprite(e1, t = {}, n) {
        this._checkLoaded(), !(e1 && this._validate((0, $1rqx5.on).sprite, `sprite`, e1, null, t)) && (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, n) : (this._unloadSprite(), n && n(null)));
    }
    destroy() {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this.patternAtlas.destroy()), this.glyphManager && this.glyphManager.destroy();
        for(let e1 in this._layers){
            let t = this._layers[e1];
            t.setEventedParent(null), t.onRemove && t.onRemove(this.map);
        }
        this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler(`GG`), this.dispatcher.unregisterMessageHandler(`GI`), this.dispatcher.unregisterMessageHandler(`GDA`), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
    }
};
const $834619e78bbf578c$var$Al = (0, $1rqx5.Yt)([
    {
        name: `a_pos`,
        type: `Int16`,
        components: 2
    },
    {
        name: `a_texture_pos`,
        type: `Int16`,
        components: 2
    }
]);
var $834619e78bbf578c$var$jl = class {
    constructor(){
        this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
    }
    bind(e1, t, n, r, i, a, o, s, c) {
        this.context = e1;
        let l = this.boundPaintVertexBuffers.length !== r.length;
        for(let e1 = 0; !l && e1 < r.length; e1++)this.boundPaintVertexBuffers[e1] !== r[e1] && (l = !0);
        !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== n || l || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s || this.boundDynamicVertexBuffer3 !== c ? this.freshBind(t, n, r, i, a, o, s, c) : e1.bindVertexArray.set(this.vao);
    }
    freshBind(e1, t, n, r, i, a, o, s) {
        let c = e1.numAttributes, l = this.context, u = l.gl;
        this.vao && this.destroy(), this.vao = l.createVertexArray(), l.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = n, this.boundIndexBuffer = r, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o, this.boundDynamicVertexBuffer3 = s, t.enableAttributes(u, e1);
        for (let t of n)t.enableAttributes(u, e1);
        a && a.enableAttributes(u, e1), o && o.enableAttributes(u, e1), s && s.enableAttributes(u, e1), t.bind(), t.setVertexAttribPointers(u, e1, i);
        for (let t of n)t.bind(), t.setVertexAttribPointers(u, e1, i);
        a && (a.bind(), a.setVertexAttribPointers(u, e1, i)), r && r.bind(), o && (o.bind(), o.setVertexAttribPointers(u, e1, i)), s && (s.bind(), s.setVertexAttribPointers(u, e1, i)), l.currentNumAttributes = c;
    }
    destroy() {
        this.vao &&= (this.context.deleteVertexArray(this.vao), null);
    }
};
const $834619e78bbf578c$var$Ml = (e1, t)=>({
        u_depth: new (0, $1rqx5.Mt)(e1, t.u_depth),
        u_terrain: new (0, $1rqx5.Mt)(e1, t.u_terrain)
    }), $834619e78bbf578c$var$Nl = (e1, t)=>({
        u_texture: new (0, $1rqx5.Mt)(e1, t.u_texture),
        u_ele_delta: new (0, $1rqx5.jt)(e1, t.u_ele_delta),
        u_fog_matrix: new (0, $1rqx5.zt)(e1, t.u_fog_matrix),
        u_fog_color: new (0, $1rqx5.It)(e1, t.u_fog_color),
        u_fog_ground_blend: new (0, $1rqx5.jt)(e1, t.u_fog_ground_blend),
        u_fog_ground_blend_opacity: new (0, $1rqx5.jt)(e1, t.u_fog_ground_blend_opacity),
        u_horizon_color: new (0, $1rqx5.It)(e1, t.u_horizon_color),
        u_horizon_fog_blend: new (0, $1rqx5.jt)(e1, t.u_horizon_fog_blend),
        u_is_globe_mode: new (0, $1rqx5.jt)(e1, t.u_is_globe_mode)
    }), $834619e78bbf578c$var$Pl = (e1, t)=>({
        u_ele_delta: new (0, $1rqx5.jt)(e1, t.u_ele_delta)
    }), $834619e78bbf578c$var$Fl = (e1, t, n, r, i)=>({
        u_texture: 0,
        u_ele_delta: e1,
        u_fog_matrix: t,
        u_fog_color: n ? n.properties.get(`fog-color`) : (0, $1rqx5.fn).white,
        u_fog_ground_blend: n ? n.properties.get(`fog-ground-blend`) : 1,
        u_fog_ground_blend_opacity: i ? 0 : n ? n.calculateFogBlendOpacity(r) : 0,
        u_horizon_color: n ? n.properties.get(`horizon-color`) : (0, $1rqx5.fn).white,
        u_horizon_fog_blend: n ? n.properties.get(`horizon-fog-blend`) : 1,
        u_is_globe_mode: +!!i
    }), $834619e78bbf578c$var$Il = (e1)=>({
        u_ele_delta: e1
    }), $834619e78bbf578c$var$Ll = {
    ProjectionUBO: 0,
    TerrainUBO: 1,
    FrameUBO: 2
};
function $834619e78bbf578c$var$Rl(e1, t) {
    for (let [n, r] of Object.entries($834619e78bbf578c$var$Ll)){
        let i = e1.getUniformBlockIndex(t, n);
        i !== e1.INVALID_INDEX && e1.uniformBlockBinding(t, i, r);
    }
}
const $834619e78bbf578c$var$zl = {
    float: [
        1,
        1
    ],
    int: [
        1,
        1
    ],
    vec2: [
        2,
        2
    ],
    vec4: [
        4,
        4
    ],
    mat4: [
        16,
        4
    ]
};
function $834619e78bbf578c$var$Bl(e1) {
    let t = {}, n = 0;
    for (let { name: r, type: i } of e1){
        let [e1, a] = $834619e78bbf578c$var$zl[i];
        n = Math.ceil(n / a) * a, t[r] = n, n += e1;
    }
    return {
        offsets: t,
        contentWords: n,
        sizeWords: Math.ceil(n / 4) * 4
    };
}
var $834619e78bbf578c$var$Vl = class {
    constructor(e1, t, n){
        this.context = e1, this.binding = t, this.contentWords = n.contentWords;
        let r = e1.gl;
        this.buffer = r.createBuffer(), r.bindBuffer(r.UNIFORM_BUFFER, this.buffer), r.bufferData(r.UNIFORM_BUFFER, n.sizeWords * 4, r.DYNAMIC_DRAW), this.uploaded = new Float32Array(n.sizeWords), this.pending = new Float32Array(n.sizeWords), this.uploadedWords = new Uint32Array(this.uploaded.buffer), this.pendingWords = new Uint32Array(this.pending.buffer), this.hasData = !1;
    }
    upload() {
        let e1 = this.context.gl, t = !this.hasData;
        if (!t) {
            let e1 = this.pendingWords, n = this.uploadedWords;
            for(let r = 0; r < this.contentWords; r++)if (e1[r] !== n[r]) {
                t = !0;
                break;
            }
        }
        if (!t) {
            this.bind();
            return;
        }
        e1.bindBufferBase(e1.UNIFORM_BUFFER, this.binding, this.buffer), this.context.boundUniformBuffers[this.binding] = this.buffer, e1.bufferData(e1.UNIFORM_BUFFER, this.pending, e1.DYNAMIC_DRAW), this.uploaded.set(this.pending), this.hasData = !0;
    }
    bind() {
        let e1 = this.context.boundUniformBuffers;
        if (e1[this.binding] === this.buffer) return;
        let t = this.context.gl;
        t.bindBufferBase(t.UNIFORM_BUFFER, this.binding, this.buffer), e1[this.binding] = this.buffer;
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $834619e78bbf578c$var$Hl = $834619e78bbf578c$var$Bl([
    {
        name: `u_projection_matrix`,
        type: `mat4`
    },
    {
        name: `u_projection_fallback_matrix`,
        type: `mat4`
    },
    {
        name: `u_projection_tile_mercator_coords`,
        type: `vec4`
    },
    {
        name: `u_projection_clipping_plane`,
        type: `vec4`
    },
    {
        name: `u_projection_transition`,
        type: `float`
    },
    {
        name: `u_projection_clip_antimeridian`,
        type: `int`
    }
]), $834619e78bbf578c$var$Ul = $834619e78bbf578c$var$Hl.offsets;
function $834619e78bbf578c$var$Wl(e1) {
    return new $834619e78bbf578c$var$Vl(e1, $834619e78bbf578c$var$Ll.ProjectionUBO, $834619e78bbf578c$var$Hl);
}
function $834619e78bbf578c$var$Gl(e1, t) {
    let n = e1.pending;
    n.set(t.mainMatrix, $834619e78bbf578c$var$Ul.u_projection_matrix), n.set(t.fallbackMatrix, $834619e78bbf578c$var$Ul.u_projection_fallback_matrix), n.set(t.tileMercatorCoords, $834619e78bbf578c$var$Ul.u_projection_tile_mercator_coords), n.set(t.clippingPlane, $834619e78bbf578c$var$Ul.u_projection_clipping_plane), n[$834619e78bbf578c$var$Ul.u_projection_transition] = t.projectionTransition, e1.pendingWords[$834619e78bbf578c$var$Ul.u_projection_clip_antimeridian] = +!!t.clipAntimeridian, e1.upload();
}
function $834619e78bbf578c$var$Kl(e1, t) {
    if (!t) {
        e1.projectionUniformBuffer.bind();
        return;
    }
    let n = t.uniformBufferKey;
    if (n === void 0) {
        $834619e78bbf578c$var$Gl(e1.projectionUniformBuffer, t);
        return;
    }
    let r = e1.keyedProjectionUniformBuffers.get(n);
    if (r) {
        r.bind();
        return;
    }
    let i = e1.freeProjectionUniformBuffers.pop() ?? $834619e78bbf578c$var$Wl(e1);
    e1.keyedProjectionUniformBuffers.set(n, i), $834619e78bbf578c$var$Gl(i, t);
}
function $834619e78bbf578c$var$ql(e1) {
    e1.freeProjectionUniformBuffers.push(...e1.keyedProjectionUniformBuffers.values()), e1.keyedProjectionUniformBuffers.clear();
}
function $834619e78bbf578c$var$Jl(e1) {
    e1.projectionUniformBuffer.destroy();
    for (let t of e1.keyedProjectionUniformBuffers.values())t.destroy();
    for (let t of e1.freeProjectionUniformBuffers)t.destroy();
}
const $834619e78bbf578c$var$Yl = $834619e78bbf578c$var$Bl([
    {
        name: `u_terrain_matrix`,
        type: `mat4`
    },
    {
        name: `u_terrain_unpack`,
        type: `vec4`
    },
    {
        name: `u_terrain_dim`,
        type: `float`
    },
    {
        name: `u_terrain_exaggeration`,
        type: `float`
    }
]), $834619e78bbf578c$var$Xl = $834619e78bbf578c$var$Yl.offsets;
function $834619e78bbf578c$var$Zl(e1) {
    return new $834619e78bbf578c$var$Vl(e1, $834619e78bbf578c$var$Ll.TerrainUBO, $834619e78bbf578c$var$Yl);
}
function $834619e78bbf578c$var$Ql(e1, t) {
    let n = e1.pending;
    n.set(t.u_terrain_matrix, $834619e78bbf578c$var$Xl.u_terrain_matrix), n.set(t.u_terrain_unpack, $834619e78bbf578c$var$Xl.u_terrain_unpack), n[$834619e78bbf578c$var$Xl.u_terrain_dim] = t.u_terrain_dim, n[$834619e78bbf578c$var$Xl.u_terrain_exaggeration] = t.u_terrain_exaggeration, e1.upload();
}
function $834619e78bbf578c$var$$l(e1) {
    let t = [];
    for (let n of e1){
        if (n === null) continue;
        let e1 = n.split(` `);
        t.push(e1.pop());
    }
    return t;
}
function $834619e78bbf578c$var$eu(e1, t) {
    let n = /* @__PURE__ */ new Set([
        e1.INT,
        e1.INT_VEC2,
        e1.INT_VEC3,
        e1.INT_VEC4,
        e1.UNSIGNED_INT,
        e1.UNSIGNED_INT_VEC2,
        e1.UNSIGNED_INT_VEC3,
        e1.UNSIGNED_INT_VEC4
    ]), r = /* @__PURE__ */ new Set, i = e1.getProgramParameter(t, e1.ACTIVE_ATTRIBUTES);
    for(let a = 0; a < i; a++){
        let i = e1.getActiveAttrib(t, a);
        i && n.has(i.type) && r.add(i.name);
    }
    return r;
}
var $834619e78bbf578c$var$tu = class {
    constructor(e1, t, n, r, i, a, o, s, c = []){
        let l = e1.gl;
        this.program = l.createProgram();
        let u = $834619e78bbf578c$var$$l(t.staticAttributes), d = n ? n.getBinderAttributes() : [], f = u.concat(d), p = $834619e78bbf578c$var$uc.prelude.staticUniforms ? $834619e78bbf578c$var$$l($834619e78bbf578c$var$uc.prelude.staticUniforms) : [], m = t.staticUniforms ? $834619e78bbf578c$var$$l(t.staticUniforms) : [], h = n ? n.getBinderUniforms() : [], g = p.concat(m).concat(h), _ = [];
        for (let e1 of g)_.includes(e1) || _.push(e1);
        let v = n ? n.defines() : [];
        v.unshift(`#version 300 es`), i && v.push(`#define OVERDRAW_INSPECTOR;`), a && v.push(`#define TERRAIN3D;`), s && v.push(s), c && v.push(...c);
        let y = v.concat($834619e78bbf578c$var$uc.prelude.fragmentSource, o.fragmentSource, t.fragmentSource).join(`
`), b = v.concat($834619e78bbf578c$var$uc.prelude.vertexSource, o.vertexSource, t.vertexSource).join(`
`), x = l.createShader(l.FRAGMENT_SHADER);
        if (l.isContextLost()) {
            this.failedToCreate = !0;
            return;
        }
        l.shaderSource(x, y), l.compileShader(x), l.attachShader(this.program, x);
        let S = l.createShader(l.VERTEX_SHADER);
        if (l.isContextLost()) {
            this.failedToCreate = !0;
            return;
        }
        l.shaderSource(S, b), l.compileShader(S), l.attachShader(this.program, S), this.attributes = {};
        let C = {};
        if (this.numAttributes = f.length, l.linkProgram(this.program), !l.getProgramParameter(this.program, l.LINK_STATUS)) {
            if (l.isContextLost()) {
                this.failedToCreate = !0;
                return;
            }
            throw l.getShaderParameter(x, l.COMPILE_STATUS) ? l.getShaderParameter(S, l.COMPILE_STATUS) ? Error(`Program failed to link: ${l.getProgramInfoLog(this.program)}`) : Error(`Could not compile vertex shader: ${l.getShaderInfoLog(S)}`) : Error(`Could not compile fragment shader: ${l.getShaderInfoLog(x)}`);
        }
        $834619e78bbf578c$var$Rl(l, this.program);
        let w = $834619e78bbf578c$var$eu(l, this.program);
        for (let e1 of f){
            if (!e1) continue;
            let t = l.getAttribLocation(this.program, e1);
            t >= 0 && (this.attributes[e1] = {
                location: t,
                isInteger: w.has(e1)
            });
        }
        l.deleteShader(S), l.deleteShader(x);
        for (let e1 of _)if (e1 && !C[e1]) {
            let t = l.getUniformLocation(this.program, e1);
            t && (C[e1] = t);
        }
        this.fixedUniforms = r(e1, C), this.terrainUniforms = $834619e78bbf578c$var$Ml(e1, C), this.binderUniforms = n ? n.getUniforms(e1, C) : [];
    }
    draw(e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v) {
        let y = e1.gl;
        if (this.failedToCreate) return;
        if (e1.program.set(this.program), e1.terrainUniformBuffer.bind(), e1.frameUniformBuffer.bind(), e1.setDepthMode(n), e1.setStencilMode(r), e1.setColorMode(i), e1.setCullFace(a), s) {
            e1.activeTexture.set(y.TEXTURE2), y.bindTexture(y.TEXTURE_2D, s.depthTexture), e1.activeTexture.set(y.TEXTURE3), y.bindTexture(y.TEXTURE_2D, s.texture);
            for(let e1 in this.terrainUniforms)this.terrainUniforms[e1].set(s[e1]);
            $834619e78bbf578c$var$Ql(e1.terrainUniformBuffer, s);
        }
        if ($834619e78bbf578c$var$Kl(e1, c), o) for(let e1 in this.fixedUniforms)this.fixedUniforms[e1].set(o[e1]);
        h && h.setUniforms(e1, this.binderUniforms, p, {
            zoom: m
        });
        let b = 0;
        switch(t){
            case y.LINES:
                b = 2;
                break;
            case y.TRIANGLES:
                b = 3;
                break;
            case y.LINE_STRIP:
                b = 1;
        }
        for (let n of f.get())n.vaos ||= {}, n.vaos[l] ||= new $834619e78bbf578c$var$jl, n.vaos[l].bind(e1, this, u, h ? h.getPaintVertexBuffers() : [], d, n.vertexOffset, g, _, v), y.drawElements(t, n.primitiveLength * b, y.UNSIGNED_SHORT, n.primitiveOffset * b * 2);
    }
};
function $834619e78bbf578c$var$nu(e1, t, n) {
    let r = 1 / (0, $1rqx5.Ir)(n, 1, t.transform.tileZoom), i = 2 ** n.tileID.overscaledZ, a = n.tileSize * 2 ** t.transform.tileZoom / i, o = a * (n.tileID.canonical.x + n.tileID.wrap * i), s = a * n.tileID.canonical.y;
    return {
        u_image: 0,
        u_texsize: n.imageAtlasTexture.size,
        u_scale: [
            r,
            e1.fromScale,
            e1.toScale
        ],
        u_fade: e1.t,
        u_pixel_coord_upper: [
            o >> 16,
            s >> 16
        ],
        u_pixel_coord_lower: [
            o & 65535,
            s & 65535
        ]
    };
}
function $834619e78bbf578c$var$ru(e1, t, n, r) {
    let i = n.patternAtlas.getPattern(e1.from.toString()), a = n.patternAtlas.getPattern(e1.to.toString()), { width: o, height: s } = n.patternAtlas.getPixelSize(), c = 2 ** r.tileID.overscaledZ, l = r.tileSize * 2 ** n.transform.tileZoom / c, u = l * (r.tileID.canonical.x + r.tileID.wrap * c), d = l * r.tileID.canonical.y;
    return {
        u_image: 0,
        u_pattern_tl_a: i.tl,
        u_pattern_br_a: i.br,
        u_pattern_tl_b: a.tl,
        u_pattern_br_b: a.br,
        u_texsize: [
            o,
            s
        ],
        u_mix: t.t,
        u_pattern_size_a: i.displaySize,
        u_pattern_size_b: a.displaySize,
        u_scale_a: t.fromScale,
        u_scale_b: t.toScale,
        u_tile_units_to_pixels: 1 / (0, $1rqx5.Ir)(r, 1, n.transform.tileZoom),
        u_pixel_coord_upper: [
            u >> 16,
            d >> 16
        ],
        u_pixel_coord_lower: [
            u & 65535,
            d & 65535
        ]
    };
}
const $834619e78bbf578c$var$iu = (e1, t)=>({
        u_lightpos: new (0, $1rqx5.Pt)(e1, t.u_lightpos),
        u_lightpos_globe: new (0, $1rqx5.Pt)(e1, t.u_lightpos_globe),
        u_lightintensity: new (0, $1rqx5.jt)(e1, t.u_lightintensity),
        u_lightcolor: new (0, $1rqx5.Pt)(e1, t.u_lightcolor),
        u_vertical_gradient: new (0, $1rqx5.jt)(e1, t.u_vertical_gradient),
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity),
        u_fill_translate: new (0, $1rqx5.Nt)(e1, t.u_fill_translate)
    }), $834619e78bbf578c$var$au = (e1, t)=>({
        u_lightpos: new (0, $1rqx5.Pt)(e1, t.u_lightpos),
        u_lightpos_globe: new (0, $1rqx5.Pt)(e1, t.u_lightpos_globe),
        u_lightintensity: new (0, $1rqx5.jt)(e1, t.u_lightintensity),
        u_lightcolor: new (0, $1rqx5.Pt)(e1, t.u_lightcolor),
        u_vertical_gradient: new (0, $1rqx5.jt)(e1, t.u_vertical_gradient),
        u_height_factor: new (0, $1rqx5.jt)(e1, t.u_height_factor),
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity),
        u_fill_translate: new (0, $1rqx5.Nt)(e1, t.u_fill_translate),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $1rqx5.Pt)(e1, t.u_scale),
        u_fade: new (0, $1rqx5.jt)(e1, t.u_fade)
    }), $834619e78bbf578c$var$ou = (e1, t, n, r)=>{
    let i = e1.style.light, a = i.getCartesianPosition(), o = (0, $1rqx5.Mi)();
    i.properties.get(`anchor`) === `viewport` && (0, $1rqx5.Ni)(o, e1.transform.bearingInRadians), (0, $1rqx5.fi)(a, a, o);
    let s = e1.transform.transformLightDirection(a), c = i.properties.get(`color`);
    return {
        u_lightpos: a,
        u_lightpos_globe: s,
        u_lightintensity: i.properties.get(`intensity`),
        u_lightcolor: [
            c.r,
            c.g,
            c.b
        ],
        u_vertical_gradient: +t,
        u_opacity: n,
        u_fill_translate: r
    };
}, $834619e78bbf578c$var$su = (e1, t, n, r, i, a, o)=>(0, $1rqx5.er)($834619e78bbf578c$var$ou(e1, t, n, r), $834619e78bbf578c$var$nu(a, e1, o), {
        u_height_factor: -(2 ** i.overscaledZ) / o.tileSize / 8
    }), $834619e78bbf578c$var$cu = (e1, t)=>({
        u_fill_translate: new (0, $1rqx5.Nt)(e1, t.u_fill_translate)
    }), $834619e78bbf578c$var$lu = (e1, t)=>({
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $1rqx5.Pt)(e1, t.u_scale),
        u_fade: new (0, $1rqx5.jt)(e1, t.u_fade),
        u_sdf_pattern: new (0, $1rqx5.Mt)(e1, t.u_sdf_pattern),
        u_fill_translate: new (0, $1rqx5.Nt)(e1, t.u_fill_translate)
    }), $834619e78bbf578c$var$uu = (e1, t)=>({
        u_fill_translate: new (0, $1rqx5.Nt)(e1, t.u_fill_translate)
    }), $834619e78bbf578c$var$du = (e1, t)=>({
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $1rqx5.Pt)(e1, t.u_scale),
        u_fade: new (0, $1rqx5.jt)(e1, t.u_fade),
        u_sdf_pattern: new (0, $1rqx5.Mt)(e1, t.u_sdf_pattern),
        u_fill_translate: new (0, $1rqx5.Nt)(e1, t.u_fill_translate)
    }), $834619e78bbf578c$var$fu = (e1, t, n, r, i)=>(0, $1rqx5.er)($834619e78bbf578c$var$nu(t, e1, n), {
        u_fill_translate: r,
        u_sdf_pattern: +!!i
    }), $834619e78bbf578c$var$pu = (e1)=>({
        u_fill_translate: e1
    }), $834619e78bbf578c$var$mu = (e1)=>({
        u_fill_translate: e1
    }), $834619e78bbf578c$var$hu = (e1, t, n, r, i)=>$834619e78bbf578c$var$fu(e1, t, n, r, i), $834619e78bbf578c$var$gu = (e1, t)=>({
        u_scale_with_map: new (0, $1rqx5.Mt)(e1, t.u_scale_with_map),
        u_pitch_with_map: new (0, $1rqx5.Mt)(e1, t.u_pitch_with_map),
        u_extrude_scale: new (0, $1rqx5.Nt)(e1, t.u_extrude_scale),
        u_globe_extrude_scale: new (0, $1rqx5.jt)(e1, t.u_globe_extrude_scale),
        u_translate: new (0, $1rqx5.Nt)(e1, t.u_translate)
    }), $834619e78bbf578c$var$_u = (e1, t, n, r, i)=>{
    let a = e1.transform, o, s, c = 0;
    if (n.paint.get(`circle-pitch-alignment`) === `map`) {
        let e1 = (0, $1rqx5.Ir)(t, 1, a.zoom);
        o = !0, s = [
            e1,
            e1
        ], c = e1 / ((0, $1rqx5.Lr) * 2 ** t.tileID.overscaledZ) * 2 * Math.PI * i;
    } else o = !1, s = a.pixelsToGLUnits;
    return {
        u_scale_with_map: +(n.paint.get(`circle-pitch-scale`) === `map`),
        u_pitch_with_map: +o,
        u_extrude_scale: s,
        u_globe_extrude_scale: c,
        u_translate: r
    };
}, $834619e78bbf578c$var$vu = (e1, t)=>({
        u_color: new (0, $1rqx5.It)(e1, t.u_color),
        u_overlay: new (0, $1rqx5.Mt)(e1, t.u_overlay),
        u_overlay_scale: new (0, $1rqx5.jt)(e1, t.u_overlay_scale)
    }), $834619e78bbf578c$var$yu = (e1, t = 1)=>({
        u_color: e1,
        u_overlay: 0,
        u_overlay_scale: t
    }), $834619e78bbf578c$var$bu = (e1, t)=>({
        u_extrude_scale: new (0, $1rqx5.jt)(e1, t.u_extrude_scale),
        u_intensity: new (0, $1rqx5.jt)(e1, t.u_intensity),
        u_globe_extrude_scale: new (0, $1rqx5.jt)(e1, t.u_globe_extrude_scale)
    }), $834619e78bbf578c$var$xu = (e1, t)=>({
        u_matrix: new (0, $1rqx5.zt)(e1, t.u_matrix),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_color_ramp: new (0, $1rqx5.Mt)(e1, t.u_color_ramp),
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity)
    }), $834619e78bbf578c$var$Su = (e1, t, n, r)=>{
    let i = (0, $1rqx5.Ir)(e1, 1, t) / ((0, $1rqx5.Lr) * 2 ** e1.tileID.overscaledZ) * 2 * Math.PI * r;
    return {
        u_extrude_scale: (0, $1rqx5.Ir)(e1, 1, t),
        u_intensity: n,
        u_globe_extrude_scale: i
    };
}, $834619e78bbf578c$var$Cu = (e1, t, n, r)=>{
    let i = (0, $1rqx5.vi)();
    return (0, $1rqx5.Ti)(i, 0, e1.width, e1.height, 0, 0, 1), {
        u_matrix: i,
        u_image: n,
        u_color_ramp: r,
        u_opacity: t.paint.get(`heatmap-opacity`)
    };
}, $834619e78bbf578c$var$wu = (e1, t)=>({
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_latrange: new (0, $1rqx5.Nt)(e1, t.u_latrange),
        u_exaggeration: new (0, $1rqx5.jt)(e1, t.u_exaggeration),
        u_altitudes: new (0, $1rqx5.Rt)(e1, t.u_altitudes),
        u_azimuths: new (0, $1rqx5.Rt)(e1, t.u_azimuths),
        u_accent: new (0, $1rqx5.It)(e1, t.u_accent),
        u_method: new (0, $1rqx5.Mt)(e1, t.u_method),
        u_shadows: new (0, $1rqx5.Lt)(e1, t.u_shadows),
        u_highlights: new (0, $1rqx5.Lt)(e1, t.u_highlights)
    }), $834619e78bbf578c$var$Tu = (e1, t)=>({
        u_matrix: new (0, $1rqx5.zt)(e1, t.u_matrix),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_dimension: new (0, $1rqx5.Nt)(e1, t.u_dimension),
        u_zoom: new (0, $1rqx5.jt)(e1, t.u_zoom),
        u_unpack: new (0, $1rqx5.Ft)(e1, t.u_unpack)
    }), $834619e78bbf578c$var$Eu = (e1, t, n)=>{
    let r = n.paint.get(`hillshade-accent-color`), i;
    switch(n.paint.get(`hillshade-method`)){
        case `basic`:
            i = 4;
            break;
        case `combined`:
            i = 1;
            break;
        case `igor`:
            i = 2;
            break;
        case `multidirectional`:
            i = 3;
            break;
        default:
            i = 0;
    }
    let a = n.getIlluminationProperties();
    for(let t = 0; t < a.directionRadians.length; t++)n.paint.get(`hillshade-illumination-anchor`) === `viewport` && (a.directionRadians[t] += e1.transform.bearingInRadians);
    return {
        u_image: 0,
        u_latrange: $834619e78bbf578c$var$Ou(e1, t.tileID),
        u_exaggeration: n.paint.get(`hillshade-exaggeration`),
        u_altitudes: a.altitudeRadians,
        u_azimuths: a.directionRadians,
        u_accent: r,
        u_method: i,
        u_highlights: a.highlightColor,
        u_shadows: a.shadowColor
    };
}, $834619e78bbf578c$var$Du = (e1, t)=>{
    let n = t.stride, r = (0, $1rqx5.vi)();
    return (0, $1rqx5.Ti)(r, 0, (0, $1rqx5.Lr), -(0, $1rqx5.Lr), 0, 0, 1), (0, $1rqx5.ji)(r, r, [
        0,
        -(0, $1rqx5.Lr),
        0
    ]), {
        u_matrix: r,
        u_image: 1,
        u_dimension: [
            n,
            n
        ],
        u_zoom: e1.overscaledZ,
        u_unpack: t.getUnpackVector()
    };
};
function $834619e78bbf578c$var$Ou(e1, t) {
    let n = 2 ** t.canonical.z, r = t.canonical.y;
    return [
        new (0, $1rqx5.nt)(0, r / n).toLngLat().lat,
        new (0, $1rqx5.nt)(0, (r + 1) / n).toLngLat().lat
    ];
}
const $834619e78bbf578c$var$ku = (e1, t)=>({
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_unpack: new (0, $1rqx5.Ft)(e1, t.u_unpack),
        u_dimension: new (0, $1rqx5.Nt)(e1, t.u_dimension),
        u_elevation_stops: new (0, $1rqx5.Mt)(e1, t.u_elevation_stops),
        u_color_stops: new (0, $1rqx5.Mt)(e1, t.u_color_stops),
        u_color_ramp_size: new (0, $1rqx5.Mt)(e1, t.u_color_ramp_size),
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity)
    }), $834619e78bbf578c$var$Au = (e1, t, n = 0)=>({
        u_image: 0,
        u_unpack: t.getUnpackVector(),
        u_dimension: [
            t.stride,
            t.stride
        ],
        u_elevation_stops: 1,
        u_color_stops: 4,
        u_color_ramp_size: n,
        u_opacity: e1.paint.get(`color-relief-opacity`)
    }), $834619e78bbf578c$var$ju = (e1, t)=>({
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1rqx5.jt)(e1, t.u_ratio)
    }), $834619e78bbf578c$var$Mu = (e1, t)=>({
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1rqx5.jt)(e1, t.u_ratio),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_image_height: new (0, $1rqx5.jt)(e1, t.u_image_height)
    }), $834619e78bbf578c$var$Nu = (e1, t)=>({
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_ratio: new (0, $1rqx5.jt)(e1, t.u_ratio),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_scale: new (0, $1rqx5.Pt)(e1, t.u_scale),
        u_fade: new (0, $1rqx5.jt)(e1, t.u_fade)
    }), $834619e78bbf578c$var$Pu = (e1, t)=>({
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1rqx5.jt)(e1, t.u_ratio),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_mix: new (0, $1rqx5.jt)(e1, t.u_mix),
        u_tileratio: new (0, $1rqx5.jt)(e1, t.u_tileratio),
        u_crossfade_from: new (0, $1rqx5.jt)(e1, t.u_crossfade_from),
        u_crossfade_to: new (0, $1rqx5.jt)(e1, t.u_crossfade_to),
        u_lineatlas_width: new (0, $1rqx5.jt)(e1, t.u_lineatlas_width),
        u_lineatlas_height: new (0, $1rqx5.jt)(e1, t.u_lineatlas_height)
    }), $834619e78bbf578c$var$Fu = (e1, t)=>({
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1rqx5.jt)(e1, t.u_ratio),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_image_height: new (0, $1rqx5.jt)(e1, t.u_image_height),
        u_tileratio: new (0, $1rqx5.jt)(e1, t.u_tileratio),
        u_crossfade_from: new (0, $1rqx5.jt)(e1, t.u_crossfade_from),
        u_crossfade_to: new (0, $1rqx5.jt)(e1, t.u_crossfade_to),
        u_image_dash: new (0, $1rqx5.Mt)(e1, t.u_image_dash),
        u_mix: new (0, $1rqx5.jt)(e1, t.u_mix),
        u_lineatlas_width: new (0, $1rqx5.jt)(e1, t.u_lineatlas_width),
        u_lineatlas_height: new (0, $1rqx5.jt)(e1, t.u_lineatlas_height)
    }), $834619e78bbf578c$var$Iu = (e1, t, n, r)=>{
    let i = e1.transform;
    return {
        u_translation: $834619e78bbf578c$var$Hu(e1, t, n),
        u_ratio: r / (0, $1rqx5.Ir)(t, 1, i.zoom)
    };
}, $834619e78bbf578c$var$Lu = (e1, t, n, r, i)=>(0, $1rqx5.er)($834619e78bbf578c$var$Iu(e1, t, n, r), {
        u_image: 0,
        u_image_height: i
    }), $834619e78bbf578c$var$Ru = (e1, t, n, r, i)=>{
    let a = e1.transform, o = $834619e78bbf578c$var$Vu(t, a);
    return {
        u_translation: $834619e78bbf578c$var$Hu(e1, t, n),
        u_texsize: t.imageAtlasTexture.size,
        u_ratio: r / (0, $1rqx5.Ir)(t, 1, a.zoom),
        u_image: 0,
        u_scale: [
            o,
            i.fromScale,
            i.toScale
        ],
        u_fade: i.t
    };
}, $834619e78bbf578c$var$zu = (e1, t, n, r, i)=>{
    let a = e1.transform, o = $834619e78bbf578c$var$Vu(t, a);
    return (0, $1rqx5.er)($834619e78bbf578c$var$Iu(e1, t, n, r), {
        u_tileratio: o,
        u_crossfade_from: i.fromScale,
        u_crossfade_to: i.toScale,
        u_image: 0,
        u_mix: i.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
}, $834619e78bbf578c$var$Bu = (e1, t, n, r, i, a)=>{
    let o = e1.transform, s = $834619e78bbf578c$var$Vu(t, o);
    return (0, $1rqx5.er)($834619e78bbf578c$var$Iu(e1, t, n, r), {
        u_image: 0,
        u_image_height: a,
        u_tileratio: s,
        u_crossfade_from: i.fromScale,
        u_crossfade_to: i.toScale,
        u_image_dash: 1,
        u_mix: i.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
};
function $834619e78bbf578c$var$Vu(e1, t) {
    return 1 / (0, $1rqx5.Ir)(e1, 1, t.tileZoom);
}
function $834619e78bbf578c$var$Hu(e1, t, n) {
    return (0, $1rqx5.jr)(e1.transform, t, n.paint.get(`line-translate`), n.paint.get(`line-translate-anchor`));
}
const $834619e78bbf578c$var$Uu = (e1, t)=>({
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity)
    }), $834619e78bbf578c$var$Wu = (e1, t)=>({
        u_image: t,
        u_opacity: e1
    }), $834619e78bbf578c$var$Gu = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $1rqx5.Mt)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $1rqx5.Mt)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $1rqx5.jt)(e1, t.u_size_t),
        u_size: new (0, $1rqx5.jt)(e1, t.u_size),
        u_rotate_symbol: new (0, $1rqx5.Mt)(e1, t.u_rotate_symbol),
        u_label_plane_matrix: new (0, $1rqx5.zt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $1rqx5.zt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $1rqx5.Mt)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $1rqx5.Mt)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $1rqx5.Mt)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $1rqx5.Mt)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_texture: new (0, $1rqx5.Mt)(e1, t.u_texture),
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_pitched_scale: new (0, $1rqx5.jt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $1rqx5.Mt)(e1, t.u_is_offset),
        u_height_anchor_ground: new (0, $1rqx5.Mt)(e1, t.u_height_anchor_ground)
    }), $834619e78bbf578c$var$Ku = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $1rqx5.Mt)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $1rqx5.Mt)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $1rqx5.jt)(e1, t.u_size_t),
        u_size: new (0, $1rqx5.jt)(e1, t.u_size),
        u_rotate_symbol: new (0, $1rqx5.Mt)(e1, t.u_rotate_symbol),
        u_label_plane_matrix: new (0, $1rqx5.zt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $1rqx5.zt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $1rqx5.Mt)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $1rqx5.Mt)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $1rqx5.Mt)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $1rqx5.Mt)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_texture: new (0, $1rqx5.Mt)(e1, t.u_texture),
        u_gamma_scale: new (0, $1rqx5.jt)(e1, t.u_gamma_scale),
        u_is_halo: new (0, $1rqx5.Mt)(e1, t.u_is_halo),
        u_is_plain: new (0, $1rqx5.Mt)(e1, t.u_is_plain),
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_pitched_scale: new (0, $1rqx5.jt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $1rqx5.Mt)(e1, t.u_is_offset),
        u_height_anchor_ground: new (0, $1rqx5.Mt)(e1, t.u_height_anchor_ground)
    }), $834619e78bbf578c$var$qu = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $1rqx5.Mt)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $1rqx5.Mt)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $1rqx5.jt)(e1, t.u_size_t),
        u_size: new (0, $1rqx5.jt)(e1, t.u_size),
        u_rotate_symbol: new (0, $1rqx5.Mt)(e1, t.u_rotate_symbol),
        u_label_plane_matrix: new (0, $1rqx5.zt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $1rqx5.zt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $1rqx5.Mt)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $1rqx5.Mt)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $1rqx5.Mt)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $1rqx5.Mt)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_texsize_icon: new (0, $1rqx5.Nt)(e1, t.u_texsize_icon),
        u_texture: new (0, $1rqx5.Mt)(e1, t.u_texture),
        u_texture_icon: new (0, $1rqx5.Mt)(e1, t.u_texture_icon),
        u_gamma_scale: new (0, $1rqx5.jt)(e1, t.u_gamma_scale),
        u_is_halo: new (0, $1rqx5.Mt)(e1, t.u_is_halo),
        u_translation: new (0, $1rqx5.Nt)(e1, t.u_translation),
        u_pitched_scale: new (0, $1rqx5.jt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $1rqx5.Mt)(e1, t.u_is_offset),
        u_height_anchor_ground: new (0, $1rqx5.Mt)(e1, t.u_height_anchor_ground)
    }), $834619e78bbf578c$var$Ju = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m)=>({
        u_is_size_zoom_constant: +(e1 === `constant` || e1 === `source`),
        u_is_size_feature_constant: +(e1 === `constant` || e1 === `camera`),
        u_size_t: t ? t.uSizeT : 0,
        u_size: t ? t.uSize : 0,
        u_rotate_symbol: +n,
        u_label_plane_matrix: s,
        u_coord_matrix: c,
        u_is_text: +u,
        u_pitch_with_map: +r,
        u_is_along_line: i,
        u_is_variable_anchor: a,
        u_texsize: d,
        u_texture: 0,
        u_translation: l,
        u_pitched_scale: f,
        u_is_offset: p,
        u_height_anchor_ground: +m
    }), $834619e78bbf578c$var$Yu = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h)=>{
    let g = o.transform;
    return (0, $1rqx5.er)($834619e78bbf578c$var$Ju(e1, t, n, r, i, a, o, s, c, l, u, d, p, m, h), {
        u_gamma_scale: r ? Math.cos(g.pitch * Math.PI / 180) * g.cameraToCenterDistance : 1,
        u_is_halo: +!!f,
        u_is_plain: 1
    });
}, $834619e78bbf578c$var$Xu = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m)=>(0, $1rqx5.er)($834619e78bbf578c$var$Yu(e1, t, n, r, i, a, o, s, c, l, !0, u, !0, f, p, m), {
        u_texsize_icon: d,
        u_texture_icon: 1
    }), $834619e78bbf578c$var$Zu = (e1, t)=>({
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity),
        u_color: new (0, $1rqx5.It)(e1, t.u_color)
    }), $834619e78bbf578c$var$Qu = (e1, t)=>({
        u_opacity: new (0, $1rqx5.jt)(e1, t.u_opacity),
        u_image: new (0, $1rqx5.Mt)(e1, t.u_image),
        u_pattern_tl_a: new (0, $1rqx5.Nt)(e1, t.u_pattern_tl_a),
        u_pattern_br_a: new (0, $1rqx5.Nt)(e1, t.u_pattern_br_a),
        u_pattern_tl_b: new (0, $1rqx5.Nt)(e1, t.u_pattern_tl_b),
        u_pattern_br_b: new (0, $1rqx5.Nt)(e1, t.u_pattern_br_b),
        u_texsize: new (0, $1rqx5.Nt)(e1, t.u_texsize),
        u_mix: new (0, $1rqx5.jt)(e1, t.u_mix),
        u_pattern_size_a: new (0, $1rqx5.Nt)(e1, t.u_pattern_size_a),
        u_pattern_size_b: new (0, $1rqx5.Nt)(e1, t.u_pattern_size_b),
        u_scale_a: new (0, $1rqx5.jt)(e1, t.u_scale_a),
        u_scale_b: new (0, $1rqx5.jt)(e1, t.u_scale_b),
        u_pixel_coord_upper: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1rqx5.Nt)(e1, t.u_pixel_coord_lower),
        u_tile_units_to_pixels: new (0, $1rqx5.jt)(e1, t.u_tile_units_to_pixels)
    }), $834619e78bbf578c$var$$u = (e1, t)=>({
        u_opacity: e1,
        u_color: t
    }), $834619e78bbf578c$var$ed = (e1, t, n, r, i)=>(0, $1rqx5.er)($834619e78bbf578c$var$ru(n, i, t, r), {
        u_opacity: e1
    }), $834619e78bbf578c$var$td = (e1, t)=>({
        u_sun_pos: new (0, $1rqx5.Pt)(e1, t.u_sun_pos),
        u_atmosphere_blend: new (0, $1rqx5.jt)(e1, t.u_atmosphere_blend),
        u_globe_position: new (0, $1rqx5.Pt)(e1, t.u_globe_position),
        u_globe_radius: new (0, $1rqx5.jt)(e1, t.u_globe_radius),
        u_inv_proj_matrix: new (0, $1rqx5.zt)(e1, t.u_inv_proj_matrix)
    }), $834619e78bbf578c$var$nd = (e1, t, n, r, i)=>({
        u_sun_pos: e1,
        u_atmosphere_blend: t,
        u_globe_position: n,
        u_globe_radius: r,
        u_inv_proj_matrix: i
    }), $834619e78bbf578c$var$rd = (e1, t)=>({
        u_sky_color: new (0, $1rqx5.It)(e1, t.u_sky_color),
        u_horizon_color: new (0, $1rqx5.It)(e1, t.u_horizon_color),
        u_horizon: new (0, $1rqx5.Nt)(e1, t.u_horizon),
        u_horizon_normal: new (0, $1rqx5.Nt)(e1, t.u_horizon_normal),
        u_sky_horizon_blend: new (0, $1rqx5.jt)(e1, t.u_sky_horizon_blend),
        u_sky_blend: new (0, $1rqx5.jt)(e1, t.u_sky_blend),
        u_inv_proj_matrix: new (0, $1rqx5.zt)(e1, t.u_inv_proj_matrix),
        u_globe_position: new (0, $1rqx5.Pt)(e1, t.u_globe_position),
        u_globe_radius: new (0, $1rqx5.jt)(e1, t.u_globe_radius),
        u_atmosphere_blend: new (0, $1rqx5.jt)(e1, t.u_atmosphere_blend)
    }), $834619e78bbf578c$var$id = (e1, t, n)=>{
    let r = Math.cos(t.rollInRadians), i = Math.sin(t.rollInRadians), a = (0, $1rqx5.Z)(t), o = t.getProjectionData({
        overscaledTileID: null,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }).projectionTransition, s = $834619e78bbf578c$var$Jc(t), c = $834619e78bbf578c$var$qc(t.worldSize, t.center.lat);
    return {
        u_sky_color: e1.properties.get(`sky-color`),
        u_horizon_color: e1.properties.get(`horizon-color`),
        u_horizon: [
            (t.width / 2 - a * i) * n,
            (t.height / 2 + a * r) * n
        ],
        u_horizon_normal: [
            -i,
            r
        ],
        u_sky_horizon_blend: e1.properties.get(`sky-horizon-blend`) * t.height / 2 * n,
        u_sky_blend: o,
        u_inv_proj_matrix: t.inverseProjectionMatrix,
        u_globe_position: s,
        u_globe_radius: c,
        u_atmosphere_blend: e1.properties.get(`atmosphere-blend`) * $834619e78bbf578c$var$dl((0, $1rqx5.ni)(s) - c, c)
    };
}, $834619e78bbf578c$var$ad = (e1, t)=>({}), $834619e78bbf578c$var$od = {
    fillExtrusion: $834619e78bbf578c$var$iu,
    fillExtrusionPattern: $834619e78bbf578c$var$au,
    fill: $834619e78bbf578c$var$cu,
    fillPattern: $834619e78bbf578c$var$lu,
    fillOutline: $834619e78bbf578c$var$uu,
    fillOutlinePattern: $834619e78bbf578c$var$du,
    circle: $834619e78bbf578c$var$gu,
    collisionBox: $834619e78bbf578c$var$ad,
    collisionCircle: $834619e78bbf578c$var$ad,
    debug: $834619e78bbf578c$var$vu,
    depth: $834619e78bbf578c$var$ad,
    clippingMask: $834619e78bbf578c$var$ad,
    heatmap: $834619e78bbf578c$var$bu,
    heatmapTexture: $834619e78bbf578c$var$xu,
    hillshade: $834619e78bbf578c$var$wu,
    hillshadePrepare: $834619e78bbf578c$var$Tu,
    colorRelief: $834619e78bbf578c$var$ku,
    line: $834619e78bbf578c$var$ju,
    lineGradient: $834619e78bbf578c$var$Mu,
    linePattern: $834619e78bbf578c$var$Nu,
    lineSDF: $834619e78bbf578c$var$Pu,
    lineGradientSDF: $834619e78bbf578c$var$Fu,
    layerOpacity: $834619e78bbf578c$var$Uu,
    raster: $834619e78bbf578c$var$Ua,
    symbolIcon: $834619e78bbf578c$var$Gu,
    symbolSDF: $834619e78bbf578c$var$Ku,
    symbolTextAndIcon: $834619e78bbf578c$var$qu,
    background: $834619e78bbf578c$var$Zu,
    backgroundPattern: $834619e78bbf578c$var$Qu,
    terrain: $834619e78bbf578c$var$Nl,
    terrainDepth: $834619e78bbf578c$var$Pl,
    atmosphere: $834619e78bbf578c$var$td,
    sky: $834619e78bbf578c$var$rd
};
var $834619e78bbf578c$var$sd = class {
    constructor(e1, t, n){
        this.context = e1;
        let r = e1.gl;
        this.buffer = r.createBuffer(), this.dynamicDraw = !!n, this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindElementBuffer.set(this.buffer);
    }
    updateData(e1) {
        let t = this.context.gl;
        if (!this.dynamicDraw) throw Error(`Attempted to update data while not in dynamic mode.`);
        this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $834619e78bbf578c$var$cd = {
    Int8: `BYTE`,
    Uint8: `UNSIGNED_BYTE`,
    Int16: `SHORT`,
    Uint16: `UNSIGNED_SHORT`,
    Int32: `INT`,
    Uint32: `UNSIGNED_INT`,
    Float32: `FLOAT`
};
var $834619e78bbf578c$var$ld = class {
    constructor(e1, t, n, r){
        this.length = t.length, this.attributes = n, this.itemSize = t.bytesPerElement, this.dynamicDraw = r, this.context = e1;
        let i = e1.gl;
        this.buffer = i.createBuffer(), e1.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindVertexBuffer.set(this.buffer);
    }
    updateData(e1) {
        if (e1.length !== this.length) throw Error(`Length of new data is ${e1.length}, which doesn't match current length of ${this.length}`);
        let t = this.context.gl;
        this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    enableAttributes(e1, t) {
        for (let n of this.attributes){
            let r = t.attributes[n.name];
            r !== void 0 && e1.enableVertexAttribArray(r.location);
        }
    }
    setVertexAttribPointers(e1, t, n) {
        for (let r of this.attributes){
            let i = t.attributes[r.name];
            if (i !== void 0) {
                let t = r.offset + this.itemSize * (n || 0);
                i.isInteger ? e1.vertexAttribIPointer(i.location, r.components, e1[$834619e78bbf578c$var$cd[r.type]], this.itemSize, t) : e1.vertexAttribPointer(i.location, r.components, e1[$834619e78bbf578c$var$cd[r.type]], !1, this.itemSize, t);
            }
        }
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
}, $834619e78bbf578c$var$X = class {
    constructor(e1){
        this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
    }
    get() {
        return this.current;
    }
    set(e1) {}
    getDefault() {
        return this.default;
    }
    setDefault() {
        this.set(this.default);
    }
}, $834619e78bbf578c$var$ud = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return (0, $1rqx5.fn).transparent;
    }
    set(e1) {
        let t = this.current;
        (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$dd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return 1;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$fd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return 0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$pd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return [
            !0,
            !0,
            !0,
            !0
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$md = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$hd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return 255;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$gd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 255
        };
    }
    set(e1) {
        let t = this.current;
        (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$_d = class extends $834619e78bbf578c$var$X {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.KEEP,
            e1.KEEP,
            e1.KEEP
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$vd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$yd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return [
            0,
            1
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$bd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$xd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return this.gl.LESS;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Sd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Cd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.ONE,
            e1.ZERO
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$wd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return (0, $1rqx5.fn).transparent;
    }
    set(e1) {
        let t = this.current;
        (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Td = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return this.gl.FUNC_ADD;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Ed = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Dd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return this.gl.BACK;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Od = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return this.gl.CCW;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$kd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Ad = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return this.gl.TEXTURE0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$jd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        let e1 = this.gl;
        return [
            0,
            0,
            e1.drawingBufferWidth,
            e1.drawingBufferHeight
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Md = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Nd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Pd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Fd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Id = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        let t = this.gl;
        t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Ld = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
    }
}, $834619e78bbf578c$var$Rd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return 4;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$zd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Bd = class extends $834619e78bbf578c$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Vd = class extends $834619e78bbf578c$var$X {
    constructor(e1, t){
        super(e1), this.context = e1, this.parent = t;
    }
    getDefault() {
        return null;
    }
}, $834619e78bbf578c$var$Hd = class extends $834619e78bbf578c$var$Vd {
    setDirty() {
        this.dirty = !0;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Ud = class extends $834619e78bbf578c$var$Vd {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Wd = class extends $834619e78bbf578c$var$Vd {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $834619e78bbf578c$var$Gd = class {
    constructor(e1, t, n, r, i){
        this.context = e1, this.width = t, this.height = n;
        let a = e1.gl, o = this.framebuffer = a.createFramebuffer();
        if (this.colorAttachment = new $834619e78bbf578c$var$Hd(e1, o), r) this.depthAttachment = i ? new $834619e78bbf578c$var$Wd(e1, o) : new $834619e78bbf578c$var$Ud(e1, o);
        else if (i) throw Error(`Stencil cannot be set without depth`);
    }
    destroy() {
        let e1 = this.context.gl, t = this.colorAttachment.get();
        if (t && e1.deleteTexture(t), this.depthAttachment) {
            let t = this.depthAttachment.get();
            t && e1.deleteRenderbuffer(t);
        }
        e1.deleteFramebuffer(this.framebuffer);
    }
};
const $834619e78bbf578c$var$Kd = $834619e78bbf578c$var$Bl([
    {
        name: `u_units_to_pixels`,
        type: `vec2`
    },
    {
        name: `u_world_size`,
        type: `vec2`
    },
    {
        name: `u_camera_to_center_distance`,
        type: `float`
    },
    {
        name: `u_symbol_fade_change`,
        type: `float`
    },
    {
        name: `u_aspect_ratio`,
        type: `float`
    },
    {
        name: `u_device_pixel_ratio`,
        type: `float`
    },
    {
        name: `u_viewport_size`,
        type: `vec2`
    },
    {
        name: `u_pixel_extrude_scale`,
        type: `vec2`
    },
    {
        name: `u_pitch`,
        type: `float`
    }
]), $834619e78bbf578c$var$qd = $834619e78bbf578c$var$Kd.offsets;
function $834619e78bbf578c$var$Jd(e1) {
    return new $834619e78bbf578c$var$Vl(e1, $834619e78bbf578c$var$Ll.FrameUBO, $834619e78bbf578c$var$Kd);
}
function $834619e78bbf578c$var$Yd(e1, t) {
    let n = e1.pending, { transform: r } = t, i = t.context.gl;
    n[$834619e78bbf578c$var$qd.u_units_to_pixels] = 1 / r.pixelsToGLUnits[0], n[$834619e78bbf578c$var$qd.u_units_to_pixels + 1] = 1 / r.pixelsToGLUnits[1], n[$834619e78bbf578c$var$qd.u_world_size] = i.drawingBufferWidth, n[$834619e78bbf578c$var$qd.u_world_size + 1] = i.drawingBufferHeight, n[$834619e78bbf578c$var$qd.u_camera_to_center_distance] = r.cameraToCenterDistance, n[$834619e78bbf578c$var$qd.u_symbol_fade_change] = t.options.fadeDuration ? t.symbolFadeChange : 1, n[$834619e78bbf578c$var$qd.u_aspect_ratio] = r.width / r.height, n[$834619e78bbf578c$var$qd.u_device_pixel_ratio] = t.pixelRatio, n[$834619e78bbf578c$var$qd.u_viewport_size] = r.width, n[$834619e78bbf578c$var$qd.u_viewport_size + 1] = r.height, n[$834619e78bbf578c$var$qd.u_pixel_extrude_scale] = 1 / r.width, n[$834619e78bbf578c$var$qd.u_pixel_extrude_scale + 1] = 1 / r.height, n[$834619e78bbf578c$var$qd.u_pitch] = r.pitch / 360 * 2 * Math.PI, e1.upload();
}
var $834619e78bbf578c$var$Xd = class {
    constructor(e1, t, n){
        this.blendFunction = e1, this.blendColor = t, this.mask = n;
    }
};
$834619e78bbf578c$var$Xd.Replace = [
    1,
    0
], $834619e78bbf578c$var$Xd.disabled = new $834619e78bbf578c$var$Xd($834619e78bbf578c$var$Xd.Replace, (0, $1rqx5.fn).transparent, [
    !1,
    !1,
    !1,
    !1
]), $834619e78bbf578c$var$Xd.unblended = new $834619e78bbf578c$var$Xd($834619e78bbf578c$var$Xd.Replace, (0, $1rqx5.fn).transparent, [
    !0,
    !0,
    !0,
    !0
]), $834619e78bbf578c$var$Xd.alphaBlended = new $834619e78bbf578c$var$Xd([
    1,
    771
], (0, $1rqx5.fn).transparent, [
    !0,
    !0,
    !0,
    !0
]);
var $834619e78bbf578c$var$Zd = class {
    constructor(e1){
        this.gl = e1, this.clearColor = new $834619e78bbf578c$var$ud(this), this.clearDepth = new $834619e78bbf578c$var$dd(this), this.clearStencil = new $834619e78bbf578c$var$fd(this), this.colorMask = new $834619e78bbf578c$var$pd(this), this.depthMask = new $834619e78bbf578c$var$md(this), this.stencilMask = new $834619e78bbf578c$var$hd(this), this.stencilFunc = new $834619e78bbf578c$var$gd(this), this.stencilOp = new $834619e78bbf578c$var$_d(this), this.stencilTest = new $834619e78bbf578c$var$vd(this), this.depthRange = new $834619e78bbf578c$var$yd(this), this.depthTest = new $834619e78bbf578c$var$bd(this), this.depthFunc = new $834619e78bbf578c$var$xd(this), this.blend = new $834619e78bbf578c$var$Sd(this), this.blendFunc = new $834619e78bbf578c$var$Cd(this), this.blendColor = new $834619e78bbf578c$var$wd(this), this.blendEquation = new $834619e78bbf578c$var$Td(this), this.cullFace = new $834619e78bbf578c$var$Ed(this), this.cullFaceSide = new $834619e78bbf578c$var$Dd(this), this.frontFace = new $834619e78bbf578c$var$Od(this), this.program = new $834619e78bbf578c$var$kd(this), this.activeTexture = new $834619e78bbf578c$var$Ad(this), this.viewport = new $834619e78bbf578c$var$jd(this), this.bindFramebuffer = new $834619e78bbf578c$var$Md(this), this.bindRenderbuffer = new $834619e78bbf578c$var$Nd(this), this.bindTexture = new $834619e78bbf578c$var$Pd(this), this.bindVertexBuffer = new $834619e78bbf578c$var$Fd(this), this.bindElementBuffer = new $834619e78bbf578c$var$Id(this), this.bindVertexArray = new $834619e78bbf578c$var$Ld(this), this.pixelStoreUnpack = new $834619e78bbf578c$var$Rd(this), this.pixelStoreUnpackPremultiplyAlpha = new $834619e78bbf578c$var$zd(this), this.pixelStoreUnpackFlipY = new $834619e78bbf578c$var$Bd(this), this.extTextureFilterAnisotropic = e1.getExtension(`EXT_texture_filter_anisotropic`), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), e1.getExtension(`EXT_color_buffer_half_float`), e1.getExtension(`EXT_color_buffer_float`), this.boundUniformBuffers = [], this.projectionUniformBuffer = $834619e78bbf578c$var$Wl(this), this.keyedProjectionUniformBuffers = /* @__PURE__ */ new Map, this.freeProjectionUniformBuffers = [], this.terrainUniformBuffer = $834619e78bbf578c$var$Zl(this), this.frameUniformBuffer = $834619e78bbf578c$var$Jd(this);
    }
    setDefault() {
        this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    setDirty() {
        this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0, this.boundUniformBuffers = [];
    }
    setCustomLayerDefaults() {
        this.unbindVAO(), this.cullFace.setDefault(), this.activeTexture.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    createIndexBuffer(e1, t) {
        return new $834619e78bbf578c$var$sd(this, e1, t);
    }
    createVertexBuffer(e1, t, n) {
        return new $834619e78bbf578c$var$ld(this, e1, t, n);
    }
    createRenderbuffer(e1, t, n) {
        let r = this.gl, i = r.createRenderbuffer();
        return this.bindRenderbuffer.set(i), r.renderbufferStorage(r.RENDERBUFFER, e1, t, n), this.bindRenderbuffer.set(null), i;
    }
    createFramebuffer(e1, t, n, r) {
        return new $834619e78bbf578c$var$Gd(this, e1, t, n, r);
    }
    clear({ color: e1, depth: t, stencil: n }) {
        let r = this.gl, i = 0;
        e1 && (i |= r.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
            !0,
            !0,
            !0,
            !0
        ])), t !== void 0 && (i |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
            0,
            1
        ]), this.clearDepth.set(t), this.depthMask.set(!0)), n !== void 0 && (i |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(n), this.stencilMask.set(255)), r.clear(i);
    }
    setCullFace(e1) {
        e1.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
    }
    setDepthMode(e1) {
        e1.func === this.gl.ALWAYS && !e1.mask ? this.depthTest.set(!1) : (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range));
    }
    setStencilMode(e1) {
        e1.test.func === this.gl.ALWAYS && !e1.mask ? this.stencilTest.set(!1) : (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
            e1.fail,
            e1.depthFail,
            e1.pass
        ]), this.stencilFunc.set({
            func: e1.test.func,
            ref: e1.ref,
            mask: e1.test.mask
        }));
    }
    setColorMode(e1) {
        (0, $1rqx5.qn)(e1.blendFunction, $834619e78bbf578c$var$Xd.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
    }
    createVertexArray() {
        return this.gl.createVertexArray();
    }
    deleteVertexArray(e1) {
        this.gl.deleteVertexArray(e1);
    }
    unbindVAO() {
        this.bindVertexArray.set(null);
    }
}, $834619e78bbf578c$var$Z = class {
    constructor(e1, t, n){
        this.func = e1, this.mask = t, this.range = n;
    }
};
$834619e78bbf578c$var$Z.ReadOnly = !1, $834619e78bbf578c$var$Z.ReadWrite = !0, $834619e78bbf578c$var$Z.disabled = new $834619e78bbf578c$var$Z(519, $834619e78bbf578c$var$Z.ReadOnly, [
    0,
    1
]);
const $834619e78bbf578c$var$Qd = 7680;
var $834619e78bbf578c$var$Q = class {
    constructor(e1, t, n, r, i, a){
        this.test = e1, this.ref = t, this.mask = n, this.fail = r, this.depthFail = i, this.pass = a;
    }
};
$834619e78bbf578c$var$Q.disabled = new $834619e78bbf578c$var$Q({
    func: 519,
    mask: 0
}, 0, 0, $834619e78bbf578c$var$Qd, $834619e78bbf578c$var$Qd, $834619e78bbf578c$var$Qd);
const $834619e78bbf578c$var$$d = 1029, $834619e78bbf578c$var$ef = 2305;
var $834619e78bbf578c$var$$ = class {
    constructor(e1, t, n){
        this.enable = e1, this.mode = t, this.frontFace = n;
    }
};
$834619e78bbf578c$var$$.disabled = new $834619e78bbf578c$var$$(!1, $834619e78bbf578c$var$$d, $834619e78bbf578c$var$ef), $834619e78bbf578c$var$$.backCCW = new $834619e78bbf578c$var$$(!0, $834619e78bbf578c$var$$d, $834619e78bbf578c$var$ef), $834619e78bbf578c$var$$.frontCCW = new $834619e78bbf578c$var$$(!0, 1028, $834619e78bbf578c$var$ef);
function $834619e78bbf578c$var$tf(e1, t, n) {
    let r = t?.transitionState ?? 0;
    return {
        currentPass: `offscreen`,
        currentLayer: 0,
        opaquePassCutoff: 1 / 0,
        depthRangeFor3D: [
            0,
            1
        ],
        isRenderingToTexture: !1,
        transform: e1,
        terrain: n,
        projectionTransition: r,
        isRenderingGlobe: r > 0
    };
}
function $834619e78bbf578c$var$nf(e1, t, n = {}) {
    let r = e1.transform.getProjectionData({
        overscaledTileID: t,
        aligned: n.aligned,
        applyGlobeMatrix: !e1.isRenderingToTexture,
        applyTerrainMatrix: n.applyTerrainMatrix ?? !0
    });
    return e1.isRenderingToTexture || (r.uniformBufferKey = n.aligned ? `${t.key}/aligned` : t.key), r;
}
function $834619e78bbf578c$var$rf(e1, t) {
    return e1.isRenderingToTexture ? null : e1.terrain?.getTerrainData(t) ?? null;
}
let $834619e78bbf578c$var$af;
function $834619e78bbf578c$var$of(e1, t, n, r, i, a) {
    let o = e1.context, s = o.gl, c = e1.useProgram(`collisionBox`), l = [], u = 0, d = 0;
    for (let f of r){
        let r = t.getTile(f).getBucket(n);
        if (!r) continue;
        let p = i ? r.textCollisionBox : r.iconCollisionBox, m = r.collisionCircleArray;
        m.length > 0 && (l.push({
            circleArray: m,
            circleOffset: d,
            coord: f
        }), u += m.length / 4, d = u), p && c.draw(o, s.LINES, $834619e78bbf578c$var$Z.disabled, $834619e78bbf578c$var$Q.disabled, e1.colorModeForRenderPass(), $834619e78bbf578c$var$$.disabled, null, $834619e78bbf578c$var$rf(a, f), $834619e78bbf578c$var$nf(a, f), n.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, null, e1.transform.zoom, null, null, p.collisionVertexBuffer);
    }
    if (!i || !l.length) return;
    let p = e1.useProgram(`collisionCircle`), m = new (0, $1rqx5.Ht);
    m.resize(u * 4), m._trim();
    let h = 0;
    for (let e1 of l)for(let t = 0; t < e1.circleArray.length / 4; t++){
        let n = t * 4, r = e1.circleArray[n + 0], i = e1.circleArray[n + 1], a = e1.circleArray[n + 2], o = e1.circleArray[n + 3];
        m.emplace(h++, r, i, a, o, 0), m.emplace(h++, r, i, a, o, 1), m.emplace(h++, r, i, a, o, 2), m.emplace(h++, r, i, a, o, 3);
    }
    (!$834619e78bbf578c$var$af || $834619e78bbf578c$var$af.length < u * 2) && ($834619e78bbf578c$var$af = $834619e78bbf578c$var$sf(u));
    let g = o.createIndexBuffer($834619e78bbf578c$var$af, !0), _ = o.createVertexBuffer(m, (0, $1rqx5.U).members, !0);
    for (let t of l)p.draw(o, s.TRIANGLES, $834619e78bbf578c$var$Z.disabled, $834619e78bbf578c$var$Q.disabled, e1.colorModeForRenderPass(), $834619e78bbf578c$var$$.disabled, null, $834619e78bbf578c$var$rf(a, t.coord), null, n.id, _, g, (0, $1rqx5.Bt).simpleSegment(0, t.circleOffset * 2, t.circleArray.length, t.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
    _.destroy(), g.destroy();
}
function $834619e78bbf578c$var$sf(e1) {
    let t = e1 * 2, n = new (0, $1rqx5.Kt);
    n.resize(t), n._trim();
    for(let e1 = 0; e1 < t; e1++){
        let t = e1 * 6;
        n.uint16[t + 0] = e1 * 4 + 0, n.uint16[t + 1] = e1 * 4 + 1, n.uint16[t + 2] = e1 * 4 + 2, n.uint16[t + 3] = e1 * 4 + 2, n.uint16[t + 4] = e1 * 4 + 3, n.uint16[t + 5] = e1 * 4 + 0;
    }
    return n;
}
const $834619e78bbf578c$var$cf = (0, $1rqx5.Si)(/* @__PURE__ */ new Float32Array(16));
function $834619e78bbf578c$var$lf(e1, t, n, r, i, a) {
    if (a.currentPass !== `translucent`) return;
    let o = $834619e78bbf578c$var$Q.disabled, s = e1.colorModeForRenderPass();
    (n._unevaluatedLayout.hasValue(`text-variable-anchor`) || n._unevaluatedLayout.hasValue(`text-variable-anchor-offset`)) && $834619e78bbf578c$var$df(r, e1, n, t, n.layout.get(`text-rotation-alignment`), n.layout.get(`text-pitch-alignment`), n.paint.get(`text-translate`), n.paint.get(`text-translate-anchor`), i), n.paint.get(`icon-opacity`).constantOr(1) !== 0 && $834619e78bbf578c$var$hf(e1, t, n, r, !1, n.paint.get(`icon-translate`), n.paint.get(`icon-translate-anchor`), n.layout.get(`icon-rotation-alignment`).constantOr(`viewport`), n.layout.get(`icon-pitch-alignment`), n.layout.get(`icon-keep-upright`), o, s, a), n.paint.get(`text-opacity`).constantOr(1) !== 0 && $834619e78bbf578c$var$hf(e1, t, n, r, !0, n.paint.get(`text-translate`), n.paint.get(`text-translate-anchor`), n.layout.get(`text-rotation-alignment`), n.layout.get(`text-pitch-alignment`), n.layout.get(`text-keep-upright`), o, s, a), t.map.showCollisionBoxes && ($834619e78bbf578c$var$of(e1, t, n, r, !0, a), $834619e78bbf578c$var$of(e1, t, n, r, !1, a));
}
function $834619e78bbf578c$var$uf(e1, t, n, r, i, a) {
    let { horizontalAlign: o, verticalAlign: s } = (0, $1rqx5.M)(e1), c = -(o - .5) * t, l = -(s - .5) * n;
    return new (0, $1rqx5.Li)((c / i + r[0]) * a, (l / i + r[1]) * a);
}
function $834619e78bbf578c$var$df(e1, t, n, r, a, o, s, c, l) {
    let u = t.transform, d = t.style.map.terrain, f = a === `map`, p = o === `map`;
    for (let a of e1){
        let e1 = r.getTile(a), o = e1.getBucket(n);
        if (!o?.text?.segments.get().length) continue;
        let m = o.textSizeData, h = (0, $1rqx5.A)(m, u.zoom), g = (0, $1rqx5.Ir)(e1, 1, t.transform.zoom), _ = $834619e78bbf578c$var$ts(f, t.transform, g), v = n.layout.get(`icon-text-fit`) !== `none` && o.hasIconData();
        if (h) {
            let t = 2 ** (u.zoom - e1.tileID.overscaledZ), r = d ? (e1, t)=>d.getElevation(a, e1, t) : void 0;
            $834619e78bbf578c$var$pf(o, f, p, l, u, _, t, h, v, (0, $1rqx5.jr)(u, e1, s, c), a.toUnwrapped(), r, n.layout.get(`symbol-height-anchor`) === `ground`);
        }
    }
}
function $834619e78bbf578c$var$ff(e1, t, n, r, i, a) {
    let o = t.tileAnchorPoint.add(new (0, $1rqx5.Li)(t.translation[0], t.translation[1]));
    if (t.pitchWithMap) {
        let e1 = r.mult(a);
        n || (e1 = e1.rotate(-i));
        let s = o.add(e1);
        return $834619e78bbf578c$var$as(s.x, s.y, t.pitchedLabelPlaneMatrix, $834619e78bbf578c$var$is(t, s.x, s.y)).point;
    }
    if (n) {
        let n = $834619e78bbf578c$var$ms(t.tileAnchorPoint.x + 1, t.tileAnchorPoint.y, t).point.sub(e1), i = Math.atan(n.y / n.x) + (n.x < 0 ? Math.PI : 0);
        return e1.add(r.rotate(i));
    }
    return e1.add(r);
}
function $834619e78bbf578c$var$pf(e1, t, n, r, i, a, o, s, c, l, u, d, f) {
    let m = e1.text.placedSymbolArray, h = e1.text.dynamicLayoutVertexArray, g = e1.icon.dynamicLayoutVertexArray, _ = {};
    h.clear();
    for(let g = 0; g < m.length; g++){
        let v = m.get(g), y = e1.allowVerticalPlacement && !v.placedOrientation, b = !v.hidden && v.crossTileID && !y ? r[v.crossTileID] : null;
        if (!b) $834619e78bbf578c$var$xs(v.numGlyphs, h);
        else {
            let r = new (0, $1rqx5.Li)(v.anchorX, v.anchorY), m = {
                getElevation: d,
                heightOffset: v.heightOffset,
                heightAnchorGround: f,
                width: i.width,
                height: i.height,
                pitchedLabelPlaneMatrix: a,
                lineVertexArray: null,
                pitchWithMap: n,
                transform: i,
                projectionCache: null,
                tileAnchorPoint: r,
                translation: l,
                unwrappedTileID: u
            }, g = n ? $834619e78bbf578c$var$gs(r.x, r.y, m) : $834619e78bbf578c$var$ms(r.x, r.y, m), y = $834619e78bbf578c$var$os(i.cameraToCenterDistance, g.signedDistanceFromCamera), x = (0, $1rqx5.k)(e1.textSizeData, s, v) * y / 24;
            n && (x *= e1.tilePixelRatio / o);
            let { width: S, height: C, anchor: w, textOffset: T, textBoxScale: E } = b, D = $834619e78bbf578c$var$uf(w, S, C, T, E, x), O = i.getPitchedTextCorrection(r.x + l[0], r.y + l[1], u), k = $834619e78bbf578c$var$ff(g.point, m, t, D, -i.bearingInRadians, O), A = e1.allowVerticalPlacement && v.placedOrientation === 2 ? Math.PI / 2 : 0;
            for(let e1 = 0; e1 < v.numGlyphs; e1++)(0, $1rqx5.C)(h, k, A);
            c && v.associatedIconIndex >= 0 && (_[v.associatedIconIndex] = {
                shiftedAnchor: k,
                angle: A
            });
        }
    }
    if (c) {
        g.clear();
        let t = e1.icon.placedSymbolArray;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t.get(e1);
            if (n.hidden) $834619e78bbf578c$var$xs(n.numGlyphs, g);
            else {
                let t = _[e1];
                if (!t) $834619e78bbf578c$var$xs(n.numGlyphs, g);
                else for(let e1 = 0; e1 < n.numGlyphs; e1++)(0, $1rqx5.C)(g, t.shiftedAnchor, t.angle);
            }
        }
        e1.icon.dynamicLayoutVertexBuffer.updateData(g);
    }
    e1.text.dynamicLayoutVertexBuffer.updateData(h);
}
function $834619e78bbf578c$var$mf(e1, t, n) {
    return n.iconsInText && t ? `symbolTextAndIcon` : e1 ? `symbolSDF` : `symbolIcon`;
}
function $834619e78bbf578c$var$hf(e1, t, n, r, a, o, s, c, l, u, d, p, m) {
    let h = e1.context, g = h.gl, _ = e1.transform, v = c === `map`, y = l === `map`, b = c !== `viewport` && n.layout.get(`symbol-placement`) !== `point`, x = v && !y && !b, S = !n.layout.get(`symbol-sort-key`).isConstant(), C = !1, w = e1.getDepthModeForSublayer(0, $834619e78bbf578c$var$Z.ReadOnly), T = n._unevaluatedLayout.hasValue(`text-variable-anchor`) || n._unevaluatedLayout.hasValue(`text-variable-anchor-offset`), E = [], D = _.getCircleRadiusCorrection();
    for (let c of r){
        let r = t.getTile(c), l = r.getBucket(n);
        if (!l) continue;
        let d = a ? l.text : l.icon;
        if (!d?.segments.get().length || !d.hasVisibleVertices) continue;
        let p = d.programConfigurations.get(n.id), h = a || l.sdfIcons, w = a ? l.textSizeData : l.iconSizeData, O = y || _.pitch !== 0, k = e1.useProgram($834619e78bbf578c$var$mf(h, a, l), p), A = (0, $1rqx5.A)(w, _.zoom), j = $834619e78bbf578c$var$rf(m, c), M, ee = [
            0,
            0
        ], te, ne, re = null, ie;
        if (a) {
            if (te = r.glyphAtlasTexture, ne = g.LINEAR, M = r.glyphAtlasTexture.size, l.iconsInText) {
                ee = r.imageAtlasTexture.size, re = r.imageAtlasTexture;
                let t = w.kind === `composite` || w.kind === `camera`;
                ie = O || e1.options.rotating || e1.options.zooming || t ? g.LINEAR : g.NEAREST;
            }
        } else {
            let t = n.layout.get(`icon-size`).constantOr(0) !== 1 || l.iconsNeedLinear;
            te = r.imageAtlasTexture, ne = h || e1.options.rotating || e1.options.zooming || t || O ? g.LINEAR : g.NEAREST, M = r.imageAtlasTexture.size;
        }
        let ae = (0, $1rqx5.Ir)(r, 1, e1.transform.zoom), oe = $834619e78bbf578c$var$ts(v, e1.transform, ae), se = $834619e78bbf578c$var$ns(y, v, e1.transform, ae), le = (0, $1rqx5.jr)(_, r, o, s), ue = $834619e78bbf578c$var$nf(m, c), de = T && l.hasTextData(), fe = n.layout.get(`icon-text-fit`) !== `none` && de && l.hasIconData(), pe = n._unevaluatedLayout.hasValue(`icon-offset`), me = n.layout.get(`symbol-height-anchor`) === `ground`;
        if (b) {
            let t = (0, $1rqx5.vi)();
            $834619e78bbf578c$var$Zo(t, oe);
            let r = e1.style.map.terrain ? (t, n)=>e1.style.map.terrain.getElevation(c, t, n) : void 0;
            $834619e78bbf578c$var$cs(l, e1, a, oe, t, y, u, n.layout.get(`text-rotation-alignment`) === `map`, c.toUnwrapped(), _.width, _.height, le, r);
        }
        let he = a && T || fe, ge = y ? oe : e1.transform.clipSpaceToPixelsMatrix, _e = b || he ? $834619e78bbf578c$var$cf : ge, ve = h && n.paint.get(a ? `text-halo-width` : `icon-halo-width`).constantOr(1) !== 0, N;
        N = h ? l.iconsInText ? $834619e78bbf578c$var$Xu(w.kind, A, x, y, b, he, e1, _e, se, le, M, ee, D, pe, me) : $834619e78bbf578c$var$Yu(w.kind, A, x, y, b, he, e1, _e, se, le, a, M, ve, D, pe, me) : $834619e78bbf578c$var$Ju(w.kind, A, x, y, b, he, e1, _e, se, le, a, M, D, pe, me);
        let ye = {
            program: k,
            buffers: d,
            uniformValues: N,
            projectionData: ue,
            atlasTexture: te,
            atlasTextureIcon: re,
            atlasInterpolation: ne,
            atlasInterpolationIcon: ie,
            isSDF: h,
            hasHalo: ve
        };
        if (S && l.canOverlap) {
            C = !0;
            let e1 = d.segments.get();
            for (let t of e1)E.push({
                segments: new (0, $1rqx5.Bt)([
                    t
                ]),
                sortKey: t.sortKey,
                state: ye,
                terrainData: j
            });
        } else E.push({
            segments: d.segments,
            sortKey: 0,
            state: ye,
            terrainData: j
        });
    }
    C && E.sort((e1, t)=>e1.sortKey - t.sortKey);
    let O = n.paint.get(a ? `text-halo-width` : `icon-halo-width`).constantOr(null) ?? 1 / 0, k = n.layout.get(`text-letter-spacing`).constantOr(0) * 24 < 0 || O > 1;
    for (let t of E){
        let r = t.state;
        h.activeTexture.set(g.TEXTURE0), r.atlasTexture.bind(r.atlasInterpolation, g.CLAMP_TO_EDGE), r.atlasTextureIcon && (h.activeTexture.set(g.TEXTURE1), r.atlasTextureIcon && r.atlasTextureIcon.bind(r.atlasInterpolationIcon, g.CLAMP_TO_EDGE));
        let i = r.isSDF && r.hasHalo;
        if (i) {
            let i = r.uniformValues;
            i.u_is_halo = 1, k && (i.u_is_plain = 0, $834619e78bbf578c$var$gf(r.buffers, t.segments, n, e1, r.program, w, d, p, i, r.projectionData, t.terrainData), i.u_is_halo = 0, i.u_is_plain = 1);
        }
        $834619e78bbf578c$var$gf(r.buffers, t.segments, n, e1, r.program, w, d, p, r.uniformValues, r.projectionData, t.terrainData), i && !k && (r.uniformValues.u_is_halo = 0);
    }
}
function $834619e78bbf578c$var$gf(e1, t, n, r, i, a, o, s, c, l, u) {
    let d = r.context, f = d.gl;
    i.draw(d, f.TRIANGLES, a, o, s, $834619e78bbf578c$var$$.backCCW, c, u, l, n.id, e1.layoutVertexBuffer, e1.indexBuffer, t, n.paint, r.transform.zoom, e1.programConfigurations.get(n.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
}
function $834619e78bbf578c$var$_f(e1, t, n, r, i) {
    if (i.currentPass !== `translucent`) return;
    let a = n.paint.get(`circle-opacity`), o = n.paint.get(`circle-stroke-width`), s = n.paint.get(`circle-stroke-opacity`), c = !n.layout.get(`circle-sort-key`).isConstant();
    if (a.constantOr(1) === 0 && (o.constantOr(1) === 0 || s.constantOr(1) === 0)) return;
    let l = e1.context, u = l.gl, d = e1.transform, p = e1.getDepthModeForSublayer(0, $834619e78bbf578c$var$Z.ReadOnly), m = $834619e78bbf578c$var$Q.disabled, h = e1.colorModeForRenderPass(), g = [], _ = d.getCircleRadiusCorrection();
    for (let a of r){
        let r = t.getTile(a), o = r.getBucket(n);
        if (!o) continue;
        let s = n.paint.get(`circle-translate`), l = n.paint.get(`circle-translate-anchor`), u = (0, $1rqx5.jr)(d, r, s, l), p = o.programConfigurations.get(n.id), m = e1.useProgram(`circle`, p), h = o.layoutVertexBuffer, v = o.indexBuffer, y = $834619e78bbf578c$var$rf(i, a), b = {
            programConfiguration: p,
            program: m,
            layoutVertexBuffer: h,
            indexBuffer: v,
            uniformValues: $834619e78bbf578c$var$_u(e1, r, n, u, _),
            terrainData: y,
            projectionData: $834619e78bbf578c$var$nf(i, a)
        };
        if (c) {
            let e1 = o.segments.get();
            for (let t of e1)g.push({
                segments: new (0, $1rqx5.Bt)([
                    t
                ]),
                sortKey: t.sortKey,
                state: b
            });
        } else g.push({
            segments: o.segments,
            sortKey: 0,
            state: b
        });
    }
    c && g.sort((e1, t)=>e1.sortKey - t.sortKey);
    for (let t of g){
        let { programConfiguration: r, program: i, layoutVertexBuffer: a, indexBuffer: o, uniformValues: s, terrainData: c, projectionData: d } = t.state, f = t.segments;
        i.draw(l, u.TRIANGLES, p, m, h, $834619e78bbf578c$var$$.backCCW, s, c, d, n.id, a, o, f, n.paint, e1.transform.zoom, r);
    }
}
function $834619e78bbf578c$var$vf(e1, t, n, r, i) {
    if (n.paint.get(`heatmap-opacity`) === 0) return;
    let a = e1.context;
    if (e1.style.map.terrain) {
        for (let a of r){
            let r = t.getTile(a);
            t.hasRenderableParent(a) || (i.currentPass === `offscreen` ? $834619e78bbf578c$var$xf(e1, r, n, a, i) : i.currentPass === `translucent` && $834619e78bbf578c$var$Sf(e1, n, a, i));
        }
        a.viewport.set([
            0,
            0,
            e1.width,
            e1.height
        ]);
    } else i.currentPass === `offscreen` ? $834619e78bbf578c$var$yf(e1, t, n, r, i) : i.currentPass === `translucent` && $834619e78bbf578c$var$bf(e1, n);
}
function $834619e78bbf578c$var$yf(e1, t, n, r, i) {
    let a = e1.context, o = a.gl, s = e1.transform, c = $834619e78bbf578c$var$Q.disabled, l = new $834619e78bbf578c$var$Xd([
        o.ONE,
        o.ONE
    ], (0, $1rqx5.fn).transparent, [
        !0,
        !0,
        !0,
        !0
    ]);
    $834619e78bbf578c$var$Cf(a, e1, n), a.clear({
        color: (0, $1rqx5.fn).transparent
    });
    for (let u of r){
        if (t.hasRenderableParent(u)) continue;
        let r = t.getTile(u), d = r.getBucket(n);
        if (!d) continue;
        let f = d.programConfigurations.get(n.id), p = e1.useProgram(`heatmap`, f), m = $834619e78bbf578c$var$nf(i, u, {
            applyTerrainMatrix: !1
        }), h = s.getCircleRadiusCorrection();
        p.draw(a, o.TRIANGLES, $834619e78bbf578c$var$Z.disabled, c, l, $834619e78bbf578c$var$$.backCCW, $834619e78bbf578c$var$Su(r, s.zoom, n.paint.get(`heatmap-intensity`), h), null, m, n.id, d.layoutVertexBuffer, d.indexBuffer, d.segments, n.paint, s.zoom, f);
    }
    a.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $834619e78bbf578c$var$bf(e1, t) {
    let n = e1.context, r = n.gl;
    n.setColorMode(e1.colorModeForRenderPass());
    let i = t.heatmapFbos.get((0, $1rqx5.Ct));
    i && (n.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), n.activeTexture.set(r.TEXTURE1), $834619e78bbf578c$var$Tf(n, t).bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.useProgram(`heatmapTexture`).draw(n, r.TRIANGLES, $834619e78bbf578c$var$Z.disabled, $834619e78bbf578c$var$Q.disabled, e1.colorModeForRenderPass(), $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$Cu(e1, t, 0, 1), null, null, t.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t.paint, e1.transform.zoom));
}
function $834619e78bbf578c$var$xf(e1, t, n, r, i) {
    let a = e1.context, o = a.gl, s = $834619e78bbf578c$var$Q.disabled, c = new $834619e78bbf578c$var$Xd([
        o.ONE,
        o.ONE
    ], (0, $1rqx5.fn).transparent, [
        !0,
        !0,
        !0,
        !0
    ]), l = t.getBucket(n);
    if (!l) return;
    let u = r.key, d = n.heatmapFbos.get(u);
    d || (d = $834619e78bbf578c$var$wf(a, t.tileSize, t.tileSize), n.heatmapFbos.set(u, d)), a.bindFramebuffer.set(d.framebuffer), a.viewport.set([
        0,
        0,
        t.tileSize,
        t.tileSize
    ]), a.clear({
        color: (0, $1rqx5.fn).transparent
    });
    let f = l.programConfigurations.get(n.id), p = e1.useProgram(`heatmap`, f, !i.isRenderingGlobe), m = $834619e78bbf578c$var$nf(i, t.tileID), h = $834619e78bbf578c$var$rf(i, r);
    p.draw(a, o.TRIANGLES, $834619e78bbf578c$var$Z.disabled, s, c, $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$Su(t, e1.transform.zoom, n.paint.get(`heatmap-intensity`), 1), h, m, n.id, l.layoutVertexBuffer, l.indexBuffer, l.segments, n.paint, e1.transform.zoom, f);
}
function $834619e78bbf578c$var$Sf(e1, t, n, r) {
    let i = e1.context, a = i.gl, o = e1.transform;
    i.setColorMode(e1.colorModeForRenderPass());
    let s = $834619e78bbf578c$var$Tf(i, t), c = n.key, l = t.heatmapFbos.get(c);
    if (!l) return;
    i.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, l.colorAttachment.get()), i.activeTexture.set(a.TEXTURE1), s.bind(a.LINEAR, a.CLAMP_TO_EDGE);
    let u = $834619e78bbf578c$var$nf(r, n, {
        applyTerrainMatrix: r.isRenderingGlobe
    });
    e1.useProgram(`heatmapTexture`).draw(i, a.TRIANGLES, $834619e78bbf578c$var$Z.disabled, $834619e78bbf578c$var$Q.disabled, e1.colorModeForRenderPass(), $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$Cu(e1, t, 0, 1), null, u, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, o.zoom), l.destroy(), t.heatmapFbos.delete(c);
}
function $834619e78bbf578c$var$Cf(e1, t, n) {
    let r = e1.gl;
    e1.activeTexture.set(r.TEXTURE1), e1.viewport.set([
        0,
        0,
        t.width / 4,
        t.height / 4
    ]);
    let i = n.heatmapFbos.get((0, $1rqx5.Ct));
    i ? (r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), e1.bindFramebuffer.set(i.framebuffer)) : (i = $834619e78bbf578c$var$wf(e1, t.width / 4, t.height / 4), n.heatmapFbos.set((0, $1rqx5.Ct), i));
}
function $834619e78bbf578c$var$wf(e1, t, n) {
    let r = e1.gl, i = r.createTexture();
    r.bindTexture(r.TEXTURE_2D, i), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texStorage2D(r.TEXTURE_2D, 1, r.RGBA16F, t, n);
    let a = e1.createFramebuffer(t, n, !1, !1);
    return a.colorAttachment.set(i), a;
}
function $834619e78bbf578c$var$Tf(e1, t) {
    return t.colorRampTexture ||= new (0, $1rqx5.xt)(e1, t.colorRamp, e1.gl.RGBA), t.colorRampTexture;
}
function $834619e78bbf578c$var$Ef(e1, t, n) {
    let r = e1.context, i = r.bindFramebuffer.get(), a = r.viewport.get(), [, , o, s] = a;
    return $834619e78bbf578c$var$Df(e1, o, s), r.viewport.set([
        0,
        0,
        o,
        s
    ]), r.clear({
        color: (0, $1rqx5.fn).transparent,
        depth: 1,
        stencil: 0
    }), e1.currentStencilSource = void 0, e1.renderTileClippingMasks(t, n), {
        compositeTarget: i,
        compositeViewport: a
    };
}
function $834619e78bbf578c$var$Df(e1, t, n) {
    let r = e1.context.gl;
    if (!e1.layerOpacityFbo) {
        let i = e1.context.createFramebuffer(t, n, !0, !0), a = r.createTexture();
        r.bindTexture(r.TEXTURE_2D, a), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, null), i.colorAttachment.set(a), i.depthAttachment.set(e1.context.createRenderbuffer(r.DEPTH_STENCIL, t, n)), e1.layerOpacityFbo = i, e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        return;
    }
    if (e1.layerOpacityFbo.width === t && e1.layerOpacityFbo.height === n) {
        e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        return;
    }
    let i = e1.layerOpacityFbo;
    r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, null), e1.context.bindRenderbuffer.set(i.depthAttachment.get()), r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_STENCIL, t, n), e1.context.bindRenderbuffer.set(null), i.width = t, i.height = n, e1.context.bindFramebuffer.set(i.framebuffer);
}
function $834619e78bbf578c$var$Of(e1, t, n, r) {
    let i = e1.context, a = i.gl;
    i.bindFramebuffer.set(n.compositeTarget), i.viewport.set(n.compositeViewport), i.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, e1.layerOpacityFbo.colorAttachment.get()), e1.useProgram(`layerOpacity`).draw(i, a.TRIANGLES, $834619e78bbf578c$var$Z.disabled, $834619e78bbf578c$var$Q.disabled, e1.colorModeForRenderPass(), $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$Wu(t, 0), null, null, r.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, r.paint, e1.transform.zoom), e1.currentStencilSource = void 0;
}
function $834619e78bbf578c$var$kf(e1, t, n, r, i, a, o, s) {
    let c = 256;
    if (i.stepInterpolant) {
        let r = t.getSource().maxzoom, i = o.canonical.z === r ? Math.ceil(1 << e1.transform.maxZoom - o.canonical.z) : 1, s = a.maxLineLength / (0, $1rqx5.Lr) * 1024 * i;
        c = (0, $1rqx5.Bn)((0, $1rqx5._r)(s), 256, n.maxTextureSize);
    }
    return s.gradient = (0, $1rqx5.Tt)({
        expression: i.gradientExpression(),
        evaluationKey: `lineProgress`,
        resolution: c,
        image: s.gradient || void 0,
        clips: a.lineClipsArray
    }), s.texture ? s.texture.update(s.gradient) : s.texture = new (0, $1rqx5.xt)(n, s.gradient, r.RGBA), s.version = i.gradientVersion, s.texture;
}
function $834619e78bbf578c$var$Af(e1, t, n, r, i) {
    e1.activeTexture.set(t.TEXTURE0), n.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), r.updatePaintBuffers(i);
}
function $834619e78bbf578c$var$jf(e1, t, n, r, i, a) {
    (i || e1.lineAtlas.dirty) && (t.activeTexture.set(n.TEXTURE0), e1.lineAtlas.bind(t)), r.updatePaintBuffers(a);
}
function $834619e78bbf578c$var$Mf(e1, t, n, r, i, a, o) {
    let s = a.gradients[i.id], c = s.texture;
    i.gradientVersion !== s.version && (c = $834619e78bbf578c$var$kf(e1, t, n, r, i, a, o, s)), n.activeTexture.set(r.TEXTURE0), c.bind(i.stepInterpolant ? r.NEAREST : r.LINEAR, r.CLAMP_TO_EDGE);
}
function $834619e78bbf578c$var$Nf(e1, t, n, r, i, a, o, s, c) {
    let l = a.gradients[i.id], u = l.texture;
    i.gradientVersion !== l.version && (u = $834619e78bbf578c$var$kf(e1, t, n, r, i, a, o, l)), n.activeTexture.set(r.TEXTURE0), u.bind(i.stepInterpolant ? r.NEAREST : r.LINEAR, r.CLAMP_TO_EDGE), n.activeTexture.set(r.TEXTURE1), e1.lineAtlas.bind(n), s.updatePaintBuffers(c);
}
function $834619e78bbf578c$var$Pf(e1, t, n, r, i) {
    if (i.currentPass !== `translucent`) return;
    let a = n.paint.get(`line-opacity`), o = n.paint.get(`line-width`), s = n.paint.get(`line-layer-opacity`);
    if (a.constantOr(1) !== 0 && o.constantOr(1) !== 0 && s !== 0) {
        if (s < 1) {
            let a = $834619e78bbf578c$var$Ef(e1, n, r);
            $834619e78bbf578c$var$Ff(e1, t, n, r, i), $834619e78bbf578c$var$Of(e1, s, a, n);
            return;
        }
        $834619e78bbf578c$var$Ff(e1, t, n, r, i);
    }
}
function $834619e78bbf578c$var$Ff(e1, t, n, r, i) {
    let a = e1.getDepthModeForSublayer(0, $834619e78bbf578c$var$Z.ReadOnly), o = e1.colorModeForRenderPass(), s = n.paint.get(`line-dasharray`), c = s.constantOr(1), l = n.paint.get(`line-pattern`), u = l.constantOr(1), d = n.paint.get(`line-gradient`), f = n.getCrossfadeParameters(), p;
    p = u ? `linePattern` : c && d ? `lineGradientSDF` : c ? `lineSDF` : d ? `lineGradient` : `line`;
    let m = e1.context, h = m.gl, g = e1.transform, _ = !0;
    for (let v of r){
        let r = t.getTile(v);
        if (u && !r.patternsLoaded()) continue;
        let y = r.getBucket(n);
        if (!y) continue;
        let b = y.programConfigurations.get(n.id), x = e1.context.program.get(), S = e1.useProgram(p, b), C = _ || S.program !== x, w = $834619e78bbf578c$var$rf(i, v), T = l.constantOr(null), E = s?.constantOr(null);
        if (T && r.imageAtlas) {
            let e1 = r.imageAtlas, t = e1.patternPositions[T.to.toString()], n = e1.patternPositions[T.from.toString()];
            t && n && b.setConstantPatternPositions(t, n);
        } else if (E) {
            let t = n.layout.get(`line-cap`).constantOr(null) === `round`, r = e1.lineAtlas.getDash(E.to, t), i = e1.lineAtlas.getDash(E.from, t);
            b.setConstantDashPositions(r, i);
        }
        let D = $834619e78bbf578c$var$nf(i, v), O = g.getPixelScale(), k;
        u ? (k = $834619e78bbf578c$var$Ru(e1, r, n, O, f), $834619e78bbf578c$var$Af(m, h, r, b, f)) : c && d ? (k = $834619e78bbf578c$var$Bu(e1, r, n, O, f, y.lineClipsArray.length), $834619e78bbf578c$var$Nf(e1, t, m, h, n, y, v, b, f)) : c ? (k = $834619e78bbf578c$var$zu(e1, r, n, O, f), $834619e78bbf578c$var$jf(e1, m, h, b, C, f)) : d ? (k = $834619e78bbf578c$var$Lu(e1, r, n, O, y.lineClipsArray.length), $834619e78bbf578c$var$Mf(e1, t, m, h, n, y, v)) : k = $834619e78bbf578c$var$Iu(e1, r, n, O);
        let A = e1.stencilModeForClipping(v);
        S.draw(m, h.TRIANGLES, a, A, o, $834619e78bbf578c$var$$.disabled, k, w, D, n.id, y.layoutVertexBuffer, y.indexBuffer, y.segments, n.paint, e1.transform.zoom, b, y.layoutVertexBuffer2), _ = !1;
    }
}
function $834619e78bbf578c$var$If(e1, t, n, r, i) {
    if (!n || !r?.imageAtlas) return;
    let a = r.imageAtlas.patternPositions, o = a[n.to.toString()], s = a[n.from.toString()];
    if (!o && s && (o = s), !s && o && (s = o), !o || !s) {
        let e1 = i.getPaintProperty(t);
        o = a[e1], s = a[e1];
    }
    o && s && e1.setConstantPatternPositions(o, s);
}
function $834619e78bbf578c$var$Lf(e1, t, n, r, i) {
    let a = n.paint.get(`fill-color`), o = n.paint.get(`fill-opacity`), s = n.paint.get(`fill-layer-opacity`);
    if (o.constantOr(1) === 0 || s === 0) return;
    if (s < 1) {
        if (i.currentPass !== `translucent`) return;
        let a = $834619e78bbf578c$var$Ef(e1, n, r);
        $834619e78bbf578c$var$Rf(e1, t, n, r, i), $834619e78bbf578c$var$Of(e1, s, a, n);
        return;
    }
    let c = n.paint.get(`fill-pattern`), l = e1.opaquePassEnabledForLayer() && !c.constantOr(1) && a.constantOr((0, $1rqx5.fn).transparent).a === 1 && o.constantOr(0) === 1;
    if (l && i.currentPass === `opaque`) {
        let a = e1.colorModeForRenderPass();
        $834619e78bbf578c$var$Bf(e1, t, n, r, e1.getDepthModeForSublayer(1, $834619e78bbf578c$var$Z.ReadWrite), a, !1, i);
        return;
    }
    if (l && i.currentPass === `translucent`) {
        $834619e78bbf578c$var$zf(e1, t, n, r, i);
        return;
    }
    i.currentPass === `translucent` && $834619e78bbf578c$var$Rf(e1, t, n, r, i);
}
function $834619e78bbf578c$var$Rf(e1, t, n, r, i) {
    let a = e1.colorModeForRenderPass();
    $834619e78bbf578c$var$Bf(e1, t, n, r, e1.getDepthModeForSublayer(1, $834619e78bbf578c$var$Z.ReadOnly), a, !1, i), $834619e78bbf578c$var$zf(e1, t, n, r, i);
}
function $834619e78bbf578c$var$zf(e1, t, n, r, i) {
    if (!n.paint.get(`fill-antialias`)) return;
    let a = e1.colorModeForRenderPass();
    $834619e78bbf578c$var$Bf(e1, t, n, r, e1.getDepthModeForSublayer(n.getPaintProperty(`fill-outline-color`) ? 2 : 0, $834619e78bbf578c$var$Z.ReadOnly), a, !0, i);
}
function $834619e78bbf578c$var$Bf(e1, t, n, r, i, a, o, s) {
    let c = e1.context.gl, l = `fill-pattern`, u = n.paint.get(l), d = u?.constantOr(1), f = n.getCrossfadeParameters(), p, m, h, g, _, v = e1.transform, y = n.paint.get(`fill-translate`), b = n.paint.get(`fill-translate-anchor`);
    o ? (m = d && !n.getPaintProperty(`fill-outline-color`) ? `fillOutlinePattern` : `fillOutline`, p = c.LINES) : (m = d ? `fillPattern` : `fill`, p = c.TRIANGLES);
    let x = u.constantOr(null);
    for (let u of r){
        let r = t.getTile(u);
        if (d && !r.patternsLoaded()) continue;
        let S = r.getBucket(n);
        if (!S) continue;
        let C = S.sdfPatterns[n.id] ?? !1, w = S.programConfigurations.get(n.id), T = e1.useProgram(m, w), E = $834619e78bbf578c$var$rf(s, u);
        d && (e1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), w.updatePaintBuffers(f)), $834619e78bbf578c$var$If(w, l, x, r, n);
        let D = $834619e78bbf578c$var$nf(s, u), O = (0, $1rqx5.jr)(v, r, y, b);
        o ? (g = S.indexBuffer2, _ = S.segments2, h = m === `fillOutlinePattern` && d ? $834619e78bbf578c$var$hu(e1, f, r, O, C) : $834619e78bbf578c$var$mu(O)) : (g = S.indexBuffer, _ = S.segments, h = d ? $834619e78bbf578c$var$fu(e1, f, r, O, C) : $834619e78bbf578c$var$pu(O));
        let k = e1.stencilModeForClipping(u);
        T.draw(e1.context, p, i, k, a, $834619e78bbf578c$var$$.backCCW, h, E, D, n.id, S.layoutVertexBuffer, g, _, n.paint, e1.transform.zoom, w);
    }
}
function $834619e78bbf578c$var$Vf(e1, t, n, r, i) {
    let a = n.paint.get(`fill-extrusion-opacity`);
    if (a !== 0 && i.currentPass === `translucent`) {
        let o = new $834619e78bbf578c$var$Z(e1.context.gl.LEQUAL, $834619e78bbf578c$var$Z.ReadWrite, i.depthRangeFor3D);
        if (a === 1 && !n.paint.get(`fill-extrusion-pattern`).constantOr(1)) {
            let a = e1.colorModeForRenderPass();
            $834619e78bbf578c$var$Hf(e1, t, n, r, o, $834619e78bbf578c$var$Q.disabled, a, i);
        } else $834619e78bbf578c$var$Hf(e1, t, n, r, o, $834619e78bbf578c$var$Q.disabled, $834619e78bbf578c$var$Xd.disabled, i), $834619e78bbf578c$var$Hf(e1, t, n, r, o, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), i);
    }
}
function $834619e78bbf578c$var$Hf(e1, t, n, r, i, a, o, s) {
    let c = e1.context, l = c.gl, u = `fill-extrusion-pattern`, d = n.paint.get(u), f = d.constantOr(1), p = n.getCrossfadeParameters(), m = n.paint.get(`fill-extrusion-opacity`), h = d.constantOr(null), g = e1.transform;
    for (let d of r){
        let r = t.getTile(d), _ = r.getBucket(n);
        if (!_) continue;
        let v = $834619e78bbf578c$var$rf(s, d), y = _.programConfigurations.get(n.id), b = e1.useProgram(f ? `fillExtrusionPattern` : `fillExtrusion`, y);
        f && (e1.context.activeTexture.set(l.TEXTURE0), r.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), y.updatePaintBuffers(p));
        let x = $834619e78bbf578c$var$nf(s, d);
        $834619e78bbf578c$var$If(y, u, h, r, n);
        let S = (0, $1rqx5.jr)(g, r, n.paint.get(`fill-extrusion-translate`), n.paint.get(`fill-extrusion-translate-anchor`)), C = n.paint.get(`fill-extrusion-vertical-gradient`), w = f ? $834619e78bbf578c$var$su(e1, C, m, S, d, p, r) : $834619e78bbf578c$var$ou(e1, C, m, S);
        b.draw(c, c.gl.TRIANGLES, i, a, o, $834619e78bbf578c$var$$.backCCW, w, v, x, n.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, n.paint, e1.transform.zoom, y, e1.style.map.terrain && _.centroidVertexBuffer);
    }
}
function $834619e78bbf578c$var$Uf(e1, t, n, r, i) {
    if (i.currentPass !== `offscreen` && i.currentPass !== `translucent`) return;
    let a = e1.context, o = e1.style.projection.useSubdivision, s = e1.getDepthModeForSublayer(0, $834619e78bbf578c$var$Z.ReadOnly), c = e1.colorModeForRenderPass();
    if (i.currentPass === `offscreen`) $834619e78bbf578c$var$Gf(e1, t, r, n, s, $834619e78bbf578c$var$Q.disabled, c), a.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
    else if (i.currentPass === `translucent`) {
        if (o) {
            let [a, o, l] = e1.stencilConfigForOverlapTwoPass(r);
            $834619e78bbf578c$var$Wf(e1, t, n, l, a, s, c, !1, i), $834619e78bbf578c$var$Wf(e1, t, n, l, o, s, c, !0, i);
        } else {
            let [a, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
            $834619e78bbf578c$var$Wf(e1, t, n, o, a, s, c, !1, i);
        }
    }
}
function $834619e78bbf578c$var$Wf(e1, t, n, r, i, a, o, s, c) {
    let l = e1.style.projection, u = e1.context, d = u.gl, f = [
        `#define NUM_ILLUMINATION_SOURCES ${n.paint.get(`hillshade-highlight-color`).values.length}`
    ], p = e1.useProgram(`hillshade`, null, !1, f), m = !e1.options.moving;
    for (let f of r){
        let r = t.getTile(f), h = r.fbo;
        if (!h) continue;
        let g = l.getMeshFromTileID(u, f.canonical, s, !0, `raster`), _ = $834619e78bbf578c$var$rf(c, f);
        u.activeTexture.set(d.TEXTURE0), d.bindTexture(d.TEXTURE_2D, h.colorAttachment.get());
        let v = $834619e78bbf578c$var$nf(c, f, {
            aligned: m
        });
        p.draw(u, d.TRIANGLES, a, i[f.overscaledZ], o, $834619e78bbf578c$var$$.backCCW, $834619e78bbf578c$var$Eu(e1, r, n), _, v, n.id, g.vertexBuffer, g.indexBuffer, g.segments);
    }
}
function $834619e78bbf578c$var$Gf(e1, t, n, r, i, a, o) {
    let s = e1.context, c = s.gl, l = r.paint.get(`resampling`) === `nearest` ? c.NEAREST : c.LINEAR;
    for (let u of n){
        let n = t.getTile(u), d = n.dem;
        if (!d?.data || !n.needsHillshadePrepare) continue;
        let f = d.dim + 2, p = d.stride, m = d.getPixels();
        if (s.activeTexture.set(c.TEXTURE1), s.pixelStoreUnpackPremultiplyAlpha.set(!1), n.demTexture ||= e1.getTileTexture(p), n.demTexture) {
            let e1 = n.demTexture;
            e1.update(m, {
                premultiply: !1
            }), e1.bind(c.NEAREST, c.CLAMP_TO_EDGE);
        } else n.demTexture = new (0, $1rqx5.xt)(s, m, c.RGBA, {
            premultiply: !1
        }), n.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
        s.activeTexture.set(c.TEXTURE0);
        let h = n.fbo;
        if (!h) {
            let e1 = new (0, $1rqx5.xt)(s, {
                width: f,
                height: f,
                data: null
            }, c.RGBA);
            e1.bind(l, c.CLAMP_TO_EDGE), h = n.fbo = s.createFramebuffer(f, f, !0, !1), h.colorAttachment.set(e1.texture);
        }
        s.bindFramebuffer.set(h.framebuffer), s.viewport.set([
            0,
            0,
            f,
            f
        ]), e1.useProgram(`hillshadePrepare`).draw(s, c.TRIANGLES, i, a, o, $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$Du(n.tileID, d), null, null, r.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), n.needsHillshadePrepare = !1;
    }
}
function $834619e78bbf578c$var$Kf(e1, t, n, r, i) {
    if (i.currentPass !== `translucent` || !r.length) return;
    let a = e1.style.projection.useSubdivision, o = e1.getDepthModeForSublayer(0, $834619e78bbf578c$var$Z.ReadOnly), s = e1.colorModeForRenderPass();
    if (a) {
        let [a, c, l] = e1.stencilConfigForOverlapTwoPass(r);
        $834619e78bbf578c$var$Jf(e1, t, n, l, a, o, s, !1, i), $834619e78bbf578c$var$Jf(e1, t, n, l, c, o, s, !0, i);
    } else {
        let [a, c] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
        $834619e78bbf578c$var$Jf(e1, t, n, c, a, o, s, !1, i);
    }
}
let $834619e78bbf578c$var$qf = 0;
function $834619e78bbf578c$var$Jf(e1, t, n, r, i, a, o, s, c) {
    let l = e1.style.projection, u = e1.context, d = u.gl, f = e1.useProgram(`colorRelief`), p = !e1.options.moving, m = n.paint.get(`resampling`) === `nearest` ? d.NEAREST : d.LINEAR, h = !0, g = 0;
    for (let _ of r){
        let r = t.getTile(_), v = r.dem;
        if (!v?.data) continue;
        if (h) {
            $834619e78bbf578c$var$qf ||= d.getParameter(d.MAX_TEXTURE_SIZE);
            let e1 = $834619e78bbf578c$var$qf, { elevationTexture: t, colorTexture: r } = n.getColorRampTextures(u, e1, v.getUnpackVector());
            u.activeTexture.set(d.TEXTURE1), t.bind(d.NEAREST, d.CLAMP_TO_EDGE), u.activeTexture.set(d.TEXTURE4), r.bind(d.LINEAR, d.CLAMP_TO_EDGE), h = !1, g = t.size[0];
        }
        let y = v.stride;
        u.activeTexture.set(d.TEXTURE0), (!r.demTexture || r.needsColorReliefPrepare) && (u.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture ||= e1.getTileTexture(y) ?? new (0, $1rqx5.xt)(u, {
            width: y,
            height: y,
            data: null
        }, d.RGBA), r.demTexture.update(v.getPixels(), {
            premultiply: !1
        }), r.needsColorReliefPrepare = !1), r.demTexture.bind(m, d.CLAMP_TO_EDGE);
        let b = l.getMeshFromTileID(u, _.canonical, s, !0, `raster`), x = $834619e78bbf578c$var$rf(c, _), S = $834619e78bbf578c$var$nf(c, _, {
            aligned: p
        });
        f.draw(u, d.TRIANGLES, a, i[_.overscaledZ], o, $834619e78bbf578c$var$$.backCCW, $834619e78bbf578c$var$Au(n, r.dem, g), x, S, n.id, b.vertexBuffer, b.indexBuffer, b.segments);
    }
}
const $834619e78bbf578c$var$Yf = [
    new (0, $1rqx5.Li)(0, 0),
    new (0, $1rqx5.Li)((0, $1rqx5.Lr), 0),
    new (0, $1rqx5.Li)((0, $1rqx5.Lr), (0, $1rqx5.Lr)),
    new (0, $1rqx5.Li)(0, (0, $1rqx5.Lr))
];
function $834619e78bbf578c$var$Xf(e1, t, n, r, i) {
    if (i.currentPass !== `translucent` || n.paint.get(`raster-opacity`) === 0 || !r.length) return;
    let a = t.getSource(), o = e1.style.projection.useSubdivision;
    if (a instanceof $834619e78bbf578c$export$280e9a68c3ffd919) $834619e78bbf578c$var$Zf(e1, t, n, r, null, !1, !1, a.tileCoords, a.imageWarp, a.flippedWindingOrder, i, a.getMesh(e1.context, o));
    else if (o) {
        let [a, o, s] = e1.stencilConfigForOverlapTwoPass(r);
        $834619e78bbf578c$var$Zf(e1, t, n, s, a, !1, !0, $834619e78bbf578c$var$Yf, $834619e78bbf578c$var$Ha, !1, i), $834619e78bbf578c$var$Zf(e1, t, n, s, o, !0, !0, $834619e78bbf578c$var$Yf, $834619e78bbf578c$var$Ha, !1, i);
    } else {
        let [a, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
        $834619e78bbf578c$var$Zf(e1, t, n, o, a, !1, !0, $834619e78bbf578c$var$Yf, $834619e78bbf578c$var$Ha, !1, i);
    }
}
function $834619e78bbf578c$var$Zf(e1, t, n, r, i, a, o, s, c, l = !1, u, d = null) {
    let f = r[r.length - 1].overscaledZ, p = e1.context, m = p.gl, h = e1.useProgram(`raster`), g = e1.style.projection, _ = e1.colorModeForRenderPass(), v = !e1.options.moving, y = n.paint.get(`raster-opacity`), b = n.paint.get(`resampling`) === `nearest` || n.paint.get(`raster-resampling`) === `nearest` ? m.NEAREST : m.LINEAR, x = n.paint.get(`raster-fade-duration`), S = !!e1.style.map.terrain;
    for (let C of r){
        let r = e1.getDepthModeForSublayer(C.overscaledZ - f, y === 1 ? $834619e78bbf578c$var$Z.ReadWrite : $834619e78bbf578c$var$Z.ReadOnly, m.LESS), w = t.getTile(C);
        p.activeTexture.set(m.TEXTURE0), w.texture.bind(b, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST), p.activeTexture.set(m.TEXTURE1);
        let { parentTile: T, parentScaleBy: E, parentTopLeft: D, fadeValues: O } = $834619e78bbf578c$var$Qf(w, t, x, S);
        w.fadeOpacity = O.tileOpacity, T ? (T.fadeOpacity = O.parentTileOpacity, T.texture.bind(b, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST)) : w.texture.bind(b, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST), w.texture.useMipmap && p.extTextureFilterAnisotropic && e1.transform.pitch > e1.options.anisotropicFilterPitch && m.texParameterf(m.TEXTURE_2D, p.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, p.extTextureFilterAnisotropicMax);
        let k = $834619e78bbf578c$var$rf(u, C), A = $834619e78bbf578c$var$nf(u, C, {
            aligned: v
        }), j = $834619e78bbf578c$var$Wa(D, E, O.fadeMix, n, s, c), M = d ?? g.getMeshFromTileID(p, C.canonical, a, o, `raster`), ee = i ? i[C.overscaledZ] : $834619e78bbf578c$var$Q.disabled;
        h.draw(p, m.TRIANGLES, r, ee, _, l ? $834619e78bbf578c$var$$.frontCCW : $834619e78bbf578c$var$$.backCCW, j, k, A, n.id, M.vertexBuffer, M.indexBuffer, M.segments);
    }
}
function $834619e78bbf578c$var$Qf(e1, t, n, r) {
    let i = {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: {
            tileOpacity: 1,
            parentTileOpacity: 1,
            fadeMix: {
                opacity: 1,
                mix: 0
            }
        }
    };
    if (n === 0 || r) return i;
    if (e1.fadingParentID) {
        let r = t.getLoadedTile(e1.fadingParentID);
        if (!r) return i;
        let a = 2 ** (r.tileID.overscaledZ - e1.tileID.overscaledZ);
        return {
            parentTile: r,
            parentScaleBy: a,
            parentTopLeft: [
                e1.tileID.canonical.x * a % 1,
                e1.tileID.canonical.y * a % 1
            ],
            fadeValues: $834619e78bbf578c$var$$f(e1, r, n)
        };
    }
    return e1.selfFading ? {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: $834619e78bbf578c$var$ep(e1, n)
    } : i;
}
function $834619e78bbf578c$var$$f(e1, t, n) {
    let r = $834619e78bbf578c$export$461939dd4422153(), i = (r - e1.timeAdded) / n, a = (r - t.timeAdded) / n, o = e1.fadingDirection === 1, s = (0, $1rqx5.Bn)(i, 0, 1), c = (0, $1rqx5.Bn)(1 - a, 0, 1), l = o ? s : c;
    return {
        tileOpacity: l,
        parentTileOpacity: o ? c : s,
        fadeMix: {
            opacity: 1,
            mix: 1 - l
        }
    };
}
function $834619e78bbf578c$var$ep(e1, t) {
    let n = ($834619e78bbf578c$export$461939dd4422153() - e1.timeAdded) / t, r = (0, $1rqx5.Bn)(n, 0, 1);
    return {
        tileOpacity: r,
        fadeMix: {
            opacity: r,
            mix: 0
        }
    };
}
function $834619e78bbf578c$var$tp(e1, t, n, r, i) {
    let a = n.paint.get(`background-color`), o = n.paint.get(`background-opacity`);
    if (o === 0) return;
    let s = e1.context, c = s.gl, l = e1.style.projection, u = e1.transform, d = u.tileSize, f = n.paint.get(`background-pattern`);
    if (e1.isPatternMissing(f)) return;
    let p = !f && a.a === 1 && o === 1 && e1.opaquePassEnabledForLayer() ? `opaque` : `translucent`;
    if (i.currentPass !== p) return;
    let m = $834619e78bbf578c$var$Q.disabled, h = e1.getDepthModeForSublayer(0, p === `opaque` ? $834619e78bbf578c$var$Z.ReadWrite : $834619e78bbf578c$var$Z.ReadOnly), g = e1.colorModeForRenderPass(), _ = e1.useProgram(f ? `backgroundPattern` : `background`), v = r || $834619e78bbf578c$var$Fo(u, {
        tileSize: d,
        terrain: e1.style.map.terrain
    });
    f && (s.activeTexture.set(c.TEXTURE0), e1.patternAtlas.bind(e1.context));
    let y = n.getCrossfadeParameters();
    for (let t of v){
        let r = $834619e78bbf578c$var$nf(i, t), u = f ? $834619e78bbf578c$var$ed(o, e1, f, {
            tileID: t,
            tileSize: d
        }, y) : $834619e78bbf578c$var$$u(o, a), p = $834619e78bbf578c$var$rf(i, t), v = l.getMeshFromTileID(s, t.canonical, !1, !0, `raster`);
        _.draw(s, c.TRIANGLES, h, m, g, $834619e78bbf578c$var$$.backCCW, u, p, r, n.id, v.vertexBuffer, v.indexBuffer, v.segments);
    }
}
const $834619e78bbf578c$var$np = new (0, $1rqx5.fn)(1, 0, 0, 1), $834619e78bbf578c$var$rp = new (0, $1rqx5.fn)(0, 1, 0, 1), $834619e78bbf578c$var$ip = new (0, $1rqx5.fn)(0, 0, 1, 1), $834619e78bbf578c$var$ap = new (0, $1rqx5.fn)(1, 0, 1, 1), $834619e78bbf578c$var$op = new (0, $1rqx5.fn)(0, 1, 1, 1);
function $834619e78bbf578c$var$sp(e1) {
    let t = e1.transform.padding;
    $834619e78bbf578c$var$lp(e1, e1.transform.height - (t.top || 0), 3, $834619e78bbf578c$var$np), $834619e78bbf578c$var$lp(e1, t.bottom || 0, 3, $834619e78bbf578c$var$rp), $834619e78bbf578c$var$up(e1, t.left || 0, 3, $834619e78bbf578c$var$ip), $834619e78bbf578c$var$up(e1, e1.transform.width - (t.right || 0), 3, $834619e78bbf578c$var$ap);
    let n = e1.transform.centerPoint;
    $834619e78bbf578c$var$cp(e1, n.x, e1.transform.height - n.y, $834619e78bbf578c$var$op);
}
function $834619e78bbf578c$var$cp(e1, t, n, r) {
    $834619e78bbf578c$var$dp(e1, t - 1, n - 10, 2, 20, r), $834619e78bbf578c$var$dp(e1, t - 10, n - 1, 20, 2, r);
}
function $834619e78bbf578c$var$lp(e1, t, n, r) {
    $834619e78bbf578c$var$dp(e1, 0, t + n / 2, e1.transform.width, n, r);
}
function $834619e78bbf578c$var$up(e1, t, n, r) {
    $834619e78bbf578c$var$dp(e1, t - n / 2, 0, n, e1.transform.height, r);
}
function $834619e78bbf578c$var$dp(e1, t, n, r, i, a) {
    let o = e1.context, s = o.gl;
    s.enable(s.SCISSOR_TEST), s.scissor(t * e1.pixelRatio, n * e1.pixelRatio, r * e1.pixelRatio, i * e1.pixelRatio), o.clear({
        color: a
    }), s.disable(s.SCISSOR_TEST);
}
function $834619e78bbf578c$var$fp(e1, t, n, r) {
    for (let i of n)$834619e78bbf578c$var$pp(e1, t, i, r);
}
function $834619e78bbf578c$var$pp(e1, t, n, r) {
    let i = e1.context, a = i.gl, o = e1.useProgram(`debug`), s = $834619e78bbf578c$var$Z.disabled, c = $834619e78bbf578c$var$Q.disabled, l = e1.colorModeForRenderPass(), u = `$debug`, d = $834619e78bbf578c$var$rf(r, n);
    i.activeTexture.set(a.TEXTURE0);
    let f = t.getTileByID(n.key).latestRawTileData?.byteLength || 0, p = Math.floor(f / 1024), m = t.getTile(n).tileSize, h = 512 / Math.min(m, 512) * (n.overscaledZ / e1.transform.zoom) * .5, g = n.canonical.toString();
    n.overscaledZ !== n.canonical.z && (g += ` => ${n.overscaledZ}`), $834619e78bbf578c$var$mp(e1, `${g} ${p}kB`);
    let _ = $834619e78bbf578c$var$nf(r, n);
    o.draw(i, a.TRIANGLES, s, c, $834619e78bbf578c$var$Xd.alphaBlended, $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$yu((0, $1rqx5.fn).transparent, h), null, _, u, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), o.draw(i, a.LINE_STRIP, s, c, l, $834619e78bbf578c$var$$.disabled, $834619e78bbf578c$var$yu((0, $1rqx5.fn).red), d, _, u, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
}
function $834619e78bbf578c$var$mp(e1, t) {
    e1.initDebugOverlayCanvas();
    let n = e1.debugOverlayCanvas, r = e1.context.gl, i = e1.debugOverlayCanvas.getContext(`2d`);
    i.clearRect(0, 0, n.width, n.height), i.shadowColor = `white`, i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = `white`, i.textBaseline = `top`, i.font = `bold 36px Open Sans, sans-serif`, i.fillText(t, 5, 5), i.strokeText(t, 5, 5), e1.debugOverlayTexture.update(n), e1.debugOverlayTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
}
function $834619e78bbf578c$var$hp(e1, t) {
    let n = null, r = Object.values(e1._layers).flatMap((n)=>n.source && !n.isHidden(t) ? [
            e1.tileManagers[n.source]
        ] : []), i = r.filter((e1)=>e1.getSource().type === `vector`), a = r.filter((e1)=>e1.getSource().type !== `vector`), o = (e1)=>{
        (!n || n.getSource().maxzoom < e1.getSource().maxzoom) && (n = e1);
    };
    for (let e1 of i)o(e1);
    if (!n) for (let e1 of a)o(e1);
    return n;
}
function $834619e78bbf578c$var$gp(e1, t, n, r) {
    let { isRenderingGlobe: i } = r, a = e1.context, o = n.implementation, s = e1.style.projection, c = e1.transform, l = c.getProjectionDataForCustomLayer(i), u = {
        farZ: c.farZ,
        nearZ: c.nearZ,
        fov: c.fov * Math.PI / 180,
        modelViewProjectionMatrix: c.modelViewProjectionMatrix,
        projectionMatrix: c.projectionMatrix,
        shaderData: {
            variantName: s.shaderVariantName,
            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${s.shaderPreludeCode.vertexSource}`,
            define: s.shaderDefine
        },
        defaultProjectionData: l,
        getProjectionData: (e1)=>c.getProjectionData({
                overscaledTileID: new (0, $1rqx5.d)(e1.tileID.canonical.z, e1.tileID.wrap ?? 0, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y),
                aligned: e1.aligned,
                applyGlobeMatrix: e1.applyGlobeMatrix,
                applyTerrainMatrix: e1.applyTerrainMatrix
            })
    }, d = o.renderingMode ? o.renderingMode : `2d`;
    if (r.currentPass === `offscreen`) {
        let t = o.prerender;
        t && (e1.setCustomLayerDefaults(), a.setColorMode(e1.colorModeForRenderPass()), t.call(o, a.gl, u), a.setDirty(), e1.setBaseState());
    } else if (r.currentPass === `translucent`) {
        e1.setCustomLayerDefaults(), a.setColorMode(e1.colorModeForRenderPass()), a.setStencilMode($834619e78bbf578c$var$Q.disabled);
        let t = d === `3d` ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, $834619e78bbf578c$var$Z.ReadOnly);
        a.setDepthMode(t), o.render(a.gl, u), a.setDirty(), e1.setBaseState(), a.bindFramebuffer.set(null);
    }
}
function $834619e78bbf578c$var$_p(e1, t) {
    let n = e1.context, r = n.gl, i = e1.transform, a = $834619e78bbf578c$var$Xd.unblended, o = new $834619e78bbf578c$var$Z(r.LEQUAL, $834619e78bbf578c$var$Z.ReadWrite, [
        0,
        1
    ]), s = t.tileManager.getRenderableTiles(), c = e1.useProgram(`terrainDepth`);
    n.bindFramebuffer.set(t.getFramebuffer().framebuffer), n.viewport.set([
        0,
        0,
        e1.width / devicePixelRatio,
        e1.height / devicePixelRatio
    ]), n.clear({
        color: (0, $1rqx5.fn).white,
        depth: 1
    });
    for (let e1 of s){
        let s = t.getTerrainMesh(e1.tileID), l = t.getTerrainData(e1.tileID), u = i.getProjectionData({
            overscaledTileID: e1.tileID,
            applyTerrainMatrix: !1,
            applyGlobeMatrix: !0
        }), d = $834619e78bbf578c$var$Il(t.getSkirtLength(i.zoom));
        c.draw(n, r.TRIANGLES, o, $834619e78bbf578c$var$Q.disabled, a, $834619e78bbf578c$var$$.backCCW, d, l, u, `terrain`, s.vertexBuffer, s.indexBuffer, s.segments);
    }
    n.bindFramebuffer.set(null), n.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $834619e78bbf578c$var$vp(e1, t, n, r) {
    let { isRenderingGlobe: i } = r, a = e1.context, o = a.gl, s = e1.transform, c = e1.colorModeForRenderPass(), l = e1.getDepthModeFor3D(), u = e1.useProgram(`terrain`);
    a.bindFramebuffer.set(null), a.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
    for (let d of n){
        let n = t.getTerrainMesh(d.tileID), f = e1.renderToTexture.getTexture(d), p = t.getTerrainData(d.tileID);
        a.activeTexture.set(o.TEXTURE0), f.bind(o.LINEAR, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_LINEAR);
        let m = t.getSkirtLength(s.zoom), h = s.calculateFogMatrix(d.tileID.toUnwrapped()), g = $834619e78bbf578c$var$Fl(m, h, e1.style.sky, s.pitch, i), _ = $834619e78bbf578c$var$nf(r, d.tileID, {
            applyTerrainMatrix: !1
        });
        u.draw(a, o.TRIANGLES, l, $834619e78bbf578c$var$Q.disabled, c, $834619e78bbf578c$var$$.backCCW, g, p, _, `terrain`, n.vertexBuffer, n.indexBuffer, n.segments);
    }
}
function $834619e78bbf578c$var$yp(e1, t) {
    if (!t.mesh) {
        let n = new (0, $1rqx5.Gt);
        n.emplaceBack(-1, -1), n.emplaceBack(1, -1), n.emplaceBack(1, 1), n.emplaceBack(-1, 1);
        let r = new (0, $1rqx5.Jt);
        r.emplaceBack(0, 1, 2), r.emplaceBack(0, 2, 3), t.mesh = new $834619e78bbf578c$var$Ja(e1.createVertexBuffer(n, $834619e78bbf578c$var$Ya.members), e1.createIndexBuffer(r), (0, $1rqx5.Bt).simpleSegment(0, 0, n.length, r.length));
    }
    return t.mesh;
}
function $834619e78bbf578c$var$bp(e1, t) {
    let n = e1.context, r = n.gl, i = $834619e78bbf578c$var$id(t, e1.transform, e1.pixelRatio), a = new $834619e78bbf578c$var$Z(r.LEQUAL, $834619e78bbf578c$var$Z.ReadWrite, [
        0,
        1
    ]), o = $834619e78bbf578c$var$Q.disabled, s = e1.colorModeForRenderPass(), c = e1.useProgram(`sky`), l = $834619e78bbf578c$var$yp(n, t);
    c.draw(n, r.TRIANGLES, a, o, s, $834619e78bbf578c$var$$.disabled, i, null, void 0, `sky`, l.vertexBuffer, l.indexBuffer, l.segments);
}
function $834619e78bbf578c$var$xp(e1, t) {
    let n = e1.getCartesianPosition();
    (0, $1rqx5.ri)(n, n);
    let r = (0, $1rqx5.Si)(/* @__PURE__ */ new Float64Array(16));
    return e1.properties.get(`anchor`) === `map` && ((0, $1rqx5.ki)(r, r, t.rollInRadians), (0, $1rqx5.Di)(r, r, -t.pitchInRadians), (0, $1rqx5.ki)(r, r, t.bearingInRadians), (0, $1rqx5.Di)(r, r, t.center.lat * Math.PI / 180), (0, $1rqx5.Oi)(r, r, -t.center.lng * Math.PI / 180)), (0, $1rqx5.pi)(n, n, r), n;
}
function $834619e78bbf578c$var$Sp(e1, t, n) {
    let r = e1.context, i = r.gl, a = e1.useProgram(`atmosphere`), o = new $834619e78bbf578c$var$Z(i.LEQUAL, $834619e78bbf578c$var$Z.ReadOnly, [
        0,
        1
    ]), s = e1.transform, c = $834619e78bbf578c$var$xp(n, e1.transform), l = s.getProjectionData({
        overscaledTileID: null,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }), u = $834619e78bbf578c$var$qc(s.worldSize, s.center.lat), d = $834619e78bbf578c$var$Jc(s), f = $834619e78bbf578c$var$dl((0, $1rqx5.ni)(d) - u, u), p = t.properties.get(`atmosphere-blend`) * l.projectionTransition * f;
    if (p === 0) return;
    let m = $834619e78bbf578c$var$nd(c, p, d, u, s.inverseProjectionMatrix), h = $834619e78bbf578c$var$yp(r, t);
    a.draw(r, i.TRIANGLES, o, $834619e78bbf578c$var$Q.disabled, $834619e78bbf578c$var$Xd.alphaBlended, $834619e78bbf578c$var$$.disabled, m, null, null, `atmosphere`, h.vertexBuffer, h.indexBuffer, h.segments);
}
const $834619e78bbf578c$var$Cp = {
    symbol: $834619e78bbf578c$var$lf,
    circle: $834619e78bbf578c$var$_f,
    heatmap: $834619e78bbf578c$var$vf,
    line: $834619e78bbf578c$var$Pf,
    fill: $834619e78bbf578c$var$Lf,
    fillExtrusion: $834619e78bbf578c$var$Vf,
    hillshade: $834619e78bbf578c$var$Uf,
    colorRelief: $834619e78bbf578c$var$Kf,
    raster: $834619e78bbf578c$var$Xf,
    background: $834619e78bbf578c$var$tp,
    sky: $834619e78bbf578c$var$bp,
    atmosphere: $834619e78bbf578c$var$Sp,
    custom: $834619e78bbf578c$var$gp,
    debug: $834619e78bbf578c$var$fp,
    debugPadding: $834619e78bbf578c$var$sp,
    terrainDepth: $834619e78bbf578c$var$_p
};
var $834619e78bbf578c$var$wp = class e1 {
    constructor(e1, t){
        this.drawFunctions = $834619e78bbf578c$var$Cp, this.context = new $834619e78bbf578c$var$Zd(e1), this.transform = t, this.layerOpacityFbo = null, this._tileTextures = {}, this._rttObjectRecyclePool = [], this._rttSharedFbo = null, this.terrainFacilitator = {
            depthDirty: !0,
            matrix: (0, $1rqx5.Si)(/* @__PURE__ */ new Float64Array(16)),
            renderTime: 0
        }, this.setup(), this.numSublayers = $834619e78bbf578c$var$Ko.maxOverzooming + $834619e78bbf578c$var$Ko.maxUnderzooming + 1, this.depthEpsilon = 1 / 2 ** 16, this.crossTileSymbolIndex = new $834619e78bbf578c$var$ec;
    }
    resize(e1, t, n) {
        if (this.width = Math.round(e1 * n), this.height = Math.round(t * n), this.pixelRatio = n, this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.style) for (let e1 of this.style._order)this.style._layers[e1].resize();
    }
    setup() {
        let e1 = this.context, t = new (0, $1rqx5.Gt);
        t.emplaceBack(0, 0), t.emplaceBack((0, $1rqx5.Lr), 0), t.emplaceBack(0, (0, $1rqx5.Lr)), t.emplaceBack((0, $1rqx5.Lr), (0, $1rqx5.Lr)), this.tileExtentBuffer = e1.createVertexBuffer(t, $834619e78bbf578c$var$Ya.members), this.tileExtentSegments = (0, $1rqx5.Bt).simpleSegment(0, 0, 4, 2);
        let n = new (0, $1rqx5.Gt);
        n.emplaceBack(0, 0), n.emplaceBack((0, $1rqx5.Lr), 0), n.emplaceBack(0, (0, $1rqx5.Lr)), n.emplaceBack((0, $1rqx5.Lr), (0, $1rqx5.Lr)), this.debugBuffer = e1.createVertexBuffer(n, $834619e78bbf578c$var$Ya.members), this.debugSegments = (0, $1rqx5.Bt).simpleSegment(0, 0, 4, 5);
        let r = new (0, $1rqx5.qt);
        r.emplaceBack(0, 0, 0, 0), r.emplaceBack((0, $1rqx5.Lr), 0, (0, $1rqx5.Lr), 0), r.emplaceBack(0, (0, $1rqx5.Lr), 0, (0, $1rqx5.Lr)), r.emplaceBack((0, $1rqx5.Lr), (0, $1rqx5.Lr), (0, $1rqx5.Lr), (0, $1rqx5.Lr)), this.rasterBoundsBuffer = e1.createVertexBuffer(r, $834619e78bbf578c$var$Al.members), this.rasterBoundsSegments = (0, $1rqx5.Bt).simpleSegment(0, 0, 4, 2);
        let i = new (0, $1rqx5.Gt);
        i.emplaceBack(0, 0), i.emplaceBack((0, $1rqx5.Lr), 0), i.emplaceBack(0, (0, $1rqx5.Lr)), i.emplaceBack((0, $1rqx5.Lr), (0, $1rqx5.Lr)), this.rasterBoundsBufferPosOnly = e1.createVertexBuffer(i, $834619e78bbf578c$var$Ya.members), this.rasterBoundsSegmentsPosOnly = (0, $1rqx5.Bt).simpleSegment(0, 0, 4, 5);
        let a = new (0, $1rqx5.Gt);
        a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, $834619e78bbf578c$var$Ya.members), this.viewportSegments = (0, $1rqx5.Bt).simpleSegment(0, 0, 4, 2);
        let o = new (0, $1rqx5.Ut);
        o.emplaceBack(0), o.emplaceBack(1), o.emplaceBack(3), o.emplaceBack(2), o.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(o);
        let s = new (0, $1rqx5.Jt);
        s.emplaceBack(1, 0, 2), s.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s);
        let c = this.context.gl;
        this.stencilClearMode = new $834619e78bbf578c$var$Q({
            func: c.ALWAYS,
            mask: 0
        }, 0, 255, c.ZERO, c.ZERO, c.ZERO), this.tileExtentMesh = new $834619e78bbf578c$var$Ja(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
    }
    clearStencil() {
        let e1 = this.context, t = e1.gl;
        this.nextStencilID = 1, this.currentStencilSource = void 0;
        let n = (0, $1rqx5.vi)();
        (0, $1rqx5.Ti)(n, 0, this.width, this.height, 0, 0, 1), (0, $1rqx5.Ai)(n, n, [
            t.drawingBufferWidth,
            t.drawingBufferHeight,
            0
        ]);
        let r = {
            mainMatrix: n,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: n,
            clipAntimeridian: !1
        };
        this.useProgram(`clippingMask`, null, !0).draw(e1, t.TRIANGLES, $834619e78bbf578c$var$Z.disabled, this.stencilClearMode, $834619e78bbf578c$var$Xd.disabled, $834619e78bbf578c$var$$.disabled, null, null, r, `$clipping`, this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
    }
    renderTileClippingMasks(e1, t) {
        if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !t?.length) return;
        this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
        let n = this.context;
        n.setColorMode($834619e78bbf578c$var$Xd.disabled), n.setDepthMode($834619e78bbf578c$var$Z.disabled);
        let r = {};
        for (let e1 of t)r[e1.key] = this.nextStencilID++;
        this.style.projection.useSubdivision && this._renderTileMasks(r, t, !0), this._renderTileMasks(r, t, !1), this._tileClippingMaskIDs = r;
    }
    _renderTileMasks(e1, t, n) {
        let r = this.context, i = r.gl, a = this.style.projection, o = this.renderContext, s = this.useProgram(`clippingMask`);
        for (let c of t){
            let t = e1[c.key], l = $834619e78bbf578c$var$rf(o, c), u = a.getMeshFromTileID(this.context, c.canonical, n, !0, `stencil`), d = $834619e78bbf578c$var$nf(o, c);
            s.draw(r, i.TRIANGLES, $834619e78bbf578c$var$Z.disabled, new $834619e78bbf578c$var$Q({
                func: i.ALWAYS,
                mask: 0
            }, t, 255, i.KEEP, i.KEEP, i.REPLACE), $834619e78bbf578c$var$Xd.disabled, o.isRenderingToTexture ? $834619e78bbf578c$var$$.disabled : $834619e78bbf578c$var$$.backCCW, null, l, d, `$clipping`, u.vertexBuffer, u.indexBuffer, u.segments);
        }
    }
    _renderTilesDepthBuffer() {
        let e1 = this.context, t = e1.gl, n = this.style.projection, r = this.transform, i = this.useProgram(`depth`), a = this.getDepthModeFor3D(), o = $834619e78bbf578c$var$Fo(r, {
            tileSize: r.tileSize
        });
        for (let r of o){
            let o = $834619e78bbf578c$var$rf(this.renderContext, r), s = n.getMeshFromTileID(this.context, r.canonical, !0, !0, `raster`), c = $834619e78bbf578c$var$nf(this.renderContext, r);
            i.draw(e1, t.TRIANGLES, a, $834619e78bbf578c$var$Q.disabled, $834619e78bbf578c$var$Xd.disabled, $834619e78bbf578c$var$$.backCCW, null, o, c, `$clipping`, s.vertexBuffer, s.indexBuffer, s.segments);
        }
    }
    stencilModeFor3D() {
        this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
        let e1 = this.nextStencilID++, t = this.context.gl;
        return new $834619e78bbf578c$var$Q({
            func: t.NOTEQUAL,
            mask: 255
        }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
    }
    stencilModeForClipping(e1) {
        let t = this.context.gl;
        return new $834619e78bbf578c$var$Q({
            func: t.EQUAL,
            mask: 255
        }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
    }
    getStencilConfigForOverlapAndUpdateStencilID(e1) {
        let t = this.context.gl, n = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = n[n.length - 1].overscaledZ, i = n[0].overscaledZ - r + 1;
        if (i > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + i > 256 && this.clearStencil();
            let e1 = {};
            for(let n = 0; n < i; n++)e1[n + r] = new $834619e78bbf578c$var$Q({
                func: t.GEQUAL,
                mask: 255
            }, n + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID += i, [
                e1,
                n
            ];
        }
        return [
            {
                [r]: $834619e78bbf578c$var$Q.disabled
            },
            n
        ];
    }
    stencilConfigForOverlapTwoPass(e1) {
        let t = this.context.gl, n = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = n[n.length - 1].overscaledZ, i = n[0].overscaledZ - r + 1;
        if (this.clearStencil(), i > 1) {
            let e1 = {}, a = {};
            for(let n = 0; n < i; n++)e1[n + r] = new $834619e78bbf578c$var$Q({
                func: t.GREATER,
                mask: 255
            }, i + 1 + n, 255, t.KEEP, t.KEEP, t.REPLACE), a[n + r] = new $834619e78bbf578c$var$Q({
                func: t.GREATER,
                mask: 255
            }, 1 + n, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID = i * 2 + 1, [
                e1,
                a,
                n
            ];
        }
        return this.nextStencilID = 3, [
            {
                [r]: new $834619e78bbf578c$var$Q({
                    func: t.GREATER,
                    mask: 255
                }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            {
                [r]: new $834619e78bbf578c$var$Q({
                    func: t.GREATER,
                    mask: 255
                }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            n
        ];
    }
    colorModeForRenderPass() {
        let e1 = this.context.gl;
        if (this._showOverdrawInspector) {
            let t = 1 / 8;
            return new $834619e78bbf578c$var$Xd([
                e1.CONSTANT_COLOR,
                e1.ONE
            ], new (0, $1rqx5.fn)(t, t, t, 0), [
                !0,
                !0,
                !0,
                !0
            ]);
        }
        return this.renderContext.currentPass === `opaque` ? $834619e78bbf578c$var$Xd.unblended : $834619e78bbf578c$var$Xd.alphaBlended;
    }
    getDepthModeForSublayer(e1, t, n) {
        if (!this.opaquePassEnabledForLayer()) return $834619e78bbf578c$var$Z.disabled;
        let r = 1 - ((1 + this.renderContext.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
        return new $834619e78bbf578c$var$Z(n || this.context.gl.LEQUAL, t, [
            r,
            r
        ]);
    }
    getDepthModeFor3D() {
        return new $834619e78bbf578c$var$Z(this.context.gl.LEQUAL, $834619e78bbf578c$var$Z.ReadWrite, this.renderContext.depthRangeFor3D);
    }
    opaquePassEnabledForLayer() {
        return this.renderContext.currentLayer < this.renderContext.opaquePassCutoff;
    }
    render(e1, t) {
        this.style = e1, this.options = t;
        let n = this.renderContext = $834619e78bbf578c$var$tf(this.transform, e1.projection, e1.map.terrain ?? null);
        this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.patternAtlas = e1.patternAtlas, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange($834619e78bbf578c$export$461939dd4422153()), $834619e78bbf578c$var$Yd(this.context.frameUniformBuffer, this), this.imageManager.beginFrame(), $834619e78bbf578c$var$ql(this.context);
        let r = this.style._order, i = this.style.tileManagers, a = {}, o = {}, s = {};
        for(let e1 in i){
            let t = i[e1];
            t.used && t.prepare(this.context), a[e1] = t.getVisibleCoordinates(!1), o[e1] = a[e1].slice().reverse(), s[e1] = t.getVisibleCoordinates(!0).reverse();
        }
        n.opaquePassCutoff = 1 / 0;
        for(let e1 = 0; e1 < r.length; e1++){
            let t = r[e1];
            if (this.style._layers[t].is3D()) {
                n.opaquePassCutoff = e1;
                break;
            }
        }
        this.maybeDrawDepth(), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), n.opaquePassCutoff = 0), n.currentPass = `offscreen`;
        for (let e1 of r){
            let t = this.style._layers[e1];
            if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
            let r = o[t.source];
            (t.type === `custom` || r.length) && this.renderLayer(this, i[t.source], t, r, n);
        }
        if (this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.bindFramebuffer.set(null), this.context.clear({
            color: t.showOverdrawInspector ? (0, $1rqx5.fn).black : (0, $1rqx5.fn).transparent,
            depth: 1
        }), this.clearStencil(), this.style.sky && this.drawFunctions.sky(this, this.style.sky), this._showOverdrawInspector = t.showOverdrawInspector, n.depthRangeFor3D = [
            0,
            1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
        ], !this.renderToTexture) for(n.currentPass = `opaque`, n.currentLayer = r.length - 1; n.currentLayer >= 0; n.currentLayer--){
            let e1 = this.style._layers[r[n.currentLayer]];
            if (e1.isHidden(this.transform.zoom)) continue;
            let t = i[e1.source], o = a[e1.source];
            this.renderTileClippingMasks(e1, o), this.renderLayer(this, t, e1, o, n);
        }
        n.currentPass = `translucent`;
        let c = !1;
        for(n.currentLayer = 0; n.currentLayer < r.length; n.currentLayer++){
            let e1 = this.style._layers[r[n.currentLayer]];
            if (e1.isHidden(this.transform.zoom)) continue;
            let t = i[e1.source];
            if (this.renderToTexture?.renderLayer(e1, n)) continue;
            !this.opaquePassEnabledForLayer() && !c && (c = !0, n.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
            let l = (e1.type === `symbol` ? s : o)[e1.source];
            this.renderTileClippingMasks(e1, a[e1.source]), this.renderLayer(this, t, e1, l, n);
        }
        if (n.isRenderingGlobe && this.drawFunctions.atmosphere(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
            let e1 = $834619e78bbf578c$var$hp(this.style, this.transform.zoom);
            e1 && this.drawFunctions.debug(this, e1, e1.getVisibleCoordinates(), n);
        }
        this.options.showPadding && this.drawFunctions.debugPadding(this), this.renderToTexture && !this.options.moving && this.clearRTTPool(), this.context.setDefault();
    }
    markTerrainDepthDirty() {
        this.terrainFacilitator.depthDirty = !0;
    }
    maybeDrawDepth() {
        if (!this.style?.projection || !this.style.map?.terrain) return;
        let e1 = this.terrainFacilitator.matrix, t = this.transform.modelViewProjectionMatrix, n = this.terrainFacilitator.depthDirty;
        n ||= !(0, $1rqx5.yi)(e1, t), n ||= this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime), n && ((0, $1rqx5._i)(e1, t), this.terrainFacilitator.renderTime = $834619e78bbf578c$export$461939dd4422153(), this.terrainFacilitator.depthDirty = !1, this.drawFunctions.terrainDepth(this, this.style.map.terrain));
    }
    renderLayer(e1, t, n, r, i) {
        if (n.isHidden(this.transform.zoom) || n.type !== `background` && n.type !== `custom` && !(r || []).length) return;
        this.id = n.id;
        let a = this.drawFunctions;
        (0, $1rqx5.x)(n) ? a.symbol(e1, t, n, r, this.style.placement.variableOffsets, i) : (0, $1rqx5.Ot)(n) ? a.circle(e1, t, n, r, i) : (0, $1rqx5.wt)(n) ? a.heatmap(e1, t, n, r, i) : (0, $1rqx5.W)(n) ? a.line(e1, t, n, r, i) : (0, $1rqx5.mt)(n) ? a.fill(e1, t, n, r, i) : (0, $1rqx5.K)(n) ? a.fillExtrusion(e1, t, n, r, i) : (0, $1rqx5.St)(n) ? a.hillshade(e1, t, n, r, i) : (0, $1rqx5.yt)(n) ? a.colorRelief(e1, t, n, r, i) : (0, $1rqx5.Xt)(n) ? a.raster(e1, t, n, r, i) : (0, $1rqx5.b)(n) ? a.background(e1, t, n, r, i) : (0, $1rqx5.v)(n) && a.custom(e1, t, n, i);
    }
    static{
        this.MAX_TEXTURE_POOL_SIZE_PER_BUCKET = 50;
    }
    saveTileTexture(t) {
        let n = this._tileTextures[t.size[0]];
        n ? n.length < e1.MAX_TEXTURE_POOL_SIZE_PER_BUCKET ? n.push(t) : t.destroy() : this._tileTextures[t.size[0]] = [
            t
        ];
    }
    getTileTexture(e1) {
        let t = this._tileTextures[e1];
        return t && t.length > 0 ? t.pop() : null;
    }
    acquireRTT(e1) {
        let t = this.context.gl, n = this._rttObjectRecyclePool.pop();
        if (n) return n.size !== e1 && (n.texture.update({
            width: e1,
            height: e1,
            data: null
        }, {
            premultiply: !1,
            useMipmap: !0
        }), n.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE, t.LINEAR_MIPMAP_LINEAR), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), n.size = e1), n;
        let r = new (0, $1rqx5.xt)(this.context, {
            width: e1,
            height: e1,
            data: null
        }, t.RGBA, {
            premultiply: !1,
            useMipmap: !0
        });
        return r.bind(t.LINEAR, t.CLAMP_TO_EDGE, t.LINEAR_MIPMAP_LINEAR), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), {
            texture: r,
            size: e1
        };
    }
    bindRTT(e1) {
        let t = this.context.gl, n = e1.size;
        if (!this._rttSharedFbo) {
            let e1 = this.context.createFramebuffer(n, n, !0, !0), r = this.context.createRenderbuffer(t.DEPTH_STENCIL, n, n);
            e1.depthAttachment.set(r), this._rttSharedFbo = {
                fbo: e1,
                depthRenderbuffer: r,
                size: n
            };
        }
        this._rttSharedFbo.size !== n && (this.context.bindRenderbuffer.set(this._rttSharedFbo.depthRenderbuffer), t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, n, n), this.context.bindRenderbuffer.set(null), this._rttSharedFbo.fbo.width = n, this._rttSharedFbo.fbo.height = n, this._rttSharedFbo.size = n), this._rttSharedFbo.fbo.colorAttachment.set(e1.texture.texture), this.context.bindFramebuffer.set(this._rttSharedFbo.fbo.framebuffer);
    }
    releaseRTT(e1) {
        this._rttObjectRecyclePool.push(e1);
    }
    clearRTTPool() {
        for (let e1 of this._rttObjectRecyclePool)e1.texture.destroy();
        this._rttObjectRecyclePool.length = 0;
    }
    destroyRTTResources() {
        if (this.clearRTTPool(), !this._rttSharedFbo) return;
        this._rttSharedFbo.fbo.colorAttachment.set(null), this._rttSharedFbo.fbo.depthAttachment.set(null);
        let e1 = this.context.gl;
        e1.deleteRenderbuffer(this._rttSharedFbo.depthRenderbuffer), e1.deleteFramebuffer(this._rttSharedFbo.fbo.framebuffer), this._rttSharedFbo = null;
    }
    isPatternMissing(e1) {
        if (!e1) return !1;
        if (!e1.from || !e1.to) return !0;
        let t = this.patternAtlas.getPattern(e1.from.toString()), n = this.patternAtlas.getPattern(e1.to.toString());
        return !t || !n;
    }
    useProgram(e1, t, n = !1, r = []) {
        this.cache ||= {};
        let i = !!this.style.map.terrain, a = this.style.projection, o = n ? $834619e78bbf578c$var$uc.projectionMercator : a.shaderPreludeCode, s = n ? $834619e78bbf578c$var$dc : a.shaderDefine, c = `/${n ? $834619e78bbf578c$var$fc : a.shaderVariantName}`, l = t ? t.cacheKey : ``, u = this._showOverdrawInspector ? `/overdraw` : ``, d = i ? `/terrain` : ``, f = r ? `/${r.join(`/`)}` : ``, p = e1 + l + c + u + d + f;
        return this.cache[p] ||= new $834619e78bbf578c$var$tu(this.context, $834619e78bbf578c$var$uc[e1], t, $834619e78bbf578c$var$od[e1], this._showOverdrawInspector, i, o, s, r), this.cache[p];
    }
    setCustomLayerDefaults() {
        this.context.setCustomLayerDefaults();
    }
    setBaseState() {
        let e1 = this.context.gl;
        this.context.cullFace.set(!1), this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.blendEquation.set(e1.FUNC_ADD);
    }
    initDebugOverlayCanvas() {
        if (this.debugOverlayCanvas == null) {
            this.debugOverlayCanvas = document.createElement(`canvas`), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
            let e1 = this.context.gl;
            this.debugOverlayTexture = new (0, $1rqx5.xt)(this.context, this.debugOverlayCanvas, e1.RGBA);
        }
    }
    destroy() {
        if (this._tileTextures) {
            for(let e1 in this._tileTextures){
                let t = this._tileTextures[e1];
                if (t) for (let e1 of t)e1.destroy();
            }
            this._tileTextures = {};
        }
        if (this.destroyRTTResources(), this.layerOpacityFbo?.destroy(), this.layerOpacityFbo = null, this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && this.tileExtentMesh.vertexBuffer?.destroy(), this.tileExtentMesh && this.tileExtentMesh.indexBuffer?.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), $834619e78bbf578c$var$Jl(this.context), this.context.terrainUniformBuffer.destroy(), this.context.frameUniformBuffer.destroy(), this.cache) {
            for(let e1 in this.cache){
                let t = this.cache[e1];
                t?.program && this.context.gl.deleteProgram(t.program);
            }
            this.cache = {};
        }
        this.context && this.context.setDefault();
    }
    overLimit() {
        let { drawingBufferWidth: e1, drawingBufferHeight: t } = this.context.gl;
        return this.width !== e1 || this.height !== t;
    }
}, $834619e78bbf578c$export$68b5dc085315a832 = class extends Error {
    constructor(e1, t){
        super(`WebGL2 is required to display this map. We are sorry, but it seems that your browser does not support WebGL2, a technology for rendering 3D graphics on the web. Read more on https://wiki.openstreetmap.org/wiki/This_map_requires_WebGL`), this.name = `GPUInitializationError`, this.requestedAttributes = e1, this.statusMessage = t?.statusMessage ?? null;
    }
};
function $834619e78bbf578c$var$Ep(e1, t) {
    let n = !1, r = null, i, a = ()=>{
        r = null, n &&= (e1(...i), r = setTimeout(a, t), !1);
    };
    return (...e1)=>(n = !0, i = e1, r || a(), r);
}
var $834619e78bbf578c$export$ab85ecd77ce6a5cd = class {
    constructor(e1){
        this._getHashParams = ()=>new URLSearchParams(window.location.hash.replace(`#`, ``)), this._getCurrentHash = ()=>{
            let e1 = this._getHashParams();
            return this._hashName ? (e1.get(this._hashName) || ``).split(`/`) : ([
                ...e1.keys()
            ][0] ?? ``).split(`/`);
        }, this._onHashChange = ()=>{
            let e1 = this._getCurrentHash();
            if (!this._isValidHash(e1)) return !1;
            let t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e1[3] || 0) : this._map.getBearing();
            return this._map.jumpTo({
                center: [
                    +e1[2],
                    +e1[1]
                ],
                zoom: +e1[0],
                bearing: t,
                pitch: +(e1[4] || 0)
            }), !0;
        }, this._updateHashUnthrottled = ()=>{
            let e1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
            window.history.replaceState(window.history.state, null, e1);
        }, this._removeHash = ()=>{
            let e1 = this._getHashParams();
            if (this._hashName) e1.delete(this._hashName);
            else {
                let t = Array.from(e1.keys());
                t.length > 0 && e1.delete(t[0]);
            }
            let t = decodeURIComponent(e1.toString()).replace(/=&/g, `&`).replace(/=$/g, ``), n = t ? `#${t}` : ``, r = window.location.href.replace(/(#.+)?$/, n);
            r = r.replace(`&&`, `&`), window.history.replaceState(window.history.state, null, r);
        }, this._updateHash = $834619e78bbf578c$var$Ep(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
    }
    addTo(e1) {
        return this._map = e1, addEventListener(`hashchange`, this._onHashChange, !1), this._map.on(`moveend`, this._updateHash), this;
    }
    remove() {
        return removeEventListener(`hashchange`, this._onHashChange, !1), this._map.off(`moveend`, this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
    }
    getHashString(e1) {
        let t = this._map.getCenter(), n = Math.round(this._map.getZoom() * 100) / 100, r = 10 ** Math.ceil((n * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), i = Math.round(t.lng * r) / r, a = Math.round(t.lat * r) / r, o = this._map.getBearing(), s = this._map.getPitch(), c = ``;
        if (c += e1 ? `/${i}/${a}/${n}` : `${n}/${a}/${i}`, (o || s) && (c += `/${Math.round(o * 10) / 10}`), s && (c += `/${Math.round(s)}`), this._hashName) {
            let e1 = this._getHashParams();
            return e1.set(this._hashName, c), `#${decodeURIComponent(e1.toString()).replace(/=&/g, `&`).replace(/=$/g, ``)}`;
        }
        return `#${c}`;
    }
    _isValidHash(e1) {
        if (e1.length < 3 || e1.some((e1)=>isNaN(+e1))) return !1;
        try {
            new (0, $1rqx5.lt)(+e1[2], +e1[1]);
        } catch  {
            return !1;
        }
        let t = +e1[0], n = +(e1[3] || 0), r = +(e1[4] || 0);
        return t >= this._map.getMinZoom() && t <= this._map.getMaxZoom() && n >= -180 && n <= 180 && r >= this._map.getMinPitch() && r <= this._map.getMaxPitch();
    }
};
const $834619e78bbf578c$var$Op = {
    linearity: .3,
    easing: (0, $1rqx5.zn)(0, 0, .3, 1)
}, $834619e78bbf578c$var$kp = (0, $1rqx5.er)({
    deceleration: 2500,
    maxSpeed: 1400
}, $834619e78bbf578c$var$Op), $834619e78bbf578c$var$Ap = (0, $1rqx5.er)({
    deceleration: 20,
    maxSpeed: 1400
}, $834619e78bbf578c$var$Op), $834619e78bbf578c$var$jp = (0, $1rqx5.er)({
    deceleration: 1e3,
    maxSpeed: 360
}, $834619e78bbf578c$var$Op), $834619e78bbf578c$var$Mp = (0, $1rqx5.er)({
    deceleration: 1e3,
    maxSpeed: 90
}, $834619e78bbf578c$var$Op), $834619e78bbf578c$var$Np = (0, $1rqx5.er)({
    deceleration: 1e3,
    maxSpeed: 360
}, $834619e78bbf578c$var$Op);
var $834619e78bbf578c$var$Pp = class {
    constructor(e1){
        this._map = e1, this.clear();
    }
    clear() {
        this._inertiaBuffer = [];
    }
    record(e1) {
        this._drainInertiaBuffer(), this._inertiaBuffer.push({
            time: $834619e78bbf578c$export$461939dd4422153(),
            settings: e1
        });
    }
    _drainInertiaBuffer() {
        let e1 = this._inertiaBuffer, t = $834619e78bbf578c$export$461939dd4422153();
        for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
    }
    _getVelocityEntries() {
        let e1 = this._inertiaBuffer, t = $834619e78bbf578c$export$461939dd4422153() - 60, n = Math.max(0, e1.length - 2);
        for(; n > 0 && e1[n - 1].time >= t;)n--;
        return e1.slice(n);
    }
    _onMoveEnd(e1) {
        this._drainInertiaBuffer();
        let n = this._getVelocityEntries();
        if (n.length < 2) {
            this.clear();
            return;
        }
        let r = {
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            pan: new (0, $1rqx5.Li)(0, 0),
            pinchAround: void 0,
            around: void 0
        };
        for (let { settings: e1 } of n)e1.around && (r.around = e1.around), e1.pinchAround && (r.pinchAround = e1.pinchAround);
        for (let { settings: e1 } of n.slice(1))r.zoom += e1.zoomDelta || 0, r.bearing += e1.bearingDelta || 0, r.pitch += e1.pitchDelta || 0, r.roll += e1.rollDelta || 0, e1.panDelta && r.pan._add(e1.panDelta);
        if (!r.pan.mag() && !r.zoom && !r.bearing && !r.pitch && !r.roll) {
            this.clear();
            return;
        }
        let i = $834619e78bbf578c$export$461939dd4422153() - n[0].time, a = {};
        if (r.pan.mag()) {
            let t = $834619e78bbf578c$var$Ip(r.pan.mag(), i, (0, $1rqx5.er)({}, $834619e78bbf578c$var$kp, e1 || {})), n = r.pan.mult(t.amount / r.pan.mag()), o = this._map._camera.cameraHelper.handlePanInertia(n, this._map._camera.transform);
            a.center = o.easingCenter, a.offset = o.easingOffset, $834619e78bbf578c$var$Fp(a, t);
        }
        if (r.zoom) {
            let e1 = $834619e78bbf578c$var$Ip(r.zoom, i, $834619e78bbf578c$var$Ap);
            a.zoom = (0, $1rqx5.$n)(this._map.getZoom() + e1.amount, this._map.getZoomSnap(), e1.amount), $834619e78bbf578c$var$Fp(a, e1);
        }
        if (r.bearing) {
            let e1 = $834619e78bbf578c$var$Ip(r.bearing, i, $834619e78bbf578c$var$jp);
            a.bearing = this._map.getBearing() + (0, $1rqx5.Bn)(e1.amount, -179, 179), $834619e78bbf578c$var$Fp(a, e1);
        }
        if (r.pitch) {
            let e1 = $834619e78bbf578c$var$Ip(r.pitch, i, $834619e78bbf578c$var$Mp);
            a.pitch = this._map.getPitch() + e1.amount, $834619e78bbf578c$var$Fp(a, e1);
        }
        if (r.roll) {
            let e1 = $834619e78bbf578c$var$Ip(r.roll, i, $834619e78bbf578c$var$Np);
            a.roll = this._map.getRoll() + (0, $1rqx5.Bn)(e1.amount, -179, 179), $834619e78bbf578c$var$Fp(a, e1);
        }
        if (a.zoom || a.bearing) {
            let e1 = r.pinchAround === void 0 ? r.around : r.pinchAround;
            a.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
        }
        return this.clear(), (0, $1rqx5.er)(a, {
            noMoveStart: !0
        });
    }
};
function $834619e78bbf578c$var$Fp(e1, t) {
    (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
}
function $834619e78bbf578c$var$Ip(e1, t, n) {
    let { maxSpeed: r, linearity: i, deceleration: a } = n, o = (0, $1rqx5.Bn)(e1 * i / (t / 1e3), -r, r), s = Math.abs(o) / (a * i);
    return {
        easing: n.easing,
        duration: s * 1e3,
        amount: s / 2 * o
    };
}
var $834619e78bbf578c$var$Lp = class {
    constructor(e1, t){
        this._map = e1, this._clickTolerance = t.clickTolerance;
    }
    reset() {
        delete this._mousedownPos;
    }
    wheel(e1) {
        return this._firePreventable(new $834619e78bbf578c$export$10870e40d23509f(this._map, e1));
    }
    mousedown(e1, t) {
        return this._mousedownPos = t, this._firePreventable(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseup(e1) {
        this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    click(e1, t) {
        this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    dblclick(e1) {
        return this._firePreventable(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseover(e1) {
        this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseout(e1) {
        this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    touchstart(e1) {
        return this._firePreventable(new $834619e78bbf578c$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchmove(e1) {
        this._map.fire(new $834619e78bbf578c$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchend(e1) {
        this._map.fire(new $834619e78bbf578c$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchcancel(e1) {
        this._map.fire(new $834619e78bbf578c$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    _firePreventable(e1) {
        if (this._map.fire(e1), e1.defaultPrevented) return {};
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $834619e78bbf578c$var$Rp = class {
    constructor(e1, t){
        this._map = e1, this._clickTolerance = t.clickTolerance;
    }
    reset() {
        this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent, this._clearLongPress(), this._touchActive = !1;
    }
    mousemove(e1) {
        this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mousedown() {
        this._delayContextMenu = !0, this._ignoreContextMenu = !1;
    }
    mouseup() {
        this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(`contextmenu`, this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
    }
    touchstart(e1, t, n) {
        if (this._clearLongPress(), this._touchActive = n.length > 0, n.length !== 1) return;
        this._longPressStart = t[0];
        let r = n[0];
        this._longPressTimer = setTimeout(()=>{
            this._longPressTimer = void 0;
            let e1 = new MouseEvent(`contextmenu`, {
                clientX: r.clientX,
                clientY: r.clientY,
                button: 2,
                bubbles: !0,
                cancelable: !0
            });
            this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(`contextmenu`, this._map, e1));
        }, 500);
    }
    touchmove(e1, t, n) {
        this._longPressTimer && (n.length !== 1 || !this._longPressStart || t[0].dist(this._longPressStart) > this._clickTolerance) && this._clearLongPress();
    }
    touchend() {
        this._touchActive = !1, this._clearLongPress();
    }
    touchcancel() {
        this._touchActive = !1, this._clearLongPress();
    }
    _clearLongPress() {
        this._longPressTimer &&= (clearTimeout(this._longPressTimer), void 0), this._longPressStart = void 0;
    }
    contextmenu(e1) {
        if (this._touchActive) {
            e1.preventDefault();
            return;
        }
        this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new $834619e78bbf578c$export$83f023c8e5acf676(e1.type, this._map, e1)), this._map.listens(`contextmenu`) && e1.preventDefault();
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $834619e78bbf578c$export$bd01c6f06175f3af = class {
    constructor(e1, t, n){
        this._map = e1, this._tr = n, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1, t.boxZoom && typeof t.boxZoom == `object` && (this._boxZoomEnd = t.boxZoom.boxZoomEnd);
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
    enable() {
        this.isEnabled() || (this._enabled = !0);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    mousedown(e1, t) {
        this.isEnabled() && e1.shiftKey && e1.button === 0 && ($834619e78bbf578c$var$G.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
    }
    mousemoveWindow(e1, t) {
        if (!this._active) return;
        let n = t;
        if (this._lastPos.equals(n) || !this._box && n.dist(this._startPos) < this._clickTolerance) return;
        let r = this._startPos;
        this._lastPos = n, this._box || (this._box = $834619e78bbf578c$var$G.create(`div`, `maplibregl-boxzoom`, this._container), this._container.classList.add(`maplibregl-crosshair`), this._fireEvent(`boxzoomstart`, e1));
        let i = Math.min(r.x, n.x), a = Math.max(r.x, n.x), o = Math.min(r.y, n.y), s = Math.max(r.y, n.y);
        this._box.style.transform = `translate(${i}px,${o}px)`, this._box.style.width = `${a - i}px`, this._box.style.height = `${s - o}px`;
    }
    mouseupWindow(e1, t) {
        if (!this._active || e1.button !== 0) return;
        let n = this._startPos, r = t;
        if (this.reset(), $834619e78bbf578c$var$G.suppressClick(), n.x === r.x && n.y === r.y) this._fireEvent(`boxzoomcancel`, e1);
        else {
            if (this._map.fire(new $834619e78bbf578c$export$702e4d7a848278fa(`boxzoomend`, {
                originalEvent: e1
            })), this._boxZoomEnd) {
                this._boxZoomEnd(this._map, n, r, e1);
                return;
            }
            return {
                cameraAnimation: (e1)=>e1.fitScreenCoordinates(n, r, this._tr.bearing, {
                        linear: !0
                    })
            };
        }
    }
    keydown(e1) {
        this._active && e1.keyCode === 27 && (this.reset(), this._fireEvent(`boxzoomcancel`, e1));
    }
    reset() {
        this._active = !1, this._container.classList.remove(`maplibregl-crosshair`), this._box &&= (this._box.remove(), null), $834619e78bbf578c$var$G.enableDrag(), delete this._startPos, delete this._lastPos;
    }
    _fireEvent(e1, t) {
        return this._map.fire(new $834619e78bbf578c$export$702e4d7a848278fa(e1, {
            originalEvent: t
        }));
    }
};
function $834619e78bbf578c$var$Bp(e1, t) {
    if (e1.length !== t.length) throw Error(`The number of touches and points are not equal - touches ${e1.length}, points ${t.length}`);
    let n = {};
    for(let r = 0; r < e1.length; r++)n[e1[r].identifier] = t[r];
    return n;
}
function $834619e78bbf578c$var$Vp(e1) {
    let t = new (0, $1rqx5.Li)(0, 0);
    for (let n of e1)t._add(n);
    return t.div(e1.length);
}
var $834619e78bbf578c$var$Hp = class {
    constructor(e1){
        this.reset(), this.numTouches = e1.numTouches;
    }
    reset() {
        delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
    }
    touchstart(e1, t, n) {
        (this.centroid || n.length > this.numTouches) && (this.aborted = !0), !this.aborted && (this.startTime === void 0 && (this.startTime = e1.timeStamp), n.length === this.numTouches && (this.centroid = $834619e78bbf578c$var$Vp(t), this.touches = $834619e78bbf578c$var$Bp(n, t)));
    }
    touchmove(e1, t, n) {
        if (this.aborted || !this.centroid) return;
        let r = $834619e78bbf578c$var$Bp(n, t);
        for(let e1 in this.touches){
            let t = this.touches[e1], n = r[e1];
            (!n || n.dist(t) > 30) && (this.aborted = !0);
        }
    }
    touchend(e1, t, n) {
        if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), n.length === 0) {
            let e1 = !this.aborted && this.centroid;
            if (this.reset(), e1) return e1;
        }
    }
}, $834619e78bbf578c$var$Up = class {
    constructor(e1){
        this.singleTap = new $834619e78bbf578c$var$Hp(e1), this.numTaps = e1.numTaps, this.reset();
    }
    reset() {
        this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
    }
    touchstart(e1, t, n) {
        this.singleTap.touchstart(e1, t, n);
    }
    touchmove(e1, t, n) {
        this.singleTap.touchmove(e1, t, n);
    }
    touchend(e1, t, n) {
        let r = this.singleTap.touchend(e1, t, n);
        if (r) {
            let t = e1.timeStamp - this.lastTime < 500, n = !this.lastTap || this.lastTap.dist(r) < 30;
            if ((!t || !n) && this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = r, this.count === this.numTaps) return this.reset(), r;
        }
    }
}, $834619e78bbf578c$var$Wp = class {
    constructor(e1, t){
        this._tr = t, this._zoomIn = new $834619e78bbf578c$var$Up({
            numTouches: 1,
            numTaps: 2
        }), this._zoomOut = new $834619e78bbf578c$var$Up({
            numTouches: 2,
            numTaps: 1
        }), this.reset();
    }
    reset() {
        this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
    }
    touchstart(e1, t, n) {
        this._zoomIn.touchstart(e1, t, n), this._zoomOut.touchstart(e1, t, n);
    }
    touchmove(e1, t, n) {
        this._zoomIn.touchmove(e1, t, n), this._zoomOut.touchmove(e1, t, n);
    }
    touchend(e1, n, r) {
        let i = this._zoomIn.touchend(e1, n, r), a = this._zoomOut.touchend(e1, n, r), o = this._tr;
        if (i) return this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (n)=>n.easeTo({
                    duration: 300,
                    zoom: (0, $1rqx5.$n)(o.zoom + 1, n.getZoomSnap()),
                    around: o.transform.isPointOnMapSurface(i) ? o.unproject(i) : void 0
                }, {
                    originalEvent: e1
                })
        };
        if (a) return this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (n)=>n.easeTo({
                    duration: 300,
                    zoom: (0, $1rqx5.$n)(o.zoom - 1, n.getZoomSnap()),
                    around: o.transform.isPointOnMapSurface(a) ? o.unproject(a) : void 0
                }, {
                    originalEvent: e1
                })
        };
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $834619e78bbf578c$var$Gp = class {
    constructor(e1){
        this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
    }
    reset(e1) {
        this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
    }
    _move(...e1) {
        let t = this._moveFunction(...e1);
        if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
    }
    dragStart(e1, t) {
        this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
    }
    dragMove(e1, t) {
        if (!this.isEnabled()) return;
        let n = this._lastPoint;
        if (!n) return;
        if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) {
            this.reset(e1);
            return;
        }
        let r = Array.isArray(t) ? t[0] : t;
        if (!(!this._moved && r.dist(n) < this._clickTolerance)) return this._moved = !0, this._lastPoint = r, this._move(n, r);
    }
    dragEnd(e1) {
        this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e1) && (this._moved && $834619e78bbf578c$var$G.suppressClick(), this.reset(e1));
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    getClickTolerance() {
        return this._clickTolerance;
    }
};
const $834619e78bbf578c$var$Kp = {
    0: 1,
    2: 2
};
function $834619e78bbf578c$var$qp(e1, t) {
    let n = $834619e78bbf578c$var$Kp[t];
    return e1.buttons === void 0 || (e1.buttons & n) !== n;
}
var $834619e78bbf578c$var$Jp = class {
    constructor(e1){
        this._correctEvent = e1.checkCorrectEvent;
    }
    startMove(e1) {
        this._eventButton = e1.button;
    }
    endMove(e1) {
        delete this._eventButton;
    }
    isValidStartEvent(e1) {
        return this._correctEvent(e1);
    }
    isValidMoveEvent(e1) {
        return !$834619e78bbf578c$var$qp(e1, this._eventButton);
    }
    isValidEndEvent(e1) {
        return e1.button === this._eventButton;
    }
}, $834619e78bbf578c$var$Yp = class {
    constructor(){
        this._firstTouch = void 0;
    }
    _isOneFingerTouch(e1) {
        return e1.targetTouches.length === 1;
    }
    _isSameTouchEvent(e1) {
        return e1.targetTouches[0].identifier === this._firstTouch;
    }
    startMove(e1) {
        this._firstTouch = e1.targetTouches[0].identifier;
    }
    endMove(e1) {
        delete this._firstTouch;
    }
    isValidStartEvent(e1) {
        return this._isOneFingerTouch(e1);
    }
    isValidMoveEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
    isValidEndEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
}, $834619e78bbf578c$var$Xp = class {
    constructor(e1 = new $834619e78bbf578c$var$Jp({
        checkCorrectEvent: ()=>!0
    }), t = new $834619e78bbf578c$var$Yp){
        this.mouseMoveStateManager = e1, this.oneFingerTouchMoveStateManager = t;
    }
    _executeRelevantHandler(e1, t, n) {
        if (e1 instanceof MouseEvent) return t(e1);
        if (typeof TouchEvent < `u` && e1 instanceof TouchEvent) return n(e1);
    }
    startMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.startMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.startMove(e1);
        });
    }
    endMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.endMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.endMove(e1);
        });
    }
    isValidStartEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidStartEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e1));
    }
    isValidMoveEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidMoveEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1));
    }
    isValidEndEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidEndEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e1));
    }
};
const $834619e78bbf578c$var$Zp = (e1)=>{
    e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = (e1)=>{
        e1.preventDefault();
    };
};
function $834619e78bbf578c$var$Qp({ enable: e1, clickTolerance: t }) {
    return new $834619e78bbf578c$var$Gp({
        clickTolerance: t,
        move: (e1, t)=>({
                around: t,
                panDelta: t.sub(e1)
            }),
        activateOnStart: !0,
        moveStateManager: new $834619e78bbf578c$var$Jp({
            checkCorrectEvent: (e1)=>e1.button === 0 && !e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $834619e78bbf578c$var$Zp
    });
}
function $834619e78bbf578c$var$$p({ enable: e1, clickTolerance: t, aroundCenter: n = !0, minPixelCenterThreshold: r = 100, rotateSpeed: i = .8 }, a) {
    return new $834619e78bbf578c$var$Gp({
        clickTolerance: t,
        move: (e1, t)=>{
            let o = a();
            if (n && Math.abs(o.y - e1.y) > r) return {
                bearingDelta: (0, $1rqx5.ir)(new (0, $1rqx5.Li)(e1.x, t.y), t, o)
            };
            let s = (t.x - e1.x) * i;
            return n && t.y < o.y && (s = -s), {
                bearingDelta: s
            };
        },
        moveStateManager: new $834619e78bbf578c$var$Jp({
            checkCorrectEvent: (e1)=>e1.button === 0 && e1.ctrlKey || e1.button === 2 && !e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $834619e78bbf578c$var$Zp
    });
}
function $834619e78bbf578c$var$em({ enable: e1, clickTolerance: t, pitchSpeed: n = -0.5 }) {
    return new $834619e78bbf578c$var$Gp({
        clickTolerance: t,
        move: (e1, t)=>({
                pitchDelta: (t.y - e1.y) * n
            }),
        moveStateManager: new $834619e78bbf578c$var$Jp({
            checkCorrectEvent: (e1)=>e1.button === 0 && e1.ctrlKey || e1.button === 2
        }),
        enable: e1,
        assignEvents: $834619e78bbf578c$var$Zp
    });
}
function $834619e78bbf578c$var$tm({ enable: e1, clickTolerance: t, rollDegreesPerPixelMoved: n = .3 }, r) {
    return new $834619e78bbf578c$var$Gp({
        clickTolerance: t,
        move: (e1, t)=>{
            let i = r(), a = (t.x - e1.x) * n;
            return t.y < i.y && (a = -a), {
                rollDelta: a
            };
        },
        moveStateManager: new $834619e78bbf578c$var$Jp({
            checkCorrectEvent: (e1)=>e1.button === 2 && e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $834619e78bbf578c$var$Zp
    });
}
var $834619e78bbf578c$var$nm = class {
    constructor(e1, t){
        this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
    }
    reset() {
        this._active = !1, this._touches = {}, this._sum = new (0, $1rqx5.Li)(0, 0);
    }
    _shouldBePrevented(e1) {
        return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
    }
    touchstart(e1, t, n) {
        return this._calculateTransform(e1, t, n);
    }
    touchmove(e1, t, n) {
        if (this._active) {
            if (this._shouldBePrevented(n.length)) {
                this._map.cooperativeGestures.notifyGestureBlocked(`touch_pan`, e1);
                return;
            }
            return e1.preventDefault(), this._calculateTransform(e1, t, n);
        }
    }
    touchend(e1, t, n) {
        this._calculateTransform(e1, t, n), this._active && this._shouldBePrevented(n.length) && this.reset();
    }
    touchcancel() {
        this.reset();
    }
    _calculateTransform(e1, t, n) {
        n.length > 0 && (this._active = !0);
        let r = $834619e78bbf578c$var$Bp(n, t), i = new (0, $1rqx5.Li)(0, 0), a = new (0, $1rqx5.Li)(0, 0), o = 0;
        for(let e1 in r){
            let t = r[e1], n = this._touches[e1];
            n && (i._add(t), a._add(t.sub(n)), o++, r[e1] = t);
        }
        if (this._touches = r, this._shouldBePrevented(o) || !a.mag()) return;
        let s = a.div(o);
        if (this._sum._add(s), !(this._sum.mag() < this._clickTolerance)) return {
            around: i.div(o),
            panDelta: s
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $834619e78bbf578c$var$rm = class {
    constructor(){
        this.reset();
    }
    reset() {
        this._active = !1, delete this._firstTwoTouches;
    }
    touchstart(e1, t, n) {
        this._firstTwoTouches || n.length < 2 || (this._firstTwoTouches = [
            n[0].identifier,
            n[1].identifier
        ], this._start([
            t[0],
            t[1]
        ]));
    }
    touchmove(e1, t, n) {
        if (!this._firstTwoTouches) return;
        e1.preventDefault();
        let [r, i] = this._firstTwoTouches, a = $834619e78bbf578c$var$im(n, t, r), o = $834619e78bbf578c$var$im(n, t, i);
        if (!a || !o) return;
        let s = this._aroundCenter ? null : a.add(o).div(2);
        return this._move([
            a,
            o
        ], s, e1);
    }
    touchend(e1, t, n) {
        if (!this._firstTwoTouches) return;
        let [r, i] = this._firstTwoTouches, a = $834619e78bbf578c$var$im(n, t, r), o = $834619e78bbf578c$var$im(n, t, i);
        a && o || (this._active && $834619e78bbf578c$var$G.suppressClick(), this.reset());
    }
    touchcancel() {
        this.reset();
    }
    enable(e1) {
        this._enabled = !0, this._aroundCenter = !!e1 && e1.around === `center`;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
};
function $834619e78bbf578c$var$im(e1, t, n) {
    for(let r = 0; r < e1.length; r++)if (e1[r].identifier === n) return t[r];
}
const $834619e78bbf578c$var$am = .1;
function $834619e78bbf578c$var$om(e1, t) {
    return Math.log(e1 / t) / Math.LN2;
}
var $834619e78bbf578c$export$db37e9f00445aa54 = class extends $834619e78bbf578c$var$rm {
    constructor(){
        super(), this._zoomRate = 1, this._zoomThreshold = $834619e78bbf578c$var$am;
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    setZoomThreshold(e1) {
        this._zoomThreshold = e1 ?? $834619e78bbf578c$var$am;
    }
    reset() {
        super.reset(), delete this._distance, delete this._startDistance;
    }
    _start(e1) {
        this._startDistance = this._distance = e1[0].dist(e1[1]);
    }
    _move(e1, t) {
        let n = this._distance;
        if (this._distance = e1[0].dist(e1[1]), !(!this._active && Math.abs($834619e78bbf578c$var$om(this._distance, this._startDistance)) < this._zoomThreshold)) return this._active = !0, {
            zoomDelta: $834619e78bbf578c$var$om(this._distance, n) * this._zoomRate,
            pinchAround: t
        };
    }
};
function $834619e78bbf578c$var$cm(e1, t) {
    return e1.angleWith(t) * 180 / Math.PI;
}
var $834619e78bbf578c$export$6966aa20d1b4577f = class extends $834619e78bbf578c$var$rm {
    reset() {
        super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
    }
    _start(e1) {
        this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
    }
    _move(e1, t, n) {
        let r = this._vector;
        if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
            bearingDelta: $834619e78bbf578c$var$cm(this._vector, r),
            pinchAround: t
        };
    }
    _isBelowThreshold(e1) {
        this._minDiameter = Math.min(this._minDiameter, e1.mag());
        let t = 25 / (Math.PI * this._minDiameter) * 360, n = $834619e78bbf578c$var$cm(e1, this._startVector);
        return Math.abs(n) < t;
    }
};
function $834619e78bbf578c$var$um(e1) {
    return Math.abs(e1.y) > Math.abs(e1.x);
}
var $834619e78bbf578c$export$7ea266bd3010ae2a = class extends $834619e78bbf578c$var$rm {
    constructor(e1){
        super(), this._currentTouchCount = 0, this._map = e1;
    }
    reset() {
        super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
    }
    touchstart(e1, t, n) {
        super.touchstart(e1, t, n), this._currentTouchCount = n.length;
    }
    _start(e1) {
        this._lastPoints = e1, $834619e78bbf578c$var$um(e1[0].sub(e1[1])) && (this._valid = !1);
    }
    _move(e1, t, n) {
        if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
        let r = e1[0].sub(this._lastPoints[0]), i = e1[1].sub(this._lastPoints[1]);
        if (this._valid = this.gestureBeginsVertically(r, i, n.timeStamp), this._valid) return this._lastPoints = e1, this._active = !0, {
            pitchDelta: (r.y + i.y) / 2 * -0.5
        };
    }
    gestureBeginsVertically(e1, t, n) {
        if (this._valid !== void 0) return this._valid;
        let r = e1.mag() >= 2, i = t.mag() >= 2;
        if (!r && !i) return;
        if (!r || !i) return this._firstMove === void 0 && (this._firstMove = n), n - this._firstMove < 100 && void 0;
        let a = e1.y > 0 == t.y > 0;
        return $834619e78bbf578c$var$um(e1) && $834619e78bbf578c$var$um(t) && a;
    }
};
const $834619e78bbf578c$var$fm = {
    panStep: 100,
    bearingStep: 15,
    pitchStep: 10
};
var $834619e78bbf578c$export$474b8119f9aaf6a9 = class {
    constructor(e1, t){
        this._tr = t;
        let n = $834619e78bbf578c$var$fm;
        this._panStep = n.panStep, this._bearingStep = n.bearingStep, this._pitchStep = n.pitchStep, this._rotationDisabled = !1;
    }
    reset() {
        this._active = !1;
    }
    keydown(e1) {
        if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
        let n = 0, r = 0, i = 0, a = 0, o = 0;
        switch(e1.keyCode){
            case 61:
            case 107:
            case 171:
            case 187:
                n = 1;
                break;
            case 189:
            case 109:
            case 173:
                n = -1;
                break;
            case 37:
                e1.shiftKey ? r = -1 : (e1.preventDefault(), a = -1);
                break;
            case 39:
                e1.shiftKey ? r = 1 : (e1.preventDefault(), a = 1);
                break;
            case 38:
                e1.shiftKey ? i = 1 : (e1.preventDefault(), o = -1);
                break;
            case 40:
                e1.shiftKey ? i = -1 : (e1.preventDefault(), o = 1);
                break;
            default:
                return;
        }
        return this._rotationDisabled && (r = 0, i = 0), {
            cameraAnimation: (s)=>{
                let c = this._tr;
                s.easeTo({
                    duration: 300,
                    easeId: `keyboardHandler`,
                    easing: $834619e78bbf578c$var$mm,
                    zoom: n ? (0, $1rqx5.$n)(c.zoom + n * (e1.shiftKey ? 2 : 1), s.getZoomSnap()) : c.zoom,
                    bearing: c.bearing + r * this._bearingStep,
                    pitch: c.pitch + i * this._pitchStep,
                    offset: [
                        -a * this._panStep,
                        -o * this._panStep
                    ],
                    center: c.center
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    disableRotation() {
        this._rotationDisabled = !0;
    }
    enableRotation() {
        this._rotationDisabled = !1;
    }
};
function $834619e78bbf578c$var$mm(e1) {
    return e1 * (2 - e1);
}
const $834619e78bbf578c$var$hm = 4.000244140625;
var $834619e78bbf578c$export$fd7a47efd2367414 = class {
    constructor(e1, t, n){
        this._onTimeout = (e1)=>{
            this._type = `wheel`, this._delta -= this._lastValue, this._active || this._start(e1);
        }, this._map = e1, this._tr = n, this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
    }
    setZoomRate(e1) {
        this._defaultZoomRate = e1;
    }
    setWheelZoomRate(e1) {
        this._wheelZoomRate = e1;
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active || this._finishTimeout !== void 0;
    }
    isZooming() {
        return !!this._zooming;
    }
    enable(e1) {
        this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && e1.around === `center`);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    _shouldBePrevented(e1) {
        return this._map.cooperativeGestures.isEnabled() ? !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1)) : !1;
    }
    wheel(e1) {
        if (!this.isEnabled()) return;
        if (this._shouldBePrevented(e1)) {
            this._map.cooperativeGestures.notifyGestureBlocked(`wheel_zoom`, e1);
            return;
        }
        let t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? e1.deltaY * 40 : e1.deltaY, n = $834619e78bbf578c$export$461939dd4422153(), r = n - (this._lastWheelEventTime || 0);
        this._lastWheelEventTime = n, t !== 0 && t % $834619e78bbf578c$var$hm == 0 ? this._type = `wheel` : t !== 0 && Math.abs(t) < 4 ? this._type = `trackpad` : r > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(r * t) < 200 ? `trackpad` : `wheel`, this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e1.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= t, this._active || this._start(e1)), e1.preventDefault();
    }
    _start(e1) {
        if (!this._delta) return;
        this._needsRerender = !1, this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
        let t = $834619e78bbf578c$var$G.mousePos(this._map.getCanvas(), e1), n = this._tr;
        this._aroundPoint = this._aroundCenter ? n.transform.locationToScreenPoint((0, $1rqx5.lt).convert(n.center)) : t, this._needsRerender || (this._needsRerender = !0, this._triggerRenderFrame());
    }
    renderFrame() {
        if (!this._needsRerender || (this._needsRerender = !1, !this.isActive())) return;
        let e1 = this._tr.transform;
        if (typeof this._lastExpectedZoom == `number`) {
            let t = e1.zoom - this._lastExpectedZoom;
            typeof this._startZoom == `number` && (this._startZoom += t), typeof this._targetZoom == `number` && (this._targetZoom += t);
        }
        if (this._delta !== 0) {
            let n = this._type === `wheel` && Math.abs(this._delta) > $834619e78bbf578c$var$hm ? this._wheelZoomRate : this._defaultZoomRate, r = 2 / (1 + Math.exp(-Math.abs(this._delta * n)));
            this._delta < 0 && r !== 0 && (r = 1 / r);
            let i = typeof this._targetZoom == `number` ? (0, $1rqx5.Fr)(this._targetZoom) : e1.scale, a = e1.applyConstrain(e1.getCameraLngLat(), (0, $1rqx5.Dr)(i * r)).zoom, o = this._map.getZoomSnap();
            if (this._type === `wheel` && o > 0) {
                let n = (0, $1rqx5.$n)(e1.zoom, o);
                this._targetZoom = (0, $1rqx5.$n)(a, o, a - n);
            } else this._targetZoom = a;
            this._type === `wheel` && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
        }
        let n = typeof this._targetZoom == `number` ? this._targetZoom : e1.zoom, r = this._startZoom, i = this._easing, a = !1, o;
        if (this._type === `wheel` && r && i) {
            let e1 = $834619e78bbf578c$export$461939dd4422153() - this._lastWheelEventTime, t = Math.min((e1 + 5) / 200, 1), s = i(t);
            o = (0, $1rqx5.un).number(r, n, s), t < 1 ? this._needsRerender = !0 : a = !0;
        } else o = n, a = !0;
        return this._active = !0, a && (this._active = !1, this._finishTimeout = setTimeout(()=>{
            this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
        }, 200)), this._lastExpectedZoom = o, {
            noInertia: !0,
            needsRenderFrame: !a,
            zoomDelta: o - e1.zoom,
            around: this._aroundPoint,
            originalEvent: this._lastWheelEvent
        };
    }
    _smoothOutEasing(e1) {
        let t = (0, $1rqx5.Jn);
        if (this._prevEase) {
            let e1 = this._prevEase, n = ($834619e78bbf578c$export$461939dd4422153() - e1.start) / e1.duration, r = e1.easing(n + .01) - e1.easing(n), i = .27 / Math.sqrt(r * r + 1e-4) * .01, a = Math.sqrt(.0729 - i * i);
            t = (0, $1rqx5.zn)(i, a, .25, 1);
        }
        return this._prevEase = {
            start: $834619e78bbf578c$export$461939dd4422153(),
            duration: e1,
            easing: t
        }, t;
    }
    reset() {
        this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
    }
}, $834619e78bbf578c$export$939799190379133f = class {
    constructor(e1, t){
        this._clickZoom = e1, this._tapZoom = t;
    }
    enable() {
        this._clickZoom.enable(), this._tapZoom.enable();
    }
    disable() {
        this._clickZoom.disable(), this._tapZoom.disable();
    }
    isEnabled() {
        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
    }
    isActive() {
        return this._clickZoom.isActive() || this._tapZoom.isActive();
    }
}, $834619e78bbf578c$var$vm = class {
    constructor(e1, t){
        this._tr = t, this.reset();
    }
    reset() {
        this._active = !1;
    }
    dblclick(e1, n) {
        return e1.preventDefault(), {
            cameraAnimation: (r)=>{
                r.easeTo({
                    duration: 300,
                    zoom: (0, $1rqx5.$n)(this._tr.zoom + (e1.shiftKey ? -1 : 1), r.getZoomSnap()),
                    around: this._tr.transform.isPointOnMapSurface(n) ? this._tr.unproject(n) : void 0
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $834619e78bbf578c$var$ym = class {
    constructor(){
        this._tap = new $834619e78bbf578c$var$Up({
            numTouches: 1,
            numTaps: 1
        }), this._zoomRate = 1, this.reset();
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    reset() {
        this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
    }
    touchstart(e1, t, n) {
        if (!this._swipePoint) {
            if (!this._tapTime) this._tap.touchstart(e1, t, n);
            else {
                let r = t[0], i = e1.timeStamp - this._tapTime < 500, a = this._tapPoint.dist(r) < 30;
                !i || !a ? this.reset() : n.length > 0 && (this._swipePoint = r, this._swipeTouch = n[0].identifier);
            }
        }
    }
    touchmove(e1, t, n) {
        if (!this._tapTime) this._tap.touchmove(e1, t, n);
        else if (this._swipePoint) {
            if (n[0].identifier !== this._swipeTouch) return;
            let r = t[0], i = r.y - this._swipePoint.y;
            return this._swipePoint = r, e1.preventDefault(), this._active = !0, {
                zoomDelta: i / 128 * this._zoomRate
            };
        }
    }
    touchend(e1, t, n) {
        if (this._tapTime) this._swipePoint && n.length === 0 && this.reset();
        else {
            let r = this._tap.touchend(e1, t, n);
            r && (this._tapTime = e1.timeStamp, this._tapPoint = r);
        }
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $834619e78bbf578c$export$69c4612f5624c3f0 = class {
    constructor(e1, t, n){
        this._el = e1, this._mousePan = t, this._touchPan = n;
    }
    enable(e1) {
        this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add(`maplibregl-touch-drag-pan`);
    }
    disable() {
        this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove(`maplibregl-touch-drag-pan`);
    }
    isEnabled() {
        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
    }
    isActive() {
        return this._mousePan.isActive() || this._touchPan.isActive();
    }
}, $834619e78bbf578c$export$fc9ed7efe29ccb64 = class {
    constructor(e1, t, n, r){
        this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = n, this._mouseRoll = r;
    }
    enable() {
        this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
    }
    disable() {
        this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
    }
    isEnabled() {
        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
    }
    isActive() {
        return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
    }
}, $834619e78bbf578c$export$69d5f25840cce15f = class {
    constructor(e1, t, n, r){
        this._el = e1, this._touchZoom = t, this._touchRotate = n, this._tapDragZoom = r, this._rotationDisabled = !1, this._enabled = !0;
    }
    enable(e1) {
        this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add(`maplibregl-touch-zoom-rotate`);
    }
    disable() {
        this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove(`maplibregl-touch-zoom-rotate`);
    }
    isEnabled() {
        return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
    }
    isActive() {
        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
    }
    setZoomRate(e1) {
        this._touchZoom.setZoomRate(e1), this._tapDragZoom.setZoomRate(e1);
    }
    setZoomThreshold(e1) {
        this._touchZoom.setZoomThreshold(e1);
    }
    disableRotation() {
        this._rotationDisabled = !0, this._touchRotate.disable();
    }
    enableRotation() {
        this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
    }
}, $834619e78bbf578c$export$eba3588e2069a729 = class {
    constructor(e1, t){
        this._bypassKey = navigator.userAgent.includes(`Mac`) ? `metaKey` : `ctrlKey`, this._map = e1, this._options = t, this._enabled = !1;
    }
    isActive() {
        return !1;
    }
    reset() {}
    _setupUI() {
        if (this._container) return;
        let e1 = this._map.getCanvasContainer();
        e1.classList.add(`maplibregl-cooperative-gestures`), this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-cooperative-gesture-screen`, e1);
        let t = this._map._getUIString(`CooperativeGesturesHandler.WindowsHelpText`);
        this._bypassKey === `metaKey` && (t = this._map._getUIString(`CooperativeGesturesHandler.MacHelpText`));
        let n = this._map._getUIString(`CooperativeGesturesHandler.MobileHelpText`), r = document.createElement(`div`);
        r.className = `maplibregl-desktop-message`, r.textContent = t, this._container.appendChild(r);
        let i = document.createElement(`div`);
        i.className = `maplibregl-mobile-message`, i.textContent = n, this._container.appendChild(i), this._container.setAttribute(`aria-hidden`, `true`);
    }
    _destroyUI() {
        this._container && (this._container.remove(), this._map.getCanvasContainer().classList.remove(`maplibregl-cooperative-gestures`)), delete this._container;
    }
    enable() {
        this._setupUI(), this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this._destroyUI();
    }
    isEnabled() {
        return this._enabled;
    }
    isBypassed(e1) {
        return e1[this._bypassKey];
    }
    notifyGestureBlocked(e1, t) {
        this._enabled && (this._map.fire(new $834619e78bbf578c$export$fc21b96c04d10d16(`cooperativegestureprevented`, {
            gestureType: e1,
            originalEvent: t
        })), this._container.classList.add(`maplibregl-show`), setTimeout(()=>{
            this._container.classList.remove(`maplibregl-show`);
        }, 100));
    }
}, $834619e78bbf578c$var$wm = class {
    constructor(e1){
        this._camera = e1;
    }
    get transform() {
        return this._camera._requestedCameraState || this._camera.transform;
    }
    get center() {
        return {
            lng: this.transform.center.lng,
            lat: this.transform.center.lat
        };
    }
    get zoom() {
        return this.transform.zoom;
    }
    get pitch() {
        return this.transform.pitch;
    }
    get bearing() {
        return this.transform.bearing;
    }
    unproject(e1) {
        return this.transform.screenPointToLocation((0, $1rqx5.Li).convert(e1), this._camera.terrain);
    }
};
const $834619e78bbf578c$var$Tm = (e1)=>e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
var $834619e78bbf578c$var$Em = class extends (0, $1rqx5._n) {
};
function $834619e78bbf578c$var$Dm(e1) {
    return e1.panDelta?.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
}
var $834619e78bbf578c$var$Om = class {
    get _ownerDocument() {
        return this._el?.ownerDocument || document;
    }
    get _ownerWindow() {
        return this._el?.ownerDocument?.defaultView || window;
    }
    constructor(e1, t, n){
        this._terrainGesture = {
            inFlight: !1,
            anchorElevation: null
        }, this.handleWindowEvent = (e1)=>{
            this.handleEvent(e1, `${e1.type}Window`);
        }, this.handleEvent = (e1, t)=>{
            if (e1.type === `blur`) {
                this.stop(!0);
                return;
            }
            this._updatingCamera = !0;
            let n = e1.type === `renderFrame` ? void 0 : e1, r = {
                needsRenderFrame: !1
            }, i = {}, a = {};
            for (let { handlerName: o, handler: s, allowed: c } of this._handlers){
                if (!s.isEnabled()) continue;
                let l;
                if (this._blockedByActive(a, c, o)) s.reset();
                else if (s[t || e1.type]) {
                    if ((0, $1rqx5.lr)(e1, t || e1.type)) {
                        let n = $834619e78bbf578c$var$G.mousePos(this._map.getCanvas(), e1);
                        l = s[t || e1.type](e1, n);
                    } else if ((0, $1rqx5.dr)(e1, t || e1.type)) {
                        let n = e1.touches, r = this._getMapTouches(n), i = $834619e78bbf578c$var$G.touchPos(this._map.getCanvas(), r);
                        l = s[t || e1.type](e1, i, r);
                    } else (0, $1rqx5.fr)(t || e1.type) || (l = s[t || e1.type](e1));
                    this.mergeHandlerResult(r, i, l, o, n), l?.needsRenderFrame && this._triggerRenderFrame();
                }
                (l || s.isActive()) && (a[o] = s);
            }
            let o = {};
            for(let e1 in this._previousActiveHandlers)a[e1] || (o[e1] = n);
            this._previousActiveHandlers = a, (Object.keys(o).length || $834619e78bbf578c$var$Dm(r)) && (this._changes.push([
                r,
                i,
                o
            ]), this._triggerRenderFrame()), (Object.keys(a).length || $834619e78bbf578c$var$Dm(r)) && this._camera.stop(!0), this._updatingCamera = !1;
            let { cameraAnimation: s } = r;
            s && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], s(this._map));
        }, this._map = e1, this._camera = t, this._transformProvider = new $834619e78bbf578c$var$wm(this._camera), this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new $834619e78bbf578c$var$Pp(e1), this._bearingSnap = n.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(n);
        let r = this._el;
        this._listeners = [
            [
                r,
                `touchstart`,
                {
                    passive: !0
                }
            ],
            [
                r,
                `touchmove`,
                {
                    passive: !1
                }
            ],
            [
                r,
                `touchend`,
                void 0
            ],
            [
                r,
                `touchcancel`,
                void 0
            ],
            [
                r,
                `mousedown`,
                void 0
            ],
            [
                r,
                `mousemove`,
                void 0
            ],
            [
                r,
                `mouseup`,
                void 0
            ],
            [
                this._ownerDocument,
                `mousemove`,
                {
                    capture: !0
                }
            ],
            [
                this._ownerDocument,
                `mouseup`,
                void 0
            ],
            [
                r,
                `mouseover`,
                void 0
            ],
            [
                r,
                `mouseout`,
                void 0
            ],
            [
                r,
                `dblclick`,
                void 0
            ],
            [
                r,
                `click`,
                void 0
            ],
            [
                r,
                `keydown`,
                {
                    capture: !1
                }
            ],
            [
                r,
                `keyup`,
                void 0
            ],
            [
                r,
                `wheel`,
                {
                    passive: !1
                }
            ],
            [
                r,
                `contextmenu`,
                void 0
            ],
            [
                this._ownerWindow,
                `blur`,
                void 0
            ]
        ];
        for (let [e1, t, n] of this._listeners)e1.addEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, n);
    }
    destroy() {
        for (let [e1, t, n] of this._listeners)e1.removeEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, n);
    }
    _addDefaultHandlers(e1) {
        let t = this._map, n = t.getCanvasContainer();
        this._add(`mapEvent`, new $834619e78bbf578c$var$Lp(t, e1));
        let r = t.boxZoom = new $834619e78bbf578c$export$bd01c6f06175f3af(t, e1, this._transformProvider);
        this._add(`boxZoom`, r), e1.interactive && e1.boxZoom && r.enable();
        let i = t.cooperativeGestures = new $834619e78bbf578c$export$eba3588e2069a729(t, e1.cooperativeGestures);
        this._add(`cooperativeGestures`, i), e1.cooperativeGestures && i.enable();
        let a = new $834619e78bbf578c$var$Wp(t, this._transformProvider), o = new $834619e78bbf578c$var$vm(t, this._transformProvider);
        t.doubleClickZoom = new $834619e78bbf578c$export$939799190379133f(o, a), this._add(`tapZoom`, a), this._add(`clickZoom`, o), e1.interactive && e1.doubleClickZoom && t.doubleClickZoom.enable();
        let s = new $834619e78bbf578c$var$ym;
        this._add(`tapDragZoom`, s);
        let c = t.touchPitch = new $834619e78bbf578c$export$7ea266bd3010ae2a(t);
        this._add(`touchPitch`, c), e1.interactive && e1.touchPitch && t.touchPitch.enable(e1.touchPitch);
        let l = ()=>this._camera.transform.centerPoint, u = $834619e78bbf578c$var$$p(e1, l), d = $834619e78bbf578c$var$em(e1), f = $834619e78bbf578c$var$tm(e1, l);
        t.dragRotate = new $834619e78bbf578c$export$fc9ed7efe29ccb64(e1, u, d, f), this._add(`mouseRotate`, u, [
            `mousePitch`
        ]), this._add(`mousePitch`, d, [
            `mouseRotate`,
            `mouseRoll`
        ]), this._add(`mouseRoll`, f, [
            `mousePitch`
        ]), e1.interactive && e1.dragRotate && t.dragRotate.enable();
        let p = $834619e78bbf578c$var$Qp(e1), m = new $834619e78bbf578c$var$nm(e1, t);
        t.dragPan = new $834619e78bbf578c$export$69c4612f5624c3f0(n, p, m), this._add(`mousePan`, p), this._add(`touchPan`, m, [
            `touchZoom`,
            `touchRotate`
        ]), e1.interactive && e1.dragPan && t.dragPan.enable(e1.dragPan);
        let h = new $834619e78bbf578c$export$6966aa20d1b4577f, g = new $834619e78bbf578c$export$db37e9f00445aa54;
        t.touchZoomRotate = new $834619e78bbf578c$export$69d5f25840cce15f(n, g, h, s), this._add(`touchRotate`, h, [
            `touchPan`,
            `touchZoom`
        ]), this._add(`touchZoom`, g, [
            `touchPan`,
            `touchRotate`
        ]), e1.interactive && e1.touchZoomRotate && t.touchZoomRotate.enable(e1.touchZoomRotate), this._add(`blockableMapEvent`, new $834619e78bbf578c$var$Rp(t, e1), [
            `touchPan`
        ]);
        let _ = t.scrollZoom = new $834619e78bbf578c$export$fd7a47efd2367414(t, ()=>this._triggerRenderFrame(), this._transformProvider);
        this._add(`scrollZoom`, _, [
            `mousePan`
        ]), e1.interactive && e1.scrollZoom && t.scrollZoom.enable(e1.scrollZoom);
        let v = t.keyboard = new $834619e78bbf578c$export$474b8119f9aaf6a9(t, this._transformProvider);
        this._add(`keyboard`, v), e1.interactive && e1.keyboard && t.keyboard.enable();
    }
    _add(e1, t, n) {
        this._handlers.push({
            handlerName: e1,
            handler: t,
            allowed: n
        }), this._handlersById[e1] = t;
    }
    stop(e1) {
        if (!this._updatingCamera) {
            for (let { handler: e1 } of this._handlers)e1.reset();
            this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
        }
    }
    isActive() {
        for (let { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
        return !1;
    }
    isZooming() {
        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
    }
    isRotating() {
        return !!this._eventsInProgress.rotate;
    }
    isMoving() {
        return !!$834619e78bbf578c$var$Tm(this._eventsInProgress) || this.isZooming();
    }
    _blockedByActive(e1, t, n) {
        for(let r in e1)if (r !== n && !t?.includes(r)) return !0;
        return !1;
    }
    _getMapTouches(e1) {
        let t = [];
        for (let n of e1){
            let e1 = n.target;
            this._el.contains(e1) && t.push(n);
        }
        return t;
    }
    mergeHandlerResult(e1, t, n, r, i) {
        if (!n) return;
        (0, $1rqx5.er)(e1, n);
        let a = {
            handlerName: r,
            originalEvent: n.originalEvent || i
        };
        n.zoomDelta !== void 0 && (t.zoom = a), n.panDelta !== void 0 && (t.drag = a), n.rollDelta !== void 0 && (t.roll = a), n.pitchDelta !== void 0 && (t.pitch = a), n.bearingDelta !== void 0 && (t.rotate = a);
    }
    _applyChanges() {
        let e1 = {}, t = {}, n = {};
        for (let [r, i, a] of this._changes)r.panDelta && (e1.panDelta = (e1.panDelta || new (0, $1rqx5.Li)(0, 0))._add(r.panDelta)), r.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + r.pitchDelta), r.rollDelta && (e1.rollDelta = (e1.rollDelta || 0) + r.rollDelta), r.around !== void 0 && (e1.around = r.around), r.pinchAround !== void 0 && (e1.pinchAround = r.pinchAround), r.noInertia && (e1.noInertia = r.noInertia), (0, $1rqx5.er)(t, i), (0, $1rqx5.er)(n, a);
        this._updateMapTransform(e1, t, n), this._changes = [];
    }
    _updateMapTransform(e1, t, n) {
        let r = this._map.terrain;
        if (!$834619e78bbf578c$var$Dm(e1)) {
            this._fireEvents(t, n, !0);
            return;
        }
        let i = this._camera.getTransformForUpdate();
        this._camera.stop(!0);
        let { panDelta: a, zoomDelta: o, bearingDelta: s, pitchDelta: c, rollDelta: l } = e1, { around: u, aroundOnSurface: d } = this._resolveAround(e1, r, i), f = r ? this._terrainGestureElevation(r, u, d, i, t) : void 0, p = {
            panDelta: a,
            zoomDelta: o,
            rollDelta: l,
            pitchDelta: c,
            bearingDelta: s,
            around: u,
            aroundElevation: f
        };
        this._camera.cameraHelper.useGlobeControls && !i.isPointOnMapSurface(u) && (u = i.centerPoint);
        let m = this._computePreZoomAroundLoc(i, u, a, f);
        this._handleMapControls({
            terrain: r,
            tr: i,
            deltasForHelper: p,
            preZoomAroundLoc: m,
            combinedEventsInProgress: t,
            panDelta: a
        }), this._camera.applyUpdatedTransform(i), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, n, !0);
    }
    _resolveAround(e1, t, n) {
        let r = e1.pinchAround === void 0 ? e1.around : e1.pinchAround;
        return r ||= this._camera.transform.centerPoint, t && !n.isPointOnMapSurface(r) ? {
            around: n.centerPoint,
            aroundOnSurface: !1
        } : {
            around: r,
            aroundOnSurface: !0
        };
    }
    _terrainGestureElevation(e1, t, n, r, i) {
        if (!n) return;
        if (this._terrainGesture.anchorElevation === null && (i.drag || i.zoom)) {
            let n = r.screenTerrainPointToMercatorCoordinate(t, e1);
            this._terrainGesture.anchorElevation = n ? n.z : void 0;
        }
        let a = this._terrainGesture.anchorElevation;
        if (a != null && !(t.distSqr(r.centerPoint) < .01) && !(a - r.elevation >= .9 * (r.getCameraAltitude() - r.elevation))) return a;
    }
    _computePreZoomAroundLoc(e1, t, n, r) {
        if (t.distSqr(e1.centerPoint) < .01) return e1.center;
        let i = n ? t.sub(n) : t;
        return r === void 0 ? e1.screenPointToLocation(i) : e1.screenPointToLocationAtElevation(i, r);
    }
    _handleMapControls({ terrain: e1, tr: t, deltasForHelper: n, preZoomAroundLoc: r, combinedEventsInProgress: i, panDelta: a }) {
        let o = this._camera.cameraHelper;
        if (o.handleMapControlsRollPitchBearingZoom(n, t), !e1 && !o.useGlobeControls && !t.isPointOnMapSurface(n.around)) {
            a && t.setCenter(t.screenPointToLocation(t.centerPoint.sub(a)));
            return;
        }
        if (!e1) {
            o.handleMapControlsPan(n, t, r);
            return;
        }
        if (!this._terrainGesture.inFlight) {
            this._terrainGesture.inFlight = !0, this._camera.elevationFreeze = !0, o.handleMapControlsPan(n, t, r);
            return;
        }
        if (!o.useGlobeControls && n.aroundElevation === void 0 && i.drag && a) {
            t.setCenter(t.screenPointToLocation(t.centerPoint.sub(a)));
            return;
        }
        o.handleMapControlsPan(n, t, r);
    }
    _fireEvents(e1, t, n) {
        let r = $834619e78bbf578c$var$Tm(this._eventsInProgress), i = $834619e78bbf578c$var$Tm(e1), a = {};
        for(let t in e1){
            let { originalEvent: n } = e1[t];
            this._eventsInProgress[t] || (a[`${t}start`] = n), this._eventsInProgress[t] = e1[t];
        }
        !r && i && this._fireEvent(`movestart`, i.originalEvent);
        for(let e1 in a)this._fireEvent(e1, a[e1]);
        i && this._fireEvent(`move`, i.originalEvent);
        for(let t in e1){
            let { originalEvent: n } = e1[t];
            this._fireEvent(t, n);
        }
        let o = {}, s;
        for(let e1 in this._eventsInProgress){
            let { handlerName: n, originalEvent: r } = this._eventsInProgress[e1];
            this._handlersById[n].isActive() || (delete this._eventsInProgress[e1], s = t[n] || r, o[`${e1}end`] = s);
        }
        for(let e1 in o)this._fireEvent(e1, o[e1]);
        let c = $834619e78bbf578c$var$Tm(this._eventsInProgress), l = (r || i) && !c;
        if (l && this._terrainGesture.inFlight) {
            this._camera.elevationFreeze = !1, this._terrainGesture = {
                inFlight: !1,
                anchorElevation: null
            };
            let e1 = this._camera.getTransformForUpdate();
            this._map.getCenterClampedToGround() && e1.recalculateZoomAndCenter(this._map.terrain), this._camera.applyUpdatedTransform(e1);
        }
        if (n && l) {
            this._updatingCamera = !0;
            let e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), t = (e1)=>e1 !== 0 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
            e1 && (e1.essential || !$834619e78bbf578c$var$Rr.prefersReducedMotion) ? (t(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                originalEvent: s
            })) : (this._fireEvent(`moveend`, s), t(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
        }
    }
    _fireEvent(e1, t) {
        this._camera.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(e1, t ? {
            originalEvent: t
        } : {}));
    }
    _requestFrame() {
        return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
            delete this._frameId, this.handleEvent(new $834619e78bbf578c$var$Em(`renderFrame`, {
                timeStamp: e1
            })), this._applyChanges();
        });
    }
    _triggerRenderFrame() {
        this._frameId === void 0 && (this._frameId = this._requestFrame());
    }
}, $834619e78bbf578c$var$km = class extends (0, $1rqx5.vn) {
    constructor(e1){
        super(), this._renderFrameCallback = ()=>{
            let e1 = Math.min(($834619e78bbf578c$export$461939dd4422153() - this._easeStart) / this._easeOptions.duration, 1);
            this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }, this.transform = new $834619e78bbf578c$var$Oc, this.cameraHelper = new $834619e78bbf578c$var$Fc, e1.minZoom !== void 0 && this.transform.setMinZoom(e1.minZoom), e1.maxZoom !== void 0 && this.transform.setMaxZoom(e1.maxZoom), e1.minPitch !== void 0 && this.transform.setMinPitch(e1.minPitch), e1.maxPitch !== void 0 && this.transform.setMaxPitch(e1.maxPitch), e1.renderWorldCopies !== void 0 && this.transform.setRenderWorldCopies(e1.renderWorldCopies), e1.transformConstrain !== null && this.transform.setConstrainOverride(e1.transformConstrain), this._moving = !1, this._zooming = !1, this._bearingSnap = e1.bearingSnap, this._zoomSnap = e1.zoomSnap, this._requestRenderFrame = e1.requestRenderFrame, this._cancelRenderFrame = e1.cancelRenderFrame, this.terrain = e1.terrain, this._centerClampedToGround = e1.centerClampedToGround ?? !0, this.transformCameraUpdate = e1.transformCameraUpdate ?? null, this._stopHandlers = e1.stopHandlers ?? (()=>{}), this.on(`moveend`, ()=>{
            delete this._requestedCameraState;
        });
    }
    setTerrain(e1) {
        this.terrain = e1, this.applyTerrainChange();
    }
    migrateProjection(e1, t) {
        if (e1.apply(this.transform, !0), this.transform = e1, this.cameraHelper = t, this._requestedCameraState) {
            let t = e1.clone();
            t.apply(this._requestedCameraState, !0), this._requestedCameraState = t;
        }
    }
    getCenter() {
        return new (0, $1rqx5.lt)(this.transform.center.lng, this.transform.center.lat);
    }
    setCenter(e1, t) {
        return this.jumpTo({
            center: e1
        }, t);
    }
    getCenterElevation() {
        return this.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this.jumpTo({
            elevation: e1
        }, t), this;
    }
    getCenterClampedToGround() {
        return this._centerClampedToGround;
    }
    setCenterClampedToGround(e1) {
        this._centerClampedToGround = e1;
    }
    panBy(e1, t, n) {
        return e1 = (0, $1rqx5.Li).convert(e1).mult(-1), this.panTo(this.transform.center, (0, $1rqx5.er)({
            offset: e1
        }, t), n);
    }
    panTo(e1, t, n) {
        return this.easeTo((0, $1rqx5.er)({
            center: e1
        }, t), n);
    }
    getZoom() {
        return this.transform.zoom;
    }
    setZoom(e1, t) {
        return this.jumpTo({
            zoom: e1
        }, t), this;
    }
    zoomTo(e1, t, n) {
        return this.easeTo((0, $1rqx5.er)({
            zoom: e1
        }, t), n);
    }
    zoomIn(e1, n) {
        return this.zoomTo((0, $1rqx5.$n)(this.getZoom() + 1, this._zoomSnap), e1, n), this;
    }
    zoomOut(e1, n) {
        return this.zoomTo((0, $1rqx5.$n)(this.getZoom() - 1, this._zoomSnap), e1, n), this;
    }
    getVerticalFieldOfView() {
        return this.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return e1 != this.transform.fov && (this.applyTransformChange((t)=>t.setFov(e1)), this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`, t)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`, t)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`, t))), this;
    }
    getBearing() {
        return this.transform.bearing;
    }
    setZoomSnap(e1) {
        return this._zoomSnap = e1, this;
    }
    getZoomSnap() {
        return this._zoomSnap;
    }
    setBearing(e1, t) {
        return this.jumpTo({
            bearing: e1
        }, t), this;
    }
    getPadding() {
        return this.transform.padding;
    }
    setPadding(e1, t) {
        return this.jumpTo({
            padding: e1
        }, t), this;
    }
    rotateTo(e1, t, n) {
        return this.easeTo((0, $1rqx5.er)({
            bearing: e1
        }, t), n);
    }
    resetNorth(e1, t) {
        return this.rotateTo(0, (0, $1rqx5.er)({
            duration: 1e3
        }, e1), t), this;
    }
    resetNorthPitch(e1, t) {
        return this.easeTo((0, $1rqx5.er)({
            bearing: 0,
            pitch: 0,
            roll: 0,
            duration: 1e3
        }, e1), t), this;
    }
    snapToNorth(e1, t) {
        return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
    }
    getPitch() {
        return this.transform.pitch;
    }
    setPitch(e1, t) {
        return this.jumpTo({
            pitch: e1
        }, t), this;
    }
    getRoll() {
        return this.transform.roll;
    }
    setRoll(e1, t) {
        return this.jumpTo({
            roll: e1
        }, t), this;
    }
    cameraForBounds(e1, t) {
        e1 = $834619e78bbf578c$export$266d2884f61535d3.convert(e1).adjustAntiMeridian();
        let n = t?.bearing || 0;
        return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), n, t);
    }
    _cameraForBoxAndBearing(e1, n, r, i) {
        let a = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        if (i = (0, $1rqx5.er)({
            padding: a,
            offset: [
                0,
                0
            ],
            maxZoom: this.transform.maxZoom
        }, i), typeof i.padding == `number`) {
            let e1 = i.padding;
            i.padding = {
                top: e1,
                bottom: e1,
                right: e1,
                left: e1
            };
        }
        let o = (0, $1rqx5.er)(a, i.padding);
        i.padding = o;
        let s = this.transform, c = new $834619e78bbf578c$export$266d2884f61535d3(e1, n), l = this.cameraHelper.cameraForBoxAndBearing(i, o, c, r, s);
        return l && this._zoomSnap && (l.zoom = (0, $1rqx5.$n)(l.zoom, this._zoomSnap, -1)), l;
    }
    fitBounds(e1, t, n) {
        return this._fitInternal(this.cameraForBounds(e1, t), t, n);
    }
    fitScreenCoordinates(e1, t, n, r, i) {
        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation((0, $1rqx5.Li).convert(e1)), this.transform.screenPointToLocation((0, $1rqx5.Li).convert(t)), n, r), r, i);
    }
    _fitInternal(e1, t, n) {
        return e1 ? (t = (0, $1rqx5.er)(e1, t), delete t.padding, t.linear ? this.easeTo(t, n) : this.flyTo(t, n)) : this;
    }
    jumpTo(e1, n) {
        this.stop(), e1.zoom !== void 0 && this._zoomSnap && (e1.zoom = (0, $1rqx5.$n)(e1.zoom, this._zoomSnap));
        let r = this.getTransformForUpdate(), i = !1, a = !1, o = !1, s = r.zoom;
        this.terrain && r.setElevation(this.terrain.getElevationForLngLat(e1.center ? (0, $1rqx5.lt).convert(e1.center) : r.center, r)), this.cameraHelper.handleJumpToCenterZoom(r, e1);
        let c = r.zoom !== s;
        return e1.elevation !== void 0 && r.elevation !== +e1.elevation && r.setElevation(+e1.elevation), e1.bearing !== void 0 && r.bearing !== +e1.bearing && (i = !0, r.setBearing(+e1.bearing)), e1.pitch !== void 0 && r.pitch !== +e1.pitch && (a = !0, r.setPitch(+e1.pitch)), e1.roll !== void 0 && r.roll !== +e1.roll && (o = !0, r.setRoll(+e1.roll)), e1.padding != null && !r.isPaddingEqual(e1.padding) && r.setPadding(e1.padding), this.applyUpdatedTransform(r), this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`, n)), c && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomstart`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoom`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomend`, n)), i && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rotatestart`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rotate`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rotateend`, n)), a && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchstart`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitch`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchend`, n)), o && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rollstart`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`roll`, n)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rollend`, n)), this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`, n));
    }
    calculateAnchoredCameraOptions(e1) {
        let t = this.transform.clone(), n = (0, $1rqx5.lt).convert(e1.anchorLocation), r = (0, $1rqx5.Li).convert(e1.anchorScreenPoint), i = {
            panDelta: r.sub(this.transform.locationToScreenPoint(n, this.terrain)),
            zoomDelta: e1.zoom === void 0 ? 0 : e1.zoom - t.zoom,
            bearingDelta: 0,
            pitchDelta: 0,
            rollDelta: 0,
            around: r,
            aroundElevation: this.terrain?.getElevationForLngLat(n, t)
        };
        return this.cameraHelper.handleMapControlsRollPitchBearingZoom(i, t), this.cameraHelper.handleMapControlsPan(i, t, n), {
            center: t.center,
            zoom: t.zoom
        };
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i) {
        let a = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
        return {
            center: a.center,
            elevation: a.elevation,
            zoom: a.zoom,
            bearing: n,
            pitch: r,
            roll: i
        };
    }
    easeTo(e1, n) {
        this._stop(!1, e1.easeId), e1 = (0, $1rqx5.er)({
            offset: [
                0,
                0
            ],
            duration: 500,
            easing: (0, $1rqx5.Jn)
        }, e1), e1.zoom !== void 0 && this._zoomSnap && (e1.zoom = (0, $1rqx5.$n)(e1.zoom, this._zoomSnap)), (e1.animate === !1 || !e1.essential && $834619e78bbf578c$var$Rr.prefersReducedMotion) && (e1.duration = 0);
        let r = this.getTransformForUpdate(), i = this.getBearing(), a = r.pitch, o = r.roll, s = e1.bearing === void 0 ? i : this._normalizeBearing(e1.bearing, i), c = e1.pitch === void 0 ? a : +e1.pitch, l = e1.roll === void 0 ? o : this._normalizeBearing(e1.roll, o), u = e1.padding === void 0 ? r.padding : e1.padding, d = (0, $1rqx5.Li).convert(e1.offset), f, p;
        e1.around && (f = (0, $1rqx5.lt).convert(e1.around), p = r.locationToScreenPoint(f));
        let m = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching,
            rolling: this._rolling
        }, h = this.cameraHelper.handleEaseTo(r, {
            bearing: s,
            pitch: c,
            roll: l,
            padding: u,
            around: f,
            aroundPoint: p,
            offsetAsPoint: d,
            offset: e1.offset,
            zoom: e1.zoom,
            center: e1.center
        });
        return this._rotating ||= i !== s, this._pitching ||= c !== a, this._rolling ||= l !== o, this._padding = !r.isPaddingEqual(u), this._zooming ||= h.isZooming, this._easeId = e1.easeId, this._prepareEase(n, e1.noMoveStart, m), this.terrain && this._prepareElevation(h.elevationCenter, r), this._ease((t)=>{
            h.easeFunc(t), this.terrain && !e1.freezeElevation && this._updateElevation(t, r), this.applyUpdatedTransform(r), this._fireMoveEvents(n);
        }, (t)=>{
            this.terrain && e1.freezeElevation ? this._finalizeElevation() : this.elevationFreeze = !1, this._afterEase(n, t);
        }, e1), this;
    }
    _prepareEase(e1, t, n = {}) {
        this._moving = !0, !t && !n.moving && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`, e1)), this._zooming && !n.zooming && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomstart`, e1)), this._rotating && !n.rotating && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rotatestart`, e1)), this._pitching && !n.pitching && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchstart`, e1)), this._rolling && !n.rolling && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rollstart`, e1));
    }
    _prepareElevation(e1, t) {
        this._elevationCenter = e1, this._elevationStart = t.elevation, this._elevationTarget = this.terrain.getElevationForLngLat(e1, t), this.elevationFreeze = !0;
    }
    _updateElevation(e1, t) {
        (this._elevationStart === void 0 || this._elevationCenter === void 0) && this._prepareElevation(t.center, t), t.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, t.tileZoom));
        let n = this.terrain.getElevationForLngLat(this._elevationCenter, t);
        if (e1 < 1 && n !== this._elevationTarget) {
            let t = this._elevationTarget - this._elevationStart, r = (n - (t * e1 + this._elevationStart)) / (1 - e1);
            this._elevationStart += e1 * (t - r), this._elevationTarget = n;
        }
        t.setElevation((0, $1rqx5.un).number(this._elevationStart, this._elevationTarget, e1));
    }
    _finalizeElevation() {
        this.elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
    }
    applyTerrainChange() {
        if (this.elevationFreeze) return;
        let e1 = this.transform;
        e1.setMinElevationForCurrentTile(this.terrain ? this.terrain.getMinTileElevationForLngLatZoom(e1.center, e1.tileZoom) : 0), this.getCenterClampedToGround() && e1.setElevation(this.terrain ? this.terrain.getElevationForLngLat(e1.center, e1) : 0);
    }
    getTransformForUpdate() {
        return !this.transformCameraUpdate && !this.terrain ? this.transform : (this._requestedCameraState ||= this.transform.clone(), this._requestedCameraState);
    }
    _elevateCameraIfInsideTerrain(e1) {
        if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
        let t = e1.getCameraLngLat(), n = e1.getCameraAltitude(), r = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e1.zoom) : 0;
        if (n < r) {
            let n = e1.calculateCameraOptionsFromTo(t, r, e1.center, e1.elevation);
            return {
                pitch: n.pitch,
                zoom: n.zoom
            };
        }
        return {};
    }
    applyUpdatedTransform(e1) {
        let t = [];
        if (t.push((e1)=>this._elevateCameraIfInsideTerrain(e1)), this.transformCameraUpdate && t.push((e1)=>this.transformCameraUpdate(e1)), !t.length) return;
        let n = e1.clone();
        for (let e1 of t){
            let t = n.clone(), { center: r, zoom: i, roll: a, pitch: o, bearing: s, elevation: c } = e1(t);
            r && t.setCenter(r), c !== void 0 && t.setElevation(c), i !== void 0 && t.setZoom(i), a !== void 0 && t.setRoll(a), o !== void 0 && t.setPitch(o), s !== void 0 && t.setBearing(s), n.apply(t, !1);
        }
        this.transform.apply(n, !1);
    }
    applyTransformChange(e1) {
        let t = this._requestedCameraState !== void 0, n = this.getTransformForUpdate();
        e1(n), this.applyUpdatedTransform(n), t || delete this._requestedCameraState;
    }
    _fireMoveEvents(e1) {
        this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`, e1)), this._zooming && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoom`, e1)), this._rotating && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rotate`, e1)), this._pitching && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitch`, e1)), this._rolling && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`roll`, e1));
    }
    _afterEase(e1, t) {
        if (this._easeId && t && this._easeId === t) return;
        delete this._easeId;
        let n = this._zooming, r = this._rotating, i = this._pitching, a = this._rolling;
        this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, n && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomend`, e1)), r && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rotateend`, e1)), i && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchend`, e1)), a && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`rollend`, e1)), this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`, e1));
    }
    flyTo(e1, n) {
        if (!e1.essential && $834619e78bbf578c$var$Rr.prefersReducedMotion) {
            let t = (0, $1rqx5.yr)(e1, [
                `center`,
                `zoom`,
                `bearing`,
                `pitch`,
                `roll`,
                `elevation`,
                `padding`
            ]);
            return this.jumpTo(t, n);
        }
        this.stop(), e1 = (0, $1rqx5.er)({
            offset: [
                0,
                0
            ],
            speed: 1.2,
            curve: 1.42,
            easing: (0, $1rqx5.Jn)
        }, e1), e1.zoom !== void 0 && this._zoomSnap && (e1.zoom = (0, $1rqx5.$n)(e1.zoom, this._zoomSnap));
        let r = this.getTransformForUpdate(), i = r.bearing, a = r.pitch, o = r.roll, s = r.padding, c = e1.bearing === void 0 ? i : this._normalizeBearing(e1.bearing, i), l = e1.pitch === void 0 ? a : +e1.pitch, u = e1.roll === void 0 ? o : this._normalizeBearing(e1.roll, o), d = e1.padding === void 0 ? r.padding : e1.padding, f = (0, $1rqx5.Li).convert(e1.offset), p = r.centerPoint.add(f), m = r.screenPointToLocation(p), h = this.cameraHelper.handleFlyTo(r, {
            bearing: c,
            pitch: l,
            roll: u,
            padding: d,
            locationAtOffset: m,
            offsetAsPoint: f,
            center: e1.center,
            minZoom: e1.minZoom,
            zoom: e1.zoom
        }), g = e1.curve, _ = Math.max(r.width, r.height), v = _ / h.scaleOfZoom, y = h.pixelPathLength, b = _ / h.scaleOfMinZoom;
        g = Math.min(g, Math.sqrt(b / y * 2));
        let x = g * g;
        function S(e1) {
            let t = (v * v - _ * _ + (e1 ? -1 : 1) * x * x * y * y) / (2 * (e1 ? v : _) * x * y);
            return Math.log(Math.sqrt(t * t + 1) - t);
        }
        function C(e1) {
            return (Math.exp(e1) - Math.exp(-e1)) / 2;
        }
        function w(e1) {
            return (Math.exp(e1) + Math.exp(-e1)) / 2;
        }
        function T(e1) {
            return C(e1) / w(e1);
        }
        let E = S(!1), D = function(e1) {
            return w(E) / w(E + g * e1);
        }, O = function(e1) {
            return _ * ((w(E) * T(E + g * e1) - C(E)) / x) / y;
        }, k = (S(!0) - E) / g;
        if (Math.abs(y) < 2e-6 || !isFinite(k)) {
            if (Math.abs(_ - v) < 1e-6) return this.easeTo(e1, n);
            let t = v < _ ? -1 : 1;
            k = Math.abs(Math.log(v / _)) / g, O = ()=>0, D = (e1)=>Math.exp(t * g * e1);
        }
        if (e1.duration !== void 0) e1.duration = +e1.duration;
        else {
            let t = e1.screenSpeed === void 0 ? +e1.speed : +e1.screenSpeed / g;
            e1.duration = 1e3 * k / t;
        }
        return e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = i !== c, this._pitching = l !== a, this._rolling = u !== o, this._padding = !r.isPaddingEqual(d), this._prepareEase(n, !1), this.terrain && this._prepareElevation(h.targetCenter, r), this._ease((t)=>{
            let m = t * k, g = 1 / D(m), _ = O(m);
            this._rotating && r.setBearing((0, $1rqx5.un).number(i, c, t)), this._pitching && r.setPitch((0, $1rqx5.un).number(a, l, t)), this._rolling && r.setRoll((0, $1rqx5.un).number(o, u, t)), this._padding && (r.interpolatePadding(s, d, t), p = r.centerPoint.add(f)), h.easeFunc(t, g, _, p), this.terrain && !e1.freezeElevation && this._updateElevation(t, r), this.applyUpdatedTransform(r), this._fireMoveEvents(n);
        }, ()=>{
            this.terrain && e1.freezeElevation ? this._finalizeElevation() : this.elevationFreeze = !1, this._afterEase(n);
        }, e1), this;
    }
    isEasing() {
        return !!this._easeFrameId;
    }
    stop(e1) {
        return this._stop(e1);
    }
    _stop(e1, t) {
        if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
            let e1 = this._onEaseEnd;
            delete this._onEaseEnd, e1.call(this, t);
        }
        return e1 || this._stopHandlers(), this;
    }
    _ease(e1, t, n) {
        n.animate === !1 || n.duration === 0 ? (e1(1), t()) : (this._easeStart = $834619e78bbf578c$export$461939dd4422153(), this._easeOptions = n, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
    }
    _normalizeBearing(e1, t) {
        e1 = (0, $1rqx5.Pr)(e1, -180, 180);
        let n = Math.abs(e1 - t);
        return Math.abs(e1 - 360 - t) < n && (e1 -= 360), Math.abs(e1 + 360 - t) < n && (e1 += 360), e1;
    }
    isMoving() {
        return this._moving;
    }
    isZooming() {
        return this._zooming;
    }
    isRotating() {
        return this._rotating;
    }
};
const $834619e78bbf578c$var$Am = {
    compact: !0,
    customAttribution: `<a href="https://maplibre.org/" target="_blank">MapLibre</a>`
};
var $834619e78bbf578c$export$5af5c3cc9905683 = class {
    constructor(e1 = $834619e78bbf578c$var$Am){
        this._toggleAttribution = ()=>{
            this._container.classList.contains(`maplibregl-compact`) && (this._container.classList.contains(`maplibregl-compact-show`) ? (this._container.setAttribute(`open`, ``), this._container.classList.remove(`maplibregl-compact-show`)) : (this._container.classList.add(`maplibregl-compact-show`), this._container.removeAttribute(`open`)));
        }, this._updateData = (e1)=>{
            e1 && (e1.type === `terrain` || e1.dataType === `style` || e1.dataType === `source` && (e1.sourceDataType === `metadata` || e1.sourceDataType === `visibility`)) && this._updateAttributions();
        }, this._updateCompact = ()=>{
            this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact === !1 ? this._container.setAttribute(`open`, ``) : !this._container.classList.contains(`maplibregl-compact`) && !this._container.classList.contains(`maplibregl-attrib-empty`) && (this._container.setAttribute(`open`, ``), this._container.classList.add(`maplibregl-compact`, `maplibregl-compact-show`)) : (this._container.setAttribute(`open`, ``), this._container.classList.contains(`maplibregl-compact`) && this._container.classList.remove(`maplibregl-compact`, `maplibregl-compact-show`));
        }, this._updateCompactMinimize = ()=>{
            this._container.classList.contains(`maplibregl-compact`) && this._container.classList.contains(`maplibregl-compact-show`) && this._container.classList.remove(`maplibregl-compact-show`);
        }, this.options = e1;
    }
    getDefaultPosition() {
        return `bottom-right`;
    }
    onAdd(e1) {
        return this._map = e1, this._compact = this.options.compact, this._container = $834619e78bbf578c$var$G.create(`details`, `maplibregl-ctrl maplibregl-ctrl-attrib`), this._compactButton = $834619e78bbf578c$var$G.create(`summary`, `maplibregl-ctrl-attrib-button`, this._container), this._compactButton.addEventListener(`click`, this._toggleAttribution), this._setElementTitle(this._compactButton, `ToggleAttribution`), this._innerContainer = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl-attrib-inner`, this._container), this._updateAttributions(), this._updateCompact(), this._map.on(`styledata`, this._updateData), this._map.on(`sourcedata`, this._updateData), this._map.on(`terrain`, this._updateData), this._map.on(`resize`, this._updateCompact), this._map.on(`drag`, this._updateCompactMinimize), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`styledata`, this._updateData), this._map.off(`sourcedata`, this._updateData), this._map.off(`terrain`, this._updateData), this._map.off(`resize`, this._updateCompact), this._map.off(`drag`, this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
    }
    _setElementTitle(e1, t) {
        let n = this._map._getUIString(`AttributionControl.${t}`);
        e1.title = n, e1.setAttribute(`aria-label`, n);
    }
    _updateAttributions() {
        if (!this._map.style) return;
        let e1 = [];
        if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = e1.concat(this.options.customAttribution.map((e1)=>typeof e1 == `string` ? e1 : ``)) : typeof this.options.customAttribution == `string` && e1.push(this.options.customAttribution)), this._map.style.stylesheet) {
            let e1 = this._map.style.stylesheet;
            this.styleOwner = e1.owner, this.styleId = e1.id;
        }
        let t = this._map.style.tileManagers;
        for(let n in t){
            let r = t[n];
            if (r.used || r.usedForTerrain) {
                let t = r.getSource();
                t.attribution && !e1.includes(t.attribution) && e1.push(t.attribution);
            }
        }
        e1 = e1.filter((e1)=>String(e1).trim()), e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, n)=>{
            for(let r = n + 1; r < e1.length; r++)if (e1[r].includes(t)) return !1;
            return !0;
        });
        let n = e1.join(` | `);
        n !== this._attribHTML && (this._attribHTML = n, e1.length ? (this._innerContainer.replaceChildren($834619e78bbf578c$var$G.sanitize(n)), this._container.classList.remove(`maplibregl-attrib-empty`)) : this._container.classList.add(`maplibregl-attrib-empty`), this._updateCompact(), this._editLink = null);
    }
}, $834619e78bbf578c$export$6941d1bdee1234d4 = class {
    constructor(e1 = {}){
        this._updateCompact = ()=>{
            let e1 = this._container.children;
            if (e1.length) {
                let t = e1[0];
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact !== !1 && t.classList.add(`maplibregl-compact`) : t.classList.remove(`maplibregl-compact`);
            }
        }, this.options = e1;
    }
    getDefaultPosition() {
        return `bottom-left`;
    }
    onAdd(e1) {
        this._map = e1, this._compact = this.options?.compact, this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl`);
        let t = $834619e78bbf578c$var$G.create(`a`, `maplibregl-ctrl-logo`);
        return t.target = `_blank`, t.rel = `noopener nofollow`, t.href = `https://maplibre.org/`, t.setAttribute(`aria-label`, this._map._getUIString(`LogoControl.Title`)), t.setAttribute(`rel`, `noopener nofollow`), this._container.appendChild(t), this._container.style.display = `block`, this._map.on(`resize`, this._updateCompact), this._updateCompact(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`resize`, this._updateCompact), this._map = void 0, this._compact = void 0;
    }
}, $834619e78bbf578c$var$Nm = class {
    constructor(){
        this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
    }
    add(e1) {
        let t = ++this._id;
        return this._queue.push({
            callback: e1,
            id: t,
            cancelled: !1
        }), t;
    }
    remove(e1) {
        let t = this._currentlyRunning, n = t ? this._queue.concat(t) : this._queue;
        for (let t of n)if (t.id === e1) {
            t.cancelled = !0;
            return;
        }
    }
    run(e1 = 0) {
        if (this._currentlyRunning) throw Error(`Attempting to run(), but is already running.`);
        let t = this._currentlyRunning = this._queue;
        this._queue = [];
        let n = !1, r;
        for (let i of t)if (!i.cancelled) {
            try {
                i.callback(e1);
            } catch (e1) {
                n || (n = !0, r = e1);
            }
            if (this._cleared) break;
        }
        if (this._cleared = !1, this._currentlyRunning = !1, n) throw r;
    }
    clear() {
        this._currentlyRunning && (this._cleared = !0), this._queue = [];
    }
};
const $834619e78bbf578c$var$Pm = [
    `none`,
    `zoom`,
    `sourceTiles`,
    `visibleLayers`,
    `revision`
];
var $834619e78bbf578c$var$Fm = class {
    constructor(e1, t, n, r){
        this._tileKeys = e1.map((e1)=>e1.key).sort().join(), this._revision = t, this._zoom = n, this._visibleLayerIds = r;
    }
    difference(e1) {
        return this._revision === e1?._revision ? this._visibleLayerIds === e1._visibleLayerIds ? this._tileKeys === e1._tileKeys ? this._zoom === e1._zoom ? `none` : `zoom` : `sourceTiles` : `visibleLayers` : `revision`;
    }
};
const $834619e78bbf578c$var$Im = {
    background: !0,
    fill: !0,
    line: !0,
    raster: !0,
    hillshade: !0,
    "color-relief": !0
};
var $834619e78bbf578c$var$Lm = class {
    constructor(e1, t){
        this.needsFollowUpFrame = !1, this.painter = e1, this.terrain = t, this.rttSize = t.tileManager.tileSize * t.qualityFactor;
    }
    getTexture(e1) {
        return e1.getRTT(this._stacks.length - 1).texture;
    }
    prepareForRender(e1, t) {
        let n = t !== this._lastPrepareZoom;
        this._lastPrepareZoom = t, this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter((n)=>!e1._layers[n].isHidden(t));
        let r = this._renderableLayerIds.join(), i = /* @__PURE__ */ new Set;
        for (let t of this._renderableLayerIds){
            let n = e1._layers[t], r = n.source;
            r && $834619e78bbf578c$var$Im[n.type] && i.add(r);
        }
        this._coordsAscending = {}, this._rttFingerprints = {};
        for (let n of i){
            let i = e1.tileManagers[n];
            if (!i) continue;
            this._coordsAscending[n] = {};
            let a = this._coordsAscending[n], o = i.getSource(), s = o instanceof $834619e78bbf578c$export$280e9a68c3ffd919 ? o.terrainTileRanges : null;
            for (let e1 of i.getVisibleCoordinates()){
                let t = this.terrain.tileManager.getTerrainCoords(e1, s);
                for(let e1 in t)a[e1] ||= [], a[e1].push(t[e1]);
            }
            this._rttFingerprints[n] = {};
            let c = this._rttFingerprints[n], l = i.getState().revision;
            for(let e1 in a)c[e1] = new $834619e78bbf578c$var$Fm(a[e1], l, t, r);
        }
        this.needsFollowUpFrame = !1;
        let a = n || this.painter.options.moving, o = !1;
        for (let e1 of this._renderableTiles){
            let t = this._textureDifference(e1);
            t !== `none` && (t === `zoom` && a || t === `visibleLayers` && n ? this.needsFollowUpFrame = !0 : t === `zoom` || t === `sourceTiles` ? (o ? this.needsFollowUpFrame = !0 : e1.releaseRTT(this.painter), o = !0) : e1.releaseRTT(this.painter));
        }
    }
    _textureDifference(e1) {
        let t = `none`;
        for(let n in this._rttFingerprints){
            let r = this._rttFingerprints[n][e1.tileID.key];
            if (!r) continue;
            let i = r.difference(e1.rttFingerprint[n]);
            $834619e78bbf578c$var$Pm.indexOf(i) > $834619e78bbf578c$var$Pm.indexOf(t) && (t = i);
        }
        return t;
    }
    renderLayer(e1, t) {
        if (e1.isHidden(this.painter.transform.zoom)) return !1;
        let n = e1.type, r = this.painter, i = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
        if ($834619e78bbf578c$var$Im[n] && ((!this._prevType || !$834619e78bbf578c$var$Im[this._prevType]) && this._stacks.push([]), this._prevType = n, this._stacks[this._stacks.length - 1].push(e1.id), !i)) return !0;
        if ($834619e78bbf578c$var$Im[this._prevType] || $834619e78bbf578c$var$Im[n] && i) {
            this._prevType = n;
            let e1 = this._stacks.length - 1, i = this._stacks[e1] || [];
            t.isRenderingToTexture = !0;
            for (let n of this._renderableTiles){
                if (this._rttTiles.push(n), n.getRTT(e1)) continue;
                let a = n.acquireRTT(r, e1, this.rttSize);
                r.bindRTT(a), r.context.clear({
                    color: (0, $1rqx5.fn).transparent,
                    stencil: 0
                }), r.currentStencilSource = void 0;
                for (let e1 of i){
                    let i = r.style._layers[e1], a = i.source ? this._coordsAscending[i.source][n.tileID.key] : [
                        n.tileID
                    ];
                    r.context.viewport.set([
                        0,
                        0,
                        this.rttSize,
                        this.rttSize
                    ]), r.renderTileClippingMasks(i, a), r.renderLayer(r, r.style.tileManagers[i.source], i, a, t), i.source && (n.rttFingerprint[i.source] = this._rttFingerprints[i.source][n.tileID.key]);
                }
                a.texture.generateMipmap();
            }
            return t.isRenderingToTexture = !1, $834619e78bbf578c$var$vp(this.painter, this.terrain, this._rttTiles, t), this._rttTiles = [], $834619e78bbf578c$var$Im[n];
        }
        return !1;
    }
};
const $834619e78bbf578c$var$Rm = {
    "AttributionControl.ToggleAttribution": `Toggle attribution`,
    "AttributionControl.MapFeedback": `Map feedback`,
    "FullscreenControl.Enter": `Enter fullscreen`,
    "FullscreenControl.Exit": `Exit fullscreen`,
    "GeolocateControl.FindMyLocation": `Find my location`,
    "GeolocateControl.LocationNotAvailable": `Location not available`,
    "LogoControl.Title": `MapLibre logo`,
    "Map.Title": `Map`,
    "Marker.Title": `Map marker`,
    "NavigationControl.ResetBearing": `Drag to rotate map, click to reset north`,
    "NavigationControl.ZoomIn": `Zoom in`,
    "NavigationControl.ZoomOut": `Zoom out`,
    "Popup.Close": `Close popup`,
    "ScaleControl.Feet": `ft`,
    "ScaleControl.Meters": `m`,
    "ScaleControl.Kilometers": `km`,
    "ScaleControl.Miles": `mi`,
    "ScaleControl.NauticalMiles": `nm`,
    "GlobeControl.Enable": `Enable globe`,
    "GlobeControl.Disable": `Disable globe`,
    "TerrainControl.Enable": `Enable terrain`,
    "TerrainControl.Disable": `Disable terrain`,
    "CooperativeGesturesHandler.WindowsHelpText": `Use Ctrl + scroll to zoom the map`,
    "CooperativeGesturesHandler.MacHelpText": `Use \u{2318} + scroll to zoom the map`,
    "CooperativeGesturesHandler.MobileHelpText": `Use two fingers to move the map`
}, $834619e78bbf578c$var$zm = $834619e78bbf578c$var$Ar, $834619e78bbf578c$var$Bm = {
    hash: !1,
    interactive: !0,
    bearingSnap: 7,
    zoomSnap: 0,
    attributionControl: $834619e78bbf578c$var$Am,
    maplibreLogo: !1,
    refreshExpiredTiles: !0,
    canvasContextAttributes: {
        antialias: !1,
        preserveDrawingBuffer: !1,
        powerPreference: `high-performance`,
        failIfMajorPerformanceCaveat: !1,
        desynchronized: !1,
        contextType: void 0
    },
    scrollZoom: !0,
    minZoom: -2,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    boxZoom: !0,
    dragRotate: !0,
    dragPan: !0,
    keyboard: !0,
    doubleClickZoom: !0,
    touchZoomRotate: !0,
    touchPitch: !0,
    cooperativeGestures: !1,
    trackResize: !0,
    center: [
        0,
        0
    ],
    elevation: 0,
    zoom: 0,
    bearing: 0,
    pitch: 0,
    roll: 0,
    renderWorldCopies: !0,
    maxTileCacheSize: null,
    maxTileCacheZoomLevels: (0, $1rqx5.An).MAX_TILE_CACHE_ZOOM_LEVELS,
    transformRequest: null,
    transformCameraUpdate: null,
    transformConstrain: null,
    fadeDuration: 300,
    crossSourceCollisions: !0,
    clickTolerance: 3,
    localIdeographFontFamily: `sans-serif`,
    pitchWithRotate: !0,
    rollEnabled: !1,
    rotateSpeed: .8,
    pitchSpeed: -0.5,
    reduceMotion: void 0,
    validateStyle: !0,
    maxCanvasSize: [
        4096,
        4096
    ],
    cancelPendingTileRequestsWhileZooming: !0,
    centerClampedToGround: !0,
    terrainSkirtLength: `auto`,
    zoomLevelsToOverscale: 4,
    anisotropicFilterPitch: 20
};
var $834619e78bbf578c$export$a5c7b93649eaf8f8 = class extends (0, $1rqx5.vn) {
    get _ownerWindow() {
        return this._container?.ownerDocument?.defaultView || window;
    }
    constructor(e1){
        super(), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new $834619e78bbf578c$var$Nm, this._controls = [], this._mapId = (0, $1rqx5.Mr)(), this._styleUrl = null, this._missingStyleImageResolver = null, this._lostContextStyle = {
            style: null,
            images: null
        }, this._contextLost = (e1)=>{
            if (e1.preventDefault(), this._frameRequest &&= (this._frameRequest.abort(), null), this.painter.destroy(), this._lostContextStyle = this._getStyleAndImages(), !this.style) {
                this.fire(new $834619e78bbf578c$export$3238995171e25bd5(`webglcontextlost`, {
                    originalEvent: e1
                }));
                return;
            }
            for (let e1 of Object.values(this.style._layers))if (e1.type === `custom` && console.warn(`Custom layer with id '${e1.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e1._listeners) for (let [t] of Object.entries(e1._listeners))console.warn(`Custom layer with id '${e1.id}' had event listeners for event '${t}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
            this.style.destroy(), this.style = null, this.fire(new $834619e78bbf578c$export$3238995171e25bd5(`webglcontextlost`, {
                originalEvent: e1
            }));
        }, this._contextRestored = (e1)=>{
            if (this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                diff: !1
            }), this._lostContextStyle.images && this.style) {
                this.style.imageManager.images = this._lostContextStyle.images;
                for(let e1 in this._lostContextStyle.images){
                    let t = this._lostContextStyle.images[e1];
                    t.isWebGLImage && this.style.imageManager.updateImage(e1, t, !1);
                }
            }
            this._lostContextStyle = {
                style: null,
                images: null
            };
            try {
                this._setupPainter();
            } catch (e1) {
                this.fire(new (0, $1rqx5.gn)(e1));
                return;
            }
            this.resize(), this._update(), this._resizeInternal(), this.fire(new $834619e78bbf578c$export$3238995171e25bd5(`webglcontextrestored`, {
                originalEvent: e1
            }));
        }, this._onMapScroll = (e1)=>{
            if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
        }, this._onWindowOnline = ()=>{
            this._update();
        };
        let t = {
            ...$834619e78bbf578c$var$Bm,
            ...e1,
            canvasContextAttributes: {
                ...$834619e78bbf578c$var$Bm.canvasContextAttributes,
                ...e1.canvasContextAttributes
            }
        };
        if (t.minZoom != null && t.maxZoom != null && t.minZoom > t.maxZoom) throw Error(`maxZoom must be greater than or equal to minZoom`);
        if (t.minPitch != null && t.maxPitch != null && t.minPitch > t.maxPitch) throw Error(`maxPitch must be greater than or equal to minPitch`);
        if (t.minPitch != null && t.minPitch < 0) throw Error(`minPitch must be greater than or equal to 0`);
        if (t.maxPitch != null && t.maxPitch > 180) throw Error(`maxPitch must be less than or equal to 180`);
        this._camera = new $834619e78bbf578c$var$km({
            minZoom: t.minZoom,
            maxZoom: t.maxZoom,
            minPitch: t.minPitch,
            maxPitch: t.maxPitch,
            bearingSnap: t.bearingSnap,
            zoomSnap: t.zoomSnap,
            renderWorldCopies: t.renderWorldCopies,
            centerClampedToGround: t.centerClampedToGround,
            terrain: this.terrain,
            transformConstrain: t.transformConstrain,
            requestRenderFrame: (e1)=>this._requestRenderFrame(e1),
            cancelRenderFrame: (e1)=>this._cancelRenderFrame(e1),
            transformCameraUpdate: t.transformCameraUpdate,
            stopHandlers: ()=>this._handlers?.stop(!1)
        }), this._camera.setEventedParent(this), this._interactive = t.interactive, this._maxTileCacheSize = t.maxTileCacheSize, this._maxTileCacheZoomLevels = t.maxTileCacheZoomLevels, this._canvasContextAttributes = {
            ...t.canvasContextAttributes
        }, this._trackResize = t.trackResize === !0, this._terrainSkirtLength = t.terrainSkirtLength, this._refreshExpiredTiles = t.refreshExpiredTiles === !0, this._fadeDuration = t.fadeDuration, this._crossSourceCollisions = t.crossSourceCollisions === !0, this._collectResourceTiming = t.collectResourceTiming === !0, this._locale = {
            ...$834619e78bbf578c$var$Rm,
            ...t.locale
        }, this._clickTolerance = t.clickTolerance, this._overridePixelRatio = t.pixelRatio, this._maxCanvasSize = t.maxCanvasSize, this._zoomLevelsToOverscale = t.zoomLevelsToOverscale, this.cancelPendingTileRequestsWhileZooming = t.cancelPendingTileRequestsWhileZooming === !0, this.setAnisotropicFilterPitch(t.anisotropicFilterPitch), t.reduceMotion !== void 0 && ($834619e78bbf578c$var$Rr.prefersReducedMotion = t.reduceMotion), this._requestManager = new $834619e78bbf578c$var$Xr(t.transformRequest), this._container = this._resolveContainer(t.container), t.maxBounds && this.setMaxBounds(t.maxBounds), this._setupContainer();
        try {
            this._setupPainter();
        } catch (e1) {
            throw this._cleanupContainer(), e1;
        }
        this._imageQueueHandle = $834619e78bbf578c$var$Yr.addThrottleControl(()=>this.isMoving()), this.on(`move`, ()=>this._update(!1)), this.on(`moveend`, ()=>this._update(!1)), this.on(`zoom`, ()=>this._update(!0)), this.on(`terrain`, ()=>{
            this.painter.markTerrainDepthDirty(), this._update(!0);
        }), this.once(`idle`, ()=>this._idleTriggered = !0), this._handlers = new $834619e78bbf578c$var$Om(this, this._camera, t), typeof window < `u` && (this._ownerWindow.addEventListener(`online`, this._onWindowOnline, !1), this._setupResizeObserver());
        let n = typeof t.hash == `string` && t.hash || void 0;
        this._hash = t.hash ? new $834619e78bbf578c$export$ab85ecd77ce6a5cd(n).addTo(this) : void 0, this._hash?._onHashChange() || (this.jumpTo({
            center: t.center,
            elevation: t.elevation,
            zoom: t.zoom,
            bearing: t.bearing,
            pitch: t.pitch,
            roll: t.roll
        }), t.bounds && (this.resize(), this.fitBounds(t.bounds, (0, $1rqx5.er)({}, t.fitBoundsOptions, {
            duration: 0
        }))));
        let r = typeof t.style == `string` || t.style?.projection?.type !== `globe`;
        this.resize(null, r), this._localIdeographFontFamily = t.localIdeographFontFamily, this._validateStyle = t.validateStyle, t.style && this.setStyle(t.style, {
            localIdeographFontFamily: t.localIdeographFontFamily
        }), t.attributionControl && this.addControl(new $834619e78bbf578c$export$5af5c3cc9905683(typeof t.attributionControl == `boolean` ? void 0 : t.attributionControl)), t.maplibreLogo && this.addControl(new $834619e78bbf578c$export$6941d1bdee1234d4, t.logoPosition), this.on(`style.load`, ()=>{
            if (r || this._resizeTransform(), this._camera.transform.unmodified) {
                let e1 = (0, $1rqx5.yr)(this.style.stylesheet, [
                    `center`,
                    `zoom`,
                    `bearing`,
                    `pitch`,
                    `roll`
                ]);
                this.jumpTo(e1);
            }
        }), this.on(`data`, (e1)=>{
            this._update(e1.dataType === `style`), this.fire(e1.dataType === `style` ? new $834619e78bbf578c$export$49025a11e3fe5bd0(`styledata`, e1) : new $834619e78bbf578c$export$ae09c661b7a299b2(`sourcedata`, e1));
        }), this.on(`dataloading`, (e1)=>{
            this.fire(e1.dataType === `style` ? new $834619e78bbf578c$export$49025a11e3fe5bd0(`styledataloading`, e1) : new $834619e78bbf578c$export$ae09c661b7a299b2(`sourcedataloading`, e1));
        }), this.on(`dataabort`, (e1)=>{
            this.fire(new $834619e78bbf578c$export$ae09c661b7a299b2(`sourcedataabort`, e1));
        });
    }
    _getMapId() {
        return this._mapId;
    }
    setGlobalStateProperty(e1, t) {
        return this.style.setGlobalStateProperty(e1, t), this._update(!0);
    }
    getGlobalState() {
        return this.style.getGlobalState();
    }
    addControl(e1, t) {
        if (t === void 0 && (t = e1.getDefaultPosition ? e1.getDefaultPosition() : `top-right`), !e1?.onAdd) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.`)));
        let n = e1.onAdd(this);
        this._controls.push(e1);
        let r = this._controlPositions[t];
        return t.includes(`bottom`) ? r.insertBefore(n, r.firstChild) : r.appendChild(n), this;
    }
    removeControl(e1) {
        if (!e1?.onRemove) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.`)));
        let t = this._controls.indexOf(e1);
        return t > -1 && this._controls.splice(t, 1), e1.onRemove(this), this;
    }
    hasControl(e1) {
        return this._controls.includes(e1);
    }
    coveringTiles(e1) {
        return $834619e78bbf578c$var$Fo(this._camera.transform, e1);
    }
    setTransformCameraUpdate(e1) {
        this._camera.transformCameraUpdate = e1;
    }
    getCenter() {
        return new (0, $1rqx5.lt)(this._camera.transform.center.lng, this._camera.transform.center.lat);
    }
    setCenter(e1, t) {
        return this._camera.setCenter(e1, t), this;
    }
    getCenterElevation() {
        return this._camera.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this._camera.setCenterElevation(e1, t), this;
    }
    setCenterClampedToGround(e1) {
        this._camera.setCenterClampedToGround(e1);
    }
    panBy(e1, t, n) {
        return this._camera.panBy(e1, t, n), this;
    }
    panTo(e1, t, n) {
        return this._camera.panTo(e1, t, n), this;
    }
    getZoom() {
        return this._camera.transform.zoom;
    }
    setZoom(e1, t) {
        return this._camera.setZoom(e1, t), this;
    }
    zoomTo(e1, t, n) {
        return this._camera.zoomTo(e1, t, n), this;
    }
    zoomIn(e1, t) {
        return this._camera.zoomIn(e1, t), this;
    }
    zoomOut(e1, t) {
        return this._camera.zoomOut(e1, t), this;
    }
    getVerticalFieldOfView() {
        return this._camera.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return this._camera.setVerticalFieldOfView(e1, t), this;
    }
    getBearing() {
        return this._camera.transform.bearing;
    }
    setBearing(e1, t) {
        return this._camera.setBearing(e1, t), this;
    }
    getZoomSnap() {
        return this._camera.getZoomSnap();
    }
    setZoomSnap(e1) {
        return this._camera.setZoomSnap(e1), this;
    }
    getPadding() {
        return this._camera.transform.padding;
    }
    setPadding(e1, t) {
        return this._camera.setPadding(e1, t), this;
    }
    rotateTo(e1, t, n) {
        return this._camera.rotateTo(e1, t, n), this;
    }
    resetNorth(e1, t) {
        return this._camera.resetNorth(e1, t), this;
    }
    resetNorthPitch(e1, t) {
        return this._camera.resetNorthPitch(e1, t), this;
    }
    snapToNorth(e1, t) {
        return this._camera.snapToNorth(e1, t), this;
    }
    getPitch() {
        return this._camera.transform.pitch;
    }
    setPitch(e1, t) {
        return this._camera.setPitch(e1, t), this;
    }
    getRoll() {
        return this._camera.transform.roll;
    }
    setRoll(e1, t) {
        return this._camera.setRoll(e1, t), this;
    }
    cameraForBounds(e1, t) {
        return this._camera.cameraForBounds(e1, t);
    }
    fitBounds(e1, t, n) {
        return this._camera.fitBounds(e1, t, n), this;
    }
    fitScreenCoordinates(e1, t, n, r, i) {
        return this._camera.fitScreenCoordinates(e1, t, n, r, i), this;
    }
    jumpTo(e1, t) {
        return this._camera.jumpTo(e1, t), this;
    }
    calculateAnchoredCameraOptions(e1) {
        return this._camera.calculateAnchoredCameraOptions(e1);
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i) {
        return this._camera.calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i);
    }
    easeTo(e1, t) {
        return this._camera.easeTo(e1, t), this;
    }
    flyTo(e1, t) {
        return this._camera.flyTo(e1, t), this;
    }
    stop() {
        return this._camera.stop(), this;
    }
    queryTerrainElevation(e1) {
        return this.terrain ? this.terrain.getElevationForLngLat((0, $1rqx5.lt).convert(e1), this._camera.transform) : null;
    }
    getCenterClampedToGround() {
        return this._camera.getCenterClampedToGround();
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        return r == null && this.terrain && (r = this.terrain.getElevationForLngLat(n, this._camera.transform)), this._camera.transform.calculateCameraOptionsFromTo(e1, t, n, r ?? 0);
    }
    resize(e1, t = !0) {
        if (this._lostContextStyle.style !== null) return this;
        this._resizeInternal(t);
        let n = !this._camera._moving;
        return n && (this.stop(), this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`, e1)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`, e1))), this.fire(new $834619e78bbf578c$export$fc21b96c04d10d16(`resize`, e1)), n && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`, e1)), this;
    }
    _resizeInternal(e1 = !0) {
        let [t, n] = this._containerDimensions(), r = this._getClampedPixelRatio(t, n);
        if (this._resizeCanvas(t, n, r), this.painter.resize(t, n, r), this.painter.overLimit()) {
            let e1 = this.painter.context.gl;
            this._maxCanvasSize = [
                e1.drawingBufferWidth,
                e1.drawingBufferHeight
            ];
            let r = this._getClampedPixelRatio(t, n);
            this._resizeCanvas(t, n, r), this.painter.resize(t, n, r);
        }
        this._resizeTransform(e1);
    }
    _resizeTransform(e1 = !0) {
        let [t, n] = this._containerDimensions();
        this._camera.transform.resize(t, n, e1), this._camera._requestedCameraState?.resize(t, n, e1);
    }
    _getClampedPixelRatio(e1, t) {
        let { 0: n, 1: r } = this._maxCanvasSize, i = this.getPixelRatio(), a = e1 * i, o = t * i, s = a > n ? n / a : 1, c = o > r ? r / o : 1, l = Math.min(s, c);
        return l < 1 && (0, $1rqx5.Nr)(`The canvas is larger than maxCanvasSize and is rendered at a lower pixel ratio to fit. Increase maxCanvasSize, within MAX_TEXTURE_SIZE, to render at full resolution.`), l * i;
    }
    getPixelRatio() {
        return this._overridePixelRatio ?? devicePixelRatio;
    }
    setPixelRatio(e1) {
        this._overridePixelRatio = e1, this.resize();
    }
    getBounds() {
        return this._camera.transform.getBounds();
    }
    getMaxBounds() {
        return this._camera.transform.getMaxBounds();
    }
    setMaxBounds(e1) {
        return this._camera.applyTransformChange((t)=>t.setMaxBounds($834619e78bbf578c$export$266d2884f61535d3.convert(e1))), this._update();
    }
    setMinZoom(e1) {
        if (e1 ??= -2, e1 >= -2 && e1 <= this._camera.transform.maxZoom) {
            let t = this._camera.transform.zoom;
            return this._camera.applyTransformChange((t)=>t.setMinZoom(e1)), this._update(), t !== this._camera.transform.zoom && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomstart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoom`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomend`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`minZoom must be between -2 and the current maxZoom, inclusive`);
    }
    getMinZoom(e1 = !1) {
        let t = this._camera.transform;
        return e1 ? t.applyConstrain(t.center, t.minZoom).zoom : t.minZoom;
    }
    setMaxZoom(e1) {
        if (e1 ??= 22, e1 >= this._camera.transform.minZoom) {
            let t = this._camera.transform.zoom;
            return this._camera.applyTransformChange((t)=>t.setMaxZoom(e1)), this._update(), t !== this._camera.transform.zoom && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomstart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoom`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`zoomend`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`maxZoom must be greater than the current minZoom`);
    }
    getMaxZoom() {
        return this._camera.transform.maxZoom;
    }
    setMinPitch(e1) {
        if (e1 ??= 0, e1 < 0) throw Error(`minPitch must be greater than or equal to 0`);
        if (e1 >= 0 && e1 <= this._camera.transform.maxPitch) {
            let t = this._camera.transform.pitch;
            return this._camera.applyTransformChange((t)=>t.setMinPitch(e1)), this._update(), t !== this._camera.transform.pitch && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchstart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitch`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchend`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`minPitch must be between 0 and the current maxPitch, inclusive`);
    }
    getMinPitch() {
        return this._camera.transform.minPitch;
    }
    setMaxPitch(e1) {
        if (e1 ??= 60, e1 > 180) throw Error(`maxPitch must be less than or equal to 180`);
        if (e1 >= this._camera.transform.minPitch) {
            let t = this._camera.transform.pitch;
            return this._camera.applyTransformChange((t)=>t.setMaxPitch(e1)), this._update(), t !== this._camera.transform.pitch && this.fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchstart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitch`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`pitchend`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`movestart`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`move`)).fire(new $834619e78bbf578c$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`maxPitch must be greater than the current minPitch`);
    }
    getMaxPitch() {
        return this._camera.transform.maxPitch;
    }
    getAnisotropicFilterPitch() {
        return this._anisotropicFilterPitch;
    }
    setAnisotropicFilterPitch(e1) {
        if (e1 ??= 20, e1 > 180) throw Error(`anisotropicFilterPitch must be less than or equal to 180`);
        if (e1 < 0) throw Error(`anisotropicFilterPitch must be greater than or equal to 0`);
        return this._anisotropicFilterPitch = e1, this._update();
    }
    getRenderWorldCopies() {
        return this._camera.transform.renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        return this._camera.applyTransformChange((t)=>t.setRenderWorldCopies(e1)), this._update();
    }
    setTransformConstrain(e1) {
        return this._camera.applyTransformChange((t)=>t.setConstrainOverride(e1)), this._update();
    }
    project(e1) {
        return this._camera.transform.locationToScreenPoint((0, $1rqx5.lt).convert(e1), this.style && this.terrain);
    }
    unproject(e1) {
        return this._camera.transform.screenPointToLocation((0, $1rqx5.Li).convert(e1), this.terrain);
    }
    isMoving() {
        return this._camera.isMoving() || this._handlers?.isMoving() || !1;
    }
    isZooming() {
        return this._camera.isZooming() || this._handlers?.isZooming() || !1;
    }
    isRotating() {
        return this._camera.isRotating() || this._handlers?.isRotating() || !1;
    }
    _createDelegates(e1, t, n) {
        if (e1 === `mouseenter` || e1 === `mouseover`) {
            let r = !1;
            return {
                mousemove: (i)=>{
                    let a = t.filter((e1)=>this.getLayer(e1)), o = a.length === 0 ? [] : this.queryRenderedFeatures(i.point, {
                        layers: a
                    });
                    o.length ? r || (r = !0, n.call(this, new $834619e78bbf578c$export$83f023c8e5acf676(e1, this, i.originalEvent, {
                        features: o
                    }))) : r = !1;
                },
                mouseout: ()=>{
                    r = !1;
                }
            };
        }
        if (e1 === `mouseleave` || e1 === `mouseout`) {
            let r = !1;
            return {
                mousemove: (i)=>{
                    let a = t.filter((e1)=>this.getLayer(e1));
                    (a.length === 0 ? [] : this.queryRenderedFeatures(i.point, {
                        layers: a
                    })).length ? r = !0 : r && (r = !1, n.call(this, new $834619e78bbf578c$export$83f023c8e5acf676(e1, this, i.originalEvent)));
                },
                mouseout: (t)=>{
                    r && (r = !1, n.call(this, new $834619e78bbf578c$export$83f023c8e5acf676(e1, this, t.originalEvent)));
                }
            };
        }
        {
            let r = (e1)=>{
                let r = t.filter((e1)=>this.getLayer(e1)), i = r.length === 0 ? [] : this.queryRenderedFeatures(e1.point, {
                    layers: r
                });
                i.length && (e1.features = i, n.call(this, e1), delete e1.features);
            };
            return {
                [e1]: r
            };
        }
    }
    _addDelegatedListener(e1, t) {
        this._delegatedListeners ||= {}, this._delegatedListeners[e1] ||= [], this._delegatedListeners[e1].push(t);
        for(let e1 in t.delegates)this.on(e1, t.delegates[e1]);
    }
    _removeDelegatedListener(e1, t, n) {
        if (!this._delegatedListeners?.[e1]) return;
        let r = this._delegatedListeners[e1];
        for(let e1 = 0; e1 < r.length; e1++){
            let i = r[e1];
            if (i.listener === n && i.layers.length === t.length && i.layers.every((e1)=>t.includes(e1))) {
                for(let e1 in i.delegates)this.off(e1, i.delegates[e1]);
                r.splice(e1, 1);
                return;
            }
        }
    }
    on(e1, t, n) {
        if (n === void 0) return super.on(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t, i = {
            layers: r,
            listener: n,
            delegates: this._createDelegates(e1, r, n)
        };
        return this._addDelegatedListener(e1, i), {
            unsubscribe: ()=>{
                this._removeDelegatedListener(e1, r, n);
            }
        };
    }
    once(e1, t, n) {
        if (n === void 0) return super.once(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t, i = {
            layers: r,
            listener: n,
            delegates: this._createDelegates(e1, r, (t)=>{
                this._removeDelegatedListener(e1, r, n), n.call(this, t);
            })
        };
        return this._addDelegatedListener(e1, i), this;
    }
    off(e1, t, n) {
        if (n === void 0) return super.off(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t;
        return this._removeDelegatedListener(e1, r, n), this;
    }
    queryRenderedFeatures(e1, t) {
        if (!this.style) return [];
        let n, r = e1 instanceof (0, $1rqx5.Li) || Array.isArray(e1), i = r ? e1 : [
            [
                0,
                0
            ],
            [
                this._camera.transform.width,
                this._camera.transform.height
            ]
        ];
        if (t ||= (r ? {} : e1) || {}, i instanceof (0, $1rqx5.Li) || typeof i[0] == `number`) n = [
            (0, $1rqx5.Li).convert(i)
        ];
        else {
            let e1 = (0, $1rqx5.Li).convert(i[0]), t = (0, $1rqx5.Li).convert(i[1]);
            n = [
                e1,
                new (0, $1rqx5.Li)(t.x, e1.y),
                t,
                new (0, $1rqx5.Li)(e1.x, t.y),
                e1
            ];
        }
        return this.style.queryRenderedFeatures(n, t, this._camera.transform);
    }
    querySourceFeatures(e1, t) {
        return this.style.querySourceFeatures(e1, t);
    }
    setStyle(e1, t) {
        return t = (0, $1rqx5.er)({}, {
            localIdeographFontFamily: this._localIdeographFontFamily,
            validate: this._validateStyle
        }, t), this._styleUrl = typeof e1 == `string` ? e1 : null, t.diff !== !1 && t.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, t), this) : (this._localIdeographFontFamily = t.localIdeographFontFamily, this._updateStyle(e1, t));
    }
    setTransformRequest(e1) {
        return this._requestManager.setTransformRequest(e1), this;
    }
    _getUIString(e1) {
        let t = this._locale[e1];
        if (t == null) throw Error(`Missing UI string '${e1}'`);
        return t;
    }
    _updateStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), this._diffStyleRequest = null, t.transformStyle && this.style && !this.style._loaded) {
            this.style.once(`style.load`, ()=>this._updateStyle(e1, t));
            return;
        }
        let n = this.style && t.transformStyle ? this.style.serialize() : void 0;
        if (this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1) this.style = new $834619e78bbf578c$export$d9e45bc13d335801(this, t || {});
        else return this._frameRequest &&= (this._frameRequest.abort(), null), this.style?.projection?.destroy(), delete this.style, this;
        return this.style.setEventedParent(this, {
            style: this.style
        }), typeof e1 == `string` ? this.style.loadURL(e1, t, n) : this.style.loadJSON(e1, t, n), this;
    }
    _lazyInitEmptyStyle() {
        this.style || (this.style = new $834619e78bbf578c$export$d9e45bc13d335801(this, {}), this.style.setEventedParent(this, {
            style: this.style
        }), this.style.loadEmpty());
    }
    async _diffStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), typeof e1 == `string`) {
            let n = e1;
            this._diffStyleRequest = new AbortController;
            let r = this._diffStyleRequest;
            try {
                let e1 = await this._requestManager.transformRequest(n, `Style`);
                if (r.signal.aborted) {
                    this._diffStyleRequest = null;
                    return;
                }
                let i = await (0, $1rqx5.Sn)(e1, r);
                this._diffStyleRequest = null, this._updateDiff(i.data, t);
            } catch (e1) {
                this._diffStyleRequest = null, (0, $1rqx5.Mn)(e1) || this.fire(new (0, $1rqx5.gn)((0, $1rqx5.Qn)(e1)));
            }
        } else typeof e1 == `object` && (this._diffStyleRequest = null, this._updateDiff(e1, t));
    }
    _updateDiff(e1, t) {
        try {
            this.style.setState(e1, t) && this._update(!0);
        } catch (n) {
            (0, $1rqx5.Nr)(`Unable to perform style diff: ${(0, $1rqx5.Qn)(n).message}.  Rebuilding the style from scratch.`), this._updateStyle(e1, t);
        }
    }
    getStyle() {
        if (this.style) return this.style.serialize();
    }
    getStyleUrl() {
        return this._styleUrl;
    }
    _getStyleAndImages() {
        return this.style ? {
            style: this.style.serialize(),
            images: this.style.imageManager.cloneImages()
        } : {
            style: null,
            images: {}
        };
    }
    isStyleLoaded() {
        if (!this.style) {
            (0, $1rqx5.Nr)(`There is no style added to the map.`);
            return;
        }
        return this.style.loaded();
    }
    addSource(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
    }
    isSourceLoaded(e1) {
        let t = this.style?.tileManagers[e1];
        if (t === void 0) {
            this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`There is no tile manager with ID '${e1}'`)));
            return;
        }
        return t.loaded();
    }
    setTerrain(e1, t = {}) {
        if (this.style._checkLoaded(), e1 && (0, $1rqx5.an)(this, (0, $1rqx5.on).terrain, {
            value: e1
        }, t)) return this;
        if (this._terrainDataCallback && this.style.off(`data`, this._terrainDataCallback), !e1) this.terrain && this.terrain.destroy(), this.terrain = null, this.painter.renderToTexture = null, this.painter.destroyRTTResources(), this._camera.setTerrain(null);
        else {
            let t = this.style.tileManagers[e1.source];
            if (!t) throw Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
            this.terrain === null && t.reload();
            for(let t in this.style._layers){
                let n = this.style._layers[t];
                n.type === `hillshade` && n.source === e1.source && (0, $1rqx5.Nr)(`You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.`), n.type === `color-relief` && n.source === e1.source && (0, $1rqx5.Nr)(`You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.`);
            }
            this.terrain && this.terrain.destroy(), this.terrain = new $834619e78bbf578c$var$Cc(this.painter, t, e1, this._terrainSkirtLength), this.painter.renderToTexture = new $834619e78bbf578c$var$Lm(this.painter, this.terrain), this._camera.setTerrain(this.terrain), this._terrainDataCallback = (t)=>this._handleTerrainDataEvent(t, e1.source), this.style.on(`data`, this._terrainDataCallback);
        }
        return this.style.triggerSymbolPlacement(), this.fire(new $834619e78bbf578c$export$da1f2ab236a92d66({
            terrain: e1
        })), this;
    }
    _handleTerrainDataEvent(e1, t) {
        if (e1.dataType === `style`) {
            this.terrain.tileManager.releaseAllRTT();
            return;
        }
        let n = e1.sourceId === t;
        if (n && (this.terrain.resetElevationCache(), this.style.triggerSymbolPlacement()), n && e1.tile && (this.painter.markTerrainDepthDirty(), this._camera.applyTerrainChange()), e1.tile) {
            if (e1.source?.type === `image`) {
                this.terrain.tileManager.releaseAllRTT();
                return;
            }
            this.terrain.tileManager.releaseRTT(e1.tile.tileID);
        }
    }
    getTerrain() {
        return this.terrain?.options ?? null;
    }
    areTilesLoaded() {
        let e1 = this.style?.tileManagers;
        for (let t of Object.values(e1))if (!t.areTilesLoaded()) return !1;
        return !0;
    }
    removeSource(e1) {
        return this.style.removeSource(e1), this._update(!0);
    }
    getSource(e1) {
        return this.style?.getSource(e1);
    }
    setSourceTileLodParams(e1, t, n) {
        if (n) {
            let r = this.getSource(n);
            if (!r) throw Error(`There is no source with ID "${n}", cannot set LOD parameters`);
            r.calculateTileZoom = $834619e78bbf578c$var$ko(Math.max(1, e1), Math.max(1, t));
        } else for(let n in this.style.tileManagers)this.style.tileManagers[n].getSource().calculateTileZoom = $834619e78bbf578c$var$ko(Math.max(1, e1), Math.max(1, t));
        return this._update(!0), this;
    }
    refreshTiles(e1, t) {
        let n = this.style.tileManagers[e1];
        if (!n) throw Error(`There is no tile manager with ID "${e1}", cannot refresh tile`);
        t === void 0 ? n.reload(!0) : n.refreshTiles(t.map((e1)=>new (0, $1rqx5.u)(e1.z, e1.x, e1.y)));
    }
    addImage(e1, t, n = {}) {
        this._lazyInitEmptyStyle();
        let r = this._createStyleImage(t, n);
        return r ? (this.style.addImage(e1, r), r.userImage?.onAdd && r.userImage.onAdd(this, e1), this) : this;
    }
    setMissingStyleImageResolver(e1) {
        return this._missingStyleImageResolver = e1, this.style?.setMissingImageResolver(e1), this;
    }
    _createStyleImage(e1, t = {}) {
        let { pixelRatio: n = 1, sdf: r = !1, stretchX: i, stretchY: a, content: o, textFitWidth: s, textFitHeight: c } = t;
        if (e1 instanceof HTMLImageElement || (0, $1rqx5.cr)(e1)) {
            let { width: t, height: l, data: u } = $834619e78bbf578c$var$Rr.getImageData(e1);
            return {
                data: new (0, $1rqx5.Dt)({
                    width: t,
                    height: l
                }, u),
                pixelRatio: n,
                stretchX: i,
                stretchY: a,
                content: o,
                textFitWidth: s,
                textFitHeight: c,
                sdf: r,
                version: 0
            };
        }
        if (e1.width === void 0 || e1.height === void 0) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))), null;
        {
            let { width: t, height: l, data: u } = e1, d = e1, f = (0, $1rqx5.I)(d.data);
            return {
                data: f ? new (0, $1rqx5.Dt)({
                    width: t,
                    height: l
                }) : new (0, $1rqx5.Dt)({
                    width: t,
                    height: l
                }, new Uint8Array(u)),
                pixelRatio: n,
                stretchX: i,
                stretchY: a,
                content: o,
                textFitWidth: s,
                textFitHeight: c,
                sdf: r,
                version: 0,
                isWebGLImage: f,
                userImage: d
            };
        }
    }
    updateImage(e1, t) {
        let n = this.style.getImage(e1);
        if (!n) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
        let { width: r, height: i, data: a } = t instanceof HTMLImageElement || (0, $1rqx5.cr)(t) ? $834619e78bbf578c$var$Rr.getImageData(t) : t;
        if (r === void 0 || i === void 0) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
        if (r !== n.data.width || i !== n.data.height) return this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`The width and height of the updated image must be that same as the previous version of the image`)));
        if (n.isWebGLImage = (0, $1rqx5.I)(a), n.isWebGLImage) n.userImage = t;
        else {
            let e1 = !(t instanceof HTMLImageElement || (0, $1rqx5.cr)(t));
            n.data.replace(a, e1);
        }
        return this.style.updateImage(e1, n), this;
    }
    getImage(e1) {
        return this.style.getImage(e1);
    }
    hasImage(e1) {
        return e1 ? !!this.style.getImage(e1) : (this.fire(new (0, $1rqx5.gn)(/* @__PURE__ */ Error(`Missing required image id`))), !1);
    }
    removeImage(e1) {
        this.style.removeImage(e1);
    }
    async loadImage(e1) {
        let t = await $834619e78bbf578c$var$Yr.getImage(await this._requestManager.transformRequest(e1, `Image`), new AbortController);
        if (!t.data) throw Error(`Could not load image ${e1}: the response is empty`);
        return t;
    }
    listImages() {
        return this.style?.listImages() ?? [];
    }
    addLayer(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
    }
    moveLayer(e1, t) {
        return this.style.moveLayer(e1, t), this._update(!0);
    }
    removeLayer(e1) {
        return this.style.removeLayer(e1), this._update(!0);
    }
    getLayer(e1) {
        return this.style?.getLayer(e1);
    }
    getLayersOrder() {
        return this.style?.getLayersOrder() ?? [];
    }
    setLayerZoomRange(e1, t, n) {
        return this.style.setLayerZoomRange(e1, t, n), this._update(!0);
    }
    setFilter(e1, t, n = {}) {
        return this.style?.setFilter(e1, t, n), this._update(!0);
    }
    getFilter(e1) {
        return this.style.getFilter(e1);
    }
    setPaintProperty(e1, t, n, r = {}) {
        return this.style?.setPaintProperty(e1, t, n, r), this._update(!0);
    }
    getPaintProperty(e1, t) {
        return this.style.getPaintProperty(e1, t);
    }
    setLayoutProperty(e1, t, n, r = {}) {
        return this.style.setLayoutProperty(e1, t, n, r), this._update(!0);
    }
    getLayoutProperty(e1, t) {
        return this.style.getLayoutProperty(e1, t);
    }
    setGlyphs(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, t), this._update(!0);
    }
    getGlyphs() {
        return this.style.getGlyphsUrl();
    }
    setFontFaces(e1) {
        return this._lazyInitEmptyStyle(), this.style.setFontFaces(e1), this._update(!0);
    }
    getFontFaces() {
        return this.style.getFontFaces();
    }
    addSprite(e1, t, n = {}) {
        return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, n, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    removeSprite(e1) {
        return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
    }
    getSprite() {
        return this.style.getSprite();
    }
    setSprite(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSprite(e1, t, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    setLight(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setLight(e1, t), this._update(!0);
    }
    getLight() {
        return this.style.getLight();
    }
    setSky(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSky(e1, t), this._update(!0);
    }
    getSky() {
        return this.style.getSky();
    }
    setFeatureState(e1, t) {
        return this.style.setFeatureState(e1, t), this._update();
    }
    removeFeatureState(e1, t) {
        return this.style.removeFeatureState(e1, t), this._update();
    }
    getFeatureState(e1) {
        return this.style.getFeatureState(e1);
    }
    getContainer() {
        return this._container;
    }
    getCanvasContainer() {
        return this._canvasContainer;
    }
    getCanvas() {
        return this._canvas;
    }
    _containerDimensions() {
        let e1 = 0, t = 0;
        return this._container && (e1 = Math.floor(this._container.clientWidth) || 400, t = Math.floor(this._container.clientHeight) || 300), [
            e1,
            t
        ];
    }
    _shouldHandleInitialResize() {
        if (!this._container?.clientWidth || !this._container.clientHeight) return !1;
        let [e1, t] = this._containerDimensions();
        return e1 !== this._camera.transform.width || t !== this._camera.transform.height;
    }
    _setupResizeObserver() {
        let e1 = !1, t = $834619e78bbf578c$var$Ep((e1)=>{
            this._trackResize && !this._removed && (this.resize(e1), this.redraw());
        }, 50), n = this._ownerWindow.ResizeObserver ?? ResizeObserver;
        this._resizeObserver = new n((n)=>{
            !e1 && (e1 = !0, !this._shouldHandleInitialResize()) || t(n);
        }), this._resizeObserver.observe(this._container);
    }
    _resolveContainer(e1) {
        if (typeof e1 == `string`) {
            let t = document.getElementById(e1);
            if (!t) throw Error(`Container '${e1}' not found.`);
            return t;
        }
        if (e1 instanceof HTMLElement || e1 && typeof e1 == `object` && e1.nodeType === 1) return e1;
        throw Error(`Invalid type: 'container' must be a String or HTMLElement.`);
    }
    _setupContainer() {
        let e1 = this._containerDimensions(), t = this._getClampedPixelRatio(e1[0], e1[1]), n = this._container;
        n.classList.add(`maplibregl-map`);
        let r = this._canvasContainer = $834619e78bbf578c$var$G.create(`div`, `maplibregl-canvas-container`, n);
        this._interactive && r.classList.add(`maplibregl-interactive`), this._canvas = $834619e78bbf578c$var$G.create(`canvas`, `maplibregl-canvas`, r), this._canvas.addEventListener(`webglcontextlost`, this._contextLost, !1), this._canvas.addEventListener(`webglcontextrestored`, this._contextRestored, !1), this._canvas.setAttribute(`tabindex`, this._interactive ? `0` : `-1`), this._canvas.setAttribute(`aria-label`, this._getUIString(`Map.Title`)), this._canvas.setAttribute(`role`, `region`), this._resizeCanvas(e1[0], e1[1], t);
        let i = this._controlContainer = $834619e78bbf578c$var$G.create(`div`, `maplibregl-control-container`, n), a = this._controlPositions = {};
        for (let e1 of [
            `top-left`,
            `top-right`,
            `bottom-left`,
            `bottom-right`
        ])a[e1] = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl-${e1} `, i);
        this._container.addEventListener(`scroll`, this._onMapScroll, !1);
    }
    _cleanupContainer() {
        this._canvas.removeEventListener(`webglcontextrestored`, this._contextRestored, !1), this._canvas.removeEventListener(`webglcontextlost`, this._contextLost, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._container.removeEventListener(`scroll`, this._onMapScroll, !1), this._container.classList.remove(`maplibregl-map`);
    }
    _resizeCanvas(e1, t, n) {
        let r = Math.round(n * e1), i = Math.round(n * t);
        this._canvas.width = r, this._canvas.height = i, this._canvas.style.width = `${r / n}px`, this._canvas.style.height = `${i / n}px`;
    }
    _setupPainter() {
        let e1 = {
            ...this._canvasContextAttributes,
            alpha: !0,
            depth: !0,
            stencil: !0,
            premultipliedAlpha: !0
        }, t = null;
        this._canvas.addEventListener(`webglcontextcreationerror`, (e1)=>{
            t = e1;
        }, {
            once: !0
        });
        let n = this._canvas.getContext(`webgl2`, e1);
        if (!n) throw new $834619e78bbf578c$export$68b5dc085315a832(e1, t);
        this.painter = new $834619e78bbf578c$var$wp(n, this._camera.transform);
    }
    migrateProjection(e1, t) {
        this._camera.migrateProjection(e1, t), this.painter.transform = e1, this.fire(new $834619e78bbf578c$export$f966cee55553279({
            newProjection: this.style.projection.name
        }));
    }
    loaded() {
        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
    }
    _update(e1) {
        return this.style?._loaded ? (this._styleDirty ||= e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
    }
    _requestRenderFrame(e1) {
        return this._update(), this._renderTaskQueue.add(e1);
    }
    _cancelRenderFrame(e1) {
        this._renderTaskQueue.remove(e1);
    }
    _render(e1) {
        let t = this._idleTriggered ? this._fadeDuration : 0, n = this.style.projection?.transitionState > 0;
        if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
        let r = !1;
        if (this.style && this._styleDirty) {
            this._styleDirty = !1;
            let e1 = this._camera.transform.zoom, n = $834619e78bbf578c$export$461939dd4422153();
            this.style.zoomHistory.update(e1, n);
            let i = new (0, $1rqx5.en)(e1, {
                now: n,
                fadeDuration: t,
                zoomHistory: this.style.zoomHistory,
                transition: this.style.getTransition()
            }), a = i.crossFadingFactor();
            (a !== 1 || a !== this._crossFadingFactor) && (r = !0, this._crossFadingFactor = a), this.style.update(i);
        }
        let i = this.style.projection?.transitionState > 0 !== n;
        this._camera.transform.setTransitionState(this.style.projection?.transitionState), this.style && (this._sourcesDirty || i) && (this._sourcesDirty = !1, this.style._updateSources(this._camera.transform)), this.terrain ? (this.terrain.tileManager.update(this._camera.transform, this.terrain) && this.terrain.resetElevationCache(), this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), !this._camera.elevationFreeze && this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform))) : (this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0)), this._placementDirty = this.style?._updatePlacement(this._camera.transform, this.showCollisionBoxes, t, this._crossSourceCollisions, i), this.painter.render(this.style, {
            showTileBoundaries: this.showTileBoundaries,
            showOverdrawInspector: this._showOverdrawInspector,
            rotating: this.isRotating(),
            zooming: this.isZooming(),
            moving: this.isMoving(),
            fadeDuration: t,
            showPadding: this.showPadding,
            anisotropicFilterPitch: this.getAnisotropicFilterPitch()
        }), this.fire(new $834619e78bbf578c$export$fc21b96c04d10d16(`render`)), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new $834619e78bbf578c$export$fc21b96c04d10d16(`load`))), this.style && (this.style.hasTransitions() || r) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
        let a = this._sourcesDirty || this._styleDirty || this._placementDirty || this.painter.renderToTexture?.needsFollowUpFrame;
        return a || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new $834619e78bbf578c$export$fc21b96c04d10d16(`idle`)), this._loaded && !this._fullyLoaded && !a && (this._fullyLoaded = !0), this;
    }
    redraw() {
        return this.style && (this._frameRequest &&= (this._frameRequest.abort(), null), this._render(0)), this;
    }
    remove() {
        this._hash && this._hash.remove();
        for (let e1 of this._controls)e1.onRemove(this);
        this._controls = [], this._frameRequest &&= (this._frameRequest.abort(), null), this._renderTaskQueue.clear(), this._diffStyleRequest?.abort(), this.painter.destroy(), this._handlers.destroy(), this.setStyle(null), typeof window < `u` && this._ownerWindow.removeEventListener(`online`, this._onWindowOnline, !1), $834619e78bbf578c$var$Yr.removeThrottleControl(this._imageQueueHandle), this._resizeObserver?.disconnect();
        let e1 = this.painter.context.gl.getExtension(`WEBGL_lose_context`);
        e1?.loseContext && e1.loseContext(), this._cleanupContainer(), this._removed = !0, this.fire(new $834619e78bbf578c$export$fc21b96c04d10d16(`remove`));
    }
    triggerRepaint() {
        this.style && !this._frameRequest && (this._frameRequest = new AbortController, $834619e78bbf578c$var$Rr.frame(this._frameRequest, (e1)=>{
            this._frameRequest = null;
            try {
                this._render(e1);
            } catch (e1) {
                if (!(0, $1rqx5.Mn)(e1)) throw e1;
            }
        }, ()=>{}, this._ownerWindow));
    }
    get showTileBoundaries() {
        return !!this._showTileBoundaries;
    }
    set showTileBoundaries(e1) {
        this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
    }
    get showPadding() {
        return !!this._showPadding;
    }
    set showPadding(e1) {
        this._showPadding !== e1 && (this._showPadding = e1, this._update());
    }
    get showCollisionBoxes() {
        return !!this._showCollisionBoxes;
    }
    set showCollisionBoxes(e1) {
        this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
    }
    get showOverdrawInspector() {
        return !!this._showOverdrawInspector;
    }
    set showOverdrawInspector(e1) {
        this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
    }
    get repaint() {
        return !!this._repaint;
    }
    set repaint(e1) {
        this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
    }
    get vertices() {
        return !!this._vertices;
    }
    set vertices(e1) {
        this._vertices = e1, this._update();
    }
    get version() {
        return $834619e78bbf578c$var$zm;
    }
    getCameraTargetElevation() {
        return this._camera.transform.elevation;
    }
    getProjection() {
        return this.style.getProjection();
    }
    setProjection(e1) {
        return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
    }
};
const $834619e78bbf578c$var$Hm = {
    showCompass: !0,
    showZoom: !0,
    visualizePitch: !1,
    visualizeRoll: !0
};
var $834619e78bbf578c$export$49a437922edc1bd9 = class {
    constructor(e1){
        this._updateZoomButtons = ()=>{
            let e1 = this._map.getZoom(), t = e1 === this._map.getMaxZoom(), n = e1 === this._map.getMinZoom(!0);
            this._zoomInButton.disabled = t, this._zoomOutButton.disabled = n, this._zoomInButton.setAttribute(`aria-disabled`, t.toString()), this._zoomOutButton.setAttribute(`aria-disabled`, n.toString());
        }, this._rotateCompassArrow = ()=>{
            let e1 = this._map.getPitch(), t = this._map.getRoll(), n = this._map.getBearing(), r = 1 / Math.cos((0, $1rqx5.Yn)(e1)) ** .5;
            if (this.options.visualizePitch && this.options.visualizeRoll) {
                this._compassIcon.style.transform = `scale(${r}) rotateZ(${-t}deg) rotateX(${e1}deg) rotateZ(${-n}deg)`;
                return;
            }
            if (this.options.visualizePitch) {
                this._compassIcon.style.transform = `scale(${r}) rotateX(${e1}deg) rotateZ(${-n}deg)`;
                return;
            }
            if (this.options.visualizeRoll) {
                this._compassIcon.style.transform = `rotate(${-n - t}deg)`;
                return;
            }
            this._compassIcon.style.transform = `rotate(${-n}deg)`;
        }, this._setButtonTitle = (e1, t)=>{
            let n = this._map._getUIString(`NavigationControl.${t}`);
            e1.title = n, e1.setAttribute(`aria-label`, n);
        }, this.options = (0, $1rqx5.er)({}, $834619e78bbf578c$var$Hm, e1), this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._container.addEventListener(`contextmenu`, (e1)=>e1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton(`maplibregl-ctrl-zoom-in`, (e1)=>this._map.zoomIn({}, {
                originalEvent: e1
            })), $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, this._zoomInButton).setAttribute(`aria-hidden`, `true`), this._zoomOutButton = this._createButton(`maplibregl-ctrl-zoom-out`, (e1)=>this._map.zoomOut({}, {
                originalEvent: e1
            })), $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, this._zoomOutButton).setAttribute(`aria-hidden`, `true`)), this.options.showCompass && (this._compass = this._createButton(`maplibregl-ctrl-compass`, (e1)=>{
            this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                originalEvent: e1
            }) : this._map.resetNorth({}, {
                originalEvent: e1
            });
        }), this._compassIcon = $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, this._compass), this._compassIcon.setAttribute(`aria-hidden`, `true`));
    }
    onAdd(e1) {
        return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, `ZoomIn`), this._setButtonTitle(this._zoomOutButton, `ZoomOut`), this._map.on(`move`, this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, `ResetBearing`), this.options.visualizePitch && this._map.on(`pitch`, this._rotateCompassArrow), this.options.visualizeRoll && this._map.on(`roll`, this._rotateCompassArrow), this._map.on(`rotate`, this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new $834619e78bbf578c$var$Wm(this._map, this._compass, this.options.visualizePitch)), this._container;
    }
    onRemove() {
        this._container.remove(), this.options.showZoom && this._map.off(`move`, this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off(`pitch`, this._rotateCompassArrow), this.options.visualizeRoll && this._map.off(`roll`, this._rotateCompassArrow), this._map.off(`rotate`, this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
    }
    _createButton(e1, t) {
        let n = $834619e78bbf578c$var$G.create(`button`, e1, this._container);
        return n.type = `button`, n.addEventListener(`click`, t), n;
    }
}, $834619e78bbf578c$var$Wm = class {
    constructor(e1, t, n = !1){
        this.mousedown = (e1)=>{
            this.startMove(e1, $834619e78bbf578c$var$G.mousePos(this.element, e1)), window.addEventListener(`mousemove`, this.mousemove), window.addEventListener(`mouseup`, this.mouseup);
        }, this.mousemove = (e1)=>{
            this.move(e1, $834619e78bbf578c$var$G.mousePos(this.element, e1));
        }, this.mouseup = (e1)=>{
            this._rotatePitchHandler.dragEnd(e1), this.offTemp();
        }, this.touchstart = (e1)=>{
            e1.targetTouches.length === 1 ? (this._startPos = this._lastPos = $834619e78bbf578c$var$G.touchPos(this.element, e1.targetTouches)[0], this.startMove(e1, this._startPos), window.addEventListener(`touchmove`, this.touchmove, {
                passive: !1
            }), window.addEventListener(`touchend`, this.touchend)) : this.reset();
        }, this.touchmove = (e1)=>{
            e1.targetTouches.length === 1 ? (this._lastPos = $834619e78bbf578c$var$G.touchPos(this.element, e1.targetTouches)[0], this.move(e1, this._lastPos)) : this.reset();
        }, this.touchend = (e1)=>{
            e1.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this.reset = ()=>{
            this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this._clickTolerance = 10, this.element = t;
        let r = new $834619e78bbf578c$var$Xp;
        this._rotatePitchHandler = new $834619e78bbf578c$var$Gp({
            clickTolerance: 3,
            move: (e1, r)=>{
                let i = t.getBoundingClientRect(), a = new (0, $1rqx5.Li)((i.bottom - i.top) / 2, (i.right - i.left) / 2);
                return {
                    bearingDelta: (0, $1rqx5.ir)(new (0, $1rqx5.Li)(e1.x, r.y), r, a),
                    pitchDelta: n ? (r.y - e1.y) * -0.5 : void 0
                };
            },
            moveStateManager: r,
            enable: !0,
            assignEvents: ()=>{}
        }), this.map = e1, t.addEventListener(`mousedown`, this.mousedown), t.addEventListener(`touchstart`, this.touchstart, {
            passive: !1
        }), t.addEventListener(`touchcancel`, this.reset);
    }
    startMove(e1, t) {
        this._rotatePitchHandler.dragStart(e1, t), $834619e78bbf578c$var$G.disableDrag();
    }
    move(e1, t) {
        let n = this.map, { bearingDelta: r, pitchDelta: i } = this._rotatePitchHandler.dragMove(e1, t) || {};
        r && n.setBearing(n.getBearing() + r), i && n.setPitch(n.getPitch() + i);
    }
    off() {
        let e1 = this.element;
        e1.removeEventListener(`mousedown`, this.mousedown), e1.removeEventListener(`touchstart`, this.touchstart), window.removeEventListener(`touchmove`, this.touchmove), window.removeEventListener(`touchend`, this.touchend), e1.removeEventListener(`touchcancel`, this.reset), this.offTemp();
    }
    offTemp() {
        $834619e78bbf578c$var$G.enableDrag(), window.removeEventListener(`mousemove`, this.mousemove), window.removeEventListener(`mouseup`, this.mouseup), window.removeEventListener(`touchmove`, this.touchmove), window.removeEventListener(`touchend`, this.touchend);
    }
};
let $834619e78bbf578c$var$Gm;
async function $834619e78bbf578c$var$Km(e1 = !1) {
    if ($834619e78bbf578c$var$Gm !== void 0 && !e1) return $834619e78bbf578c$var$Gm;
    if (window.navigator.permissions === void 0) return $834619e78bbf578c$var$Gm = !!window.navigator.geolocation, $834619e78bbf578c$var$Gm;
    try {
        $834619e78bbf578c$var$Gm = (await window.navigator.permissions.query({
            name: `geolocation`
        })).state !== `denied`;
    } catch  {
        $834619e78bbf578c$var$Gm = !!window.navigator.geolocation;
    }
    return $834619e78bbf578c$var$Gm;
}
function $834619e78bbf578c$var$qm(e1, t, n, r = !1) {
    if (r || !n.getCoveringTilesDetailsProvider().allowWorldCopies()) return e1?.wrap();
    let i = new (0, $1rqx5.lt)(e1.lng, e1.lat);
    if (e1 = new (0, $1rqx5.lt)(e1.lng, e1.lat), t) {
        let r = new (0, $1rqx5.lt)(e1.lng - 360, e1.lat), i = new (0, $1rqx5.lt)(e1.lng + 360, e1.lat), a = n.locationToScreenPoint(e1).distSqr(t);
        n.locationToScreenPoint(r).distSqr(t) < a ? e1 = r : n.locationToScreenPoint(i).distSqr(t) < a && (e1 = i);
    }
    for(; Math.abs(e1.lng - n.center.lng) > 180;){
        let t = n.locationToScreenPoint(e1);
        if (t.x >= 0 && t.y >= 0 && t.x <= n.width && t.y <= n.height) break;
        e1.lng > n.center.lng ? e1.lng -= 360 : e1.lng += 360;
    }
    return e1.lng !== i.lng && n.isPointOnMapSurface(n.locationToScreenPoint(e1)) ? e1 : i;
}
const $834619e78bbf578c$var$Jm = {
    center: `translate(-50%,-50%)`,
    top: `translate(-50%,0)`,
    "top-left": `translate(0,0)`,
    "top-right": `translate(-100%,0)`,
    bottom: `translate(-50%,-100%)`,
    "bottom-left": `translate(0,-100%)`,
    "bottom-right": `translate(-100%,-100%)`,
    left: `translate(0,-50%)`,
    right: `translate(-100%,-50%)`
};
function $834619e78bbf578c$var$Ym(e1, t, n) {
    let r = e1.classList;
    for(let e1 in $834619e78bbf578c$var$Jm)r.remove(`maplibregl-${n}-anchor-${e1}`);
    r.add(`maplibregl-${n}-anchor-${t}`);
}
const $834619e78bbf578c$var$Xm = {
    ArrowLeft: [
        -1,
        0
    ],
    ArrowRight: [
        1,
        0
    ],
    ArrowUp: [
        0,
        -1
    ],
    ArrowDown: [
        0,
        1
    ]
}, $834619e78bbf578c$var$Zm = `#3FB1CE`;
function $834619e78bbf578c$var$Qm(e1, t, n = []) {
    let r = $834619e78bbf578c$var$G.createNS(`http://www.w3.org/2000/svg`, e1);
    for(let e1 in t)r.setAttributeNS(null, e1, t[e1]);
    for (let e1 of n)r.appendChild(e1);
    return r;
}
let $834619e78bbf578c$var$$m;
function $834619e78bbf578c$var$eh() {
    return $834619e78bbf578c$var$$m || ($834619e78bbf578c$var$$m = $834619e78bbf578c$var$Qm(`svg`, {
        display: `block`,
        height: `41px`,
        width: `27px`,
        viewBox: `0 0 27 41`
    }, [
        $834619e78bbf578c$var$Qm(`g`, {
            "fill-rule": `nonzero`
        }, [
            $834619e78bbf578c$var$Qm(`g`, {
                transform: `translate(3.0, 29.0)`,
                fill: `#000000`
            }, [
                [
                    `10.5`,
                    `5.25002273`
                ],
                [
                    `10.5`,
                    `5.25002273`
                ],
                [
                    `9.5`,
                    `4.77275007`
                ],
                [
                    `8.5`,
                    `4.29549936`
                ],
                [
                    `7.5`,
                    `3.81822308`
                ],
                [
                    `6.5`,
                    `3.34094679`
                ],
                [
                    `5.5`,
                    `2.86367051`
                ],
                [
                    `4.5`,
                    `2.38636864`
                ]
            ].map(([e1, t])=>$834619e78bbf578c$var$Qm(`ellipse`, {
                    opacity: `0.04`,
                    cx: `10.5`,
                    cy: `5.80029008`,
                    rx: e1,
                    ry: t
                }))),
            $834619e78bbf578c$var$Qm(`g`, {
                fill: $834619e78bbf578c$var$Zm
            }, [
                $834619e78bbf578c$var$Qm(`path`, {
                    d: `M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z`
                })
            ]),
            $834619e78bbf578c$var$Qm(`g`, {
                opacity: `0.25`,
                fill: `#000000`
            }, [
                $834619e78bbf578c$var$Qm(`path`, {
                    d: `M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z`
                })
            ]),
            $834619e78bbf578c$var$Qm(`g`, {
                transform: `translate(6.0, 7.0)`,
                fill: `#FFFFFF`
            }),
            $834619e78bbf578c$var$Qm(`g`, {
                transform: `translate(8.0, 8.0)`
            }, [
                $834619e78bbf578c$var$Qm(`circle`, {
                    fill: `#000000`,
                    opacity: `0.25`,
                    cx: `5.5`,
                    cy: `5.5`,
                    r: `5.4999962`
                }),
                $834619e78bbf578c$var$Qm(`circle`, {
                    fill: `#FFFFFF`,
                    cx: `5.5`,
                    cy: `5.5`,
                    r: `5.4999962`
                })
            ])
        ])
    ]), $834619e78bbf578c$var$$m);
}
function $834619e78bbf578c$var$th(e1) {
    return e1.firstElementChild.children[1];
}
var $834619e78bbf578c$export$4da46cf7208441a7 = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$20d8ab55cf6e381 = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$e98856a975cab58e = class extends (0, $1rqx5.vn) {
    constructor(e1){
        if (super(), this._onClick = (e1)=>{
            this.fire(new $834619e78bbf578c$export$20d8ab55cf6e381(`click`, {
                originalEvent: e1
            }));
        }, this._onKeyPress = (e1)=>{
            (e1.code === `Space` || e1.code === `Enter`) && this.togglePopup();
        }, this._onKeyDown = (e1)=>{
            if (!this._defaultMarker || !this._draggable || !this._map || !this._lngLat || e1.composedPath()[0] !== this._element || e1.altKey || e1.ctrlKey || e1.metaKey) return;
            let t = $834619e78bbf578c$var$Xm[e1.key];
            if (!t) return;
            e1.preventDefault(), e1.stopPropagation();
            let n = e1.shiftKey ? 10 : 1, r = this._map.project(this._lngLat);
            this.setLngLat(this._map.unproject(new (0, $1rqx5.Li)(r.x + t[0] * n, r.y + t[1] * n))), this._keyboardDragActive || (this._keyboardDragActive = !0, this.fire(new $834619e78bbf578c$export$4da46cf7208441a7(`dragstart`))), this.fire(new $834619e78bbf578c$export$4da46cf7208441a7(`drag`));
        }, this._onKeyUp = (e1)=>{
            $834619e78bbf578c$var$Xm[e1.key] && this._endKeyboardDrag();
        }, this._onBlur = ()=>{
            this._endKeyboardDrag();
        }, this._onMapClick = (e1)=>{
            let t = e1.originalEvent.target, n = this._element;
            this._popup && (t === n || n.contains(t)) && this.togglePopup();
        }, this._updateCoveredUnthrottled = ()=>{
            let e1 = this._map?.terrain;
            if (!e1 || !this._isInViewport()) return;
            let t = this._isCovered(e1);
            t && this._popup?.isOpen() && this._popup.remove(), this._element.style.opacity = t ? this._opacityWhenCovered : this._opacity, this._element.classList.toggle(`maplibregl-marker-covered`, t);
        }, this._updateCovered = $834619e78bbf578c$var$Ep(this._updateCoveredUnthrottled, 100), this._update = (e1)=>{
            if (!this._map) return;
            this._lngLat = $834619e78bbf578c$var$qm(this._lngLat, this._flatPos, this._map._camera.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map._camera.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
            let t = ``;
            this._rotationAlignment === `viewport` || this._rotationAlignment === `auto` ? t = `rotateZ(${this._rotation}deg)` : this._rotationAlignment === `map` && (t = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
            let n = ``;
            this._pitchAlignment === `viewport` || this._pitchAlignment === `auto` ? n = `rotateX(0deg)` : this._pitchAlignment === `map` && (n = `rotateX(${this._map.getPitch()}deg)`), !this._subpixelPositioning && e1?.type !== `move` && (this._pos = this._pos.round()), this._element.style.transform = `${$834619e78bbf578c$var$Jm[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${n} ${t}`, this._updateOpacity();
        }, this._onMove = (e1)=>{
            if (!this._isDragging) {
                let t = this._clickTolerance || this._map._clickTolerance;
                this._isDragging = e1.point.dist(this._pointerdownPos) >= t;
            }
            this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = `none`, this._state === `pending` && (this._state = `active`, this.fire(new $834619e78bbf578c$export$4da46cf7208441a7(`dragstart`))), this.fire(new $834619e78bbf578c$export$4da46cf7208441a7(`drag`)));
        }, this._onUp = ()=>{
            this._element.style.pointerEvents = `auto`, this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off(`mousemove`, this._onMove), this._map.off(`touchmove`, this._onMove), this._state === `active` && this.fire(new $834619e78bbf578c$export$4da46cf7208441a7(`dragend`)), this._state = `inactive`;
        }, this._addDragHandler = (e1)=>{
            this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos).add(this._offset), this._pointerdownPos = e1.point, this._state = `pending`, this._map.on(`mousemove`, this._onMove), this._map.on(`touchmove`, this._onMove), this._map.once(`mouseup`, this._onUp), this._map.once(`touchend`, this._onUp));
        }, this._anchor = e1?.anchor || `center`, this._color = e1?.color || $834619e78bbf578c$var$Zm, this._scale = e1?.scale || 1, this._draggable = e1?.draggable || !1, this._clickTolerance = e1?.clickTolerance || 0, this._subpixelPositioning = e1?.subpixelPositioning || !1, this._isDragging = !1, this._roleManaged = !1, this._tabIndexManaged = !1, this._keyboardDragActive = !1, this._state = `inactive`, this._rotation = e1?.rotation || 0, this._rotationAlignment = e1?.rotationAlignment || `auto`, this._pitchAlignment = e1?.pitchAlignment && e1.pitchAlignment !== `auto` ? e1.pitchAlignment : this._rotationAlignment, this.setOpacity(e1?.opacity, e1?.opacityWhenCovered), e1?.element) this._element = e1.element, this._offset = (0, $1rqx5.Li).convert(e1?.offset || [
            0,
            0
        ]);
        else {
            this._defaultMarker = !0, this._element = $834619e78bbf578c$var$G.create(`div`);
            let t = $834619e78bbf578c$var$eh().cloneNode(!0);
            t.setAttributeNS(null, `height`, `${41 * this._scale}px`), t.setAttributeNS(null, `width`, `${27 * this._scale}px`), $834619e78bbf578c$var$th(t).setAttributeNS(null, `fill`, this._color), this._element.appendChild(t), this._offset = (0, $1rqx5.Li).convert(e1?.offset || [
                0,
                -14
            ]);
        }
        if (this._element.classList.add(`maplibregl-marker`), this._element.addEventListener(`dragstart`, (e1)=>{
            e1.preventDefault();
        }), this._element.addEventListener(`mousedown`, (e1)=>{
            e1.preventDefault();
        }), $834619e78bbf578c$var$Ym(this._element, this._anchor, `marker`), e1?.className) for (let t of e1.className.split(` `))this._element.classList.add(t);
        this._popup = null;
    }
    addTo(e1) {
        return this.remove(), this._map = e1, this._defaultMarker && !this._element.hasAttribute(`aria-label`) && this._element.setAttribute(`aria-label`, e1._getUIString(`Marker.Title`)), this._updateAccessibilityRole(), e1.getCanvasContainer().appendChild(this._element), e1.on(`move`, this._update), e1.on(`moveend`, this._update), e1.on(`terrain`, this._update), e1.on(`projectiontransition`, this._update), e1.on(`idle`, this._update), this._element.addEventListener(`click`, this._onClick), this.setDraggable(this._draggable), this._update(), this._map.on(`click`, this._onMapClick), this;
    }
    remove() {
        return this._map && (this._map.off(`click`, this._onMapClick), this._map.off(`move`, this._update), this._map.off(`moveend`, this._update), this._map.off(`terrain`, this._update), this._map.off(`projectiontransition`, this._update), this._map.off(`idle`, this._update), this._map.off(`mousedown`, this._addDragHandler), this._map.off(`touchstart`, this._addDragHandler), this._map.off(`mouseup`, this._onUp), this._map.off(`touchend`, this._onUp), this._map.off(`mousemove`, this._onMove), this._map.off(`touchmove`, this._onMove), delete this._map), this._element.removeEventListener(`click`, this._onClick), this._element.removeEventListener(`keydown`, this._onKeyDown), this._element.removeEventListener(`keyup`, this._onKeyUp), this._element.removeEventListener(`blur`, this._onBlur), this._element.removeEventListener(`keypress`, this._onKeyPress), this._keyboardDragActive = !1, this._element.remove(), this._popup && this._popup.remove(), this;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = (0, $1rqx5.lt).convert(e1), this._pos = null, this._update(), this._popup && this._popup.setLngLat(this._lngLat), this;
    }
    getElement() {
        return this._element;
    }
    setPopup(e1) {
        if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener(`keypress`, this._onKeyPress)), e1) {
            if (!(`offset` in e1.options)) {
                let t = 13.5 / Math.SQRT2;
                e1.options.offset = this._defaultMarker ? {
                    top: [
                        0,
                        0
                    ],
                    "top-left": [
                        0,
                        0
                    ],
                    "top-right": [
                        0,
                        0
                    ],
                    bottom: [
                        0,
                        -38.1
                    ],
                    "bottom-left": [
                        t,
                        (24.6 + t) * -1
                    ],
                    "bottom-right": [
                        -t,
                        (24.6 + t) * -1
                    ],
                    left: [
                        13.5,
                        -24.6
                    ],
                    right: [
                        -13.5,
                        -24.6
                    ]
                } : this._offset;
            }
            this._popup = e1, this._element.addEventListener(`keypress`, this._onKeyPress);
        }
        return this._updateTabIndex(), this._updateAccessibilityRole(), this;
    }
    setSubpixelPositioning(e1) {
        return this._subpixelPositioning = e1, this;
    }
    _endKeyboardDrag() {
        this._keyboardDragActive && (this._keyboardDragActive = !1, this.fire(new $834619e78bbf578c$export$4da46cf7208441a7(`dragend`)));
    }
    getPopup() {
        return this._popup;
    }
    togglePopup() {
        let e1 = this._popup;
        if (this._element.style.opacity === this._opacityWhenCovered) return this;
        if (e1) e1.isOpen() ? e1.remove() : (e1.setLngLat(this._lngLat), e1.addTo(this._map));
        else return this;
        return this;
    }
    _updateOpacity() {
        if (!this._isInViewport()) return;
        let e1 = this._map?.terrain, t = this._map._camera.transform.isLocationOccluded(this._lngLat);
        if (!e1 || t) {
            let e1 = t ? this._opacityWhenCovered : this._opacity;
            this._element.style.opacity !== e1 && (this._element.style.opacity = e1, this._element.classList.toggle(`maplibregl-marker-covered`, t));
            return;
        }
        this._updateCovered();
    }
    _isInViewport() {
        let { width: e1, height: t } = this._map._camera.transform;
        return !!this._pos && this._pos.x >= 0 && this._pos.y >= 0 && this._pos.x <= e1 && this._pos.y <= t;
    }
    _isCovered(e1) {
        let t = this._map._camera.transform, n = e1.getElevationForLngLat(this._lngLat, t), r = Math.max(0, -this._offset.y) / t.pixelsPerMeter, i = Math.sin(this._map.getPitch() * Math.PI / 180) * r;
        return t.isLocationOccluded(this._lngLat, e1, n + i);
    }
    getOffset() {
        return this._offset;
    }
    setOffset(e1) {
        return this._offset = (0, $1rqx5.Li).convert(e1), this._update(), this;
    }
    addClassName(e1) {
        this._element.classList.add(e1);
    }
    removeClassName(e1) {
        this._element.classList.remove(e1);
    }
    toggleClassName(e1) {
        return this._element.classList.toggle(e1);
    }
    setDraggable(e1) {
        return this._draggable = !!e1, this._element.classList.toggle(`maplibregl-marker-draggable`, this._draggable), this._map && (e1 ? (this._map.on(`mousedown`, this._addDragHandler), this._map.on(`touchstart`, this._addDragHandler)) : (this._map.off(`mousedown`, this._addDragHandler), this._map.off(`touchstart`, this._addDragHandler))), this._defaultMarker && (this._draggable ? (this._element.addEventListener(`keydown`, this._onKeyDown), this._element.addEventListener(`keyup`, this._onKeyUp), this._element.addEventListener(`blur`, this._onBlur)) : (this._element.removeEventListener(`keydown`, this._onKeyDown), this._element.removeEventListener(`keyup`, this._onKeyUp), this._element.removeEventListener(`blur`, this._onBlur), this._endKeyboardDrag())), this._updateTabIndex(), this._updateAccessibilityRole(), this;
    }
    isDraggable() {
        return this._draggable;
    }
    _updateTabIndex() {
        this._popup || this._defaultMarker && this._draggable ? this._element.hasAttribute(`tabindex`) || (this._element.setAttribute(`tabindex`, `0`), this._tabIndexManaged = !0) : this._tabIndexManaged &&= (this._element.getAttribute(`tabindex`) === `0` && this._element.removeAttribute(`tabindex`), !1);
    }
    _updateAccessibilityRole() {
        if (!this._defaultMarker || this._element.hasAttribute(`role`) && !this._roleManaged) return;
        let e1 = this._draggable || this._popup ? `button` : `img`;
        this._element.setAttribute(`role`, e1), this._roleManaged = !0;
    }
    setRotation(e1) {
        return this._rotation = e1 || 0, this._update(), this;
    }
    getRotation() {
        return this._rotation;
    }
    setRotationAlignment(e1) {
        return this._rotationAlignment = e1 || `auto`, this._update(), this;
    }
    getRotationAlignment() {
        return this._rotationAlignment;
    }
    setPitchAlignment(e1) {
        return this._pitchAlignment = e1 && e1 !== `auto` ? e1 : this._rotationAlignment, this._update(), this;
    }
    getPitchAlignment() {
        return this._pitchAlignment;
    }
    setOpacity(e1, t) {
        return (this._opacity === void 0 || e1 === void 0 && t === void 0) && (this._opacity = `1`, this._opacityWhenCovered = `0.2`), e1 !== void 0 && (this._opacity = String(e1)), t !== void 0 && (this._opacityWhenCovered = String(t)), this._map && this._updateOpacity(), this;
    }
};
const $834619e78bbf578c$var$ah = {
    positionOptions: {
        enableHighAccuracy: !1,
        maximumAge: 0,
        timeout: 6e3
    },
    fitBoundsOptions: {
        maxZoom: 15
    },
    trackUserLocation: !1,
    showAccuracyCircle: !0,
    showUserLocation: !0
};
let $834619e78bbf578c$var$oh = 0, $834619e78bbf578c$var$sh = !1;
var $834619e78bbf578c$export$caf365a3870a7616 = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$d3cbd8e3df821073 = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$319ba8bf7a75a42a = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$15e4ff48f7e9d8e0 = class extends (0, $1rqx5.vn) {
    constructor(e1){
        super(), this._onSuccess = (e1)=>{
            if (this._map) {
                if (this._isOutOfMapMaxBounds(e1)) {
                    this._setErrorState(), this.fire(new $834619e78bbf578c$export$d3cbd8e3df821073(`outofmaxbounds`, e1)), this._updateMarker(), this._finish();
                    return;
                }
                if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                    case `WAITING_ACTIVE`:
                    case `ACTIVE_LOCK`:
                    case `ACTIVE_ERROR`:
                        this._watchState = `ACTIVE_LOCK`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                        break;
                    case `BACKGROUND`:
                    case `BACKGROUND_ERROR`:
                        this._watchState = `BACKGROUND`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background`);
                        break;
                    default:
                        throw Error(`Unexpected watchState ${this._watchState}`);
                }
                this.options.showUserLocation && this._watchState !== `OFF` && this._updateMarker(e1), (!this.options.trackUserLocation || this._watchState === `ACTIVE_LOCK`) && this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove(`maplibregl-user-location-dot-stale`), this.fire(new $834619e78bbf578c$export$d3cbd8e3df821073(`geolocate`, e1)), this._finish();
            }
        }, this._updateCamera = (e1)=>{
            let t = new (0, $1rqx5.lt)(e1.coords.longitude, e1.coords.latitude), n = e1.coords.accuracy, r = this._map.getBearing(), i = (0, $1rqx5.er)({
                bearing: r
            }, this.options.fitBoundsOptions), a = $834619e78bbf578c$export$266d2884f61535d3.fromLngLat(t, n);
            this._map.fitBounds(a, i, {
                geolocateSource: !0
            });
        }, this._updateMarker = (e1)=>{
            if (e1) {
                let t = new (0, $1rqx5.lt)(e1.coords.longitude, e1.coords.latitude);
                this._accuracyCircleMarker.setLngLat(t).addTo(this._map), this._userLocationDotMarker.setLngLat(t).addTo(this._map), this._accuracy = e1.coords.accuracy, this._updateCircleRadiusIfNeeded();
            } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }, this._onUpdate = ()=>{
            this._updateCircleRadiusIfNeeded();
        }, this._onError = (e1)=>{
            if (this._map) {
                if (e1.code === 1) {
                    this._watchState = `OFF`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.disabled = !0;
                    let e1 = this._map._getUIString(`GeolocateControl.LocationNotAvailable`);
                    this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1), this._geolocationWatchID !== void 0 && this._clearWatch();
                } else if (e1.code === 3 && $834619e78bbf578c$var$sh) return;
                else this._setErrorState();
                this._watchState !== `OFF` && this.options.showUserLocation && this._dotElement.classList.add(`maplibregl-user-location-dot-stale`), this.fire(new $834619e78bbf578c$export$319ba8bf7a75a42a(`error`, e1)), this._finish();
            }
        }, this._finish = ()=>{
            this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }, this._onMoveStart = (e1)=>{
            if (!this._map) return;
            let t = e1?.[0] instanceof ResizeObserverEntry;
            !e1.geolocateSource && this._watchState === `ACTIVE_LOCK` && !t && !this._map.isZooming() && (this._watchState = `BACKGROUND`, this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this.fire(new $834619e78bbf578c$export$caf365a3870a7616(`trackuserlocationend`)), this.fire(new $834619e78bbf578c$export$caf365a3870a7616(`userlocationlostfocus`)));
        }, this._setupUI = ()=>{
            this._map && (this._container.addEventListener(`contextmenu`, (e1)=>{
                e1.preventDefault();
            }), this._geolocateButton = $834619e78bbf578c$var$G.create(`button`, `maplibregl-ctrl-geolocate`, this._container), $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, this._geolocateButton).setAttribute(`aria-hidden`, `true`), this._geolocateButton.type = `button`, this._geolocateButton.disabled = !0);
        }, this._finishSetupUI = (e1)=>{
            if (this._map) {
                if (e1 === !1) {
                    (0, $1rqx5.Nr)(`Geolocation support is not available so the GeolocateControl will be disabled.`);
                    let e1 = this._map._getUIString(`GeolocateControl.LocationNotAvailable`);
                    this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1);
                } else {
                    let e1 = this._map._getUIString(`GeolocateControl.FindMyLocation`);
                    this._geolocateButton.disabled = !1, this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute(`aria-pressed`, `false`), this._watchState = `OFF`), this.options.showUserLocation && (this._dotElement = $834619e78bbf578c$var$G.create(`div`, `maplibregl-user-location-dot`), this._userLocationDotMarker = new $834619e78bbf578c$export$e98856a975cab58e({
                    element: this._dotElement
                }), this._circleElement = $834619e78bbf578c$var$G.create(`div`, `maplibregl-user-location-accuracy-circle`), this._accuracyCircleMarker = new $834619e78bbf578c$export$e98856a975cab58e({
                    element: this._circleElement,
                    pitchAlignment: `map`
                }), this.options.trackUserLocation && (this._watchState = `OFF`), this._map.on(`zoom`, this._onUpdate), this._map.on(`move`, this._onUpdate), this._map.on(`rotate`, this._onUpdate), this._map.on(`pitch`, this._onUpdate)), this._geolocateButton.addEventListener(`click`, ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on(`movestart`, this._onMoveStart);
            }
        }, this.options = (0, $1rqx5.er)({}, $834619e78bbf578c$var$ah, e1);
    }
    onAdd(e1) {
        return this._map = e1, this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._setupUI(), $834619e78bbf578c$var$Km().then((e1)=>this._finishSetupUI(e1)), this._container;
    }
    onRemove() {
        this._geolocationWatchID !== void 0 && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off(`movestart`, this._onMoveStart), this._map.off(`zoom`, this._onUpdate), this._map.off(`move`, this._onUpdate), this._map.off(`rotate`, this._onUpdate), this._map.off(`pitch`, this._onUpdate), this._map = void 0, $834619e78bbf578c$var$oh = 0, $834619e78bbf578c$var$sh = !1;
    }
    _isOutOfMapMaxBounds(e1) {
        let t = this._map.getMaxBounds(), n = e1.coords;
        return t && (n.longitude < t.getWest() || n.longitude > t.getEast() || n.latitude < t.getSouth() || n.latitude > t.getNorth());
    }
    _setErrorState() {
        switch(this._watchState){
            case `WAITING_ACTIVE`:
                this._watchState = `ACTIVE_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active-error`);
                break;
            case `ACTIVE_LOCK`:
                this._watchState = `ACTIVE_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`);
                break;
            case `BACKGROUND`:
                this._watchState = `BACKGROUND_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`);
                break;
            case `ACTIVE_ERROR`:
            case `BACKGROUND_ERROR`:
                break;
            case `OFF`:
            case void 0:
                break;
            default:
                throw Error(`Unexpected watchState ${this._watchState}`);
        }
    }
    _updateCircleRadiusIfNeeded() {
        let e1 = this._userLocationDotMarker.getLngLat();
        if (!this.options.showUserLocation || !this.options.showAccuracyCircle || !this._accuracy || !e1) return;
        let t = this._map.project(e1), n = this._map.unproject([
            t.x + 100,
            t.y
        ]), r = e1.distanceTo(n) / 100, i = 2 * this._accuracy / r;
        this._circleElement.style.width = `${i.toFixed(2)}px`, this._circleElement.style.height = `${i.toFixed(2)}px`;
    }
    trigger() {
        if (!this._setup) return (0, $1rqx5.Nr)(`Geolocate control triggered before added to a map`), !1;
        if (this.options.trackUserLocation) {
            switch(this._watchState){
                case `OFF`:
                    this._watchState = `WAITING_ACTIVE`, this.fire(new $834619e78bbf578c$export$caf365a3870a7616(`trackuserlocationstart`));
                    break;
                case `WAITING_ACTIVE`:
                case `ACTIVE_LOCK`:
                case `ACTIVE_ERROR`:
                case `BACKGROUND_ERROR`:
                    $834619e78bbf578c$var$oh--, $834619e78bbf578c$var$sh = !1, this._watchState = `OFF`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this.fire(new $834619e78bbf578c$export$caf365a3870a7616(`trackuserlocationend`));
                    break;
                case `BACKGROUND`:
                    this._watchState = `ACTIVE_LOCK`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new $834619e78bbf578c$export$caf365a3870a7616(`trackuserlocationstart`)), this.fire(new $834619e78bbf578c$export$caf365a3870a7616(`userlocationfocus`));
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            switch(this._watchState){
                case `WAITING_ACTIVE`:
                    this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                    break;
                case `ACTIVE_LOCK`:
                    this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                    break;
                case `OFF`:
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            if (this._watchState === `OFF` && this._geolocationWatchID !== void 0) this._clearWatch();
            else if (this._geolocationWatchID === void 0) {
                this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.setAttribute(`aria-pressed`, `true`), $834619e78bbf578c$var$oh++;
                let e1;
                $834619e78bbf578c$var$oh > 1 ? (e1 = {
                    maximumAge: 6e5,
                    timeout: 0
                }, $834619e78bbf578c$var$sh = !0) : (e1 = this.options.positionOptions, $834619e78bbf578c$var$sh = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
            }
        } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
        return !0;
    }
    _clearWatch() {
        window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.setAttribute(`aria-pressed`, `false`), this.options.showUserLocation && this._updateMarker(null);
    }
};
const $834619e78bbf578c$var$fh = {
    maxWidth: 100,
    unit: `metric`
};
var $834619e78bbf578c$export$1fb16e435eedcce9 = class {
    constructor(e1){
        this._onMove = ()=>{
            $834619e78bbf578c$var$mh(this._map, this._container, this.options);
        }, this.setUnit = (e1)=>{
            this.options.unit = e1, $834619e78bbf578c$var$mh(this._map, this._container, this.options);
        }, this.options = {
            ...$834619e78bbf578c$var$fh,
            ...e1
        };
    }
    getDefaultPosition() {
        return `bottom-left`;
    }
    onAdd(e1) {
        return this._map = e1, this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-scale`, e1.getContainer()), this._map.on(`move`, this._onMove), this._onMove(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`move`, this._onMove), this._map = void 0;
    }
};
function $834619e78bbf578c$var$mh(e1, t, n) {
    let r = n?.maxWidth || 100, { width: i, height: a } = e1._camera.transform, o = a / 2, s = i / 2, c = e1.unproject([
        s - r / 2,
        o
    ]), l = e1.unproject([
        s + r / 2,
        o
    ]), u = Math.round(e1.project(l).x - e1.project(c).x), d = Math.min(r, u, i), f = c.distanceTo(l);
    if (n?.unit === `imperial`) {
        let n = 3.2808 * f;
        n > 5280 ? $834619e78bbf578c$var$hh(t, d, n / 5280, e1._getUIString(`ScaleControl.Miles`)) : $834619e78bbf578c$var$hh(t, d, n, e1._getUIString(`ScaleControl.Feet`));
    } else n?.unit === `nautical` ? $834619e78bbf578c$var$hh(t, d, f / 1852, e1._getUIString(`ScaleControl.NauticalMiles`)) : f >= 1e3 ? $834619e78bbf578c$var$hh(t, d, f / 1e3, e1._getUIString(`ScaleControl.Kilometers`)) : $834619e78bbf578c$var$hh(t, d, f, e1._getUIString(`ScaleControl.Meters`));
}
function $834619e78bbf578c$var$hh(e1, t, n, r) {
    let i = $834619e78bbf578c$var$_h(n), a = i / n;
    e1.style.width = `${t * a}px`;
    let o = `${i}\u00a0${r}`;
    e1.textContent !== o && (e1.textContent = o);
}
function $834619e78bbf578c$var$gh(e1) {
    let t = 10 ** Math.ceil(-Math.log(e1) / Math.LN10);
    return Math.round(e1 * t) / t;
}
function $834619e78bbf578c$var$_h(e1) {
    let t = 10 ** (`${Math.floor(e1)}`.length - 1), n = e1 / t;
    return n = n >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : n >= 1 ? 1 : $834619e78bbf578c$var$gh(n), t * n;
}
var $834619e78bbf578c$export$a2126d0731cda86b = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$91e8ffb52c2b32c5 = class extends (0, $1rqx5.vn) {
    constructor(e1 = {}){
        super(), this._onFullscreenChange = ()=>{
            let e1 = window.document.fullscreenElement || window.document.webkitFullscreenElement;
            for(; e1?.shadowRoot?.fullscreenElement;)e1 = e1.shadowRoot.fullscreenElement;
            e1 === this._container !== this._fullscreen && this._handleFullscreenChange();
        }, this._onClickFullscreen = ()=>{
            this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
        }, this._fullscreen = !1, this._pseudo = e1.pseudo ?? !1, e1?.container && (e1.container instanceof HTMLElement ? this._container = e1.container : (0, $1rqx5.Nr)(`Full screen control 'container' must be a DOM element.`)), `onfullscreenchange` in document ? this._fullscreenchange = `fullscreenchange` : `onmozfullscreenchange` in document ? this._fullscreenchange = `mozfullscreenchange` : `onwebkitfullscreenchange` in document ? this._fullscreenchange = `webkitfullscreenchange` : `onmsfullscreenchange` in document && (this._fullscreenchange = `MSFullscreenChange`);
    }
    onAdd(e1) {
        return this._map = e1, this._container ||= this._map.getContainer(), this._controlContainer = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._setupUI(), this._controlContainer;
    }
    onRemove() {
        this._controlContainer.remove(), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _setupUI() {
        let e1 = this._fullscreenButton = $834619e78bbf578c$var$G.create(`button`, `maplibregl-ctrl-fullscreen`, this._controlContainer);
        $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, e1).setAttribute(`aria-hidden`, `true`), e1.type = `button`, this._updateTitle(), this._fullscreenButton.addEventListener(`click`, this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _updateTitle() {
        let e1 = this._getTitle();
        this._fullscreenButton.setAttribute(`aria-label`, e1), this._fullscreenButton.title = e1;
    }
    _getTitle() {
        return this._map._getUIString(this._isFullscreen() ? `FullscreenControl.Exit` : `FullscreenControl.Enter`);
    }
    _isFullscreen() {
        return this._fullscreen;
    }
    _handleFullscreenChange() {
        this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle(`maplibregl-ctrl-shrink`), this._fullscreenButton.classList.toggle(`maplibregl-ctrl-fullscreen`), this._updateTitle(), this._fullscreen ? (this.fire(new $834619e78bbf578c$export$a2126d0731cda86b(`fullscreenstart`)), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new $834619e78bbf578c$export$a2126d0731cda86b(`fullscreenend`)), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
    }
    _exitFullscreen() {
        this._pseudo ? this._togglePseudoFullScreen() : window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
    }
    _requestFullscreen() {
        this._pseudo ? this._togglePseudoFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
    }
    _togglePseudoFullScreen() {
        this._container.classList.toggle(`maplibregl-pseudo-fullscreen`), this._handleFullscreenChange(), this._map.resize();
    }
}, $834619e78bbf578c$export$cc733900d53f94f9 = class {
    constructor(e1){
        this._toggleTerrain = ()=>{
            this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
        }, this._updateTerrainIcon = ()=>{
            this._terrainButton.classList.remove(`maplibregl-ctrl-terrain`), this._terrainButton.classList.remove(`maplibregl-ctrl-terrain-enabled`), this._map.terrain ? (this._terrainButton.classList.add(`maplibregl-ctrl-terrain-enabled`), this._terrainButton.title = this._map._getUIString(`TerrainControl.Disable`)) : (this._terrainButton.classList.add(`maplibregl-ctrl-terrain`), this._terrainButton.title = this._map._getUIString(`TerrainControl.Enable`));
        }, this.options = e1;
    }
    onAdd(e1) {
        return this._map = e1, this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._terrainButton = $834619e78bbf578c$var$G.create(`button`, `maplibregl-ctrl-terrain`, this._container), $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, this._terrainButton).setAttribute(`aria-hidden`, `true`), this._terrainButton.type = `button`, this._terrainButton.addEventListener(`click`, this._toggleTerrain), this._updateTerrainIcon(), this._map.on(`terrain`, this._updateTerrainIcon), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`terrain`, this._updateTerrainIcon), this._map = void 0;
    }
}, $834619e78bbf578c$export$9618410ded3c9550 = class {
    constructor(){
        this._toggleProjection = ()=>{
            let e1 = this._map.getProjection()?.type;
            e1 === `mercator` || !e1 ? this._map.setProjection({
                type: `globe`
            }) : this._map.setProjection({
                type: `mercator`
            }), this._updateGlobeIcon();
        }, this._updateGlobeIcon = ()=>{
            this._globeButton.classList.remove(`maplibregl-ctrl-globe`), this._globeButton.classList.remove(`maplibregl-ctrl-globe-enabled`), this._map.getProjection()?.type === `globe` ? (this._globeButton.classList.add(`maplibregl-ctrl-globe-enabled`), this._globeButton.title = this._map._getUIString(`GlobeControl.Disable`)) : (this._globeButton.classList.add(`maplibregl-ctrl-globe`), this._globeButton.title = this._map._getUIString(`GlobeControl.Enable`));
        };
    }
    onAdd(e1) {
        return this._map = e1, this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._globeButton = $834619e78bbf578c$var$G.create(`button`, `maplibregl-ctrl-globe`, this._container), $834619e78bbf578c$var$G.create(`span`, `maplibregl-ctrl-icon`, this._globeButton).setAttribute(`aria-hidden`, `true`), this._globeButton.type = `button`, this._globeButton.addEventListener(`click`, this._toggleProjection), this._updateGlobeIcon(), this._map.on(`styledata`, this._updateGlobeIcon), this._map.on(`projectiontransition`, this._updateGlobeIcon), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`styledata`, this._updateGlobeIcon), this._map.off(`projectiontransition`, this._updateGlobeIcon), this._globeButton.removeEventListener(`click`, this._toggleProjection), this._map = void 0;
    }
};
const $834619e78bbf578c$var$Sh = {
    closeButton: !0,
    closeOnClick: !0,
    focusAfterOpen: !0,
    className: ``,
    maxWidth: `240px`,
    subpixelPositioning: !1,
    locationOccludedOpacity: void 0,
    padding: void 0
}, $834619e78bbf578c$var$Ch = [
    `a[href]`,
    `[tabindex]:not([tabindex='-1'])`,
    `[contenteditable]:not([contenteditable='false'])`,
    `button:not([disabled])`,
    `input:not([disabled])`,
    `select:not([disabled])`,
    `textarea:not([disabled])`
].join(`, `);
var $834619e78bbf578c$export$c09aca14b6b2f8f0 = class extends (0, $1rqx5._n) {
}, $834619e78bbf578c$export$129a32eedafa97c5 = class extends (0, $1rqx5.vn) {
    constructor(e1){
        super(), this._updateOpacity = ()=>{
            this.options.locationOccludedOpacity !== void 0 && (this._map._camera.transform.isLocationOccluded(this.getLngLat()) ? this._container.style.opacity = `${this.options.locationOccludedOpacity}` : this._container.style.opacity = ``);
        }, this.remove = ()=>(this._content && this._content.remove(), this._container && (this._container.remove(), delete this._container), this._map && (this._map.off(`move`, this._update), this._map.off(`move`, this._onClose), this._map.off(`click`, this._onClose), this._map.off(`remove`, this.remove), this._map.off(`terrain`, this._update), this._map.off(`projectiontransition`, this._update), this._map.off(`idle`, this._update), this._map.off(`mousemove`, this._update), this._map.off(`mouseup`, this._update), this._map.off(`drag`, this._update), this._map._canvasContainer.classList.remove(`maplibregl-track-pointer`), delete this._map, this.fire(new $834619e78bbf578c$export$c09aca14b6b2f8f0(`close`))), this), this._update = (e1)=>{
            let t = this._lngLat || this._trackPointer;
            if (!this._map || !t || !this._content) return;
            if (!this._container) {
                if (this._container = $834619e78bbf578c$var$G.create(`div`, `maplibregl-popup`, this._map.getContainer()), this._tip = $834619e78bbf578c$var$G.create(`div`, `maplibregl-popup-tip`, this._container), this._container.appendChild(this._content), this.options.className) for (let e1 of this.options.className.split(` `))this._container.classList.add(e1);
                this._closeButton && this._closeButton.setAttribute(`aria-label`, this._map._getUIString(`Popup.Close`)), this._trackPointer && this._container.classList.add(`maplibregl-popup-track-pointer`);
            }
            this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = $834619e78bbf578c$var$qm(this._lngLat, this._flatPos, this._map._camera.transform, this._trackPointer);
            let n;
            if (e1 && `point` in e1 && e1.point && (n = e1.point), this._trackPointer && !n) return;
            let r = this._flatPos = this._pos = this._trackPointer && n ? n : this._map.project(this._lngLat);
            this._map.terrain && (this._flatPos = this._trackPointer && n ? n : this._map._camera.transform.locationToScreenPoint(this._lngLat));
            let i = this.options.anchor, a = $834619e78bbf578c$var$Eh(this.options.offset);
            if (!i) {
                let e1 = this._container.offsetWidth, t = this._container.offsetHeight, n = $834619e78bbf578c$var$Dh(this.options.padding), o;
                o = r.y + a.bottom.y < t + n.top ? [
                    `top`
                ] : r.y > this._map._camera.transform.height - t - n.bottom ? [
                    `bottom`
                ] : [], r.x < e1 / 2 + n.left ? o.push(`left`) : r.x > this._map._camera.transform.width - e1 / 2 - n.right && o.push(`right`), i = o.length === 0 ? `bottom` : o.join(`-`);
            }
            let o = r.add(a[i]);
            this.options.subpixelPositioning || (o = o.round()), this._container.style.transform = `${$834619e78bbf578c$var$Jm[i]} translate(${o.x}px,${o.y}px)`, $834619e78bbf578c$var$Ym(this._container, i, `popup`), this._updateOpacity();
        }, this._onClose = ()=>{
            this.remove();
        }, this.options = (0, $1rqx5.er)(Object.create($834619e78bbf578c$var$Sh), e1);
    }
    addTo(e1) {
        return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on(`click`, this._onClose), this.options.closeOnMove && this._map.on(`move`, this._onClose), this._map.on(`remove`, this.remove), this._map.on(`terrain`, this._update), this._map.on(`projectiontransition`, this._update), this._map.on(`idle`, this._update), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on(`mousemove`, this._update), this._map.on(`mouseup`, this._update), this._container && this._container.classList.add(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.add(`maplibregl-track-pointer`)) : this._map.on(`move`, this._update), this.fire(new $834619e78bbf578c$export$c09aca14b6b2f8f0(`open`)), this;
    }
    isOpen() {
        return !!this._map;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = (0, $1rqx5.lt).convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on(`move`, this._update), this._map.off(`mousemove`, this._update), this._container && this._container.classList.remove(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.remove(`maplibregl-track-pointer`)), this;
    }
    trackPointer() {
        return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off(`move`, this._update), this._map.on(`mousemove`, this._update), this._map.on(`drag`, this._update), this._container && this._container.classList.add(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.add(`maplibregl-track-pointer`)), this;
    }
    getElement() {
        return this._container;
    }
    setText(e1) {
        return this.setDOMContent(document.createTextNode(e1));
    }
    setHTML(e1) {
        let t = document.createDocumentFragment(), n = document.createElement(`body`), r;
        for(n.innerHTML = e1; r = n.firstChild, r;)t.appendChild(r);
        return this.setDOMContent(t);
    }
    getMaxWidth() {
        return this._container?.style.maxWidth;
    }
    setMaxWidth(e1) {
        return this.options.maxWidth = e1, this._update(), this;
    }
    setDOMContent(e1) {
        if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
        else this._content = $834619e78bbf578c$var$G.create(`div`, `maplibregl-popup-content`, this._container);
        return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
    }
    addClassName(e1) {
        return this._container && this._container.classList.add(e1), this;
    }
    removeClassName(e1) {
        return this._container && this._container.classList.remove(e1), this;
    }
    setOffset(e1) {
        return this.options.offset = e1, this._update(), this;
    }
    toggleClassName(e1) {
        if (this._container) return this._container.classList.toggle(e1);
    }
    setSubpixelPositioning(e1) {
        this.options.subpixelPositioning = e1;
    }
    setPadding(e1) {
        this.options.padding = e1, this._update();
    }
    _createCloseButton() {
        this.options.closeButton && (this._closeButton = $834619e78bbf578c$var$G.create(`button`, `maplibregl-popup-close-button`, this._content), this._closeButton.type = `button`, this._closeButton.innerHTML = `&#215;`, this._closeButton.addEventListener(`click`, this._onClose));
    }
    _focusFirstElement() {
        if (!this.options.focusAfterOpen || !this._container) return;
        let e1 = this._container.querySelector($834619e78bbf578c$var$Ch);
        e1 && e1.focus();
    }
};
function $834619e78bbf578c$var$Eh(e1) {
    if (!e1) return $834619e78bbf578c$var$Eh(new (0, $1rqx5.Li)(0, 0));
    if (typeof e1 == `number`) {
        let t = Math.round(Math.abs(e1) / Math.SQRT2);
        return {
            center: new (0, $1rqx5.Li)(0, 0),
            top: new (0, $1rqx5.Li)(0, e1),
            "top-left": new (0, $1rqx5.Li)(t, t),
            "top-right": new (0, $1rqx5.Li)(-t, t),
            bottom: new (0, $1rqx5.Li)(0, -e1),
            "bottom-left": new (0, $1rqx5.Li)(t, -t),
            "bottom-right": new (0, $1rqx5.Li)(-t, -t),
            left: new (0, $1rqx5.Li)(e1, 0),
            right: new (0, $1rqx5.Li)(-e1, 0)
        };
    }
    if (e1 instanceof (0, $1rqx5.Li) || Array.isArray(e1)) {
        let t = (0, $1rqx5.Li).convert(e1);
        return {
            center: t,
            top: t,
            "top-left": t,
            "top-right": t,
            bottom: t,
            "bottom-left": t,
            "bottom-right": t,
            left: t,
            right: t
        };
    }
    return {
        center: (0, $1rqx5.Li).convert(e1.center || [
            0,
            0
        ]),
        top: (0, $1rqx5.Li).convert(e1.top || [
            0,
            0
        ]),
        "top-left": (0, $1rqx5.Li).convert(e1[`top-left`] || [
            0,
            0
        ]),
        "top-right": (0, $1rqx5.Li).convert(e1[`top-right`] || [
            0,
            0
        ]),
        bottom: (0, $1rqx5.Li).convert(e1.bottom || [
            0,
            0
        ]),
        "bottom-left": (0, $1rqx5.Li).convert(e1[`bottom-left`] || [
            0,
            0
        ]),
        "bottom-right": (0, $1rqx5.Li).convert(e1[`bottom-right`] || [
            0,
            0
        ]),
        left: (0, $1rqx5.Li).convert(e1.left || [
            0,
            0
        ]),
        right: (0, $1rqx5.Li).convert(e1.right || [
            0,
            0
        ])
    };
}
function $834619e78bbf578c$var$Dh(e1) {
    return e1 ? {
        top: e1.top ?? 0,
        right: e1.right ?? 0,
        bottom: e1.bottom ?? 0,
        left: e1.left ?? 0
    } : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
const $834619e78bbf578c$var$Oh = $834619e78bbf578c$var$Ar;
function $834619e78bbf578c$export$80220802faa18fec(e1, t) {
    return $834619e78bbf578c$var$_o().setRTLTextPlugin(e1, t);
}
function $834619e78bbf578c$export$c8f205afdabdaef4() {
    return $834619e78bbf578c$var$_o().getRTLTextPluginStatus();
}
function $834619e78bbf578c$export$c506eb22e615ba4a() {
    return $834619e78bbf578c$var$Oh;
}
function $834619e78bbf578c$export$33e4148f0a10446f() {
    return $834619e78bbf578c$var$ia.workerCount;
}
function $834619e78bbf578c$export$ec8b1053ddd7f5bc(e1) {
    $834619e78bbf578c$var$ia.workerCount = e1;
}
function $834619e78bbf578c$export$8ac2684f98a393b0() {
    return (0, $1rqx5.An).MAX_PARALLEL_IMAGE_REQUESTS;
}
function $834619e78bbf578c$export$9569597edc1f5cf3(e1) {
    (0, $1rqx5.An).MAX_PARALLEL_IMAGE_REQUESTS = e1;
}
function $834619e78bbf578c$export$b01b5f33620cab52() {
    return (0, $1rqx5.An).WORKER_URL;
}
function $834619e78bbf578c$export$f7f2857281fba5f0(e1) {
    (0, $1rqx5.An).WORKER_URL = e1;
}
async function $834619e78bbf578c$export$9cdc513767f0ece9(e1) {
    await $834619e78bbf578c$export$6f0c702cbe7d6ed8().broadcast(`IS`, e1);
}



'use strict';
function $3b59aa368551d641$export$2e2bcd8739ae039(person) {
    if (typeof person.gender === 'undefined') return null;
    return person.gender;
}


'use strict';
function $d774bcb2a641a945$export$2e2bcd8739ae039(person, lang) {
    if (typeof person.labels === 'undefined' || Object.keys(person.labels).length === 0) return null;
    const keys = Object.keys(person.labels);
    const label = person.labels[lang] ?? person.labels[keys[0]] ?? null;
    return label !== null ? label.value : null;
}


'use strict';
function $f9662fd6d4bb15a8$export$2e2bcd8739ae039(person) {
    if (typeof person.birth === 'undefined') return null;
    return person.birth;
}


'use strict';
function $0b1c818579e6544c$export$2e2bcd8739ae039(person) {
    if (typeof person.death === 'undefined') return null;
    return person.death;
}


'use strict';
function $25bf71e62f9b9646$export$2e2bcd8739ae039(person, lang) {
    if (typeof person.descriptions === 'undefined' || Object.keys(person.descriptions).length === 0) return null;
    const keys = Object.keys(person.descriptions);
    const description = person.descriptions[lang] ?? person.descriptions[keys[0]] ?? null;
    return description !== null ? description.value : null;
}


'use strict';
function $8428d177f2d79741$export$2e2bcd8739ae039(person, lang) {
    if (typeof person.nicknames === 'undefined' || person.nicknames === null || Object.keys(person.nicknames).length === 0) return null;
    return typeof person.nicknames[lang] !== 'undefined' ? person.nicknames[lang].value : null;
}


'use strict';
function $7595072d08983b61$export$2e2bcd8739ae039(person, lang) {
    if (typeof person.sitelinks === 'undefined' || Object.keys(person.sitelinks).length === 0) return null;
    const link = person.sitelinks[`${lang}wiki`] ?? person.sitelinks.enwiki ?? person.sitelinks.frwiki ?? person.sitelinks.nlwiki ?? person.sitelinks.dewiki ?? null;
    return link !== null ? {
        lang: link.site.substr(0, 2),
        url: link.url
    } : null;
}


'use strict';
function $9144b446dec8c8e6$export$2e2bcd8739ae039(person, height, width) {
    if (typeof person.image === 'undefined' || person.image === null) return null;
    return `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(person.image)}?width=${width}&height=${height}`;
}





'use strict';
function $e6df7f29f59feebf$export$2e2bcd8739ae039(feature) {
    const properties = feature.properties;
    const streetname = $e6df7f29f59feebf$var$getStreetname(properties);
    const details = typeof properties.details !== 'undefined' && properties.details !== null ? properties.details : null;
    const source = feature.source;
    const featureId = feature.id;
    let featureType = null;
    switch(source){
        case 'geojson-relations':
            featureType = 'relation';
            break;
        case 'geojson-ways':
            featureType = 'way';
            break;
    }
    let html = '';
    if (details !== null) {
        if (Array.isArray(details) === true) details.forEach((d)=>{
            html += $e6df7f29f59feebf$var$popupDetails(d);
        });
        else html += $e6df7f29f59feebf$var$popupDetails(details);
    }
    html += '<div class="popup-streetname">';
    html += streetname;
    if (featureType === 'node' || featureType === 'way' || featureType === 'relation') html += `<a target="_blank" href="https://www.openstreetmap.org/${featureType}/${featureId}" class="fas fa-edit popup-edit" title="Edit in OpenStreetMap"></a>`;
    html += '</div>';
    return html;
}
function $e6df7f29f59feebf$var$popupDetails(details) {
    const colors = (0, $c329767ff48960ee$export$bca14c5b3b88a9c9) === 'dark' ? (0, $f1e5777e1ac4f58e$export$eae85ad18a22ab6c) : (0, $f1e5777e1ac4f58e$export$38d2ecc76f0c2959);
    const wikidata = details.wikidata;
    const name = (0, $d774bcb2a641a945$export$2e2bcd8739ae039)(details, (0, $358c21e678401062$export$9a771d6906431624));
    const birth = (0, $f9662fd6d4bb15a8$export$2e2bcd8739ae039)(details);
    const death = (0, $0b1c818579e6544c$export$2e2bcd8739ae039)(details);
    const description = (0, $25bf71e62f9b9646$export$2e2bcd8739ae039)(details, (0, $358c21e678401062$export$9a771d6906431624));
    const nickname = (0, $8428d177f2d79741$export$2e2bcd8739ae039)(details, (0, $358c21e678401062$export$9a771d6906431624));
    const gender = (0, $3b59aa368551d641$export$2e2bcd8739ae039)(details);
    const wikipedia = (0, $7595072d08983b61$export$2e2bcd8739ae039)(details, (0, $358c21e678401062$export$9a771d6906431624));
    const image = (0, $9144b446dec8c8e6$export$2e2bcd8739ae039)(details, 150, 150);
    let htmlDetails = '';
    htmlDetails += '<div class="popup-wikidata">';
    if (image !== null) {
        htmlDetails += '<div class="d-flex">';
        htmlDetails += `<div class="flex-shrink-0"><img src="${image}" alt="${name}" /></div>`;
        htmlDetails += '<div class="flex-grow-1 ms-3">';
    }
    htmlDetails += '<div class="popup-name">';
    htmlDetails += `<span class="popup-name__name">${name}</span>`;
    if (nickname !== null) htmlDetails += ` (<span class="popup-name__nickname">${nickname}</span>)`;
    if (details.person === true && gender !== null) {
        const highlightColor = colors[gender.toLowerCase()] ?? '#fff';
        htmlDetails += `<span class="highlight-low" style="background:linear-gradient(180deg, rgba(255, 255, 255, 0) 65%, ${highlightColor} 65%);"></span>`;
    }
    htmlDetails += '</div>';
    if (details.person === true && (birth !== null || death !== null)) htmlDetails += '<div class="popup-life">' + (birth === null ? '???' : birth) + ' - ' + (death === null ? '???' : death) + '</div>';
    if (description !== null) htmlDetails += `<p class="popup-description">${description}</p>`;
    htmlDetails += '<div class="popup-links">';
    if (wikipedia !== null) htmlDetails += `<a target="_blank" href="${wikipedia.url}">` + `Wikipedia (${wikipedia.lang.toUpperCase()})` + '</a> + ';
    if (wikidata !== null) htmlDetails += `<a target="_blank" href="https://www.wikidata.org/wiki/${wikidata}">Wikidata</a>`;
    htmlDetails += '</div>';
    if (image !== null) {
        htmlDetails += '</div>';
        htmlDetails += '</div>';
    }
    htmlDetails += '<hr>';
    return htmlDetails;
}
function $e6df7f29f59feebf$var$getStreetname(properties) {
    if (properties.name === null) return '';
    const matches = properties.name.match(/^(.+) - (.+)$/);
    if (matches !== null && matches.length > 1) {
        matches.shift();
        return matches.join('<br>');
    }
    return properties.name;
}


'use strict';
function $45be644cebcd91b2$export$2e2bcd8739ae039(map, features, lnglat) {
    const html = (0, $e6df7f29f59feebf$export$2e2bcd8739ae039)(features[0]);
    new (0, $834619e78bbf578c$export$129a32eedafa97c5)({
        maxWidth: 'none'
    }).setLngLat(lnglat).setHTML(html).addTo(map);
}


'use strict';
function $30193ad94d9aac13$export$2e2bcd8739ae039(map) {
    map.getCanvas().style.cursor = 'pointer';
}


'use strict';
function $84195d24eaae0860$export$2e2bcd8739ae039(map) {
    map.getCanvas().style.cursor = '';
}


'use strict';
function $9364fb6466c001d1$export$2e2bcd8739ae039(map) {
    // Add click event.
    map.on('click', (event)=>{
        const bbox = [
            [
                event.point.x - 5,
                event.point.y - 5
            ],
            [
                event.point.x + 5,
                event.point.y + 5
            ]
        ];
        const features = map.queryRenderedFeatures(bbox, {
            layers: [
                'layer-relations',
                'layer-ways'
            ]
        });
        if (features.length > 0) (0, $45be644cebcd91b2$export$2e2bcd8739ae039)(map, features, event.lngLat);
    });
    // Change the cursor to a pointer when the mouse is over a layer.
    map.on('mouseenter', 'layer-relations', ()=>(0, $30193ad94d9aac13$export$2e2bcd8739ae039)(map));
    map.on('mouseenter', 'layer-ways', ()=>(0, $30193ad94d9aac13$export$2e2bcd8739ae039)(map));
    // Change it back to a pointer when it leaves.
    map.on('mouseleave', 'layer-relations', ()=>(0, $84195d24eaae0860$export$2e2bcd8739ae039)(map));
    map.on('mouseleave', 'layer-ways', ()=>(0, $84195d24eaae0860$export$2e2bcd8739ae039)(map));
}


var $e88ab36af78b94dc$exports = {};
$e88ab36af78b94dc$exports = import.meta.resolve("cq9Tl");


'use strict';
const $d0073964e9954144$var$attribution = '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
function $d0073964e9954144$export$2e2bcd8739ae039(map) {
    map.addSource('geojson-boundary', {
        type: 'geojson',
        attribution: $d0073964e9954144$var$attribution,
        data: (/*@__PURE__*/$parcel$interopDefault($e88ab36af78b94dc$exports))
    });
    map.addLayer({
        id: 'layer-boundary',
        type: 'line',
        source: 'geojson-boundary',
        paint: {
            'line-color': '#000',
            'line-width': 3,
            'line-opacity': 0.5
        }
    });
}


'use strict';
var $2a3e4c2d3677f8bb$export$2e2bcd8739ae039 = {
    'line-cap': 'round',
    'line-join': 'round',
    'line-sort-key': [
        'case',
        [
            '==',
            [
                'typeof',
                [
                    'get',
                    'gender'
                ]
            ],
            'string'
        ],
        10,
        5
    ]
};




'use strict';
function $c708cec39846b318$export$2e2bcd8739ae039() {
    const colors = (0, $c329767ff48960ee$export$bca14c5b3b88a9c9) === 'dark' ? (0, $f1e5777e1ac4f58e$export$eae85ad18a22ab6c) : (0, $f1e5777e1ac4f58e$export$38d2ecc76f0c2959);
    return {
        'line-color': [
            'case',
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                'F'
            ],
            colors.f,
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                'M'
            ],
            colors.m,
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                'FX'
            ],
            colors.fx,
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                'MX'
            ],
            colors.mx,
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                'X'
            ],
            colors.x,
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                '?'
            ],
            colors.u,
            [
                '==',
                [
                    'get',
                    'gender'
                ],
                '+'
            ],
            colors.p,
            colors.o
        ],
        'line-width': [
            'interpolate',
            [
                'linear'
            ],
            [
                'zoom'
            ],
            13,
            1,
            22,
            [
                'case',
                [
                    '==',
                    [
                        'typeof',
                        [
                            'get',
                            'gender'
                        ]
                    ],
                    'string'
                ],
                20,
                10
            ]
        ],
        'line-opacity': 0.8
    };
}


var $66881bca8ec3b933$exports = {};
$66881bca8ec3b933$exports = import.meta.resolve("dI9OM");


'use strict';
const $715cd2ddece9546c$var$attribution = '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
function $715cd2ddece9546c$export$2e2bcd8739ae039(map) {
    map.addSource('geojson-relations', {
        type: 'geojson',
        attribution: $715cd2ddece9546c$var$attribution,
        data: (/*@__PURE__*/$parcel$interopDefault($66881bca8ec3b933$exports))
    });
    map.addLayer({
        id: 'layer-relations',
        type: 'line',
        source: 'geojson-relations',
        layout: $2a3e4c2d3677f8bb$export$2e2bcd8739ae039,
        paint: (0, $c708cec39846b318$export$2e2bcd8739ae039)()
    });
}




var $0635df88157c9f96$exports = {};
$0635df88157c9f96$exports = import.meta.resolve("fELxM");


'use strict';
const $7bb295c0bc0e40e0$var$attribution = '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
function $7bb295c0bc0e40e0$export$2e2bcd8739ae039(map) {
    map.addSource('geojson-ways', {
        type: 'geojson',
        attribution: $7bb295c0bc0e40e0$var$attribution,
        data: (/*@__PURE__*/$parcel$interopDefault($0635df88157c9f96$exports))
    });
    map.addLayer({
        id: 'layer-ways',
        type: 'line',
        source: 'geojson-ways',
        layout: $2a3e4c2d3677f8bb$export$2e2bcd8739ae039,
        paint: (0, $c708cec39846b318$export$2e2bcd8739ae039)()
    });
}




'use strict';
var $b028a3c67515b650$exports = {};
$b028a3c67515b650$exports = import.meta.resolve("a36tH");


(0, $834619e78bbf578c$export$f7f2857281fba5f0)(new URL($b028a3c67515b650$exports).toString());
let $b8838d500693c75e$export$871de8747c9eaa88;
async function $b8838d500693c75e$export$2e2bcd8739ae039() {
    const options = {
        container: 'map',
        hash: true,
        style: typeof (0, $358c21e678401062$export$1d567c320f4763bc) !== 'undefined' ? (0, $358c21e678401062$export$1d567c320f4763bc) : (0, $c329767ff48960ee$export$bca14c5b3b88a9c9) === 'dark' ? 'https://tiles.openfreemap.org/styles/dark' : 'https://tiles.openfreemap.org/styles/positron'
    };
    if (typeof (0, $358c21e678401062$export$3481c78889e8fbe8) !== 'undefined' && typeof (0, $358c21e678401062$export$e83f174dbf56adcc) !== 'undefined') {
        options.center = (0, $358c21e678401062$export$3481c78889e8fbe8);
        options.zoom = (0, $358c21e678401062$export$e83f174dbf56adcc);
    } else {
        options.bounds = (0, $358c21e678401062$export$bf67010aacbe66fa) || (0, $5dd0c5bafbf7a4a5$exports.bounds);
        options.fitBoundsOptions = {
            padding: 50
        };
    }
    // Initialize map.
    if (typeof $b8838d500693c75e$export$871de8747c9eaa88 !== 'undefined') $b8838d500693c75e$export$871de8747c9eaa88.remove();
    $b8838d500693c75e$export$871de8747c9eaa88 = new (0, $834619e78bbf578c$export$a5c7b93649eaf8f8)(options);
    // Add controls.
    const nav = new (0, $834619e78bbf578c$export$49a437922edc1bd9)({
        showCompass: false
    });
    $b8838d500693c75e$export$871de8747c9eaa88.addControl(nav, 'top-left');
    const scale = new (0, $834619e78bbf578c$export$1fb16e435eedcce9)({
        unit: 'metric'
    });
    $b8838d500693c75e$export$871de8747c9eaa88.addControl(scale);
    const geocoder = new (0, $4703be9d11e2fafd$export$2e2bcd8739ae039)({
        forwardGeocode: async (config)=>{
            const features = [];
            try {
                const request = `https://nominatim.openstreetmap.org/search?q=${config.query}&format=geojson&polygon_geojson=1&addressdetails=1`;
                const response = await fetch(request);
                const geojson = await response.json();
                for (const feature of geojson.features){
                    const center = [
                        feature.bbox[0] + (feature.bbox[2] - feature.bbox[0]) / 2,
                        feature.bbox[1] + (feature.bbox[3] - feature.bbox[1]) / 2
                    ];
                    const point = {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: center
                        },
                        place_name: feature.properties.display_name,
                        properties: feature.properties,
                        text: feature.properties.display_name,
                        place_type: [
                            'place'
                        ],
                        center: center
                    };
                    features.push(point);
                }
            } catch (error) {
                throw new Error(`Failed to forwardGeocode with error: ${error}`, {
                    cause: error
                });
            }
            return {
                features: features
            };
        }
    }, {
        bbox: (0, $358c21e678401062$export$bf67010aacbe66fa) || (0, $5dd0c5bafbf7a4a5$exports.bounds),
        enableEventLogging: false,
        language: (0, $358c21e678401062$export$9a771d6906431624),
        maplibregl: $834619e78bbf578c$exports
    });
    $b8838d500693c75e$export$871de8747c9eaa88.addControl(geocoder);
    $b8838d500693c75e$export$871de8747c9eaa88.on('load', ()=>{
        $b8838d500693c75e$export$871de8747c9eaa88.resize();
        // Add GeoJSON sources.
        (0, $715cd2ddece9546c$export$2e2bcd8739ae039)($b8838d500693c75e$export$871de8747c9eaa88);
        (0, $7bb295c0bc0e40e0$export$2e2bcd8739ae039)($b8838d500693c75e$export$871de8747c9eaa88);
        (0, $d0073964e9954144$export$2e2bcd8739ae039)($b8838d500693c75e$export$871de8747c9eaa88);
        // Add events
        (0, $9364fb6466c001d1$export$2e2bcd8739ae039)($b8838d500693c75e$export$871de8747c9eaa88);
    });
    $b8838d500693c75e$export$871de8747c9eaa88.on('idle', ()=>{
        document.body.classList.add('loaded');
    });
    return $b8838d500693c75e$export$871de8747c9eaa88;
}


'use strict';
const $c329767ff48960ee$var$themeSwitch = document.querySelector('#themeSwitch');
let $c329767ff48960ee$export$bca14c5b3b88a9c9;
function $c329767ff48960ee$var$changeTheme() {
    document.documentElement.setAttribute('data-theme', $c329767ff48960ee$export$bca14c5b3b88a9c9);
    if (typeof $c329767ff48960ee$var$themeSwitch?.checked !== 'undefined') $c329767ff48960ee$var$themeSwitch.checked = $c329767ff48960ee$export$bca14c5b3b88a9c9 === 'dark';
    (0, $b8838d500693c75e$export$2e2bcd8739ae039)();
    (0, $8b6c78f0b565e44c$export$2e2bcd8739ae039)();
}
function $c329767ff48960ee$export$2e2bcd8739ae039() {
    // Initialize theme
    $c329767ff48960ee$export$bca14c5b3b88a9c9 = window.matchMedia('(prefers-color-scheme: dark)').matches === true ? 'dark' : 'light';
    $c329767ff48960ee$var$changeTheme();
    // Update theme when browser configuration changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event)=>{
        $c329767ff48960ee$export$bca14c5b3b88a9c9 = event.matches === true ? 'dark' : 'light';
        $c329767ff48960ee$var$changeTheme();
    });
    // Update theme when user click on them switch
    $c329767ff48960ee$var$themeSwitch?.addEventListener('click', ()=>{
        $c329767ff48960ee$export$bca14c5b3b88a9c9 = $c329767ff48960ee$var$themeSwitch.checked === true ? 'dark' : 'light';
        $c329767ff48960ee$var$changeTheme();
    });
}


var $5dd0c5bafbf7a4a5$exports = {};
$5dd0c5bafbf7a4a5$exports = JSON.parse("{\"bounds\":[2.224122,48.8155755,2.4697602,48.902156],\"statistics\":{\"F\":335,\"M\":2976,\"FX\":1,\"MX\":0,\"X\":0,\"NB\":1,\"+\":28,\"?\":11,\"-\":3843},\"lastUpdate\":\"2026-11-02T06:37:11+00:00\"}");


'use strict';
let $358c21e678401062$export$9a771d6906431624;
let $358c21e678401062$export$3481c78889e8fbe8;
let $358c21e678401062$export$e83f174dbf56adcc;
let $358c21e678401062$export$bf67010aacbe66fa;
let $358c21e678401062$export$1d567c320f4763bc;
(function() {
    const html = document.querySelector('html');
    $358c21e678401062$export$9a771d6906431624 = html.getAttribute('lang') ?? 'en';
    const data = document.getElementById('map')?.dataset;
    if (typeof data?.style !== 'undefined') $358c21e678401062$export$1d567c320f4763bc = data.style;
    if (typeof data?.center !== 'undefined' && typeof data?.zoom !== 'undefined') {
        $358c21e678401062$export$3481c78889e8fbe8 = JSON.parse(data.center);
        $358c21e678401062$export$e83f174dbf56adcc = parseFloat(data.zoom);
    }
    if (typeof data?.bbox !== 'undefined') $358c21e678401062$export$bf67010aacbe66fa = JSON.parse(data.bbox);
    (0, $c329767ff48960ee$export$2e2bcd8739ae039)();
})();


//# sourceMappingURL=en.ca02808f.js.map
